import React, { useEffect, useState, useRef, useCallback } from "react";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { BASE_URL, TESTING_URL } from "../../config/axios";
import { ToastContainer, toast } from "react-toastify";
import usePermission from "../../config/permissions";
import { handleErrorToast, inputMaxLimit, sortProjects, customSortByKey, uploadFileInChunks, CSSForSelect, calculateNextDate, subtractDaysFromDate, ProgressModal, CSSForSelectSmallWidth, CSSForSelect15vWWidth, CSSForSelect10vWWidth, CSSForSelect15vWWidthvwWithourforntSize, CSSForSelect20vWWidth, DeleteButton, Addbutton, Updatebutton, CSSForSelect23vWWidth, CSSForSelectModern, CSSForSelectModern15VWWidth } from "../CustomFunctions";
import { datearray } from "../Date";
import './AddProject.css'
import './NewCSS.css';
import {
  AddwithWhiteCircle,
  AddwithBlueCircle,
  DeleteDustbin,
  DropdownArrow,
  CrossRed,
  Eye,
  UpdatePencil,
  CheckGreen,
  DropdownArrowOption,
  Attachment,
  DocumentIcon,
  CloseEye,
  CrosswithRedCircle,
  ArrowBullet,
  DocumentButton,
  DocumentfOLDIcon,
  DeleteDustbinbUTTON,
} from "../AllSvg";
import {
  DocumentSection,
  RenderInputField,
  RenderInputTextareaField,
  RenderSelectField,
  statesAndUTs,
  toTitleCase,
} from "../FormdataComponent";
import { axiosInstance2 } from "../../config/axiosInstance";
import Select, { components } from "react-select";

import { AddSiteDepartment } from "../Wfm/WorkforceCrudButton";
import Letter from "./Components/Letter";
import { useRowSelect } from "react-table";

import {
  X, Plus, Building2, Calendar, IndianRupee, MapPin,
  FileText, Users, Briefcase, Clock, AlertCircle,
  CheckCircle, ChevronRight, Save, Hash, TrendingUp,
  CreditCard, UserCheck, Info, ChevronDown, ChevronUp,
  Loader, Globe, Phone, Mail, Shield, Award, Zap,
  Ruler,
  Timer,
  Edit,
  PlusCircle,
  MinusCircle,
  Link,
  Tag,
  Percent,
  Paperclip,
  MessageSquare,
  AwardIcon,
  LucideAward,
  PercentCircle,
  PercentCircleIcon,
  UploadIcon,
  Upload,
  FileUp,
  FileCheck,
  FileSpreadsheet,
  Trash2,
  List,
  User,
  ReceiptIndianRupeeIcon,
  PencilRuler,
  CheckCircle2,
} from 'lucide-react';
import AddModalButton from "./Components/modernbuttons/AddButton";
import { AddDynamicButton } from "./Components/modernbuttons/AddDynamicButton";



// ! *************** Project Crud Models Start ***************

// const AddProjectDetails = ({ getProjects, subcompany }) => {
//   const [show, setShow] = useState(false);
//   const [clientList, setClientList] = useState([]);
//   const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
//   const siteSubcompany = sessionStorage.getItem("sitemanagement_project_sub_company")


//   const uniqueStreamTypes = new Set();

//   const handleClose = () => {
//     setFormData({
//       site_prcode: "",
//       project_name: "",
//       project_short_name: "",
//       location: "",
//       pan_no: "",
//       gst_no: "",
//       // sub_company: sessionStorage.getItem('company_id'),
//       sub_company: "",
//       work_type: "",
//       bid_due_date: "null",
//       loa_award_date: "null",

//       actual_construction_completion_date: "null",
//       schedule_construction_completion_date: "null",
//       agreement_date: "null",
//       commencement_date: "null",

//       concern_person: "",
//       authority_engineer: "",
//       project_length: "",
//       tender_id: "",
//       actual_completion_date: "null",
//       schedule_completion_date: "null",
//       construction_cost: 0,
//       remark: "",
//       consultancy_fees: "",
//       contract_mode: "",
//       lead: "",
//       jv: "",
//       our_share: "",
//       jv_share: "",
//       association: "",
//       work_performed_by: "",
//       client_name: "",
//       project_key_point: "",
//       ro: "",
//       ro_address: "",
//       piu_address: "",
//       contractor_address: "",
//       // appointed_date:"",
//       project_duration: "",
//       our_role: "",
//       site_office_address: "",
//     });
//     setErrors({});
//     setShow(false);
//   };
//   const handleShow = () => {
//     // setFormData(i);
//     setShow(true);
//     getAllEmp_code();
//     getSubCompany();
//     clientList.forEach((entry) => {
//       uniqueStreamTypes.add(entry.client_name);
//     });
//   };

//   const [empList, setEmpList] = useState([]);
//   const [operatorempList, setoperatorEmpList] = useState([]);
//   const [buffer, setBuffering] = useState(false); //buffering logic


//   const [formData, setFormData] = useState({
//     site_prcode: "",
//     project_name: "",
//     project_short_name: "",
//     location: "",
//     // sub_company: sessionStorage.getItem('company_id'),
//     sub_company: "",
//     work_type: "",
//     bid_due_date: null,
//     loa_award_date: null,
//     pan_no: "",
//     gst_no: "",
//     agreement_date: null,
//     commencement_date: null,
//     authority_engineer: "",
//     project_length: "",
//     tender_id: "",
//     actual_completion_date: null,
//     actual_construction_completion_date: null,
//     schedule_construction_completion_date: null,
//     mobilization: null,
//     remark: "",
//     consultancy_fees: "",
//     contract_mode: "",
//     lead: "",
//     ro: "",
//     ro_address: "",
//     piu_address: "",
//     jv: "",
//     our_share: "",
//     jv_share: "",
//     association: "",
//     work_performed_by: "",
//     client_name: "",
//     // appointed_date:"",
//     project_duration: "",
//     our_role: "",
//     site_office_address: "",
//     om_duration: "",
//     construction_duration: "",
//     com_operators: [],
//     imprest_amount: ""
//   });
//   useEffect(() => {
//     updateStatusAndRemarks(); // Update status and remarks together
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [
//     formData.actual_completion_date,
//     formData.actual_construction_completion_date,
//     formData.schedule_completion_date,
//     formData.schedule_construction_completion_date,
//     formData.commencement_date,
//     formData.agreement_date,
//     formData.bgid_submission_date,
//     formData.loa_award_date,
//     formData.bid_due_date,
//   ]); // Add only the necessary dependencies

//   // !  ************** Validation start **************  ! //


//   const getSubCompany = async () => {
//     try {
//       const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
//       setSiteSubCompanyList(sub.data);
//     } catch (error) {
//       console.error(error);

//     }
//   };


//   // ****************************************User Logs ***************************************************//
//   const [userLogData, setUserLogData] = useState([{
//     type: "",
//     username: "",
//     useremail: "",
//     used_for: "",
//     item_id: "",
//     item_code: "",
//     item_name: "",
//   }]);






//   // ****************************************User Logs ***************************************************//


//   const getAllEmp_code = async () => {
//     setBuffering(true);
//     try {
//       const res = await axios.get(
//         // `${BASE_URL}/siteproject/employeefilterbysubcompany/${formData.sub_company}/`
//         `${BASE_URL}/siteproject/employeebyfilterss/null/null/null/null/null/AuthorityEngineer/null/`
//       );
//       const ress = await axios.get(
//         // `${BASE_URL}/siteproject/employeefilterbysubcompany/${formData.sub_company}/`
//         `${BASE_URL}/siteproject/employeebyfilterss/null/null/null/null/null/DataEntryOperator/null/`
//       );

//       const sortedList = customSortByKey(res.data, "emp_code");
//       const sortedListt = customSortByKey(ress.data, "emp_code");

//       setEmpList(sortedList);
//       setoperatorEmpList(sortedListt);

//       const cli = await axios.get(`${BASE_URL}/siteproject/project-clients/`);
//       setClientList(cli.data);


//     } catch (err) {
//       // alert(err.message);
//     } finally {
//       setBuffering(false);
//     }
//   };
//   useEffect(() => {
//     getAllEmp_code();
//   }, [formData.sub_company, subcompany]);
//   const updateStatusAndRemarks = () => {
//     let newStatus = "";
//     let newRemark = "";

//     if (formData.actual_completion_date) {
//       newStatus = "Completed";
//       newRemark = "The project is successfully completed.";
//     } else if (formData.actual_construction_completion_date) {
//       newStatus = "Yet to Complete including O&M";
//       newRemark = "Construction phase completed; O&M is pending.";
//     } else if (formData.schedule_completion_date) {
//       newStatus = "In Progress";
//       newRemark = "Project is currently in progress.";
//     } else if (formData.schedule_construction_completion_date) {
//       newStatus = "In Progress including O&M";
//       newRemark = "Construction is in progress along with O&M.";
//     } else if (formData.commencement_date) {
//       newStatus = "Yet to Commence";
//       newRemark = "Project commencement is yet to start.";
//     } else if (formData.agreement_date) {
//       newStatus = "Yet to Sign Agreement";
//       newRemark = "Agreement signing is pending.";
//     } else if (formData.bgid_submission_date) {
//       newStatus = "Yet to Submit BG";
//       newRemark = "Bank Guarantee submission is pending.";
//     } else if (formData.loa_award_date) {
//       newStatus = "Yet to Award";
//       newRemark = "Letter of Award is pending.";
//     } else if (formData.bid_due_date) {
//       newStatus = "Yet to Bid";
//       newRemark = "Bid submission is pending.";
//     }

//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       status: newStatus,
//     }));
//   };

//   const [isSubmitted, setIsSubmitted] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});

//   const validateForm = () => {
//     const newErrors = {};
//     const requiredFields = [
//       "site_prcode",
//       "project_name",
//       "project_short_name",
//       "location",
//       // "sub_company",
//       "work_type",
//       "lead",
//       "tender_id",
//       "project_length",
//       "pan_no",
//       "gst_no",

//     ];
//     requiredFields.forEach((field) => {
//       if (!formData[field]) {
//         newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
//           } is required !`;
//       }
//     });

//     setErrors(newErrors);
//     setIsSubmitted(true);
//     return Object.keys(newErrors).length === 0;
//   };
//   const [filteredList, setFilteredList] = useState([]);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target || e;

//     // fields that should be CAPITAL
//     const capitalizeFields = [
//       "tender_id",
//       "location",
//       "project_short_name",
//       "site_prcode",
//     ];

//     const finalValue = capitalizeFields.includes(name)
//       ? value.toUpperCase()
//       : value;

//     setInputState({
//       ...inputState,
//       [name]: finalValue.trim() ? "green" : "",
//     });

//     const updatedFormData = {
//       ...formData,
//       [name]: finalValue,
//     };

//     const omDuration =
//       parseInt(name === "om_duration" ? finalValue : formData.om_duration) || 0;
//     const constructionDuration =
//       parseInt(
//         name === "construction_duration"
//           ? finalValue
//           : formData.construction_duration
//       ) || 0;

//     if (name === "om_duration" || name === "construction_duration") {
//       updatedFormData.project_duration = omDuration + constructionDuration;
//     }

//     setFormData(updatedFormData);

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       if (finalValue) {
//         delete updatedErrors[name];
//       }
//       return updatedErrors;
//     });

//     // Client name filtering logic (keep lowercase search)
//     if (name === "client_name") {
//       const filtered = clientList.filter((item) =>
//         item?.client_name
//           ?.toLowerCase()
//           .includes(finalValue.toLowerCase())
//       );

//       const uniqueFiltered = Array.from(
//         new Map(filtered.map((item) => [item.client_name, item])).values()
//       );

//       setFilteredList(uniqueFiltered);
//     }
//   };



//   // ?  ************** Validation End **************  ! //

//   const [loading, setLoading] = useState(false); //loading logic
//   const handleFormSubmit = async (e) => {
//     e.preventDefault();

//     if (validateForm()) {
//       setLoading(true); //loading logic
//       const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//       try {
//         let res = await axios.post(
//           `${BASE_URL}/siteproject/project/`,
//           formData
//         );

//         if (res.status === 200) {
//           handleClose();
//           await getProjects();
//         } else {
//           alert(res);
//         }
//       } catch (err) {
//         //toast Logic
//         handleErrorToast(err);
//       } finally {
//         setLoading(false); //loading logic
//         toast.dismiss(loadingToastId);
//       }
//     }
//   };

//   const sortedStatesAndUTs = [...statesAndUTs].sort();


//   const handleChangeAssignedTo = (selected) => {
//     const com_operators = selected?.map((item) => item.value) || [];
//     setFormData((prevState) => ({
//       ...prevState,
//       com_operators,
//     }));
//   };

//   const options = empList?.sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))?.filter(i => i.emp_role === "DataEntryOperator")?.map((e) => ({
//     value: e.id,
//     label: `${e.emp_code} - ${e.name}`,
//   }));

//   const locationOptions = sortedStatesAndUTs.map((state) => ({
//     value: state,
//     label: state,
//   }));

//   const workTypeOptions = [
//     {
//       value: "Construction Consultant - Authority Engineer",
//       label: "Construction Consultant - Authority Engineer",
//     },
//     {
//       value: "Construction Consultant - Independent Engineer",
//       label: "Construction Consultant - Independent Engineer",
//     },
//     {
//       value: "Operation & Maintenance Consultant - Authority Engineer",
//       label: "Operation & Maintenance Consultant - Authority Engineer",
//     },
//     {
//       value: "Operation & Maintenance Consultant - Independent Engineer",
//       label: "Operation & Maintenance Consultant - Independent Engineer",
//     },
//     {
//       value: "Detailed Project Report (DPR)",
//       label: "Detailed Project Report (DPR)",
//     },
//     {
//       value: "Safety Consultant (SC)",
//       label: "Safety Consultant (SC)",
//     },
//     {
//       value: "Asset Monetization (AM)",
//       label: "Asset Monetization (AM)",
//     },
//   ];

//   useEffect(() => {
//     const {
//       construction_duration,
//       om_duration,
//       mobilization
//     } = formData;

//     const projectDuration =
//       construction_duration && om_duration
//         ? Number(construction_duration) + Number(om_duration)
//         : "";

//     const addMonthsToDate = (dateString, months) => {
//       if (!dateString || !months) return "";
//       const date = new Date(dateString);
//       date.setMonth(date.getMonth() + Number(months));
//       return date.toISOString().split("T")[0];
//     };

//     const scheduleConstructionCompletionDate = addMonthsToDate(
//       mobilization,
//       construction_duration
//     );

//     const projectCompletionDate = addMonthsToDate(
//       mobilization,
//       projectDuration
//     );

//     setFormData((prev) => ({
//       ...prev,
//       project_duration: projectDuration,
//       schedule_construction_completion_date: scheduleConstructionCompletionDate,
//       schedule_completion_date: projectCompletionDate,
//     }));
//   }, [
//     formData.construction_duration,
//     formData.om_duration,
//     formData.mobilization,
//     formData.project_duration
//   ]);


//   const authorityEngineerOptions = empList
//     .sort((a, b) => a.emp_code - b.emp_code)
//     .map(emp => ({
//       value: emp.id, // what will be submitted
//       label: `${emp.emp_code} - ${emp.name}`, // what is displayed
//     }));
//   const operatorOptions = operatorempList
//     .sort((a, b) => a.emp_code - b.emp_code)
//     .map(emp => ({
//       value: emp.id, // what will be submitted
//       label: `${emp.emp_code} - ${emp.name}`, // what is displayed
//     }));

//   const handleAuthorityEngineerChange = (selectedOption) => {
//     setFormData(prev => ({
//       ...prev,
//       authority_engineer: selectedOption ? selectedOption.value : "",
//     }));

//     setInputState(prev => ({
//       ...prev,
//       authority_engineer: selectedOption ? "green" : "",
//     }));
//   };

//   const contractModeOptions = [
//     { value: "epc", label: "EPC" },
//     { value: "ham", label: "HAM" },
//     { value: "bot", label: "BOT" },
//   ];

//   const consultantOptions = [
//     { value: "Chaitanya Projects Concsultancy Pvt. Ltd.", label: "Chaitanya Projects Concsultancy Pvt. Ltd." },
//     { value: "G-Eng Advisory Services Pvt Ltd", label: "G-Eng Advisory Services Pvt Ltd" },
//     { value: "Sapatgon Asia Private Limited", label: "Sapatgon Asia Private Limited" },
//     { value: "AECOM Asia Company Limited", label: "AECOM Asia Company Limited" },
//     { value: "Agnitio Infrastructure Projects Pvt. Ltd", label: "Agnitio Infrastructure Projects Pvt. Ltd" },
//     { value: "Almondz Global Infra Consultant Limited", label: "Almondz Global Infra Consultant Limited" },
//     { value: "Centro de Estudios de Materiales y Control de Obra, SA", label: "Centro de Estudios de Materiales y Control de Obra, SA" },
//     { value: "Dhruv Consultancy Services Ltd.", label: "Dhruv Consultancy Services Ltd." },
//     { value: "ARKITECHNO Consultancy (India) Pvt. Ltd.", label: "ARKITECHNO Consultancy (India) Pvt. Ltd." },
//     { value: "FP India Project Management Consultancy Services Pvt.Ltd", label: "FP India Project Management Consultancy Services Pvt.Ltd" },
//     { value: "Global Infra Solutions", label: "Global Infra Solutions" },
//     { value: "JC Technocrats Pvt.Ltd", label: "JC Technocrats Pvt.Ltd" },
//     { value: "Marc Technocrats Private Limited", label: "Marc Technocrats Private Limited" },
//     { value: "RITES Ltd in association", label: "RITES Ltd in association" },
//     { value: "Rodic Consultants Private Limited", label: "Rodic Consultants Private Limited" },
//     { value: "Segmental Consulting & Infrastructure Advisory Pvt. Ltd", label: "Segmental Consulting & Infrastructure Advisory Pvt. Ltd" },
//     { value: "TUMAS Turkish Engineering Consulting and Contracting Inc. Co.", label: "TUMAS Turkish Engineering Consulting and Contracting Inc. Co." },
//     { value: "URS Scott Wilson India Pvt. Ltd", label: "URS Scott Wilson India Pvt. Ltd" },
//     { value: "Voyants Solution Pvt. Ltd", label: "Voyants Solution Pvt. Ltd" },
//     { value: "Infinite Solutions Private Limited", label: "Infinite Solutions Private Limited" },
//     { value: "K & J Projects Private Limited", label: "K & J Projects Private Limited" },
//     { value: "Open Solutions Infrastructure Consultancy Services Pvt. Ltd.", label: "Open Solutions Infrastructure Consultancy Services Pvt. Ltd." },
//     { value: "Sterling Indo Tech Consultants Pvt. Ltd.", label: "Sterling Indo Tech Consultants Pvt. Ltd." },
//     { value: "CivilMantra Infracon Pvt. Ltd", label: "CivilMantra Infracon Pvt. Ltd" },
//     { value: "TPF Getinsa-Eurostudios, S.L", label: "TPF Getinsa-Eurostudios, S.L" },
//     { value: "JS Infrastructure Consultants Pvt. Ltd.", label: "JS Infrastructure Consultants Pvt. Ltd." },
//     { value: "DN Consultant", label: "DN Consultant" },
//     { value: "India Engg.Consultants India Private Limited", label: "India Engg.Consultants India Private Limited" },
//     { value: "Infinite Civil Solutions Pvt. Ltd", label: "Infinite Civil Solutions Pvt. Ltd" },
//     { value: "Introsoft Solutions", label: "Introsoft Solutions" },
//     { value: "Mahamarg Infra Consultants Private Limited", label: "Mahamarg Infra Consultants Private Limited" },
//     { value: "MAV Associates LLP", label: "MAV Associates LLP" },
//     { value: "MS Consultants", label: "MS Consultants" },
//     { value: "MVK Infrabulid Pvt. Ltd.", label: "MVK Infrabulid Pvt. Ltd." },
//     { value: "Nu-Infra Engineering Pvt Ltd.", label: "Nu-Infra Engineering Pvt Ltd." },
//     { value: "Samarth Softech Solutions Pvt. Ltd.", label: "Samarth Softech Solutions Pvt. Ltd." },
//     { value: "Shree Bhawani Consultancy Service Pvt. Ltd.,", label: "Shree Bhawani Consultancy Service Pvt. Ltd.," },
//     { value: "Transtek Engineers & Services Pvt. Ltd.", label: "Transtek Engineers & Services Pvt. Ltd." },
//     { value: "CivilMantra ConsAi Limited", label: "CivilMantra ConsAi Limited" },
//     { value: "AVOK Engineering Consulting & Contracting Pvt. Ltd.", label: "AVOK Engineering Consulting & Contracting Pvt. Ltd." },
//     { value: "Aicons Engineering Pvt. Ltd.", label: "Aicons Engineering Pvt. Ltd." }
//   ];



//   const extendedConsultantOptions = [
//     { label: "PWD", value: "PWD", },
//     { label: "BRO", value: "BRO", },
//     { label: "NHIDCL", value: "NHIDCL", },
//     { label: "MoRTH", value: "MoRTH", },
//     { label: "NHAI", value: "NHAI", },

//     { label: "Other", value: "other", },

//   ];






//   const handleContractModeChange = (selectedOption) => {
//     setFormData(prev => ({
//       ...prev,
//       contract_mode: selectedOption ? selectedOption.value : "",
//     }));

//     setInputState(prev => ({
//       ...prev,
//       contract_mode: selectedOption ? "green" : "",
//     }));
//   };



//   return (
//     <>
//       <button
//         title="Add Project Details"
//         className="upload-svg"
//         onClick={handleShow}
//       >
//         <AddwithWhiteCircle /> {" "}
//         Project
//       </button>

//       {/* <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model"> */}
//       <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
//         <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500    font-size-heading ">
//           <Modal.Title>Add Project Details</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <form className="register-form">
//             <div className="form-flex-wrap">
//               <div title="Tender ID" className="flex-column">
//                 <label
//                   htmlFor="tender_id"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Tender ID<span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   id="tender_id"
//                   name="tender_id"
//                   placeholder="e.g. TNDR/2025/045"
//                   onChange={handleInputChange}
//                   value={formData.tender_id}
//                   className={`form-input-div  ${errors.tender_id
//                     ? "error"
//                     : inputState.tender_id
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.tender_id && (
//                   <span className="error-message font-size-text ">
//                     {errors.tender_id}
//                   </span>
//                 )}
//               </div>

//               <div title="Project Code" className="flex-column">
//                 <label
//                   htmlFor="site_prcode"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Project Code<span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   id="site_prcode"
//                   name="site_prcode"
//                   placeholder="e.g. PRJ-RD-NH44-AP-01"
//                   onChange={handleInputChange}
//                   value={formData.site_prcode}
//                   className={`form-text-trasformation-uppercase form-input-div  ${errors.site_prcode
//                     ? "error"
//                     : inputState.site_prcode
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.site_prcode && (
//                   <span className="error-message font-size-text ">
//                     {errors.site_prcode}
//                   </span>
//                 )}
//               </div>

//               <div title="Project Short Name" className="flex-column">
//                 <label
//                   htmlFor="project_short_name"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Short Name<span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   id="project_short_name"
//                   name="project_short_name"
//                   placeholder="e.g. NH44 Bypass"
//                   onChange={handleInputChange}
//                   value={formData.project_short_name}
//                   className={`form-input-div  ${errors.project_short_name
//                     ? "error"
//                     : inputState.project_short_name
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.project_short_name && (
//                   <span className="error-message font-size-text ">
//                     {errors.project_short_name}
//                   </span>
//                 )}
//               </div>

//               <div title="Location" className="flex-column">
//                 <label
//                   htmlFor="location"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Location (State)<span className="required">*</span>
//                 </label>

//                 <Select
//                   name="location"
//                   options={locationOptions}
//                   value={
//                     formData.location
//                       ? { value: formData.location, label: formData.location }
//                       : null
//                   }
//                   onChange={(selected) =>
//                     handleInputChange({
//                       target: {
//                         name: "location",
//                         value: selected?.value || "",
//                       },
//                     })
//                   }
//                   isSearchable={true}
//                   placeholder="Select Location"
//                   styles={CSSForSelect23vWWidth}
//                 />

//                 {errors.location && (
//                   <span className="error-message font-size-text ">
//                     {errors.location}
//                   </span>
//                 )}
//               </div>

//               <div title="Project Name" className="flex-column">
//                 <label
//                   htmlFor="project_name"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Project Name<span className="required">*</span>
//                 </label>
//                 <textarea
//                   id="project_name"
//                   name="project_name"
//                   placeholder="e.g. Construction of NH44 Bypass"
//                   onChange={handleInputChange}
//                   value={formData.project_name}
//                   rows={50}
//                   col={50}
//                   className={`form-textarea form-input-div  ${errors.project_name
//                     ? "error"
//                     : inputState.project_name
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.project_name && (
//                   <div className="error-message font-size-text">
//                     {errors.project_name}
//                   </div>
//                 )}
//               </div>

//               <div title="Project Key Points" className="flex-column">
//                 <label
//                   htmlFor="project_key_point"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Project Key Points
//                 </label>
//                 <textarea
//                   id="project_key_point"
//                   name="project_key_point"
//                   placeholder="e.g. 6-lane highway, elevated corridor"
//                   onChange={handleInputChange}
//                   value={formData.project_key_point}
//                   rows="50"
//                   cols="100"
//                   className={`form-textarea form-input-div  ${errors.project_key_point
//                     ? "error"
//                     : inputState.project_key_point
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.project_key_point && (
//                   <div className="error-message font-size-text">
//                     {errors.project_key_point}
//                   </div>
//                 )}
//               </div>

//               <div title="Site Sub Company" className="flex-column ">
//                 <div className="form-group-selectt">
//                   <label
//                     htmlFor="sub_company"
//                     className="form-labels  font-weight500    font-size-subheading"
//                     disabled
//                   >
//                     Site Sub Company<span className="required">*</span>
//                   </label>
//                   <br />
//                   <select
//                     id="sub_company"
//                     name="sub_company"
//                     placeholder="Site Sub Company"
//                     value={formData.sub_company}
//                     onChange={handleInputChange}
//                     className={`form-input form-group-selection location-input ${errors.sub_company
//                       ? "error"
//                       : inputState.sub_company
//                         ? "success"
//                         : ""
//                       }`}
//                   >
//                     <option value="">Select a Site SubCompany</option>
//                     <>
//                       {subcompany === "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" ?
//                         <>
//                           {siteSubCompanyList
//                             ?.sort((a, b) =>
//                               a.title.localeCompare(b.title, "en", {
//                                 ignorePunctuation: true,
//                               })
//                             ).filter(i => i.id === "6d96e791-c499-4524-ba5a-2e8d9f99ad7c")
//                             .map((i, index) => (
//                               <option key={index} value={i.id}>
//                                 {i.title}
//                               </option>
//                             ))}
//                         </>
//                         : <>
//                           {siteSubCompanyList
//                             ?.sort((a, b) =>
//                               a.title.localeCompare(b.title, "en", {
//                                 ignorePunctuation: true,
//                               })
//                             ).filter(i => i.id !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c")
//                             .map((i, index) => (
//                               <option key={index} value={i.id}>
//                                 {i.title}
//                               </option>
//                             ))}
//                         </>
//                       }

//                     </>

//                   </select>

//                 </div>
//                 <br />
//                 {errors.sub_company && (
//                   <span className="error-message font-size-text ">
//                     {errors.sub_company}
//                   </span>
//                 )}
//               </div>

//               <div title="Work Type" className="flex-column ">
//                 <div className="form-group-selectt">
//                   <label
//                     htmlFor="work_type"
//                     className="form-labels  font-weight500    font-size-subheading"
//                   >
//                     Work Type<span className="required">*</span>
//                   </label>
//                   <br />
//                   <Select
//                     options={workTypeOptions}
//                     isSearchable={true}
//                     placeholder="Select Work Type"
//                     value={workTypeOptions.find(
//                       (opt) => opt.value === formData.work_type
//                     )}
//                     onChange={(selectedOption) => {
//                       setFormData({
//                         ...formData,
//                         work_type: selectedOption ? selectedOption.value : "",
//                       });

//                       setInputState({
//                         ...inputState,
//                         work_type: selectedOption ? "green" : "",
//                       });
//                     }}
//                     styles={CSSForSelect23vWWidth}

//                   />
//                 </div>
//                 <br />
//                 {errors.work_type && (
//                   <span className="error-message font-size-text ">
//                     {errors.work_type}
//                   </span>
//                 )}
//               </div>



//               <div title="Project Length" className="flex-column">
//                 <label
//                   htmlFor="project_length"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Project Length (in KM)<span className="required">*</span>
//                 </label>
//                 <input
//                   type="number"
//                   maxLength={10}
//                   min={0}
//                   id="project_length"
//                   name="project_length"
//                   placeholder="e.g. 18.5"
//                   onChange={handleInputChange}
//                   value={formData.project_length}
//                   className={`form-input-date ${errors.project_length
//                     ? "error"
//                     : inputState.project_length
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.project_length && (
//                   <span className="error-message font-size-text ">
//                     {errors.project_length}
//                   </span>
//                 )}
//               </div>
//               <div title="GST Number" className="flex-column">
//                 <label
//                   htmlFor="gst_no"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   GST Number<span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   id="gst_no"
//                   name="gst_no"
//                   placeholder="Enter GST No."
//                   onChange={handleInputChange}
//                   value={formData.gst_no}
//                   className={`form-input-date ${errors.gst_no
//                     ? "error"
//                     : inputState.gst_no
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.gst_no && (
//                   <span className="error-message font-size-text ">
//                     {errors.gst_no}
//                   </span>
//                 )}
//               </div>
//               <div title="PAN Number" className="flex-column">
//                 <label
//                   htmlFor="pan_no"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   PAN Number<span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   id="pan_no"
//                   name="pan_no"
//                   placeholder="Enter PAN No."
//                   onChange={handleInputChange}
//                   value={formData.pan_no}
//                   className={`form-input-date ${errors.pan_no
//                     ? "error"
//                     : inputState.pan_no
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.pan_no && (
//                   <span className="error-message font-size-text ">
//                     {errors.pan_no}
//                   </span>
//                 )}
//               </div>

//               <div title="Bid Due Date" className="flex-column">
//                 <label
//                   htmlFor="bid_due_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Bid Due Date
//                 </label>
//                 <input
//                   type="date"
//                   id="bid_due_date"
//                   name="bid_due_date"
//                   placeholder="e.g. 05/15/2025"
//                   onChange={handleInputChange}
//                   value={formData.bid_due_date}
//                   className={`form-input-date ${errors.bid_due_date
//                     ? "error"
//                     : inputState.bid_due_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.bid_due_date && (
//                   <span className="error-message font-size-text">
//                     {errors.bid_due_date}
//                   </span>
//                 )}
//               </div>

//               <div title="LOA Date" className="flex-column">
//                 <label
//                   htmlFor="loa_award_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   LOA Date
//                 </label>
//                 <input
//                   type="date"
//                   id="loa_award_date"
//                   name="loa_award_date"
//                   min={formData.bid_due_date}
//                   placeholder="e.g. 06/01/2025"
//                   onChange={handleInputChange}
//                   value={formData.loa_award_date}
//                   className={`form-input-date ${errors.loa_award_date
//                     ? "error"
//                     : inputState.loa_award_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.loa_award_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.loa_award_date}
//                   </span>
//                 )}
//               </div>

//               <div title="Agreement Date" className="flex-column">
//                 <label
//                   htmlFor="agreement_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Agreement Date
//                 </label>
//                 <input
//                   type="date"
//                   id="agreement_date"
//                   name="agreement_date"
//                   min={formData.bid_due_date}
//                   placeholder="e.g. 06/20/2025"
//                   onChange={handleInputChange}
//                   value={formData.agreement_date}
//                   className={`form-input-date ${errors.agreement_date
//                     ? "error"
//                     : inputState.agreement_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.agreement_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.agreement_date}
//                   </span>
//                 )}
//               </div>

//               <div title="Commencement Date" className="flex-column">
//                 <label
//                   htmlFor="commencement_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Commencement Date
//                 </label>
//                 <input
//                   type="date"
//                   id="commencement_date"
//                   name="commencement_date"
//                   min={formData.agreement_date}
//                   placeholder="e.g. 07/01/2025"
//                   onChange={handleInputChange}
//                   value={formData.commencement_date}
//                   className={`form-input-date ${errors.commencement_date
//                     ? "error"
//                     : inputState.commencement_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.commencement_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.commencement_date}
//                   </span>
//                 )}
//               </div>

//               <div title="Mobilization Date" className="flex-column">
//                 <label
//                   htmlFor="mobilization"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Mobilization Date
//                 </label>
//                 <input
//                   type="date"
//                   id="mobilization"
//                   name="mobilization"
//                   min={formData.agreement_date}
//                   placeholder="e.g. 07/01/2025"
//                   onChange={handleInputChange}
//                   value={formData.mobilization}
//                   className={`form-input-date ${errors.mobilization
//                     ? "error"
//                     : inputState.mobilization
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.mobilization && (
//                   <span className="error-message font-size-text ">
//                     {errors.mobilization}
//                   </span>
//                 )}
//               </div>



//               <div title="O&M Duration" className="flex-column">
//                 <label
//                   htmlFor="om_duration"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   O & M Duration
//                 </label>
//                 <input
//                   type="Number"
//                   onWheel={(e) => e.target.blur()}
//                   id="om_duration"
//                   name="om_duration"
//                   placeholder="e.g. 60"
//                   onChange={handleInputChange}
//                   value={formData.om_duration}
//                   className={`form-input-date ${errors.om_duration
//                     ? "error"
//                     : inputState.om_duration
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.om_duration && (
//                   <span className="error-message font-size-text ">
//                     {errors.om_duration}
//                   </span>
//                 )}
//               </div>

//               <div title="  Construction Duration " className="flex-column">
//                 <label
//                   htmlFor="construction_duration"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Construction Duration
//                 </label>
//                 <input
//                   type="Number"
//                   onWheel={(e) => e.target.blur()}
//                   id="construction_duration"
//                   name="construction_duration"
//                   placeholder="e.g. 18"
//                   onChange={handleInputChange}
//                   value={formData.construction_duration}
//                   className={`form-input-date ${errors.construction_duration
//                     ? "error"
//                     : inputState.construction_duration
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.construction_duration && (
//                   <span className="error-message font-size-text ">
//                     {errors.construction_duration}
//                   </span>
//                 )}
//               </div>

//               <div title="Project Duration" className="flex-column">
//                 <label
//                   htmlFor="project_duration"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Project Duration (In Months)
//                   <span className="required">Read-Only</span>
//                 </label>
//                 <input
//                   type="Number"
//                   onWheel={(e) => e.target.blur()}
//                   id="project_duration"
//                   name="project_duration"
//                   placeholder="e.g. 24"
//                   onChange={handleInputChange}
//                   value={formData.project_duration}
//                   className={`form-input-date ${errors.project_duration
//                     ? "error"
//                     : inputState.project_duration
//                       ? "success"
//                       : ""
//                     }`}
//                   disabled
//                 />
//                 {errors.project_duration && (
//                   <span className="error-message font-size-text ">
//                     {errors.project_duration}
//                   </span>
//                 )}
//               </div>

//               <div
//                 title="Schedule Construction Completion Date"
//                 className="flex-column"
//               >
//                 <label
//                   htmlFor="schedule_construction_completion_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Schedule Construction Completion Date
//                   <span className="required">Read-Only</span>

//                 </label>
//                 <input
//                   type="date"
//                   id="schedule_construction_completion_date"
//                   name="schedule_construction_completion_date"
//                   min={formData.commencement_date}
//                   placeholder="e.g. 12/31/2026"
//                   onChange={handleInputChange}
//                   readOnly

//                   value={formData.schedule_construction_completion_date}
//                   className={`form-input-date ${errors.schedule_construction_completion_date
//                     ? "error"
//                     : inputState.schedule_construction_completion_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.schedule_construction_completion_date && (
//                   <span className="error-message font-size-text">
//                     {errors.schedule_construction_completion_date}
//                   </span>
//                 )}
//               </div>

//               <div title="Target Date" className="flex-column">
//                 <label
//                   htmlFor="schedule_completion_date"
//                   className="form-labels  font-weight500   "
//                 >
//                   Schedule Completion Date
//                   <span className="required">Read-Only</span>

//                 </label>
//                 <input
//                   type="date"
//                   id="schedule_completion_date"
//                   name="schedule_completion_date"
//                   min={formData.actual_construction_completion_date}
//                   placeholder="e.g. 06/30/2027"
//                   onChange={handleInputChange}
//                   readOnly
//                   value={formData.schedule_completion_date}
//                   className={`form-input-date ${errors.schedule_completion_date
//                     ? "error"
//                     : inputState.schedule_completion_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.schedule_completion_date && (
//                   <span className="error-message">
//                     {errors.schedule_completion_date}
//                   </span>
//                 )}
//               </div>
//               <div title="Authorized AE/IE" className="flex-column">
//                 <label
//                   htmlFor="athorized_IE_AE"
//                   className="form-labels  font-weight500   "
//                 >
//                   Authorized AE/IE
//                 </label>
//                 <input
//                   type="text"
//                   id="athorized_IE_AE"
//                   name="athorized_IE_AE"
//                   placeholder="Authorized AE/IE"
//                   onChange={handleInputChange}
//                   value={formData.athorized_IE_AE}
//                   className={`form-input-date ${errors.athorized_IE_AE
//                     ? "error"
//                     : inputState.athorized_IE_AE
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.athorized_IE_AE && (
//                   <span className="error-message">
//                     {errors.athorized_IE_AE}
//                   </span>
//                 )}
//               </div>

//               <div title="Site Supervision on behalf of AE/IE" className="flex-column ">
//                 <div className=" form-group-selectt">
//                   <label className="form-labels  font-weight500    font-size-subheading">
//                     Supervision on behalf of AE/IE
//                   </label>
//                   <br />
//                   <Select
//                     options={authorityEngineerOptions}
//                     isSearchable
//                     isClearable
//                     placeholder="Select Authority Engineer"
//                     value={authorityEngineerOptions.find(
//                       opt => opt.value === formData.authority_engineer
//                     )}
//                     onChange={handleAuthorityEngineerChange}
//                     styles={CSSForSelect23vWWidth}
//                   />
//                 </div>
//                 {errors.authority_engineer && (
//                   <span className="error-message font-size-text ">
//                     {errors.authority_engineer}
//                   </span>
//                 )}
//               </div>

//               <div className="flex-row justify-around">
//                 <div className="flex-column form-group-select">
//                   <label className="form-labels">
//                     Coordinator:
//                   </label>
//                   {buffer ?
//                     <div className="form-loader-date">
//                       <div className="bar-loader"></div>
//                     </div>
//                     :
//                     <>
//                       <Select
//                         options={operatorOptions}
//                         isMulti
//                         onChange={handleChangeAssignedTo}
//                         value={formData.com_operators?.map((code) => ({
//                           value: code,
//                           label: operatorOptions.find((opt) => opt.value === code)?.label || code,
//                         }))}
//                         styles={{
//                           control: (provided) => ({
//                             ...provided,
//                             width: '23vw',
//                             minHeight: '50px',
//                             borderRadius: '10px',
//                             border: '1px solid #e3e3e3',
//                             margin: '10px 0px 28px 0px',
//                             color: '#4a4a4a',
//                             backgroundColor: '#f7f8fa',
//                             // padding: '0px 10px',
//                           }),
//                           placeholder: (provided) => ({
//                             ...provided,
//                             color: '#4a4a4a',
//                           }),
//                           menu: (provided) => ({
//                             ...provided,
//                             borderRadius: '10px',
//                             marginTop: '0',
//                           }),
//                           input: (provided) => ({
//                             ...provided,
//                             color: '#4a4a4a',
//                           }),
//                           singleValue: (provided) => ({
//                             ...provided,
//                             color: '#4a4a4a',
//                           }),
//                         }}
//                       />
//                       {errors.com_operators && (
//                         <span className="error-message font-size-text ">{errors.person}</span>
//                       )}
//                     </>}
//                 </div>
//               </div>

//               <div title="Remark" className="flex-column">
//                 <label
//                   htmlFor="remark"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Remark
//                 </label>
//                 <input
//                   type="text"
//                   id="remark"
//                   name="remark"
//                   placeholder="Remark"
//                   onChange={handleInputChange}
//                   value={formData.remark}
//                   className={`form-input-date ${errors.remark ? "error" : inputState.remark ? "success" : ""
//                     }`}
//                 />
//                 {errors.remark && (
//                   <span className="error-message font-size-text ">
//                     {errors.remark}
//                   </span>
//                 )}
//               </div>

//               <div title="Consultancy Fees" className="flex-column">
//                 <label
//                   htmlFor="consultancy_fees"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Consultancy Fees (Write Full amount)
//                 </label>
//                 <input
//                   type="number"
//                   min={0}
//                   id="consultancy_fees"
//                   name="consultancy_fees"
//                   placeholder="Consultancy Fees"
//                   onChange={handleInputChange}
//                   value={formData.consultancy_fees}
//                   className={`form-input-date  ${errors.consultancy_fees
//                     ? "error"
//                     : inputState.consultancy_fees
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.consultancy_fees && (
//                   <span className="error-message font-size-text">
//                     {errors.consultancy_fees}
//                   </span>
//                 )}
//               </div>
//               <div title="Contract Mode" className="flex-column ">
//                 <div className=" form-group-selectt">
//                   <label className="form-labels  font-weight500    font-size-subheading">
//                     Contract Mode
//                   </label>
//                   <br />
//                   <Select
//                     options={contractModeOptions}
//                     isSearchable
//                     placeholder="Select Contract Mode"
//                     value={contractModeOptions.find(
//                       opt => opt.value === formData.contract_mode
//                     )}
//                     onChange={handleContractModeChange}
//                     styles={CSSForSelect23vWWidth}
//                   />
//                   {/* <div className="form-group-selection-arrow">

//                   </div> */}
//                 </div>
//                 {errors.contract_mode && (
//                   <span className="error-message font-size-text ">
//                     {errors.contract_mode}
//                   </span>
//                 )}
//               </div>

//               <div title="Lead" className="flex-column">
//                 <label
//                   htmlFor="lead"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Lead<span className="required">*</span>
//                 </label>
//                 <Select
//                   options={consultantOptions}
//                   isSearchable={true}
//                   isClearable
//                   placeholder="Select"
//                   value={consultantOptions.find(
//                     (opt) => opt.value === formData.lead
//                   )}
//                   onChange={(selectedOption) => {
//                     setFormData({
//                       ...formData,
//                       lead: selectedOption ? selectedOption.value : "",
//                     });

//                     setInputState({
//                       ...inputState,
//                       lead: selectedOption ? "green" : "",
//                     });
//                   }}
//                   styles={CSSForSelect23vWWidth}

//                 />

//                 {errors.lead && (
//                   <span className="error-message font-size-text ">
//                     {errors.lead}
//                   </span>
//                 )}
//               </div>

//               <div title="JV" className="flex-column">
//                 <label
//                   htmlFor="jv"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   JV Partner
//                 </label>
//                 <Select
//                   options={consultantOptions}
//                   isSearchable={true}
//                   placeholder="Select JV"
//                   isClearable
//                   value={consultantOptions.find(
//                     (opt) => opt.value === formData.jv
//                   )}
//                   onChange={(selectedOption) => {
//                     setFormData({
//                       ...formData,
//                       jv: selectedOption ? selectedOption.value : "",
//                     });

//                     setInputState({
//                       ...inputState,
//                       jv: selectedOption ? "green" : "",
//                     });
//                   }}
//                   styles={CSSForSelect23vWWidth}

//                 />
//                 {errors.jv && (
//                   <span className="error-message font-size-text ">
//                     {errors.jv}
//                   </span>
//                 )}
//               </div>
//               <div title="Association" className="flex-column">
//                 <label
//                   htmlFor="association"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Association Partner
//                 </label>
//                 <Select
//                   options={consultantOptions}
//                   isSearchable={true}
//                   isClearable
//                   placeholder="Select Association Partner"
//                   value={consultantOptions.find(
//                     (opt) => opt.value === formData.association
//                   )}
//                   onChange={(selectedOption) => {
//                     setFormData({
//                       ...formData,
//                       association: selectedOption ? selectedOption.value : "",
//                     });

//                     setInputState({
//                       ...inputState,
//                       association: selectedOption ? "green" : "",
//                     });
//                   }}
//                   styles={CSSForSelect23vWWidth}

//                 />
//                 {errors.association && (
//                   <span className="error-message font-size-text ">
//                     {errors.association}
//                   </span>
//                 )}
//               </div>

//               <div title="Client Name" className="flex-column">
//                 <label
//                   htmlFor="client_name"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Client
//                 </label>

//                 <Select
//                   options={extendedConsultantOptions}
//                   isSearchable={true}
//                   isClearable
//                   placeholder="Select"
//                   value={extendedConsultantOptions.find(
//                     (opt) => opt.value === formData.client_name
//                   )}
//                   onChange={(selectedOption) => {
//                     setFormData({
//                       ...formData,
//                       client_name: selectedOption ? selectedOption.value : "",
//                     });

//                     setInputState({
//                       ...inputState,
//                       client_name: selectedOption ? "green" : "",
//                     });
//                   }}
//                   styles={CSSForSelect23vWWidth}

//                 />

//                 {errors.client_name && (
//                   <span className="error-message font-size-text ">
//                     {errors.client_name}
//                   </span>
//                 )}
//               </div>

//               <div title="Our Share" className="flex-column">
//                 <label
//                   htmlFor="our_share"
//                   className="form-labels font-weight500 font-size-subheading"
//                 >
//                   {/* {formData.sub_company ? formData.sub_company : "Our"} Share */}
//                   Lead Partner Share (%)
//                   {/* Saptagon Share */}
//                 </label>

//                 <input
//                   type="text"
//                   id="our_share"
//                   name="our_share"
//                   placeholder="Enter percentage (%)"
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     if (
//                       value === "" ||
//                       (/^\d+\.?\d{0,2}$/.test(value) && value <= 100)
//                     ) {
//                       handleInputChange(e);
//                     }
//                   }}
//                   value={`${formData.our_share ? formData.our_share : ""}`}
//                   className={`form-input-date ${errors.our_share
//                     ? "error"
//                     : inputState.our_share
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.our_share && (
//                   <span className="error-message font-size-text ">
//                     {errors.our_share}
//                   </span>
//                 )}
//               </div>


//               <div title="Associate Partner Share" className="flex-column">
//                 <label
//                   htmlFor="associate_partner_share"
//                   className="form-labels font-weight500 font-size-subheading"
//                 >
//                   {/* {formData.sub_company ? formData.sub_company : "Our"} Share */}
//                   Associate Partner Share (%)
//                   {/* Saptagon Share */}
//                 </label>

//                 <input
//                   type="number"
//                   id="associate_partner_share"
//                   name="associate_partner_share"
//                   placeholder="Enter percentage (%)"
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     if (
//                       value === "" ||
//                       (/^\d+\.?\d{0,2}$/.test(value) && value <= 100)
//                     ) {
//                       handleInputChange(e);
//                     }
//                   }}
//                   value={`${formData.associate_partner_share ? formData.associate_partner_share : ""}`}
//                   className={`form-input-date ${errors.associate_partner_share
//                     ? "error"
//                     : inputState.associate_partner_share
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.associate_partner_share && (
//                   <span className="error-message font-size-text ">
//                     {errors.associate_partner_share}
//                   </span>
//                 )}
//               </div>
//               <div title="Jv Share" className="flex-column">
//                 <label
//                   htmlFor="jv_share"
//                   className="form-labels font-weight500 font-size-subheading"
//                 >
//                   {/* {formData.sub_company ? formData.sub_company : "Our"} Share */}
//                   Jv Share (%)
//                   {/* Saptagon Share */}
//                 </label>

//                 <input
//                   type="number"
//                   id="jv_share"
//                   name="jv_share"
//                   placeholder="Enter percentage (%)"
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     if (
//                       value === "" ||
//                       (/^\d+\.?\d{0,2}$/.test(value) && value <= 100)
//                     ) {
//                       handleInputChange(e);
//                     }
//                   }}
//                   value={`${formData.jv_share ? formData.jv_share : ""}`}
//                   className={`form-input-date ${errors.jv_share
//                     ? "error"
//                     : inputState.jv_share
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.jv_share && (
//                   <span className="error-message font-size-text ">
//                     {errors.jv_share}
//                   </span>
//                 )}
//               </div>







//               <div title="Regional Office Name" className="flex-column">
//                 <label htmlFor="work_performed_by" className="form-labels  font-weight500    font-size-subheading">
//                   Regional Office Name (RO Name)
//                 </label>
//                 <input
//                   type="text"
//                   id="ro"
//                   name="ro"
//                   placeholder="Regional Office Name"
//                   onChange={handleInputChange}
//                   value={formData.ro}
//                   className={`form-input-div  ${errors.ro ? "error" : inputState.ro ? "success" : ""
//                     }`}
//                 />
//                 {errors.ro && (
//                   <span className="error-message font-size-text ">
//                     {errors.ro}
//                   </span>
//                 )}
//               </div>

//               <div
//                 title="Regional Office Address (RO Address)"
//                 className="flex-column"
//               >
//                 <label
//                   htmlFor="ro_address"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Regional Office Address (RO Address)
//                 </label>
//                 <textarea
//                   id="ro_address"
//                   name="ro_address"
//                   placeholder="Regional Office Address"
//                   onChange={handleInputChange}
//                   value={formData.ro_address}
//                   rows="50"
//                   cols="100"
//                   className={`form-textarea form-input-div  ${errors.ro_address
//                     ? "error"
//                     : inputState.ro_address
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.ro_address && (
//                   <div className="error-message font-size-text">
//                     {errors.ro_address}
//                   </div>
//                 )}
//               </div>

//               <div title="PIU Address" className="flex-column">
//                 <label
//                   htmlFor="piu_address"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Project Implementation Unit Name (PIU Name)
//                 </label>
//                 <textarea
//                   id="piu_address"
//                   name="piu_address"
//                   placeholder="PIU Address"
//                   onChange={handleInputChange}
//                   value={formData.piu_address}
//                   rows="50"
//                   cols="100"
//                   className={`form-textarea form-input-div  ${errors.piu_address
//                     ? "error"
//                     : inputState.piu_address
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.piu_address && (
//                   <div className="error-message font-size-text">
//                     {errors.piu_address}
//                   </div>
//                 )}
//               </div>

//               <div title="Site Address" className="flex-column">
//                 <label
//                   htmlFor="site_office_address"
//                   className="form-labels  font-weight500 font-size-subheading"
//                 >
//                   Site Address
//                 </label>
//                 <textarea
//                   id="site_office_address"
//                   name="site_office_address"
//                   placeholder="Site Address"
//                   onChange={handleInputChange}
//                   value={formData.site_office_address}
//                   rows="50"
//                   cols="100"
//                   className={`form-textarea form-input-div  ${errors.site_office_address
//                     ? "error"
//                     : inputState.site_office_address
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.site_office_address && (
//                   <div className="error-message font-size-text">
//                     {errors.site_office_address}
//                   </div>
//                 )}
//               </div>
//               <div title="Client Address" className="flex-column">
//                 <label
//                   htmlFor="client_address"
//                   className="form-labels  font-weight500 font-size-subheading"
//                 >
//                   Client Address
//                 </label>
//                 <textarea
//                   id="client_address"
//                   name="client_address"
//                   placeholder="Site Address"
//                   onChange={handleInputChange}
//                   value={formData.client_address}
//                   rows="50"
//                   cols="100"
//                   className={`form-textarea form-input-div  ${errors.client_address
//                     ? "error"
//                     : inputState.client_address
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.client_address && (
//                   <div className="error-message font-size-text">
//                     {errors.client_address}
//                   </div>
//                 )}
//               </div>




//             </div>

//             <div className="button-models justifycontentimportant" style={{ gap: "24px" }}>
//               <button
//                 type="button"
//                 onClick={handleClose}
//                 className="model-button font-weight500 model-button-cancel"


//               >
//                 {/* //loading logic */}
//                 Cancel
//               </button>
//               <button
//                 type="button"
//                 onClick={handleFormSubmit}
//                 className="model-button font-weight500 model-button-submit"
//                 disabled={loading}
//               >
//                 {/* //loading logic */}
//                 Submit
//               </button>
//             </div>
//             <p className="error-message font-size-text">
//               {isSubmitted && Object.keys(errors).length > 0 && (
//                 Object.keys(errors).length > 5 ? (
//                   <h5 className="text-center">Please fill all mandatory fields!</h5>
//                 ) : (

//                   <h6 className="text-center">
//                     {Object.keys(errors).map((field) =>
//                       field.charAt(0).toUpperCase() + field.slice(1)
//                     ).join(', ') + ' are required!'}
//                   </h6>
//                 )
//               )}
//             </p>
//           </form>
//           <ToastContainer
//             position="top-center"
//             autoClose={1000}
//             hideProgressBar={false}
//             newestOnTop={true}
//             closeOnClick
//             rtl={false}
//             pauseOnFocusLoss
//             draggable
//             pauseOnHover
//           />
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };




const AddProjectDetails = ({ getProjects, subcompany }) => {
  const [show, setShow] = useState(false);
  const [activeSection, setActiveSection] = useState('basic');
  const [clientList, setClientList] = useState([]);
  const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
  const [empList, setEmpList] = useState([]);
  const [operatorempList, setoperatorEmpList] = useState([]);
  const [buffer, setBuffering] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [filteredList, setFilteredList] = useState([]);

  const siteSubcompany = sessionStorage.getItem("sitemanagement_project_sub_company");
  const uniqueStreamTypes = new Set();

  // Section configuration
  const sections = [
    { id: 'basic', label: 'Basic Info', icon: Info },
    { id: 'timeline', label: 'Timeline', icon: Calendar },
    { id: 'financial', label: 'Financial', icon: IndianRupee },
    { id: 'partners', label: 'Partners', icon: Users },
    { id: 'address', label: 'Addresses', icon: MapPin },
  ];

  const [formData, setFormData] = useState({
    site_prcode: "",
    project_name: "",
    project_short_name: "",
    location: "",
    sub_company: "",
    work_type: "",
    bid_due_date: null,
    loa_award_date: null,
    pan_no: "",
    gst_no: "",
    agreement_date: null,
    commencement_date: null,
    authority_engineer: "",
    project_length: "",
    tender_id: "",
    actual_completion_date: null,
    actual_construction_completion_date: null,
    schedule_construction_completion_date: null,
    mobilization: null,
    remark: "",
    consultancy_fees: "",
    contract_mode: "",
    lead: "",
    ro: "",
    ro_address: "",
    piu_address: "",
    jv: "",
    our_share: "",
    jv_share: "",
    association: "",
    work_performed_by: "",
    client_name: "",
    project_duration: "",
    our_role: "",
    site_office_address: "",
    om_duration: "",
    construction_duration: "",
    com_operators: [],
    imprest_amount: "",
    athorized_IE_AE: "",
    associate_partner_share: "",
    client_address: "",
    project_key_point: "",
    escalation_apllicable_on: "",
    concern_person: "",
    construction_cost: 0,
    contractor_address: "",
    appointed_date: null,
    bgid_submission_date: null,
    status: ""
  });


  const updateStatusAndRemarks = useCallback(() => {
    setFormData((prevFormData) => {
      let newStatus = "";
      let newRemark = "";

      if (prevFormData.actual_completion_date) {
        newStatus = "Completed";
        newRemark = "The project is successfully completed.";
      } else if (prevFormData.actual_construction_completion_date) {
        newStatus = "Yet to Complete including O&M";
        newRemark = "Construction phase completed; O&M is pending.";
      } else if (prevFormData.schedule_completion_date) {
        newStatus = "In Progress";
        newRemark = "Project is currently in progress.";
      } else if (prevFormData.schedule_construction_completion_date) {
        newStatus = "In Progress including O&M";
        newRemark = "Construction is in progress along with O&M.";
      } else if (prevFormData.commencement_date) {
        newStatus = "Yet to Commence";
        newRemark = "Project commencement is yet to start.";
      } else if (prevFormData.agreement_date) {
        newStatus = "Yet to Sign Agreement";
        newRemark = "Agreement signing is pending.";
      } else if (prevFormData.bgid_submission_date) {
        newStatus = "Yet to Submit BG";
        newRemark = "Bank Guarantee submission is pending.";
      } else if (prevFormData.loa_award_date) {
        newStatus = "Yet to Award";
        newRemark = "Letter of Award is pending.";
      } else if (prevFormData.bid_due_date) {
        newStatus = "Yet to Bid";
        newRemark = "Bid submission is pending.";
      }

      // ✅ Only update if values actually changed — prevents re-render cascade
      if (
        prevFormData.status === newStatus &&
        prevFormData.remark === newRemark
      ) {
        return prevFormData; // Return same reference = no re-render
      }

      return { ...prevFormData, status: newStatus, remark: newRemark };
    });
  }, []); // ✅ Empty deps — setFormData is stable, prevFormData comes from updater

  useEffect(() => {
    updateStatusAndRemarks();
  }, [
    formData.actual_completion_date,
    formData.actual_construction_completion_date,
    formData.schedule_completion_date,
    formData.schedule_construction_completion_date,
    formData.commencement_date,
    formData.agreement_date,
    formData.bgid_submission_date,
    formData.loa_award_date,
    formData.bid_due_date,
    updateStatusAndRemarks,
  ]);

  // Auto-calculate project duration
  useEffect(() => {
    const { construction_duration, om_duration, mobilization } = formData;

    const projectDuration = construction_duration && om_duration
      ? Number(construction_duration) + Number(om_duration)
      : "";

    const addMonthsToDate = (dateString, months) => {
      if (!dateString || !months) return "";
      const date = new Date(dateString);
      date.setMonth(date.getMonth() + Number(months));
      return date.toISOString().split("T")[0];
    };

    const scheduleConstructionCompletionDate = addMonthsToDate(mobilization, construction_duration);
    const projectCompletionDate = addMonthsToDate(mobilization, projectDuration);

    if (formData.mobilization && formData.construction_duration) {
      setFormData((prev) => ({
        ...prev,
        project_duration: projectDuration,
        schedule_construction_completion_date: scheduleConstructionCompletionDate,
        schedule_completion_date: projectCompletionDate,
      }));
    }
    else {
      setFormData((prev) => ({
        ...prev,
        project_duration: projectDuration,
        schedule_construction_completion_date: null,
        schedule_completion_date: null,
      }));
    }

  }, [formData.construction_duration, formData.om_duration, formData.mobilization]);

  const getSubCompany = async () => {
    try {
      const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSiteSubCompanyList(sub.data);
    } catch (error) {
      console.error(error);
    }
  };

  const getAllEmp_code = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/employeebyfilterss/null/null/null/null/null/AuthorityEngineer/null/`
      );
      const ress = await axios.get(
        `${BASE_URL}/siteproject/employeebyfilterss/null/null/null/null/null/DataEntryOperator/null/`
      );

      const sortedList = customSortByKey(res.data, "emp_code");
      const sortedListt = customSortByKey(ress.data, "emp_code");

      setEmpList(sortedList);
      setoperatorEmpList(sortedListt);

      const cli = await axios.get(`${BASE_URL}/siteproject/project-clients/`);
      setClientList(cli.data);
    } catch (err) {
      console.error(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    if (show) {
      getAllEmp_code();
      getSubCompany();
      clientList.forEach((entry) => {
        uniqueStreamTypes.add(entry.client_name);
      });
    }
  }, [formData.sub_company, subcompany, show]);

  const handleShow = () => {
    setShow(true);
    setActiveSection('basic');
  };

  const handleClose = () => {
    setFormData({
      site_prcode: "",
      project_name: "",
      project_short_name: "",
      location: "",
      pan_no: "",
      gst_no: "",
      sub_company: "",
      work_type: "",
      bid_due_date: "null",
      loa_award_date: "null",
      actual_construction_completion_date: "null",
      schedule_construction_completion_date: "null",
      agreement_date: "null",
      commencement_date: "null",
      concern_person: "",
      authority_engineer: "",
      project_length: "",
      tender_id: "",
      actual_completion_date: "null",
      schedule_completion_date: "null",
      construction_cost: 0,
      remark: "",
      consultancy_fees: "",
      contract_mode: "",
      lead: "",
      jv: "",
      our_share: "",
      jv_share: "",
      association: "",
      work_performed_by: "",
      client_name: "",
      project_key_point: "",
      ro: "",
      ro_address: "",
      escalation_apllicable_on: "",
      piu_address: "",
      contractor_address: "",
      project_duration: "",
      our_role: "",
      site_office_address: "",
      om_duration: "",
      construction_duration: "",
      com_operators: [],
      imprest_amount: "",
      athorized_IE_AE: "",
      associate_partner_share: "",
      client_address: "",
      mobilization: null,
      bgid_submission_date: null,
      status: ""
    });
    setErrors({});
    setInputState({});
    setShow(false);
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "site_prcode", "project_name", "project_short_name", "location", "escalation_apllicable_on",
      "work_type", "lead", "tender_id", "project_length", "pan_no", "gst_no", "escalation_apllicable_on"
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target || e;

    const capitalizeFields = ["tender_id", "location", "project_short_name", "site_prcode"];
    const finalValue = capitalizeFields.includes(name) ? value.toUpperCase() : value;

    setInputState({ ...inputState, [name]: finalValue.trim() ? "green" : "" });

    const updatedFormData = { ...formData, [name]: finalValue };

    const omDuration = parseInt(name === "om_duration" ? finalValue : formData.om_duration) || 0;
    const constructionDuration = parseInt(name === "construction_duration" ? finalValue : formData.construction_duration) || 0;

    if (name === "om_duration" || name === "construction_duration") {
      updatedFormData.project_duration = omDuration + constructionDuration;
    }

    setFormData(updatedFormData);

    setErrors((prev) => {
      const updated = { ...prev };
      if (finalValue) delete updated[name];
      return updated;
    });

    if (name === "client_name") {
      const filtered = clientList.filter((item) =>
        item?.client_name?.toLowerCase().includes(finalValue.toLowerCase())
      );
      const uniqueFiltered = Array.from(new Map(filtered.map((item) => [item.client_name, item])).values());
      setFilteredList(uniqueFiltered);
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        let res = await axios.post(`${BASE_URL}/siteproject/project/`, formData);
        if (res.status === 200 || res.status === 201) {
          toast.success("Project created successfully!");
          handleClose();
          await getProjects();
        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  const handleChangeAssignedTo = (selected) => {
    const com_operators = selected?.map((item) => item.value) || [];
    setFormData((prevState) => ({
      ...prevState,
      com_operators,
    }));
  };

  const handleAuthorityEngineerChange = (selectedOption) => {
    setFormData(prev => ({
      ...prev,
      authority_engineer: selectedOption ? selectedOption.value : "",
    }));
    setInputState(prev => ({
      ...prev,
      authority_engineer: selectedOption ? "green" : "",
    }));
  };

  const handleContractModeChange = (selectedOption) => {
    setFormData(prev => ({
      ...prev,
      contract_mode: selectedOption ? selectedOption.value : "",
    }));
    setInputState(prev => ({
      ...prev,
      contract_mode: selectedOption ? "green" : "",
    }));
  };




  // Options arrays
  const sortedStatesAndUTs = [...statesAndUTs].sort();
  const locationOptions = sortedStatesAndUTs.map((state) => ({ value: state, label: state }));

  const workTypeOptions = [
    { value: "Construction Consultant - Authority Engineer", label: "Construction Consultant - Authority Engineer" },
    { value: "Construction Consultant - Independent Engineer", label: "Construction Consultant - Independent Engineer" },
    { value: "Project Management Consultancy (PMC)", label: "Project Management Consultancy (PMC)" },
    { value: "Operation & Maintenance Consultant - Authority Engineer", label: "Operation & Maintenance Consultant - Authority Engineer" },
    { value: "Operation & Maintenance Consultant - Independent Engineer", label: "Operation & Maintenance Consultant - Independent Engineer" },
    { value: "Detailed Project Report (DPR)", label: "Detailed Project Report (DPR)" },
    { value: "Safety Consultant (SC)", label: "Safety Consultant (SC)" },
    { value: "Asset Monetization (AM)", label: "Asset Monetization (AM)" },
  ];

  const contractModeOptions = [
    { value: "epc", label: "EPC" },
    { value: "ham", label: "HAM" },
    { value: "bot", label: "BOT" },
  ];

  const escalationApplicableOnOptions = [
    { value: "Bid Due Date", label: "Bid Due Date" },
    { value: "Commencement Date", label: "Commencement Date" },
    { value: "Contract Agreement Date", label: "Contract Agreement Date" },
  ];

  const consultantOptions = [
    { value: "Chaitanya Projects Concsultancy Pvt. Ltd.", label: "Chaitanya Projects Concsultancy Pvt. Ltd." },
    { value: "G-Eng Advisory Services Pvt Ltd", label: "G-Eng Advisory Services Pvt Ltd" },
    { value: "Sapatgon Asia Private Limited", label: "Sapatgon Asia Private Limited" },
    { value: "AECOM Asia Company Limited", label: "AECOM Asia Company Limited" },
    { value: "Agnitio Infrastructure Projects Pvt. Ltd", label: "Agnitio Infrastructure Projects Pvt. Ltd" },
    { value: "Almondz Global Infra Consultant Limited", label: "Almondz Global Infra Consultant Limited" },
    { value: "Centro de Estudios de Materiales y Control de Obra, SA", label: "Centro de Estudios de Materiales y Control de Obra, SA" },
    { value: "Dhruv Consultancy Services Ltd.", label: "Dhruv Consultancy Services Ltd." },
    { value: "ARKITECHNO Consultancy (India) Pvt. Ltd.", label: "ARKITECHNO Consultancy (India) Pvt. Ltd." },
    { value: "FP India Project Management Consultancy Services Pvt.Ltd", label: "FP India Project Management Consultancy Services Pvt.Ltd" },
    { value: "Global Infra Solutions", label: "Global Infra Solutions" },
    { value: "JC Technocrats Pvt.Ltd", label: "JC Technocrats Pvt.Ltd" },
    { value: "Marc Technocrats Private Limited", label: "Marc Technocrats Private Limited" },
    { value: "RITES Ltd in association", label: "RITES Ltd in association" },
    { value: "Rodic Consultants Private Limited", label: "Rodic Consultants Private Limited" },
    { value: "Segmental Consulting & Infrastructure Advisory Pvt. Ltd", label: "Segmental Consulting & Infrastructure Advisory Pvt. Ltd" },
    { value: "TUMAS Turkish Engineering Consulting and Contracting Inc. Co.", label: "TUMAS Turkish Engineering Consulting and Contracting Inc. Co." },
    { value: "URS Scott Wilson India Pvt. Ltd", label: "URS Scott Wilson India Pvt. Ltd" },
    { value: "Voyants Solution Pvt. Ltd", label: "Voyants Solution Pvt. Ltd" },
    { value: "Infinite Solutions Private Limited", label: "Infinite Solutions Private Limited" },
    { value: "K & J Projects Private Limited", label: "K & J Projects Private Limited" },
    { value: "Open Solutions Infrastructure Consultancy Services Pvt. Ltd.", label: "Open Solutions Infrastructure Consultancy Services Pvt. Ltd." },
    { value: "Sterling Indo Tech Consultants Pvt. Ltd.", label: "Sterling Indo Tech Consultants Pvt. Ltd." },
    { value: "CivilMantra Infracon Pvt. Ltd", label: "CivilMantra Infracon Pvt. Ltd" },
    { value: "TPF Getinsa-Eurostudios, S.L", label: "TPF Getinsa-Eurostudios, S.L" },
    { value: "JS Infrastructure Consultants Pvt. Ltd.", label: "JS Infrastructure Consultants Pvt. Ltd." },
    { value: "DN Consultant", label: "DN Consultant" },
    { value: "India Engg.Consultants India Private Limited", label: "India Engg.Consultants India Private Limited" },
    { value: "Infinite Civil Solutions Pvt. Ltd", label: "Infinite Civil Solutions Pvt. Ltd" },
    { value: "Introsoft Solutions", label: "Introsoft Solutions" },
    { value: "Mahamarg Infra Consultants Private Limited", label: "Mahamarg Infra Consultants Private Limited" },
    { value: "MAV Associates LLP", label: "MAV Associates LLP" },
    { value: "MS Consultants", label: "MS Consultants" },
    { value: "MVK Infrabulid Pvt. Ltd.", label: "MVK Infrabulid Pvt. Ltd." },
    { value: "Nu-Infra Engineering Pvt Ltd.", label: "Nu-Infra Engineering Pvt Ltd." },
    { value: "Samarth Softech Solutions Pvt. Ltd.", label: "Samarth Softech Solutions Pvt. Ltd." },
    { value: "Shree Bhawani Consultancy Service Pvt. Ltd.,", label: "Shree Bhawani Consultancy Service Pvt. Ltd.," },
    { value: "Transtek Engineers & Services Pvt. Ltd.", label: "Transtek Engineers & Services Pvt. Ltd." },
    { value: "CivilMantra ConsAi Limited", label: "CivilMantra ConsAi Limited" },
    { value: "AVOK Engineering Consulting & Contracting Pvt. Ltd.", label: "AVOK Engineering Consulting & Contracting Pvt. Ltd." },
    { value: "Aicons Engineering Pvt. Ltd.", label: "Aicons Engineering Pvt. Ltd." },
    { value: "M/s Pentacon Associates.", label: "M/s Pentacon Associates." },

  ];

  const extendedConsultantOptions = [
    { label: "PWD", value: "PWD" },
    { label: "BRO", value: "BRO" },
    { label: "NHIDCL", value: "NHIDCL" },
    { label: "MoRTH", value: "MoRTH" },
    { label: "NHAI", value: "NHAI" },
    { label: "Other", value: "other" },
  ];

  const authorityEngineerOptions = empList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map(emp => ({ value: emp.id, label: `${emp.emp_code} - ${emp.name}` }));

  const operatorOptions = operatorempList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map(emp => ({ value: emp.id, label: `${emp.emp_code} - ${emp.name}` }));


  const [tabValidationAttempted, setTabValidationAttempted] = useState({});

  // Define required fields for each tab separately
  const tabRequiredFields = {
    basic: [
      "site_prcode", "project_name", "project_short_name", "location",
      "work_type", "tender_id", "project_length", "pan_no", "gst_no", "escalation_apllicable_on",
    ],
    timeline: [],
    financial: [],
    partners: ["lead"],
    address: []
  };

  // Function to validate only the current tab fields
  const validateCurrentTab = () => {
    const currentTab = activeSection;
    const newErrors = {};

    const fieldsToValidate = tabRequiredFields[currentTab] || [];

    fieldsToValidate.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    // Only set errors for current tab, preserve errors from other tabs
    setErrors(prev => ({
      ...prev,
      ...newErrors
    }));

    // Remove errors for fields that are now filled
    Object.keys(errors).forEach(field => {
      if (fieldsToValidate.includes(field) && formData[field]) {
        setErrors(prev => {
          const updated = { ...prev };
          delete updated[field];
          return updated;
        });
      }
    });

    setTabValidationAttempted(prev => ({ ...prev, [currentTab]: true }));

    return Object.keys(newErrors).length === 0;
  };

  // Updated goToNextTab function - only validates current tab
  const goToNextTab = () => {
    const currentIndex = sections.findIndex(s => s.id === activeSection);
    const nextTab = sections[currentIndex + 1]?.id;

    // Validate current tab only
    if (!validateCurrentTab()) {
      // Scroll to show errors
      const formContainer = document.querySelector('.modern-modal-body');
      if (formContainer) {
        formContainer.scrollTop = 0;
      }
      return; // Stay on current tab
    }

    // Clear errors for the next tab when moving forward
    if (nextTab) {
      setErrors(prev => {
        const nextTabFields = tabRequiredFields[nextTab] || [];
        const filteredErrors = { ...prev };
        nextTabFields.forEach(field => {
          delete filteredErrors[field];
        });
        return filteredErrors;
      });
    }

    if (currentIndex < sections.length - 1) {
      setActiveSection(nextTab);
    }
  };

  // Updated goToPreviousTab - no validation needed
  const goToPreviousTab = () => {
    const currentIndex = sections.findIndex(s => s.id === activeSection);
    if (currentIndex > 0) {
      setActiveSection(sections[currentIndex - 1].id);
      // Clear errors when moving back (optional)
      setErrors({});
    }
  };

  // Helper to check if current tab has errors
  const hasCurrentTabErrors = () => {
    const currentTab = activeSection;
    const fieldsToValidate = tabRequiredFields[currentTab] || [];
    return fieldsToValidate.some(field => errors[field]);
  };

  // Helper to get current tab error message
  const getCurrentTabErrorMessage = () => {
    const currentTab = activeSection;
    const missingFields = (tabRequiredFields[currentTab] || [])
      .filter(field => !formData[field])
      .map(field => field.charAt(0).toUpperCase() + field.slice(1));

    if (missingFields.length === 0) return null;

    if (missingFields.length === 1) {
      return `${missingFields[0]} is required to proceed`;
    }

    return `Please fill all required fields in ${currentTab.charAt(0).toUpperCase() + currentTab.slice(1)} Information before proceeding`;
  };

  // Render functions for each section
  const renderBasicInfo = () => (
    <div className="form-section">
      <div className="section-title">
        <Info size={18} />
        <h4>Basic Information</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><Hash size={14} /> Tender ID<span className="required">*</span></label>
          <input type="text" name="tender_id" placeholder="e.g. TNDR/2025/045" onChange={handleInputChange} value={formData.tender_id} className={errors.tender_id ? "error" : inputState.tender_id ? "success" : ""} />
          {errors.tender_id && <span className="error-message">{errors.tender_id}</span>}
        </div>

        <div className="form-field">
          <label><Hash size={14} /> Project Code<span className="required">*</span></label>
          <input type="text" name="site_prcode" placeholder="e.g. PRJ-RD-NH44-AP-01" onChange={handleInputChange} value={formData.site_prcode} className={`text-uppercase ${errors.site_prcode ? "error" : inputState.site_prcode ? "success" : ""}`} />
          {errors.site_prcode && <span className="error-message">{errors.site_prcode}</span>}
        </div>

        <div className="form-field">
          <label><FileText size={14} /> Short Name<span className="required">*</span></label>
          <input type="text" name="project_short_name" placeholder="e.g. NH44 Bypass" onChange={handleInputChange} value={formData.project_short_name} className={errors.project_short_name ? "error" : inputState.project_short_name ? "success" : ""} />
          {errors.project_short_name && <span className="error-message">{errors.project_short_name}</span>}
        </div>

        <div className="form-field">
          <label><MapPin size={14} /> Location (State)<span className="required">*</span></label>
          <Select name="location" options={locationOptions} value={formData.location ? { value: formData.location, label: formData.location } : null} onChange={(selected) => handleInputChange({ target: { name: "location", value: selected?.value || "" } })} isSearchable placeholder="Select Location" styles={CSSForSelectModern} />
          {errors.location && <span className="error-message">{errors.location}</span>}
        </div>

        <div className="form-field full-width">
          <label><FileText size={14} /> Project Name<span className="required">*</span></label>
          <textarea name="project_name" placeholder="e.g. Construction of NH44 Bypass" onChange={handleInputChange} value={formData.project_name} rows={3} className={errors.project_name ? "error" : inputState.project_name ? "success" : ""} />
          {errors.project_name && <div className="error-message">{errors.project_name}</div>}
        </div>

        <div className="form-field full-width">
          <label><FileText size={14} /> Project Key Points</label>
          <textarea name="project_key_point" placeholder="e.g. 6-lane highway, elevated corridor" onChange={handleInputChange} value={formData.project_key_point} rows={2} />
        </div>

        <div className="form-field">
          <label><Building2 size={14} /> Site Sub Company</label>
          <select name="sub_company" value={formData.sub_company} onChange={handleInputChange} className={errors.sub_company ? "error" : inputState.sub_company ? "success" : ""}>
            <option value="">Select a Site SubCompany</option>
            {subcompany === "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" ? (
              siteSubCompanyList?.sort((a, b) => a.title.localeCompare(b.title)).filter(i => i.id === "6d96e791-c499-4524-ba5a-2e8d9f99ad7c").map((i, index) => (
                <option key={index} value={i.id}>{i.title}</option>
              ))
            ) : (
              siteSubCompanyList?.sort((a, b) => a.title.localeCompare(b.title)).filter(i => i.id !== "6d96e791-c499-4524-ba5a-2e8d9f99ad7c").map((i, index) => (
                <option key={index} value={i.id}>{i.title}</option>
              ))
            )}
          </select>
        </div>

        <div className="form-field">
          <label><Briefcase size={14} /> Work Type<span className="required">*</span></label>
          <Select options={workTypeOptions} isSearchable placeholder="Select Work Type" value={workTypeOptions.find(opt => opt.value === formData.work_type)} onChange={(selected) => { setFormData({ ...formData, work_type: selected?.value || "" }); setInputState({ ...inputState, work_type: selected ? "green" : "" }); }} styles={CSSForSelectModern} />
          {errors.work_type && <span className="error-message">{errors.work_type}</span>}
        </div>

        <div className="form-field">
          <label><TrendingUp size={14} /> Project Length (KM)<span className="required">*</span></label>
          <input type="number" step="0.01" name="project_length" placeholder="e.g. 18.5" onChange={handleInputChange} value={formData.project_length} className={errors.project_length ? "error" : inputState.project_length ? "success" : ""} />
          {errors.project_length && <span className="error-message">{errors.project_length}</span>}
        </div>

        <div className="form-field">
          <label><CreditCard size={14} /> GST Number<span className="required">*</span></label>
          <input type="text" name="gst_no" placeholder="Enter GST No." onChange={handleInputChange} value={formData.gst_no} className={errors.gst_no ? "error" : inputState.gst_no ? "success" : ""} />
          {errors.gst_no && <span className="error-message">{errors.gst_no}</span>}
        </div>

        <div className="form-field">
          <label><CreditCard size={14} /> PAN Number<span className="required">*</span></label>
          <input type="text" name="pan_no" placeholder="Enter PAN No." onChange={handleInputChange} value={formData.pan_no} className={errors.pan_no ? "error" : inputState.pan_no ? "success" : ""} />
          {errors.pan_no && <span className="error-message">{errors.pan_no}</span>}
        </div>
        <div className="form-field">
          <label><Briefcase size={14} /> Escalation Applicable On:<span className="required">*</span></label>
          <Select options={escalationApplicableOnOptions} isSearchable placeholder="Select Escalation Applicable On:" value={escalationApplicableOnOptions.find(opt => opt.value === formData.escalation_apllicable_on)} onChange={(selected) => { setFormData({ ...formData, escalation_apllicable_on: selected?.value || "" }); setInputState({ ...inputState, escalation_apllicable_on: selected ? "green" : "" }); }} styles={CSSForSelectModern} />
          {errors.escalation_apllicable_on && <span className="error-message">{errors.escalation_apllicable_on}</span>}
        </div>
      </div>


      <div className="section-navigation-buttons nav-buttons-wrapper">
        {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
          <div className="tab-error-message">
            <AlertCircle size={14} />
            <span>{getCurrentTabErrorMessage()}</span>
          </div>
        )}
        {tabValidationAttempted[activeSection] && !hasCurrentTabErrors() && (
          <div></div>
        )}
        <button type="button" className="btn-next" onClick={goToNextTab}>
          Next: Timeline <ChevronRight size={16} />
        </button>
      </div>

    </div>
  );

  const renderTimeline = () => (
    <div className="form-section">
      <div className="section-title">
        <Calendar size={18} />
        <h4>Project Timeline</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><Calendar size={14} /> Bid Due Date</label>
          <input type="date" name="bid_due_date" onChange={handleInputChange} value={formData.bid_due_date} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> LOA Date</label>
          <input type="date" name="loa_award_date" min={formData.bid_due_date} onChange={handleInputChange} value={formData.loa_award_date} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Agreement Date</label>
          <input type="date" name="agreement_date" min={formData.bid_due_date} onChange={handleInputChange} value={formData.agreement_date} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Commencement Date</label>
          <input type="date" name="commencement_date" min={formData.agreement_date} onChange={handleInputChange} value={formData.commencement_date} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Mobilization Date</label>
          <input type="date" name="mobilization" min={formData.agreement_date} onChange={handleInputChange} value={formData.mobilization} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> BG Submission Date</label>
          <input type="date" name="bgid_submission_date" onChange={handleInputChange} value={formData.bgid_submission_date} />
        </div>

        <div className="form-field">
          <label><Clock size={14} /> Construction Duration (Months)</label>
          <input type="number" name="construction_duration" placeholder="e.g. 18" onChange={handleInputChange} value={formData.construction_duration} />
        </div>

        <div className="form-field">
          <label><Clock size={14} /> O&M Duration (Months)</label>
          <input type="number" name="om_duration" placeholder="e.g. 60" onChange={handleInputChange} value={formData.om_duration} />
        </div>

        <div className="form-field">
          <label><Clock size={14} /> Total Project Duration (Months)</label>
          <input type="text" value={formData.project_duration} disabled className="readonly-field" />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Schedule Construction Completion</label>
          <input type="date" value={formData.schedule_construction_completion_date} disabled className="readonly-field" />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Schedule Completion Date</label>
          <input type="date" value={formData.schedule_completion_date} disabled className="readonly-field" />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Actual Construction Completion</label>
          <input type="date" name="actual_construction_completion_date" onChange={handleInputChange} value={formData.actual_construction_completion_date} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Actual Completion Date</label>
          <input type="date" name="actual_completion_date" onChange={handleInputChange} value={formData.actual_completion_date} />
        </div>

        <div className="form-field full-width">
          <label><FileText size={14} /> Remark</label>
          <input type="text" name="remark" placeholder="Add any remarks..." onChange={handleInputChange} value={formData.remark} />
        </div>
      </div>

      <div className="section-navigation-buttons dual-buttons">

        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous
          </button>
          {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
            <div className="tab-error-message">
              <AlertCircle size={14} />
              <span>{getCurrentTabErrorMessage()}</span>
            </div>
          )}
          <button type="button" className="btn-next" onClick={goToNextTab}>
            Next <ChevronRight size={16} />
          </button>
        </div>
      </div>



    </div>
  );

  const renderFinancial = () => (
    <div className="form-section">
      <div className="section-title">
        <IndianRupee size={18} />
        <h4>Financial Information</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><IndianRupee size={14} /> Consultancy Fees</label>
          <input type="number" name="consultancy_fees" placeholder="Enter full amount" onChange={handleInputChange} value={formData.consultancy_fees} />
        </div>

        <div className="form-field">
          <label><IndianRupee size={14} /> Construction Cost</label>
          <input type="number" name="construction_cost" placeholder="Enter construction cost" onChange={handleInputChange} value={formData.construction_cost} />
        </div>

        <div className="form-field">
          <label><IndianRupee size={14} /> Imprest Amount</label>
          <input type="number" name="imprest_amount" placeholder="Enter imprest amount" onChange={handleInputChange} value={formData.imprest_amount} />
        </div>

        <div className="form-field">
          <label><Briefcase size={14} /> Contract Mode</label>
          <Select options={contractModeOptions} isSearchable placeholder="Select Contract Mode" value={contractModeOptions.find(opt => opt.value === formData.contract_mode)} onChange={handleContractModeChange} styles={CSSForSelectModern} />
        </div>
      </div>
      <div className="section-navigation-buttons dual-buttons">

        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous
          </button>
          {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
            <div className="tab-error-message">
              <AlertCircle size={14} />
              <span>{getCurrentTabErrorMessage()}</span>
            </div>
          )}
          <button type="button" className="btn-next" onClick={goToNextTab}>
            Next <ChevronRight size={16} />
          </button>
        </div>
      </div>

    </div>
  );

  const renderPartners = () => (
    <div className="form-section">
      <div className="section-title">
        <Users size={18} />
        <h4>Partners & Stakeholders</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><Building2 size={14} /> Lead Partner<span className="required">*</span></label>
          <Select options={consultantOptions} isSearchable isClearable placeholder="Select Lead Partner" value={consultantOptions.find(opt => opt.value === formData.lead)} onChange={(selected) => { setFormData({ ...formData, lead: selected?.value || "" }); setInputState({ ...inputState, lead: selected ? "green" : "" }); }} styles={CSSForSelectModern} />
          {errors.lead && <span className="error-message">{errors.lead}</span>}
        </div>
        <div className="form-field">
          <label><TrendingUp size={14} /> Lead Partner Share (%)</label>
          <input type="number" name="our_share" placeholder="Enter percentage" onChange={(e) => { const val = e.target.value; if (val === "" || (/^\d+\.?\d{0,2}$/.test(val) && val <= 100)) handleInputChange(e); }} value={formData.our_share} />
        </div>

        <div className="form-field">
          <label><Users size={14} /> JV Partner</label>
          <Select options={consultantOptions} isSearchable isClearable placeholder="Select JV Partner" value={consultantOptions.find(opt => opt.value === formData.jv)} onChange={(selected) => setFormData({ ...formData, jv: selected?.value || "" })} styles={CSSForSelectModern} />
        </div>
        <div className="form-field">
          <label><TrendingUp size={14} /> JV Share (%)</label>
          <input type="number" name="jv_share" placeholder="Enter percentage" onChange={(e) => { const val = e.target.value; if (val === "" || (/^\d+\.?\d{0,2}$/.test(val) && val <= 100)) handleInputChange(e); }} value={formData.jv_share} />
        </div>


        <div className="form-field">
          <label><Users size={14} /> Association Partner</label>
          <Select options={consultantOptions} isSearchable isClearable placeholder="Select Association Partner" value={consultantOptions.find(opt => opt.value === formData.association)} onChange={(selected) => setFormData({ ...formData, association: selected?.value || "" })} styles={CSSForSelectModern} />
        </div>
        <div className="form-field">
          <label><TrendingUp size={14} /> Associate Partner Share (%)</label>
          <input type="number" name="associate_partner_share" placeholder="Enter percentage" onChange={(e) => { const val = e.target.value; if (val === "" || (/^\d+\.?\d{0,2}$/.test(val) && val <= 100)) handleInputChange(e); }} value={formData.associate_partner_share} />
        </div>

        <div className="form-field">
          <label><Building2 size={14} /> Client</label>
          <Select options={extendedConsultantOptions} isSearchable isClearable placeholder="Select Client" value={extendedConsultantOptions.find(opt => opt.value === formData.client_name)} onChange={(selected) => setFormData({ ...formData, client_name: selected?.value || "" })} styles={CSSForSelectModern} />
        </div>






        <div className="form-field">
          <label><UserCheck size={14} /> Authorized AE/IE</label>
          <input type="text" name="athorized_IE_AE" placeholder="Authorized AE/IE" onChange={handleInputChange} value={formData.athorized_IE_AE} />
        </div>

        <div className="form-field">
          <label><UserCheck size={14} /> Supervision on behalf of AE/IE</label>
          <Select options={authorityEngineerOptions} isSearchable isClearable placeholder="Select Authority Engineer" value={authorityEngineerOptions.find(opt => opt.value === formData.authority_engineer)} onChange={handleAuthorityEngineerChange} styles={CSSForSelectModern} />
        </div>

        <div className="form-field">
          <label><UserCheck size={14} /> Concern Person</label>
          <input type="text" name="concern_person" placeholder="Concern Person" onChange={handleInputChange} value={formData.concern_person} />
        </div>

        <div className="form-field full-width">
          <label><Users size={14} /> Coordinators</label>
          {buffer ? (
            <div className="loader-placeholder">Loading...</div>
          ) : (
            <Select options={operatorOptions} isMulti onChange={handleChangeAssignedTo} value={formData.com_operators?.map(code => ({ value: code, label: operatorOptions.find(opt => opt.value === code)?.label || code }))} styles={CSSForSelectModern} />
          )}
        </div>
      </div>

      <div className="section-navigation-buttons dual-buttons">

        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous
          </button>
          {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
            <div className="tab-error-message">
              <AlertCircle size={14} />
              <span>{getCurrentTabErrorMessage()}</span>
            </div>
          )}
          <button type="button" className="btn-next" onClick={goToNextTab}>
            Next <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );

  const renderAddresses = () => (
    <div className="form-section">
      <div className="section-title">
        <MapPin size={18} />
        <h4>Addresses</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><MapPin size={14} /> Regional Office Name</label>
          <input type="text" name="ro" placeholder="Regional Office Name" onChange={handleInputChange} value={formData.ro} />
        </div>

        <div className="form-field full-width">
          <label><MapPin size={14} /> Regional Office Address</label>
          <textarea name="ro_address" placeholder="Regional Office Address" onChange={handleInputChange} value={formData.ro_address} rows={2} />
        </div>

        <div className="form-field full-width">
          <label><MapPin size={14} /> PIU Address</label>
          <textarea name="piu_address" placeholder="Project Implementation Unit Address" onChange={handleInputChange} value={formData.piu_address} rows={2} />
        </div>

        <div className="form-field full-width">
          <label><MapPin size={14} /> Site Office Address</label>
          <textarea name="site_office_address" placeholder="Site Office Address" onChange={handleInputChange} value={formData.site_office_address} rows={2} />
        </div>

        <div className="form-field full-width">
          <label><MapPin size={14} /> Contractor Address</label>
          <textarea name="contractor_address" placeholder="Contractor Address" onChange={handleInputChange} value={formData.contractor_address} rows={2} />
        </div>

        <div className="form-field full-width">
          <label><MapPin size={14} /> Client Address</label>
          <textarea name="client_address" placeholder="Client Address" onChange={handleInputChange} value={formData.client_address} rows={2} />
        </div>
      </div>

      {/* Submit Buttons - Only shown on the last tab */}
      <div className="form-actions">
        <button type="button" className="btn-prev" onClick={goToPreviousTab}>
          <ChevronRight size={16} className="rotate-left" /> Previous: Partners
        </button>
        <div className="submit-buttons">
          <button type="button" className="btn-secondaryy" onClick={handleClose}>
            Cancel
          </button>
          <button type="submit" className=" btn-primaryy" style={{ width: "8vw" }} disabled={loading}>
            {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
            <span>{loading ? 'Creating...' : 'Create Project'}</span>
          </button>
        </div>
      </div>
    </div>
  );

  const renderCurrentSection = () => {
    switch (activeSection) {
      case 'basic': return renderBasicInfo();
      case 'timeline': return renderTimeline();
      case 'financial': return renderFinancial();
      case 'partners': return renderPartners();
      case 'address': return renderAddresses();
      default: return renderBasicInfo();
    }
  };

  return (
    <>
      <AddModalButton onClick={handleShow} title="Add Project" />
      <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
        <Modal.Header className="modern-modal-header">
          <div className="header-content">
            <div style={{ color: "white" }}>
              <Building2 size={24} />
            </div>
            <div>
              <Modal.Title>Add Project Details</Modal.Title>
              <p className="header-subtitle" style={{ color: "white" }}>Fill in the details to create a new project</p>
            </div>
          </div>
          <button className="close-btn" onClick={handleClose}>
            <X size={20} />
          </button>
        </Modal.Header>

        <Modal.Body className="modern-modal-body">
          {/* Section Navigation Tabs */}
          <div className="section-navigation">
            {sections.map((section) => {
              const Icon = section.icon;
              // Check if this tab has missing required fields
              const hasMissingRequiredFields = () => {
                const requiredFields = tabRequiredFields[section.id] || [];
                return requiredFields.some(field => !formData[field]);
              };

              return (
                <button
                  key={section.id}
                  className={`section-nav-btn ${activeSection === section.id ? 'active' : ''} ${hasMissingRequiredFields() && section.id !== activeSection ? 'has-warning' : ''}`}
                  onClick={() => {
                    // Validate current tab before switching to another tab
                    if (activeSection !== section.id) {
                      if (validateCurrentTab()) {
                        setActiveSection(section.id);
                        setErrors({});
                      } else {
                        // Show error message and stay on current tab
                        const formContainer = document.querySelector('.modern-modal-body');
                        if (formContainer) {
                          formContainer.scrollTop = 0;
                        }
                      }
                    }
                  }}
                >
                  <Icon size={16} />
                  <span>{section.label}</span>
                  {hasMissingRequiredFields() && section.id !== activeSection && (
                    <div className="warning-dot" title="Missing required fields" />
                  )}
                  {activeSection === section.id && <ChevronRight size={14} className="nav-arrow" />}
                </button>
              );
            })}
          </div>

          {/* Form Content */}
          <form onSubmit={handleFormSubmit} className="project-form">
            {/* Show current tab validation error */}


            {buffer ? (
              <div className="loader-container">
                <Loader size={40} className="spinning" />
                <p>Loading data...</p>
              </div>
            ) : (
              renderCurrentSection()
            )}


          </form>
        </Modal.Body>
      </Modal>

      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};






const UpdateProjectAllDetails = ({ i, getProjects, siteSubCompanyList }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [buffer, setBuffering] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [clientList, setClientList] = useState([]);
  const [empList, setEmpList] = useState([]);
  const [operatorempList, setoperatorEmpList] = useState([]);
  const uniqueStreamTypes = new Set();

  const [formData, setFormData] = useState({
    site_prcode: "",
    project_name: "",
    project_short_name: "",
    ro: "",
    ro_address: "",
    piu_address: "",
    project_key_point: "",
    escalation_apllicable_on: "",
    imprest_amount: "",
    pan_no: "",
    gst_no: "",
    client_address: "",
    site_office_address: "",
    contractor_address: "",
    location: "",
    work_type: "",
    lead: "",
    tender_id: "",
    project_length: "",
    consultancy_fees: "",
    construction_cost: "",
    contract_mode: "",
    jv: "",
    our_share: "",
    jv_share: "",
    association: "",
    associate_partner_share: "",
    client_name: "",
    authority_engineer: "",
    athorized_IE_AE: "",
    concern_person: "",
    com_operators: [],
    bid_due_date: null,
    loa_award_date: null,
    agreement_date: null,
    commencement_date: null,
    mobilization: null,
    bgid_submission_date: null,
    construction_duration: "",
    om_duration: "",
    project_duration: "",
    schedule_construction_completion_date: null,
    schedule_completion_date: null,
    actual_construction_completion_date: null,
    actual_completion_date: null,
    remark: "",
    status: ""
  });

  const getAllEmp_code = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/employeebyfilterss/null/null/null/null/null/AuthorityEngineer/null/`
      );
      const ress = await axios.get(
        `${BASE_URL}/siteproject/employeebyfilterss/null/null/null/null/null/DataEntryOperator/null/`
      );

      const sortedList = customSortByKey(res.data, "emp_code");
      const sortedListt = customSortByKey(ress.data, "emp_code");

      setEmpList(sortedList);
      setoperatorEmpList(sortedListt);

      const cli = await axios.get(`${BASE_URL}/siteproject/project-clients/`);
      setClientList(cli.data);
    } catch (err) {
      console.error(err);
    } finally {
      setBuffering(false);
    }
  };

  const handleShow = () => {
    getAllEmp_code();
    setFormData(i);
    setShow(true);
    clientList.forEach(entry => {
      uniqueStreamTypes.add(entry.client_name);
    });
  };

  const handleClose = () => {
    getProjects();
    setErrors({});
    setInputState({});
    setIsSubmitted(false);
    setShow(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value?.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });

    if (errors[name]) {
      setErrors(prev => {
        const updated = { ...prev };
        delete updated[name];
        return updated;
      });
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "site_prcode",
      "project_name",
      "project_short_name",
      "pan_no",
      "gst_no",
      "escalation_apllicable_on",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        const labels = {
          site_prcode: "Project Code",
          project_name: "Project Name",
          project_short_name: "Short Name",
          pan_no: "PAN Number",
          gst_no: "GST Number",
          escalation_apllicable_on: "Escalation Applicable On"
        };
        newErrors[field] = `${labels[field] || field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleProjectUpdate = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Updating project...");

      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/project/${i.id}/`,
          formData
        );

        if (res.status === 200 || res.status === 201) {
          toast.success("Project details updated successfully!");
          setShow(false);
          await getProjects();
        } else {
          toast.error(`Error: ${res.statusText}`);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    } else {
      const formContainer = document.querySelector('.modern-modal-body');
      if (formContainer) {
        formContainer.scrollTop = 0;
      }
    }
  };

  const consultantOptions = [
    { value: "Chaitanya Projects Concsultancy Pvt. Ltd.", label: "Chaitanya Projects Consultancy Pvt. Ltd." },
    { value: "G-Eng Advisory Services Pvt Ltd", label: "G-Eng Advisory Services Pvt Ltd" },
    { value: "Sapatgon Asia Private Limited", label: "Sapatgon Asia Private Limited" },
  ];

  const extendedConsultantOptions = [
    { label: "PWD", value: "PWD" },
    { label: "BRO", value: "BRO" },
    { label: "NHIDCL", value: "NHIDCL" },
    { label: "MoRTH", value: "MoRTH" },
    { label: "NHAI", value: "NHAI" },
    { label: "Other", value: "other" },
  ];

  const contractModeOptions = [
    { value: "epc", label: "EPC" },
    { value: "ham", label: "HAM" },
    { value: "bot", label: "BOT" },
  ];
  const escalationApplicableOnOptions = [
    { value: "Bid Due Date", label: "Bid Due Date" },
    { value: "Commencement Date", label: "Commencement Date" },
    { value: "Contract Agreement Date", label: "Contract Agreement Date" },
  ];

  return (
    <>
      <button title="Update Project Details" className="upload-svg" onClick={handleShow}>
        <Edit size={18} />
        <span>Update Details</span>
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
        <Modal.Header className="modern-modal-header">
          <div className="header-content">
            <div style={{ color: "white" }}>
              <Building2 size={24} />
            </div>
            <div>
              <Modal.Title>Update Project Details</Modal.Title>
              <p className="header-subtitle" style={{ color: "white" }}>Update the project information</p>
            </div>
          </div>
          <button className="close-btn" onClick={handleClose}>
            <X size={20} />
          </button>
        </Modal.Header>

        <Modal.Body className="modern-modal-body">
          <form onSubmit={handleProjectUpdate} className="project-form">
            {buffer ? (
              <div className="loader-container">
                <Loader size={40} className="spinning" />
                <p>Loading data...</p>
              </div>
            ) : (
              <div className="form-container">
                {/* Basic Information Section */}
                <div className="form-section">
                  <div className="section-title">
                    <Info size={18} />
                    <h4>Basic Information</h4>
                  </div>
                  <div className="form-grid">
                    <div className="form-field">
                      <label><Hash size={14} /> Project Code<span className="required">*</span></label>
                      <input type="text" name="site_prcode" placeholder="Project Code" value={formData.site_prcode} onChange={handleInputChange} className={`text-uppercase ${errors.site_prcode ? "error" : inputState.site_prcode ? "success" : ""}`} />
                      {errors.site_prcode && <span className="error-message">{errors.site_prcode}</span>}
                    </div>

                    <div className="form-field">
                      <label><FileText size={14} /> Short Name<span className="required">*</span></label>
                      <input type="text" name="project_short_name" placeholder="Short Name" value={formData.project_short_name} onChange={handleInputChange} className={errors.project_short_name ? "error" : inputState.project_short_name ? "success" : ""} />
                      {errors.project_short_name && <span className="error-message">{errors.project_short_name}</span>}
                    </div>

                    <div className="form-field full-width">
                      <label><FileText size={14} /> Project Name<span className="required">*</span></label>
                      <textarea name="project_name" placeholder="Project Name" value={formData.project_name} onChange={handleInputChange} rows={3} className={errors.project_name ? "error" : inputState.project_name ? "success" : ""} />
                      {errors.project_name && <div className="error-message">{errors.project_name}</div>}
                    </div>

                    <div className="form-field full-width">
                      <label><FileText size={14} /> Project Key Points</label>
                      <textarea name="project_key_point" placeholder="Project Key Points" value={formData.project_key_point} onChange={handleInputChange} rows={2} />
                    </div>

                    <div style={{ display: 'flex', justifyContent: "space-between" }}>
                      <div className="form-field">
                        <label><CreditCard size={14} /> GST Number<span className="required">*</span></label>
                        <input type="text" name="gst_no" style={{ width: "10vw" }} placeholder="GST Number" value={formData.gst_no} onChange={handleInputChange} className={errors.gst_no ? "error" : inputState.gst_no ? "success" : ""} />
                        {errors.gst_no && <span className="error-message">{errors.gst_no}</span>}
                      </div>

                      <div className="form-field">
                        <label><CreditCard size={14} /> PAN Number<span className="required">*</span></label>
                        <input type="text" name="pan_no" style={{ width: "10vw" }} placeholder="PAN Number" value={formData.pan_no} onChange={handleInputChange} className={errors.pan_no ? "error" : inputState.pan_no ? "success" : ""} />
                        {errors.pan_no && <span className="error-message">{errors.pan_no}</span>}
                      </div>
                    </div>

                    <div className="form-field">
                      <label><Briefcase size={14} /> Escalation Applicable On:<span className="required">*</span></label>
                      <Select options={escalationApplicableOnOptions} isSearchable placeholder="Select Escalation Applicable On:" value={escalationApplicableOnOptions.find(opt => opt.value === formData.escalation_apllicable_on)} onChange={(selected) => { setFormData({ ...formData, escalation_apllicable_on: selected?.value || "" }); setInputState({ ...inputState, escalation_apllicable_on: selected ? "green" : "" }); }} styles={CSSForSelectModern} />
                      {errors.escalation_apllicable_on && <span className="error-message">{errors.escalation_apllicable_on}</span>}
                    </div>
                  </div>
                </div>

                {/* Address Information Section */}
                <div className="form-section">
                  <div className="section-title">
                    <MapPin size={18} />
                    <h4>Address Information</h4>
                  </div>
                  <div className="form-grid">
                    <div className="form-field">
                      <label><MapPin size={14} /> Regional Office Name</label>
                      <input type="text" name="ro" placeholder="Regional Office Name" value={formData.ro} onChange={handleInputChange} />
                    </div>

                    <div className="form-field full-width">
                      <label><MapPin size={14} /> Regional Office Address</label>
                      <textarea name="ro_address" placeholder="Regional Office Address" value={formData.ro_address} onChange={handleInputChange} rows={2} />
                    </div>

                    <div className="form-field full-width">
                      <label><MapPin size={14} /> PIU Address</label>
                      <textarea name="piu_address" placeholder="PIU Address" value={formData.piu_address} onChange={handleInputChange} rows={2} />
                    </div>

                    <div className="form-field full-width">
                      <label><MapPin size={14} /> Site Office Address</label>
                      <textarea name="site_office_address" placeholder="Site Office Address" value={formData.site_office_address} onChange={handleInputChange} rows={2} />
                    </div>

                    <div className="form-field full-width">
                      <label><MapPin size={14} /> Client Address</label>
                      <textarea name="client_address" placeholder="Client Address" value={formData.client_address} onChange={handleInputChange} rows={2} />
                    </div>
                  </div>
                </div>

                {/* Error Summary */}
                {isSubmitted && Object.keys(errors).length > 0 && (
                  <div className="error-summary">
                    <AlertCircle size={16} />
                    <span>
                      {Object.keys(errors).length > 3
                        ? "Please fill all mandatory fields!"
                        : `${Object.keys(errors).map(f => {
                          const labels = {
                            site_prcode: "Project Code",
                            project_name: "Project Name",
                            project_short_name: "Short Name",
                            pan_no: "PAN Number",
                            gst_no: "GST Number"
                          };
                          return labels[f] || f.charAt(0).toUpperCase() + f.slice(1);
                        }).join(', ')} ${Object.keys(errors).length === 1 ? 'is' : 'are'} required!`}
                    </span>
                  </div>
                )}

                {/* Form Actions */}
                <div className="form-actions">
                  <div className="submit-buttons" style={{ justifyContent: 'flex-end', width: '100%', gap: '1rem' }}>
                    <button type="button" className="btn-secondaryy" onClick={handleClose}>
                      Cancel
                    </button>
                    <button type="submit" className="btn-primaryy" disabled={loading}>
                      {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                      <span>{loading ? 'Updating...' : 'Update Project'}</span>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </form>
        </Modal.Body>
      </Modal>

      <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};


const UpdateConsultantDetails = ({ i, getProjects, siteSubCompanyList }) => {
  const [show, setShow] = useState(false);
  const uniqueStreamTypes = new Set();
  const [accountList, setAccountList] = useState([]);
  const [invoiceList, setInvoiceList] = useState([]);
  const getAccoundetails = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/consultancyaccountbysubcompany/${formData.sub_company}/`);



      // setProjectList(response.data)
      setAccountList(response.data)

    } catch (error) {
    }
  }

  const getInvoice = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/consultant-invoiceBy-projectfilter/${formData.project}/null/null/`);
      setInvoiceList(response.data);

    } catch (error) {
    }
  }
  const handleShow = () => {
    getAllEmp_code();
    setFormData(i);
    setShow(true);

    // getAccoundetails();
    clientList.forEach(entry => {
      uniqueStreamTypes.add(entry.client_name);
    });
  };


  const [clientList, setClientList] = useState([]);

  const [empList, setEmpList] = useState([]);

  const handleClose = () => {
    getProjects();
    setErrors({});
    setShow(false);
  };

  const [buffer, setBuffering] = useState(true); //buffering logic
  // const [buffer1, setBuffering1] = useState(true); //buffering logic

  const [formData, setFormData] = useState({
    consultancy_account_details: "",
    location: "",
    // sub_company: sessionStorage.getItem('company_id'),
    sub_company: "",
    work_type: "",
    bid_due_date: null,
    loa_award_date: null,

    actual_construction_completion_date: null,
    schedule_construction_completion_date: "",
    agreement_date: null,
    commencement_date: null,

    concern_person: "",
    athorized_IE_AE: "",
    authority_engineer: "",
    project_length: "",
    tender_id: "",
    actual_completion_date: null,
    mobilization: null,
    construction_cost: 0,
    remark: "",
    consultancy_fees: "",
    contract_mode: "",
    lead: "",
    jv: "",
    our_share: "",
    jv_share: "",
    associate_partner_share: "",
    association: "",
    work_performed_by: "",
    client_name: "",
    contractor_address: "",
    project_duration: "",
    our_role: "",
    om_duration: "",
    construction_duration: "",
    site_office_address: "",
    client_address: "",

  });
  useEffect(() => {
    getAccoundetails();
  }, [formData.sub_company])
  const [operatorempList, setoperatorEmpList] = useState([]);


  const getAllEmp_code = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        // `${BASE_URL}/siteproject/employeefilterbysubcompany/${formData.sub_company}/`
        `${BASE_URL}/siteproject/employeebyfilterss/null/null/null/null/null/AuthorityEngineer/null/`
      );
      const ress = await axios.get(
        // `${BASE_URL}/siteproject/employeefilterbysubcompany/${formData.sub_company}/`
        `${BASE_URL}/siteproject/employeebyfilterss/null/null/null/null/null/DataEntryOperator/null/`
      );

      const sortedList = customSortByKey(res.data, "emp_code");
      const sortedListt = customSortByKey(ress.data, "emp_code");

      setEmpList(sortedList);
      setoperatorEmpList(sortedListt);

      const cli = await axios.get(`${BASE_URL}/siteproject/project-clients/`);
      setClientList(cli.data);


    } catch (err) {
      // alert(err.message);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    updateStatusAndRemarks(); // Update status and remarks together
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formData?.actual_completion_date,
    formData?.actual_construction_completion_date,
    formData?.schedule_completion_date,
    formData?.schedule_construction_completion_date,
    formData?.commencement_date,
    formData?.agreement_date,
    formData?.bgid_submission_date,
    formData?.loa_award_date,
    formData?.bid_due_date,
  ]); // Add only the necessary dependencies

  // !  ************** Validation start **************  ! //

  const updateStatusAndRemarks = () => {
    let newStatus = "";
    let newRemark = "";

    if (formData.actual_completion_date) {
      newStatus = "Completed";
      newRemark = "The project is successfully completed.";
    } else if (formData.actual_construction_completion_date) {
      newStatus = "Yet to Complete including O&M";
      newRemark = "Construction phase completed; O&M is pending.";
    } else if (formData.schedule_completion_date) {
      newStatus = "In Progress";
      newRemark = "Project is currently in progress.";
    } else if (formData.schedule_construction_completion_date) {
      newStatus = "In Progress including O&M";
      newRemark = "Construction is in progress along with O&M.";
    } else if (formData.commencement_date) {
      newStatus = "Yet to Commence";
      newRemark = "Project commencement is yet to start.";
    } else if (formData.agreement_date) {
      newStatus = "Yet to Sign Agreement";
      newRemark = "Agreement signing is pending.";
    } else if (formData.bgid_submission_date) {
      newStatus = "Yet to Submit BG";
      newRemark = "Bank Guarantee submission is pending.";
    } else if (formData.loa_award_date) {
      newStatus = "Yet to Award";
      newRemark = "Letter of Award is pending.";
    } else if (formData.bid_due_date) {
      newStatus = "Yet to Bid";
      newRemark = "Bid submission is pending.";
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      status: newStatus,
    }));
  };

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};

    const requiredFields = [
      "sub_company",
      "work_type",
      "lead",
      "tender_id",
      "location",
      "project_length",
      "client_name",
      "lead",
      "contract_mode",
      "bid_due_date",

    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);
    toast.warning(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  console.log(errors)


  const [filteredList, setFilteredList] = useState([]);


  // const handleInputChange = (e) => {
  //   const { name, value } = e.target;

  //   setInputState({
  //     ...inputState,
  //     [name]: value.trim() ? "green" : "",
  //   });

  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });

  //   if (name === "client_name") {
  //     const filtered = clientList.filter((item) =>
  //       item?.client_name?.toLowerCase().includes(value.toLowerCase())
  //     );
  //     const uniqueFiltered = Array.from(new Map(filtered.map(item => [item.client_name, item])).values());
  //     setFilteredList(uniqueFiltered);
  //   }

  //   setErrors((prevErrors) => {
  //     const newErrors = { ...prevErrors };
  //     if (value.trim() && newErrors[name]) {
  //       delete newErrors[name];
  //     }
  //     return newErrors;
  //   });


  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target || e;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    const updatedFormData = {
      ...formData,
      [name]: value,
    };

    const omDuration = parseInt(name === "om_duration" ? value : formData.om_duration) || 0;
    const constructionDuration = parseInt(name === "construction_duration" ? value : formData.construction_duration) || 0;

    if (name === "om_duration" || name === "construction_duration") {
      updatedFormData.project_duration = omDuration + constructionDuration;
    }

    setFormData(updatedFormData);

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (value) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });

    // Client name filtering logic
    if (name === "client_name") {
      const filtered = clientList.filter((item) =>
        item?.client_name?.toLowerCase().includes(value.toLowerCase())
      );
      const uniqueFiltered = Array.from(
        new Map(filtered.map((item) => [item.client_name, item])).values()
      );
      setFilteredList(uniqueFiltered);
    }
  };



  // ?  ************** Validation End **************  ! //

  const [loading, setLoading] = useState(false); //loading logic
  const handleProjectUpdate = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic

      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/project/${i.id}/`,
          formData
        );

        if (res.status === 200) {
          setShow(false);
          await getProjects();
          toast.success("Consultant Details are Updated Successfully")
          toast.dismiss(loadingToastId);

        } else {
          alert(res);
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  const sortedStatesAndUTs = [...statesAndUTs].sort();



  const handleChangeAssignedTo = (selected) => {
    const com_operators = selected?.map((item) => item.value) || [];
    setFormData((prevState) => ({
      ...prevState,
      com_operators,
    }));
  };

  const options = operatorempList?.sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))?.map((e) => ({
    value: e.id,
    label: `${e.emp_code} - ${e.name}`,
  }));

  useEffect(() => {
    const {
      construction_duration,
      om_duration,
      mobilization
    } = formData;

    const projectDuration =
      construction_duration && om_duration
        ? Number(construction_duration) + Number(om_duration)
        : "";

    const addMonthsToDate = (dateString, months) => {
      if (!dateString || !months) return "";
      const date = new Date(dateString);
      date.setMonth(date.getMonth() + Number(months));
      return date.toISOString().split("T")[0];
    };

    const scheduleConstructionCompletionDate = addMonthsToDate(
      mobilization,
      construction_duration
    );

    const projectCompletionDate = addMonthsToDate(
      mobilization,
      projectDuration
    );

    setFormData((prev) => ({
      ...prev,
      project_duration: projectDuration,
      schedule_construction_completion_date: scheduleConstructionCompletionDate,
      schedule_completion_date: projectCompletionDate,
    }));
  }, [
    formData.construction_duration,
    formData.om_duration,
    formData.mobilization,
    formData.project_duration
  ]);


  const authorityEngineerOptions = empList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map(emp => ({
      value: emp.id, // what will be submitted
      label: `${emp.emp_code} - ${emp.name}`, // what is displayed
    }));
  const operatorOptions = operatorempList
    .sort((a, b) => a.emp_code - b.emp_code)
    .map(emp => ({
      value: emp.id, // what will be submitted
      label: `${emp.emp_code} - ${emp.name}`, // what is displayed
    }));

  const handleAuthorityEngineerChange = (selectedOption) => {
    setFormData(prev => ({
      ...prev,
      authority_engineer: selectedOption ? selectedOption.value : "",
    }));

    setInputState(prev => ({
      ...prev,
      authority_engineer: selectedOption ? "green" : "",
    }));
  };
  const workTypeOptions = [
    {
      value: "Construction Consultant - Authority Engineer",
      label: "Construction Consultant - Authority Engineer",
    },
    {
      value: "Construction Consultant - Independent Engineer",
      label: "Construction Consultant - Independent Engineer",
    },
    {
      value: "Project Management Consultancy (PMC)",
      label: "Project Management Consultancy (PMC)",
    },
    {
      value: "Operation & Maintenance Consultant - Authority Engineer",
      label: "Operation & Maintenance Consultant - Authority Engineer",
    },
    {
      value: "Operation & Maintenance Consultant - Independent Engineer",
      label: "Operation & Maintenance Consultant - Independent Engineer",
    },
    {
      value: "Detailed Project Report (DPR)",
      label: "Detailed Project Report (DPR)",
    },
    {
      value: "Safety Consultant (SC)",
      label: "Safety Consultant (SC)",
    },
    {
      value: "Asset Monetization (AM)",
      label: "Asset Monetization (AM)",
    },
  ];


  const consultantOptions = [
    { value: "Chaitanya Projects Concsultancy Pvt. Ltd.", label: "Chaitanya Projects Concsultancy Pvt. Ltd." },
    { value: "G-Eng Advisory Services Pvt Ltd", label: "G-Eng Advisory Services Pvt Ltd" },
    { value: "Sapatgon Asia Private Limited", label: "Sapatgon Asia Private Limited" },
    { value: "AECOM Asia Company Limited", label: "AECOM Asia Company Limited" },
    { value: "Agnitio Infrastructure Projects Pvt. Ltd", label: "Agnitio Infrastructure Projects Pvt. Ltd" },
    { value: "Almondz Global Infra Consultant Limited", label: "Almondz Global Infra Consultant Limited" },
    { value: "Centro de Estudios de Materiales y Control de Obra, SA", label: "Centro de Estudios de Materiales y Control de Obra, SA" },
    { value: "Dhruv Consultancy Services Ltd.", label: "Dhruv Consultancy Services Ltd." },
    { value: "ARKITECHNO Consultancy (India) Pvt. Ltd.", label: "ARKITECHNO Consultancy (India) Pvt. Ltd." },
    { value: "FP India Project Management Consultancy Services Pvt.Ltd", label: "FP India Project Management Consultancy Services Pvt.Ltd" },
    { value: "Global Infra Solutions", label: "Global Infra Solutions" },
    { value: "JC Technocrats Pvt.Ltd", label: "JC Technocrats Pvt.Ltd" },
    { value: "Marc Technocrats Private Limited", label: "Marc Technocrats Private Limited" },
    { value: "RITES Ltd in association", label: "RITES Ltd in association" },
    { value: "Rodic Consultants Private Limited", label: "Rodic Consultants Private Limited" },
    { value: "Segmental Consulting & Infrastructure Advisory Pvt. Ltd", label: "Segmental Consulting & Infrastructure Advisory Pvt. Ltd" },
    { value: "TUMAS Turkish Engineering Consulting and Contracting Inc. Co.", label: "TUMAS Turkish Engineering Consulting and Contracting Inc. Co." },
    { value: "URS Scott Wilson India Pvt. Ltd", label: "URS Scott Wilson India Pvt. Ltd" },
    { value: "Voyants Solution Pvt. Ltd", label: "Voyants Solution Pvt. Ltd" },
    { value: "Infinite Solutions Private Limited", label: "Infinite Solutions Private Limited" },
    { value: "K & J Projects Private Limited", label: "K & J Projects Private Limited" },
    { value: "Open Solutions Infrastructure Consultancy Services Pvt. Ltd.", label: "Open Solutions Infrastructure Consultancy Services Pvt. Ltd." },
    { value: "Sterling Indo Tech Consultants Pvt. Ltd.", label: "Sterling Indo Tech Consultants Pvt. Ltd." },
    { value: "CivilMantra Infracon Pvt. Ltd", label: "CivilMantra Infracon Pvt. Ltd" },
    { value: "TPF Getinsa-Eurostudios, S.L", label: "TPF Getinsa-Eurostudios, S.L" },
    { value: "JS Infrastructure Consultants Pvt. Ltd.", label: "JS Infrastructure Consultants Pvt. Ltd." },
    { value: "DN Consultant", label: "DN Consultant" },
    { value: "India Engg.Consultants India Private Limited", label: "India Engg.Consultants India Private Limited" },
    { value: "Infinite Civil Solutions Pvt. Ltd", label: "Infinite Civil Solutions Pvt. Ltd" },
    { value: "Introsoft Solutions", label: "Introsoft Solutions" },
    { value: "Mahamarg Infra Consultants Private Limited", label: "Mahamarg Infra Consultants Private Limited" },
    { value: "MAV Associates LLP", label: "MAV Associates LLP" },
    { value: "MS Consultants", label: "MS Consultants" },
    { value: "MVK Infrabulid Pvt. Ltd.", label: "MVK Infrabulid Pvt. Ltd." },
    { value: "Nu-Infra Engineering Pvt Ltd.", label: "Nu-Infra Engineering Pvt Ltd." },
    { value: "Samarth Softech Solutions Pvt. Ltd.", label: "Samarth Softech Solutions Pvt. Ltd." },
    { value: "Shree Bhawani Consultancy Service Pvt. Ltd.,", label: "Shree Bhawani Consultancy Service Pvt. Ltd.," },
    { value: "Transtek Engineers & Services Pvt. Ltd.", label: "Transtek Engineers & Services Pvt. Ltd." },
    { value: "CivilMantra ConsAi Limited", label: "CivilMantra ConsAi Limited" },
    { value: "AVOK Engineering Consulting & Contracting Pvt. Ltd.", label: "AVOK Engineering Consulting & Contracting Pvt. Ltd." },
    { value: "Aicons Engineering Pvt. Ltd.", label: "Aicons Engineering Pvt. Ltd." },
    { value: "M/s Pentacon Associates.", label: "M/s Pentacon Associates." },

  ];



  const extendedConsultantOptions = [
    { label: "PWD", value: "PWD", },
    { label: "BRO", value: "BRO", },
    { label: "NHIDCL", value: "NHIDCL", },
    { label: "MoRTH", value: "MoRTH", },
    { label: "NHAI", value: "NHAI", },

    { label: "Other", value: "other", },

  ];


  const locationOptions = sortedStatesAndUTs.map((state) => ({
    value: state,
    label: state,
  }));
  return (
    <>
      <button
        title="Update Consultant Details"
        style={{ margin: 0 }}
        className="upload-svg update-button-size"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          fill="white"
          viewBox="0 0 24 24"
          id="pen-new-square"
        >
          <path
            fill=""
            fill-rule="evenodd"
            d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z"
            clip-rule="evenodd"
          ></path>
          <path
            fill=""
            fill-rule="evenodd"
            d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z"
            clip-rule="evenodd"
          ></path>
        </svg>{" "}
        Update Consultant Details
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Consultant Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-form">
            <br />
            <div className="form-flex-wrap">
              <div title="Tender ID" className="flex-column">
                <label
                  htmlFor="tender_id"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Tender ID <span className="required">
                    {/* (Read-Only) */}*
                  </span>
                </label>
                <input
                  type="text"
                  id="tender_id"
                  name="tender_id"
                  placeholder="Tender ID"
                  onChange={handleInputChange}
                  // disabled
                  value={formData?.tender_id}
                  className={`form-input-small-four ${errors.tender_id
                    ? "error"
                    : inputState.tender_id
                      ? "success"
                      : ""
                    }`}
                />
                {errors.tender_id && (
                  <span className="error-message font-size-text ">
                    {errors.tender_id}
                  </span>
                )}
              </div>


              <div title="Location" className="flex-column">
                <label
                  htmlFor="location"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Location (State)<span className="required">
                    {/* (Read-Only) */}*
                  </span>
                </label>
                <Select
                  name="location"
                  options={locationOptions}
                  value={
                    formData.location
                      ? { value: formData.location, label: formData.location }
                      : null
                  }
                  onChange={(selected) =>
                    handleInputChange({
                      target: {
                        name: "location",
                        value: selected?.value || "",
                      },
                    })
                  }
                  isSearchable={true}
                  placeholder="Select Location"
                  styles={CSSForSelect15vWWidth}
                />

                {errors.location && (
                  <span className="error-message font-size-text ">
                    {errors.location}
                  </span>
                )}
              </div>






              <div title="Site Sub Company" className="flex-column ">
                <div className=" form-group-selectt">
                  <label
                    htmlFor="sub_company"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Site Sub Company<span className="required">
                      {/* (Read-Only) */}*
                    </span>
                  </label>
                  <br />
                  <select
                    id="sub_company"
                    name="sub_company"
                    placeholder="Site SubCompany"
                    value={formData.sub_company}
                    onChange={handleInputChange}
                    // disabled
                    className={`form-input-small-four ${errors.sub_company
                      ? "error"
                      : inputState.sub_company
                        ? "success"
                        : ""
                      }`}
                  >
                    <option value="">Select a Site SubCompany</option>
                    {siteSubCompanyList
                      ?.sort((a, b) =>
                        a.title.localeCompare(b.title, "en", {
                          ignorePunctuation: true,
                        })
                      )
                      .map((i, index) => (
                        <option key={index} value={i.id}>
                          {i.title}
                        </option>
                      ))}
                  </select>

                </div>
                {errors.sub_company && (
                  <span className="error-message font-size-text ">
                    {errors.sub_company}
                  </span>
                )}
              </div>

              <div title="Work Type" className="flex-column ">
                <div className="form-group-selectt">
                  <label
                    htmlFor="work_type"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Work Type<span className="required">
                      {/* (Read-Only) */}*
                    </span>
                  </label>
                  <br />
                  <Select
                    options={workTypeOptions}
                    isSearchable={true}
                    placeholder="Select Work Type"
                    value={workTypeOptions.find(
                      (opt) => opt.value === formData.work_type
                    )}
                    onChange={(selectedOption) => {
                      setFormData({
                        ...formData,
                        work_type: selectedOption ? selectedOption.value : "",
                      });

                      setInputState({
                        ...inputState,
                        work_type: selectedOption ? "green" : "",
                      });
                    }}
                    styles={CSSForSelect15vWWidth}

                  />
                </div>
                {errors.work_type && (
                  <span className="error-message font-size-text ">
                    {errors.work_type}
                  </span>
                )}
              </div>
              <div title="Project Length" className="flex-column">
                <label
                  htmlFor="project_length"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Project Length<span className="required">
                    {/* (Read-Only) */}*
                  </span>
                </label>
                <input
                  type="number"
                  maxLength={10}
                  min={0}
                  id="project_length"
                  name="project_length"
                  placeholder="Project Length"
                  onChange={handleInputChange}
                  // disabled
                  value={formData.project_length}
                  className={`form-input-small-four ${errors.project_length
                    ? "error"
                    : inputState.project_length
                      ? "success"
                      : ""
                    }`}
                />
                {errors.project_length && (
                  <span className="error-message font-size-text ">
                    {errors.project_length}
                  </span>
                )}
              </div>

              <div title="Bid Due Date" className="flex-column">
                <label
                  htmlFor="bid_due_date"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Bid Due Date <span className="required">
                    {/* (Read-Only) */}*
                  </span>
                </label>
                <input
                  type="date"
                  id="bid_due_date"
                  name="bid_due_date"
                  // disabled
                  placeholder="Target Date"
                  onChange={handleInputChange}
                  value={formData.bid_due_date}
                  className={`form-input-small-four ${errors.bid_due_date
                    ? "error"
                    : inputState.bid_due_date
                      ? "success"
                      : ""
                    }`}
                />
                {errors.bid_due_date && (
                  <span className="error-message font-size-text">
                    {errors.bid_due_date}
                  </span>
                )}
              </div>

              <div title="LOA Date" className="flex-column">
                <label
                  htmlFor="loa_award_date"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  LOA Date
                </label>
                <input
                  type="date"
                  id="loa_award_date"
                  name="loa_award_date"
                  min={formData.bid_due_date}
                  placeholder="Award Date"
                  onChange={handleInputChange}
                  value={formData.loa_award_date}
                  className={`form-input-small-four ${errors.loa_award_date
                    ? "error"
                    : inputState.loa_award_date
                      ? "success"
                      : ""
                    }`}
                />
                {errors.loa_award_date && (
                  <span className="error-message font-size-text ">
                    {errors.loa_award_date}
                  </span>
                )}
              </div>

              <div title="Agreement Date" className="flex-column">
                <label
                  htmlFor="agreement_date"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Agreement Date
                </label>
                <input
                  type="date"
                  id="agreement_date"
                  name="agreement_date"
                  min={formData.bid_due_date}
                  placeholder="Agreement Date"
                  onChange={handleInputChange}
                  value={formData.agreement_date}
                  className={`form-input-small-four ${errors.agreement_date
                    ? "error"
                    : inputState.agreement_date
                      ? "success"
                      : ""
                    }`}
                />
                {errors.agreement_date && (
                  <span className="error-message font-size-text ">
                    {errors.agreement_date}
                  </span>
                )}
              </div>

              <div title="Commencement Date" className="flex-column">
                <label
                  htmlFor="commencement_date"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Commencement Date
                </label>
                <input
                  type="date"
                  id="commencement_date"
                  name="commencement_date"
                  min={formData.agreement_date}
                  placeholder="Commencement Date"
                  onChange={handleInputChange}
                  value={formData.commencement_date}
                  className={`form-input-small-four ${errors.commencement_date
                    ? "error"
                    : inputState.commencement_date
                      ? "success"
                      : ""
                    }`}
                />
                {errors.commencement_date && (
                  <span className="error-message font-size-text ">
                    {errors.commencement_date}
                  </span>
                )}
              </div>
              <div title="Mobilization Date" className="flex-column">
                <label
                  htmlFor="mobilization"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Mobilization Date
                </label>
                <input
                  type="date"
                  id="mobilization"
                  name="mobilization"
                  min={formData.agreement_date}
                  placeholder="e.g. 07/01/2025"
                  onChange={handleInputChange}
                  value={formData.mobilization}
                  className={`form-input-small-four ${errors.mobilization
                    ? "error"
                    : inputState.mobilization
                      ? "success"
                      : ""
                    }`}
                />
                {errors.mobilization && (
                  <span className="error-message font-size-text ">
                    {errors.mobilization}
                  </span>
                )}
              </div>

              <div title="  Construction Duration " className="flex-column">
                <label
                  htmlFor="construction_duration"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Construction Duration
                </label>
                <input
                  type="Number"
                  onWheel={(e) => e.target.blur()}
                  id="construction_duration"
                  name="construction_duration"
                  placeholder="Project Duaration"
                  onChange={handleInputChange}
                  value={formData.construction_duration}
                  className={`form-input-small-four ${errors.construction_duration
                    ? "error"
                    : inputState.construction_duration
                      ? "success"
                      : ""
                    }`}
                />
                {errors.construction_duration && (
                  <span className="error-message font-size-text ">
                    {errors.construction_duration}
                  </span>
                )}
              </div>

              <div title="O&M Duration" className="flex-column">
                <label
                  htmlFor="om_duration"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  O & M Duration
                </label>
                <input
                  type="Number"
                  onWheel={(e) => e.target.blur()}
                  id="om_duration"
                  name="om_duration"
                  placeholder="O&M Duaration"
                  onChange={handleInputChange}
                  value={formData.om_duration}
                  className={`form-input-small-four ${errors.om_duration
                    ? "error"
                    : inputState.om_duration
                      ? "success"
                      : ""
                    }`}
                />
                {errors.om_duration && (
                  <span className="error-message font-size-text ">
                    {errors.om_duration}
                  </span>
                )}
              </div>


              <div title="Project Duration" className="flex-column">
                <label
                  htmlFor="project_duration"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Project Duration (In Month)
                  <br /><span className="required">(Read-Only)</span>
                </label>
                <input
                  type="number"
                  id="project_duration"
                  name="project_duration"
                  placeholder="Project Duaration"
                  onChange={handleInputChange}
                  value={formData.project_duration}
                  className={`form-input-small-four ${errors.project_duration
                    ? "error"
                    : inputState.project_duration
                      ? "success"
                      : ""
                    }`}
                  disabled
                />
                {errors.project_duration && (
                  <span className="error-message font-size-text ">
                    {errors.project_duration}
                  </span>
                )}
              </div>

              <div
                title="Schedule Construction Completion Date"
                className="flex-column"
              >
                <label
                  htmlFor="schedule_construction_completion_date"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Schedule Const. Completion
                  <br /><span className="required">(Read-Only)</span>

                </label>
                <input
                  type="date"
                  id="schedule_construction_completion_date"
                  name="schedule_construction_completion_date"
                  min={formData.commencement_date}
                  placeholder="Target Date"
                  onChange={handleInputChange}
                  disabled
                  value={formData.schedule_construction_completion_date}
                  className={`form-input-small-four ${errors.schedule_construction_completion_date
                    ? "error"
                    : inputState.schedule_construction_completion_date
                      ? "success"
                      : ""
                    }`}
                />
                {errors.schedule_construction_completion_date && (
                  <span className="error-message font-size-text">
                    {errors.schedule_construction_completion_date}
                  </span>
                )}
              </div>

              <div title="Target Date" className="flex-column">
                <label
                  htmlFor="schedule_completion_date"
                  className="form-labels  font-weight500   "
                >
                  Schedule Completion Date
                  <br /><span className="required">(Read-Only)</span>

                </label>
                <input
                  type="date"
                  id="schedule_completion_date"
                  name="schedule_completion_date"
                  min={formData.actual_construction_completion_date}
                  placeholder="Target Date"
                  disabled
                  onChange={handleInputChange}
                  value={formData.schedule_completion_date}
                  className={`form-input-small-four ${errors.schedule_completion_date
                    ? "error"
                    : inputState.schedule_completion_date
                      ? "success"
                      : ""
                    }`}
                />
                {errors.schedule_completion_date && (
                  <span className="error-message">
                    {errors.schedule_completion_date}
                  </span>
                )}
              </div>

              <div
                title="Actual Construction Completion Date"
                className="flex-column"
              >
                <label
                  htmlFor="actual_construction_completion_date"
                  className="form-labels  font-weight500    font-size-subheading"
                  style={{ marginBottom: "24px" }}

                >
                  Actual Const. Completion
                </label>
                <input
                  type="date"
                  id="actual_construction_completion_date"
                  name="actual_construction_completion_date"
                  min={formData.commencement_date}
                  placeholder="Target Date"
                  onChange={handleInputChange}
                  value={formData.actual_construction_completion_date}
                  className={`form-input-small-four ${errors.actual_construction_completion_date
                    ? "error"
                    : inputState.actual_construction_completion_date
                      ? "success"
                      : ""
                    }`}
                />
                {errors.actual_construction_completion_date && (
                  <span className="error-message font-size-text">
                    {errors.actual_construction_completion_date}
                  </span>
                )}
              </div>

              <div title="Actual Completion Date" className="flex-column">
                <label
                  htmlFor="actual_completion_date"
                  className="form-labels  font-weight500   "

                >
                  Actual Completion Date
                </label>
                <input
                  type="date"
                  id="actual_completion_date"
                  name="actual_completion_date"
                  min={formData.actual_completion_date}
                  placeholder="Actual Completion Date"
                  onChange={handleInputChange}
                  value={formData.actual_completion_date}
                  className={`form-input-small-four ${errors.actual_completion_date
                    ? "error"
                    : inputState.actual_completion_date
                      ? "success"
                      : ""
                    }`}
                />
                {errors.actual_completion_date && (
                  <span className="error-message">
                    {errors.actual_completion_date}
                  </span>
                )}
              </div>
              <div title="Authorized AE/IE" className="flex-column">
                <label
                  htmlFor="athorized_IE_AE"
                  className="form-labels  font-weight500   "
                >
                  Authorized AE/IE
                </label>
                <input
                  type="text"
                  id="athorized_IE_AE"
                  name="athorized_IE_AE"
                  placeholder="Authorized AE/IE"
                  onChange={handleInputChange}
                  value={formData.athorized_IE_AE}
                  className={`form-input-small-four ${errors.athorized_IE_AE
                    ? "error"
                    : inputState.athorized_IE_AE
                      ? "success"
                      : ""
                    }`}
                />
                {errors.athorized_IE_AE && (
                  <span className="error-message">
                    {errors.athorized_IE_AE}
                  </span>
                )}
              </div>

              <div title="Site Authority Engineer" className="flex-column ">
                <div className=" form-group-selectt">
                  <label className="form-labels  font-weight500    font-size-subheading">
                    Supervision on behalf of AE/IE
                  </label>
                  <br />
                  <Select
                    options={authorityEngineerOptions}
                    isSearchable
                    isClearable
                    placeholder="Select Authority Engineer"
                    value={authorityEngineerOptions.find(
                      opt => opt.value === formData.authority_engineer
                    )}
                    onChange={handleAuthorityEngineerChange}
                    styles={CSSForSelect10vWWidth}
                  />
                  {errors.authority_engineer && (
                    <span className="error-message font-size-text ">
                      {errors.authority_engineer}
                    </span>
                  )}

                </div>

              </div>


              <div className="flex-row justify-around">
                <div className="flex-column form-group-select">
                  <label className="form-labels">
                    Coordinator:
                  </label>
                  {buffer ?
                    <div className="form-loader-date">
                      <div className="bar-loader"></div>
                    </div>
                    :
                    <>
                      <Select
                        options={options}
                        isMulti
                        onChange={handleChangeAssignedTo}
                        value={formData.com_operators?.map((code) => ({
                          value: code,
                          label: options.find((opt) => opt.value === code)?.label || code,
                        }))}
                        styles={{
                          control: (provided) => ({
                            ...provided,
                            width: '15vw',
                            minHeight: '50px',
                            borderRadius: '10px',
                            border: '1px solid #e3e3e3',
                            margin: '10px 0px 28px 0px',
                            color: '#4a4a4a',
                            backgroundColor: '#f7f8fa',
                            // padding: '0px 10px',
                          }),
                          placeholder: (provided) => ({
                            ...provided,
                            color: '#4a4a4a',
                          }),
                          menu: (provided) => ({
                            ...provided,
                            borderRadius: '10px',
                            marginTop: '0',
                          }),
                          input: (provided) => ({
                            ...provided,
                            color: '#4a4a4a',
                          }),
                          singleValue: (provided) => ({
                            ...provided,
                            color: '#4a4a4a',
                          }),
                        }}
                      />
                      {errors.com_operators && (
                        <span className="error-message font-size-text ">{errors.person}</span>
                      )}
                    </>}
                </div>
              </div>


              <div title="Remark" className="flex-column">
                <label
                  htmlFor="remark"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Remark
                </label>
                <input
                  type="text"
                  id="remark"
                  name="remark"
                  placeholder="Remark"
                  onChange={handleInputChange}
                  value={formData.remark}
                  className={`form-input-small-four ${errors.remark ? "error" : inputState.remark ? "success" : ""
                    }`}
                />
                {errors.remark && (
                  <span className="error-message font-size-text ">
                    {errors.remark}
                  </span>
                )}
              </div>

              <div title="Consultancy Fees" className="flex-column">
                <label
                  htmlFor="consultancy_fees"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Consultancy Fees
                </label>
                <input
                  type="number"
                  min={0}
                  id="consultancy_fees"
                  name="consultancy_fees"
                  placeholder="Consultancy Fees"
                  onChange={handleInputChange}
                  value={formData.consultancy_fees}
                  className={`form-input-small-four ${errors.consultancy_fees
                    ? "error"
                    : inputState.consultancy_fees
                      ? "success"
                      : ""
                    }`}
                />
                {errors.consultancy_fees && (
                  <span className="error-message font-size-text">
                    {errors.consultancy_fees}
                  </span>
                )}
              </div>
              <div title="Contract Mode" className="flex-column ">
                <div className=" form-group-selectt">
                  <label className="form-labels  font-weight500    font-size-subheading">
                    Contract Mode<span className="required">
                      {/* (Read-Only) */}
                      *</span>
                  </label>
                  <br />
                  <select
                    name="contract_mode"
                    onChange={handleInputChange}
                    value={formData.contract_mode}
                    // disabled
                    className={`form-input-small-four form-group-selection form-input-background ${errors.contract_mode
                      ? "error"
                      : inputState.contract_mode
                        ? "success"
                        : ""
                      }`}
                  >
                    <option value="">Select Contract Mode </option>
                    <option value="epc">EPC </option>
                    <option value="ham"> HAM</option>
                    <option value="bot">BOT </option>
                  </select>
                  <div className="form-group-selection-arrow">

                  </div>
                </div>
                {errors.contract_mode && (
                  <span className="error-message font-size-text ">
                    {errors.contract_mode}
                  </span>
                )}
              </div>

              <div title="Lead" className="flex-column">
                <label
                  htmlFor="lead"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Lead Partner<span className="required">
                    {/* (Read-Only) */}
                    *</span>
                </label>
                <Select
                  options={consultantOptions}
                  isSearchable={true}
                  isClearable
                  placeholder="Select"
                  value={consultantOptions.find(
                    (opt) => opt.value === formData.lead
                  )}
                  onChange={(selectedOption) => {
                    setFormData({
                      ...formData,
                      lead: selectedOption ? selectedOption.value : "",
                    });

                    setInputState({
                      ...inputState,
                      lead: selectedOption ? "green" : "",
                    });
                  }}
                  styles={CSSForSelect15vWWidth}

                />
                {errors.lead && (
                  <span className="error-message font-size-text ">
                    {errors.lead}
                  </span>
                )}
              </div>

              <div title="JV" className="flex-column">
                <label
                  htmlFor="jv"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  JV Partner<span className="required">
                    {/* (Read-Only) */}
                  </span>
                </label>
                <Select
                  options={consultantOptions}
                  isSearchable={true}
                  placeholder="Select JV"
                  isClearable
                  value={consultantOptions.find(
                    (opt) => opt.value === formData.jv
                  )}
                  onChange={(selectedOption) => {
                    setFormData({
                      ...formData,
                      jv: selectedOption ? selectedOption.value : "",
                    });

                    setInputState({
                      ...inputState,
                      jv: selectedOption ? "green" : "",
                    });
                  }}
                  styles={CSSForSelect15vWWidth}

                />
                {errors.jv && (
                  <span className="error-message font-size-text ">
                    {errors.jv}
                  </span>
                )}
              </div>

              <div title="Association" className="flex-column">
                <label
                  htmlFor="association"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Association Partner<span className="required">
                    {/* (Read-Only) */}
                  </span>
                </label>
                <Select
                  options={consultantOptions}
                  isSearchable={true}
                  isClearable
                  placeholder="Select Association Partner"
                  value={consultantOptions.find(
                    (opt) => opt.value === formData.association
                  )}
                  onChange={(selectedOption) => {
                    setFormData({
                      ...formData,
                      association: selectedOption ? selectedOption.value : "",
                    });

                    setInputState({
                      ...inputState,
                      association: selectedOption ? "green" : "",
                    });
                  }}
                  styles={CSSForSelect15vWWidth}

                />
                {errors.association && (
                  <span className="error-message font-size-text ">
                    {errors.association}
                  </span>
                )}
              </div>
              <div title="Client Name" className="flex-column">
                <label
                  htmlFor="client_name"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Client
                  <span className="required">
                    {/* (Read-Only) */}
                    *</span>

                </label>
                <Select
                  options={extendedConsultantOptions}
                  isSearchable={true}
                  isClearable
                  placeholder="Select"
                  value={extendedConsultantOptions.find(
                    (opt) => opt.value === formData.client_name
                  )}
                  onChange={(selectedOption) => {
                    setFormData({
                      ...formData,
                      client_name: selectedOption ? selectedOption.value : "",
                    });

                    setInputState({
                      ...inputState,
                      client_name: selectedOption ? "green" : "",
                    });
                  }}
                  styles={CSSForSelect15vWWidth}

                />
                {errors.client_name && (
                  <span className="error-message font-size-text ">
                    {errors.client_name}
                  </span>
                )}
                {filteredList.length > 0 && (
                  <div className="list-group">
                    {filteredList.map((item, index) => (
                      <div key={index} className="list-group-item">
                        {item.client_name}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div title="Lead Share" className="flex-column">
                <label
                  htmlFor="our_share"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  {/* {formData.sub_company ? formData.sub_company : "Our"} Share */}
                  Lead Partner Share (%)
                  {/* Saptagon Share */}
                </label>

                <input
                  type="number"
                  id="our_share"
                  name="our_share"
                  placeholder="Enter percentage (%)"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      value === "" ||
                      (/^\d+\.?\d{0,2}$/.test(value) && value <= 100)
                    ) {
                      handleInputChange(e);
                    }
                  }}
                  value={`${formData.our_share ? formData.our_share : ""}`}
                  className={`form-input-small-four ${errors.our_share
                    ? "error"
                    : inputState.our_share
                      ? "success"
                      : ""
                    }`}
                />
                {errors.our_share && (
                  <span className="error-message font-size-text ">
                    {errors.our_share}
                  </span>
                )}
              </div>

              <div title="jv_share" className="flex-column">
                <label
                  htmlFor="jv_share"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  {/* {formData.sub_company ? formData.sub_company : "Our"} Share */}
                  JV Partner Share (%)
                  {/* Saptagon Share */}
                </label>

                <input
                  type="number"
                  id="jv_share"
                  name="jv_share"
                  placeholder="Enter percentage (%)"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      value === "" ||
                      (/^\d+\.?\d{0,2}$/.test(value) && value <= 100)
                    ) {
                      handleInputChange(e);
                    }
                  }}
                  value={`${formData.jv_share ? formData.jv_share : ""}`}
                  className={`form-input-small-four ${errors.jv_share
                    ? "error"
                    : inputState.jv_share
                      ? "success"
                      : ""
                    }`}
                />
                {errors.jv_share && (
                  <span className="error-message font-size-text ">
                    {errors.jv_share}
                  </span>
                )}
              </div>
              <div title="associate_partner_share" className="flex-column">
                <label
                  htmlFor="associate_partner_share"
                  className="form-labels font-weight500 font-size-subheading"
                >
                  {/* {formData.sub_company ? formData.sub_company : "Our"} Share */}
                  Association Partner Share (%)
                  {/* Saptagon Share */}
                </label>

                <input
                  type="number"
                  id="associate_partner_share"
                  name="associate_partner_share"
                  placeholder="Enter percentage (%)"
                  onChange={(e) => {
                    const value = e.target.value;
                    if (
                      value === "" ||
                      (/^\d+\.?\d{0,2}$/.test(value) && value <= 100)
                    ) {
                      handleInputChange(e);
                    }
                  }}
                  value={`${formData.associate_partner_share ? formData.associate_partner_share : ""}`}
                  className={`form-input-small-four ${errors.associate_partner_share
                    ? "error"
                    : inputState.associate_partner_share
                      ? "success"
                      : ""
                    }`}
                />
                {errors.associate_partner_share && (
                  <span className="error-message font-size-text ">
                    {errors.associate_partner_share}
                  </span>
                )}
              </div>







              <div title="Site Address" className="flex-column">
                <label
                  htmlFor="site_office_address"
                  className="form-labels  font-weight500 font-size-subheading "
                >
                  Site Address
                </label>
                <textarea
                  id="site_office_address"
                  name="site_office_address"
                  placeholder="Site Address"
                  onChange={handleInputChange}
                  value={formData.site_office_address}
                  rows="50"
                  cols="100"
                  // disabled
                  className={`form-textarea form-input-small-four ${errors.site_office_address
                    ? "error"
                    : inputState.site_office_address
                      ? "success"
                      : ""
                    }`}
                />
                {errors.site_office_address && (
                  <div className="error-message font-size-text">
                    {errors.site_office_address}
                  </div>
                )}
              </div>
              <div title="Client Address" className="flex-column">
                <label
                  htmlFor="client_address"
                  className="form-labels  font-weight500 font-size-subheading "
                >
                  Client Address
                </label>
                <textarea
                  id="client_address"
                  name="client_address"
                  placeholder="Client Address"
                  onChange={handleInputChange}
                  value={formData.client_address}
                  rows="50"
                  cols="100"
                  className={`form-textarea form-input-small-four ${errors.client_address
                    ? "error"
                    : inputState.client_address
                      ? "success"
                      : ""
                    }`}
                />
                {errors.client_address && (
                  <div className="error-message font-size-text">
                    {errors.client_address}
                  </div>
                )}
              </div>


              {/* <div title="Client Name" className="flex-column">
                <label htmlFor="client_name" className="form-labels  font-weight500    font-size-subheading">
                  Client
                </label>

                <CreatableSelect
                  id="client_name"
                  name="client_name"
                  options={clientList.map(client => ({ value: client.client_name, label: client.client_name }))}
                  value={
                    formData.client_name
                      ? { value: formData.client_name, label: formData.client_name }
                      : null
                  }
                  onChange={handleInputChangeClient}
                  onInputChange={(inputValue) =>
                    handleInputChangeClient({
                      value: inputValue,
                      label: inputValue
                    })
                  }
                  inputValue={formData.client_name}
                  placeholder="Select or type a new Client Name"
                  className={`form-input ${errors.client_name ? "error" : inputState.client_name ? "success" : ""}`}
                  isClearable
                  formatCreateLabel={(inputValue) =>
                    `Create new Client Name: ${inputValue}`
                  }
                  isValidNewOption={(inputValue, selectValue, selectOptions) =>
                    inputValue.trim() !== "" &&
                    !selectOptions.some(
                      (option) =>
                        option.value.toLowerCase() === inputValue.toLowerCase()
                    )
                  }
                />

                <CreatableSelect
                  id="client_name"
                  name="client_name"
                  options={clientList}
                  value={formData.client_name ? { value: formData.client_name, label: formData.client_name } : null}  // Ensure state reflects this
                  onChange={(option) => handleChange(index, { target: { name: 'stream', value: option ? option.value : '' } })}
                  placeholder="Select or type a new stream"
                  className={`form-input ${errors.client_name ? "error" : inputState.client_name ? "success" : ""}`}
                  // className={`${errors[stream_${index}] ? 'error' : field.stream ? 'success' : ''}`}
                  // isClearable
                  formatCreateLabel={(inputValue) => Create new client_name:${inputV}}
                isValidNewOption={(inputValue, selectValue, selectOptions) =>
                  inputValue.trim() !== '' &&
                  !selectOptions.find(option => option.label.toLowerCase() === inputValue.toLowerCase())
                }
                styles={{
                  control: (provided) => ({
                    ...provided,
                    width: '33vw',
                    height: '50px',
                    borderRadius: '10px',
                    border: '1px solid #e3e3e3',
                    margin: '10px 0px 20px 0px',
                    color: '#4a4a4a',
                    backgroundColor: '#f7f8fa',
                    padding: '0px 10px',
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    color: '#4a4a4a',
                  }),
                  menu: (provided) => ({
                    ...provided,
                    borderRadius: '10px',
                    marginTop: '0',
                  }),
                  input: (provided) => ({
                    ...provided,
                    color: '#4a4a4a',
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    color: '#4a4a4a',
                  }),
                }}
                />

                {errors.client_name && <span className="error-message font-size-text ">{errors.client_name}</span>}
              </div> */}
            </div>
            {/* <div className="flex-column flex-row button-models" style={{ width: "50%", justifyContent: 'center' }}> */}
            <div className="button-models">

              <button
                onClick={handleProjectUpdate}
                type="submit"
                className="model-button font-weight500 model-button-submit"
                disabled={loading}
              >
                Update
              </button>
            </div>


          </form>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal >
    </>
  );
};

const AddProjectBill = ({
  project,
  cosData,
  getProjects,
  site_prcode,
  projectName,
  contractor,
}) => {
  const [show, setShow] = useState(false);
  const handleShow = () => {
    getLetters();
    setShow(true);
  };


  const [formData, setFormData] = useState({
    project: project ? project : "",
    date: null,
    bill_type: "null",
    contractor_name: "",
    work_done_amt: "",
    bill_num: "",
    bill_period_start: null,
    bill_period_end: null,
    billing_date: null,
    bill_catagory: "",
    workperformedby: "contractor",
    site_percentage_amt: "",
    recommended_bill_amount: "",
    recommended_percentage: "0",
    recomended_bill_date: null,
    ho_percentage_amt: "",
    submitted_bill_amount: "",
    submitted_bill_date: null,
    submitted_percentage: "",
    percentage_amt: "",
    submitted_letter_num: null,
    recomended_letter_num: null,
    deduction_amount: 0,
    ld_amount: "",
    withheld_amt: "",
    released_withheld_amt: "",
    remark: "",
    site_recomended_bill_date: null,
    site_recommended_bill_amount: "",
    site_recommended_percentage: "",
    site_ld_amount: "",
    site_withheld_amt: "",
    site_released_withheld_amt: "",
    site_deduction_amount: "",
    site_remark: "",
    site_attachment: "",
    ho_attachment: "",
    escalation: "",
    gst: "",
    site_escalation: "",
    site_gst: "",
    ho_escalation: "",
    ho_gst: "",
    contractor_deduction_amt: "",
    ho_work_done_amt: "",
    contractor_withheld: "0",
    contractor_withheld_release: "0",
    site_work_done_amt: "",
    contractor: contractor,
    cos: null,
    cos_amount: "0",
  });




  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      contractor: contractor,
    }));
  }, [contractor]);


  const {
    submitted_bill_amount = "",
    recommended_bill_amount = "",
    site_deduction_amount = "",
    site_recommended_bill_amount = "",
  } = formData || {};

  const updatesiterecommendedPercentage = submitted_bill_amount
    ? (
      (site_recommended_bill_amount /
        (submitted_bill_amount - (site_deduction_amount || 0))) *
      100
    ).toFixed(2)
    : 0;

  const [trackRecordList, setTrackRecordList] = useState([]);
  const [deductionHeadingsList, setDeductionHeadingsList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});


  // ***********************************Dynamic Deduction and Withheld functionality *****************************************//
  const fileInputRefs = useRef([]);
  const [ContractorWithheldRelease, setContractorWithheldRelease] = useState([]);
  const [ContractorDeductionData, setContractorDeductionData] = useState([]);
  const [SiteWithheldRelease, setSiteWithheldRelease] = useState([]);
  const [SiteDeductionData, setSiteDeductionData] = useState([]);
  const [HOWithheldRelease, setHOWithheldRelease] = useState([]);
  const [HODeductionData, setHODeductionData] = useState([]);

  const [totalContractorWithheldAmount, settotalContractorWithheldAmount] = useState("0");
  const [totalContractorDeductionAmount, settotalContractorDeductionAmount] = useState("0");
  const [totalSiteWithehldAmounnt, settotalSiteWithehldAmounnt] = useState("0");
  const [totalSiteDeductionAmount, settotalSiteDeductionAmount] = useState("0");
  const [totalHOReleaseAmount, settotalHOReleaseAmount] = useState("0");
  const [totalHODeductionAmount, settotalHODeductionAmount] = useState("0");







  const handleAddContractorWitheheldRelease = (e) => {
    e.preventDefault();
    setContractorWithheldRelease((prevFormData) => [
      ...prevFormData,
      {
        contractor_releasing_heading: "",
        contractor_releasing_amount: "0",
        billing: "defaultBilling",
      },
    ]);
  };
  const handleAddContractorDeduction = (e) => {
    e.preventDefault();
    setContractorDeductionData((prevFormData) => [
      ...prevFormData,
      {
        contractor_deduction_heading: "",
        contractor_deduction_amount: "0",
        billing: "",

      },
    ]);
  };
  const handleAddSiteWitheheldRelease = (e) => {
    e.preventDefault();
    setSiteWithheldRelease((prevFormData) => [
      ...prevFormData,
      {
        site_released_heading: "",
        site_released_amount: "0",
        billing: "",

      },
    ]);
  };
  const handleAddSiteDeductionAmount = (e) => {
    e.preventDefault();
    setSiteDeductionData((prevFormData) => [
      ...prevFormData,
      {
        site_deduction_heading: "",
        site_deduction_amount: "0",
        billing: "",

      },
    ]);
  };
  const handleAddHOWitheheldRelease = (e) => {
    e.preventDefault();
    setHOWithheldRelease((prevFormData) => [
      ...prevFormData,
      {
        HO_released_heading: "",
        HO_released_amount: "0",
        billing: "",

      },
    ]);
  };
  const handleAddHOdeduction = (e) => {
    e.preventDefault();
    setHODeductionData((prevFormData) => [
      ...prevFormData,
      {
        HO_deduction_heading: "",
        HO_deduction_amount: "0",
        billing: "",

      },
    ]);
  };


  const handleRemoveContractorWithheldRelease = (index) => {
    setContractorWithheldRelease((prevFormData) => {
      const updatedData = prevFormData.filter((_, i) => i !== index);
      return [...updatedData];
    });


    fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
  };
  const handleRemoveContractorDeduction = (index) => {
    setContractorDeductionData((prevFormData) => {
      const updatedData = prevFormData.filter((_, i) => i !== index);
      return [...updatedData];
    });


    fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
  };
  const handleRemoveSiteWithheldRelease = (index) => {
    setSiteWithheldRelease((prevFormData) => {
      const updatedData = prevFormData.filter((_, i) => i !== index);
      return [...updatedData];
    });


    fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
  };
  const handleRemoveSiteDeduction = (index) => {
    setSiteDeductionData((prevFormData) => {
      const updatedData = prevFormData.filter((_, i) => i !== index);
      return [...updatedData];
    });


    fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
  };
  const handleRemoveHOWitheld = (index) => {
    setHOWithheldRelease((prevFormData) => {
      const updatedData = prevFormData.filter((_, i) => i !== index);
      return [...updatedData];
    });


    fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
  };
  const handleRemoveHODeduction = (index) => {
    setHODeductionData((prevFormData) => {
      const updatedData = prevFormData.filter((_, i) => i !== index);
      return [...updatedData];
    });


    fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
  };

  const handleContractorWithheldInputChange = (e, index) => {
    const { name, value } = e.target;
    setContractorWithheldRelease((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };
  const handleContractorDeductionInputChange = (e, index) => {
    const { name, value } = e.target;
    setContractorDeductionData((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };
  const handleSiteWithheldInputChange = (e, index) => {
    const { name, value } = e.target;
    setSiteWithheldRelease((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };
  const handleSiteDeductionInputChange = (e, index) => {
    const { name, value } = e.target;
    setSiteDeductionData((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };
  const handleHOWithheldInputChange = (e, index) => {
    const { name, value } = e.target;
    setHOWithheldRelease((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };
  const handleHODeductionInputChange = (e, index) => {
    const { name, value } = e.target;
    setHODeductionData((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };


  useEffect(() => {
    const totalContractorWithheldRelease = ContractorWithheldRelease.reduce(
      (acc, curr) => acc + (parseFloat(curr.contractor_releasing_amount) || 0),
      0
    );
    const totalContractorDeduction = ContractorDeductionData.reduce(
      (acc, curr) => acc + (parseFloat(curr.contractor_deduction_amount) || 0),
      0
    );
    const totalSiteWithheldRelease = SiteWithheldRelease.reduce(
      (acc, curr) => acc + (parseFloat(curr.site_released_amount) || 0),
      0
    );
    const totalSiteDeductionData = SiteDeductionData.reduce(
      (acc, curr) => acc + (parseFloat(curr.site_deduction_amount) || 0),
      0
    );
    const totalHOWithheldRelease = HOWithheldRelease.reduce(
      (acc, curr) => acc + (parseFloat(curr.HO_released_amount) || 0),
      0
    );
    const totalHODeductionData = HODeductionData.reduce(
      (acc, curr) => acc + (parseFloat(curr.HO_deduction_amount) || 0),
      0
    );
    settotalContractorWithheldAmount(totalContractorWithheldRelease);
    settotalContractorDeductionAmount(totalContractorDeduction);
    settotalSiteWithehldAmounnt(totalSiteWithheldRelease);
    settotalSiteDeductionAmount(totalSiteDeductionData);
    settotalHOReleaseAmount(totalHOWithheldRelease);
    settotalHODeductionAmount(totalHODeductionData);
  }, [ContractorWithheldRelease, ContractorDeductionData, SiteWithheldRelease, SiteDeductionData, HOWithheldRelease, HODeductionData]);



  // *************************************End of Dynamic Deduction and Withheld functionality **********************************************//

  const handleClose = () => {
    setShow(false);
    setErrors("");
    setIsError(false);
    setFormData({
      project: project ? project : "",
      date: null,
      bill_type: "null",
      contractor_name: "",
      work_done_amt: "",
      bill_num: "",
      bill_period_start: null,
      cos: null,
      bill_period_end: null,
      billing_date: null,
      bill_catagory: "",
      workperformedby: "contractor",
      site_percentage_amt: "",
      recommended_bill_amount: "",
      recommended_percentage: "0",
      recomended_bill_date: null,
      ho_percentage_amt: "",
      submitted_bill_amount: "",
      submitted_bill_date: null,
      cos_amount: "0",
      submitted_percentage: "",
      percentage_amt: "",
      submitted_letter_num: null,
      recomended_letter_num: null,
      deduction_amount: 0,
      ld_amount: "",
      withheld_amt: "",
      released_withheld_amt: "",
      remark: "",
      site_recomended_bill_date: null,
      site_recommended_bill_amount: "",
      site_recommended_percentage: "",
      site_ld_amount: "",
      site_withheld_amt: "",
      site_released_withheld_amt: "",
      site_deduction_amount: "",
      site_remark: "",
      site_attachment: "",
      ho_attachment: "",
      escalation: "",
      gst: "",
      site_escalation: "",
      site_gst: "",
      ho_escalation: "",
      ho_gst: "",
      contractor_deduction_amt: "",
      ho_work_done_amt: "",
      contractor_withheld: "0",
      contractor_withheld_release: "0",
      site_work_done_amt: "",
      contractor: contractor,
    });

    setContractorDeductionData([]);
    setContractorWithheldRelease([]);
    setSiteDeductionData([]);
    setSiteWithheldRelease([]);
    setHOWithheldRelease([]);
    setHODeductionData([]);
  };



  const getLetters = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/letterrecords/filter/null/null/null/null/${project}/${formData.workperformedby}/billing/null/null/${contractor}/null/`);
      // const res = await axios.get(

      //   `${BASE_URL}/siteproject/letterrecordbyfilters/${project}/${formData.workperformedby}/billing/`
      // );
      setTrackRecordList(res.data);
    } catch (err) {
      toast.error("Error fetching letters.");
    }
  };




  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "bill_type",
      "bill_num",
      "bill_period_start",
      "bill_period_end",
      "submitted_bill_date",
      "bill_catagory",
      "submitted_bill_amount",




    ];



    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });


    if (formData.bill_period_start) {
      const selectedDate = new Date(formData.bill_period_start).getTime();
      const today = Date.now();
      if (selectedDate > today) {
        newErrors.bill_period_start = "Future date not accepted";
      }
    }
    if (formData.bill_period_end) {
      const selectedDate = new Date(formData.bill_period_end).getTime();
      const today = Date.now();
      if (selectedDate > today) {
        newErrors.bill_period_end = "Future date not accepted";
      }
    }
    if (formData.recomended_bill_date) {
      const selectedDate = new Date(formData.recomended_bill_date).getTime();
      const today = Date.now();
      if (selectedDate > today) {
        newErrors.recomended_bill_date = "Future date not accepted";
      }
    }
    if (formData.site_recomended_bill_date) {
      const selectedDate = new Date(formData.site_recomended_bill_date).getTime();
      const today = Date.now();
      if (selectedDate > today) {
        newErrors.site_recomended_bill_date = "Future date not accepted";
      }
    }
    if (formData.submitted_bill_date) {
      const selectedDate = new Date(formData.submitted_bill_date).getTime();
      const today = Date.now();
      if (selectedDate > today) {
        newErrors.submitted_bill_date = "Future date not accepted";
      }
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };







  const [isError, setIsError] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => {
      let updatedFormData = { ...prevFormData, [name]: value };
      const errorsToSet = { ...errors };

      if (name === "bill_period_start") {
        const selectedDate = new Date(value);
        const todayDate = new Date();

        todayDate.setHours(0, 0, 0, 0);
        selectedDate.setHours(0, 0, 0, 0);

        if (selectedDate > todayDate) {
          errorsToSet[name] = "Date cannot be greater than today.";
        } else {
          delete errorsToSet[name];
        }
      }

      if (name === "recommended_bill_amount" || name === "deduction_amount") {
        const maxLimit = prevFormData.submitted_bill_amount;

        const { success, error } = inputMaxLimit(name, value, maxLimit);

        if (!success) {
          errorsToSet[name] = error;
        } else {
          delete errorsToSet[name];
        }
      }

      // Constraints for specific fields
      const LimitValues = {
        escalation: "work_done_amt",
        gst: "work_done_amt",
        contractor_deduction_amt: "work_done_amt",
        site_escalation: "site_work_done_amt",
        site_gst: "site_work_done_amt",
        site_deduction_amount: "site_work_done_amt",
        ho_escalation: "ho_work_done_amt",
        ho_gst: "ho_work_done_amt",
        deduction_amount: "ho_work_done_amt",
        ...(formData.bill_type === "ra" && {
          work_done_amt: "cos_amount",
        }),

      };

      const escalationLimitFields = {
        site_escalation: "escalation",
        ho_escalation: "escalation",
      };

      const gstLimitFields = {
        site_gst: "gst",
        ho_gst: "gst",
      };

      const workDoneLimitFields = {
        site_work_done_amt: "work_done_amt",
        ho_work_done_amt: "work_done_amt",
      };

      const submittedamoutLimitedField = {
        site_recommended_bill_amount: "submitted_bill_amount",
        recommended_bill_amount: "submitted_bill_amount",
      };

      const percemntageAmount = {
        percentage_amt: "submitted_bill_amount",
        ho_percentage_amt: "recommended_bill_amount",
        site_percentage_amt: "site_recommended_bill_amount",
      };



      // Validate field limits
      const validateLimit = (limitFields) => {
        if (limitFields[name]) {
          const limitField = limitFields[name];
          const limitValue = parseFloat(prevFormData[limitField] || 0);
          const fieldValue = parseFloat(value || 0);

          if (fieldValue > limitValue) {
            errorsToSet[name] =
              `${name.replaceAll("_", " ")} amount cannot be greater than ${limitValue}.`;
          } else {
            delete errorsToSet[name];
          }
        }
      };

      validateLimit(escalationLimitFields);
      validateLimit(gstLimitFields);
      validateLimit(workDoneLimitFields);
      validateLimit(submittedamoutLimitedField);
      validateLimit(LimitValues);
      validateLimit(percemntageAmount);



      const submittedPercentageAmount = parseFloat(updatedFormData.percentage_amt || 0);
      const site_percentage_amt = parseFloat(updatedFormData.site_percentage_amt || 0);
      const ho_percentage_amt = parseFloat(updatedFormData.ho_percentage_amt || 0);

      updatedFormData = {
        ...updatedFormData,
        submitted_percentage: (
          (submittedPercentageAmount / updatedFormData.submitted_bill_amount) *
          100
        ).toFixed(2),

        site_recommended_percentage: (
          (site_percentage_amt / updatedFormData.site_recommended_bill_amount) *
          100
        ).toFixed(2),

        recommended_percentage: (
          (ho_percentage_amt / updatedFormData.recommended_bill_amount) *
          100
        ).toFixed(2),
      };

      // Remove empty errors
      const filteredErrors = Object.fromEntries(
        Object.entries(errorsToSet).filter(
          ([_, val]) => val !== "" && val !== undefined
        )
      );

      setErrors(filteredErrors);

      setIsError(Object.keys(filteredErrors).length > 0);

      return updatedFormData;
    });
  };


  const handleDateChange = (e) => {
    const { name, value } = e.target;   // ← missing in your code

    if (name === "bill_period_start") {
      const selectedDate = new Date(value);
      const todayDate = new Date();

      // remove time
      todayDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate > todayDate) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Date cannot be greater than today.",
        }));
        return; // stop further execution
      } else {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }
    if (name === "submitted_bill_date") {
      const selectedDate = new Date(value);
      const todayDate = new Date();

      // remove time
      todayDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate > todayDate) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Date cannot be greater than today.",
        }));
        return; // stop further execution
      } else {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }
    if (name === "bill_period_end") {
      const selectedDate = new Date(value);
      const todayDate = new Date();

      // remove time
      todayDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate > todayDate) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Date cannot be greater than today.",
        }));
        return; // stop further execution
      } else {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }
    if (name === "site_recomended_bill_date") {
      const selectedDate = new Date(value);
      const todayDate = new Date();

      // remove time
      todayDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate > todayDate) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Date cannot be greater than today.",
        }));
        return; // stop further execution
      } else {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }
    if (name === "recomended_bill_date") {
      const selectedDate = new Date(value);
      const todayDate = new Date();

      // remove time
      todayDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate > todayDate) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Date cannot be greater than today.",
        }));
        return; // stop further execution
      } else {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }

    // update formData value only when valid
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  useEffect(() => {
    if (!formData) return;
    const updatedSubmittedAmount = (
      parseFloat(formData.work_done_amt || 0) +
      parseFloat(formData.gst || 0) +
      parseFloat(formData.escalation || 0) +
      parseFloat(formData.contractor_withheld_release || 0) +
      parseFloat(totalContractorWithheldAmount)
      -
      (parseFloat(formData.contractor_deduction_amt || 0) +
        parseFloat(formData.contractor_withheld || 0) +
        parseFloat(totalContractorDeductionAmount))
    );
    const updatedSiteSubmittedAmount = (
      parseFloat(formData.site_work_done_amt || 0) +
      parseFloat(formData.site_gst || 0) +
      parseFloat(formData.site_escalation || 0) +
      parseFloat(formData.site_released_withheld_amt || 0) +
      parseFloat(totalSiteWithehldAmounnt)
      -
      (parseFloat(formData.site_deduction_amount || 0) +
        parseFloat(formData.site_withheld_amt || 0) +
        parseFloat(totalSiteDeductionAmount))
    );
    const updateHOSubmittedAmount = (
      parseFloat(formData.ho_work_done_amt || 0) +
      parseFloat(formData.ho_gst || 0) +
      parseFloat(formData.ho_escalation || 0) +
      parseFloat(formData.released_withheld_amt || 0) +
      parseFloat(totalHOReleaseAmount)
      -
      (parseFloat(formData.deduction_amount || 0) +
        parseFloat(formData.withheld_amt || 0) +
        parseFloat(totalHODeductionAmount))
    );

    setFormData(prev => ({
      ...prev,
      submitted_bill_amount: updatedSubmittedAmount.toFixed(),
      site_recommended_bill_amount: updatedSiteSubmittedAmount.toFixed(),
      recommended_bill_amount: updateHOSubmittedAmount.toFixed(),
    }));
  }, [
    formData.work_done_amt,
    formData.gst,
    formData.escalation,
    formData.contractor_withheld_release,
    formData.contractor_deduction_amt,
    formData.contractor_withheld,
    formData.site_work_done_amt,
    formData.site_gst,
    formData.site_escalation,
    formData.site_released_withheld_amt,
    formData.site_withheld_amt,
    formData.site_deduction_amount,
    formData.ho_work_done_amt,
    formData.ho_gst,
    formData.ho_escalation,
    formData.released_withheld_amt,
    formData.withheld_amt,
    formData.deduction_amount,
    totalContractorWithheldAmount,
    totalContractorDeductionAmount,
    totalSiteDeductionAmount,
    totalSiteWithehldAmounnt,
    totalHODeductionAmount,
    totalHOReleaseAmount,
  ]);


  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];

    if (file) {
      setFormData({ ...formData, [name]: file });
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const updatedfromdata = {
      ...formData,
      site_recommended_percentage: updatesiterecommendedPercentage,
    };

    if (!isError && validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        const formDataToSend = new FormData();

        // Append general form fields
        Object.keys(updatedfromdata).forEach((key) => {
          if (updatedfromdata[key]) {
            formDataToSend.append(key, updatedfromdata[key]);
          }
        });

        const res = await axiosInstance2.post(
          `${BASE_URL}/siteproject/billingdetailfield/`,
          formDataToSend
        );

        if (res.status === 200) {
          const generateId = res.data.id;
          const isDataFilled = [...ContractorWithheldRelease, ...ContractorDeductionData, ...SiteWithheldRelease, ...SiteDeductionData, ...HOWithheldRelease, ...HODeductionData].some(data =>
            Object.values(data).some(value => value !== "" && value !== "null")
          );

          if (isDataFilled) {
            const updatedContractorWithheld = ContractorWithheldRelease.map((data) => ({
              ...data,
              billing: generateId,
            }));

            const updatedContractorDeduction = ContractorDeductionData.map((data) => ({
              ...data,
              billing: generateId,
            }));
            const updatedSiteWithheld = SiteWithheldRelease.map((data) => ({
              ...data,
              billing: generateId,
            }));
            const updatedSiteDeduction = SiteDeductionData.map((data) => ({
              ...data,
              billing: generateId,
            }));
            const updatedHOWithheldRelease = HOWithheldRelease.map((data) => ({
              ...data,
              billing: generateId,
            }));
            const updatedHODeduction = HODeductionData.map((data) => ({
              ...data,
              billing: generateId,
            }));

            const mergedData = [...updatedContractorWithheld, ...updatedContractorDeduction, ...updatedSiteWithheld, ...updatedSiteDeduction, ...updatedHOWithheldRelease, ...updatedHODeduction];

            await axios.post(
              `${BASE_URL}/siteproject/otherdeducationbulkUpload/`,
              mergedData
            );
            setContractorWithheldRelease(updatedContractorWithheld);
            setContractorDeductionData(updatedContractorDeduction);
            setSiteWithheldRelease(updatedSiteWithheld);
            setSiteDeductionData(updatedSiteDeduction);
            setHOWithheldRelease(updatedHOWithheldRelease);
            setHODeductionData(updatedHODeduction);

          }
          toast.dismiss(loadingToastId);
          toast.success("Billing detail added successfully!");
          handleClose();
          getProjects();
        } else {
          toast.dismiss(loadingToastId);
          toast.error("Failed to add bill detail!");
        }
      } catch (err) {
        toast.dismiss(loadingToastId);
        toast.error("Error processing your request.");
      } finally {
        setLoading(false);
      }
    }
  };

  //  *********************************Bill Type Select Option **********************************//
  const billType = [
    { value: "sps", label: "SPS" },
    { value: "ipc", label: "IPC" },
    { value: "milestonebill", label: "MileStone Bill" },
    { value: "maintainance", label: "Maintainance" },
    { value: "ra", label: "RA" },
    { value: "annuitypayment", label: "Annuity Payment" },
  ];


  const billTypeOption = billType.sort((a, b) => a.label - b.label).map((i) => ({
    value: i.value,
    label: i.label
  }));


  const handleBilltypeChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        bill_type: "null",
      })
    }
    else {
      setFormData({
        ...formData,
        bill_type: selectedOption.value,
      });
    }
  };

  //  *********************************Bill Type Select Option **********************************//


  //  *********************************Bill Category Select Option **********************************//
  const billCategory = [
    { value: "balancebills", label: "Balance Bills" },
    { value: "bills", label: "Bills" },
  ];


  const billCategoryOption = billCategory.sort((a, b) => a.label - b.label).map((i) => ({
    value: i.value,
    label: i.label
  }));


  const handleBillCategoryChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        bill_catagory: "null",
      })
    }
    else {
      setFormData({
        ...formData,
        bill_catagory: selectedOption.value,
      });
    }
  };

  //  *********************************Bill Category Select Option **********************************//



  //  *********************************Letter Select Option **********************************//
  const letter = trackRecordList.map((i) => ({
    value: i.id,
    label: i.letter_num
  }));


  const letterOption = letter.sort((a, b) => a.label - b.label).map((i) => ({
    value: i.value,
    label: i.label
  }));

  const extendedLetters = [
    { value: "null", label: "Select Letter" },
    ...letterOption,
  ];



  const handleletterChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        submitted_letter_num: null,
      })
    }
    else {
      setFormData({
        ...formData,
        submitted_letter_num: selectedOption.value,
      });
    }
  };
  const handleletterChange2 = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        recomended_letter_num: null,
      })
    }
    else {
      setFormData({
        ...formData,
        recomended_letter_num: selectedOption.value,
      });
    }
  };

  //  *********************************Letter Select Option **********************************//


  // useEffect(() => {
  //   const totalAmount = Number(formData.work_done_amt) + Number(formData.escalation);
  //   const gst_amount = totalAmount * 0.18;
  //   const totalAEAmount = Number(formData.ho_work_done_amt) + Number(formData.ho_escalation);
  //   const aegst_amount = totalAEAmount * 0.18;
  //   const totalClientAmount = Number(formData.site_work_done_amt) + Number(formData.site_escalation);
  //   const clientgst_amount = totalClientAmount * 0.18;



  //   setFormData((prev) => ({
  //     ...prev,
  //     gst: gst_amount
  //   }))
  //   setFormData((prev) => ({
  //     ...prev,
  //     site_gst: clientgst_amount
  //   }))
  //   setFormData((prev) => ({
  //     ...prev,
  //     ho_gst: aegst_amount
  //   }))
  // }, [formData.work_done_amt, formData.escalation, formData.gst, formData.site_gst, formData.ho_gst, formData.site_escalation, formData.site_work_done_amt, formData.ho_escalation, formData.ho_work_done_amt])


  const [linkedCOS, setLinkedCOS] = useState("null");

  const optionsForCOS = cosData.map((i) => ({
    value: i.id,
    label: i.cos_code
  }));

  const handleCOSChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        cos: "null",
      })
    }
    else {
      setFormData({
        ...formData,
        cos: selectedOption.value,
      });
    }
  };

  useEffect(() => {
    setIsError(false);
    setErrors({})

  }, [formData.bill_type, formData.cos])

  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      cos: null,
      cos_amount: null,
    })

    )
  }, [formData.bill_type])


  const [approvedAmount, setApprovedAmount] = useState(0);
  useEffect(() => {
    if (formData.bill_type === "ra") {
      const LinkedCOS = cosData.find(cos => cos.id === formData.cos);
      if (LinkedCOS) {
        const approvedAmount = LinkedCOS.approved_amount || 0;
        setFormData(prev => ({
          ...prev,
          cos_amount: approvedAmount
        }));

      }
    }
  }, [formData.bill_type, formData.cos, formData.work_done_amt, cosData]);


  return (
    <>
      <button title="Add Bill" className="upload-svg" onClick={handleShow}>
        <AddwithWhiteCircle />
        {" "}
        Add Bill
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="three-fourth-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Billing  Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar
          />

          <div className="form-flex-wrap">
            <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
              <div className="jd-heading-outer-flex " >
                <h2 className="jd-heading-main font-weight600  font-size-heading"> Bill Details</h2>
              </div>
              <div>
                <div className="jd-heading-bottom-bold" style={{ width: "160px" }}></div>
                <div className="jd-heading-bottom-light"></div>
              </div>
            </div>
            <div className="form-flex-wrap">
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Bill Type">
                  Bill Type<span className="required">*</span>
                </label>
                <Select
                  options={billTypeOption}
                  isSearchable
                  isClearable
                  title="Bill Type"
                  placeholder="Select Bill Type"
                  value={billTypeOption.find(i => i.value === formData.bill_type)}
                  noOptionsMessage={() => "No other options"}
                  onChange={handleBilltypeChange}
                  styles={CSSForSelect15vWWidthvwWithourforntSize}
                />

                {errors.bill_type && (
                  <div className="error-message font-size-text">
                    {errors.bill_type}
                  </div>
                )}
              </div>

              {formData.bill_type === "ra" &&
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="Bill Type">
                    Select COS<span className="required">*</span>
                  </label>
                  <Select
                    options={optionsForCOS}
                    isSearchable
                    isClearable
                    title="Select COS"
                    placeholder="Select COS"
                    value={optionsForCOS.find(i => i.value === formData.cos)}
                    noOptionsMessage={() => "No other options"}
                    onChange={handleCOSChange}
                    styles={CSSForSelect15vWWidthvwWithourforntSize}
                  />

                  {errors.cos && (
                    <div className="error-message font-size-text">
                      {errors.cos}
                    </div>
                  )}
                </div>
              }

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Bill Category">
                  Bill Category<span className="required">*</span>
                </label>
                <Select
                  options={billCategoryOption}
                  isSearchable
                  isClearable
                  title="Bill Category"
                  placeholder="Select Bill Category"
                  value={billCategoryOption.find(i => i.value === formData.bill_catagory)}
                  noOptionsMessage={() => "No other options"}
                  onChange={handleBillCategoryChange}
                  styles={CSSForSelect15vWWidthvwWithourforntSize}
                />


                {errors.bill_catagory && (
                  <div className="error-message font-size-text">
                    {errors.bill_catagory}
                  </div>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Bill Number">
                  Bill Num<span className="required">*</span>
                </label>
                <input
                  type="text"
                  title="Bill Number"
                  name="bill_num"
                  placeholder="Bill Num"
                  value={formData.bill_num}
                  onChange={handleInputChange}
                  className={`form-input-date width-15vw ${errors.bill_num ? "is-invalid" : ""
                    }`}
                />
                {errors.bill_num && (
                  <div className="error-message font-size-text">
                    {errors.bill_num}
                  </div>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Bill Period Start">
                  Bill Period Start<span className="required">*</span>
                </label>
                <input
                  type="date"
                  name="bill_period_start"
                  title="Bill Period Start"
                  value={formData.bill_period_start}
                  onChange={handleDateChange}
                  max={new Date().toISOString().split('T')[0]}
                  className={`form-input-date width-15vw ${errors.bill_period_start ? "is-invalid" : ""
                    }`}
                />
                {errors.bill_period_start && (
                  <div className="error-message font-size-text">
                    {errors.bill_period_start}
                  </div>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Bill Period End">
                  Bill Period End<span className="required">*</span>
                </label>
                <input
                  type="date"
                  name="bill_period_end"
                  title="Bill Period End"
                  value={formData.bill_period_end}
                  max={new Date().toISOString().split('T')[0]}

                  onChange={handleDateChange}
                  className={`form-input-date width-15vw ${errors.bill_period_end ? "is-invalid" : ""
                    }`}
                  min={formData.bill_period_start}
                />
                {errors.bill_period_end && (
                  <div className="error-message font-size-text">
                    {errors.bill_period_end}
                  </div>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Submitted Bill Date">
                  Submitted Bill Date<span className="required">*</span>
                </label>
                <input
                  type="date"
                  title="Submitted Bill Date"
                  name="submitted_bill_date"
                  value={formData.submitted_bill_date}
                  min={formData.bill_period_end}
                  max={new Date().toISOString().split('T')[0]}

                  onChange={handleDateChange}
                  className={`form-input-date width-15vw ${errors.submitted_bill_date ? "is-invalid" : ""
                    }`}
                />
                {errors.submitted_bill_date && (
                  <div className="error-message font-size-text">
                    {errors.submitted_bill_date}
                  </div>
                )}
              </div>
            </div>
            <div className="form-flex-wrap">
              <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                <div className="jd-heading-outer-flex " >
                  <h2 className="jd-heading-main font-weight600  font-size-heading"> Allowance</h2>
                </div>

              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="GST">
                  Work Done Amount
                </label>
                <input
                  type="number"
                  title="Work Done Amount "
                  name="work_done_amt"
                  placeholder="0 "
                  value={formData.work_done_amt}
                  onChange={handleInputChange}
                  className={`form-input-date width-10vw ${errors.work_done_amt ? "is-invalid" : ""
                    }`}
                />
                {errors.work_done_amt && (
                  <div className="error-message font-size-text">
                    {errors.work_done_amt}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Escalation">
                  Escalation Amount
                </label>
                <input
                  type="number"
                  title="Escalation Amount"
                  name="escalation"
                  placeholder="0"
                  value={formData.escalation}
                  onChange={handleInputChange}
                  className={`form-input-date width-10vw ${errors.escalation ? "is-invalid" : ""
                    }`}
                />
                {errors.escalation && (
                  <div className="error-message font-size-text">
                    {errors.escalation}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="GST">
                  GST Amount <span className="required"></span>
                </label>
                <input
                  type="text"
                  title="GST Amount"
                  // disabled
                  name="gst"
                  placeholder="GST Amount"
                  value={formData.gst}
                  onChange={handleInputChange}
                  className={`form-input-date width-10vw ${errors.gst ? "is-invalid" : ""
                    }`}
                />
                {errors.gst && (
                  <div className="error-message font-size-text">
                    {errors.gst}
                  </div>
                )}
              </div>
              <button type='button' title="Add Allowance" className="jd-heading-main font-weight600" onClick={handleAddContractorWitheheldRelease}>
                <AddwithBlueCircle />
                Add a Bill Allowance
              </button>
            </div>
            <div className="form-flex-wrap" style={{ width: "100%" }}>


              <div className="form-flex-wrap" style={{ width: "100%" }}>
                {ContractorWithheldRelease.map((data, index) => (
                  <>
                    <div className="flex-column">

                      <label className="form-labels font-weight500 font-size-subheading">
                        Heading
                      </label>

                      <input

                        type="text"
                        name="contractor_releasing_heading"
                        value={data.contractor_releasing_heading}
                        onChange={(e) => handleContractorWithheldInputChange(e, index)}
                        placeholder="Enter Heading"
                        className="form-input"
                        style={{ width: "30vw" }}
                      />
                      {errors[`${index}-contractor_releasing_heading`] && (
                        <span className="error-message font-size-text">
                          {errors[`${index}-contractor_releasing_heading`]}
                        </span>
                      )}
                    </div>
                    <div className="flex-column">
                      <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                        <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                          <div>
                            <label className="form-labels font-weight500 font-size-subheading">
                              Amount
                            </label>
                          </div>
                          {index === ContractorWithheldRelease.length - 1 && (
                            <div className="flex-column justify-center">
                              <button

                                title="Remove Field"
                                onClick={() => handleRemoveContractorWithheldRelease(index)}
                                className="file-clear clear-button2"
                                style={{ width: "1.8vw" }}
                              >
                                X
                              </button>
                            </div>
                          )}
                        </div >
                        <div >

                        </div>
                      </div>
                      <input

                        type="number"
                        min={0}
                        name="contractor_releasing_amount"
                        value={data.contractor_releasing_amount}
                        onChange={(e) => handleContractorWithheldInputChange(e, index)}
                        placeholder="Enter Amount"
                        className="form-input"
                        style={{ width: "22vw" }}
                      />
                      {errors[`${index}-contractor_releasing_amount`] && (
                        <span className="error-message font-size-text">
                          {errors[`${index}-contractor_releasing_amount`]}
                        </span>
                      )}
                    </div>

                  </>
                ))}
              </div>
            </div>

            <div className="form-flex-wrap">
              <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                <div className="jd-heading-outer-flex " >
                  <h2 className="jd-heading-main font-weight600  font-size-heading"> Deduction</h2>
                </div>

              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="GST">
                  Deduction Submitted Amount
                </label>
                <input
                  type="number"
                  title="Deduction Submitted Amount"
                  name="contractor_deduction_amt"
                  placeholder="Deduction Submitted Amount"
                  value={formData.contractor_deduction_amt}
                  onChange={handleInputChange}
                  className={`form-input  ${errors.contractor_deduction_amt ? "is-invalid" : ""
                    }`}
                  style={{ width: "30vw" }}
                />
                {errors.contractor_deduction_amt && (
                  <div className="error-message font-size-text">
                    {errors.contractor_deduction_amt}
                  </div>
                )}
              </div>
              <div style={{ width: "22vw" }}>
                <button type='button' title="Add Deduction" className="jd-heading-main font-weight600" onClick={handleAddContractorDeduction}>
                  <AddwithBlueCircle />
                  Add a Bill Deduction
                </button>
              </div>


            </div>
            <div className="form-flex-wrap" style={{ width: "100%" }}>

              <div className="form-flex-wrap" style={{ width: "100%" }}>
                {ContractorDeductionData.map((data, index) => (
                  <>
                    <div className="flex-column">

                      <label className="form-labels font-weight500 font-size-subheading">
                        Heading
                      </label>

                      <input

                        type="text"
                        name="contractor_deduction_heading"
                        value={data.contractor_deduction_heading}
                        onChange={(e) => handleContractorDeductionInputChange(e, index)}
                        placeholder="Enter Heading"
                        className="form-input"
                        style={{ width: "30vw" }}
                      />
                      {errors[`${index}-contractor_deduction_heading`] && (
                        <span className="error-message font-size-text">
                          {errors[`${index}-contractor_deduction_heading`]}
                        </span>
                      )}
                    </div>
                    <div className="flex-column">
                      <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                        <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                          <div>
                            <label className="form-labels font-weight500 font-size-subheading">
                              Amount
                            </label>
                          </div>
                          {index === ContractorDeductionData.length - 1 && (
                            <div className="flex-column justify-center">
                              <button

                                title="Remove Field"
                                onClick={() => handleRemoveContractorDeduction(index)}
                                className="file-clear clear-button2"
                                style={{ width: "1.8vw" }}
                              >
                                X
                              </button>
                            </div>
                          )}
                        </div >
                        <div >

                        </div>
                      </div>
                      <input

                        type="number"
                        min={0}
                        name="contractor_deduction_amount"
                        value={data.contractor_deduction_amount}
                        onChange={(e) => handleContractorDeductionInputChange(e, index)}
                        placeholder="0"
                        className="form-input"
                        style={{ width: "22vw" }}
                      />
                      {errors[`${index}-contractor_deduction_amount`] && (
                        <span className="error-message font-size-text">
                          {errors[`${index}-contractor_deduction_amount`]}
                        </span>
                      )}
                    </div>

                  </>
                ))}
              </div>

              <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                <div className="jd-heading-outer-flex " >
                  <h2 className="jd-heading-main font-weight600  font-size-heading"> Total</h2>
                </div>

              </div>
              <div className="flex-column">
                <label
                  className="form-labels font-weight500 font-size-subheading"
                  title="Submitted Bill Amount"
                >
                  Submitted Bill Amount<span className="required">(Read-Only)</span>
                </label>
                <input
                  type="number"
                  title="Submitted Bill Amount"
                  placeholder="1,00,000"
                  name="submitted_bill_amount"
                  value={formData.submitted_bill_amount}
                  readOnly // Make this field read-only to prevent manual edits

                  className={`form-input-date width-15vw ${errors.submitted_bill_amount ? "is-invalid" : ""
                    }`}
                />
                {errors.submitted_bill_amount && (
                  <div className="error-message font-size-text">
                    {errors.submitted_bill_amount}
                  </div>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="GST">
                  Submitted Percentage Amount
                </label>
                <input
                  type="number"
                  title=" Submitted Percentage Amount"
                  name="percentage_amt"
                  placeholder=" 0"
                  // readOnly
                  value={formData.percentage_amt}
                  onChange={handleInputChange}
                  className={`form-input-date width-15vw ${errors.percentage_amt ? "is-invalid" : ""
                    }`}
                />
                {errors.percentage_amt && (
                  <div className="error-message font-size-text">
                    {errors.percentage_amt}
                  </div>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="GST">
                  Submitted Percentage<span className="required">(Read-only)</span>
                </label>
                <input
                  type="text"
                  title=" Submitted Percentage"
                  name="submitted_percentage"
                  disabled
                  placeholder=" 0"
                  value={formData.submitted_percentage}
                  onChange={handleInputChange}
                  className={`form-input-date width-15vw ${errors.submitted_percentage ? "is-invalid" : ""
                    }`}
                />
                {errors.submitted_percentage && (
                  <div className="error-message font-size-text">
                    {errors.submitted_percentage}
                  </div>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Submitted Letter">
                  Submitted Letter
                </label>
                <Select
                  options={extendedLetters}
                  isSearchable
                  isClearable
                  title="Submitted Letter "
                  placeholder="Select Letter"
                  value={extendedLetters.find(i => i.value === formData.submitted_letter_num)}
                  noOptionsMessage={() => "No other options"}
                  onChange={handleletterChange}
                  styles={CSSForSelect20vWWidth}
                />
                {/* <select
                  name="submitted_letter_num"
                  title="Submitted Letter"
                  value={formData.submitted_letter_num}
                  onChange={handleInputChange}
                  className={`form-input-date`}
                >
                  <option value="">Select an existing letter</option>
                  {trackRecordList.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.letter_num}
                    </option>
                  ))}
                </select> */}
                {errors.submitted_letter_num && (
                  <div className="error-message font-size-text">
                    {errors.submitted_letter_num}
                  </div>
                )}
              </div>

              <div className="flex-column">
                {formData.submitted_letter_num !== "null" ? (
                  ""
                ) : (
                  <div
                    className="flex-row "
                    style={{
                      width: "23.5vw",
                      justifyContent: "space-between",
                      marginTop: "15px",
                    }}
                  >
                    <div
                      style={{ display: "flex", justifyContent: "space-evenly" }}
                    >
                      <div>OR</div>
                    </div>
                    <div className="button-models">
                      <AddTrackRecordDetails
                        projectId={project}
                        letterfor="contractor"
                        lettertype="billing"
                        getProjects={getLetters}
                        title="Bill Letter Details"
                        contractor={contractor}
                        site_prcode={site_prcode}
                        projectName={projectName}
                      />
                    </div>
                  </div>
                )}
              </div>

            </div>




            {/* 
            {sessionStorage.getItem('sitemanagement_role') === "SiteManagement" ? (
              ""
            ) : ( */}
            <>
              <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                <div className="jd-heading-outer-flex " >
                  <h2 className="jd-heading-main font-weight600  font-size-heading"> AE/IE Bill Details</h2>
                </div>
                <div>
                  <div className="jd-heading-bottom-bold" style={{ width: "160px" }}></div>
                  <div className="jd-heading-bottom-light"></div>
                </div>
              </div>
              <div className="form-flex-wrap">
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="Recommend Bill Date">
                    AE/IE Recomended Bill Date
                  </label>
                  <input
                    type="date"
                    name="recomended_bill_date"
                    title="Recommended Bill Date"
                    placeholder="Recomended Bill Date"
                    value={formData.recomended_bill_date}
                    onChange={handleInputChange}
                    max={new Date().toISOString().split('T')[0]}

                    className={`form-input-date ${errors.recomended_bill_date ? "is-invalid" : ""
                      }`}
                  />
                  {errors.recomended_bill_date && (
                    <div className="error-message font-size-text">
                      {errors.recomended_bill_date}
                    </div>
                  )}
                </div>
                <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                  <div className="jd-heading-outer-flex " >
                    <h2 className="jd-heading-main font-weight600  font-size-heading"> Allowance</h2>
                  </div>

                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="GST">
                    AE/IE Work Done Amount
                  </label>
                  <input
                    type="number"
                    title="AE/IE Work Done Amount "
                    name="ho_work_done_amt"
                    placeholder="0"
                    value={formData.ho_work_done_amt}
                    onChange={handleInputChange}
                    className={`form-input-date  width-10vw ${errors.ho_work_done_amt ? "is-invalid" : ""
                      }`}
                  />
                  {errors.ho_work_done_amt && (
                    <div className="error-message font-size-text">
                      {errors.ho_work_done_amt}
                    </div>
                  )}
                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="AE/IE Escalation Amount">
                    AE/IE Escalation Amount
                  </label>
                  <input
                    type="number"
                    title="AE/IE Escalation Amount"
                    name="ho_escalation"
                    placeholder="0"
                    value={formData.ho_escalation}
                    onChange={handleInputChange}
                    className={`form-input-date  width-10vw ${errors.ho_escalation ? "is-invalid" : ""
                      }`}
                  />
                  {errors.ho_escalation && (
                    <div className="error-message font-size-text">
                      {errors.ho_escalation}
                    </div>
                  )}
                </div>

                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="AE/IE GST Amount">
                    AE/IE GST Amount <span className="required"></span>
                  </label>
                  <input
                    type="number"
                    title=" AE/IE GST Amount"
                    name="ho_gst"
                    placeholder="0"
                    value={formData.ho_gst}
                    onChange={handleInputChange}
                    className={`form-input-date  width-10vw ${errors.ho_gst ? "is-invalid" : ""
                      }`}
                  />
                  {errors.ho_gst && (
                    <div className="error-message font-size-text">
                      {errors.ho_gst}
                    </div>
                  )}
                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="Release Withheld Amount">
                    AE/IE Release Withheld Amount
                  </label>
                  <input
                    type="number"
                    title="Released Withheld Amount"
                    min={0}
                    name="released_withheld_amt"
                    placeholder="0"
                    value={formData.released_withheld_amt}
                    onChange={handleInputChange}
                    className={`form-input-date  width-10vw ${errors.released_withheld_amt ? "is-invalid" : ""
                      }`}
                  />
                  {errors.released_withheld_amt && (
                    <div className="error-message font-size-text">
                      {errors.released_withheld_amt}
                    </div>
                  )}
                </div>
                <div className="form-flex-wrap" style={{ width: "100%" }}>
                  <button type='button' title="Add Allowance" className="jd-heading-main font-weight600" onClick={handleAddHOWitheheldRelease}>
                    <AddwithBlueCircle />
                    Add a Bill Allowance
                  </button>

                  <div className="form-flex-wrap" style={{ width: "100%" }}>
                    {HOWithheldRelease.map((data, index) => (
                      <>
                        <div className="flex-column">

                          <label className="form-labels font-weight500 font-size-subheading">
                            AE/IE Heading
                          </label>

                          <input

                            type="text"
                            name="HO_released_heading"
                            value={data.HO_released_heading}
                            onChange={(e) => handleHOWithheldInputChange(e, index)}
                            placeholder="Enter Heading"
                            className="form-input"
                            style={{ width: "30vw" }}
                          />
                          {errors[`${index}-HO_released_heading`] && (
                            <span className="error-message font-size-text">
                              {errors[`${index}-HO_released_heading`]}
                            </span>
                          )}
                        </div>
                        <div className="flex-column">
                          <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                            <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                              <div>
                                <label className="form-labels font-weight500 font-size-subheading">
                                  AE/IE  Amount
                                </label>
                              </div>
                              {index === HOWithheldRelease.length - 1 && (
                                <div className="flex-column justify-center">
                                  <button

                                    title="Remove Field"
                                    onClick={() => handleRemoveHOWitheld(index)}
                                    className="file-clear clear-button2"
                                    style={{ width: "1.8vw" }}
                                  >
                                    X
                                  </button>
                                </div>
                              )}
                            </div >
                            <div >

                            </div>
                          </div>
                          <input

                            type="number"
                            min={0}
                            name="HO_released_amount"
                            value={data.HO_released_amount}
                            onChange={(e) => handleHOWithheldInputChange(e, index)}
                            placeholder="0"
                            className="form-input"
                            style={{ width: "22vw" }}
                          />
                          {errors[`${index}-HO_released_amount`] && (
                            <span className="error-message font-size-text">
                              {errors[`${index}-HO_released_amount`]}
                            </span>
                          )}
                        </div>

                      </>
                    ))}
                  </div>
                </div>

                <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                  <div className="jd-heading-outer-flex " >
                    <h2 className="jd-heading-main font-weight600  font-size-heading"> Deduction</h2>
                  </div>

                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="Withheld Amount">
                    Withheld Amount
                  </label>
                  <input
                    type="number"
                    title="Withheld Amount"
                    min={0}
                    name="withheld_amt"
                    placeholder="0"
                    value={formData.withheld_amt}
                    onChange={handleInputChange}
                    style={{ width: "20vw" }}
                    className={`form-input ${errors.withheld_amt ? "is-invalid" : ""
                      }`}
                  />
                  {errors.withheld_amt && (
                    <div className="error-message font-size-text">
                      {errors.withheld_amt}
                    </div>
                  )}
                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="AE/IE Deduction Amount">
                    AE/IE Deduction Amount
                  </label>
                  <input
                    type="number"
                    title="AE/IE Deduction Amount"
                    min={0}
                    max={formData.submitted_bill_amount}
                    name="deduction_amount"
                    placeholder="0"
                    value={formData.deduction_amount}
                    style={{ width: "20vw" }}

                    onChange={handleInputChange}
                    className={`form-input ${errors.deduction_amount ? "is-invalid" : ""
                      }`}
                  />
                  {errors.deduction_amount && (
                    <div className="error-message font-size-text">
                      {errors.deduction_amount}
                    </div>
                  )}
                </div>
                <button type='button' title="Add Deduction" className="jd-heading-main font-weight600" onClick={handleAddHOdeduction}>
                  <AddwithBlueCircle />
                  Add a Bill Deduction
                </button>
                <div className="form-flex-wrap" style={{ width: "100%" }}>


                  <div className="form-flex-wrap" style={{ width: "100%" }}>
                    {HODeductionData.map((data, index) => (
                      <>
                        <div className="flex-column">

                          <label className="form-labels font-weight500 font-size-subheading">
                            AE/IE Heading
                          </label>

                          <input

                            type="text"
                            name="HO_deduction_heading"
                            value={data.HO_deduction_heading}
                            onChange={(e) => handleHODeductionInputChange(e, index)}
                            placeholder="Enter Heading"
                            className="form-input"
                            style={{ width: "30vw" }}
                          />
                          {errors[`${index}-HO_deduction_heading`] && (
                            <span className="error-message font-size-text">
                              {errors[`${index}-HO_deduction_heading`]}
                            </span>
                          )}
                        </div>
                        <div className="flex-column">
                          <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                            <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                              <div>
                                <label className="form-labels font-weight500 font-size-subheading">
                                  AE/IE  Amount
                                </label>
                              </div>
                              {index === HODeductionData.length - 1 && (
                                <div className="flex-column justify-center">
                                  <button

                                    title="Remove Field"
                                    onClick={() => handleRemoveHODeduction(index)}
                                    className="file-clear clear-button2"
                                    style={{ width: "1.8vw" }}
                                  >
                                    X
                                  </button>
                                </div>
                              )}
                            </div >
                            <div >

                            </div>
                          </div>
                          <input

                            type="number"
                            min={0}
                            name="HO_deduction_amount"
                            value={data.hode}
                            onChange={(e) => handleHODeductionInputChange(e, index)}
                            placeholder="0"
                            style={{ width: "20vw" }}
                            className="form-input"
                          />
                          {errors[`${index}-HO_deduction_amount`] && (
                            <span className="error-message font-size-text">
                              {errors[`${index}-HO_deduction_amount`]}
                            </span>
                          )}
                        </div>

                      </>
                    ))}
                  </div>
                </div>


                <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                  <div className="jd-heading-outer-flex " >
                    <h2 className="jd-heading-main font-weight600  font-size-heading"> Total</h2>
                  </div>

                </div>

                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="AE/IE Recommended Bill Amount">
                    AE/IE Recommended <br /> Bill Amount<span className="required">(Read-Only)</span>
                  </label>
                  <input
                    title="AE/IE Recommended Bill Amount"
                    type="number"
                    min={0}
                    max={formData.submitted_bill_amount}
                    name="recommended_bill_amount"
                    placeholder="AE/IE Recommended Bill Amount"
                    value={formData.recommended_bill_amount}
                    readOnly
                    onChange={handleInputChange}
                    style={{ width: "15vw" }}
                    className={`form-input-date ${errors.recommended_bill_amount ? "is-invalid" : ""
                      }`}
                  />
                  {errors.recommended_bill_amount && (
                    <div className="error-message font-size-text">
                      {errors.recommended_bill_amount}
                    </div>
                  )}
                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title=" AE/IE Recommended Percentage Amount">
                    AE/IE Recommended <br /> Percentage Amount
                  </label>
                  <input
                    title=" AE/IE Recommended Percentage Amount"
                    type="number"
                    min={0}
                    max={formData.submitted_bill_amount}
                    name="ho_percentage_amt"
                    placeholder="0"
                    value={formData.ho_percentage_amt}
                    onChange={handleInputChange}
                    className={`form-input-date width-15vw ${errors.ho_percentage_amt ? "is-invalid" : ""
                      }`}
                  />
                  {errors.ho_percentage_amt && (
                    <div className="error-message font-size-text">
                      {errors.ho_percentage_amt}
                    </div>
                  )}
                </div>

                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="AE/IE Recommended Bill Percentage">
                    AE/IE Recommended <br /> Bill Percentage <span className="required"> (Read-Only)</span>
                  </label>
                  <input
                    type="text"
                    title="AE/IE Recommended Bill Percentage"
                    min={0}
                    max={100}
                    name="recommended_percentage"
                    disabled
                    placeholder="0"
                    style={{ width: "15vw" }}

                    value={formData.recommended_percentage}
                    onChange={handleInputChange}
                    className={`form-input-date width-15vw ${errors.recommended_percentage ? "is-invalid" : ""
                      }`}
                  />
                  {errors.recommended_percentage && (
                    <div className="error-message font-size-text">
                      {errors.recommended_percentage}
                    </div>
                  )}
                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="Recommended Letter">
                    Recommended Letter
                  </label>
                  <Select
                    options={extendedLetters}
                    isSearchable
                    isClearable
                    title="Recommended Letter "
                    placeholder="Select Letter"
                    value={extendedLetters.find(i => i.value === formData.recomended_letter_num)}
                    noOptionsMessage={() => "No other options"}
                    onChange={handleletterChange2}
                    styles={CSSForSelect20vWWidth}
                  />
                </div>

                {formData.recomended_letter_num !== "null" ? (
                  ""
                ) : (
                  <div
                    className="flex-row "
                    style={{
                      width: "23.5vw",
                      justifyContent: "space-between",
                      marginTop: "15px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <div>OR</div>
                    </div>
                    <div className="button-models">
                      <AddTrackRecordDetails
                        projectId={project}
                        letterfor={formData.workperformedby}
                        lettertype="billing"
                        getProjects={getLetters}
                        title="Recomended Letter Details"
                        contractor={contractor}
                        site_prcode={site_prcode}
                        projectName={projectName}
                      />
                    </div>
                  </div>
                )}


              </div>
            </>
            {/* )} */}
            <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
              <div className="jd-heading-outer-flex " >
                <h2 className="jd-heading-main font-weight600  font-size-heading"> Client Bill Details</h2>
              </div>
              <div>
                <div className="jd-heading-bottom-bold" style={{ width: "160px" }}></div>
                <div className="jd-heading-bottom-light"></div>
              </div>
            </div>




            <div className="form-flex-wrap">
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Client Recomended Bill Date">
                  Client Recomended Bill Date
                </label>
                <input
                  type="date"
                  name="site_recomended_bill_date"
                  title="Client Recomended Bill Date"
                  max={new Date().toISOString().split('T')[0]}

                  value={formData.site_recomended_bill_date}
                  onChange={handleDateChange}
                  className={`form-input-date ${errors.site_recomended_bill_date ? "is-invalid" : ""
                    }`}
                  min={formData.submitted_bill_date}
                />
                {errors.site_recomended_bill_date && (
                  <div className="error-message font-size-text">
                    {errors.site_recomended_bill_date}
                  </div>
                )}
              </div>

              <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                <div className="jd-heading-outer-flex " >
                  <h2 className="jd-heading-main font-weight600  font-size-heading"> Allowance</h2>
                </div>

              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="GST">
                  Client Work Done Amount
                </label>
                <input
                  type="number"
                  title="Client Work Done Amount "
                  name="site_work_done_amt"
                  placeholder="Work Done Amount "
                  value={formData.site_work_done_amt}
                  onChange={handleInputChange}
                  className={`form-input-date  width-10vw ${errors.site_work_done_amt ? "is-invalid" : ""
                    }`}
                />
                {errors.site_work_done_amt && (
                  <div className="error-message font-size-text">
                    {errors.site_work_done_amt}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Client Escalation">
                  Client Escalation Amount
                </label>
                <input
                  type="number"
                  title="Client Escalation Amount"
                  name="site_escalation"
                  max={formData.escalation}
                  placeholder="Client Escalation Amount"
                  value={formData.site_escalation}
                  onChange={handleInputChange}
                  className={`form-input-date  width-10vw ${errors.site_escalation ? "is-invalid" : ""
                    }`}
                />
                {errors.site_escalation && (
                  <div className="error-message font-size-text">
                    {errors.site_escalation}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title=" Client GST">
                  Client GST Amount <span className="required"></span>
                </label>
                <input
                  type="number"
                  title="Client GST Amount"
                  name="site_gst"
                  placeholder="GST Amount"
                  value={formData.site_gst}
                  onChange={handleInputChange}
                  className={`form-input-date  width-10vw ${errors.site_gst ? "is-invalid" : ""
                    }`}
                />
                {errors.site_gst && (
                  <div className="error-message font-size-text">
                    {errors.site_gst}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Release Withheld Amount">
                  Client Release Withheld Amount
                </label>
                <input
                  type="number"
                  title="Released Withheld Amount"
                  min={0}
                  name="site_released_withheld_amt"
                  placeholder="0"
                  value={formData.site_released_withheld_amt}
                  onChange={handleInputChange}
                  className={`form-input-date  width-10vw ${errors.site_released_withheld_amt ? "is-invalid" : ""
                    }`}
                />
                {errors.site_released_withheld_amt && (
                  <div className="error-message font-size-text">
                    {errors.site_released_withheld_amt}
                  </div>
                )}
              </div>
              <button type='button' title="Add Allowance" className="jd-heading-main font-weight600" onClick={handleAddSiteWitheheldRelease}>
                <AddwithBlueCircle />
                Add a Bill Allowance
              </button>

              <div className="form-flex-wrap" style={{ width: "100%" }}>


                <div className="form-flex-wrap" style={{ width: "100%" }}>
                  {SiteWithheldRelease.map((data, index) => (
                    <>
                      <div className="flex-column">

                        <label className="form-labels font-weight500 font-size-subheading">
                          Client Heading
                        </label>

                        <input

                          type="text"
                          name="site_released_heading"
                          value={data.site_released_heading}
                          onChange={(e) => handleSiteWithheldInputChange(e, index)}
                          placeholder="Enter Heading"
                          style={{ width: "30vw" }}

                          className="form-input"
                        />
                        {errors[`${index}-site_released_heading`] && (
                          <span className="error-message font-size-text">
                            {errors[`${index}-site_released_heading`]}
                          </span>
                        )}
                      </div>
                      <div className="flex-column">
                        <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                          <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                            <div>
                              <label className="form-labels font-weight500 font-size-subheading">
                                Client  Amount
                              </label>
                            </div>
                            {index === SiteWithheldRelease.length - 1 && (
                              <div className="flex-column justify-center">
                                <button

                                  title="Remove Field"
                                  onClick={() => handleRemoveSiteWithheldRelease(index)}
                                  className="file-clear clear-button2"
                                  style={{ width: "1.8vw" }}
                                >
                                  X
                                </button>
                              </div>
                            )}
                          </div >
                          <div >

                          </div>
                        </div>
                        <input

                          type="number"
                          min={0}
                          name="site_released_amount"
                          value={data.site_released_amount}
                          onChange={(e) => handleSiteWithheldInputChange(e, index)}
                          placeholder="Enter Amount"
                          style={{ width: "20vw" }}

                          className="form-input"
                        />
                        {errors[`${index}-site_released_amount`] && (
                          <span className="error-message font-size-text">
                            {errors[`${index}-site_released_amount`]}
                          </span>
                        )}
                      </div>

                    </>
                  ))}
                </div>
              </div>

              <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                <div className="jd-heading-outer-flex " >
                  <h2 className="jd-heading-main font-weight600  font-size-heading"> Deduction</h2>
                </div>
              </div>



              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Client Deduction Amount">
                  Client Deduction Amount
                </label>
                <input
                  type="number"
                  title="Deduction Amount"
                  name="site_deduction_amount"
                  placeholder="Client Deduction Amount"
                  value={formData.site_deduction_amount}
                  onChange={handleInputChange}
                  className={`form-input  ${errors.site_deduction_amount ? "is-invalid" : ""
                    }`}
                  style={{
                    width: "30vw"
                  }}
                />
                {errors.site_deduction_amount && (
                  <div className="error-message font-size-text">
                    {errors.site_deduction_amount}
                  </div>
                )}


              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="">
                  LD Amount <span className="required"></span>
                </label>
                <input
                  type="number"
                  title=" LD Amount"
                  name="site_ld_amount"
                  placeholder="0"
                  value={formData.site_ld_amount}
                  onChange={handleInputChange}
                  className={`form-input-date  width-10vw ${errors.site_ld_amount ? "is-invalid" : ""
                    }`}
                />
                {errors.site_ld_amount && (
                  <div className="error-message font-size-text">
                    {errors.site_ld_amount}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Withheld Amount">
                  Client Withheld Amount
                </label>
                <input
                  type="number"
                  title="Withheld Amount"
                  min={0}
                  name="site_withheld_amt"
                  placeholder="0"
                  value={formData.site_withheld_amt}
                  onChange={handleInputChange}
                  style={{ width: "20vw" }}
                  className={`form-input ${errors.site_withheld_amt ? "is-invalid" : ""
                    }`}
                />
                {errors.site_withheld_amt && (
                  <div className="error-message font-size-text">
                    {errors.site_withheld_amt}
                  </div>
                )}
              </div>
              <button type='button' title="Add Deduction" className="jd-heading-main font-weight600" onClick={handleAddSiteDeductionAmount}>
                <AddwithBlueCircle />
                Add a Bill Deduction
              </button>
              <div className="form-flex-wrap" style={{ width: "100%" }}>

                <div className="form-flex-wrap" style={{ width: "100%" }}>
                  {SiteDeductionData.map((data, index) => (
                    <>
                      <div className="flex-column">

                        <label className="form-labels font-weight500 font-size-subheading">
                          Client Heading
                        </label>

                        <input

                          type="text"
                          style={{ width: "30vw" }}
                          name="site_deduction_heading"
                          value={data.site_deduction_heading}
                          onChange={(e) => handleSiteDeductionInputChange(e, index)}
                          placeholder="Enter Heading"
                          className="form-input"
                        />
                        {errors[`${index}-site_deduction_heading`] && (
                          <span className="error-message font-size-text">
                            {errors[`${index}-site_deduction_heading`]}
                          </span>
                        )}
                      </div>
                      <div className="flex-column">
                        <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                          <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                            <div>
                              <label className="form-labels font-weight500 font-size-subheading">
                                Client  Amount
                              </label>
                            </div>
                            {index === SiteDeductionData.length - 1 && (
                              <div className="flex-column justify-center">
                                <button

                                  title="Remove Field"
                                  onClick={() => handleRemoveSiteDeduction(index)}
                                  className="file-clear clear-button2"
                                  style={{ width: "1.8vw" }}
                                >
                                  X
                                </button>
                              </div>
                            )}
                          </div >
                          <div >

                          </div>
                        </div>
                        <input

                          type="number"
                          min={0}
                          name="site_deduction_amount"
                          style={{ width: "20vw" }}

                          value={data.site_deduction_amount}
                          onChange={(e) => handleSiteDeductionInputChange(e, index)}
                          placeholder="Enter Amount"
                          className="form-input"
                        />
                        {errors[`${index}-site_deduction_amount`] && (
                          <span className="error-message font-size-text">
                            {errors[`${index}-site_deduction_amount`]}
                          </span>
                        )}
                      </div>

                    </>
                  ))}
                </div>
              </div>
              <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                <div className="jd-heading-outer-flex " >
                  <h2 className="jd-heading-main font-weight600  font-size-heading"> Total</h2>
                </div>

              </div>

              <div className="flex-column">
                <label
                  className="form-labels font-weight500 font-size-subheading"
                  title="Client Approve Bill Amount"
                >
                  Client Approve  <br /> Bill Amount<span className="required">(Read-Only)</span>
                </label>
                <input
                  type="number"
                  title="Client Approve Bill Amount"
                  placeholder="Client Approve Bill Amount"
                  disabled
                  name="site_recommended_bill_amount"
                  value={formData.site_recommended_bill_amount}
                  className={`form-input-date ${errors.site_recommended_bill_amount ? "is-invalid" : ""
                    }`}
                  style={{ width: "15vw" }}
                />
                {errors.site_recommended_bill_amount && (
                  <div className="error-message font-size-text">
                    {errors.site_recommended_bill_amount}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Client Approve Percentage">
                  Client Approve <br /> Percentage<span className="required">(Read-Only)</span>
                </label>
                <input
                  type="number"
                  title=" Client Approve Percentage"
                  name="site_recommended_percentage"
                  placeholder=" 0"
                  style={{ width: "15vw" }}

                  value={formData.site_recommended_percentage}
                  onChange={handleInputChange}
                  className={`form-input-date ${errors.site_recommended_percentage ? "is-invalid" : ""
                    }`}
                />
                {errors.site_recommended_percentage && (
                  <div className="error-message font-size-text">
                    {errors.site_recommended_percentage}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Client Approve Percentage Amount">
                  Client Approve <br /> Percentage Amount
                </label>
                <input
                  type="number"
                  title=" Client Approve Percentage Amount"
                  name="site_percentage_amt"
                  placeholder="0"
                  style={{ width: "15vw" }}

                  // readOnly
                  value={formData.site_percentage_amt}

                  onChange={handleInputChange}
                  className={`form-input-date ${errors.site_percentage_amt ? "is-invalid" : ""
                    }`}
                />
                {errors.site_percentage_amt && (
                  <div className="error-message font-size-text">
                    {errors.site_percentage_amt}
                  </div>
                )}
              </div>



              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Client Rermark">
                  {" "}
                  Client Remark
                </label>
                <textarea
                  type="text"
                  name="site_remark"
                  title="Client Remarks"
                  placeholder="Client Remark"
                  value={formData.site_remark}
                  onChange={handleInputChange}
                  style={{ width: "35vw" }}

                  className={`form-input-date ${errors.site_remark ? "is-invalid" : ""
                    }`}
                />
                {errors.site_remark && (
                  <div className="error-message font-size-text">
                    {errors.site_remark}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="AE/IE Attachment">
                  Client Attachment{" "}
                </label>
                <input
                  type="file"
                  title="Client Attachment"
                  name="ho_attachment"
                  placeholder="Client Attachment"
                  onChange={handleFileChange}
                  style={{ width: "15vw" }}
                  className={`form-input-date ${errors.ho_attachment ? "is-invalid" : ""}`}
                />
                {errors.ho_attachment && (
                  <div className="error-message font-size-text">
                    {errors.ho_attachment}
                  </div>
                )}
              </div>
            </div>


          </div>
          <div className="button-models">
            <button
              className="model-button   font-weight500    model-button-cancel"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              className="model-button font-weight500 model-button-leave font-size-heading"
              onClick={handleFormSubmit}
              disabled={loading}
            >
              {loading ? "Adding..." : "Add"}
            </button>
          </div>
        </Modal.Body>
      </Modal >
    </>
  );
};


// const AddProjectBill = ({
//   project,
//   cosData,
//   getProjects,
//   site_prcode,
//   projectName,
//   contractor,
// }) => {
//   const [show, setShow] = useState(false);
//   const [activeSection, setActiveSection] = useState('basic');
//   const [tabValidationAttempted, setTabValidationAttempted] = useState({});
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const sections = [
//     { id: 'basic', label: 'Basic Info', icon: FileText },
//     { id: 'contractor', label: 'Contractor Billing Details', icon: Building2 },
//     { id: 'ae', label: 'AE/IE Details', icon: CheckCircle },
//     { id: 'client', label: 'Client Details', icon: Award },
//   ];

//   // Define required fields for each tab
//   const tabRequiredFields = {
//     basic: ["bill_type", "bill_num", "bill_period_start", "bill_period_end", "submitted_bill_date", "bill_catagory"],
//     contractor: [],
//     ae: [],
//     client: []
//   };

//   const handleShow = () => {
//     getLetters();
//     setShow(true);
//   };

//   const [formData, setFormData] = useState({
//     project: project ? project : "",
//     date: null,
//     bill_type: "null",
//     contractor_name: "",
//     work_done_amt: "",
//     bill_num: "",
//     bill_period_start: null,
//     bill_period_end: null,
//     billing_date: null,
//     bill_catagory: "",
//     workperformedby: "contractor",
//     site_percentage_amt: "",
//     recommended_bill_amount: "",
//     recommended_percentage: "0",
//     recomended_bill_date: null,
//     ho_percentage_amt: "",
//     submitted_bill_amount: "",
//     submitted_bill_date: null,
//     submitted_percentage: "",
//     percentage_amt: "",
//     submitted_letter_num: null,
//     recomended_letter_num: null,
//     deduction_amount: 0,
//     ld_amount: "",
//     withheld_amt: "",
//     released_withheld_amt: "",
//     remark: "",
//     site_recomended_bill_date: null,
//     site_recommended_bill_amount: "",
//     site_recommended_percentage: "",
//     site_ld_amount: "",
//     site_withheld_amt: "",
//     site_released_withheld_amt: "",
//     site_deduction_amount: "",
//     site_remark: "",
//     site_attachment: "",
//     ho_attachment: "",
//     escalation: "",
//     gst: "",
//     site_escalation: "",
//     site_gst: "",
//     ho_escalation: "",
//     ho_gst: "",
//     contractor_deduction_amt: "",
//     ho_work_done_amt: "",
//     contractor_withheld: "0",
//     contractor_withheld_release: "0",
//     site_work_done_amt: "",
//     contractor: contractor,
//     cos: null,
//     cos_amount: "0",
//   });

//   useEffect(() => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       contractor: contractor,
//     }));
//   }, [contractor]);

//   const {
//     submitted_bill_amount = "",
//     recommended_bill_amount = "",
//     site_deduction_amount = "",
//     site_recommended_bill_amount = "",
//   } = formData || {};

//   const updatesiterecommendedPercentage = submitted_bill_amount
//     ? (
//       (site_recommended_bill_amount /
//         (submitted_bill_amount - (site_deduction_amount || 0))) *
//       100
//     ).toFixed(2)
//     : 0;

//   const [trackRecordList, setTrackRecordList] = useState([]);
//   const [deductionHeadingsList, setDeductionHeadingsList] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});

//   // ***********************************Dynamic Deduction and Withheld functionality *****************************************//
//   const fileInputRefs = useRef([]);
//   const [ContractorWithheldRelease, setContractorWithheldRelease] = useState([]);
//   const [ContractorDeductionData, setContractorDeductionData] = useState([]);
//   const [SiteWithheldRelease, setSiteWithheldRelease] = useState([]);
//   const [SiteDeductionData, setSiteDeductionData] = useState([]);
//   const [HOWithheldRelease, setHOWithheldRelease] = useState([]);
//   const [HODeductionData, setHODeductionData] = useState([]);

//   const [totalContractorWithheldAmount, settotalContractorWithheldAmount] = useState("0");
//   const [totalContractorDeductionAmount, settotalContractorDeductionAmount] = useState("0");
//   const [totalSiteWithehldAmounnt, settotalSiteWithehldAmounnt] = useState("0");
//   const [totalSiteDeductionAmount, settotalSiteDeductionAmount] = useState("0");
//   const [totalHOReleaseAmount, settotalHOReleaseAmount] = useState("0");
//   const [totalHODeductionAmount, settotalHODeductionAmount] = useState("0");

//   const handleAddContractorWitheheldRelease = (e) => {
//     e.preventDefault();
//     setContractorWithheldRelease((prevFormData) => [
//       ...prevFormData,
//       {
//         contractor_releasing_heading: "",
//         contractor_releasing_amount: "0",
//         billing: "defaultBilling",
//       },
//     ]);
//   };
//   const handleAddContractorDeduction = (e) => {
//     e.preventDefault();
//     setContractorDeductionData((prevFormData) => [
//       ...prevFormData,
//       {
//         contractor_deduction_heading: "",
//         contractor_deduction_amount: "0",
//         billing: "",
//       },
//     ]);
//   };
//   const handleAddSiteWitheheldRelease = (e) => {
//     e.preventDefault();
//     setSiteWithheldRelease((prevFormData) => [
//       ...prevFormData,
//       {
//         site_released_heading: "",
//         site_released_amount: "0",
//         billing: "",
//       },
//     ]);
//   };
//   const handleAddSiteDeductionAmount = (e) => {
//     e.preventDefault();
//     setSiteDeductionData((prevFormData) => [
//       ...prevFormData,
//       {
//         site_deduction_heading: "",
//         site_deduction_amount: "0",
//         billing: "",
//       },
//     ]);
//   };
//   const handleAddHOWitheheldRelease = (e) => {
//     e.preventDefault();
//     setHOWithheldRelease((prevFormData) => [
//       ...prevFormData,
//       {
//         HO_released_heading: "",
//         HO_released_amount: "0",
//         billing: "",
//       },
//     ]);
//   };
//   const handleAddHOdeduction = (e) => {
//     e.preventDefault();
//     setHODeductionData((prevFormData) => [
//       ...prevFormData,
//       {
//         HO_deduction_heading: "",
//         HO_deduction_amount: "0",
//         billing: "",
//       },
//     ]);
//   };

//   const handleRemoveContractorWithheldRelease = (index) => {
//     setContractorWithheldRelease((prevFormData) => {
//       const updatedData = prevFormData.filter((_, i) => i !== index);
//       return [...updatedData];
//     });
//     fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
//   };
//   const handleRemoveContractorDeduction = (index) => {
//     setContractorDeductionData((prevFormData) => {
//       const updatedData = prevFormData.filter((_, i) => i !== index);
//       return [...updatedData];
//     });
//     fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
//   };
//   const handleRemoveSiteWithheldRelease = (index) => {
//     setSiteWithheldRelease((prevFormData) => {
//       const updatedData = prevFormData.filter((_, i) => i !== index);
//       return [...updatedData];
//     });
//     fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
//   };
//   const handleRemoveSiteDeduction = (index) => {
//     setSiteDeductionData((prevFormData) => {
//       const updatedData = prevFormData.filter((_, i) => i !== index);
//       return [...updatedData];
//     });
//     fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
//   };
//   const handleRemoveHOWitheld = (index) => {
//     setHOWithheldRelease((prevFormData) => {
//       const updatedData = prevFormData.filter((_, i) => i !== index);
//       return [...updatedData];
//     });
//     fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
//   };
//   const handleRemoveHODeduction = (index) => {
//     setHODeductionData((prevFormData) => {
//       const updatedData = prevFormData.filter((_, i) => i !== index);
//       return [...updatedData];
//     });
//     fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
//   };

//   const handleContractorWithheldInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setContractorWithheldRelease((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });
//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };
//   const handleContractorDeductionInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setContractorDeductionData((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });
//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };
//   const handleSiteWithheldInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setSiteWithheldRelease((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });
//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };
//   const handleSiteDeductionInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setSiteDeductionData((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });
//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };
//   const handleHOWithheldInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setHOWithheldRelease((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });
//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };
//   const handleHODeductionInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setHODeductionData((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });
//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };

//   useEffect(() => {
//     const totalContractorWithheldRelease = ContractorWithheldRelease.reduce(
//       (acc, curr) => acc + (parseFloat(curr.contractor_releasing_amount) || 0),
//       0
//     );
//     const totalContractorDeduction = ContractorDeductionData.reduce(
//       (acc, curr) => acc + (parseFloat(curr.contractor_deduction_amount) || 0),
//       0
//     );
//     const totalSiteWithheldRelease = SiteWithheldRelease.reduce(
//       (acc, curr) => acc + (parseFloat(curr.site_released_amount) || 0),
//       0
//     );
//     const totalSiteDeductionData = SiteDeductionData.reduce(
//       (acc, curr) => acc + (parseFloat(curr.site_deduction_amount) || 0),
//       0
//     );
//     const totalHOWithheldRelease = HOWithheldRelease.reduce(
//       (acc, curr) => acc + (parseFloat(curr.HO_released_amount) || 0),
//       0
//     );
//     const totalHODeductionData = HODeductionData.reduce(
//       (acc, curr) => acc + (parseFloat(curr.HO_deduction_amount) || 0),
//       0
//     );
//     settotalContractorWithheldAmount(totalContractorWithheldRelease);
//     settotalContractorDeductionAmount(totalContractorDeduction);
//     settotalSiteWithehldAmounnt(totalSiteWithheldRelease);
//     settotalSiteDeductionAmount(totalSiteDeductionData);
//     settotalHOReleaseAmount(totalHOWithheldRelease);
//     settotalHODeductionAmount(totalHODeductionData);
//   }, [ContractorWithheldRelease, ContractorDeductionData, SiteWithheldRelease, SiteDeductionData, HOWithheldRelease, HODeductionData]);

//   // *************************************End of Dynamic Deduction and Withheld functionality **********************************************//

//   const handleClose = () => {
//     setShow(false);
//     setErrors("");
//     setIsError(false);
//     setFormData({
//       project: project ? project : "",
//       date: null,
//       bill_type: "null",
//       contractor_name: "",
//       work_done_amt: "",
//       bill_num: "",
//       bill_period_start: null,
//       cos: null,
//       bill_period_end: null,
//       billing_date: null,
//       bill_catagory: "",
//       workperformedby: "contractor",
//       site_percentage_amt: "",
//       recommended_bill_amount: "",
//       recommended_percentage: "0",
//       recomended_bill_date: null,
//       ho_percentage_amt: "",
//       submitted_bill_amount: "",
//       submitted_bill_date: null,
//       cos_amount: "0",
//       submitted_percentage: "",
//       percentage_amt: "",
//       submitted_letter_num: null,
//       recomended_letter_num: null,
//       deduction_amount: 0,
//       ld_amount: "",
//       withheld_amt: "",
//       released_withheld_amt: "",
//       remark: "",
//       site_recomended_bill_date: null,
//       site_recommended_bill_amount: "",
//       site_recommended_percentage: "",
//       site_ld_amount: "",
//       site_withheld_amt: "",
//       site_released_withheld_amt: "",
//       site_deduction_amount: "",
//       site_remark: "",
//       site_attachment: "",
//       ho_attachment: "",
//       escalation: "",
//       gst: "",
//       site_escalation: "",
//       site_gst: "",
//       ho_escalation: "",
//       ho_gst: "",
//       contractor_deduction_amt: "",
//       ho_work_done_amt: "",
//       contractor_withheld: "0",
//       contractor_withheld_release: "0",
//       site_work_done_amt: "",
//       contractor: contractor,
//     });
//     setContractorDeductionData([]);
//     setContractorWithheldRelease([]);
//     setSiteDeductionData([]);
//     setSiteWithheldRelease([]);
//     setHOWithheldRelease([]);
//     setHODeductionData([]);
//     setActiveSection('basic');
//     setTabValidationAttempted({});
//     setIsSubmitted(false);
//   };

//   const getLetters = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/siteproject/letterrecords/filter/null/null/null/null/${project}/${formData.workperformedby}/billing/null/null/${contractor}/null/`);
//       setTrackRecordList(res.data);
//     } catch (err) {
//       toast.error("Error fetching letters.");
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     const requiredFields = [
//       "bill_type",
//       "bill_num",
//       "bill_period_start",
//       "bill_period_end",
//       "submitted_bill_date",
//       "bill_catagory",
//       "submitted_bill_amount",
//     ];
//     requiredFields.forEach((field) => {
//       if (!formData[field]) {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//       }
//     });
//     if (formData.bill_period_start) {
//       const selectedDate = new Date(formData.bill_period_start).getTime();
//       const today = Date.now();
//       if (selectedDate > today) {
//         newErrors.bill_period_start = "Future date not accepted";
//       }
//     }
//     if (formData.bill_period_end) {
//       const selectedDate = new Date(formData.bill_period_end).getTime();
//       const today = Date.now();
//       if (selectedDate > today) {
//         newErrors.bill_period_end = "Future date not accepted";
//       }
//     }
//     if (formData.recomended_bill_date) {
//       const selectedDate = new Date(formData.recomended_bill_date).getTime();
//       const today = Date.now();
//       if (selectedDate > today) {
//         newErrors.recomended_bill_date = "Future date not accepted";
//       }
//     }
//     if (formData.site_recomended_bill_date) {
//       const selectedDate = new Date(formData.site_recomended_bill_date).getTime();
//       const today = Date.now();
//       if (selectedDate > today) {
//         newErrors.site_recomended_bill_date = "Future date not accepted";
//       }
//     }
//     if (formData.submitted_bill_date) {
//       const selectedDate = new Date(formData.submitted_bill_date).getTime();
//       const today = Date.now();
//       if (selectedDate > today) {
//         newErrors.submitted_bill_date = "Future date not accepted";
//       }
//     }
//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const [isError, setIsError] = useState(false);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setInputState({
//       ...inputState,
//       [name]: value.trim() ? "green" : "",
//     });
//     setFormData((prevFormData) => {
//       let updatedFormData = { ...prevFormData, [name]: value };
//       const errorsToSet = { ...errors };

//       if (name === "bill_period_start") {
//         const selectedDate = new Date(value);
//         const todayDate = new Date();
//         todayDate.setHours(0, 0, 0, 0);
//         selectedDate.setHours(0, 0, 0, 0);
//         if (selectedDate > todayDate) {
//           errorsToSet[name] = "Date cannot be greater than today.";
//         } else {
//           delete errorsToSet[name];
//         }
//       }

//       if (name === "recommended_bill_amount" || name === "deduction_amount") {
//         const maxLimit = prevFormData.submitted_bill_amount;
//         const { success, error } = inputMaxLimit(name, value, maxLimit);
//         if (!success) {
//           errorsToSet[name] = error;
//         } else {
//           delete errorsToSet[name];
//         }
//       }

//       // Constraints for specific fields
//       const LimitValues = {
//         escalation: "work_done_amt",
//         gst: "work_done_amt",
//         contractor_deduction_amt: "work_done_amt",
//         site_escalation: "site_work_done_amt",
//         site_gst: "site_work_done_amt",
//         site_deduction_amount: "site_work_done_amt",
//         ho_escalation: "ho_work_done_amt",
//         ho_gst: "ho_work_done_amt",
//         deduction_amount: "ho_work_done_amt",
//         ...(formData.bill_type === "ra" && {
//           work_done_amt: "cos_amount",
//         }),
//       };

//       const escalationLimitFields = {
//         site_escalation: "escalation",
//         ho_escalation: "escalation",
//       };

//       const gstLimitFields = {
//         site_gst: "gst",
//         ho_gst: "gst",
//       };

//       const workDoneLimitFields = {
//         site_work_done_amt: "work_done_amt",
//         ho_work_done_amt: "work_done_amt",
//       };

//       const submittedamoutLimitedField = {
//         site_recommended_bill_amount: "submitted_bill_amount",
//         recommended_bill_amount: "submitted_bill_amount",
//       };

//       const percemntageAmount = {
//         percentage_amt: "submitted_bill_amount",
//         ho_percentage_amt: "recommended_bill_amount",
//         site_percentage_amt: "site_recommended_bill_amount",
//       };

//       const validateLimit = (limitFields) => {
//         if (limitFields[name]) {
//           const limitField = limitFields[name];
//           const limitValue = parseFloat(prevFormData[limitField] || 0);
//           const fieldValue = parseFloat(value || 0);
//           if (fieldValue > limitValue) {
//             errorsToSet[name] = `${name.replaceAll("_", " ")} amount cannot be greater than ${limitValue}.`;
//           } else {
//             delete errorsToSet[name];
//           }
//         }
//       };

//       validateLimit(escalationLimitFields);
//       validateLimit(gstLimitFields);
//       validateLimit(workDoneLimitFields);
//       validateLimit(submittedamoutLimitedField);
//       validateLimit(LimitValues);
//       validateLimit(percemntageAmount);

//       const submittedPercentageAmount = parseFloat(updatedFormData.percentage_amt || 0);
//       const site_percentage_amt = parseFloat(updatedFormData.site_percentage_amt || 0);
//       const ho_percentage_amt = parseFloat(updatedFormData.ho_percentage_amt || 0);

//       updatedFormData = {
//         ...updatedFormData,
//         submitted_percentage: (
//           (submittedPercentageAmount / updatedFormData.submitted_bill_amount) *
//           100
//         ).toFixed(2),
//         site_recommended_percentage: (
//           (site_percentage_amt / updatedFormData.site_recommended_bill_amount) *
//           100
//         ).toFixed(2),
//         recommended_percentage: (
//           (ho_percentage_amt / updatedFormData.recommended_bill_amount) *
//           100
//         ).toFixed(2),
//       };

//       const filteredErrors = Object.fromEntries(
//         Object.entries(errorsToSet).filter(
//           ([_, val]) => val !== "" && val !== undefined
//         )
//       );

//       setErrors(filteredErrors);
//       setIsError(Object.keys(filteredErrors).length > 0);

//       return updatedFormData;
//     });
//   };

//   const handleDateChange = (e) => {
//     const { name, value } = e.target;
//     if (name === "bill_period_start") {
//       const selectedDate = new Date(value);
//       const todayDate = new Date();
//       todayDate.setHours(0, 0, 0, 0);
//       selectedDate.setHours(0, 0, 0, 0);
//       if (selectedDate > todayDate) {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "Date cannot be greater than today.",
//         }));
//         return;
//       } else {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "",
//         }));
//       }
//     }
//     if (name === "submitted_bill_date") {
//       const selectedDate = new Date(value);
//       const todayDate = new Date();
//       todayDate.setHours(0, 0, 0, 0);
//       selectedDate.setHours(0, 0, 0, 0);
//       if (selectedDate > todayDate) {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "Date cannot be greater than today.",
//         }));
//         return;
//       } else {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "",
//         }));
//       }
//     }
//     if (name === "bill_period_end") {
//       const selectedDate = new Date(value);
//       const todayDate = new Date();
//       todayDate.setHours(0, 0, 0, 0);
//       selectedDate.setHours(0, 0, 0, 0);
//       if (selectedDate > todayDate) {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "Date cannot be greater than today.",
//         }));
//         return;
//       } else {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "",
//         }));
//       }
//     }
//     if (name === "site_recomended_bill_date") {
//       const selectedDate = new Date(value);
//       const todayDate = new Date();
//       todayDate.setHours(0, 0, 0, 0);
//       selectedDate.setHours(0, 0, 0, 0);
//       if (selectedDate > todayDate) {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "Date cannot be greater than today.",
//         }));
//         return;
//       } else {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "",
//         }));
//       }
//     }
//     if (name === "recomended_bill_date") {
//       const selectedDate = new Date(value);
//       const todayDate = new Date();
//       todayDate.setHours(0, 0, 0, 0);
//       selectedDate.setHours(0, 0, 0, 0);
//       if (selectedDate > todayDate) {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "Date cannot be greater than today.",
//         }));
//         return;
//       } else {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "",
//         }));
//       }
//     }
//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   useEffect(() => {
//     if (!formData) return;
//     const updatedSubmittedAmount = (
//       parseFloat(formData.work_done_amt || 0) +
//       parseFloat(formData.gst || 0) +
//       parseFloat(formData.escalation || 0) +
//       parseFloat(formData.contractor_withheld_release || 0) +
//       parseFloat(totalContractorWithheldAmount)
//       -
//       (parseFloat(formData.contractor_deduction_amt || 0) +
//         parseFloat(formData.contractor_withheld || 0) +
//         parseFloat(totalContractorDeductionAmount))
//     );
//     const updatedSiteSubmittedAmount = (
//       parseFloat(formData.site_work_done_amt || 0) +
//       parseFloat(formData.site_gst || 0) +
//       parseFloat(formData.site_escalation || 0) +
//       parseFloat(formData.site_released_withheld_amt || 0) +
//       parseFloat(totalSiteWithehldAmounnt)
//       -
//       (parseFloat(formData.site_deduction_amount || 0) +
//         parseFloat(formData.site_withheld_amt || 0) +
//         parseFloat(totalSiteDeductionAmount))
//     );
//     const updateHOSubmittedAmount = (
//       parseFloat(formData.ho_work_done_amt || 0) +
//       parseFloat(formData.ho_gst || 0) +
//       parseFloat(formData.ho_escalation || 0) +
//       parseFloat(formData.released_withheld_amt || 0) +
//       parseFloat(totalHOReleaseAmount)
//       -
//       (parseFloat(formData.deduction_amount || 0) +
//         parseFloat(formData.withheld_amt || 0) +
//         parseFloat(totalHODeductionAmount))
//     );
//     setFormData(prev => ({
//       ...prev,
//       submitted_bill_amount: updatedSubmittedAmount.toFixed(),
//       site_recommended_bill_amount: updatedSiteSubmittedAmount.toFixed(),
//       recommended_bill_amount: updateHOSubmittedAmount.toFixed(),
//     }));
//   }, [
//     formData.work_done_amt,
//     formData.gst,
//     formData.escalation,
//     formData.contractor_withheld_release,
//     formData.contractor_deduction_amt,
//     formData.contractor_withheld,
//     formData.site_work_done_amt,
//     formData.site_gst,
//     formData.site_escalation,
//     formData.site_released_withheld_amt,
//     formData.site_withheld_amt,
//     formData.site_deduction_amount,
//     formData.ho_work_done_amt,
//     formData.ho_gst,
//     formData.ho_escalation,
//     formData.released_withheld_amt,
//     formData.withheld_amt,
//     formData.deduction_amount,
//     totalContractorWithheldAmount,
//     totalContractorDeductionAmount,
//     totalSiteDeductionAmount,
//     totalSiteWithehldAmounnt,
//     totalHODeductionAmount,
//     totalHOReleaseAmount,
//   ]);

//   const handleFileChange = (e) => {
//     const { name } = e.target;
//     const file = e.target.files[0];
//     if (file) {
//       setFormData({ ...formData, [name]: file });
//     }
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();
//     const updatedfromdata = {
//       ...formData,
//       site_recommended_percentage: updatesiterecommendedPercentage,
//     };
//     if (!isError && validateForm()) {
//       setLoading(true);
//       const loadingToastId = toast.loading("Loading: Please wait...");
//       try {
//         const formDataToSend = new FormData();
//         Object.keys(updatedfromdata).forEach((key) => {
//           if (updatedfromdata[key]) {
//             formDataToSend.append(key, updatedfromdata[key]);
//           }
//         });
//         const res = await axiosInstance2.post(
//           `${BASE_URL}/siteproject/billingdetailfield/`,
//           formDataToSend
//         );
//         if (res.status === 200) {
//           const generateId = res.data.id;
//           const isDataFilled = [...ContractorWithheldRelease, ...ContractorDeductionData, ...SiteWithheldRelease, ...SiteDeductionData, ...HOWithheldRelease, ...HODeductionData].some(data =>
//             Object.values(data).some(value => value !== "" && value !== "null")
//           );
//           if (isDataFilled) {
//             const updatedContractorWithheld = ContractorWithheldRelease.map((data) => ({
//               ...data,
//               billing: generateId,
//             }));
//             const updatedContractorDeduction = ContractorDeductionData.map((data) => ({
//               ...data,
//               billing: generateId,
//             }));
//             const updatedSiteWithheld = SiteWithheldRelease.map((data) => ({
//               ...data,
//               billing: generateId,
//             }));
//             const updatedSiteDeduction = SiteDeductionData.map((data) => ({
//               ...data,
//               billing: generateId,
//             }));
//             const updatedHOWithheldRelease = HOWithheldRelease.map((data) => ({
//               ...data,
//               billing: generateId,
//             }));
//             const updatedHODeduction = HODeductionData.map((data) => ({
//               ...data,
//               billing: generateId,
//             }));
//             const mergedData = [...updatedContractorWithheld, ...updatedContractorDeduction, ...updatedSiteWithheld, ...updatedSiteDeduction, ...updatedHOWithheldRelease, ...updatedHODeduction];
//             await axios.post(
//               `${BASE_URL}/siteproject/otherdeducationbulkUpload/`,
//               mergedData
//             );
//             setContractorWithheldRelease(updatedContractorWithheld);
//             setContractorDeductionData(updatedContractorDeduction);
//             setSiteWithheldRelease(updatedSiteWithheld);
//             setSiteDeductionData(updatedSiteDeduction);
//             setHOWithheldRelease(updatedHOWithheldRelease);
//             setHODeductionData(updatedHODeduction);
//           }
//           toast.dismiss(loadingToastId);
//           toast.success("Billing detail added successfully!");
//           handleClose();
//           getProjects();
//         } else {
//           toast.dismiss(loadingToastId);
//           toast.error("Failed to add bill detail!");
//         }
//       } catch (err) {
//         toast.dismiss(loadingToastId);
//         toast.error("Error processing your request.");
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   //  *********************************Bill Type Select Option **********************************//
//   const billType = [
//     { value: "sps", label: "SPS" },
//     { value: "ipc", label: "IPC" },
//     { value: "milestonebill", label: "MileStone Bill" },
//     { value: "maintainance", label: "Maintainance" },
//     { value: "ra", label: "RA" },
//     { value: "annuitypayment", label: "Annuity Payment" },
//   ];

//   const billTypeOption = billType.sort((a, b) => a.label - b.label).map((i) => ({
//     value: i.value,
//     label: i.label
//   }));

//   const handleBilltypeChange = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({ ...formData, bill_type: "null" })
//     } else {
//       setFormData({ ...formData, bill_type: selectedOption.value });
//     }
//   };

//   //  *********************************Bill Category Select Option **********************************//
//   const billCategory = [
//     { value: "balancebills", label: "Balance Bills" },
//     { value: "bills", label: "Bills" },
//   ];

//   const billCategoryOption = billCategory.sort((a, b) => a.label - b.label).map((i) => ({
//     value: i.value,
//     label: i.label
//   }));

//   const handleBillCategoryChange = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({ ...formData, bill_catagory: "null" })
//     } else {
//       setFormData({ ...formData, bill_catagory: selectedOption.value });
//     }
//   };

//   //  *********************************Letter Select Option **********************************//
//   const letter = trackRecordList.map((i) => ({
//     value: i.id,
//     label: i.letter_num
//   }));

//   const letterOption = letter.sort((a, b) => a.label - b.label).map((i) => ({
//     value: i.value,
//     label: i.label
//   }));

//   const extendedLetters = [
//     { value: "null", label: "Select Letter" },
//     ...letterOption,
//   ];

//   const handleletterChange = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({ ...formData, submitted_letter_num: null })
//     } else {
//       setFormData({ ...formData, submitted_letter_num: selectedOption.value });
//     }
//   };
//   const handleletterChange2 = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({ ...formData, recomended_letter_num: null })
//     } else {
//       setFormData({ ...formData, recomended_letter_num: selectedOption.value });
//     }
//   };

//   useEffect(() => {
//     const totalAmount = Number(formData.work_done_amt) + Number(formData.escalation);
//     const gst_amount = totalAmount * 0.18;
//     const totalAEAmount = Number(formData.ho_work_done_amt) + Number(formData.ho_escalation);
//     const aegst_amount = totalAEAmount * 0.18;
//     const totalClientAmount = Number(formData.site_work_done_amt) + Number(formData.site_escalation);
//     const clientgst_amount = totalClientAmount * 0.18;
//     setFormData((prev) => ({ ...prev, gst: gst_amount }))
//     setFormData((prev) => ({ ...prev, site_gst: clientgst_amount }))
//     setFormData((prev) => ({ ...prev, ho_gst: aegst_amount }))
//   }, [formData.work_done_amt, formData.escalation, formData.gst, formData.site_gst, formData.ho_gst, formData.site_escalation, formData.site_work_done_amt, formData.ho_escalation, formData.ho_work_done_amt])

//   const optionsForCOS = cosData.map((i) => ({
//     value: i.id,
//     label: i.cos_code
//   }));

//   const handleCOSChange = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({ ...formData, cos: "null" })
//     } else {
//       setFormData({ ...formData, cos: selectedOption.value });
//     }
//   };

//   useEffect(() => {
//     setIsError(false);
//     setErrors({})
//   }, [formData.bill_type, formData.cos])

//   useEffect(() => {
//     setFormData(prev => ({ ...prev, cos: null, cos_amount: null }))
//   }, [formData.bill_type])

//   useEffect(() => {
//     if (formData.bill_type === "ra") {
//       const LinkedCOS = cosData.find(cos => cos.id === formData.cos);
//       if (LinkedCOS) {
//         const approvedAmount = LinkedCOS.approved_amount || 0;
//         setFormData(prev => ({ ...prev, cos_amount: approvedAmount }));
//       }
//     }
//   }, [formData.bill_type, formData.cos, formData.work_done_amt, cosData]);

//   const validateCurrentTab = () => {
//     const currentTab = activeSection;
//     const newErrors = {};
//     const fieldsToValidate = tabRequiredFields[currentTab] || [];

//     fieldsToValidate.forEach((field) => {
//       if (!formData[field]) {
//         const fieldLabels = {
//           bill_type: "Bill Type",
//           bill_num: "Bill Number",
//           bill_period_start: "Bill Period Start",
//           bill_period_end: "Bill Period End",
//           submitted_bill_date: "Submitted Bill Date",
//           bill_catagory: "Bill Category"
//         };
//         newErrors[field] = `${fieldLabels[field] || field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//       }
//     });

//     setErrors(prev => ({ ...prev, ...newErrors }));
//     setTabValidationAttempted(prev => ({ ...prev, [currentTab]: true }));

//     return Object.keys(newErrors).length === 0;
//   };

//   const goToNextTab = () => {
//     const currentIndex = sections.findIndex(s => s.id === activeSection);
//     const nextTab = sections[currentIndex + 1]?.id;

//     if (!validateCurrentTab()) {
//       const formContainer = document.querySelector('.modern-modal-body');
//       if (formContainer) {
//         formContainer.scrollTop = 0;
//       }
//       return;
//     }

//     if (nextTab) {
//       setErrors(prev => {
//         const nextTabFields = tabRequiredFields[nextTab] || [];
//         const filteredErrors = { ...prev };
//         nextTabFields.forEach(field => {
//           delete filteredErrors[field];
//         });
//         return filteredErrors;
//       });
//     }

//     if (currentIndex < sections.length - 1) {
//       setActiveSection(nextTab);
//     }
//   };

//   const goToPreviousTab = () => {
//     const currentIndex = sections.findIndex(s => s.id === activeSection);
//     if (currentIndex > 0) {
//       setActiveSection(sections[currentIndex - 1].id);
//       setErrors({});
//     }
//   };

//   const hasCurrentTabErrors = () => {
//     const currentTab = activeSection;
//     const fieldsToValidate = tabRequiredFields[currentTab] || [];
//     return fieldsToValidate.some(field => errors[field]);
//   };

//   const getCurrentTabErrorMessage = () => {
//     const currentTab = activeSection;
//     const missingFields = (tabRequiredFields[currentTab] || [])
//       .filter(field => !formData[field])
//       .map(field => {
//         const labels = {
//           bill_type: "Bill Type",
//           bill_num: "Bill Number",
//           bill_period_start: "Bill Period Start",
//           bill_period_end: "Bill Period End",
//           submitted_bill_date: "Submitted Bill Date",
//           bill_catagory: "Bill Category"
//         };
//         return labels[field] || field;
//       });

//     if (missingFields.length === 0) return null;
//     if (missingFields.length === 1) {
//       return `${missingFields[0]} is required to proceed`;
//     }
//     return `Please fill all required fields in ${currentTab.charAt(0).toUpperCase() + currentTab.slice(1)} section`;
//   };

//   const validateAllTabs = () => {
//     let allValid = true;
//     const allErrors = {};

//     Object.keys(tabRequiredFields).forEach(tab => {
//       const fields = tabRequiredFields[tab];
//       fields.forEach(field => {
//         if (!formData[field]) {
//           const labels = {
//             bill_type: "Bill Type",
//             bill_num: "Bill Number",
//             bill_period_start: "Bill Period Start",
//             bill_period_end: "Bill Period End",
//             submitted_bill_date: "Submitted Bill Date",
//             bill_catagory: "Bill Category"
//           };
//           allErrors[field] = `${labels[field] || field} is required!`;
//           allValid = false;
//         }
//       });
//     });

//     setErrors(allErrors);
//     setIsSubmitted(true);
//     return allValid;
//   };

//   // Render functions for each tab
//   const renderBasicInfo = () => (
//     <div className="form-section">
//       <div className="section-title">
//         <FileText size={18} />
//         <h4>Basic Bill Information</h4>
//       </div>
//       <div className="form-grid">
//         <div className="form-field">
//           <label><FileText size={14} /> Bill Type<span className="required">*</span></label>
//           <Select
//             options={billTypeOption}
//             isSearchable
//             isClearable
//             title="Bill Type"
//             placeholder="Select Bill Type"
//             value={billTypeOption.find(i => i.value === formData.bill_type)}
//             noOptionsMessage={() => "No other options"}
//             onChange={handleBilltypeChange}
//             styles={CSSForSelectModern15VWWidth}
//           />
//           {errors.bill_type && <div className="error-message">{errors.bill_type}</div>}
//         </div>

//         {formData.bill_type === "ra" && (
//           <div className="form-field">
//             <label><Link size={14} /> Select COS<span className="required">*</span></label>
//             <Select
//               options={optionsForCOS}
//               isSearchable
//               isClearable
//               title="Select COS"
//               placeholder="Select COS"
//               value={optionsForCOS.find(i => i.value === formData.cos)}
//               noOptionsMessage={() => "No other options"}
//               onChange={handleCOSChange}
//               styles={CSSForSelectModern15VWWidth}
//             />
//             {errors.cos && <div className="error-message">{errors.cos}</div>}
//           </div>
//         )}

//         <div className="form-field">
//           <label><Tag size={14} /> Bill Category<span className="required">*</span></label>
//           <Select
//             options={billCategoryOption}
//             isSearchable
//             isClearable
//             title="Bill Category"
//             placeholder="Select Bill Category"
//             value={billCategoryOption.find(i => i.value === formData.bill_catagory)}
//             noOptionsMessage={() => "No other options"}
//             onChange={handleBillCategoryChange}
//             styles={CSSForSelectModern15VWWidth}
//           />
//           {errors.bill_catagory && <div className="error-message">{errors.bill_catagory}</div>}
//         </div>

//         <div className="form-field">
//           <label><Hash size={14} /> Bill Number<span className="required">*</span></label>
//           <input
//             type="text"
//             name="bill_num"
//             placeholder="Bill Num"
//             value={formData.bill_num}
//             onChange={handleInputChange}
//             className={`${errors.bill_num ? "error" : inputState.bill_num ? "success" : ""}`}
//           />
//           {errors.bill_num && <div className="error-message">{errors.bill_num}</div>}
//         </div>

//         <div className="form-field">
//           <label><Calendar size={14} /> Bill Period Start<span className="required">*</span></label>
//           <input
//             type="date"
//             name="bill_period_start"
//             value={formData.bill_period_start}
//             onChange={handleDateChange}
//             max={new Date().toISOString().split('T')[0]}
//             className={` ${errors.bill_period_start ? "error" : ""}`}
//           />
//           {errors.bill_period_start && <div className="error-message">{errors.bill_period_start}</div>}
//         </div>

//         <div className="form-field">
//           <label><Calendar size={14} /> Bill Period End<span className="required">*</span></label>
//           <input
//             type="date"
//             name="bill_period_end"
//             value={formData.bill_period_end}
//             max={new Date().toISOString().split('T')[0]}
//             onChange={handleDateChange}
//             min={formData.bill_period_start}
//             className={`${errors.bill_period_end ? "error" : ""}`}
//           />
//           {errors.bill_period_end && <div className="error-message">{errors.bill_period_end}</div>}
//         </div>

//         <div className="form-field">
//           <label><Calendar size={14} /> Submitted Bill Date<span className="required">*</span></label>
//           <input
//             type="date"
//             name="submitted_bill_date"
//             value={formData.submitted_bill_date}
//             min={formData.bill_period_end}
//             max={new Date().toISOString().split('T')[0]}
//             onChange={handleDateChange}
//             className={` ${errors.submitted_bill_date ? "error" : ""}`}
//           />
//           {errors.submitted_bill_date && <div className="error-message">{errors.submitted_bill_date}</div>}
//         </div>

//         <div className="form-field">
//           <label><Mail size={14} /> Submitted Letter</label>
//           <Select
//             options={extendedLetters}
//             isSearchable
//             isClearable
//             title="Submitted Letter "
//             placeholder="Select Letter"
//             value={extendedLetters.find(i => i.value === formData.submitted_letter_num)}
//             noOptionsMessage={() => "No other options"}
//             onChange={handleletterChange}
//             styles={CSSForSelectModern}
//           />
//         </div>

//         <div className="form-field">
//           {formData.submitted_letter_num !== "null" ? null : (
//             <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "15px" }}>
//               <div>OR</div>
//               <AddTrackRecordDetails
//                 projectId={project}
//                 letterfor="contractor"
//                 lettertype="billing"
//                 getProjects={getLetters}
//                 title="Bill Letter Details"
//                 contractor={contractor}
//                 site_prcode={site_prcode}
//                 projectName={projectName}
//               />
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="section-navigation-buttons">
//         {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
//           <div className="tab-error-message">
//             <AlertCircle size={14} />
//             <span>{getCurrentTabErrorMessage()}</span>
//           </div>
//         )}
//         <button type="button" className="btn-next" onClick={goToNextTab}>
//           Next: Contractor Billing Details <ChevronRight size={16} />
//         </button>
//       </div>
//     </div>
//   );

//   const renderContractorBillingDetails = () => (
//     <div className="form-section">
//       <div className="section-title">
//         <Building2 size={18} />
//         <h4>Contractor Billing Details</h4>
//       </div>

//       {/* Allowance Section */}
//       <div className="form-grid" style={{ gridTemplateColumns: "repeat(3, 1fr)" }}>
//         <div className="form-field">
//           <label><IndianRupee size={14} /> Work Done Amount</label>
//           <input type="number" name="work_done_amt" placeholder="0" value={formData.work_done_amt} onChange={handleInputChange} className={`width-5vw ${errors.work_done_amt ? "is-invalid" : ""}`} />
//           {errors.work_done_amt && <div className="error-message">{errors.work_done_amt}</div>}
//         </div>
//         <div className="form-field">
//           <label><TrendingUp size={14} /> Escalation Amount</label>
//           <input type="number" name="escalation" placeholder="0" value={formData.escalation} onChange={handleInputChange} className={`width-5vw ${errors.escalation ? "is-invalid" : ""}`} />
//           {errors.escalation && <div className="error-message">{errors.escalation}</div>}
//         </div>
//         <div className="form-field">
//           <label><Percent size={14} /> GST Amount <span className="required">*</span></label>
//           <input type="text" name="gst" disabled value={formData.gst} className="readonly-field width-5vw" />
//           {errors.gst && <div className="error-message">{errors.gst}</div>}
//         </div>
//       </div>

//       <div className="dynamic-fields-section">
//         <div className="section-subtitle">
//           <PlusCircle size={14} />
//           <span>Additional Allowances</span>
//           <button type="button" className="add-dynamic-btn" onClick={handleAddContractorWitheheldRelease}>
//             <Plus size={14} /> Add Allowance
//           </button>
//         </div>
//         {ContractorWithheldRelease.map((data, index) => (
//           <div className="dynamic-field-row" key={index}>
//             <div className="form-field">
//               <label>Heading</label>
//               <input type="text" name="contractor_releasing_heading" value={data.contractor_releasing_heading} onChange={(e) => handleContractorWithheldInputChange(e, index)} placeholder="Enter Heading" className="width-35vw" />
//               {errors[`${index}-contractor_releasing_heading`] && <span className="error-message">{errors[`${index}-contractor_releasing_heading`]}</span>}
//             </div>
//             <div className="form-field">
//               <label>Amount</label>
//               <input type="number" min={0} name="contractor_releasing_amount" value={data.contractor_releasing_amount} onChange={(e) => handleContractorWithheldInputChange(e, index)} placeholder="Enter Amount" className="width-5vw" />
//               {errors[`${index}-contractor_releasing_amount`] && <span className="error-message">{errors[`${index}-contractor_releasing_amount`]}</span>}
//             </div>
//             <button type="button" className="remove-dynamic-btn" onClick={() => handleRemoveContractorWithheldRelease(index)}><X size={14} /></button>
//           </div>
//         ))}
//       </div>

//       {/* Deduction Section */}
//       <div className="form-grid" style={{ marginTop: "1.5rem" }}>
//         <div className="form-field">
//           <label><MinusCircle size={14} /> Deduction Submitted Amount</label>
//           <input type="number" name="contractor_deduction_amt" placeholder="Deduction Submitted Amount" value={formData.contractor_deduction_amt} onChange={handleInputChange} className={` ${errors.contractor_deduction_amt ? "is-invalid" : ""}`} style={{ width: "30vw" }} />
//           {errors.contractor_deduction_amt && <div className="error-message">{errors.contractor_deduction_amt}</div>}
//         </div>
//       </div>

//       <div className="dynamic-fields-section">
//         <div className="section-subtitle">
//           <MinusCircle size={14} />
//           <span>Additional Deductions</span>
//           <button type="button" className="add-dynamic-btn" onClick={handleAddContractorDeduction}>
//             <Plus size={14} /> Add Deduction
//           </button>
//         </div>
//         {ContractorDeductionData.map((data, index) => (
//           <div className="dynamic-field-row" key={index}>
//             <div className="form-field">
//               <label>Heading</label>
//               <input type="text" name="contractor_deduction_heading" value={data.contractor_deduction_heading} onChange={(e) => handleContractorDeductionInputChange(e, index)} placeholder="Enter Heading" className="width-35vw" />
//               {errors[`${index}-contractor_deduction_heading`] && <span className="error-message">{errors[`${index}-contractor_deduction_heading`]}</span>}
//             </div>
//             <div className="form-field">
//               <label>Amount</label>
//               <input type="number" min={0} name="contractor_deduction_amount" value={data.contractor_deduction_amount} onChange={(e) => handleContractorDeductionInputChange(e, index)} placeholder="0" className="width-5vw" />
//               {errors[`${index}-contractor_deduction_amount`] && <span className="error-message">{errors[`${index}-contractor_deduction_amount`]}</span>}
//             </div>
//             <button type="button" className="remove-dynamic-btn" onClick={() => handleRemoveContractorDeduction(index)}><X size={14} /></button>
//           </div>
//         ))}
//       </div>

//       {/* Total Section */}
//       <div className="form-grid" style={{ marginTop: "1.5rem", gridTemplateColumns: "repeat(3, 1fr)" }}>
//         <div className="form-field">
//           <label>Submitted Bill Amount<span className="required">(Read-Only)</span></label>
//           <input type="number" name="submitted_bill_amount" value={formData.submitted_bill_amount} readOnly />
//           {errors.submitted_bill_amount && <div className="error-message">{errors.submitted_bill_amount}</div>}
//         </div>
//         <div className="form-field">
//           <label>Submitted Percentage Amount</label>
//           <input type="number" name="percentage_amt" placeholder="0" value={formData.percentage_amt} onChange={handleInputChange} className={`${errors.percentage_amt ? "is-invalid" : ""}`} />
//           {errors.percentage_amt && <div className="error-message">{errors.percentage_amt}</div>}
//         </div>
//         <div className="form-field">
//           <label>Submitted Percentage<span className="required">(Read-only)</span></label>
//           <input type="text" name="submitted_percentage" disabled value={formData.submitted_percentage} className="" />
//           {errors.submitted_percentage && <div className="error-message">{errors.submitted_percentage}</div>}
//         </div>
//       </div>

//       <div className="section-navigation-buttons dual-buttons">
//         <div className="nav-buttons-wrapper">
//           <button type="button" className="btn-prev" onClick={goToPreviousTab}>
//             <ChevronRight size={16} className="rotate-left" /> Previous: Basic Info
//           </button>
//           <button type="button" className="btn-next" onClick={goToNextTab}>
//             Next: AE/IE Details <ChevronRight size={16} />
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   const renderAeDetails = () => (
//     <div className="form-section">
//       <div className="section-title">
//         <CheckCircle size={18} />
//         <h4>AE/IE Bill Details</h4>
//       </div>
//       <div className="form-flex-wrap">
//         <div className="form-field">
//           <label><Calendar size={14} /> AE/IE Recomended Bill Date</label>
//           <input type="date" name="recomended_bill_date" value={formData.recomended_bill_date} onChange={handleDateChange} max={new Date().toISOString().split('T')[0]} style={{ marginBottom: "10px" }} className={` ${errors.recomended_bill_date ? "is-invalid" : ""}`} />
//           {errors.recomended_bill_date && <div className="error-message">{errors.recomended_bill_date}</div>}
//         </div>
//         <div className="form-field">
//           <label><IndianRupee size={14} /> AE/IE Work Done Amount</label>
//           <input type="number" name="ho_work_done_amt" placeholder="0" value={formData.ho_work_done_amt} onChange={handleInputChange} className={`${errors.ho_work_done_amt ? "is-invalid" : ""}`} />
//           {errors.ho_work_done_amt && <div className="error-message">{errors.ho_work_done_amt}</div>}
//         </div>
//         <div className="form-field">
//           <label><TrendingUp size={14} /> AE/IE Escalation Amount</label>
//           <input type="number" name="ho_escalation" placeholder="0" value={formData.ho_escalation} onChange={handleInputChange} className={`${errors.ho_escalation ? "is-invalid" : ""}`} />
//           {errors.ho_escalation && <div className="error-message">{errors.ho_escalation}</div>}
//         </div>
//         <div className="form-field">
//           <label><Percent size={14} /> AE/IE GST Amount <span className="required">(Read-Only)</span></label>
//           <input type="number" disabled name="ho_gst" value={formData.ho_gst} className="readonly-field" />
//           {errors.ho_gst && <div className="error-message">{errors.ho_gst}</div>}
//         </div>
//         <div className="form-field">
//           <label><IndianRupee size={14} /> AE/IE Release Withheld Amount</label>
//           <input type="number" min={0} name="released_withheld_amt" placeholder="0" value={formData.released_withheld_amt} onChange={handleInputChange} className={` ${errors.released_withheld_amt ? "is-invalid" : ""}`} />
//           {errors.released_withheld_amt && <div className="error-message">{errors.released_withheld_amt}</div>}
//         </div>
//       </div>



//       <div className="dynamic-fields-section">
//         <div className="section-subtitle">
//           <PlusCircle size={14} />
//           <span>AE/IE Additional Allowances</span>
//           <button type="button" className="add-dynamic-btn" onClick={handleAddHOWitheheldRelease}><Plus size={14} /> Add Allowance</button>
//         </div>
//         {HOWithheldRelease.map((data, index) => (
//           <div className="dynamic-field-row" key={index}>
//             <div className="form-field"><label>AE/IE Heading</label><input type="text" name="HO_released_heading" value={data.HO_released_heading} onChange={(e) => handleHOWithheldInputChange(e, index)} placeholder="Enter Heading" className="width-35vw" /></div>
//             <div className="form-field"><label>AE/IE Amount</label><input type="number" min={0} name="HO_released_amount" value={data.HO_released_amount} onChange={(e) => handleHOWithheldInputChange(e, index)} placeholder="0" className="width-5vw" /></div>
//             <button type="button" className="remove-dynamic-btn" onClick={() => handleRemoveHOWitheld(index)}><X size={14} /></button>
//           </div>
//         ))}
//       </div>

//       <div className="form-grid">
//         <div className="form-field">
//           <label><MinusCircle size={14} /> Withheld Amount</label>
//           <input type="number" min={0} name="withheld_amt" placeholder="0" value={formData.withheld_amt} onChange={handleInputChange} className={`width-25vw ${errors.withheld_amt ? "is-invalid" : ""}`} />
//           {errors.withheld_amt && <div className="error-message">{errors.withheld_amt}</div>}
//         </div>
//         <div className="form-field">
//           <label><MinusCircle size={14} /> AE/IE Deduction Amount</label>
//           <input type="number" min={0} max={formData.submitted_bill_amount} name="deduction_amount" placeholder="0" value={formData.deduction_amount} style={{ width: "25vw" }} onChange={handleInputChange} className={` ${errors.deduction_amount ? "is-invalid" : ""}`} />
//           {errors.deduction_amount && <div className="error-message">{errors.deduction_amount}</div>}
//         </div>
//       </div>

//       <div className="dynamic-fields-section">
//         <div className="section-subtitle">
//           <MinusCircle size={14} />
//           <span>AE/IE Additional Deductions</span>
//           <button type="button" className="add-dynamic-btn" onClick={handleAddHOdeduction}><Plus size={14} /> Add Deduction</button>
//         </div>
//         {HODeductionData.map((data, index) => (
//           <div className="dynamic-field-row" key={index}>
//             <div className="form-field"><label>AE/IE Heading</label><input type="text" name="HO_deduction_heading" value={data.HO_deduction_heading} onChange={(e) => handleHODeductionInputChange(e, index)} placeholder="Enter Heading" style={{ width: "35vw" }} /></div>
//             <div className="form-field"><label>AE/IE Amount</label><input type="number" min={0} name="HO_deduction_amount" value={data.HO_deduction_amount} onChange={(e) => handleHODeductionInputChange(e, index)} placeholder="0" style={{ width: "5vw" }} /></div>
//             <button type="button" className="remove-dynamic-btn" onClick={() => handleRemoveHODeduction(index)}><X size={14} /></button>
//           </div>
//         ))}
//       </div>

//       <div className="form-grid">
//         <div className="form-field">
//           <label>AE/IE Recommended Bill Amount<span className="required">(Read-Only)</span></label>
//           <input type="number" name="recommended_bill_amount" value={formData.recommended_bill_amount} readOnly className="readonly-field" style={{ width: "15vw" }} />
//           {errors.recommended_bill_amount && <div className="error-message">{errors.recommended_bill_amount}</div>}
//         </div>
//         <div className="form-field">
//           <label>AE/IE Recommended Percentage Amount</label>
//           <input type="number" name="ho_percentage_amt" placeholder="0" value={formData.ho_percentage_amt} onChange={handleInputChange} className={` ${errors.ho_percentage_amt ? "is-invalid" : ""}`} />
//           {errors.ho_percentage_amt && <div className="error-message">{errors.ho_percentage_amt}</div>}
//         </div>
//         <div className="form-field">
//           <label>AE/IE Recommended Bill Percentage<span className="required">(Read-Only)</span></label>
//           <input type="text" name="recommended_percentage" disabled value={formData.recommended_percentage} className="readonly-field" style={{ width: "15vw" }} />
//           {errors.recommended_percentage && <div className="error-message">{errors.recommended_percentage}</div>}
//         </div>
//         <div className="form-field">
//           <label>Recommended Letter</label>
//           <Select options={extendedLetters} isSearchable isClearable placeholder="Select Letter" value={extendedLetters.find(i => i.value === formData.recomended_letter_num)} onChange={handleletterChange2} styles={CSSForSelectModern} />
//         </div>
//         <div className="form-field">
//           {formData.recomended_letter_num !== "null" ? null : (
//             <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "15px" }}>
//               <div>OR</div>
//               <AddTrackRecordDetails projectId={project} letterfor={formData.workperformedby} lettertype="billing" getProjects={getLetters} title="Recomended Letter Details" contractor={contractor} site_prcode={site_prcode} projectName={projectName} />
//             </div>
//           )}
//         </div>
//         <div className="form-field">
//           <label><Paperclip size={14} /> HO Attachment</label>
//           <input type="file" name="ho_attachment" onChange={handleFileChange} className={`form-input-date ${errors.ho_attachment ? "is-invalid" : ""}`} style={{ width: "15vw" }} />
//           {errors.ho_attachment && <div className="error-message">{errors.ho_attachment}</div>}
//         </div>
//       </div>

//       <div className="section-navigation-buttons dual-buttons">
//         <div className="nav-buttons-wrapper">
//           <button type="button" className="btn-prev" onClick={goToPreviousTab}>
//             <ChevronRight size={16} className="rotate-left" /> Previous: Contractor Billing Details
//           </button>
//           <button type="button" className="btn-next" onClick={goToNextTab}>
//             Next: Client Details <ChevronRight size={16} />
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   const renderClientDetails = () => (
//     <div className="form-section">
//       <div className="section-title">
//         <Award size={18} />
//         <h4>Client Bill Details</h4>
//       </div>
//       <div className="form-grid">
//         <div className="form-field">
//           <label><Calendar size={14} /> Client Recomended Bill Date</label>
//           <input type="date" name="site_recomended_bill_date" max={new Date().toISOString().split('T')[0]} value={formData.site_recomended_bill_date} onChange={handleDateChange} min={formData.submitted_bill_date} className={`form-input-date ${errors.site_recomended_bill_date ? "is-invalid" : ""}`} />
//           {errors.site_recomended_bill_date && <div className="error-message">{errors.site_recomended_bill_date}</div>}
//         </div>
//       </div>

//       <div className="form-grid">
//         <div className="form-field">
//           <label><IndianRupee size={14} /> Client Work Done Amount</label>
//           <input type="number" name="site_work_done_amt" placeholder="Work Done Amount" value={formData.site_work_done_amt} onChange={handleInputChange} className={`form-input-date ${errors.site_work_done_amt ? "is-invalid" : ""}`} />
//           {errors.site_work_done_amt && <div className="error-message">{errors.site_work_done_amt}</div>}
//         </div>
//         <div className="form-field">
//           <label><TrendingUp size={14} /> Client Escalation Amount</label>
//           <input type="number" name="site_escalation" max={formData.escalation} placeholder="Client Escalation Amount" value={formData.site_escalation} onChange={handleInputChange} className={`form-input-date ${errors.site_escalation ? "is-invalid" : ""}`} />
//           {errors.site_escalation && <div className="error-message">{errors.site_escalation}</div>}
//         </div>
//         <div className="form-field">
//           <label><Percent size={14} /> Client GST Amount <span className="required">(Read-Only)</span></label>
//           <input type="number" disabled name="site_gst" value={formData.site_gst} className="readonly-field" />
//           {errors.site_gst && <div className="error-message">{errors.site_gst}</div>}
//         </div>
//         <div className="form-field">
//           <label><IndianRupee size={14} /> Client Release Withheld Amount</label>
//           <input type="number" min={0} name="site_released_withheld_amt" placeholder="0" value={formData.site_released_withheld_amt} onChange={handleInputChange} className={`form-input-date ${errors.site_released_withheld_amt ? "is-invalid" : ""}`} />
//           {errors.site_released_withheld_amt && <div className="error-message">{errors.site_released_withheld_amt}</div>}
//         </div>
//       </div>

//       <div className="dynamic-fields-section">
//         <div className="section-subtitle">
//           <PlusCircle size={14} />
//           <span>Client Additional Allowances</span>
//           <button type="button" className="add-dynamic-btn" onClick={handleAddSiteWitheheldRelease}><Plus size={14} /> Add Allowance</button>
//         </div>
//         {SiteWithheldRelease.map((data, index) => (
//           <div className="dynamic-field-row" key={index}>
//             <div className="form-field"><label>Client Heading</label><input type="text" name="site_released_heading" value={data.site_released_heading} onChange={(e) => handleSiteWithheldInputChange(e, index)} placeholder="Enter Heading" style={{ width: "30vw" }} className="form-input" /></div>
//             <div className="form-field"><label>Client Amount</label><input type="number" min={0} name="site_released_amount" value={data.site_released_amount} onChange={(e) => handleSiteWithheldInputChange(e, index)} placeholder="Enter Amount" style={{ width: "20vw" }} className="form-input" /></div>
//             <button type="button" className="remove-dynamic-btn" onClick={() => handleRemoveSiteWithheldRelease(index)}><X size={14} /></button>
//           </div>
//         ))}
//       </div>

//       <div className="form-grid">
//         <div className="form-field">
//           <label><MinusCircle size={14} /> Client Deduction Amount</label>
//           <input type="number" name="site_deduction_amount" placeholder="Client Deduction Amount" value={formData.site_deduction_amount} onChange={handleInputChange} className={`form-input ${errors.site_deduction_amount ? "is-invalid" : ""}`} style={{ width: "30vw" }} />
//           {errors.site_deduction_amount && <div className="error-message">{errors.site_deduction_amount}</div>}
//         </div>
//         <div className="form-field">
//           <label><MinusCircle size={14} /> Client Withheld Amount</label>
//           <input type="number" min={0} name="site_withheld_amt" placeholder="0" value={formData.site_withheld_amt} onChange={handleInputChange} style={{ width: "20vw" }} className={`form-input ${errors.site_withheld_amt ? "is-invalid" : ""}`} />
//           {errors.site_withheld_amt && <div className="error-message">{errors.site_withheld_amt}</div>}
//         </div>
//       </div>

//       <div className="dynamic-fields-section">
//         <div className="section-subtitle">
//           <MinusCircle size={14} />
//           <span>Client Additional Deductions</span>
//           <button type="button" className="add-dynamic-btn" onClick={handleAddSiteDeductionAmount}><Plus size={14} /> Add Deduction</button>
//         </div>
//         {SiteDeductionData.map((data, index) => (
//           <div className="dynamic-field-row" key={index}>
//             <div className="form-field"><label>Client Heading</label><input type="text" style={{ width: "30vw" }} name="site_deduction_heading" value={data.site_deduction_heading} onChange={(e) => handleSiteDeductionInputChange(e, index)} placeholder="Enter Heading" className="form-input" /></div>
//             <div className="form-field"><label>Client Amount</label><input type="number" min={0} name="site_deduction_amount" style={{ width: "20vw" }} value={data.site_deduction_amount} onChange={(e) => handleSiteDeductionInputChange(e, index)} placeholder="Enter Amount" className="form-input" /></div>
//             <button type="button" className="remove-dynamic-btn" onClick={() => handleRemoveSiteDeduction(index)}><X size={14} /></button>
//           </div>
//         ))}
//       </div>

//       <div className="form-grid">
//         <div className="form-field">
//           <label>Client Approve Bill Amount<span className="required">(Read-Only)</span></label>
//           <input type="number" disabled name="site_recommended_bill_amount" value={formData.site_recommended_bill_amount} className="readonly-field" style={{ width: "15vw" }} />
//           {errors.site_recommended_bill_amount && <div className="error-message">{errors.site_recommended_bill_amount}</div>}
//         </div>
//         <div className="form-field">
//           <label>Client Approve Percentage<span className="required">(Read-Only)</span></label>
//           <input type="number" name="site_recommended_percentage" value={formData.site_recommended_percentage} onChange={handleInputChange} className="readonly-field" style={{ width: "15vw" }} />
//           {errors.site_recommended_percentage && <div className="error-message">{errors.site_recommended_percentage}</div>}
//         </div>
//         <div className="form-field">
//           <label>Client Approve Percentage Amount</label>
//           <input type="number" name="site_percentage_amt" placeholder="0" value={formData.site_percentage_amt} onChange={handleInputChange} className={`form-input-date ${errors.site_percentage_amt ? "is-invalid" : ""}`} style={{ width: "15vw" }} />
//           {errors.site_percentage_amt && <div className="error-message">{errors.site_percentage_amt}</div>}
//         </div>
//         <div className="form-field full-width">
//           <label><MessageSquare size={14} /> Client Remark</label>
//           <textarea name="site_remark" placeholder="Client Remark" rows={3} value={formData.site_remark} onChange={handleInputChange} style={{ width: "35vw" }} className={`form-input-date ${errors.site_remark ? "is-invalid" : ""}`} />
//           {errors.site_remark && <div className="error-message">{errors.site_remark}</div>}
//         </div>
//         <div className="form-field">
//           <label><Paperclip size={14} /> Client Attachment</label>
//           <input type="file" name="ho_attachment" onChange={handleFileChange} style={{ width: "15vw" }} className={`form-input-date ${errors.ho_attachment ? "is-invalid" : ""}`} />
//           {errors.ho_attachment && <div className="error-message">{errors.ho_attachment}</div>}
//         </div>
//       </div>

//       <div className="section-navigation-buttons dual-buttons">
//         <div className="nav-buttons-wrapper">
//           <button type="button" className="btn-prev" onClick={goToPreviousTab}>
//             <ChevronRight size={16} className="rotate-left" /> Previous: AE/IE Details
//           </button>
//         </div>
//       </div>

//       <div className="form-actions">
//         <div className="submit-buttons">
//           <button type="button" className="btn-secondaryy" onClick={handleClose}>Cancel</button>
//           <button type="submit" className="btn-primaryy" disabled={loading}>
//             {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
//             <span>{loading ? "Adding..." : "Add Bill"}</span>
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   const renderCurrentSection = () => {
//     switch (activeSection) {
//       case 'basic': return renderBasicInfo();
//       case 'contractor': return renderContractorBillingDetails();
//       case 'ae': return renderAeDetails();
//       case 'client': return renderClientDetails();
//       default: return renderBasicInfo();
//     }
//   };

//   return (
//     <>
//       <button title="Add Bill" className="btn-animated" onClick={handleShow}>
//         <div className="btn-content">
//           <Plus size={16} />
//           <span>Add Bill</span>
//         </div>
//         <div className="btn-ripple"></div>
//       </button>

//       <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
//         <Modal.Header className="modern-modal-header">
//           <div className="header-content">
//             <div className="header-icon" style={{ background: "transparent", color: "white" }}>
//               <IndianRupee size={24} />
//             </div>
//             <div>
//               <Modal.Title>Add Billing Details</Modal.Title>
//               <p className="header-subtitle">Fill in the details to add a new bill for {projectName}</p>
//             </div>
//           </div>
//           <button className="close-btn" onClick={handleClose}>
//             <X size={20} />
//           </button>
//         </Modal.Header>

//         <Modal.Body className="modern-modal-body">
//           <div className="section-navigation">
//             {sections.map((section) => {
//               const Icon = section.icon;
//               const hasMissingRequiredFields = () => {
//                 const requiredFields = tabRequiredFields[section.id] || [];
//                 return requiredFields.some(field => !formData[field]);
//               };

//               return (
//                 <button
//                   key={section.id}
//                   className={`section-nav-btn ${activeSection === section.id ? 'active' : ''} ${hasMissingRequiredFields() && section.id !== activeSection ? 'has-warning' : ''}`}
//                   onClick={() => {
//                     if (activeSection !== section.id) {
//                       if (validateCurrentTab()) {
//                         setActiveSection(section.id);
//                         setErrors({});
//                       } else {
//                         const formContainer = document.querySelector('.modern-modal-body');
//                         if (formContainer) {
//                           formContainer.scrollTop = 0;
//                         }
//                       }
//                     }
//                   }}
//                 >
//                   <Icon size={16} />
//                   <span>{section.label}</span>
//                   {hasMissingRequiredFields() && section.id !== activeSection && (
//                     <div className="warning-dot" title="Missing required fields" />
//                   )}
//                   {activeSection === section.id && <ChevronRight size={14} className="nav-arrow" />}
//                 </button>
//               );
//             })}
//           </div>

//           <form onSubmit={handleFormSubmit} className="project-form">
//             {renderCurrentSection()}
//           </form>
//         </Modal.Body>
//       </Modal>

//       <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} />
//     </>
//   );
// };
const ViewAmountModel = ({ i, usedFor, usedIn, bills, ModuleName, modernCSS }) => {
  const [deductionData, setDeductionData] = useState([]);
  const [billAmountData, setBillAmountData] = useState({});
  const tableRef = useRef(null);

  const [show, setShow] = useState(false);
  const [letterData, setLetterData] = useState({});

  const handleClose = () => {
    setShow(false);
  }

  const handleShow = () => {
    setShow(true);
  };

  const getData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/deductionsfilter/null/${i.id}/`);
      setDeductionData(res.data);
    } catch (error) {
      console.error(error);

    }
  }
  const getBillingData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/billingdetailfield/${i.id}/`);
      setBillAmountData(res.data);
    } catch (error) {
      console.error(error);

    }
  }
  useEffect(() => {
    getData();
    getBillingData();

  }, []);
  function totalAmount(dataArray, fieldName) {
    if (!Array.isArray(dataArray)) return 0;

    return dataArray.reduce((sum, item) => {
      const value = item[fieldName];
      return value ? sum + Number(value) : sum;
    }, 0);
  }

  console.log(usedFor)




  return (
    <>
      {ModuleName !== "Billing Details" ?
        <>

          <button
            onClick={handleShow}
            className={modernCSS === "true" ? "modern-button" : ""}
            style={{
              // marginBottom: "10px",
              height: usedIn === "table" ? "20px" : usedIn === "nestedTable" ? "0px" : "30px",
              width: usedIn === "table" ? "3vw" : usedIn === "nestedTable" ? "0vw" : "5vw",
              borderRadius: usedIn === "table" ? "6px" : "10px",
              fontSize: usedIn === "nestedTable" ? "12px" : "14px"

            }}
          >
            <span className="view-text" style={{ fontSize: modernCSS === "true" && "12px" }} >View</span>
          </button>
          <Modal show={show} onHide={handleClose} dialogClassName="custom-modal">
            <Modal.Header closeButton>
              <Modal.Title>
                View Amount Details
              </Modal.Title>
            </Modal.Header>

            <Modal.Body>

              <>
                <div className='table-box scroll-container-table' >

                  <table ref={tableRef} className="nested-table-lightblue  payment" style={{ margin: "0px", width: "99%" }}>
                    <thead className="table-heading" style={{ paddingTop: "20px" }}>
                      <tr className=''>
                        <th className=''>S.no.</th>
                        <th className=''>Heading Name</th>
                        <th className='text-end'>Amount</th>
                      </tr>

                    </thead>
                    <tbody>
                      {(() => {
                        let serialNo = 1;

                        const rows = [];


                        rows.push(
                          <tr key="heading-allowance">
                            <td className="font-weight700" colSpan={3}>Allowance</td>
                          </tr>
                        );


                        rows.push(
                          <tr key="row-work-done">
                            <td>{serialNo++}</td>
                            <td>Work Done Amount</td>
                            <td className='text-end'>₹
                              {
                                usedFor === "ContractorBilling"
                                  ? Number(billAmountData.work_done_amt || 0).toFixed(0)
                                  : usedFor === "SiteBilling"
                                    ? Number(billAmountData.site_work_done_amt || 0).toFixed(0)
                                    : usedFor === "HO"
                                      ? Number(billAmountData.ho_work_done_amt || 0).toFixed(0)
                                      : ""
                              }
                            </td>
                          </tr>
                        );



                        rows.push(
                          <tr key="row-escalation">
                            <td>{serialNo++}</td>
                            <td>Escalation Amount</td>
                            <td className='text-end'>₹
                              {
                                usedFor === "ContractorBilling"
                                  ? Number(billAmountData.escalation || 0).toFixed(0)
                                  : usedFor === "SiteBilling"
                                    ? Number(billAmountData.site_escalation || 0).toFixed(0)
                                    : usedFor === "HO"
                                      ? Number(billAmountData.ho_escalation || 0).toFixed(0)
                                      : ""
                              }
                            </td>
                          </tr>
                        );

                        rows.push(
                          <tr key="row-gst">
                            <td>{serialNo++}</td>
                            <td>GST Amount</td>
                            <td className='text-end'>₹
                              {
                                usedFor === "ContractorBilling"
                                  ? Number(billAmountData.gst || 0).toFixed(0)
                                  : usedFor === "SiteBilling"
                                    ? Number(billAmountData.site_gst || 0).toFixed(0)
                                    : usedFor === "HO"
                                      ? Number(billAmountData.ho_gst || 0).toFixed(0)
                                      : ""
                              }
                            </td>
                          </tr>
                        );

                        rows.push(
                          <tr key="row-withheld-release">
                            <td>{serialNo++}</td>
                            <td>Withheld Release</td>
                            <td className='text-end'>₹
                              {
                                usedFor === "ContractorBilling"
                                  ? Number(billAmountData.contractor_withheld_release || 0).toFixed(0)
                                  : usedFor === "SiteBilling"
                                    ? Number(billAmountData.site_released_withheld_amt || 0).toFixed(0)
                                    : usedFor === "HO"
                                      ? Number(billAmountData.released_withheld_amt || 0).toFixed(0)
                                      : ""
                              }
                            </td>
                          </tr>
                        );


                        deductionData.forEach((ded, idx) => {
                          if (usedFor === "ContractorBilling") {
                            if (ded.contractor_releasing_heading && ded.contractor_releasing_amount) {
                              rows.push(
                                <tr key={`release-${idx}`}>
                                  <td>{serialNo++}</td>
                                  <td>{ded.contractor_releasing_heading}</td>
                                  <td className='text-end'>₹{ded.contractor_releasing_amount}</td>
                                </tr>
                              );
                            }
                          }
                          if (usedFor === "SiteBilling") {
                            if (ded.site_released_heading && ded.site_released_amount) {
                              rows.push(
                                <tr key={`release-${idx}`}>
                                  <td>{serialNo++}</td>
                                  <td>{ded.site_released_heading}</td>
                                  <td className='text-end'>₹{ded.site_released_amount}</td>
                                </tr>
                              );
                            }
                          }
                          if (usedFor === "HO") {
                            if (ded.HO_released_heading && ded.HO_released_amount) {
                              rows.push(
                                <tr key={`release-${idx}`}>
                                  <td>{serialNo++}</td>
                                  <td>{ded.HO_released_heading}</td>
                                  <td className='text-end'>₹{ded.HO_released_amount}</td>
                                </tr>
                              );
                            }
                          }
                        });

                        rows.push(
                          <tr key="total-a">
                            <td colSpan={2} className="font-weight700">Total (A)</td>
                            <td className="font-weight700 text-end">
                              ₹{
                                (
                                  (usedFor === "ContractorBilling"
                                    ? Number(billAmountData.contractor_withheld_release || 0)
                                    : usedFor === "SiteBilling"
                                      ? Number(billAmountData.site_released_withheld_amt || 0)
                                      : usedFor === "HO"
                                        ? Number(billAmountData.released_withheld_amt || 0)
                                        : 0)
                                  +
                                  (usedFor === "ContractorBilling"
                                    ? Number(billAmountData.gst || 0)
                                    : usedFor === "SiteBilling"
                                      ? Number(billAmountData.site_gst || 0)
                                      : usedFor === "HO"
                                        ? Number(billAmountData.ho_gst || 0)
                                        : 0)
                                  +
                                  (usedFor === "ContractorBilling"
                                    ? Number(billAmountData.work_done_amt || 0)
                                    : usedFor === "SiteBilling"
                                      ? Number(billAmountData.site_work_done_amt || 0)
                                      : usedFor === "HO"
                                        ? Number(billAmountData.ho_work_done_amt || 0)
                                        : 0)
                                  +
                                  (usedFor === "ContractorBilling"
                                    ? Number(billAmountData.escalation || 0)
                                    : usedFor === "SiteBilling"
                                      ? Number(billAmountData.site_escalation || 0)
                                      : usedFor === "HO"
                                        ? Number(billAmountData.ho_escalation || 0)
                                        : 0)
                                  +
                                  totalAmount(
                                    deductionData,
                                    usedFor === "ContractorBilling"
                                      ? "contractor_releasing_amount"
                                      : usedFor === "SiteBilling"
                                        ? "site_released_amount"
                                        : usedFor === "HO"
                                          ? "HO_released_amount"
                                          : ""
                                  )
                                ).toFixed(0)
                              }
                            </td>

                          </tr>
                        )



                        rows.push(
                          <tr key="heading-deduction">
                            <td className="font-weight700" colSpan={3}>Deductions</td>
                          </tr>
                        );

                        rows.push(
                          <tr key="withheld">
                            <td>{serialNo++}</td>
                            <td>Withheld Amount</td>
                            <td className='text-end'>₹
                              {
                                usedFor === "ContractorBilling"
                                  ? Number(billAmountData.contractor_withheld || 0).toFixed(0)
                                  : usedFor === "SiteBilling"
                                    ? Number(billAmountData.site_withheld_amt || 0).toFixed(0)
                                    : usedFor === "HO"
                                      ? Number(billAmountData.withheld_amt || 0).toFixed(0)
                                      : ""
                              }
                            </td>
                          </tr>
                        );

                        rows.push(
                          <tr key="contractor-deduction">
                            <td>{serialNo++}</td>
                            <td>Contractor Deduction</td>
                            <td className='text-end'>₹
                              {
                                usedFor === "ContractorBilling"
                                  ? Number(billAmountData.contractor_deduction_amt || 0).toFixed(0)
                                  : usedFor === "SiteBilling"
                                    ? Number(billAmountData.site_deduction_amount || 0).toFixed(0)
                                    : usedFor === "HO"
                                      ? Number(billAmountData.deduction_amount || 0).toFixed(0)
                                      : ""
                              }
                            </td>
                          </tr>
                        );



                        deductionData.forEach((ded, idx) => {
                          if (usedFor === "ContractorBilling") {
                            if (ded.contractor_deduction_heading && ded.contractor_deduction_amount) {
                              rows.push(
                                <tr key={`release-${idx}`}>
                                  <td>{serialNo++}</td>
                                  <td>{ded.contractor_deduction_heading}</td>
                                  <td className='text-end'>₹{ded.contractor_deduction_amount}</td>
                                </tr>
                              );
                            }
                          }
                          if (usedFor === "SiteBilling") {
                            if (ded.site_deduction_heading && ded.site_deduction_amount) {
                              rows.push(
                                <tr key={`release-${idx}`}>
                                  <td>{serialNo++}</td>
                                  <td>{ded.site_deduction_heading}</td>
                                  <td className='text-end'>₹{ded.site_deduction_amount}</td>
                                </tr>
                              );
                            }
                          }
                          if (usedFor === "HO") {
                            if (ded.HO_deduction_heading && ded.HO_deduction_amount) {
                              rows.push(
                                <tr key={`release-${idx}`}>
                                  <td>{serialNo++}</td>
                                  <td>{ded.HO_deduction_heading}</td>
                                  <td className='text-end'>₹{ded.HO_deduction_amount}</td>
                                </tr>
                              );
                            }
                          }
                        });


                        rows.push(
                          <tr key="total-b">
                            <td className="font-weight700" colSpan={2}>Total (B)</td>
                            <td className="font-weight700 text-end">
                              ₹{
                                (
                                  (usedFor === "ContractorBilling"
                                    ? Number(billAmountData.contractor_deduction_amt || 0)
                                    : usedFor === "SiteBilling"
                                      ? Number(billAmountData.site_deduction_amount || 0)
                                      : usedFor === "HO"
                                        ? Number(billAmountData.deduction_amount || 0)
                                        : 0)
                                  +
                                  (usedFor === "ContractorBilling"
                                    ? Number(billAmountData.contractor_withheld || 0)
                                    : usedFor === "SiteBilling"
                                      ? Number(billAmountData.site_withheld_amt || 0)
                                      : usedFor === "HO"
                                        ? Number(billAmountData.withheld_amt || 0)
                                        : 0)
                                  +
                                  totalAmount(
                                    deductionData,
                                    usedFor === "ContractorBilling"
                                      ? "contractor_deduction_amount"
                                      : usedFor === "SiteBilling"
                                        ? "site_deduction_amount"
                                        : usedFor === "HO"
                                          ? "HO_deduction_amount"
                                          : ""
                                  )
                                ).toFixed(0)
                              }
                            </td>
                          </tr>
                        );


                        rows.push(
                          <tr key="heading-deduction">
                            <td className="font-weight700" colSpan={3}>Final Amount </td>
                          </tr>
                        );

                        rows.push(
                          <tr key="final-amount">
                            <td className="font-weight700" colSpan={2}>Total Amount (A)-(B)</td>
                            <td className='font-weight700 text-end'>₹
                              {
                                usedFor === "ContractorBilling"
                                  ? Number(billAmountData.submitted_bill_amount || 0).toFixed(0)
                                  : usedFor === "SiteBilling"
                                    ? Number(billAmountData.site_recommended_bill_amount || 0).toFixed(0)
                                    : usedFor === "HO"
                                      ? Number(billAmountData.recommended_bill_amount || 0).toFixed(0)
                                      : ""
                              }
                            </td>
                          </tr>
                        );

                        rows.push(
                          <tr key="submitted-percent">
                            <td className="font-weight700" colSpan={2}>Submitted Percentage</td>
                            <td className='font-weight700 text-end'>
                              {
                                usedFor === "ContractorBilling"
                                  ? `${Number(billAmountData.submitted_percentage || 0)}%`
                                  : usedFor === "SiteBilling"
                                    ? `${Number(billAmountData.site_recommended_percentage || 0)}%`
                                    : usedFor === "HO"
                                      ? `${Number(billAmountData.recommended_percentage || 0)}%`
                                      : ""
                              }
                            </td>
                          </tr>
                        );

                        rows.push(
                          <tr key="percent-amount">
                            <td className="font-weight700" colSpan={2}>Percentage Amount</td>
                            <td className='font-weight700 text-end'>₹
                              {
                                usedFor === "ContractorBilling"
                                  ? Number(billAmountData.percentage_amt || 0).toFixed(0)
                                  : usedFor === "SiteBilling"
                                    ? Number(billAmountData.site_percentage_amt || 0).toFixed(0)
                                    : usedFor === "HO"
                                      ? Number(billAmountData.ho_percentage_amt || 0).toFixed(0)
                                      : ""
                              }
                            </td>
                          </tr>
                        );


                        return rows;
                      })()}
                    </tbody>



                  </table>


                </div>
              </>
            </Modal.Body>
          </Modal >
        </> : <>
          <div className='' >

            <table ref={tableRef} className="nested-table-lightblue  payment" style={{ margin: "0px", width: "99%" }}>
              <thead className="table-heading" style={{ paddingTop: "20px" }}>
                <tr className=''>
                  <th className=''>S.no.</th>
                  <th className=''>Heading Name</th>
                  <th className='text-end'>Amount</th>
                </tr>

              </thead>
              <tbody>
                {(() => {
                  let serialNo = 1;

                  const rows = [];


                  rows.push(
                    <tr key="heading-allowance">
                      <td className="font-weight700" colSpan={3}>Allowance</td>
                    </tr>
                  );


                  rows.push(
                    <tr key="row-work-done">
                      <td>{serialNo++}</td>
                      <td>Work Done Amount</td>
                      <td className='text-end'>₹
                        {
                          usedFor === "ContractorBilling"
                            ? Number(billAmountData.work_done_amt || 0).toFixed(0)
                            : usedFor === "SiteBilling"
                              ? Number(billAmountData.site_work_done_amt || 0).toFixed(0)
                              : usedFor === "HO"
                                ? Number(billAmountData.ho_work_done_amt || 0).toFixed(0)
                                : ""
                        }
                      </td>
                    </tr>
                  );



                  rows.push(
                    <tr key="row-escalation">
                      <td>{serialNo++}</td>
                      <td>Escalation Amount</td>
                      <td className='text-end'>₹
                        {
                          usedFor === "ContractorBilling"
                            ? Number(billAmountData.escalation || 0).toFixed(0)
                            : usedFor === "SiteBilling"
                              ? Number(billAmountData.site_escalation || 0).toFixed(0)
                              : usedFor === "HO"
                                ? Number(billAmountData.ho_escalation || 0).toFixed(0)
                                : ""
                        }
                      </td>
                    </tr>
                  );

                  rows.push(
                    <tr key="row-gst">
                      <td>{serialNo++}</td>
                      <td>GST Amount</td>
                      <td className='text-end'>₹
                        {
                          usedFor === "ContractorBilling"
                            ? Number(billAmountData.gst || 0).toFixed(0)
                            : usedFor === "SiteBilling"
                              ? Number(billAmountData.site_gst || 0).toFixed(0)
                              : usedFor === "HO"
                                ? Number(billAmountData.ho_gst || 0).toFixed(0)
                                : ""
                        }
                      </td>
                    </tr>
                  );

                  rows.push(
                    <tr key="row-withheld-release">
                      <td>{serialNo++}</td>
                      <td>Withheld Release</td>
                      <td className='text-end'>₹
                        {
                          usedFor === "ContractorBilling"
                            ? Number(billAmountData.contractor_withheld_release || 0).toFixed(0)
                            : usedFor === "SiteBilling"
                              ? Number(billAmountData.site_released_withheld_amt || 0).toFixed(0)
                              : usedFor === "HO"
                                ? Number(billAmountData.released_withheld_amt || 0).toFixed(0)
                                : ""
                        }
                      </td>
                    </tr>
                  );


                  deductionData.forEach((ded, idx) => {
                    if (usedFor === "ContractorBilling") {
                      if (ded.contractor_releasing_heading && ded.contractor_releasing_amount) {
                        rows.push(
                          <tr key={`release-${idx}`}>
                            <td>{serialNo++}</td>
                            <td>{ded.contractor_releasing_heading}</td>
                            <td className='text-end'>₹{ded.contractor_releasing_amount}</td>
                          </tr>
                        );
                      }
                    }
                    if (usedFor === "SiteBilling") {
                      if (ded.site_released_heading && ded.site_released_amount) {
                        rows.push(
                          <tr key={`release-${idx}`}>
                            <td>{serialNo++}</td>
                            <td>{ded.site_released_heading}</td>
                            <td className='text-end'>₹{ded.site_released_amount}</td>
                          </tr>
                        );
                      }
                    }
                    if (usedFor === "HO") {
                      if (ded.HO_released_heading && ded.HO_released_amount) {
                        rows.push(
                          <tr key={`release-${idx}`}>
                            <td>{serialNo++}</td>
                            <td>{ded.HO_released_heading}</td>
                            <td className='text-end'>₹{ded.HO_released_amount}</td>
                          </tr>
                        );
                      }
                    }
                  });

                  rows.push(
                    <tr key="total-a">
                      <td colSpan={2} className="font-weight700">Total (A)</td>
                      <td className="font-weight700 text-end">
                        ₹{
                          (
                            (usedFor === "ContractorBilling"
                              ? Number(billAmountData.contractor_withheld_release || 0)
                              : usedFor === "SiteBilling"
                                ? Number(billAmountData.site_released_withheld_amt || 0)
                                : usedFor === "HO"
                                  ? Number(billAmountData.released_withheld_amt || 0)
                                  : 0)
                            +
                            (usedFor === "ContractorBilling"
                              ? Number(billAmountData.gst || 0)
                              : usedFor === "SiteBilling"
                                ? Number(billAmountData.site_gst || 0)
                                : usedFor === "HO"
                                  ? Number(billAmountData.ho_gst || 0)
                                  : 0)
                            +
                            (usedFor === "ContractorBilling"
                              ? Number(billAmountData.work_done_amt || 0)
                              : usedFor === "SiteBilling"
                                ? Number(billAmountData.site_work_done_amt || 0)
                                : usedFor === "HO"
                                  ? Number(billAmountData.ho_work_done_amt || 0)
                                  : 0)
                            +
                            (usedFor === "ContractorBilling"
                              ? Number(billAmountData.escalation || 0)
                              : usedFor === "SiteBilling"
                                ? Number(billAmountData.site_escalation || 0)
                                : usedFor === "HO"
                                  ? Number(billAmountData.ho_escalation || 0)
                                  : 0)
                            +
                            totalAmount(
                              deductionData,
                              usedFor === "ContractorBilling"
                                ? "contractor_releasing_amount"
                                : usedFor === "SiteBilling"
                                  ? "site_released_amount"
                                  : usedFor === "HO"
                                    ? "HO_released_amount"
                                    : ""
                            )
                          ).toFixed(0)
                        }
                      </td>

                    </tr>
                  )



                  rows.push(
                    <tr key="heading-deduction">
                      <td className="font-weight700" colSpan={3}>Deductions</td>
                    </tr>
                  );

                  rows.push(
                    <tr key="withheld">
                      <td>{serialNo++}</td>
                      <td>Withheld Amount</td>
                      <td className='text-end'>₹
                        {
                          usedFor === "ContractorBilling"
                            ? Number(billAmountData.contractor_withheld || 0).toFixed(0)
                            : usedFor === "SiteBilling"
                              ? Number(billAmountData.site_withheld_amt || 0).toFixed(0)
                              : usedFor === "HO"
                                ? Number(billAmountData.withheld_amt || 0).toFixed(0)
                                : ""
                        }
                      </td>
                    </tr>
                  );

                  rows.push(
                    <tr key="contractor-deduction">
                      <td>{serialNo++}</td>
                      <td>Contractor Deduction</td>
                      <td className='text-end'>₹
                        {
                          usedFor === "ContractorBilling"
                            ? Number(billAmountData.contractor_deduction_amt || 0).toFixed(0)
                            : usedFor === "SiteBilling"
                              ? Number(billAmountData.site_deduction_amount || 0).toFixed(0)
                              : usedFor === "HO"
                                ? Number(billAmountData.deduction_amount || 0).toFixed(0)
                                : ""
                        }
                      </td>
                    </tr>
                  );



                  deductionData.forEach((ded, idx) => {
                    if (usedFor === "ContractorBilling") {
                      if (ded.contractor_deduction_heading && ded.contractor_deduction_amount) {
                        rows.push(
                          <tr key={`release-${idx}`}>
                            <td>{serialNo++}</td>
                            <td>{ded.contractor_deduction_heading}</td>
                            <td className='text-end'>₹{ded.contractor_deduction_amount}</td>
                          </tr>
                        );
                      }
                    }
                    if (usedFor === "SiteBilling") {
                      if (ded.site_deduction_heading && ded.site_deduction_amount) {
                        rows.push(
                          <tr key={`release-${idx}`}>
                            <td>{serialNo++}</td>
                            <td>{ded.site_deduction_heading}</td>
                            <td className='text-end'>₹{ded.site_deduction_amount}</td>
                          </tr>
                        );
                      }
                    }
                    if (usedFor === "HO") {
                      if (ded.HO_deduction_heading && ded.HO_deduction_amount) {
                        rows.push(
                          <tr key={`release-${idx}`}>
                            <td>{serialNo++}</td>
                            <td>{ded.HO_deduction_heading}</td>
                            <td className='text-end'>₹{ded.HO_deduction_amount}</td>
                          </tr>
                        );
                      }
                    }
                  });


                  rows.push(
                    <tr key="total-b">
                      <td className="font-weight700" colSpan={2}>Total (B)</td>
                      <td className="font-weight700 text-end">
                        ₹{
                          (
                            (usedFor === "ContractorBilling"
                              ? Number(billAmountData.contractor_deduction_amt || 0)
                              : usedFor === "SiteBilling"
                                ? Number(billAmountData.site_deduction_amount || 0)
                                : usedFor === "HO"
                                  ? Number(billAmountData.deduction_amount || 0)
                                  : 0)
                            +
                            (usedFor === "ContractorBilling"
                              ? Number(billAmountData.contractor_withheld || 0)
                              : usedFor === "SiteBilling"
                                ? Number(billAmountData.site_withheld_amt || 0)
                                : usedFor === "HO"
                                  ? Number(billAmountData.withheld_amt || 0)
                                  : 0)
                            +
                            totalAmount(
                              deductionData,
                              usedFor === "ContractorBilling"
                                ? "contractor_deduction_amount"
                                : usedFor === "SiteBilling"
                                  ? "site_deduction_amount"
                                  : usedFor === "HO"
                                    ? "HO_deduction_amount"
                                    : ""
                            )
                          ).toFixed(0)
                        }
                      </td>
                    </tr>
                  );


                  rows.push(
                    <tr key="heading-deduction">
                      <td className="font-weight700" colSpan={3}>Final Amount </td>
                    </tr>
                  );

                  rows.push(
                    <tr key="final-amount">
                      <td className="font-weight700" colSpan={2}>Total Amount (A)-(B)</td>
                      <td className='font-weight700 text-end'>₹
                        {
                          usedFor === "ContractorBilling"
                            ? Number(billAmountData.submitted_bill_amount || 0).toFixed(0)
                            : usedFor === "SiteBilling"
                              ? Number(billAmountData.site_recommended_bill_amount || 0).toFixed(0)
                              : usedFor === "HO"
                                ? Number(billAmountData.recommended_bill_amount || 0).toFixed(0)
                                : ""
                        }
                      </td>
                    </tr>
                  );

                  rows.push(
                    <tr key="submitted-percent">
                      <td className="font-weight700" colSpan={2}>Submitted Percentage</td>
                      <td className='font-weight700 text-end'>
                        {
                          usedFor === "ContractorBilling"
                            ? `${Number(billAmountData.submitted_percentage || 0)}%`
                            : usedFor === "SiteBilling"
                              ? `${Number(billAmountData.site_recommended_percentage || 0)}%`
                              : usedFor === "HO"
                                ? `${Number(billAmountData.recommended_percentage || 0)}%`
                                : ""
                        }
                      </td>
                    </tr>
                  );

                  rows.push(
                    <tr key="percent-amount">
                      <td className="font-weight700" colSpan={2}>Percentage Amount</td>
                      <td className='font-weight700 text-end'>₹
                        {
                          usedFor === "ContractorBilling"
                            ? Number(billAmountData.percentage_amt || 0).toFixed(0)
                            : usedFor === "SiteBilling"
                              ? Number(billAmountData.site_percentage_amt || 0).toFixed(0)
                              : usedFor === "HO"
                                ? Number(billAmountData.ho_percentage_amt || 0).toFixed(0)
                                : ""
                        }
                      </td>
                    </tr>
                  );


                  return rows;
                })()}
              </tbody>



            </table>


          </div>
        </>
      }

    </>

  )
}

const UpdateBill = ({
  i,
  project,
  cosData,
  getProjects,
  contractor,
  getdeducitonData,
  deductionData
}) => {
  const [show, setShow] = useState(false);
  const handleShow = () => {
    setShow(true);
    getLetters();
    const filteredData = { ...i };
    delete filteredData.ho_attachment;
    delete filteredData.site_attachment;
    delete filteredData.previous_amount;
    delete filteredData.remaining_amount;
    delete filteredData.cummulative_amount;

    setFormData(filteredData);

  };






  const handleClose = () => {
    setShow(false);
    setContractorDeductionData([]);
    setContractorWithheldRelease([]);
    setSiteDeductionData([]);
    setSiteWithheldRelease([]);
    setHOWithheldRelease([]);
    setHODeductionData([]);
  };


  const [formData, setFormData] = useState({
    project: project ? project : "",
    date: null,
    bill_type: "",
    contractor_name: "",
    work_done_amt: "",
    bill_num: "",
    bill_period_start: null,
    bill_period_end: null,
    billing_date: null,
    bill_catagory: "",
    workperformedby: "contractor",
    site_percentage_amt: "",
    recommended_bill_amount: "",
    recommended_percentage: "",
    recomended_bill_date: null,
    ho_percentage_amt: "",
    submitted_bill_amount: "",
    submitted_bill_date: null,
    submitted_percentage: "",
    percentage_amt: "",
    submitted_letter_num: null,
    recomended_letter_num: null,
    deduction_amount: "",
    ld_amount: "",
    withheld_amt: "",
    released_withheld_amt: "",
    contractor_withheld: " 0",
    contractor_withheld_release: "0",
    remark: "",
    site_recomended_bill_date: null,
    site_recommended_bill_amount: "",
    site_recommended_percentage: "",
    site_ld_amount: "",
    site_withheld_amt: "",
    site_released_withheld_amt: "",
    site_deduction_amount: "",
    site_remark: "",
    site_attachment: "",
    ho_attachment: "",
    escalation: "",
    gst: "",
    site_escalation: "",
    site_gst: "",
    ho_escalation: "",
    ho_gst: "",
    contractor_deduction_amt: "",
    ho_work_done_amt: "",
    site_work_done_amt: "",
    contractor: contractor,
    cos: null,
    cos_amount: null,

  });






  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      contractor: contractor,
    }));
  }, [contractor]);

  const { deduction_amount, submitted_bill_amount, recommended_bill_amount, site_deduction_amount, site_recommended_bill_amount } = formData;



  const [trackRecordList, setTrackRecordList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const getLetters = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/letterrecordbyfilters/${project}/contractor/billing/`);
      // const res = await axios.get(

      //   `${BASE_URL}/siteproject/letterrecordbyfilters/${project}/${formData.workperformedby}/billing/`
      // );
      setTrackRecordList(res.data);
    } catch (err) {
      toast.error("Error fetching letters.");
    }
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "bill_type",
      "bill_num",
      "bill_period_start",
      "bill_period_end",
      "submitted_bill_date",
      "bill_catagory",
      "submitted_bill_amount",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };






  // **********************************Dynamic Deduction and Withheld functionality *****************************************//
  const fileInputRefs = useRef([]);

  const [ContractorWithheldRelease, setContractorWithheldRelease] = useState([]);
  const [ContractorDeductionData, setContractorDeductionData] = useState([]);
  const [SiteWithheldRelease, setSiteWithheldRelease] = useState([]);
  const [SiteDeductionData, setSiteDeductionData] = useState([]);
  const [HOWithheldRelease, setHOWithheldRelease] = useState([]);
  const [HODeductionData, setHODeductionData] = useState([]);
  const [ExistingContractorWithheldRelease, setExistingContractorWithheldRelease] = useState([
    {
      contractor_releasing_heading: "",
      contractor_releasing_amount: "",

    }]);
  const [ExistingContractorDeduction, setExistingContractorDeduction] = useState([
    {
      contractor_deduction_heading: "",
      contractor_deduction_amount: "",

    }]);
  const [ExistingSiteWithheldRelease, setExistingSiteWithheldRelease] = useState([
    {
      site_released_heading: "",
      site_released_amount: "",

    }]);
  const [ExistingSiteDeduction, setExistingSiteDeduction] = useState([
    {
      site_deduction_heading: "",
      site_deduction_amount: "",

    }]);
  const [ExistingHOWithheldRelease, setExistingHOWithheldRelease] = useState([
    {
      HO_released_heading: "",
      HO_released_amount: "",

    }]);
  const [ExistingHODeduction, setExistingHODeduction] = useState([
    {
      HO_deduction_heading: "",
      HO_deduction_amount: "",


    }]);
  const [totalContractorWithheldAmount, settotalContractorWithheldAmount] = useState("0");
  const [totalExistingContractorWithheldAmount, settotalExistingContractorWithheldAmount] = useState("0");
  const [totalContractorDeductionAmount, settotalContractorDeductionAmount] = useState("0");
  const [ExistingtotalContractorDeductionAmount, setExistingtotalContractorDeductionAmount] = useState("0");
  const [totalSiteWithehldAmounnt, settotalSiteWithehldAmounnt] = useState("0");
  const [totalExistingSiteWithehldAmounnt, settotalExistingSiteWithehldAmounnt] = useState("0");
  const [totalSiteDeductionAmount, settotalSiteDeductionAmount] = useState("0");
  const [totalExistingSiteDeductionAmount, settotalExistingSiteDeductionAmount] = useState("0");
  const [totalHOReleaseAmount, settotalHOReleaseAmount] = useState("0");
  const [totalExistingHOReleaseAmount, settotalExistingHOReleaseAmount] = useState("0");
  const [totalHODeductionAmount, settotalHODeductionAmount] = useState("0");
  const [totalExistingHODeductionAmount, settotalExistingHODeductionAmount] = useState("0");

  const billingID = i.id;

  console.log("billingID");
  console.log(billingID);


  const getData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/deductionsfilter/null/${i.id}/`);
      const data = res.data || [];

      // Filter each category based on the presence of its fields
      const contractorWithheld = data.filter(
        item => item.contractor_releasing_heading && item.contractor_releasing_amount != null
      );
      const contractorDeduction = data.filter(
        item => item.contractor_deduction_heading && item.contractor_deduction_amount != null
      );
      const siteWithheld = data.filter(
        item => item.site_released_heading && item.site_released_amount != null
      );
      const siteDeduction = data.filter(
        item => item.site_deduction_heading && item.site_deduction_amount != null
      );
      const hoWithheld = data.filter(
        item => item.HO_released_heading && item.HO_released_amount != null
      );
      const hoDeduction = data.filter(
        item => item.HO_deduction_heading && item.HO_deduction_amount != null
      );

      // Set states
      setExistingContractorWithheldRelease(contractorWithheld);
      setExistingContractorDeduction(contractorDeduction);
      setExistingSiteWithheldRelease(siteWithheld);
      setExistingSiteDeduction(siteDeduction);
      setExistingHOWithheldRelease(hoWithheld);
      setExistingHODeduction(hoDeduction);

      console.log("Filtered data set successfully");
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (show === true) {
      getData();
    }
  }, [show])


  const handleAddContractorWitheheldRelease = (e) => {
    e.preventDefault();
    setContractorWithheldRelease((prevFormData) => [
      ...prevFormData,
      {
        contractor_releasing_heading: "",
        contractor_releasing_amount: "0",
        billing: billingID,


      },
    ]);
  };
  const handleAddContractorDeduction = (e) => {
    e.preventDefault();
    setContractorDeductionData((prevFormData) => [
      ...prevFormData,
      {
        contractor_deduction_heading: "",
        contractor_deduction_amount: "0",
        billing: "",

      },
    ]);
  };
  const handleAddSiteWitheheldRelease = (e) => {
    e.preventDefault();
    setSiteWithheldRelease((prevFormData) => [
      ...prevFormData,
      {
        site_released_heading: "",
        site_released_amount: "0",
        billing: "",

      },
    ]);
  };
  const handleAddSiteDeductionAmount = (e) => {
    e.preventDefault();
    setSiteDeductionData((prevFormData) => [
      ...prevFormData,
      {
        site_deduction_heading: "",
        site_deduction_amount: "0",
        billing: "",

      },
    ]);
  };
  const handleAddHOWitheheldRelease = (e) => {
    e.preventDefault();
    setHOWithheldRelease((prevFormData) => [
      ...prevFormData,
      {
        HO_released_heading: "",
        HO_released_amount: "0",
        billing: "",

      },
    ]);
  };
  const handleAddHOdeduction = (e) => {
    e.preventDefault();
    setHODeductionData((prevFormData) => [
      ...prevFormData,
      {
        HO_deduction_heading: "",
        HO_deduction_amount: "0",
        billing: "",

      },
    ]);
  };


  const handleRemoveContractorWithheldRelease = (index) => {
    setContractorWithheldRelease((prevFormData) => {
      const updatedData = prevFormData.filter((_, i) => i !== index);
      return [...updatedData];
    });


    fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
  };
  const handleRemoveContractorDeduction = (index) => {
    setContractorDeductionData((prevFormData) => {
      const updatedData = prevFormData.filter((_, i) => i !== index);
      return [...updatedData];
    });


    fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
  };
  const handleRemoveSiteWithheldRelease = (index) => {
    setSiteWithheldRelease((prevFormData) => {
      const updatedData = prevFormData.filter((_, i) => i !== index);
      return [...updatedData];
    });


    fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
  };
  const handleRemoveSiteDeduction = (index) => {
    setSiteDeductionData((prevFormData) => {
      const updatedData = prevFormData.filter((_, i) => i !== index);
      return [...updatedData];
    });


    fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
  };
  const handleRemoveHOWitheld = (index) => {
    setHOWithheldRelease((prevFormData) => {
      const updatedData = prevFormData.filter((_, i) => i !== index);
      return [...updatedData];
    });


    fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
  };
  const handleRemoveHODeduction = (index) => {
    setHODeductionData((prevFormData) => {
      const updatedData = prevFormData.filter((_, i) => i !== index);
      return [...updatedData];
    });


    fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
  };

  const handleContractorWithheldInputChange = (e, index) => {
    const { name, value } = e.target;
    setContractorWithheldRelease((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };
  const handleExistingContractorWithheldInputChange = (e, index) => {
    const { name, value } = e.target;
    setExistingContractorWithheldRelease((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };
  const handleContractorDeductionInputChange = (e, index) => {
    const { name, value } = e.target;
    setContractorDeductionData((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };
  const handleExistingContractorDeductionInputChange = (e, index) => {
    const { name, value } = e.target;
    setExistingContractorDeduction((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };
  const handleSiteWithheldInputChange = (e, index) => {
    const { name, value } = e.target;
    setSiteWithheldRelease((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };
  const handleExistingSiteWithheldInputChange = (e, index) => {
    const { name, value } = e.target;
    setExistingSiteWithheldRelease((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };
  const handleSiteDeductionInputChange = (e, index) => {
    const { name, value } = e.target;
    setSiteDeductionData((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  }
  const handleExistingSiteDeductionInputChange = (e, index) => {
    const { name, value } = e.target;
    setExistingSiteDeduction((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };
  const handleHOWithheldInputChange = (e, index) => {
    const { name, value } = e.target;
    setHOWithheldRelease((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  }
  const handleExistingHOWithheldInputChange = (e, index) => {
    const { name, value } = e.target;
    setExistingHOWithheldRelease((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };
  const handleHODeductionInputChange = (e, index) => {
    const { name, value } = e.target;
    setHODeductionData((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };
  const handleExistingHODeductionInputChange = (e, index) => {
    const { name, value } = e.target;
    setExistingHODeduction((prevFormData) => {
      const newFields = [...prevFormData];
      newFields[index] = {
        ...newFields[index],
        [name]: value,
      };
      return newFields;
    });

    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") {
        delete newErrors[`${index}-${name}`];
      }
      return newErrors;
    });
  };


  useEffect(() => {
    const safeSum = (arr, key) => {
      if (!Array.isArray(arr)) return 0;
      return arr.reduce((acc, curr) => {
        const val = curr?.[key];
        return acc + (val !== undefined && val !== null ? parseFloat(val) || 0 : 0);
      }, 0);
    };

    const totalContractorWithheldRelease = safeSum(ContractorWithheldRelease, "contractor_releasing_amount");
    const totalExistingContractorWithheldRelease = safeSum(ExistingContractorWithheldRelease, "contractor_releasing_amount");
    const totalContractorDeduction = safeSum(ContractorDeductionData, "contractor_deduction_amount");
    const totalExistingContractorDeduction = safeSum(ExistingContractorDeduction, "contractor_deduction_amount");
    const totalSiteWithheldRelease = safeSum(SiteWithheldRelease, "site_released_amount");
    const totalExistingSiteWithheldRelease = safeSum(ExistingSiteWithheldRelease, "site_released_amount");
    const totalSiteDeductionData = safeSum(SiteDeductionData, "site_deduction_amount");
    const totalExistingSiteDeductionData = safeSum(ExistingSiteDeduction, "site_deduction_amount");
    const totalHOWithheldRelease = safeSum(HOWithheldRelease, "HO_released_amount");
    const totalExistingHOWithheldRelease = safeSum(ExistingHOWithheldRelease, "HO_released_amount");
    const totalHODeductionData = safeSum(HODeductionData, "HO_deduction_amount");
    const totalExistingHODeductionData = safeSum(ExistingHODeduction, "HO_deduction_amount");

    settotalContractorWithheldAmount(totalContractorWithheldRelease);
    settotalExistingContractorWithheldAmount(totalExistingContractorWithheldRelease);
    settotalContractorDeductionAmount(totalContractorDeduction);
    settotalSiteWithehldAmounnt(totalSiteWithheldRelease);
    settotalSiteDeductionAmount(totalSiteDeductionData);
    settotalHOReleaseAmount(totalHOWithheldRelease);
    settotalHODeductionAmount(totalHODeductionData);
    setExistingtotalContractorDeductionAmount(totalExistingContractorDeduction);
    settotalExistingSiteWithehldAmounnt(totalExistingSiteWithheldRelease);
    settotalExistingSiteDeductionAmount(totalExistingSiteDeductionData);
    settotalExistingHOReleaseAmount(totalExistingHOWithheldRelease);
    settotalExistingHODeductionAmount(totalExistingHODeductionData);
  }, [
    ContractorWithheldRelease,
    ContractorDeductionData,
    SiteWithheldRelease,
    SiteDeductionData,
    HOWithheldRelease,
    HODeductionData,
    ExistingContractorWithheldRelease,
    ExistingContractorDeduction,
    ExistingSiteWithheldRelease,
    ExistingSiteDeduction,
    ExistingHOWithheldRelease,
    ExistingHODeduction,
  ]);


  // *************************************End of Dynamic Deduction and Withheld functionality **********************************************//

  const [isError, setIsError] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => {
      let updatedFormData = { ...prevFormData, [name]: value };
      const errorsToSet = { ...errors };

      if (name === "bill_period_start") {
        const selectedDate = new Date(value);
        const todayDate = new Date();

        todayDate.setHours(0, 0, 0, 0);
        selectedDate.setHours(0, 0, 0, 0);

        if (selectedDate > todayDate) {
          errorsToSet[name] = "Date cannot be greater than today.";
        } else {
          delete errorsToSet[name];
        }
      }

      if (name === "recommended_bill_amount" || name === "deduction_amount") {
        const maxLimit = prevFormData.submitted_bill_amount;

        const { success, error } = inputMaxLimit(name, value, maxLimit);

        if (!success) {
          errorsToSet[name] = error;
        } else {
          delete errorsToSet[name];
        }
      }

      // Constraints for specific fields
      const LimitValues = {
        escalation: "work_done_amt",
        gst: "work_done_amt",
        contractor_deduction_amt: "work_done_amt",
        site_escalation: "site_work_done_amt",
        site_gst: "site_work_done_amt",
        site_deduction_amount: "site_work_done_amt",
        ho_escalation: "ho_work_done_amt",
        ho_gst: "ho_work_done_amt",
        deduction_amount: "ho_work_done_amt",
        ...(formData.bill_type === "ra" && {
          work_done_amt: "cos_amount",
        }),

      };

      const escalationLimitFields = {
        site_escalation: "escalation",
        ho_escalation: "escalation",
      };

      const gstLimitFields = {
        site_gst: "gst",
        ho_gst: "gst",
      };

      const workDoneLimitFields = {
        site_work_done_amt: "work_done_amt",
        ho_work_done_amt: "work_done_amt",
      };

      const submittedamoutLimitedField = {
        site_recommended_bill_amount: "submitted_bill_amount",
        recommended_bill_amount: "submitted_bill_amount",
      };

      const percemntageAmount = {
        percentage_amt: "submitted_bill_amount",
        ho_percentage_amt: "recommended_bill_amount",
        site_percentage_amt: "site_recommended_bill_amount",
      };



      // Validate field limits
      const validateLimit = (limitFields) => {
        if (limitFields[name]) {
          const limitField = limitFields[name];
          const limitValue = parseFloat(prevFormData[limitField] || 0);
          const fieldValue = parseFloat(value || 0);

          if (fieldValue > limitValue) {
            errorsToSet[name] =
              `${name.replaceAll("_", " ")} amount cannot be greater than ${limitValue}.`;
          } else {
            delete errorsToSet[name];
          }
        }
      };

      validateLimit(escalationLimitFields);
      validateLimit(gstLimitFields);
      validateLimit(workDoneLimitFields);
      validateLimit(submittedamoutLimitedField);
      validateLimit(LimitValues);
      validateLimit(percemntageAmount);



      const submittedPercentageAmount = parseFloat(updatedFormData.percentage_amt || 0);
      const site_percentage_amt = parseFloat(updatedFormData.site_percentage_amt || 0);
      const ho_percentage_amt = parseFloat(updatedFormData.ho_percentage_amt || 0);

      updatedFormData = {
        ...updatedFormData,
        submitted_percentage: (
          (submittedPercentageAmount / updatedFormData.submitted_bill_amount) *
          100
        ).toFixed(2),

        site_recommended_percentage: (
          (site_percentage_amt / updatedFormData.site_recommended_bill_amount) *
          100
        ).toFixed(2),

        recommended_percentage: (
          (ho_percentage_amt / updatedFormData.recommended_bill_amount) *
          100
        ).toFixed(2),
      };

      // Remove empty errors
      const filteredErrors = Object.fromEntries(
        Object.entries(errorsToSet).filter(
          ([_, val]) => val !== "" && val !== undefined
        )
      );

      setErrors(filteredErrors);

      setIsError(Object.keys(filteredErrors).length > 0);

      return updatedFormData;
    });
  };


  useEffect(() => {
    const updatedSubmittedAmount = (
      parseFloat(formData.work_done_amt || 0) +
      parseFloat(formData.gst || 0) +
      parseFloat(formData.escalation || 0) +
      parseFloat(formData.contractor_withheld_release || 0) +
      parseFloat(totalContractorWithheldAmount) +
      parseFloat(totalExistingContractorWithheldAmount) -
      (
        parseFloat(formData.contractor_deduction_amt || 0) +
        parseFloat(formData.contractor_withheld || 0) +
        parseFloat(totalContractorDeductionAmount) +
        parseFloat(ExistingtotalContractorDeductionAmount)
      )
    );

    const updatedSiteSubmittedAmount = (
      parseFloat(formData.site_work_done_amt || 0) +
      parseFloat(formData.site_gst || 0) +
      parseFloat(formData.site_escalation || 0) +
      parseFloat(formData.site_released_withheld_amt || 0) +
      parseFloat(totalSiteWithehldAmounnt) +
      parseFloat(totalExistingSiteWithehldAmounnt) -
      (
        parseFloat(formData.site_deduction_amount || 0) +
        parseFloat(formData.site_withheld_amt || 0) +
        parseFloat(totalSiteDeductionAmount) +
        parseFloat(totalExistingSiteDeductionAmount)
      )
    );

    const updateHOSubmittedAmount = (
      parseFloat(formData.ho_work_done_amt || 0) +
      parseFloat(formData.ho_gst || 0) +
      parseFloat(formData.ho_escalation || 0) +
      parseFloat(formData.released_withheld_amt || 0) +
      parseFloat(totalHOReleaseAmount) +
      parseFloat(totalExistingHOReleaseAmount) -
      (
        parseFloat(formData.deduction_amount || 0) +
        parseFloat(formData.withheld_amt || 0) +
        parseFloat(totalHODeductionAmount) +
        parseFloat(totalExistingHODeductionAmount)
      )
    );

    const submittedPercentageAmount = parseFloat(formData.percentage_amt || 0);
    const sitePercentageAmt = parseFloat(formData.site_percentage_amt || 0);
    const hoPercentageAmt = parseFloat(formData.ho_percentage_amt || 0);

    setFormData(prev => ({
      ...prev,
      submitted_bill_amount: updatedSubmittedAmount.toFixed(),
      site_recommended_bill_amount: updatedSiteSubmittedAmount.toFixed(),
      recommended_bill_amount: updateHOSubmittedAmount.toFixed(),

      // 💡 Recalculate percentages when bill amount changes
      submitted_percentage: updatedSubmittedAmount
        ? ((submittedPercentageAmount / updatedSubmittedAmount) * 100).toFixed(2)
        : "0",

      site_recommended_percentage: updatedSiteSubmittedAmount
        ? ((sitePercentageAmt / updatedSiteSubmittedAmount) * 100).toFixed(2)
        : "0",

      recommended_percentage: updateHOSubmittedAmount
        ? ((hoPercentageAmt / updateHOSubmittedAmount) * 100).toFixed(2)
        : "0",
    }));
  }, [
    formData.work_done_amt,
    formData.gst,
    formData.escalation,
    formData.contractor_withheld_release,
    formData.contractor_deduction_amt,
    formData.contractor_withheld,
    formData.site_work_done_amt,
    formData.site_gst,
    formData.site_escalation,
    formData.site_released_withheld_amt,
    formData.site_withheld_amt,
    formData.site_deduction_amount,
    formData.ho_work_done_amt,
    formData.ho_gst,
    formData.ho_escalation,
    formData.released_withheld_amt,
    formData.withheld_amt,
    formData.deduction_amount,
    formData.percentage_amt,
    formData.site_percentage_amt,
    formData.ho_percentage_amt,

    totalContractorWithheldAmount,
    totalContractorDeductionAmount,
    totalSiteDeductionAmount,
    totalSiteWithehldAmounnt,
    totalHODeductionAmount,
    totalHOReleaseAmount,
    totalExistingContractorWithheldAmount,
    ExistingtotalContractorDeductionAmount,
    totalExistingSiteWithehldAmounnt,
    totalExistingSiteDeductionAmount,
    totalExistingHOReleaseAmount,
    totalExistingHODeductionAmount,
  ]);





  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];

    if (file) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        [name]: file, // Only update the field when a file is uploaded
      }));
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    const updatedfromdata = {
      ...formData,
    };

    if (!isError && validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        const formDataToSend = new FormData();

        // Append general form fields
        Object.keys(updatedfromdata).forEach((key) => {
          if (updatedfromdata[key] && key !== "site_attachment" && key !== "ho_attachment") {
            formDataToSend.append(key, updatedfromdata[key]);
          }
        });

        // Append file fields conditionally
        if (updatedfromdata.site_attachment) {
          formDataToSend.append("site_attachment", updatedfromdata.site_attachment);
        }
        if (updatedfromdata.ho_attachment) {
          formDataToSend.append("ho_attachment", updatedfromdata.ho_attachment);
        }

        const res = await axiosInstance2.put(
          `${BASE_URL}/siteproject/billingdetailfield/${i.id}/`,
          formDataToSend
        );



        if (res.status === 200) {
          const generateId = res.data.id;
          const isPostDataFilled = [...ContractorWithheldRelease, ...ContractorDeductionData, ...SiteWithheldRelease, ...SiteDeductionData, ...HOWithheldRelease, ...HODeductionData].some(data =>
            Object.values(data).some(value => value !== "" && value !== "null")
          );
          const isDataFilled = [...ExistingContractorWithheldRelease, ...ExistingContractorDeduction, ...ExistingSiteWithheldRelease, ...ExistingSiteDeduction, ...ExistingHOWithheldRelease, ...ExistingHODeduction].some(data =>
            Object.values(data).some(value => value !== "" && value !== "null")
          );

          if (isPostDataFilled) {
            const updatedContractorWithheld = ContractorWithheldRelease.map((data) => ({
              ...data,
              billing: generateId,
            }));

            const updatedContractorDeduction = ContractorDeductionData.map((data) => ({
              ...data,
              billing: generateId,
            }));
            const updatedSiteWithheld = SiteWithheldRelease.map((data) => ({
              ...data,
              billing: generateId,
            }));
            const updatedSiteDeduction = SiteDeductionData.map((data) => ({
              ...data,
              billing: generateId,
            }));
            const updatedHOWithheldRelease = HOWithheldRelease.map((data) => ({
              ...data,
              billing: generateId,
            }));
            const updatedHODeduction = HODeductionData.map((data) => ({
              ...data,
              billing: generateId,
            }));


            const mergedData = [...updatedContractorWithheld, ...updatedContractorDeduction, ...updatedSiteWithheld, ...updatedSiteDeduction, ...updatedHOWithheldRelease, ...updatedHODeduction];

            await axios.post(
              `${BASE_URL}/siteproject/otherdeducationbulkUpload/`,
              mergedData
            );
          }
          if (isDataFilled) {
            const mergedDataaa = [...ExistingContractorWithheldRelease, ...ExistingContractorDeduction, ...ExistingSiteWithheldRelease, ...ExistingSiteDeduction, ...ExistingHOWithheldRelease, ...ExistingHODeduction];
            const ishaveData1 = [...ExistingContractorWithheldRelease].some(data =>
              Object.values(data).some(value => value !== "" && value !== "null")
            );
            const ishaveData2 = [...ExistingContractorDeduction].some(data =>
              Object.values(data).some(value => value !== "" && value !== "null")
            );
            const ishaveData3 = [...ExistingSiteWithheldRelease].some(data =>
              Object.values(data).some(value => value !== "" && value !== "null")
            );

            const ishaveData4 = [...ExistingSiteDeduction].some(data =>
              Object.values(data).some(value => value !== "" && value !== "null")
            );
            const ishaveData5 = [...ExistingHOWithheldRelease].some(data =>
              Object.values(data).some(value => value !== "" && value !== "null")
            );
            const ishaveData6 = [...ExistingHODeduction].some(data =>
              Object.values(data).some(value => value !== "" && value !== "null")
            );
            if (ishaveData1) {
              await axios.put(
                `${BASE_URL}/siteproject/OtherDeducationBulkUpdate/`,
                ExistingContractorWithheldRelease
              );
            }
            if (ishaveData2) {
              await axios.put(
                `${BASE_URL}/siteproject/OtherDeducationBulkUpdate/`,
                ExistingContractorDeduction
              );
            }
            if (ishaveData3) {
              await axios.put(
                `${BASE_URL}/siteproject/OtherDeducationBulkUpdate/`,
                ExistingSiteWithheldRelease
              );
            }
            if (ishaveData4) {
              await axios.put(
                `${BASE_URL}/siteproject/OtherDeducationBulkUpdate/`,
                ExistingSiteDeduction
              );
            }
            if (ishaveData5) {
              await axios.put(
                `${BASE_URL}/siteproject/OtherDeducationBulkUpdate/`,
                ExistingHOWithheldRelease
              );
            }
            if (ishaveData6) {
              await axios.put(
                `${BASE_URL}/siteproject/OtherDeducationBulkUpdate/`,
                ExistingHODeduction
              );
            }
          }

          toast.dismiss(loadingToastId);
          toast.success("Billing detail Updated successfully!");
          handleClose();
          getProjects();
        } else {
          toast.dismiss(loadingToastId);
          toast.error("Failed to add bill detail!");
        }
      } catch (err) {
        toast.dismiss(loadingToastId);
        toast.error("Error processing your request.");
      } finally {
        setLoading(false);
      }
    }
  };

  //  *********************************Bill Type Select Option **********************************//
  const billType = [
    { value: "sps", label: "SPS" },
    { value: "ipc", label: "IPC" },
    { value: "milestonebill", label: "MileStone Bill" },
    { value: "maintainance", label: "Maintainance" },
    { value: "ra", label: "RA" },
    { value: "annuitypayment", label: "Annuity Payment" },
  ];


  const billTypeOption = billType.sort((a, b) => a.label - b.label).map((i) => ({
    value: i.value,
    label: i.label
  }));


  const handleBilltypeChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        bill_type: "null",
      })
    }
    else {
      setFormData({
        ...formData,
        bill_type: selectedOption.value,
      });
    }
  };

  //  *********************************Bill Type Select Option **********************************//


  //  *********************************Bill Category Select Option **********************************//
  const billCategory = [
    { value: "balancebills", label: "Balance Bills" },
    { value: "bills", label: "Bills" },
  ];


  const billCategoryOption = billCategory.sort((a, b) => a.label - b.label).map((i) => ({
    value: i.value,
    label: i.label
  }));


  const handleBillCategoryChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        bill_catagory: "null",
      })
    }
    else {
      setFormData({
        ...formData,
        bill_catagory: selectedOption.value,
      });
    }
  };

  //  *********************************Bill Category Select Option **********************************//



  //  *********************************Letter Select Option **********************************//
  const letter = trackRecordList.map((i) => ({
    value: i.id,
    label: i.letter_num
  }));


  const letterOption = letter.sort((a, b) => a.label - b.label).map((i) => ({
    value: i.value,
    label: i.label
  }));

  const extendedLetters = [
    { value: "null", label: "Select Letter" },
    ...letterOption,
  ];



  const handleletterChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        submitted_letter_num: null,
      })
    }
    else {
      setFormData({
        ...formData,
        submitted_letter_num: selectedOption.value,
      });
    }
  };
  const handleletterChange2 = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        recomended_letter_num: null,
      })
    }
    else {
      setFormData({
        ...formData,
        recomended_letter_num: selectedOption.value,
      });
    }
  };

  //  *********************************Letter Select Option **********************************//


  // useEffect(() => {
  //   const totalAmount = Number(formData.work_done_amt) + Number(formData.escalation);
  //   const gst_amount = totalAmount * 0.18;
  //   const totalAEAmount = Number(formData.ho_work_done_amt) + Number(formData.ho_escalation);
  //   const aegst_amount = totalAEAmount * 0.18;
  //   const totalClientAmount = Number(formData.site_work_done_amt) + Number(formData.site_escalation);
  //   const clientgst_amount = totalClientAmount * 0.18;



  //   setFormData((prev) => ({
  //     ...prev,
  //     gst: gst_amount
  //   }))
  //   setFormData((prev) => ({
  //     ...prev,
  //     site_gst: clientgst_amount
  //   }))
  //   setFormData((prev) => ({
  //     ...prev,
  //     ho_gst: aegst_amount
  //   }))
  // }, [formData.work_done_amt, formData.escalation, formData.gst, formData.site_gst, formData.ho_gst, formData.site_escalation, formData.site_work_done_amt, formData.ho_escalation, formData.ho_work_done_amt])


  const handleDateChange = (e) => {
    const { name, value } = e.target;   // ← missing in your code

    if (name === "bill_period_start") {
      const selectedDate = new Date(value);
      const todayDate = new Date();

      // remove time
      todayDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate > todayDate) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Date cannot be greater than today.",
        }));
        return; // stop further execution
      } else {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }
    if (name === "submitted_bill_date") {
      const selectedDate = new Date(value);
      const todayDate = new Date();

      // remove time
      todayDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate > todayDate) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Date cannot be greater than today.",
        }));
        return; // stop further execution
      } else {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }
    if (name === "bill_period_end") {
      const selectedDate = new Date(value);
      const todayDate = new Date();

      // remove time
      todayDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate > todayDate) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Date cannot be greater than today.",
        }));
        return; // stop further execution
      } else {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }
    if (name === "site_recomended_bill_date") {
      const selectedDate = new Date(value);
      const todayDate = new Date();

      // remove time
      todayDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate > todayDate) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Date cannot be greater than today.",
        }));
        return; // stop further execution
      } else {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }
    if (name === "recomended_bill_date") {
      const selectedDate = new Date(value);
      const todayDate = new Date();

      // remove time
      todayDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate > todayDate) {
        setErrors((prev) => ({
          ...prev,
          [name]: "Date cannot be greater than today.",
        }));
        return; // stop further execution
      } else {
        setErrors((prev) => ({
          ...prev,
          [name]: "",
        }));
      }
    }

    // update formData value only when valid
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };


  const optionsForCOS = cosData.map((i) => ({
    value: i.id,
    label: i.cos_code
  }));

  const handleCOSChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        cos: "null",
      })
    }
    else {
      setFormData({
        ...formData,
        cos: selectedOption.value,
      });
    }
  };

  useEffect(() => {
    setIsError(false);
    setErrors({})

  }, [formData.bill_type, formData.cos])

  useEffect(() => {
    if (formData.bill_type !== "ra") {

      setFormData(prev => ({
        ...prev,
        cos: null,
        cos_inprinciple_amount_by_client: null,
        cos_approved_amount: null,
        cos_amount: null,
      })

      )
    }
  }, [formData.bill_type])


  const [approvedAmount, setApprovedAmount] = useState(0);
  useEffect(() => {
    if (formData.bill_type === "ra") {
      const LinkedCOS = cosData.find(cos => cos.id === formData.cos);
      if (LinkedCOS) {
        const approvedAmount = LinkedCOS.approved_amount || 0;
        setFormData(prev => ({
          ...prev,
          cos_amount: approvedAmount
        }));

      }
    }
  }, [formData.bill_type, formData.cos, formData.work_done_amt, cosData]);


  console.log(errors, "validateError")
  console.log(isError, "isError")
  console.log(i, "i")
  console.log(formData, "formData")

  return (
    <>
      <button title="Update Bill" className="model-edit-button" onClick={handleShow}>
        <UpdatePencil />

      </button>

      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName="three-fourth-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Billing  Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer
            position="top-center"
            autoClose={3000}
            hideProgressBar
          />

          <div className="form-flex-wrap">
            <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
              <div className="jd-heading-outer-flex " >
                <h2 className="jd-heading-main font-weight600  font-size-heading"> Bill Details</h2>
              </div>
              <div>
                <div className="jd-heading-bottom-bold" style={{ width: "160px" }}></div>
                <div className="jd-heading-bottom-light"></div>
              </div>
            </div>
            <div className="form-flex-wrap">
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Bill Type">
                  Bill Type<span className="required">*</span>
                </label>
                <Select
                  options={billTypeOption}
                  isSearchable
                  isClearable
                  title="Bill Type"
                  placeholder="Select Bill Type"
                  value={billTypeOption.find(i => i.value === formData.bill_type)}
                  noOptionsMessage={() => "No other options"}
                  onChange={handleBilltypeChange}
                  styles={CSSForSelect15vWWidthvwWithourforntSize}
                />

                {errors.bill_type && (
                  <div className="error-message font-size-text">
                    {errors.bill_type}
                  </div>
                )}
              </div>
              {formData.bill_type === "ra" &&
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="Bill Type">
                    Select COS<span className="required">*</span>
                  </label>
                  <Select
                    options={optionsForCOS}
                    isSearchable
                    isClearable
                    title="Select COS"
                    placeholder="Select COS"
                    value={optionsForCOS.find(i => i.value === formData.cos)}
                    noOptionsMessage={() => "No other options"}
                    onChange={handleCOSChange}
                    styles={CSSForSelect15vWWidthvwWithourforntSize}
                  />

                  {errors.cos && (
                    <div className="error-message font-size-text">
                      {errors.cos}
                    </div>
                  )}
                </div>
              }

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Bill Category">
                  Bill Category<span className="required">*</span>
                </label>
                <Select
                  options={billCategoryOption}
                  isSearchable
                  isClearable
                  title="Bill Category"
                  placeholder="Select Bill Category"
                  value={billCategoryOption.find(i => i.value === formData.bill_catagory)}
                  noOptionsMessage={() => "No other options"}
                  onChange={handleBillCategoryChange}
                  styles={CSSForSelect15vWWidthvwWithourforntSize}
                />


                {errors.bill_catagory && (
                  <div className="error-message font-size-text">
                    {errors.bill_catagory}
                  </div>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Bill Number">
                  Bill Num<span className="required">*</span>
                </label>
                <input
                  type="text"
                  title="Bill Number"
                  name="bill_num"
                  placeholder="Bill Num"
                  value={formData.bill_num}
                  onChange={handleInputChange}
                  className={`form-input-date width-15vw ${errors.bill_num ? "is-invalid" : ""
                    }`}
                />
                {errors.bill_num && (
                  <div className="error-message font-size-text">
                    {errors.bill_num}
                  </div>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Bill Period Start">
                  Bill Period Start<span className="required">*</span>
                </label>
                <input
                  type="date"
                  name="bill_period_start"
                  title="Bill Period Start"
                  value={formData.bill_period_start}
                  onChange={handleDateChange}
                  max={new Date().toISOString().split('T')[0]}
                  className={`form-input-date width-15vw ${errors.bill_period_start ? "is-invalid" : ""
                    }`}
                />
                {errors.bill_period_start && (
                  <div className="error-message font-size-text">
                    {errors.bill_period_start}
                  </div>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Bill Period End">
                  Bill Period End<span className="required">*</span>
                </label>
                <input
                  type="date"
                  name="bill_period_end"
                  title="Bill Period End"
                  value={formData.bill_period_end}
                  max={new Date().toISOString().split('T')[0]}

                  onChange={handleDateChange}
                  className={`form-input-date width-15vw ${errors.bill_period_end ? "is-invalid" : ""
                    }`}
                  min={formData.bill_period_start}
                />
                {errors.bill_period_end && (
                  <div className="error-message font-size-text">
                    {errors.bill_period_end}
                  </div>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Submitted Bill Date">
                  Submitted Bill Date<span className="required">*</span>
                </label>
                <input
                  type="date"
                  title="Submitted Bill Date"
                  name="submitted_bill_date"
                  value={formData.submitted_bill_date}
                  min={formData.bill_period_end}
                  max={new Date().toISOString().split('T')[0]}

                  onChange={handleDateChange}
                  className={`form-input-date width-15vw ${errors.submitted_bill_date ? "is-invalid" : ""
                    }`}
                />
                {errors.submitted_bill_date && (
                  <div className="error-message font-size-text">
                    {errors.submitted_bill_date}
                  </div>
                )}
              </div>
            </div>
            <div className="form-flex-wrap">
              <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                <div className="jd-heading-outer-flex " >
                  <h2 className="jd-heading-main font-weight600  font-size-heading"> Allowance</h2>
                </div>

              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="GST">
                  Work Done Amount
                </label>
                <input
                  type="number"
                  title="Work Done Amount "
                  name="work_done_amt"
                  placeholder="0 "
                  value={formData.work_done_amt}
                  onChange={handleInputChange}
                  className={`form-input-date width-10vw ${errors.work_done_amt ? "is-invalid" : ""
                    }`}
                />
                {errors.work_done_amt && (
                  <div className="error-message font-size-text">
                    {errors.work_done_amt}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Escalation">
                  Escalation Amount
                </label>
                <input
                  type="number"
                  title="Escalation Amount"
                  name="escalation"
                  placeholder="0"
                  value={formData.escalation}
                  onChange={handleInputChange}
                  className={`form-input-date width-10vw ${errors.escalation ? "is-invalid" : ""
                    }`}
                />
                {errors.escalation && (
                  <div className="error-message font-size-text">
                    {errors.escalation}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="GST">
                  GST Amount <span className="required"></span>
                </label>
                <input
                  type="text"
                  title="GST Amount"
                  name="gst"
                  placeholder="GST Amount"
                  value={formData.gst}
                  onChange={handleInputChange}
                  className={`form-input-date width-10vw ${errors.gst ? "is-invalid" : ""
                    }`}
                />
                {errors.gst && (
                  <div className="error-message font-size-text">
                    {errors.gst}
                  </div>
                )}
              </div>
              {ExistingContractorWithheldRelease
                .filter(
                  (data) =>
                    data.contractor_releasing_heading !== null &&
                    data.contractor_releasing_amount !== null
                )
                .map((data, index) => (
                  <div className="flex-column">
                    <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                      <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                        <div>
                          <label className="form-labels font-weight500 font-size-subheading">
                            {data.contractor_releasing_heading}  Amount
                          </label>
                        </div>
                      </div>
                    </div>
                    <input
                      type="number"
                      min={0}
                      name="contractor_releasing_amount"
                      placeholder={data.contractor_releasing_amount}
                      value={data.contractor_releasing_amount}
                      onChange={(e) => handleExistingContractorWithheldInputChange(e, index)}
                      className="form-input-date"
                    />
                    {errors[`${index}-contractor_releasing_amount`] && (
                      <span className="error-message font-size-text">
                        {errors[`${index}-contractor_releasing_amount`]}
                      </span>
                    )}
                  </div>
                ))}

              <button type='button' title="Add Allowance" className="jd-heading-main font-weight600" onClick={handleAddContractorWitheheldRelease}>
                <AddwithBlueCircle />
                Add a Bill Allowance
              </button>
            </div>
            <div className="form-flex-wrap" style={{ width: "100%" }}>


              <div className="form-flex-wrap" style={{ width: "100%" }}>
                {ContractorWithheldRelease.map((data, index) => (
                  <>
                    <div className="flex-column">

                      <label className="form-labels font-weight500 font-size-subheading">
                        Heading
                      </label>

                      <input

                        type="text"
                        name="contractor_releasing_heading"
                        value={data.contractor_releasing_heading}
                        onChange={(e) => handleContractorWithheldInputChange(e, index)}
                        placeholder="Enter Heading"
                        className="form-input"
                        style={{ width: "30vw" }}
                      />
                      {errors[`${index}-contractor_releasing_heading`] && (
                        <span className="error-message font-size-text">
                          {errors[`${index}-contractor_releasing_heading`]}
                        </span>
                      )}
                    </div>
                    <div className="flex-column">
                      <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                        <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                          <div>
                            <label className="form-labels font-weight500 font-size-subheading">
                              Amount
                            </label>
                          </div>
                          {index === ContractorWithheldRelease.length - 1 && (
                            <div className="flex-column justify-center">
                              <button

                                title="Remove Field"
                                onClick={() => handleRemoveContractorWithheldRelease(index)}
                                className="file-clear clear-button2"
                                style={{ width: "1.8vw" }}
                              >
                                X
                              </button>
                            </div>
                          )}
                        </div >
                        <div >

                        </div>
                      </div>
                      <input

                        type="number"
                        min={0}
                        name="contractor_releasing_amount"
                        value={data.contractor_releasing_amount}
                        onChange={(e) => handleContractorWithheldInputChange(e, index)}
                        placeholder="Enter Amount"
                        className="form-input"
                        style={{ width: "22vw" }}
                      />
                      {errors[`${index}-contractor_releasing_amount`] && (
                        <span className="error-message font-size-text">
                          {errors[`${index}-contractor_releasing_amount`]}
                        </span>
                      )}
                    </div>

                  </>
                ))}
              </div>
            </div>

            <div className="form-flex-wrap">
              <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                <div className="jd-heading-outer-flex " >
                  <h2 className="jd-heading-main font-weight600  font-size-heading"> Deduction</h2>
                </div>

              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="GST">
                  Deduction Submitted Amount
                </label>
                <input
                  type="number"
                  title="Deduction Submitted Amount"
                  name="contractor_deduction_amt"
                  placeholder="Deduction Submitted Amount"
                  value={formData.contractor_deduction_amt}
                  onChange={handleInputChange}
                  className={`form-input  ${errors.contractor_deduction_amt ? "is-invalid" : ""
                    }`}
                  style={{ width: "30vw" }}
                />
                {errors.contractor_deduction_amt && (
                  <div className="error-message font-size-text">
                    {errors.contractor_deduction_amt}
                  </div>
                )}
              </div>
              <div style={{ width: "22vw" }}>
                <button type='button' title="Add Deduction" className="jd-heading-main font-weight600" onClick={handleAddContractorDeduction}>
                  <AddwithBlueCircle />
                  Add a Bill Deduction
                </button>
              </div>
              {ExistingContractorDeduction
                .filter(
                  (data) =>
                    data.contractor_deduction_heading !== null &&
                    data.contractor_deduction_amount !== null
                )
                .map((data, index) => (


                  <div className="flex-column">
                    <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                      <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                        <div>
                          <label className="form-labels font-weight500 font-size-subheading">
                            {data.contractor_deduction_heading} Amount
                          </label>
                        </div>
                      </div>
                    </div>
                    <input
                      type="number"
                      min={0}
                      name="contractor_deduction_amount"
                      placeholder="Enter Amount"
                      value={data.contractor_deduction_amount}
                      onChange={(e) => handleExistingContractorDeductionInputChange(e, index)}
                      className="form-input-date"
                    />
                    {errors[`${index}-contractor_deduction_amount`] && (
                      <span className="error-message font-size-text">
                        {errors[`${index}-contractor_deduction_amount`]}
                      </span>
                    )}
                  </div>

                ))
              }

            </div>
            <div className="form-flex-wrap" style={{ width: "100%" }}>

              <div className="form-flex-wrap" style={{ width: "100%" }}>
                {ContractorDeductionData.map((data, index) => (
                  <>
                    <div className="flex-column">

                      <label className="form-labels font-weight500 font-size-subheading">
                        Heading
                      </label>

                      <input

                        type="text"
                        name="contractor_deduction_heading"
                        value={data.contractor_deduction_heading}
                        onChange={(e) => handleContractorDeductionInputChange(e, index)}
                        placeholder="Enter Heading"
                        className="form-input"
                        style={{ width: "30vw" }}
                      />
                      {errors[`${index}-contractor_deduction_heading`] && (
                        <span className="error-message font-size-text">
                          {errors[`${index}-contractor_deduction_heading`]}
                        </span>
                      )}
                    </div>
                    <div className="flex-column">
                      <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                        <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                          <div>
                            <label className="form-labels font-weight500 font-size-subheading">
                              Amount
                            </label>
                          </div>
                          {index === ContractorDeductionData.length - 1 && (
                            <div className="flex-column justify-center">
                              <button

                                title="Remove Field"
                                onClick={() => handleRemoveContractorDeduction(index)}
                                className="file-clear clear-button2"
                                style={{ width: "1.8vw" }}
                              >
                                X
                              </button>
                            </div>
                          )}
                        </div >
                        <div >

                        </div>
                      </div>
                      <input

                        type="number"
                        min={0}
                        name="contractor_deduction_amount"
                        value={data.contractor_deduction_amount}
                        onChange={(e) => handleContractorDeductionInputChange(e, index)}
                        placeholder="0"
                        className="form-input"
                        style={{ width: "22vw" }}
                      />
                      {errors[`${index}-contractor_deduction_amount`] && (
                        <span className="error-message font-size-text">
                          {errors[`${index}-contractor_deduction_amount`]}
                        </span>
                      )}
                    </div>

                  </>
                ))}
              </div>

              <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                <div className="jd-heading-outer-flex " >
                  <h2 className="jd-heading-main font-weight600  font-size-heading"> Total</h2>
                </div>

              </div>
              <div className="flex-column">
                <label
                  className="form-labels font-weight500 font-size-subheading"
                  title="Submitted Bill Amount"
                >
                  Submitted Bill Amount<span className="required">(Read-Only)</span>
                </label>
                <input
                  type="number"
                  title="Submitted Bill Amount"
                  placeholder="1,00,000"
                  name="submitted_bill_amount"
                  value={formData.submitted_bill_amount}
                  readOnly // Make this field read-only to prevent manual edits

                  className={`form-input-date width-15vw ${errors.submitted_bill_amount ? "is-invalid" : ""
                    }`}
                />
                {errors.submitted_bill_amount && (
                  <div className="error-message font-size-text">
                    {errors.submitted_bill_amount}
                  </div>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="GST">
                  Submitted Percentage Amount
                </label>
                <input
                  type="number"
                  title=" Submitted Percentage Amount"
                  name="percentage_amt"
                  placeholder=" 0"
                  // readOnly
                  value={formData.percentage_amt}
                  onChange={handleInputChange}
                  className={`form-input-date width-15vw ${errors.percentage_amt ? "is-invalid" : ""
                    }`}
                />
                {errors.percentage_amt && (
                  <div className="error-message font-size-text">
                    {errors.percentage_amt}
                  </div>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="GST">
                  Submitted Percentage<span className="required">(Read-only)</span>
                </label>
                <input
                  type="text"
                  title=" Submitted Percentage"
                  name="submitted_percentage"
                  disabled
                  placeholder=" 0"
                  value={formData.submitted_percentage}
                  onChange={handleInputChange}
                  className={`form-input-date width-15vw ${errors.submitted_percentage ? "is-invalid" : ""
                    }`}
                />
                {errors.submitted_percentage && (
                  <div className="error-message font-size-text">
                    {errors.submitted_percentage}
                  </div>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Submitted Letter">
                  Submitted Letter
                </label>
                <Select
                  options={extendedLetters}
                  isSearchable
                  isClearable
                  title="Submitted Letter "
                  placeholder="Select Letter"
                  value={extendedLetters.find(i => i.value === formData.submitted_letter_num)}
                  noOptionsMessage={() => "No other options"}
                  onChange={handleletterChange}
                  styles={CSSForSelect20vWWidth}
                />
                {/* <select
                  name="submitted_letter_num"
                  title="Submitted Letter"
                  value={formData.submitted_letter_num}
                  onChange={handleInputChange}
                  className={`form-input-date`}
                >
                  <option value="">Select an existing letter</option>
                  {trackRecordList.map((option) => (
                    <option key={option.id} value={option.id}>
                      {option.letter_num}
                    </option>
                  ))}
                </select> */}
                {errors.submitted_letter_num && (
                  <div className="error-message font-size-text">
                    {errors.submitted_letter_num}
                  </div>
                )}
              </div>

              <div className="flex-column">
                {formData.submitted_letter_num !== "null" ? (
                  ""
                ) : (
                  <div
                    className="flex-row "
                    style={{
                      width: "23.5vw",
                      justifyContent: "space-between",
                      marginTop: "15px",
                    }}
                  >
                    <div
                      style={{ display: "flex", justifyContent: "space-evenly" }}
                    >
                      <div>OR</div>
                    </div>
                    <div className="button-models">
                      <AddTrackRecordDetails
                        projectId={project}
                        letterfor="contractor"
                        lettertype="billing"
                        getProjects={getLetters}
                        title="Bill Letter Details"
                        contractor={contractor}
                      />

                    </div>
                  </div>
                )}
              </div>

            </div>




            {/* 
            {sessionStorage.getItem('sitemanagement_role') === "SiteManagement" ? (
              ""
            ) : ( */}
            <>
              <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                <div className="jd-heading-outer-flex " >
                  <h2 className="jd-heading-main font-weight600  font-size-heading"> AE/IE Bill Details</h2>
                </div>
                <div>
                  <div className="jd-heading-bottom-bold" style={{ width: "160px" }}></div>
                  <div className="jd-heading-bottom-light"></div>
                </div>
              </div>
              <div className="form-flex-wrap">
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="Recommend Bill Date">
                    AE/IE Recomended Bill Date
                  </label>
                  <input
                    type="date"
                    name="recomended_bill_date"
                    title="Recommended Bill Date"
                    placeholder="Recomended Bill Date"
                    value={formData.recomended_bill_date}
                    onChange={handleDateChange}
                    max={new Date().toISOString().split('T')[0]}

                    className={`form-input-date ${errors.recomended_bill_date ? "is-invalid" : ""
                      }`}
                  />
                  {errors.recomended_bill_date && (
                    <div className="error-message font-size-text">
                      {errors.recomended_bill_date}
                    </div>
                  )}
                </div>
                <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                  <div className="jd-heading-outer-flex " >
                    <h2 className="jd-heading-main font-weight600  font-size-heading"> Allowance</h2>
                  </div>

                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="GST">
                    AE/IE Work Done Amount
                  </label>
                  <input
                    type="number"
                    title="AE/IE Work Done Amount "
                    name="ho_work_done_amt"
                    placeholder="0"
                    value={formData.ho_work_done_amt}
                    onChange={handleInputChange}
                    className={`form-input-date  width-10vw ${errors.ho_work_done_amt ? "is-invalid" : ""
                      }`}
                  />
                  {errors.ho_work_done_amt && (
                    <div className="error-message font-size-text">
                      {errors.ho_work_done_amt}
                    </div>
                  )}
                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="AE/IE Escalation Amount">
                    AE/IE Escalation Amount
                  </label>
                  <input
                    type="number"
                    title="AE/IE Escalation Amount"
                    name="ho_escalation"
                    placeholder="0"
                    value={formData.ho_escalation}
                    onChange={handleInputChange}
                    className={`form-input-date  width-10vw ${errors.ho_escalation ? "is-invalid" : ""
                      }`}
                  />
                  {errors.ho_escalation && (
                    <div className="error-message font-size-text">
                      {errors.ho_escalation}
                    </div>
                  )}
                </div>

                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="AE/IE GST Amount">
                    AE/IE GST Amount <span className="required"></span>
                  </label>
                  <input
                    type="number"
                    title=" AE/IE GST Amount"
                    name="ho_gst"
                    placeholder="0"
                    value={formData.ho_gst}
                    onChange={handleInputChange}
                    className={`form-input-date  width-10vw ${errors.ho_gst ? "is-invalid" : ""
                      }`}
                  />
                  {errors.ho_gst && (
                    <div className="error-message font-size-text">
                      {errors.ho_gst}
                    </div>
                  )}
                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="Release Withheld Amount">
                    AE/IE Release Withheld Amount
                  </label>
                  <input
                    type="number"
                    title="Released Withheld Amount"
                    min={0}
                    name="released_withheld_amt"
                    placeholder="0"
                    value={formData.released_withheld_amt}
                    onChange={handleInputChange}
                    className={`form-input-date  width-10vw ${errors.released_withheld_amt ? "is-invalid" : ""
                      }`}
                  />
                  {errors.released_withheld_amt && (
                    <div className="error-message font-size-text">
                      {errors.released_withheld_amt}
                    </div>
                  )}
                </div>
                {ExistingHOWithheldRelease
                  .filter(
                    (data) =>
                      data.HO_released_heading !== null &&
                      data.HO_released_amount !== null
                  )
                  .map((data, index) => (


                    <div className="flex-column">
                      <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                        <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                          <div>
                            <label className="form-labels font-weight500 font-size-subheading">
                              {data.HO_released_heading} Amount
                            </label>
                          </div>
                        </div>
                      </div>
                      <input
                        type="number"
                        min={0}
                        name="HO_released_amount"
                        placeholder="Enter Amount"
                        value={data.HO_released_amount}
                        onChange={(e) => handleExistingHOWithheldInputChange(e, index)}
                        className="form-input-date"
                      />
                      {errors[`${index}-HO_released_amount`] && (
                        <span className="error-message font-size-text">
                          {errors[`${index}-HO_released_amount`]}
                        </span>
                      )}
                    </div>
                  ))
                }
                <div className="form-flex-wrap" style={{ width: "100%" }}>
                  <button type='button' title="Add Allowance" className="jd-heading-main font-weight600" onClick={handleAddHOWitheheldRelease}>
                    <AddwithBlueCircle />
                    Add a Bill Allowance
                  </button>

                  <div className="form-flex-wrap" style={{ width: "100%" }}>
                    {HOWithheldRelease.map((data, index) => (
                      <>
                        <div className="flex-column">

                          <label className="form-labels font-weight500 font-size-subheading">
                            AE/IE Heading
                          </label>

                          <input

                            type="text"
                            name="HO_released_heading"
                            value={data.HO_released_heading}
                            onChange={(e) => handleHOWithheldInputChange(e, index)}
                            placeholder="Enter Heading"
                            className="form-input"
                            style={{ width: "30vw" }}
                          />
                          {errors[`${index}-HO_released_heading`] && (
                            <span className="error-message font-size-text">
                              {errors[`${index}-HO_released_heading`]}
                            </span>
                          )}
                        </div>
                        <div className="flex-column">
                          <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                            <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                              <div>
                                <label className="form-labels font-weight500 font-size-subheading">
                                  AE/IE  Amount
                                </label>
                              </div>
                              {index === HOWithheldRelease.length - 1 && (
                                <div className="flex-column justify-center">
                                  <button

                                    title="Remove Field"
                                    onClick={() => handleRemoveHOWitheld(index)}
                                    className="file-clear clear-button2"
                                    style={{ width: "1.8vw" }}
                                  >
                                    X
                                  </button>
                                </div>
                              )}
                            </div >
                            <div >

                            </div>
                          </div>
                          <input

                            type="number"
                            min={0}
                            name="HO_released_amount"
                            value={data.HO_released_amount}
                            onChange={(e) => handleHOWithheldInputChange(e, index)}
                            placeholder="0"
                            className="form-input"
                            style={{ width: "22vw" }}
                          />
                          {errors[`${index}-HO_released_amount`] && (
                            <span className="error-message font-size-text">
                              {errors[`${index}-HO_released_amount`]}
                            </span>
                          )}
                        </div>

                      </>
                    ))}
                  </div>
                </div>

                <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                  <div className="jd-heading-outer-flex " >
                    <h2 className="jd-heading-main font-weight600  font-size-heading"> Deduction</h2>
                  </div>

                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="Withheld Amount">
                    Withheld Amount
                  </label>
                  <input
                    type="number"
                    title="Withheld Amount"
                    min={0}
                    name="withheld_amt"
                    placeholder="0"
                    value={formData.withheld_amt}
                    onChange={handleInputChange}
                    style={{ width: "20vw" }}
                    className={`form-input ${errors.withheld_amt ? "is-invalid" : ""
                      }`}
                  />
                  {errors.withheld_amt && (
                    <div className="error-message font-size-text">
                      {errors.withheld_amt}
                    </div>
                  )}
                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="AE/IE Deduction Amount">
                    AE/IE Deduction Amount
                  </label>
                  <input
                    type="number"
                    title="AE/IE Deduction Amount"
                    min={0}
                    max={formData.submitted_bill_amount}
                    name="deduction_amount"
                    placeholder="0"
                    value={formData.deduction_amount}
                    style={{ width: "20vw" }}

                    onChange={handleInputChange}
                    className={`form-input ${errors.deduction_amount ? "is-invalid" : ""
                      }`}
                  />
                  {errors.deduction_amount && (
                    <div className="error-message font-size-text">
                      {errors.deduction_amount}
                    </div>
                  )}
                </div>
                {ExistingHODeduction
                  .filter(
                    (data) =>
                      data.HO_deduction_heading !== null &&
                      data.HO_deduction_amount !== null
                  )
                  .map((data, index) => (
                    <div className="flex-column">
                      <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                        <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                          <div>
                            <label className="form-labels font-weight500 font-size-subheading">
                              {data.HO_deduction_heading} Amount
                            </label>
                          </div>
                        </div>
                      </div>
                      <input
                        type="number"
                        min={0}
                        name="HO_deduction_amount"
                        placeholder="Enter Amount"
                        value={data.HO_deduction_amount}
                        onChange={(e) => handleExistingHODeductionInputChange(e, index)}
                        className="form-input-date"
                      />
                      {errors[`${index}-HO_deduction_amount`] && (
                        <span className="error-message font-size-text">
                          {errors[`${index}-HO_deduction_amount`]}
                        </span>
                      )}
                    </div>
                  ))
                }
                <button type='button' title="Add Deduction" className="jd-heading-main font-weight600" onClick={handleAddHOdeduction}>
                  <AddwithBlueCircle />
                  Add a Bill Deduction
                </button>
                <div className="form-flex-wrap" style={{ width: "100%" }}>


                  <div className="form-flex-wrap" style={{ width: "100%" }}>
                    {HODeductionData.map((data, index) => (
                      <>
                        <div className="flex-column">

                          <label className="form-labels font-weight500 font-size-subheading">
                            AE/IE Heading
                          </label>

                          <input

                            type="text"
                            name="HO_deduction_heading"
                            value={data.HO_deduction_heading}
                            onChange={(e) => handleHODeductionInputChange(e, index)}
                            placeholder="Enter Heading"
                            className="form-input"
                            style={{ width: "30vw" }}
                          />
                          {errors[`${index}-HO_deduction_heading`] && (
                            <span className="error-message font-size-text">
                              {errors[`${index}-HO_deduction_heading`]}
                            </span>
                          )}
                        </div>
                        <div className="flex-column">
                          <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                            <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                              <div>
                                <label className="form-labels font-weight500 font-size-subheading">
                                  AE/IE  Amount
                                </label>
                              </div>
                              {index === HODeductionData.length - 1 && (
                                <div className="flex-column justify-center">
                                  <button

                                    title="Remove Field"
                                    onClick={() => handleRemoveHODeduction(index)}
                                    className="file-clear clear-button2"
                                    style={{ width: "1.8vw" }}
                                  >
                                    X
                                  </button>
                                </div>
                              )}
                            </div >
                            <div >

                            </div>
                          </div>
                          <input

                            type="number"
                            min={0}
                            name="HO_deduction_amount"
                            value={data.hode}
                            onChange={(e) => handleHODeductionInputChange(e, index)}
                            placeholder="0"
                            style={{ width: "20vw" }}
                            className="form-input"
                          />
                          {errors[`${index}-HO_deduction_amount`] && (
                            <span className="error-message font-size-text">
                              {errors[`${index}-HO_deduction_amount`]}
                            </span>
                          )}
                        </div>

                      </>
                    ))}
                  </div>
                </div>


                <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                  <div className="jd-heading-outer-flex " >
                    <h2 className="jd-heading-main font-weight600  font-size-heading"> Total</h2>
                  </div>

                </div>

                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="AE/IE Recommended Bill Amount">
                    AE/IE Recommended <br /> Bill Amount<span className="required">(Read-Only)</span>
                  </label>
                  <input
                    title="AE/IE Recommended Bill Amount"
                    type="number"
                    min={0}
                    max={formData.submitted_bill_amount}
                    name="recommended_bill_amount"
                    placeholder="AE/IE Recommended Bill Amount"
                    value={formData.recommended_bill_amount}
                    readOnly
                    onChange={handleInputChange}
                    style={{ width: "15vw" }}
                    className={`form-input-date ${errors.recommended_bill_amount ? "is-invalid" : ""
                      }`}
                  />
                  {errors.recommended_bill_amount && (
                    <div className="error-message font-size-text">
                      {errors.recommended_bill_amount}
                    </div>
                  )}
                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title=" AE/IE Recommended Percentage Amount">
                    AE/IE Recommended <br /> Percentage Amount
                  </label>
                  <input
                    title=" AE/IE Recommended Percentage Amount"
                    type="number"
                    min={0}
                    max={formData.submitted_bill_amount}
                    name="ho_percentage_amt"
                    placeholder="0"
                    value={formData.ho_percentage_amt}
                    onChange={handleInputChange}
                    className={`form-input-date width-15vw ${errors.ho_percentage_amt ? "is-invalid" : ""
                      }`}
                  />
                  {errors.ho_percentage_amt && (
                    <div className="error-message font-size-text">
                      {errors.ho_percentage_amt}
                    </div>
                  )}
                </div>

                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="AE/IE Recommended Bill Percentage">
                    AE/IE Recommended <br /> Bill Percentage <span className="required"> (Read-Only)</span>
                  </label>
                  <input
                    type="text"
                    title="AE/IE Recommended Bill Percentage"
                    min={0}
                    max={100}
                    name="recommended_percentage"
                    disabled
                    placeholder="0"
                    style={{ width: "15vw" }}

                    value={formData.recommended_percentage}
                    onChange={handleInputChange}
                    className={`form-input-date width-15vw ${errors.recommended_percentage ? "is-invalid" : ""
                      }`}
                  />
                  {errors.recommended_percentage && (
                    <div className="error-message font-size-text">
                      {errors.recommended_percentage}
                    </div>
                  )}
                </div>
                <div className="flex-column">
                  <label className="form-labels font-weight500 font-size-subheading" title="Recommended Letter">
                    Recommended Letter
                  </label>
                  <Select
                    options={extendedLetters}
                    isSearchable
                    isClearable
                    title="Recommended Letter "
                    placeholder="Select Letter"
                    value={extendedLetters.find(i => i.value === formData.recomended_letter_num)}
                    noOptionsMessage={() => "No other options"}
                    onChange={handleletterChange2}
                    styles={CSSForSelect20vWWidth}
                  />
                </div>

                {formData.recomended_letter_num !== "null" ? (
                  ""
                ) : (
                  <div
                    className="flex-row "
                    style={{
                      width: "23.5vw",
                      justifyContent: "space-between",
                      marginTop: "15px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-evenly",
                      }}
                    >
                      <div>OR</div>
                    </div>
                    <div className="button-models">
                      <AddTrackRecordDetails
                        projectId={project}
                        letterfor={formData.workperformedby}
                        lettertype="billing"
                        getProjects={getLetters}
                        title="Recomended Letter Details"
                        contractor={contractor}
                      />
                    </div>
                  </div>
                )}


              </div>
            </>
            {/* )} */}
            <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
              <div className="jd-heading-outer-flex " >
                <h2 className="jd-heading-main font-weight600  font-size-heading"> Client Bill Details</h2>
              </div>
              <div>
                <div className="jd-heading-bottom-bold" style={{ width: "160px" }}></div>
                <div className="jd-heading-bottom-light"></div>
              </div>
            </div>




            <div className="form-flex-wrap">
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Client Recomended Bill Date">
                  Client Recomended Bill Date
                </label>
                <input
                  type="date"
                  name="site_recomended_bill_date"
                  title="Client Recomended Bill Date"
                  value={formData.site_recomended_bill_date}
                  onChange={handleDateChange}
                  max={new Date().toISOString().split('T')[0]}

                  className={`form-input-date ${errors.site_recomended_bill_date ? "is-invalid" : ""
                    }`}
                />
                {errors.site_recomended_bill_date && (
                  <div className="error-message font-size-text">
                    {errors.site_recomended_bill_date}
                  </div>
                )}
              </div>

              <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                <div className="jd-heading-outer-flex " >
                  <h2 className="jd-heading-main font-weight600  font-size-heading"> Allowance</h2>
                </div>

              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="GST">
                  Client Work Done Amount
                </label>
                <input
                  type="number"
                  title="Client Work Done Amount "
                  name="site_work_done_amt"
                  placeholder="Work Done Amount "
                  value={formData.site_work_done_amt}
                  onChange={handleInputChange}
                  className={`form-input-date  width-10vw ${errors.site_work_done_amt ? "is-invalid" : ""
                    }`}
                />
                {errors.site_work_done_amt && (
                  <div className="error-message font-size-text">
                    {errors.site_work_done_amt}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Client Escalation">
                  Client Escalation Amount
                </label>
                <input
                  type="number"
                  title="Client Escalation Amount"
                  name="site_escalation"
                  max={formData.escalation}
                  placeholder="Client Escalation Amount"
                  value={formData.site_escalation}
                  onChange={handleInputChange}
                  className={`form-input-date  width-10vw ${errors.site_escalation ? "is-invalid" : ""
                    }`}
                />
                {errors.site_escalation && (
                  <div className="error-message font-size-text">
                    {errors.site_escalation}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title=" Client GST">
                  Client GST Amount <span className="required"></span>
                </label>
                <input
                  type="number"
                  title="Client GST Amount"
                  name="site_gst"
                  placeholder="GST Amount"
                  value={formData.site_gst}
                  onChange={handleInputChange}
                  className={`form-input-date  width-10vw ${errors.site_gst ? "is-invalid" : ""
                    }`}
                />
                {errors.site_gst && (
                  <div className="error-message font-size-text">
                    {errors.site_gst}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Release Withheld Amount">
                  Client Release Withheld Amount
                </label>
                <input
                  type="number"
                  title="Released Withheld Amount"
                  min={0}
                  name="site_released_withheld_amt"
                  placeholder="0"
                  value={formData.site_released_withheld_amt}
                  onChange={handleInputChange}
                  className={`form-input-date  width-10vw ${errors.site_released_withheld_amt ? "is-invalid" : ""
                    }`}
                />
                {errors.site_released_withheld_amt && (
                  <div className="error-message font-size-text">
                    {errors.site_released_withheld_amt}
                  </div>
                )}
              </div>

              {ExistingSiteWithheldRelease
                .filter(
                  (data) =>
                    data.site_released_heading !== null &&
                    data.site_released_amount !== null
                )
                .map((data, index) => (


                  <div className="flex-column">
                    <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                      <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                        <div>
                          <label className="form-labels font-weight500 font-size-subheading">
                            {data.site_released_heading} Amount
                          </label>
                        </div>
                      </div>
                    </div>
                    <input
                      type="number"
                      min={0}
                      name="site_released_amount"
                      placeholder="Enter Amount"
                      value={data.site_released_amount}
                      onChange={(e) => handleExistingSiteWithheldInputChange(e, index)}
                      className="form-input-date"
                    />
                    {errors[`${index}-site_released_amount`] && (
                      <span className="error-message font-size-text">
                        {errors[`${index}-site_released_amount`]}
                      </span>
                    )}
                  </div>
                ))
              }

              <button type='button' title="Add Allowance" className="jd-heading-main font-weight600" onClick={handleAddSiteWitheheldRelease}>
                <AddwithBlueCircle />
                Add a Bill Allowance
              </button>

              <div className="form-flex-wrap" style={{ width: "100%" }}>


                <div className="form-flex-wrap" style={{ width: "100%" }}>
                  {SiteWithheldRelease.map((data, index) => (
                    <>
                      <div className="flex-column">

                        <label className="form-labels font-weight500 font-size-subheading">
                          Client Heading
                        </label>

                        <input

                          type="text"
                          name="site_released_heading"
                          value={data.site_released_heading}
                          onChange={(e) => handleSiteWithheldInputChange(e, index)}
                          placeholder="Enter Heading"
                          style={{ width: "30vw" }}

                          className="form-input"
                        />
                        {errors[`${index}-site_released_heading`] && (
                          <span className="error-message font-size-text">
                            {errors[`${index}-site_released_heading`]}
                          </span>
                        )}
                      </div>
                      <div className="flex-column">
                        <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                          <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                            <div>
                              <label className="form-labels font-weight500 font-size-subheading">
                                Client  Amount
                              </label>
                            </div>
                            {index === SiteWithheldRelease.length - 1 && (
                              <div className="flex-column justify-center">
                                <button

                                  title="Remove Field"
                                  onClick={() => handleRemoveSiteWithheldRelease(index)}
                                  className="file-clear clear-button2"
                                  style={{ width: "1.8vw" }}
                                >
                                  X
                                </button>
                              </div>
                            )}
                          </div >
                          <div >

                          </div>
                        </div>
                        <input

                          type="number"
                          min={0}
                          name="site_released_amount"
                          value={data.site_released_amount}
                          onChange={(e) => handleSiteWithheldInputChange(e, index)}
                          placeholder="Enter Amount"
                          style={{ width: "20vw" }}

                          className="form-input"
                        />
                        {errors[`${index}-site_released_amount`] && (
                          <span className="error-message font-size-text">
                            {errors[`${index}-site_released_amount`]}
                          </span>
                        )}
                      </div>

                    </>
                  ))}
                </div>
              </div>

              <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                <div className="jd-heading-outer-flex " >
                  <h2 className="jd-heading-main font-weight600  font-size-heading"> Deduction</h2>
                </div>
              </div>



              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Client Deduction Amount">
                  Client Deduction  Amount
                </label>
                <input
                  type="number"
                  title="Deduction Amount"
                  name="site_deduction_amount"
                  placeholder="Client Deduction Amount"
                  value={formData.site_deduction_amount}
                  onChange={handleInputChange}
                  className={`form-input  ${errors.site_deduction_amount ? "is-invalid" : ""
                    }`}
                  style={{
                    width: "30vw"
                  }}
                />
                {errors.site_deduction_amount && (
                  <div className="error-message font-size-text">
                    {errors.site_deduction_amount}
                  </div>
                )}


              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title=" Client GST">
                  LD Amount <span className="required"></span>
                </label>
                <input
                  type="number"
                  title=" LD Amount"
                  name="site_ld_amount"
                  placeholder="LD Amount"
                  value={formData.site_ld_amount}
                  onChange={handleInputChange}
                  className={`form-input-date  width-10vw ${errors.site_ld_amount ? "is-invalid" : ""
                    }`}
                />
                {errors.site_ld_amount && (
                  <div className="error-message font-size-text">
                    {errors.site_ld_amount}
                  </div>
                )}
              </div>

              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Withheld Amount">
                  Client Withheld Amount
                </label>
                <input
                  type="number"
                  title="Withheld Amount"
                  min={0}
                  name="site_withheld_amt"
                  placeholder="0"
                  value={formData.site_withheld_amt}
                  onChange={handleInputChange}
                  style={{ width: "20vw" }}
                  className={`form-input ${errors.site_withheld_amt ? "is-invalid" : ""
                    }`}
                />
                {errors.site_withheld_amt && (
                  <div className="error-message font-size-text">
                    {errors.site_withheld_amt}
                  </div>
                )}
              </div>

              {ExistingSiteDeduction
                .filter(
                  (data) =>
                    data.site_deduction_heading !== null &&
                    data.site_deduction_amount !== null
                )
                .map((data, index) => (


                  <div className="flex-column">
                    <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                      <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                        <div>
                          <label className="form-labels font-weight500 font-size-subheading">
                            {data.site_deduction_heading} Amount
                          </label>
                        </div>
                      </div>
                    </div>
                    <input
                      type="number"
                      min={0}
                      name="site_deduction_amount"
                      placeholder="Enter Amount"
                      value={data.site_deduction_amount}
                      onChange={(e) => handleExistingSiteDeductionInputChange(e, index)}
                      className="form-input-date"
                    />
                    {errors[`${index}-site_deduction_amount`] && (
                      <span className="error-message font-size-text">
                        {errors[`${index}-site_deduction_amount`]}
                      </span>
                    )}
                  </div>

                ))
              }
              <button type='button' title="Add Deduction" className="jd-heading-main font-weight600" onClick={handleAddSiteDeductionAmount}>
                <AddwithBlueCircle />
                Add a Bill Deduction
              </button>
              <div className="form-flex-wrap" style={{ width: "100%" }}>

                <div className="form-flex-wrap" style={{ width: "100%" }}>
                  {SiteDeductionData.map((data, index) => (
                    <>
                      <div className="flex-column">

                        <label className="form-labels font-weight500 font-size-subheading">
                          Client Heading
                        </label>

                        <input

                          type="text"
                          style={{ width: "30vw" }}
                          name="site_deduction_heading"
                          value={data.site_deduction_heading}
                          onChange={(e) => handleSiteDeductionInputChange(e, index)}
                          placeholder="Enter Heading"
                          className="form-input"
                        />
                        {errors[`${index}-site_deduction_heading`] && (
                          <span className="error-message font-size-text">
                            {errors[`${index}-site_deduction_heading`]}
                          </span>
                        )}
                      </div>
                      <div className="flex-column">
                        <div className="expense-req" style={{ width: "100%", marginLeft: "0px" }}>
                          <div className="flex-row justify-beetween" style={{ width: "100%" }}>
                            <div>
                              <label className="form-labels font-weight500 font-size-subheading">
                                Client  Amount
                              </label>
                            </div>
                            {index === SiteDeductionData.length - 1 && (
                              <div className="flex-column justify-center">
                                <button

                                  title="Remove Field"
                                  onClick={() => handleRemoveSiteDeduction(index)}
                                  className="file-clear clear-button2"
                                  style={{ width: "1.8vw" }}
                                >
                                  X
                                </button>
                              </div>
                            )}
                          </div >
                          <div >

                          </div>
                        </div>
                        <input

                          type="number"
                          min={0}
                          name="site_deduction_amount"
                          style={{ width: "20vw" }}

                          value={data.site_deduction_amount}
                          onChange={(e) => handleSiteDeductionInputChange(e, index)}
                          placeholder="Enter Amount"
                          className="form-input"
                        />
                        {errors[`${index}-site_deduction_amount`] && (
                          <span className="error-message font-size-text">
                            {errors[`${index}-site_deduction_amount`]}
                          </span>
                        )}
                      </div>

                    </>
                  ))}
                </div>
              </div>
              <div className="flex-column" style={{ width: "100%", marginBottom: "10px" }}>
                <div className="jd-heading-outer-flex " >
                  <h2 className="jd-heading-main font-weight600  font-size-heading"> Total</h2>
                </div>

              </div>

              <div className="flex-column">
                <label
                  className="form-labels font-weight500 font-size-subheading"
                  title="Client Approve Bill Amount"
                >
                  Client Approve  <br /> Bill Amount<span className="required">(Read-Only)</span>
                </label>
                <input
                  type="number"
                  title="Client Approve Bill Amount"
                  placeholder="Client Approve Bill Amount"
                  disabled
                  name="site_recommended_bill_amount"
                  value={formData.site_recommended_bill_amount}
                  className={`form-input-date ${errors.site_recommended_bill_amount ? "is-invalid" : ""
                    }`}
                  style={{ width: "15vw" }}
                />
                {errors.site_recommended_bill_amount && (
                  <div className="error-message font-size-text">
                    {errors.site_recommended_bill_amount}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Client Approve Percentage">
                  Client Approve <br /> Percentage<span className="required">(Read-Only)</span>
                </label>
                <input
                  type="number"
                  title=" Client Approve Percentage"
                  name="site_recommended_percentage"
                  placeholder=" 0"
                  style={{ width: "15vw" }}

                  value={formData.site_recommended_percentage}
                  onChange={handleInputChange}
                  className={`form-input-date ${errors.site_recommended_percentage ? "is-invalid" : ""
                    }`}
                />
                {errors.site_recommended_percentage && (
                  <div className="error-message font-size-text">
                    {errors.site_recommended_percentage}
                  </div>
                )}
              </div>
              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Client Approve Percentage Amount">
                  Client Approve <br /> Percentage Amount
                </label>
                <input
                  type="number"
                  title=" Client Approve Percentage Amount"
                  name="site_percentage_amt"
                  placeholder="0"
                  style={{ width: "15vw" }}

                  // readOnly
                  value={formData.site_percentage_amt}

                  onChange={handleInputChange}
                  className={`form-input-date ${errors.site_percentage_amt ? "is-invalid" : ""
                    }`}
                />
                {errors.site_percentage_amt && (
                  <div className="error-message font-size-text">
                    {errors.site_percentage_amt}
                  </div>
                )}
              </div>



              <div className="flex-column">
                <label className="form-labels font-weight500 font-size-subheading" title="Client Rermark">
                  {" "}
                  Client Remark
                </label>
                <textarea
                  type="text"
                  name="site_remark"
                  title="Client Remarks"
                  placeholder="Client Remark"
                  value={formData.site_remark}
                  onChange={handleInputChange}
                  style={{ width: "35vw" }}

                  className={`form-input-date ${errors.site_remark ? "is-invalid" : ""
                    }`}
                />
                {errors.site_remark && (
                  <div className="error-message font-size-text">
                    {errors.site_remark}
                  </div>
                )}
              </div>

            </div>


          </div>
          <div className="button-models">
            <button
              className="model-button font-weight500 model-button-leave font-size-heading"
              onClick={handleFormSubmit}
              disabled={loading}
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </Modal.Body>
      </Modal >
    </>
  );
};

// const UpdateBill = ({
//   i,
//   project,
//   cosData,
//   getProjects,
//   contractor,
//   getdeducitonData,
//   deductionData
// }) => {
//   const [show, setShow] = useState(false);
//   const [activeSection, setActiveSection] = useState('basic');
//   const [tabValidationAttempted, setTabValidationAttempted] = useState({});

//   const sections = [
//     { id: 'basic', label: 'Basic Info', icon: FileText },
//     { id: 'contractor', label: 'Contractor Billing Details', icon: Building2 },
//     { id: 'ae', label: 'AE/IE Details', icon: CheckCircle },
//     { id: 'client', label: 'Client Details', icon: Award },
//   ];

//   // Define required fields for each tab
//   const tabRequiredFields = {
//     basic: ["bill_type", "bill_num", "bill_period_start", "bill_period_end", "submitted_bill_date", "bill_catagory"],
//     contractor: [],
//     ae: [],
//     client: []
//   };

//   const handleShow = () => {
//     setShow(true);
//     getLetters();
//     const filteredData = { ...i };
//     delete filteredData.ho_attachment;
//     delete filteredData.site_attachment;
//     delete filteredData.previous_amount;
//     delete filteredData.remaining_amount;
//     delete filteredData.cummulative_amount;

//     setFormData(filteredData);
//   };

//   const handleClose = () => {
//     setShow(false);
//     setContractorDeductionData([]);
//     setContractorWithheldRelease([]);
//     setSiteDeductionData([]);
//     setSiteWithheldRelease([]);
//     setHOWithheldRelease([]);
//     setHODeductionData([]);
//     setActiveSection('basic');
//     setTabValidationAttempted({});
//   };

//   const [formData, setFormData] = useState({
//     project: project ? project : "",
//     date: null,
//     bill_type: "",
//     contractor_name: "",
//     work_done_amt: "",
//     bill_num: "",
//     bill_period_start: null,
//     bill_period_end: null,
//     billing_date: null,
//     bill_catagory: "",
//     workperformedby: "contractor",
//     site_percentage_amt: "",
//     recommended_bill_amount: "",
//     recommended_percentage: "",
//     recomended_bill_date: null,
//     ho_percentage_amt: "",
//     submitted_bill_amount: "",
//     submitted_bill_date: null,
//     submitted_percentage: "",
//     percentage_amt: "",
//     submitted_letter_num: "",
//     recomended_letter_num: "",
//     deduction_amount: "",
//     ld_amount: "",
//     withheld_amt: "",
//     released_withheld_amt: "",
//     contractor_withheld: " 0",
//     contractor_withheld_release: "0",
//     remark: "",
//     site_recomended_bill_date: null,
//     site_recommended_bill_amount: "",
//     site_recommended_percentage: "",
//     site_ld_amount: "",
//     site_withheld_amt: "",
//     site_released_withheld_amt: "",
//     site_deduction_amount: "",
//     site_remark: "",
//     site_attachment: "",
//     ho_attachment: "",
//     escalation: "",
//     gst: "",
//     site_escalation: "",
//     site_gst: "",
//     ho_escalation: "",
//     ho_gst: "",
//     contractor_deduction_amt: "",
//     ho_work_done_amt: "",
//     site_work_done_amt: "",
//     contractor: contractor,
//     cos: null,
//     cos_amount: null,
//   });

//   useEffect(() => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       contractor: contractor,
//     }));
//   }, [contractor]);

//   const { deduction_amount, submitted_bill_amount, recommended_bill_amount, site_deduction_amount, site_recommended_bill_amount } = formData;

//   const [trackRecordList, setTrackRecordList] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});

//   const getLetters = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/siteproject/letterrecordbyfilters/${project}/contractor/billing/`);
//       setTrackRecordList(res.data);
//     } catch (err) {
//       toast.error("Error fetching letters.");
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     const requiredFields = [
//       "bill_type",
//       "bill_num",
//       "bill_period_start",
//       "bill_period_end",
//       "submitted_bill_date",
//       "bill_catagory",
//       "submitted_bill_amount",
//     ];

//     requiredFields.forEach((field) => {
//       if (!formData[field]) {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//       }
//     });

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // **********************************Dynamic Deduction and Withheld functionality *****************************************//
//   const fileInputRefs = useRef([]);

//   const [ContractorWithheldRelease, setContractorWithheldRelease] = useState([]);
//   const [ContractorDeductionData, setContractorDeductionData] = useState([]);
//   const [SiteWithheldRelease, setSiteWithheldRelease] = useState([]);
//   const [SiteDeductionData, setSiteDeductionData] = useState([]);
//   const [HOWithheldRelease, setHOWithheldRelease] = useState([]);
//   const [HODeductionData, setHODeductionData] = useState([]);
//   const [ExistingContractorWithheldRelease, setExistingContractorWithheldRelease] = useState([
//     {
//       contractor_releasing_heading: "",
//       contractor_releasing_amount: "",
//     }]);
//   const [ExistingContractorDeduction, setExistingContractorDeduction] = useState([
//     {
//       contractor_deduction_heading: "",
//       contractor_deduction_amount: "",
//     }]);
//   const [ExistingSiteWithheldRelease, setExistingSiteWithheldRelease] = useState([
//     {
//       site_released_heading: "",
//       site_released_amount: "",
//     }]);
//   const [ExistingSiteDeduction, setExistingSiteDeduction] = useState([
//     {
//       site_deduction_heading: "",
//       site_deduction_amount: "",
//     }]);
//   const [ExistingHOWithheldRelease, setExistingHOWithheldRelease] = useState([
//     {
//       HO_released_heading: "",
//       HO_released_amount: "",
//     }]);
//   const [ExistingHODeduction, setExistingHODeduction] = useState([
//     {
//       HO_deduction_heading: "",
//       HO_deduction_amount: "",
//     }]);
//   const [totalContractorWithheldAmount, settotalContractorWithheldAmount] = useState("0");
//   const [totalExistingContractorWithheldAmount, settotalExistingContractorWithheldAmount] = useState("0");
//   const [totalContractorDeductionAmount, settotalContractorDeductionAmount] = useState("0");
//   const [ExistingtotalContractorDeductionAmount, setExistingtotalContractorDeductionAmount] = useState("0");
//   const [totalSiteWithehldAmounnt, settotalSiteWithehldAmounnt] = useState("0");
//   const [totalExistingSiteWithehldAmounnt, settotalExistingSiteWithehldAmounnt] = useState("0");
//   const [totalSiteDeductionAmount, settotalSiteDeductionAmount] = useState("0");
//   const [totalExistingSiteDeductionAmount, settotalExistingSiteDeductionAmount] = useState("0");
//   const [totalHOReleaseAmount, settotalHOReleaseAmount] = useState("0");
//   const [totalExistingHOReleaseAmount, settotalExistingHOReleaseAmount] = useState("0");
//   const [totalHODeductionAmount, settotalHODeductionAmount] = useState("0");
//   const [totalExistingHODeductionAmount, settotalExistingHODeductionAmount] = useState("0");

//   const billingID = i.id;

//   const getData = async () => {
//     try {
//       const res = await axios.get(`${BASE_URL}/siteproject/deductionsfilter/null/${i.id}/`);
//       const data = res.data || [];

//       const contractorWithheld = data.filter(
//         item => item.contractor_releasing_heading && item.contractor_releasing_amount != null
//       );
//       const contractorDeduction = data.filter(
//         item => item.contractor_deduction_heading && item.contractor_deduction_amount != null
//       );
//       const siteWithheld = data.filter(
//         item => item.site_released_heading && item.site_released_amount != null
//       );
//       const siteDeduction = data.filter(
//         item => item.site_deduction_heading && item.site_deduction_amount != null
//       );
//       const hoWithheld = data.filter(
//         item => item.HO_released_heading && item.HO_released_amount != null
//       );
//       const hoDeduction = data.filter(
//         item => item.HO_deduction_heading && item.HO_deduction_amount != null
//       );

//       setExistingContractorWithheldRelease(contractorWithheld);
//       setExistingContractorDeduction(contractorDeduction);
//       setExistingSiteWithheldRelease(siteWithheld);
//       setExistingSiteDeduction(siteDeduction);
//       setExistingHOWithheldRelease(hoWithheld);
//       setExistingHODeduction(hoDeduction);
//     } catch (error) {
//       console.error("Error fetching data:", error);
//     }
//   };

//   useEffect(() => {
//     if (show === true) {
//       getData();
//     }
//   }, [show])

//   const handleAddContractorWitheheldRelease = (e) => {
//     e.preventDefault();
//     setContractorWithheldRelease((prevFormData) => [
//       ...prevFormData,
//       {
//         contractor_releasing_heading: "",
//         contractor_releasing_amount: "0",
//         billing: billingID,
//       },
//     ]);
//   };
//   const handleAddContractorDeduction = (e) => {
//     e.preventDefault();
//     setContractorDeductionData((prevFormData) => [
//       ...prevFormData,
//       {
//         contractor_deduction_heading: "",
//         contractor_deduction_amount: "0",
//         billing: "",
//       },
//     ]);
//   };
//   const handleAddSiteWitheheldRelease = (e) => {
//     e.preventDefault();
//     setSiteWithheldRelease((prevFormData) => [
//       ...prevFormData,
//       {
//         site_released_heading: "",
//         site_released_amount: "0",
//         billing: "",
//       },
//     ]);
//   };
//   const handleAddSiteDeductionAmount = (e) => {
//     e.preventDefault();
//     setSiteDeductionData((prevFormData) => [
//       ...prevFormData,
//       {
//         site_deduction_heading: "",
//         site_deduction_amount: "0",
//         billing: "",
//       },
//     ]);
//   };
//   const handleAddHOWitheheldRelease = (e) => {
//     e.preventDefault();
//     setHOWithheldRelease((prevFormData) => [
//       ...prevFormData,
//       {
//         HO_released_heading: "",
//         HO_released_amount: "0",
//         billing: "",
//       },
//     ]);
//   };
//   const handleAddHOdeduction = (e) => {
//     e.preventDefault();
//     setHODeductionData((prevFormData) => [
//       ...prevFormData,
//       {
//         HO_deduction_heading: "",
//         HO_deduction_amount: "0",
//         billing: "",
//       },
//     ]);
//   };

//   const handleRemoveContractorWithheldRelease = (index) => {
//     setContractorWithheldRelease((prevFormData) => {
//       const updatedData = prevFormData.filter((_, i) => i !== index);
//       return [...updatedData];
//     });
//     fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
//   };
//   const handleRemoveContractorDeduction = (index) => {
//     setContractorDeductionData((prevFormData) => {
//       const updatedData = prevFormData.filter((_, i) => i !== index);
//       return [...updatedData];
//     });
//     fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
//   };
//   const handleRemoveSiteWithheldRelease = (index) => {
//     setSiteWithheldRelease((prevFormData) => {
//       const updatedData = prevFormData.filter((_, i) => i !== index);
//       return [...updatedData];
//     });
//     fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
//   };
//   const handleRemoveSiteDeduction = (index) => {
//     setSiteDeductionData((prevFormData) => {
//       const updatedData = prevFormData.filter((_, i) => i !== index);
//       return [...updatedData];
//     });
//     fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
//   };
//   const handleRemoveHOWitheld = (index) => {
//     setHOWithheldRelease((prevFormData) => {
//       const updatedData = prevFormData.filter((_, i) => i !== index);
//       return [...updatedData];
//     });
//     fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
//   };
//   const handleRemoveHODeduction = (index) => {
//     setHODeductionData((prevFormData) => {
//       const updatedData = prevFormData.filter((_, i) => i !== index);
//       return [...updatedData];
//     });
//     fileInputRefs.current = fileInputRefs.current.filter((_, i) => i !== index);
//   };

//   const handleContractorWithheldInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setContractorWithheldRelease((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });

//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };
//   const handleExistingContractorWithheldInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setExistingContractorWithheldRelease((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });

//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };
//   const handleContractorDeductionInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setContractorDeductionData((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });

//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };
//   const handleExistingContractorDeductionInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setExistingContractorDeduction((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });

//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };
//   const handleSiteWithheldInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setSiteWithheldRelease((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });

//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };
//   const handleExistingSiteWithheldInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setExistingSiteWithheldRelease((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });

//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };
//   const handleSiteDeductionInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setSiteDeductionData((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });
//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   }
//   const handleExistingSiteDeductionInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setExistingSiteDeduction((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });

//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };
//   const handleHOWithheldInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setHOWithheldRelease((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });

//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   }
//   const handleExistingHOWithheldInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setExistingHOWithheldRelease((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });

//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };
//   const handleHODeductionInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setHODeductionData((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });

//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };
//   const handleExistingHODeductionInputChange = (e, index) => {
//     const { name, value } = e.target;
//     setExistingHODeduction((prevFormData) => {
//       const newFields = [...prevFormData];
//       newFields[index] = {
//         ...newFields[index],
//         [name]: value,
//       };
//       return newFields;
//     });

//     setErrors((prevErrors) => {
//       const newErrors = { ...prevErrors };
//       if (value.trim() !== "") {
//         delete newErrors[`${index}-${name}`];
//       }
//       return newErrors;
//     });
//   };

//   useEffect(() => {
//     const safeSum = (arr, key) => {
//       if (!Array.isArray(arr)) return 0;
//       return arr.reduce((acc, curr) => {
//         const val = curr?.[key];
//         return acc + (val !== undefined && val !== null ? parseFloat(val) || 0 : 0);
//       }, 0);
//     };

//     const totalContractorWithheldRelease = safeSum(ContractorWithheldRelease, "contractor_releasing_amount");
//     const totalExistingContractorWithheldRelease = safeSum(ExistingContractorWithheldRelease, "contractor_releasing_amount");
//     const totalContractorDeduction = safeSum(ContractorDeductionData, "contractor_deduction_amount");
//     const totalExistingContractorDeduction = safeSum(ExistingContractorDeduction, "contractor_deduction_amount");
//     const totalSiteWithheldRelease = safeSum(SiteWithheldRelease, "site_released_amount");
//     const totalExistingSiteWithheldRelease = safeSum(ExistingSiteWithheldRelease, "site_released_amount");
//     const totalSiteDeductionData = safeSum(SiteDeductionData, "site_deduction_amount");
//     const totalExistingSiteDeductionData = safeSum(ExistingSiteDeduction, "site_deduction_amount");
//     const totalHOWithheldRelease = safeSum(HOWithheldRelease, "HO_released_amount");
//     const totalExistingHOWithheldRelease = safeSum(ExistingHOWithheldRelease, "HO_released_amount");
//     const totalHODeductionData = safeSum(HODeductionData, "HO_deduction_amount");
//     const totalExistingHODeductionData = safeSum(ExistingHODeduction, "HO_deduction_amount");

//     settotalContractorWithheldAmount(totalContractorWithheldRelease);
//     settotalExistingContractorWithheldAmount(totalExistingContractorWithheldRelease);
//     settotalContractorDeductionAmount(totalContractorDeduction);
//     settotalSiteWithehldAmounnt(totalSiteWithheldRelease);
//     settotalSiteDeductionAmount(totalSiteDeductionData);
//     settotalHOReleaseAmount(totalHOWithheldRelease);
//     settotalHODeductionAmount(totalHODeductionData);
//     setExistingtotalContractorDeductionAmount(totalExistingContractorDeduction);
//     settotalExistingSiteWithehldAmounnt(totalExistingSiteWithheldRelease);
//     settotalExistingSiteDeductionAmount(totalExistingSiteDeductionData);
//     settotalExistingHOReleaseAmount(totalExistingHOWithheldRelease);
//     settotalExistingHODeductionAmount(totalExistingHODeductionData);
//   }, [
//     ContractorWithheldRelease,
//     ContractorDeductionData,
//     SiteWithheldRelease,
//     SiteDeductionData,
//     HOWithheldRelease,
//     HODeductionData,
//     ExistingContractorWithheldRelease,
//     ExistingContractorDeduction,
//     ExistingSiteWithheldRelease,
//     ExistingSiteDeduction,
//     ExistingHOWithheldRelease,
//     ExistingHODeduction,
//   ]);

//   // *************************************End of Dynamic Deduction and Withheld functionality **********************************************//

//   const [isError, setIsError] = useState(false);

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     setFormData((prevFormData) => {
//       let updatedFormData = { ...prevFormData, [name]: value };
//       const errorsToSet = { ...errors };

//       if (name === "bill_period_start") {
//         const selectedDate = new Date(value);
//         const todayDate = new Date();
//         todayDate.setHours(0, 0, 0, 0);
//         selectedDate.setHours(0, 0, 0, 0);
//         if (selectedDate > todayDate) {
//           errorsToSet[name] = "Date cannot be greater than today.";
//         } else {
//           delete errorsToSet[name];
//         }
//       }

//       if (name === "recommended_bill_amount" || name === "deduction_amount") {
//         const maxLimit = prevFormData.submitted_bill_amount;
//         const { success, error } = inputMaxLimit(name, value, maxLimit);
//         if (!success) {
//           errorsToSet[name] = error;
//         } else {
//           delete errorsToSet[name];
//         }
//       }

//       const LimitValues = {
//         escalation: "work_done_amt",
//         gst: "work_done_amt",
//         contractor_deduction_amt: "work_done_amt",
//         site_escalation: "site_work_done_amt",
//         site_gst: "site_work_done_amt",
//         site_deduction_amount: "site_work_done_amt",
//         ho_escalation: "ho_work_done_amt",
//         ho_gst: "ho_work_done_amt",
//         deduction_amount: "ho_work_done_amt",
//         ...(formData.bill_type === "ra" && {
//           work_done_amt: "cos_amount",
//         }),
//       };

//       const escalationLimitFields = {
//         site_escalation: "escalation",
//         ho_escalation: "escalation",
//       };

//       const gstLimitFields = {
//         site_gst: "gst",
//         ho_gst: "gst",
//       };

//       const workDoneLimitFields = {
//         site_work_done_amt: "work_done_amt",
//         ho_work_done_amt: "work_done_amt",
//       };

//       const submittedamoutLimitedField = {
//         site_recommended_bill_amount: "submitted_bill_amount",
//         recommended_bill_amount: "submitted_bill_amount",
//       };

//       const percemntageAmount = {
//         percentage_amt: "submitted_bill_amount",
//         ho_percentage_amt: "recommended_bill_amount",
//         site_percentage_amt: "site_recommended_bill_amount",
//       };

//       const validateLimit = (limitFields) => {
//         if (limitFields[name]) {
//           const limitField = limitFields[name];
//           const limitValue = parseFloat(prevFormData[limitField] || 0);
//           const fieldValue = parseFloat(value || 0);
//           if (fieldValue > limitValue) {
//             errorsToSet[name] = `${name.replaceAll("_", " ")} amount cannot be greater than ${limitValue}.`;
//           } else {
//             delete errorsToSet[name];
//           }
//         }
//       };

//       validateLimit(escalationLimitFields);
//       validateLimit(gstLimitFields);
//       validateLimit(workDoneLimitFields);
//       validateLimit(submittedamoutLimitedField);
//       validateLimit(LimitValues);
//       validateLimit(percemntageAmount);

//       const submittedPercentageAmount = parseFloat(updatedFormData.percentage_amt || 0);
//       const site_percentage_amt = parseFloat(updatedFormData.site_percentage_amt || 0);
//       const ho_percentage_amt = parseFloat(updatedFormData.ho_percentage_amt || 0);

//       updatedFormData = {
//         ...updatedFormData,
//         submitted_percentage: (
//           (submittedPercentageAmount / updatedFormData.submitted_bill_amount) *
//           100
//         ).toFixed(2),
//         site_recommended_percentage: (
//           (site_percentage_amt / updatedFormData.site_recommended_bill_amount) *
//           100
//         ).toFixed(2),
//         recommended_percentage: (
//           (ho_percentage_amt / updatedFormData.recommended_bill_amount) *
//           100
//         ).toFixed(2),
//       };

//       const filteredErrors = Object.fromEntries(
//         Object.entries(errorsToSet).filter(
//           ([_, val]) => val !== "" && val !== undefined
//         )
//       );

//       setErrors(filteredErrors);
//       setIsError(Object.keys(filteredErrors).length > 0);

//       return updatedFormData;
//     });
//   };

//   useEffect(() => {
//     const updatedSubmittedAmount = (
//       parseFloat(formData.work_done_amt || 0) +
//       parseFloat(formData.gst || 0) +
//       parseFloat(formData.escalation || 0) +
//       parseFloat(formData.contractor_withheld_release || 0) +
//       parseFloat(totalContractorWithheldAmount) +
//       parseFloat(totalExistingContractorWithheldAmount) -
//       (
//         parseFloat(formData.contractor_deduction_amt || 0) +
//         parseFloat(formData.contractor_withheld || 0) +
//         parseFloat(totalContractorDeductionAmount) +
//         parseFloat(ExistingtotalContractorDeductionAmount)
//       )
//     );

//     const updatedSiteSubmittedAmount = (
//       parseFloat(formData.site_work_done_amt || 0) +
//       parseFloat(formData.site_gst || 0) +
//       parseFloat(formData.site_escalation || 0) +
//       parseFloat(formData.site_released_withheld_amt || 0) +
//       parseFloat(totalSiteWithehldAmounnt) +
//       parseFloat(totalExistingSiteWithehldAmounnt) -
//       (
//         parseFloat(formData.site_deduction_amount || 0) +
//         parseFloat(formData.site_withheld_amt || 0) +
//         parseFloat(totalSiteDeductionAmount) +
//         parseFloat(totalExistingSiteDeductionAmount)
//       )
//     );

//     const updateHOSubmittedAmount = (
//       parseFloat(formData.ho_work_done_amt || 0) +
//       parseFloat(formData.ho_gst || 0) +
//       parseFloat(formData.ho_escalation || 0) +
//       parseFloat(formData.released_withheld_amt || 0) +
//       parseFloat(totalHOReleaseAmount) +
//       parseFloat(totalExistingHOReleaseAmount) -
//       (
//         parseFloat(formData.deduction_amount || 0) +
//         parseFloat(formData.withheld_amt || 0) +
//         parseFloat(totalHODeductionAmount) +
//         parseFloat(totalExistingHODeductionAmount)
//       )
//     );

//     const submittedPercentageAmount = parseFloat(formData.percentage_amt || 0);
//     const sitePercentageAmt = parseFloat(formData.site_percentage_amt || 0);
//     const hoPercentageAmt = parseFloat(formData.ho_percentage_amt || 0);

//     setFormData(prev => ({
//       ...prev,
//       submitted_bill_amount: updatedSubmittedAmount.toFixed(),
//       site_recommended_bill_amount: updatedSiteSubmittedAmount.toFixed(),
//       recommended_bill_amount: updateHOSubmittedAmount.toFixed(),
//       submitted_percentage: updatedSubmittedAmount
//         ? ((submittedPercentageAmount / updatedSubmittedAmount) * 100).toFixed(2)
//         : "0",
//       site_recommended_percentage: updatedSiteSubmittedAmount
//         ? ((sitePercentageAmt / updatedSiteSubmittedAmount) * 100).toFixed(2)
//         : "0",
//       recommended_percentage: updateHOSubmittedAmount
//         ? ((hoPercentageAmt / updateHOSubmittedAmount) * 100).toFixed(2)
//         : "0",
//     }));
//   }, [
//     formData.work_done_amt,
//     formData.gst,
//     formData.escalation,
//     formData.contractor_withheld_release,
//     formData.contractor_deduction_amt,
//     formData.contractor_withheld,
//     formData.site_work_done_amt,
//     formData.site_gst,
//     formData.site_escalation,
//     formData.site_released_withheld_amt,
//     formData.site_withheld_amt,
//     formData.site_deduction_amount,
//     formData.ho_work_done_amt,
//     formData.ho_gst,
//     formData.ho_escalation,
//     formData.released_withheld_amt,
//     formData.withheld_amt,
//     formData.deduction_amount,
//     formData.percentage_amt,
//     formData.site_percentage_amt,
//     formData.ho_percentage_amt,
//     totalContractorWithheldAmount,
//     totalContractorDeductionAmount,
//     totalSiteDeductionAmount,
//     totalSiteWithehldAmounnt,
//     totalHODeductionAmount,
//     totalHOReleaseAmount,
//     totalExistingContractorWithheldAmount,
//     ExistingtotalContractorDeductionAmount,
//     totalExistingSiteWithehldAmounnt,
//     totalExistingSiteDeductionAmount,
//     totalExistingHOReleaseAmount,
//     totalExistingHODeductionAmount,
//   ]);

//   const handleFileChange = (e) => {
//     const { name } = e.target;
//     const file = e.target.files[0];
//     if (file) {
//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         [name]: file,
//       }));
//     }
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();

//     const updatedfromdata = {
//       ...formData,
//     };

//     if (!isError && validateForm()) {
//       setLoading(true);
//       const loadingToastId = toast.loading("Loading: Please wait...");

//       try {
//         const formDataToSend = new FormData();

//         Object.keys(updatedfromdata).forEach((key) => {
//           if (updatedfromdata[key] && key !== "site_attachment" && key !== "ho_attachment") {
//             formDataToSend.append(key, updatedfromdata[key]);
//           }
//         });

//         if (updatedfromdata.site_attachment) {
//           formDataToSend.append("site_attachment", updatedfromdata.site_attachment);
//         }
//         if (updatedfromdata.ho_attachment) {
//           formDataToSend.append("ho_attachment", updatedfromdata.ho_attachment);
//         }

//         const res = await axiosInstance2.put(
//           `${BASE_URL}/siteproject/billingdetailfield/${i.id}/`,
//           formDataToSend
//         );

//         if (res.status === 200) {
//           const generateId = res.data.id;
//           const isPostDataFilled = [...ContractorWithheldRelease, ...ContractorDeductionData, ...SiteWithheldRelease, ...SiteDeductionData, ...HOWithheldRelease, ...HODeductionData].some(data =>
//             Object.values(data).some(value => value !== "" && value !== "null")
//           );
//           const isDataFilled = [...ExistingContractorWithheldRelease, ...ExistingContractorDeduction, ...ExistingSiteWithheldRelease, ...ExistingSiteDeduction, ...ExistingHOWithheldRelease, ...ExistingHODeduction].some(data =>
//             Object.values(data).some(value => value !== "" && value !== "null")
//           );

//           if (isPostDataFilled) {
//             const updatedContractorWithheld = ContractorWithheldRelease.map((data) => ({
//               ...data,
//               billing: generateId,
//             }));
//             const updatedContractorDeduction = ContractorDeductionData.map((data) => ({
//               ...data,
//               billing: generateId,
//             }));
//             const updatedSiteWithheld = SiteWithheldRelease.map((data) => ({
//               ...data,
//               billing: generateId,
//             }));
//             const updatedSiteDeduction = SiteDeductionData.map((data) => ({
//               ...data,
//               billing: generateId,
//             }));
//             const updatedHOWithheldRelease = HOWithheldRelease.map((data) => ({
//               ...data,
//               billing: generateId,
//             }));
//             const updatedHODeduction = HODeductionData.map((data) => ({
//               ...data,
//               billing: generateId,
//             }));

//             const mergedData = [...updatedContractorWithheld, ...updatedContractorDeduction, ...updatedSiteWithheld, ...updatedSiteDeduction, ...updatedHOWithheldRelease, ...updatedHODeduction];

//             await axios.post(
//               `${BASE_URL}/siteproject/otherdeducationbulkUpload/`,
//               mergedData
//             );
//           }
//           if (isDataFilled) {
//             const mergedDataaa = [...ExistingContractorWithheldRelease, ...ExistingContractorDeduction, ...ExistingSiteWithheldRelease, ...ExistingSiteDeduction, ...ExistingHOWithheldRelease, ...ExistingHODeduction];
//             const ishaveData1 = [...ExistingContractorWithheldRelease].some(data =>
//               Object.values(data).some(value => value !== "" && value !== "null")
//             );
//             const ishaveData2 = [...ExistingContractorDeduction].some(data =>
//               Object.values(data).some(value => value !== "" && value !== "null")
//             );
//             const ishaveData3 = [...ExistingSiteWithheldRelease].some(data =>
//               Object.values(data).some(value => value !== "" && value !== "null")
//             );
//             const ishaveData4 = [...ExistingSiteDeduction].some(data =>
//               Object.values(data).some(value => value !== "" && value !== "null")
//             );
//             const ishaveData5 = [...ExistingHOWithheldRelease].some(data =>
//               Object.values(data).some(value => value !== "" && value !== "null")
//             );
//             const ishaveData6 = [...ExistingHODeduction].some(data =>
//               Object.values(data).some(value => value !== "" && value !== "null")
//             );
//             if (ishaveData1) {
//               await axios.put(
//                 `${BASE_URL}/siteproject/OtherDeducationBulkUpdate/`,
//                 ExistingContractorWithheldRelease
//               );
//             }
//             if (ishaveData2) {
//               await axios.put(
//                 `${BASE_URL}/siteproject/OtherDeducationBulkUpdate/`,
//                 ExistingContractorDeduction
//               );
//             }
//             if (ishaveData3) {
//               await axios.put(
//                 `${BASE_URL}/siteproject/OtherDeducationBulkUpdate/`,
//                 ExistingSiteWithheldRelease
//               );
//             }
//             if (ishaveData4) {
//               await axios.put(
//                 `${BASE_URL}/siteproject/OtherDeducationBulkUpdate/`,
//                 ExistingSiteDeduction
//               );
//             }
//             if (ishaveData5) {
//               await axios.put(
//                 `${BASE_URL}/siteproject/OtherDeducationBulkUpdate/`,
//                 ExistingHOWithheldRelease
//               );
//             }
//             if (ishaveData6) {
//               await axios.put(
//                 `${BASE_URL}/siteproject/OtherDeducationBulkUpdate/`,
//                 ExistingHODeduction
//               );
//             }
//           }

//           toast.dismiss(loadingToastId);
//           toast.success("Billing detail Updated successfully!");
//           handleClose();
//           getProjects();
//         } else {
//           toast.dismiss(loadingToastId);
//           toast.error("Failed to add bill detail!");
//         }
//       } catch (err) {
//         toast.dismiss(loadingToastId);
//         toast.error("Error processing your request.");
//       } finally {
//         setLoading(false);
//       }
//     }
//   };

//   //  *********************************Bill Type Select Option **********************************//
//   const billType = [
//     { value: "sps", label: "SPS" },
//     { value: "ipc", label: "IPC" },
//     { value: "milestonebill", label: "MileStone Bill" },
//     { value: "maintainance", label: "Maintainance" },
//     { value: "ra", label: "RA" },
//     { value: "annuitypayment", label: "Annuity Payment" },
//   ];

//   const billTypeOption = billType.sort((a, b) => a.label - b.label).map((i) => ({
//     value: i.value,
//     label: i.label
//   }));

//   const handleBilltypeChange = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({
//         ...formData,
//         bill_type: "null",
//       })
//     }
//     else {
//       setFormData({
//         ...formData,
//         bill_type: selectedOption.value,
//       });
//     }
//   };

//   //  *********************************Bill Category Select Option **********************************//
//   const billCategory = [
//     { value: "balancebills", label: "Balance Bills" },
//     { value: "bills", label: "Bills" },
//   ];

//   const billCategoryOption = billCategory.sort((a, b) => a.label - b.label).map((i) => ({
//     value: i.value,
//     label: i.label
//   }));

//   const handleBillCategoryChange = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({
//         ...formData,
//         bill_catagory: "null",
//       })
//     }
//     else {
//       setFormData({
//         ...formData,
//         bill_catagory: selectedOption.value,
//       });
//     }
//   };

//   //  *********************************Letter Select Option **********************************//
//   const letter = trackRecordList.map((i) => ({
//     value: i.id,
//     label: i.letter_num
//   }));

//   const letterOption = letter.sort((a, b) => a.label - b.label).map((i) => ({
//     value: i.value,
//     label: i.label
//   }));

//   const extendedLetters = [
//     { value: "null", label: "Select Letter" },
//     ...letterOption,
//   ];

//   const handleletterChange = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({
//         ...formData,
//         submitted_letter_num: "null",
//       })
//     }
//     else {
//       setFormData({
//         ...formData,
//         submitted_letter_num: selectedOption.value,
//       });
//     }
//   };
//   const handleletterChange2 = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({
//         ...formData,
//         recomended_letter_num: "null",
//       })
//     }
//     else {
//       setFormData({
//         ...formData,
//         recomended_letter_num: selectedOption.value,
//       });
//     }
//   };

//   useEffect(() => {
//     const totalAmount = Number(formData.work_done_amt) + Number(formData.escalation);
//     const gst_amount = totalAmount * 0.18;
//     const totalAEAmount = Number(formData.ho_work_done_amt) + Number(formData.ho_escalation);
//     const aegst_amount = totalAEAmount * 0.18;
//     const totalClientAmount = Number(formData.site_work_done_amt) + Number(formData.site_escalation);
//     const clientgst_amount = totalClientAmount * 0.18;

//     setFormData((prev) => ({
//       ...prev,
//       gst: gst_amount
//     }))
//     setFormData((prev) => ({
//       ...prev,
//       site_gst: clientgst_amount
//     }))
//     setFormData((prev) => ({
//       ...prev,
//       ho_gst: aegst_amount
//     }))
//   }, [formData.work_done_amt, formData.escalation, formData.gst, formData.site_gst, formData.ho_gst, formData.site_escalation, formData.site_work_done_amt, formData.ho_escalation, formData.ho_work_done_amt])

//   const handleDateChange = (e) => {
//     const { name, value } = e.target;

//     if (name === "bill_period_start") {
//       const selectedDate = new Date(value);
//       const todayDate = new Date();
//       todayDate.setHours(0, 0, 0, 0);
//       selectedDate.setHours(0, 0, 0, 0);
//       if (selectedDate > todayDate) {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "Date cannot be greater than today.",
//         }));
//         return;
//       } else {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "",
//         }));
//       }
//     }
//     if (name === "submitted_bill_date") {
//       const selectedDate = new Date(value);
//       const todayDate = new Date();
//       todayDate.setHours(0, 0, 0, 0);
//       selectedDate.setHours(0, 0, 0, 0);
//       if (selectedDate > todayDate) {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "Date cannot be greater than today.",
//         }));
//         return;
//       } else {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "",
//         }));
//       }
//     }
//     if (name === "bill_period_end") {
//       const selectedDate = new Date(value);
//       const todayDate = new Date();
//       todayDate.setHours(0, 0, 0, 0);
//       selectedDate.setHours(0, 0, 0, 0);
//       if (selectedDate > todayDate) {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "Date cannot be greater than today.",
//         }));
//         return;
//       } else {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "",
//         }));
//       }
//     }
//     if (name === "site_recomended_bill_date") {
//       const selectedDate = new Date(value);
//       const todayDate = new Date();
//       todayDate.setHours(0, 0, 0, 0);
//       selectedDate.setHours(0, 0, 0, 0);
//       if (selectedDate > todayDate) {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "Date cannot be greater than today.",
//         }));
//         return;
//       } else {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "",
//         }));
//       }
//     }
//     if (name === "recomended_bill_date") {
//       const selectedDate = new Date(value);
//       const todayDate = new Date();
//       todayDate.setHours(0, 0, 0, 0);
//       selectedDate.setHours(0, 0, 0, 0);
//       if (selectedDate > todayDate) {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "Date cannot be greater than today.",
//         }));
//         return;
//       } else {
//         setErrors((prev) => ({
//           ...prev,
//           [name]: "",
//         }));
//       }
//     }

//     setFormData((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const optionsForCOS = cosData.map((i) => ({
//     value: i.id,
//     label: i.cos_code
//   }));

//   const handleCOSChange = (selectedOption) => {
//     if (!selectedOption) {
//       setFormData({
//         ...formData,
//         cos: "null",
//       })
//     }
//     else {
//       setFormData({
//         ...formData,
//         cos: selectedOption.value,
//       });
//     }
//   };

//   useEffect(() => {
//     setIsError(false);
//     setErrors({})
//   }, [formData.bill_type, formData.cos])

//   useEffect(() => {
//     if (formData.bill_type !== "ra") {
//       setFormData(prev => ({
//         ...prev,
//         cos: null,
//         cos_inprinciple_amount_by_client: null,
//         cos_approved_amount: null,
//         cos_amount: null,
//       }))
//     }
//   }, [formData.bill_type])

//   useEffect(() => {
//     if (formData.bill_type === "ra") {
//       const LinkedCOS = cosData.find(cos => cos.id === formData.cos);
//       if (LinkedCOS) {
//         const approvedAmount = LinkedCOS.approved_amount || 0;
//         setFormData(prev => ({
//           ...prev,
//           cos_amount: approvedAmount
//         }));
//       }
//     }
//   }, [formData.bill_type, formData.cos, formData.work_done_amt, cosData]);

//   // Tab validation functions
//   const validateCurrentTab = () => {
//     const currentTab = activeSection;
//     const newErrors = {};
//     const fieldsToValidate = tabRequiredFields[currentTab] || [];

//     fieldsToValidate.forEach((field) => {
//       if (!formData[field]) {
//         const fieldLabels = {
//           bill_type: "Bill Type",
//           bill_num: "Bill Number",
//           bill_period_start: "Bill Period Start",
//           bill_period_end: "Bill Period End",
//           submitted_bill_date: "Submitted Bill Date",
//           bill_catagory: "Bill Category"
//         };
//         newErrors[field] = `${fieldLabels[field] || field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
//       }
//     });

//     setErrors(prev => ({ ...prev, ...newErrors }));
//     setTabValidationAttempted(prev => ({ ...prev, [currentTab]: true }));

//     return Object.keys(newErrors).length === 0;
//   };

//   const goToNextTab = () => {
//     const currentIndex = sections.findIndex(s => s.id === activeSection);
//     const nextTab = sections[currentIndex + 1]?.id;

//     if (!validateCurrentTab()) {
//       const formContainer = document.querySelector('.modern-modal-body');
//       if (formContainer) {
//         formContainer.scrollTop = 0;
//       }
//       return;
//     }

//     if (nextTab) {
//       setErrors(prev => {
//         const nextTabFields = tabRequiredFields[nextTab] || [];
//         const filteredErrors = { ...prev };
//         nextTabFields.forEach(field => {
//           delete filteredErrors[field];
//         });
//         return filteredErrors;
//       });
//     }

//     if (currentIndex < sections.length - 1) {
//       setActiveSection(nextTab);
//     }
//   };

//   const goToPreviousTab = () => {
//     const currentIndex = sections.findIndex(s => s.id === activeSection);
//     if (currentIndex > 0) {
//       setActiveSection(sections[currentIndex - 1].id);
//       setErrors({});
//     }
//   };

//   const hasCurrentTabErrors = () => {
//     const currentTab = activeSection;
//     const fieldsToValidate = tabRequiredFields[currentTab] || [];
//     return fieldsToValidate.some(field => errors[field]);
//   };

//   const getCurrentTabErrorMessage = () => {
//     const currentTab = activeSection;
//     const missingFields = (tabRequiredFields[currentTab] || [])
//       .filter(field => !formData[field])
//       .map(field => {
//         const labels = {
//           bill_type: "Bill Type",
//           bill_num: "Bill Number",
//           bill_period_start: "Bill Period Start",
//           bill_period_end: "Bill Period End",
//           submitted_bill_date: "Submitted Bill Date",
//           bill_catagory: "Bill Category"
//         };
//         return labels[field] || field;
//       });

//     if (missingFields.length === 0) return null;
//     if (missingFields.length === 1) {
//       return `${missingFields[0]} is required to proceed`;
//     }
//     return `Please fill all required fields in ${currentTab.charAt(0).toUpperCase() + currentTab.slice(1)} section`;
//   };

//   // Render functions for each tab
//   const renderBasicInfo = () => (
//     <div className="form-section">
//       <div className="section-title">
//         <FileText size={18} />
//         <h4>Basic Bill Information</h4>
//       </div>
//       <div className="form-grid">
//         <div className="form-field">
//           <label><FileText size={14} /> Bill Type<span className="required">*</span></label>
//           <Select
//             options={billTypeOption}
//             isSearchable
//             isClearable
//             title="Bill Type"
//             placeholder="Select Bill Type"
//             value={billTypeOption.find(i => i.value === formData.bill_type)}
//             noOptionsMessage={() => "No other options"}
//             onChange={handleBilltypeChange}
//             styles={CSSForSelectModern15VWWidth}
//           />
//           {errors.bill_type && <div className="error-message">{errors.bill_type}</div>}
//         </div>

//         {formData.bill_type === "ra" && (
//           <div className="form-field">
//             <label><Link size={14} /> Select COS<span className="required">*</span></label>
//             <Select
//               options={optionsForCOS}
//               isSearchable
//               isClearable
//               title="Select COS"
//               placeholder="Select COS"
//               value={optionsForCOS.find(i => i.value === formData.cos)}
//               noOptionsMessage={() => "No other options"}
//               onChange={handleCOSChange}
//               styles={CSSForSelectModern15VWWidth}
//             />
//             {errors.cos && <div className="error-message">{errors.cos}</div>}
//           </div>
//         )}

//         <div className="form-field">
//           <label><Tag size={14} /> Bill Category<span className="required">*</span></label>
//           <Select
//             options={billCategoryOption}
//             isSearchable
//             isClearable
//             title="Bill Category"
//             placeholder="Select Bill Category"
//             value={billCategoryOption.find(i => i.value === formData.bill_catagory)}
//             noOptionsMessage={() => "No other options"}
//             onChange={handleBillCategoryChange}
//             styles={CSSForSelectModern15VWWidth}
//           />
//           {errors.bill_catagory && <div className="error-message">{errors.bill_catagory}</div>}
//         </div>

//         <div className="form-field">
//           <label><Hash size={14} /> Bill Number<span className="required">*</span></label>
//           <input
//             type="text"
//             name="bill_num"
//             placeholder="Bill Num"
//             value={formData.bill_num}
//             onChange={handleInputChange}
//             className={`${errors.bill_num ? "error" : ""}`}
//           />
//           {errors.bill_num && <div className="error-message">{errors.bill_num}</div>}
//         </div>

//         <div className="form-field">
//           <label><Calendar size={14} /> Bill Period Start<span className="required">*</span></label>
//           <input
//             type="date"
//             name="bill_period_start"
//             value={formData.bill_period_start}
//             onChange={handleDateChange}
//             max={new Date().toISOString().split('T')[0]}
//             className={`${errors.bill_period_start ? "error" : ""}`}
//           />
//           {errors.bill_period_start && <div className="error-message">{errors.bill_period_start}</div>}
//         </div>

//         <div className="form-field">
//           <label><Calendar size={14} /> Bill Period End<span className="required">*</span></label>
//           <input
//             type="date"
//             name="bill_period_end"
//             value={formData.bill_period_end}
//             max={new Date().toISOString().split('T')[0]}
//             onChange={handleDateChange}
//             min={formData.bill_period_start}
//             className={`${errors.bill_period_end ? "error" : ""}`}
//           />
//           {errors.bill_period_end && <div className="error-message">{errors.bill_period_end}</div>}
//         </div>

//         <div className="form-field">
//           <label><Calendar size={14} /> Submitted Bill Date<span className="required">*</span></label>
//           <input
//             type="date"
//             name="submitted_bill_date"
//             value={formData.submitted_bill_date}
//             min={formData.bill_period_end}
//             max={new Date().toISOString().split('T')[0]}
//             onChange={handleDateChange}
//             className={`${errors.submitted_bill_date ? "error" : ""}`}
//           />
//           {errors.submitted_bill_date && <div className="error-message">{errors.submitted_bill_date}</div>}
//         </div>

//         <div className="form-field">
//           <label><Mail size={14} /> Submitted Letter</label>
//           <Select
//             options={extendedLetters}
//             isSearchable
//             isClearable
//             title="Submitted Letter"
//             placeholder="Select Letter"
//             value={extendedLetters.find(i => i.value === formData.submitted_letter_num)}
//             noOptionsMessage={() => "No other options"}
//             onChange={handleletterChange}
//             styles={CSSForSelectModern}
//           />
//         </div>

//         <div className="form-field">
//           {formData.submitted_letter_num !== "null" ? null : (
//             <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "15px" }}>
//               <div>OR</div>
//               <AddTrackRecordDetails
//                 projectId={project}
//                 letterfor="contractor"
//                 lettertype="billing"
//                 getProjects={getLetters}
//                 title="Bill Letter Details"
//                 contractor={contractor}
//               />
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="section-navigation-buttons">
//         {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
//           <div className="tab-error-message">
//             <AlertCircle size={14} />
//             <span>{getCurrentTabErrorMessage()}</span>
//           </div>
//         )}
//         <button type="button" className="btn-next" onClick={goToNextTab}>
//           Next: Contractor Billing Details <ChevronRight size={16} />
//         </button>
//       </div>
//     </div>
//   );

//   const renderContractorBillingDetails = () => (
//     <div className="form-section">
//       <div className="section-title">
//         <Building2 size={18} />
//         <h4>Contractor Billing Details</h4>
//       </div>

//       {/* Existing Allowances Display */}
//       {ExistingContractorWithheldRelease
//         .filter(
//           (data) =>
//             data.contractor_releasing_heading !== null &&
//             data.contractor_releasing_heading !== "" &&
//             data.contractor_releasing_amount !== null
//         )
//         .length > 0 && (
//           <div className="dynamic-fields-section">
//             <div className="section-subtitle">
//               <PlusCircle size={14} />
//               <span>Existing Allowances</span>
//             </div>
//             <div className="form-grid" style={{ gridTemplateColumns: "repeat(2, 1fr)" }}>
//               {ExistingContractorWithheldRelease
//                 .filter(
//                   (data) =>
//                     data.contractor_releasing_heading !== null &&
//                     data.contractor_releasing_heading !== "" &&
//                     data.contractor_releasing_amount !== null
//                 )
//                 .map((data, index) => (
//                   <div className="form-field" key={index}>
//                     <label>{data.contractor_releasing_heading} Amount</label>
//                     <input
//                       type="number"
//                       min={0}
//                       name="contractor_releasing_amount"
//                       value={data.contractor_releasing_amount}
//                       onChange={(e) => handleExistingContractorWithheldInputChange(e, index)}
//                     />
//                     {errors[`${index}-contractor_releasing_amount`] && (
//                       <span className="error-message">{errors[`${index}-contractor_releasing_amount`]}</span>
//                     )}
//                   </div>
//                 ))}
//             </div>
//           </div>
//         )}

//       {/* Allowance Section */}
//       <div className="form-grid" style={{ gridTemplateColumns: "repeat(3, 1fr)" }}>
//         <div className="form-field">
//           <label><IndianRupee size={14} /> Work Done Amount</label>
//           <input type="number" name="work_done_amt" placeholder="0" value={formData.work_done_amt} onChange={handleInputChange} className={`${errors.work_done_amt ? "is-invalid" : ""}`} />
//           {errors.work_done_amt && <div className="error-message">{errors.work_done_amt}</div>}
//         </div>
//         <div className="form-field">
//           <label><TrendingUp size={14} /> Escalation Amount</label>
//           <input type="number" name="escalation" placeholder="0" value={formData.escalation} onChange={handleInputChange} className={`${errors.escalation ? "is-invalid" : ""}`} />
//           {errors.escalation && <div className="error-message">{errors.escalation}</div>}
//         </div>
//         <div className="form-field">
//           <label><Percent size={14} /> GST Amount <span className="required">(Read-Only)</span></label>
//           <input type="text" name="gst" disabled value={formData.gst} className="readonly-field" />
//           {errors.gst && <div className="error-message">{errors.gst}</div>}
//         </div>
//       </div>

//       <div className="dynamic-fields-section">
//         <div className="section-subtitle">
//           <PlusCircle size={14} />
//           <span>Additional Allowances</span>
//           <button type="button" className="add-dynamic-btn" onClick={handleAddContractorWitheheldRelease}>
//             <Plus size={14} /> Add Allowance
//           </button>
//         </div>
//         {ContractorWithheldRelease.map((data, index) => (
//           <div className="dynamic-field-row" key={index}>
//             <div className="form-field">
//               <label>Heading</label>
//               <input type="text" name="contractor_releasing_heading" value={data.contractor_releasing_heading} onChange={(e) => handleContractorWithheldInputChange(e, index)} placeholder="Enter Heading" className="width-35vw" />
//               {errors[`${index}-contractor_releasing_heading`] && <span className="error-message">{errors[`${index}-contractor_releasing_heading`]}</span>}
//             </div>
//             <div className="form-field">
//               <label>Amount</label>
//               <input type="number" min={0} name="contractor_releasing_amount" value={data.contractor_releasing_amount} onChange={(e) => handleContractorWithheldInputChange(e, index)} placeholder="Enter Amount" className="width-5vw" />
//               {errors[`${index}-contractor_releasing_amount`] && <span className="error-message">{errors[`${index}-contractor_releasing_amount`]}</span>}
//             </div>
//             <button type="button" className="remove-dynamic-btn" onClick={() => handleRemoveContractorWithheldRelease(index)}><X size={14} /></button>
//           </div>
//         ))}
//       </div>

//       {/* Existing Deductions Display */}
//       {ExistingContractorDeduction
//         .filter(
//           (data) =>
//             data.contractor_deduction_heading !== null &&
//             data.contractor_deduction_heading !== "" &&
//             data.contractor_deduction_amount !== null
//         )
//         .length > 0 && (
//           <div className="dynamic-fields-section">
//             <div className="section-subtitle">
//               <MinusCircle size={14} />
//               <span>Existing Deductions</span>
//             </div>
//             <div className="form-grid" style={{ gridTemplateColumns: "repeat(2, 1fr)" }}>
//               {ExistingContractorDeduction
//                 .filter(
//                   (data) =>
//                     data.contractor_deduction_heading !== null &&
//                     data.contractor_deduction_heading !== "" &&
//                     data.contractor_deduction_amount !== null
//                 )
//                 .map((data, index) => (
//                   <div className="form-field" key={index}>
//                     <label>{data.contractor_deduction_heading} Amount</label>
//                     <input
//                       type="number"
//                       min={0}
//                       name="contractor_deduction_amount"
//                       value={data.contractor_deduction_amount}
//                       onChange={(e) => handleExistingContractorDeductionInputChange(e, index)}
//                     />
//                     {errors[`${index}-contractor_deduction_amount`] && (
//                       <span className="error-message">{errors[`${index}-contractor_deduction_amount`]}</span>
//                     )}
//                   </div>
//                 ))}
//             </div>
//           </div>
//         )}

//       {/* Deduction Section */}
//       <div className="form-grid" style={{ marginTop: "1.5rem" }}>
//         <div className="form-field">
//           <label><MinusCircle size={14} /> Deduction Submitted Amount</label>
//           <input type="number" name="contractor_deduction_amt" placeholder="Deduction Submitted Amount" value={formData.contractor_deduction_amt} onChange={handleInputChange} className={`${errors.contractor_deduction_amt ? "is-invalid" : ""}`} style={{ width: "30vw" }} />
//           {errors.contractor_deduction_amt && <div className="error-message">{errors.contractor_deduction_amt}</div>}
//         </div>
//       </div>

//       <div className="dynamic-fields-section">
//         <div className="section-subtitle">
//           <MinusCircle size={14} />
//           <span>Additional Deductions</span>
//           <button type="button" className="add-dynamic-btn" onClick={handleAddContractorDeduction}>
//             <Plus size={14} /> Add Deduction
//           </button>
//         </div>
//         {ContractorDeductionData.map((data, index) => (
//           <div className="dynamic-field-row" key={index}>
//             <div className="form-field">
//               <label>Heading</label>
//               <input type="text" name="contractor_deduction_heading" value={data.contractor_deduction_heading} onChange={(e) => handleContractorDeductionInputChange(e, index)} placeholder="Enter Heading" className="width-35vw" />
//               {errors[`${index}-contractor_deduction_heading`] && <span className="error-message">{errors[`${index}-contractor_deduction_heading`]}</span>}
//             </div>
//             <div className="form-field">
//               <label>Amount</label>
//               <input type="number" min={0} name="contractor_deduction_amount" value={data.contractor_deduction_amount} onChange={(e) => handleContractorDeductionInputChange(e, index)} placeholder="0" className="width-5vw" />
//               {errors[`${index}-contractor_deduction_amount`] && <span className="error-message">{errors[`${index}-contractor_deduction_amount`]}</span>}
//             </div>
//             <button type="button" className="remove-dynamic-btn" onClick={() => handleRemoveContractorDeduction(index)}><X size={14} /></button>
//           </div>
//         ))}
//       </div>

//       {/* Total Section */}
//       <div className="form-grid" style={{ marginTop: "1.5rem", gridTemplateColumns: "repeat(3, 1fr)" }}>
//         <div className="form-field">
//           <label>Submitted Bill Amount<span className="required">(Read-Only)</span></label>
//           <input type="number" name="submitted_bill_amount" value={formData.submitted_bill_amount} readOnly className="readonly-field" />
//           {errors.submitted_bill_amount && <div className="error-message">{errors.submitted_bill_amount}</div>}
//         </div>
//         <div className="form-field">
//           <label>Submitted Percentage Amount</label>
//           <input type="number" name="percentage_amt" placeholder="0" value={formData.percentage_amt} onChange={handleInputChange} className={`${errors.percentage_amt ? "is-invalid" : ""}`} />
//           {errors.percentage_amt && <div className="error-message">{errors.percentage_amt}</div>}
//         </div>
//         <div className="form-field">
//           <label>Submitted Percentage<span className="required">(Read-only)</span></label>
//           <input type="text" name="submitted_percentage" disabled value={formData.submitted_percentage} className="readonly-field" />
//           {errors.submitted_percentage && <div className="error-message">{errors.submitted_percentage}</div>}
//         </div>
//       </div>

//       <div className="section-navigation-buttons dual-buttons">
//         <div className="nav-buttons-wrapper">
//           <button type="button" className="btn-prev" onClick={goToPreviousTab}>
//             <ChevronRight size={16} className="rotate-left" /> Previous: Basic Info
//           </button>
//           <button type="button" className="btn-next" onClick={goToNextTab}>
//             Next: AE/IE Details <ChevronRight size={16} />
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   const renderAeDetails = () => (
//     <div className="form-section">
//       <div className="section-title">
//         <CheckCircle size={18} />
//         <h4>AE/IE Bill Details</h4>
//       </div>

//       {/* Existing HO Allowances Display */}
//       {ExistingHOWithheldRelease
//         .filter(
//           (data) =>
//             data.HO_released_heading !== null &&
//             data.HO_released_heading !== "" &&
//             data.HO_released_amount !== null
//         )
//         .length > 0 && (
//           <div className="dynamic-fields-section">
//             <div className="section-subtitle">
//               <PlusCircle size={14} />
//               <span>Existing AE/IE Allowances</span>
//             </div>
//             <div className="form-grid" style={{ gridTemplateColumns: "repeat(2, 1fr)" }}>
//               {ExistingHOWithheldRelease
//                 .filter(
//                   (data) =>
//                     data.HO_released_heading !== null &&
//                     data.HO_released_heading !== "" &&
//                     data.HO_released_amount !== null
//                 )
//                 .map((data, index) => (
//                   <div className="form-field" key={index}>
//                     <label>{data.HO_released_heading} Amount</label>
//                     <input
//                       type="number"
//                       min={0}
//                       name="HO_released_amount"
//                       value={data.HO_released_amount}
//                       onChange={(e) => handleExistingHOWithheldInputChange(e, index)}
//                     />
//                     {errors[`${index}-HO_released_amount`] && (
//                       <span className="error-message">{errors[`${index}-HO_released_amount`]}</span>
//                     )}
//                   </div>
//                 ))}
//             </div>
//           </div>
//         )}

//       <div className="form-grid">
//         <div className="form-field">
//           <label><Calendar size={14} /> AE/IE Recomended Bill Date</label>
//           <input type="date" name="recomended_bill_date" value={formData.recomended_bill_date} onChange={handleDateChange} max={new Date().toISOString().split('T')[0]} className={`${errors.recomended_bill_date ? "is-invalid" : ""}`} />
//           {errors.recomended_bill_date && <div className="error-message">{errors.recomended_bill_date}</div>}
//         </div>
//         <div className="form-field">
//           <label><IndianRupee size={14} /> AE/IE Work Done Amount</label>
//           <input type="number" name="ho_work_done_amt" placeholder="0" value={formData.ho_work_done_amt} onChange={handleInputChange} className={`${errors.ho_work_done_amt ? "is-invalid" : ""}`} />
//           {errors.ho_work_done_amt && <div className="error-message">{errors.ho_work_done_amt}</div>}
//         </div>
//         <div className="form-field">
//           <label><TrendingUp size={14} /> AE/IE Escalation Amount</label>
//           <input type="number" name="ho_escalation" placeholder="0" value={formData.ho_escalation} onChange={handleInputChange} className={`${errors.ho_escalation ? "is-invalid" : ""}`} />
//           {errors.ho_escalation && <div className="error-message">{errors.ho_escalation}</div>}
//         </div>
//         <div className="form-field">
//           <label><Percent size={14} /> AE/IE GST Amount <span className="required">(Read-Only)</span></label>
//           <input type="number" disabled name="ho_gst" value={formData.ho_gst} className="readonly-field" />
//           {errors.ho_gst && <div className="error-message">{errors.ho_gst}</div>}
//         </div>
//         <div className="form-field">
//           <label><IndianRupee size={14} /> AE/IE Release Withheld Amount</label>
//           <input type="number" min={0} name="released_withheld_amt" placeholder="0" value={formData.released_withheld_amt} onChange={handleInputChange} className={`${errors.released_withheld_amt ? "is-invalid" : ""}`} />
//           {errors.released_withheld_amt && <div className="error-message">{errors.released_withheld_amt}</div>}
//         </div>
//       </div>

//       <div className="dynamic-fields-section">
//         <div className="section-subtitle">
//           <PlusCircle size={14} />
//           <span>AE/IE Additional Allowances</span>
//           <button type="button" className="add-dynamic-btn" onClick={handleAddHOWitheheldRelease}>
//             <Plus size={14} /> Add Allowance
//           </button>
//         </div>
//         {HOWithheldRelease.map((data, index) => (
//           <div className="dynamic-field-row" key={index}>
//             <div className="form-field">
//               <label>AE/IE Heading</label>
//               <input type="text" name="HO_released_heading" value={data.HO_released_heading} onChange={(e) => handleHOWithheldInputChange(e, index)} placeholder="Enter Heading" className="width-35vw" />
//               {errors[`${index}-HO_released_heading`] && <span className="error-message">{errors[`${index}-HO_released_heading`]}</span>}
//             </div>
//             <div className="form-field">
//               <label>AE/IE Amount</label>
//               <input type="number" min={0} name="HO_released_amount" value={data.HO_released_amount} onChange={(e) => handleHOWithheldInputChange(e, index)} placeholder="0" className="width-5vw" />
//               {errors[`${index}-HO_released_amount`] && <span className="error-message">{errors[`${index}-HO_released_amount`]}</span>}
//             </div>
//             <button type="button" className="remove-dynamic-btn" onClick={() => handleRemoveHOWitheld(index)}><X size={14} /></button>
//           </div>
//         ))}
//       </div>

//       {/* Existing HO Deductions Display */}
//       {ExistingHODeduction
//         .filter(
//           (data) =>
//             data.HO_deduction_heading !== null &&
//             data.HO_deduction_heading !== "" &&
//             data.HO_deduction_amount !== null
//         )
//         .length > 0 && (
//           <div className="dynamic-fields-section">
//             <div className="section-subtitle">
//               <MinusCircle size={14} />
//               <span>Existing AE/IE Deductions</span>
//             </div>
//             <div className="form-grid" style={{ gridTemplateColumns: "repeat(2, 1fr)" }}>
//               {ExistingHODeduction
//                 .filter(
//                   (data) =>
//                     data.HO_deduction_heading !== null &&
//                     data.HO_deduction_heading !== "" &&
//                     data.HO_deduction_amount !== null
//                 )
//                 .map((data, index) => (
//                   <div className="form-field" key={index}>
//                     <label>{data.HO_deduction_heading} Amount</label>
//                     <input
//                       type="number"
//                       min={0}
//                       name="HO_deduction_amount"
//                       value={data.HO_deduction_amount}
//                       onChange={(e) => handleExistingHODeductionInputChange(e, index)}
//                     />
//                     {errors[`${index}-HO_deduction_amount`] && (
//                       <span className="error-message">{errors[`${index}-HO_deduction_amount`]}</span>
//                     )}
//                   </div>
//                 ))}
//             </div>
//           </div>
//         )}

//       <div className="form-grid">
//         <div className="form-field">
//           <label><MinusCircle size={14} /> Withheld Amount</label>
//           <input type="number" min={0} name="withheld_amt" placeholder="0" value={formData.withheld_amt} onChange={handleInputChange} className={`${errors.withheld_amt ? "is-invalid" : ""}`} />
//           {errors.withheld_amt && <div className="error-message">{errors.withheld_amt}</div>}
//         </div>
//         <div className="form-field">
//           <label><MinusCircle size={14} /> AE/IE Deduction Amount</label>
//           <input type="number" min={0} max={formData.submitted_bill_amount} name="deduction_amount" placeholder="0" value={formData.deduction_amount} onChange={handleInputChange} className={`${errors.deduction_amount ? "is-invalid" : ""}`} />
//           {errors.deduction_amount && <div className="error-message">{errors.deduction_amount}</div>}
//         </div>
//       </div>

//       <div className="dynamic-fields-section">
//         <div className="section-subtitle">
//           <MinusCircle size={14} />
//           <span>AE/IE Additional Deductions</span>
//           <button type="button" className="add-dynamic-btn" onClick={handleAddHOdeduction}>
//             <Plus size={14} /> Add Deduction
//           </button>
//         </div>
//         {HODeductionData.map((data, index) => (
//           <div className="dynamic-field-row" key={index}>
//             <div className="form-field">
//               <label>AE/IE Heading</label>
//               <input type="text" name="HO_deduction_heading" value={data.HO_deduction_heading} onChange={(e) => handleHODeductionInputChange(e, index)} placeholder="Enter Heading" className="width-35vw" />
//               {errors[`${index}-HO_deduction_heading`] && <span className="error-message">{errors[`${index}-HO_deduction_heading`]}</span>}
//             </div>
//             <div className="form-field">
//               <label>AE/IE Amount</label>
//               <input type="number" min={0} name="HO_deduction_amount" value={data.HO_deduction_amount} onChange={(e) => handleHODeductionInputChange(e, index)} placeholder="0" className="width-5vw" />
//               {errors[`${index}-HO_deduction_amount`] && <span className="error-message">{errors[`${index}-HO_deduction_amount`]}</span>}
//             </div>
//             <button type="button" className="remove-dynamic-btn" onClick={() => handleRemoveHODeduction(index)}><X size={14} /></button>
//           </div>
//         ))}
//       </div>

//       <div className="form-grid">
//         <div className="form-field">
//           <label>AE/IE Recommended Bill Amount<span className="required">(Read-Only)</span></label>
//           <input type="number" name="recommended_bill_amount" value={formData.recommended_bill_amount} readOnly className="readonly-field" />
//           {errors.recommended_bill_amount && <div className="error-message">{errors.recommended_bill_amount}</div>}
//         </div>
//         <div className="form-field">
//           <label>AE/IE Recommended Percentage Amount</label>
//           <input type="number" name="ho_percentage_amt" placeholder="0" value={formData.ho_percentage_amt} onChange={handleInputChange} className={`${errors.ho_percentage_amt ? "is-invalid" : ""}`} />
//           {errors.ho_percentage_amt && <div className="error-message">{errors.ho_percentage_amt}</div>}
//         </div>
//         <div className="form-field">
//           <label>AE/IE Recommended Bill Percentage<span className="required">(Read-Only)</span></label>
//           <input type="text" name="recommended_percentage" disabled value={formData.recommended_percentage} className="readonly-field" />
//           {errors.recommended_percentage && <div className="error-message">{errors.recommended_percentage}</div>}
//         </div>
//         <div className="form-field">
//           <label>Recommended Letter</label>
//           <Select
//             options={extendedLetters}
//             isSearchable
//             isClearable
//             title="Recommended Letter"
//             placeholder="Select Letter"
//             value={extendedLetters.find(i => i.value === formData.recomended_letter_num)}
//             noOptionsMessage={() => "No other options"}
//             onChange={handleletterChange2}
//             styles={CSSForSelectModern}
//           />
//         </div>
//         <div className="form-field">
//           {formData.recomended_letter_num !== "null" ? null : (
//             <div style={{ display: "flex", alignItems: "center", gap: "10px", marginTop: "15px" }}>
//               <div>OR</div>
//               <AddTrackRecordDetails
//                 projectId={project}
//                 letterfor={formData.workperformedby}
//                 lettertype="billing"
//                 getProjects={getLetters}
//                 title="Recomended Letter Details"
//                 contractor={contractor}
//               />
//             </div>
//           )}
//         </div>
//         <div className="form-field">
//           <label><Paperclip size={14} /> HO Attachment</label>
//           <input type="file" name="ho_attachment" onChange={handleFileChange} className={`${errors.ho_attachment ? "is-invalid" : ""}`} />
//           {errors.ho_attachment && <div className="error-message">{errors.ho_attachment}</div>}
//         </div>
//       </div>

//       <div className="section-navigation-buttons dual-buttons">
//         <div className="nav-buttons-wrapper">
//           <button type="button" className="btn-prev" onClick={goToPreviousTab}>
//             <ChevronRight size={16} className="rotate-left" /> Previous: Contractor Billing Details
//           </button>
//           <button type="button" className="btn-next" onClick={goToNextTab}>
//             Next: Client Details <ChevronRight size={16} />
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   const renderClientDetails = () => (
//     <div className="form-section">
//       <div className="section-title">
//         <Award size={18} />
//         <h4>Client Bill Details</h4>
//       </div>

//       {/* Existing Site Allowances Display */}
//       {ExistingSiteWithheldRelease
//         .filter(
//           (data) =>
//             data.site_released_heading !== null &&
//             data.site_released_heading !== "" &&
//             data.site_released_amount !== null
//         )
//         .length > 0 && (
//           <div className="dynamic-fields-section">
//             <div className="section-subtitle">
//               <PlusCircle size={14} />
//               <span>Existing Client Allowances</span>
//             </div>
//             <div className="form-grid" style={{ gridTemplateColumns: "repeat(2, 1fr)" }}>
//               {ExistingSiteWithheldRelease
//                 .filter(
//                   (data) =>
//                     data.site_released_heading !== null &&
//                     data.site_released_heading !== "" &&
//                     data.site_released_amount !== null
//                 )
//                 .map((data, index) => (
//                   <div className="form-field" key={index}>
//                     <label>{data.site_released_heading} Amount</label>
//                     <input
//                       type="number"
//                       min={0}
//                       name="site_released_amount"
//                       value={data.site_released_amount}
//                       onChange={(e) => handleExistingSiteWithheldInputChange(e, index)}
//                     />
//                     {errors[`${index}-site_released_amount`] && (
//                       <span className="error-message">{errors[`${index}-site_released_amount`]}</span>
//                     )}
//                   </div>
//                 ))}
//             </div>
//           </div>
//         )}

//       <div className="form-grid">
//         <div className="form-field">
//           <label><Calendar size={14} /> Client Recomended Bill Date</label>
//           <input
//             type="date"
//             name="site_recomended_bill_date"
//             value={formData.site_recomended_bill_date}
//             onChange={handleDateChange}
//             max={new Date().toISOString().split('T')[0]}
//             className={`${errors.site_recomended_bill_date ? "is-invalid" : ""}`}
//           />
//           {errors.site_recomended_bill_date && <div className="error-message">{errors.site_recomended_bill_date}</div>}
//         </div>
//         <div className="form-field">
//           <label><IndianRupee size={14} /> Client Work Done Amount</label>
//           <input type="number" name="site_work_done_amt" placeholder="Work Done Amount" value={formData.site_work_done_amt} onChange={handleInputChange} className={`${errors.site_work_done_amt ? "is-invalid" : ""}`} />
//           {errors.site_work_done_amt && <div className="error-message">{errors.site_work_done_amt}</div>}
//         </div>
//         <div className="form-field">
//           <label><TrendingUp size={14} /> Client Escalation Amount</label>
//           <input type="number" name="site_escalation" max={formData.escalation} placeholder="Client Escalation Amount" value={formData.site_escalation} onChange={handleInputChange} className={`${errors.site_escalation ? "is-invalid" : ""}`} />
//           {errors.site_escalation && <div className="error-message">{errors.site_escalation}</div>}
//         </div>
//         <div className="form-field">
//           <label><Percent size={14} /> Client GST Amount <span className="required">(Read-Only)</span></label>
//           <input type="number" disabled name="site_gst" value={formData.site_gst} className="readonly-field" />
//           {errors.site_gst && <div className="error-message">{errors.site_gst}</div>}
//         </div>
//         <div className="form-field">
//           <label><IndianRupee size={14} /> Client Release Withheld Amount</label>
//           <input type="number" min={0} name="site_released_withheld_amt" placeholder="0" value={formData.site_released_withheld_amt} onChange={handleInputChange} className={`${errors.site_released_withheld_amt ? "is-invalid" : ""}`} />
//           {errors.site_released_withheld_amt && <div className="error-message">{errors.site_released_withheld_amt}</div>}
//         </div>
//       </div>

//       <div className="dynamic-fields-section">
//         <div className="section-subtitle">
//           <PlusCircle size={14} />
//           <span>Client Additional Allowances</span>
//           <button type="button" className="add-dynamic-btn" onClick={handleAddSiteWitheheldRelease}>
//             <Plus size={14} /> Add Allowance
//           </button>
//         </div>
//         {SiteWithheldRelease.map((data, index) => (
//           <div className="dynamic-field-row" key={index}>
//             <div className="form-field">
//               <label>Client Heading</label>
//               <input type="text" name="site_released_heading" value={data.site_released_heading} onChange={(e) => handleSiteWithheldInputChange(e, index)} placeholder="Enter Heading" className="width-35vw" />
//               {errors[`${index}-site_released_heading`] && <span className="error-message">{errors[`${index}-site_released_heading`]}</span>}
//             </div>
//             <div className="form-field">
//               <label>Client Amount</label>
//               <input type="number" min={0} name="site_released_amount" value={data.site_released_amount} onChange={(e) => handleSiteWithheldInputChange(e, index)} placeholder="Enter Amount" className="width-5vw" />
//               {errors[`${index}-site_released_amount`] && <span className="error-message">{errors[`${index}-site_released_amount`]}</span>}
//             </div>
//             <button type="button" className="remove-dynamic-btn" onClick={() => handleRemoveSiteWithheldRelease(index)}><X size={14} /></button>
//           </div>
//         ))}
//       </div>

//       {/* Existing Site Deductions Display */}
//       {ExistingSiteDeduction
//         .filter(
//           (data) =>
//             data.site_deduction_heading !== null &&
//             data.site_deduction_heading !== "" &&
//             data.site_deduction_amount !== null
//         )
//         .length > 0 && (
//           <div className="dynamic-fields-section">
//             <div className="section-subtitle">
//               <MinusCircle size={14} />
//               <span>Existing Client Deductions</span>
//             </div>
//             <div className="form-grid" style={{ gridTemplateColumns: "repeat(2, 1fr)" }}>
//               {ExistingSiteDeduction
//                 .filter(
//                   (data) =>
//                     data.site_deduction_heading !== null &&
//                     data.site_deduction_heading !== "" &&
//                     data.site_deduction_amount !== null
//                 )
//                 .map((data, index) => (
//                   <div className="form-field" key={index}>
//                     <label>{data.site_deduction_heading} Amount</label>
//                     <input
//                       type="number"
//                       min={0}
//                       name="site_deduction_amount"
//                       value={data.site_deduction_amount}
//                       onChange={(e) => handleExistingSiteDeductionInputChange(e, index)}
//                     />
//                     {errors[`${index}-site_deduction_amount`] && (
//                       <span className="error-message">{errors[`${index}-site_deduction_amount`]}</span>
//                     )}
//                   </div>
//                 ))}
//             </div>
//           </div>
//         )}

//       <div className="form-grid">
//         <div className="form-field">
//           <label><MinusCircle size={14} /> Client Deduction Amount</label>
//           <input type="number" name="site_deduction_amount" placeholder="Client Deduction Amount" value={formData.site_deduction_amount} onChange={handleInputChange} className={`${errors.site_deduction_amount ? "is-invalid" : ""}`} style={{ width: "30vw" }} />
//           {errors.site_deduction_amount && <div className="error-message">{errors.site_deduction_amount}</div>}
//         </div>
//         <div className="form-field">
//           <label><MinusCircle size={14} /> Client Withheld Amount</label>
//           <input type="number" min={0} name="site_withheld_amt" placeholder="0" value={formData.site_withheld_amt} onChange={handleInputChange} className={`${errors.site_withheld_amt ? "is-invalid" : ""}`} />
//           {errors.site_withheld_amt && <div className="error-message">{errors.site_withheld_amt}</div>}
//         </div>
//       </div>

//       <div className="dynamic-fields-section">
//         <div className="section-subtitle">
//           <MinusCircle size={14} />
//           <span>Client Additional Deductions</span>
//           <button type="button" className="add-dynamic-btn" onClick={handleAddSiteDeductionAmount}>
//             <Plus size={14} /> Add Deduction
//           </button>
//         </div>
//         {SiteDeductionData.map((data, index) => (
//           <div className="dynamic-field-row" key={index}>
//             <div className="form-field">
//               <label>Client Heading</label>
//               <input type="text" name="site_deduction_heading" value={data.site_deduction_heading} onChange={(e) => handleSiteDeductionInputChange(e, index)} placeholder="Enter Heading" className="width-35vw" />
//               {errors[`${index}-site_deduction_heading`] && <span className="error-message">{errors[`${index}-site_deduction_heading`]}</span>}
//             </div>
//             <div className="form-field">
//               <label>Client Amount</label>
//               <input type="number" min={0} name="site_deduction_amount" value={data.site_deduction_amount} onChange={(e) => handleSiteDeductionInputChange(e, index)} placeholder="Enter Amount" className="width-5vw" />
//               {errors[`${index}-site_deduction_amount`] && <span className="error-message">{errors[`${index}-site_deduction_amount`]}</span>}
//             </div>
//             <button type="button" className="remove-dynamic-btn" onClick={() => handleRemoveSiteDeduction(index)}><X size={14} /></button>
//           </div>
//         ))}
//       </div>

//       <div className="form-grid">
//         <div className="form-field">
//           <label>Client Approve Bill Amount<span className="required">(Read-Only)</span></label>
//           <input type="number" disabled name="site_recommended_bill_amount" value={formData.site_recommended_bill_amount} className="readonly-field" />
//           {errors.site_recommended_bill_amount && <div className="error-message">{errors.site_recommended_bill_amount}</div>}
//         </div>
//         <div className="form-field">
//           <label>Client Approve Percentage<span className="required">(Read-Only)</span></label>
//           <input type="number" name="site_recommended_percentage" value={formData.site_recommended_percentage} readOnly className="readonly-field" />
//           {errors.site_recommended_percentage && <div className="error-message">{errors.site_recommended_percentage}</div>}
//         </div>
//         <div className="form-field">
//           <label>Client Approve Percentage Amount</label>
//           <input type="number" name="site_percentage_amt" placeholder="0" value={formData.site_percentage_amt} onChange={handleInputChange} className={`${errors.site_percentage_amt ? "is-invalid" : ""}`} />
//           {errors.site_percentage_amt && <div className="error-message">{errors.site_percentage_amt}</div>}
//         </div>
//         <div className="form-field full-width">
//           <label><MessageSquare size={14} /> Client Remark</label>
//           <textarea name="site_remark" placeholder="Client Remark" rows={3} value={formData.site_remark} onChange={handleInputChange} className={`${errors.site_remark ? "is-invalid" : ""}`} />
//           {errors.site_remark && <div className="error-message">{errors.site_remark}</div>}
//         </div>
//         <div className="form-field">
//           <label><Paperclip size={14} /> Client Attachment</label>
//           <input type="file" name="site_attachment" onChange={handleFileChange} className={`${errors.site_attachment ? "is-invalid" : ""}`} />
//           {errors.site_attachment && <div className="error-message">{errors.site_attachment}</div>}
//         </div>
//       </div>

//       <div className="section-navigation-buttons dual-buttons">
//         <div className="nav-buttons-wrapper">
//           <button type="button" className="btn-prev" onClick={goToPreviousTab}>
//             <ChevronRight size={16} className="rotate-left" /> Previous: AE/IE Details
//           </button>
//         </div>
//       </div>

//       <div className="form-actions">
//         <div className="submit-buttons">
//           <button type="button" className="btn-secondaryy" onClick={handleClose}>Cancel</button>
//           <button type="submit" className="btn-primaryy" disabled={loading} onClick={handleFormSubmit}>
//             {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
//             <span>{loading ? "Updating..." : "Update Bill"}</span>
//           </button>
//         </div>
//       </div>
//     </div>
//   );

//   const renderCurrentSection = () => {
//     switch (activeSection) {
//       case 'basic': return renderBasicInfo();
//       case 'contractor': return renderContractorBillingDetails();
//       case 'ae': return renderAeDetails();
//       case 'client': return renderClientDetails();
//       default: return renderBasicInfo();
//     }
//   };

//   return (
//     <>

//       <button title="Update Bill" className="model-edit-button" style={{ background: "black" }} onClick={handleShow}>
//         <UpdatePencil modernButton="true" />
//       </button>

//       <Modal show={show} onHide={() => setShow(false)} dialogClassName="modern-project-modal" size="xl">
//         <Modal.Header className="modern-modal-header">
//           <div className="header-content">
//             <div className="header-icon" style={{ background: "transparent", color: "white" }}>
//               <IndianRupee size={24} />
//             </div>
//             <div>
//               <Modal.Title>Update Billing Details</Modal.Title>
//               <p className="header-subtitle">Update billing details for the project</p>
//             </div>
//           </div>
//           <button className="close-btn" onClick={handleClose}>
//             <X size={20} />
//           </button>
//         </Modal.Header>

//         <Modal.Body className="modern-modal-body">
//           <div className="section-navigation">
//             {sections.map((section) => {
//               const Icon = section.icon;
//               const hasMissingRequiredFields = () => {
//                 const requiredFields = tabRequiredFields[section.id] || [];
//                 return requiredFields.some(field => !formData[field]);
//               };

//               return (
//                 <button
//                   key={section.id}
//                   className={`section-nav-btn ${activeSection === section.id ? 'active' : ''} ${hasMissingRequiredFields() && section.id !== activeSection ? 'has-warning' : ''}`}
//                   onClick={() => {
//                     if (activeSection !== section.id) {
//                       if (validateCurrentTab()) {
//                         setActiveSection(section.id);
//                         setErrors({});
//                       } else {
//                         const formContainer = document.querySelector('.modern-modal-body');
//                         if (formContainer) {
//                           formContainer.scrollTop = 0;
//                         }
//                       }
//                     }
//                   }}
//                 >
//                   <Icon size={16} />
//                   <span>{section.label}</span>
//                   {hasMissingRequiredFields() && section.id !== activeSection && (
//                     <div className="warning-dot" title="Missing required fields" />
//                   )}
//                   {activeSection === section.id && <ChevronRight size={14} className="nav-arrow" />}
//                 </button>
//               );
//             })}
//           </div>

//           <form className="project-form">
//             {renderCurrentSection()}
//           </form>
//         </Modal.Body>
//       </Modal>

//       <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} />
//     </>
//   );
// };



const DeleteBillingDetails = ({ i, getbillingDetail }) => {
  const [show, setshow] = useState(false);
  const handleClose = () => {
    setshow(false);

  };
  const handleShow = () => {
    setshow(true);
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    try {
      const ress = await axios.delete(
        `${BASE_URL}/siteproject/billingdetailfield/${i.id}/`
      );
      if (ress.status === 200) {
        await getbillingDetail();
        setshow(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <button className="model-delete-button" onClick={handleShow}>
        <DeleteDustbin />
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Bill {i.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete Bill {i.title}
            <div className="button-models">
              <button
                className="model-button   font-weight500    model-button-cancel"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};


// const AddBOQInvoice = ({ project, getInvoice }) => {
//   const [show, setShow] = useState(false);
//   const role = sessionStorage.getItem('sitemanagement_role');
//   const projectId = sessionStorage.getItem('sitemanagement_project');
//   const handleShow = () => {
//     setShow(true);
//   };
//   const handleClose = () => {
//     setShow(false);
//     setFormData({
//       project: projectId ? projectId : "",
//       invoice_number: "",
//       month: "",
//       year: "",
//     });
//   };

//   const [formData, setFormData] = useState({
//     project: projectId ? projectId : "",
//     invoice_number: "",
//     month: "",
//     year: "",
//   });

//   const [projectList, setProjectList] = useState([]);

//   const getProject = async () => {
//     try {
//       const response = await axios.get(
//         sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
//           `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem('sitemanagement_emp_id')}/`
//           : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
//             `${BASE_URL}/siteproject/projectfilterbycom_operator/${sessionStorage.getItem('sitemanagement_emp_id')}/`
//             // for general(admin)
//             : `${BASE_URL}/siteproject/projectfilterbysubcompany/null/`
//       );
//       const sortedList = sortProjects(response.data, "site_prcode");
//       setProjectList(sortedList);
//       console.log(response);
//     } catch (error) {
//       console.error(error);
//     }
//   };


//   useEffect(() => {
//     getProject();
//   }, []);

//   const [errors, setErrors] = useState({});
//   const [loading, setLoading] = useState(false);
//   const [isSubmitted, setIsSubmitted] = useState(false);

//   const [inputState, setInputState] = useState({});

//   const validateForm = () => {
//     const newErrors = {};
//     const requiredFields = ["invoice_number", "month", "year"];

//     requiredFields.forEach((field) => {
//       if (!formData[field]) {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
//           } is required!`;
//       }
//     });

//     setErrors(newErrors);
//     setIsSubmitted(true);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     setInputState({
//       ...inputState,
//       [name]: value.trim() ? "green" : "",
//     });

//     setFormData({
//       ...formData,
//       [name]: value,
//     });

//     setErrors((prevErrors) => {
//       const updatedErrors = { ...prevErrors };
//       if (value.trim()) {
//         delete updatedErrors[name];
//       }
//       return updatedErrors;
//     });
//   };

//   const handleFormSubmit = async (e) => {
//     e.preventDefault();

//     if (validateForm()) {
//       setLoading(true); //loading logic
//       const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

//       try {
//         let res = await axios.post(
//           `${BASE_URL}/siteproject/consultant-invoice/`,
//           formData
//         );

//         if (res.status === 200) {
//           await getInvoice();
//           toast.dismiss(loadingToastId);
//           toast.success("Data added successfully");

//           handleClose();
//         }
//       } catch (err) {
//         //toast Logic
//         handleErrorToast(err);
//       } finally {
//         setLoading(false); //loading logic
//         toast.dismiss(loadingToastId);
//       }
//     }
//   };

//   const monthOptions = [
//     { value: "01", label: "January" },
//     { value: "02", label: "February" },
//     { value: "03", label: "March" },
//     { value: "04", label: "April" },
//     { value: "05", label: "May" },
//     { value: "06", label: "June" },
//     { value: "07", label: "July" },
//     { value: "08", label: "August" },
//     { value: "09", label: "September" },
//     { value: "10", label: "October" },
//     { value: "11", label: "November" },
//     { value: "12", label: "December" },
//   ];
//   const currentYear = new Date().getFullYear();
//   const years = Array.from({ length: 10 }, (_, i) => currentYear - i);

//   return (
//     <>
//       <button title="Add Invoice" className="upload-svg" onClick={handleShow}>
//         <AddwithWhiteCircle />
//         {" "}
//         Invoice
//       </button>
//       <Modal
//         show={show}
//         onHide={handleClose}
//         dialogClassName="request-leave width-40vw"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Add Invoice</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="parent-div">
//             <div className="bdy-div">
//               <form>
//                 <div className="flex-column">
//                   <label className="form-labels font-weight500 font-size-subheading" title="Invoice Number">
//                     Invoice Number<span className="required">*</span>
//                   </label>
//                   <input
//                     type="text"
//                     name="invoice_number"
//                     title="Invoice Number"
//                     placeholder="Invoice Number"
//                     value={formData.invoice_number}
//                     onChange={handleInputChange}
//                     className={`form-input ${errors.invoice_number ? "is-invalid" : ""
//                       }`}
//                   />
//                   {errors.invoice_number && (
//                     <div className="error-message font-size-text">
//                       {errors.invoice_number}
//                     </div>
//                   )}
//                 </div>
//                 {role === "SiteManagement" ? "" :
//                   <div title="Project" className="flex-column form-group-selectt">
//                     <label
//                       htmlFor="project"
//                       className="form-labels  font-weight500    font-size-subheading" title="Project"
//                     >
//                       Project
//                     </label>
//                     <br />
//                     <select
//                       type="text"
//                       id="project"
//                       title="Project"
//                       name="project"
//                       placeholder="project"
//                       value={formData.project}
//                       onChange={handleInputChange}
//                       className={`form-input form-group-selection ${errors.project
//                         ? "error"
//                         : inputState.project
//                           ? "success"
//                           : ""
//                         }`}
//                     >
//                       <option value="null" title="Select a Project">Select a Project</option>
//                       {projectList?.map((i, index) => (
//                         <option key={index} value={i.id}>
//                           {i.site_prcode}-{i.project_short_name}
//                         </option>
//                       ))}
//                     </select>

//                     <div className="form-group-selection-arrow">

//                     </div>
//                     {errors.project && (
//                       <span className="error-message font-size-text ">
//                         {errors.project}
//                       </span>
//                     )}
//                   </div>
//                 }
//                 <div className="flex-column form-group-selectt">
//                   <label className="form-labels font-weight500 font-size-subheading" title="Month">
//                     Month<span className="required">*</span>
//                   </label>
//                   <br />
//                   <select
//                     name="month"
//                     value={formData.month}
//                     onChange={handleInputChange}
//                     title="Month"
//                     className={`form-input form-group-selection ${errors.month ? "is-invalid" : ""
//                       }`}
//                   >
//                     <option value="" title="Select Month">Select month</option>
//                     {monthOptions.map((option) => (
//                       <option key={option.value} value={option.value}>
//                         {option.label}
//                       </option>
//                     ))}
//                   </select>
//                   <div className="form-group-selection-arrow">

//                   </div>
//                   {errors.month && (
//                     <div className="error-message font-size-text">
//                       {errors.month}
//                     </div>
//                   )}
//                 </div>
//                 <div className="flex-column form-group-selectt">
//                   <label className="form-labels font-weight500 font-size-subheading" title="Year">
//                     Year<span className="required">*</span>
//                   </label>
//                   <br />
//                   <select
//                     name="year"
//                     title="Year"
//                     value={formData.year}
//                     onChange={handleInputChange}
//                     className={`form-input form-group-selection ${errors.year ? "is-invalid" : ""
//                       }`}
//                   >
//                     <option value="" title="Select Year">Select year</option>
//                     {years.map((year) => (
//                       <option key={year} value={year} title="Select Year">
//                         {year}
//                       </option>
//                     ))}
//                   </select>
//                   <div className="form-group-selection-arrow">

//                   </div>
//                   {errors.year && (
//                     <div className="error-message font-size-text">
//                       {errors.year}
//                     </div>
//                   )}
//                 </div>

//                 <div className="button-models">
//                   <button
//                     className="model-button font-weight500 model-button-submit"
//                     onClick={handleFormSubmit}
//                     disabled={loading}
//                   >
//                     {loading ? "Adding..." : "Add"}
//                   </button>
//                 </div>
//                 <p className="error-message font-size-text">
//                   {isSubmitted && Object.keys(errors).length > 0 && (
//                     Object.keys(errors).length > 5 ? (
//                       <h5 className="text-center">Please fill all mandatory fields!</h5>
//                     ) : (

//                       <h6 className="text-center">
//                         {Object.keys(errors).map((field) =>
//                           field.charAt(0).toUpperCase() + field.slice(1)
//                         ).join(', ') + ' are required!'}
//                       </h6>
//                     )
//                   )}
//                 </p>
//               </form>
//             </div>
//           </div>
//           <ToastContainer
//             position="top-center"
//             autoClose={1000}
//             hideProgressBar={false}
//             newestOnTop={true}
//             closeOnClick
//             rtl={false}
//             pauseOnFocusLoss
//             draggable
//             pauseOnHover
//           />
//         </Modal.Body>
//       </Modal>
//     </>
//   );

// };


const AddBOQInvoice = ({ project, getInvoice }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const role = sessionStorage.getItem('sitemanagement_role');
  const projectId = sessionStorage.getItem('sitemanagement_project');

  const emptyFormData = {
    project: projectId ? projectId : "null",
    invoice_number: "",
    month: "",
    year: "",
  };

  const [formData, setFormData] = useState({ ...emptyFormData });
  const [projectList, setProjectList] = useState([]);

  const handleShow = () => {
    setFormData({ ...emptyFormData });
    setErrors({});
    setInputState({});
    setIsSubmitted(false);
    setShow(true);
  };

  const handleClose = (event) => {
    if (event) event.preventDefault();
    setShow(false);
    setFormData({ ...emptyFormData });
    setErrors({});
    setInputState({});
  };

  const getProject = async () => {
    try {
      const response = await axios.get(
        sessionStorage.getItem('sitemanagement_role') === 'AuthorityEngineer' ?
          `${BASE_URL}/siteproject/projectfilterbyauthority_engineer/${sessionStorage.getItem('sitemanagement_emp_id')}/`
          : sessionStorage.getItem('sitemanagement_role') === 'DataEntryOperator' ?
            `${BASE_URL}/siteproject/project_sub_company_BOQ_filter/${sessionStorage.getItem('sitemanagement_emp_id')}/null/`
            : `${BASE_URL}/siteproject/projectfilterbysubcompany/null/`
      );
      const sortedList = sortProjects(response.data, "site_prcode");
      setProjectList(sortedList);
    } catch (error) {
      handleErrorToast(error);
    }
  };

  useEffect(() => {
    getProject();
  }, []);

  // !  ************** Validation start **************  ! //
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [inputState, setInputState] = useState({});

  const fieldLabels = {
    invoice_number: 'Invoice Number',
    month: 'Month',
    year: 'Year',
    project: 'Project',
  };

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["invoice_number", "month", "year"];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${fieldLabels[field] || field} is required!`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));
    setInputState((prev) => ({ ...prev, [name]: value?.toString().trim() ? "green" : "" }));

    if (value?.toString().trim()) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };
  // ?  ************** Validation End **************  ! //

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        let res = await axios.post(
          `${BASE_URL}/siteproject/consultant-invoice/`,
          formData
        );

        if (res.status === 200) {
          await getInvoice();
          toast.dismiss(loadingToastId);
          toast.success("Invoice added successfully");
          handleClose();
        } else {
          toast.dismiss(loadingToastId);
          toast.error("Failed to add data!");
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  const monthOptions = [
    { value: "01", label: "January" },
    { value: "02", label: "February" },
    { value: "03", label: "March" },
    { value: "04", label: "April" },
    { value: "05", label: "May" },
    { value: "06", label: "June" },
    { value: "07", label: "July" },
    { value: "08", label: "August" },
    { value: "09", label: "September" },
    { value: "10", label: "October" },
    { value: "11", label: "November" },
    { value: "12", label: "December" },
  ];

  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: 10 }, (_, i) => currentYear - i);
  const yearOptions = years.map((y) => ({ value: y, label: `${y}` }));

  const projectOptions = projectList?.map((p) => ({
    value: p.id,
    label: `${p.site_prcode}-${p.project_short_name}`,
  }));

  return (
    <>
      <AddDynamicButton title="Add Invoice" logo={<ReceiptIndianRupeeIcon size={20} />} onClick={handleShow} />


      <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="lg">
        <Modal.Header className="modern-modal-header">
          <div className="header-content">
            <div style={{ color: "white" }}>
              <ReceiptIndianRupeeIcon size={24} />
            </div>
            <div>
              <Modal.Title>Add Invoice</Modal.Title>
              <p className="header-subtitle" style={{ color: "white" }}>Fill in the details to add a new invoice</p>
            </div>
          </div>
          <button className="close-btn" onClick={handleClose}>
            <X size={20} />
          </button>
        </Modal.Header>

        <Modal.Body className="modern-modal-body">
          <form onSubmit={handleFormSubmit} className="project-form">
            <div className="form-section">
              <div className="section-title">
                <ReceiptIndianRupeeIcon size={18} />
                <h4>Invoice Details</h4>
              </div>
              <div className="form-grid">
                <div className="form-field">
                  <label><Hash size={14} /> Invoice Number<span className="required">*</span></label>
                  <input
                    type="text"
                    name="invoice_number"
                    placeholder="Invoice Number"
                    value={formData.invoice_number}
                    onChange={handleInputChange}
                    className={errors.invoice_number ? "error" : inputState.invoice_number ? "success" : ""}
                  />
                  {errors.invoice_number && <span className="error-message">{errors.invoice_number}</span>}
                </div>

                {role !== "SiteManagement" && (
                  <div className="form-field">
                    <label><Briefcase size={14} /> Project</label>
                    <Select
                      placeholder="Select a Project"
                      value={projectOptions?.find((opt) => opt.value === formData.project) || null}
                      onChange={(selectedOption) => {
                        setFormData((prev) => ({ ...prev, project: selectedOption ? selectedOption.value : "" }));
                        setInputState((prev) => ({ ...prev, project: selectedOption ? "green" : "" }));
                        setErrors((prev) => {
                          const updated = { ...prev };
                          if (selectedOption) delete updated.project;
                          return updated;
                        });
                      }}
                      options={projectOptions}
                      styles={CSSForSelectModern}
                      isSearchable
                      isClearable
                    />
                    {errors.project && <span className="error-message">{errors.project}</span>}
                  </div>
                )}

                <div className="form-field">
                  <label><Calendar size={14} /> Month<span className="required">*</span></label>
                  <Select
                    placeholder="Select Month"
                    value={monthOptions?.find((opt) => opt.value === formData.month) || null}
                    onChange={(selectedOption) => {
                      setFormData((prev) => ({ ...prev, month: selectedOption ? selectedOption.value : "" }));
                      setInputState((prev) => ({ ...prev, month: selectedOption ? "green" : "" }));
                      setErrors((prev) => {
                        const updated = { ...prev };
                        if (selectedOption) delete updated.month;
                        return updated;
                      });
                    }}
                    options={monthOptions}
                    styles={CSSForSelectModern}
                    isSearchable
                    isClearable
                  />
                  {errors.month && <span className="error-message">{errors.month}</span>}
                </div>

                <div className="form-field">
                  <label><Calendar size={14} /> Year<span className="required">*</span></label>
                  <Select
                    placeholder="Select Year"
                    value={yearOptions?.find((opt) => opt.value === formData.year) || null}
                    onChange={(selectedOption) => {
                      setFormData((prev) => ({ ...prev, year: selectedOption ? selectedOption.value : "" }));
                      setInputState((prev) => ({ ...prev, year: selectedOption ? "green" : "" }));
                      setErrors((prev) => {
                        const updated = { ...prev };
                        if (selectedOption) delete updated.year;
                        return updated;
                      });
                    }}
                    options={yearOptions}
                    styles={CSSForSelectModern}
                    isSearchable
                    isClearable
                  />
                  {errors.year && <span className="error-message">{errors.year}</span>}
                </div>
              </div>

              <div className="form-actions">
                <div></div>
                <div className="submit-buttons">
                  <button type="button" className="btn-secondaryy" onClick={handleClose}>
                    Cancel
                  </button>
                  <button type="submit" className="btn-primaryy" disabled={loading}>
                    {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                    <span>{loading ? 'Adding...' : 'Add'}</span>
                  </button>
                </div>
              </div>

              {isSubmitted && Object.keys(errors).length > 0 && (
                <div className="tab-error-message" style={{ marginTop: '12px' }}>
                  <AlertCircle size={14} />
                  <span>Please fill all mandatory fields!</span>
                </div>
              )}
            </div>
          </form>

          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

const Generateconsultantinvoicebyproject = ({ getInvoice, projectsList }) => {
  // console.log(projectList, 'projectid')
  const [show, setShow] = useState(false);

  const { projectID } = usePermission();

  const siteRole = sessionStorage.getItem("sitemanagement_role");
  const handleShow = () => {
    // getVehicle();
    setShow(true);
  }

  const handleClose = (e) => {
    // getVehicle();
    if (e?.preventDefault) {
      e.preventDefault();
    }
    setShow(false);
  }




  const [formData, setFormData] = useState({
    month: datearray[1],
    year: datearray[0],
    numberproject: siteRole === "SiteManagement" ? "single" : '',
    project: projectID ? projectID : "",
    date: '',
  });










  const monthOptions = [
    { id: 1, name: "January" },
    { id: 2, name: "February" },
    { id: 3, name: "March" },
    { id: 4, name: "April" },
    { id: 5, name: "May" },
    { id: 6, name: "June" },
    { id: 7, name: "July" },
    { id: 8, name: "August" },
    { id: 9, name: "September" },
    { id: 10, name: "October" },
    { id: 11, name: "November" },
    { id: 12, name: "December" }
  ];
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 20; // starting 20 years ago
  const endYear = currentYear + 20; // up to 20 years in the future
  const years = Array.from({ length: endYear - startYear + 1 }, (_, index) => startYear + index);





  const handleInputChange = (e) => {
    const { name, value } = e.target;



    setFormData({
      ...formData,
      [name]: value,
    });
  };

  // ?  ************** Validation End **************  ! //
  const [generateSingleProjectloading, setGenerateSingleProjectLoading] = useState(false);
  const [generateAllProjectloading, setGenerateAllProjectLoading] = useState(false);
  const handleGenerateSingleProject = async (e) => {
    e.preventDefault();

    setGenerateSingleProjectLoading(true); //loading logic

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic



    try {
      const ress = await axios.post(
        `${BASE_URL}/siteproject/generateconsultantinvoicebyproject/`,
        {
          project_id: formData.project,
          bill_date: formData.date,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );


      if (ress.status === 200) {
        await getInvoice();
        setShow(false);

      } else if (ress.status === 400) {
        toast.error("Billing for this project and month already exists.")
        setShow(false);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setGenerateSingleProjectLoading(false); // Ensure loading state is stopped even in case of error //loading logic
      toast.dismiss(loadingToastId);
    }



  };

  const handleGenerateAllProject = async (e) => {
    e.preventDefault();

    setGenerateAllProjectLoading(true); //loading logic

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic



    try {
      const ress = await axios.post(
        `${BASE_URL}/siteproject/generateconsultantinvoicesallprojects
/`,

        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );


      if (ress.status === 200) {
        await getInvoice();
        setShow(false);
      } else {

      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setGenerateAllProjectLoading(false); // Ensure loading state is stopped even in case of error //loading logic
      toast.dismiss(loadingToastId);
    }



  };


  const [errors, setErrors] = useState({});
  // !  ************** Validation start **************  ! //
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "month",
      "year",
    ]
    console.log(formData.month)
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  }


  // const [generateAllVehicleloading, setGenerateAllVehicleLoading] = useState(false); //loading logic
  // const handleGenerateAllVechicle = async (e) => {
  //     e.preventDefault();
  //     if (validateForm()) {
  //         setGenerateAllVehicleLoading(true); //loading logic

  //         const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

  //         try {
  //             let ress = await axios.post(
  //                 `${BASE_URL}/siteproject/generate-vehicle-bill-by-all-vehicle/`
  //             );

  //             if (ress.status === 200) {
  //                 await getOfficeBillingDetails();

  //             } else {
  //                 alert(ress);
  //             }
  //         } catch (err) {
  //             handleErrorToast(err);
  //         } finally {
  //             setGenerateAllVehicleLoading(false); // Ensure loading state is stopped even in case of error //loading logic
  //             toast.dismiss(loadingToastId);
  //         }
  //     }


  // };

  const [subcompany, setSubCompany] = useState("null");



  return (
    <>
      <button title="Generate Office  Bills" className="upload-svg" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clip-path="url(#clip0_1415_3177)">
            <path
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1415_3177">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>
        {" "} Generate Invoices
      </button>

      <Modal show={show}
        onHide={(e) => handleClose(e)}
        dialogClassName="request-leave  width-40vw">
        <Modal.Header closeButton>
          <Modal.Title>Generate Invoices</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
          <div className="parent-div">
            <div className="bdy-div">
              <form>

                <div title="project" className="flex-column form-group-selectt">
                  <label htmlFor="project" className="form-labels  font-weight500    font-size-subheading">
                    What to Generate Invoice for ?
                  </label>
                  <br />
                  <select
                    id="numberproject"
                    name="numberproject"
                    value={formData.numberproject}
                    onChange={handleInputChange}
                    className="form-input form-group-selection"
                  >
                    <option value="">Generate Invoice for </option>
                    <option value="single">Single</option>
                    <option value="All">All</option>
                  </select>

                  <div>
                    {errors.numberproject && (
                      <span className="error-message font-size-text ">{errors.numberproject}</span>
                    )}
                  </div>
                </div>
                {

                  formData.numberproject === "single" && siteRole !== "SiteManagement" &&
                  <div title="Project" className="flex-column form-group-selectt">
                    <label htmlFor="project" className="form-labels  font-weight500    font-size-subheading">
                      Project<span className="required">*</span>
                    </label>
                    <br />
                    <select
                      type="text"
                      id="project"
                      name="project"
                      placeholder="project"
                      value={formData.project}
                      onChange={handleInputChange}
                      className='form-input form-group-selection'
                    >

                      <option value="null">Select a Project</option>
                      {projectsList?.sort((a, b) => a.project_short_name.localeCompare(b.project_short_name, 'en', { ignorePunctuation: true })).map((i, index) => (
                        <option key={index} value={i.id}>{i.project_short_name}</option>
                      ))}
                    </select>

                    <div className="form-group-selection-arrow">

                    </div>

                  </div>
                }

                {/* <div title="Month" className="flex-column form-group-selectt">
                                  <label htmlFor="month" className="form-labels  font-weight500    font-size-subheading">
                                      Month<span className="required">*</span>
                                  </label>
                                  <br />
                                  <select
                                      type="text"
                                      id="month"
                                      name="month"
                                      placeholder="month"
                                      value={formData.month}
                                      onChange={handleInputChange}
                                      className={`form-input-date form-group-selection `}
                                  >

                                      <option value="">Select a month</option>
                                      {monthOptions.map((month) => (
                                          <option key={month.id} value={month.id}>{month.name}</option>
                                      ))}
                                  </select>
                                  <div className="form-group-selection-arrow">
                                      <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="25"
                                          fill="currentColor"
                                          className="bi bi-caret-down-fill"
                                          viewBox="0 0 16 16"
                                      >
                                          <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                      </svg>
                                  </div>

                              </div>

                              <div title="Year" className="flex-column form-group-selectt">
                                  <label htmlFor="year" className="form-labels  font-weight500    font-size-subheading">
                                      Year<span className="required">*</span>
                                  </label>
                                  <br />
                                  <select
                                      type="text"
                                      id="year"
                                      name="year"
                                      placeholder="year"
                                      value={formData.year}
                                      onChange={handleInputChange}
                                      className={`form-input-date form-group-selection`}
                                  >

                                      <option value="">Select a Year</option>
                                      {years.map((year) => (
                                          <option key={year} value={year}>{year}</option>
                                      ))}
                                  </select>
                                  <div className="form-group-selection-arrow">
                                      <svg
                                          xmlns="http://www.w3.org/2000/svg"
                                          width="20"
                                          height="25"
                                          fill="currentColor"
                                          className="bi bi-caret-down-fill"
                                          viewBox="0 0 16 16"
                                      >
                                          <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
                                      </svg>
                                  </div>

                              </div> */}
                <div className="flex-column">
                  <label htmlFor="date" className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                    Date<span className="required">*</span>
                  </label>
                  <input
                    id="date"
                    type="date"
                    name="date"
                    onChange={handleInputChange}
                    value={formData.date}
                    className={`form-input 
                
                  `}

                  //   ${errors.date ? "error" : inputState.date ? "success" : ""
                  // }
                  />
                  {errors.date && (
                    <span className="error-message font-size-text ">{errors.date}</span>
                  )}
                </div>

                <div>
                  {formData.numberproject === "single" ? (<>
                    <button className="model-button  font-weight500  model-button-bill   model-button-leave font-size-heading" title="generateSingleProjectloading" onClick={handleGenerateSingleProject} disabled={generateAllProjectloading} >
                      {generateSingleProjectloading ? 'Generating...' : 'Generate For Single Project'}
                    </button>
                  </>) : (<>
                    <button className="model-button  font-weight500  model-button-bill   model-button-leave font-size-heading" title="generateAllProjectloading" onClick={handleGenerateAllProject} disabled={generateAllProjectloading} >
                      {generateAllProjectloading ? 'Generating...' : 'Generate For All Project'}
                    </button>
                  </>)}


                </div>

                {/* <div>
                                  <button className="model-button  font-weight500 model-button-bill    model-button-leave font-size-heading" title='generateAllVehicleloading' onClick={handleGenerateAllVechicle} disabled={generateAllVehicleloading} >
                                      {generateAllVehicleloading ? 'Generating...' : 'Generate For All Vehicle'}
                                  </button>

                              </div> */}
                {/* 
                <div>
                <GenerateforVehicle vehicleList={vehicleList} />
                
                </div> */}



                <div style={{ marginTop: '10px' }}>
                  <button className="model-button-cancel model-button font-weight500" onClick={(e) => handleClose(e)}>
                    Cancel
                  </button>

                </div>
              </form>
            </div></div>
        </Modal.Body>
      </Modal>
    </>




  )
}

const DeleteInvoice = ({ i, getInvoice }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);

    const loadingToastId = toast.loading("Loading: Please wait...");

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);

    try {
      let res = await axios.delete(`${BASE_URL}/siteproject/consultantinvoice/${i.id}/`);

      if (res.status === 200) {
        await getInvoice();
        toast.dismiss(loadingToastId);
        toast.success("Data deleted successfully!");
        setShow(false);
      } else {
        toast.dismiss(loadingToastId);
        toast.error("Failed to delete data!");
      }
    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      handleErrorToast(err);
    } finally {
      clearInterval(interval);
      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button title="Delete Invoice" className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
        <DeleteDustbin modernButton="true" />
      </button>

      {showProgressModal ? (
        <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" />
      ) : (
        <Modal show={show} onHide={handleClose} dialogClassName="modern-required-modal" centered>
          <Modal.Header className="modern-modal-header requirement-modal-header">
            <div className="header-content">
              <div className="requirement-header-icon">
                <Trash2 size={22} />
              </div>
              <div>
                <Modal.Title>Delete Invoice</Modal.Title>
                <p className="header-subtitle" style={{ color: "white" }}>
                  This action cannot be undone
                </p>
              </div>
            </div>
            <button className="close-btn" onClick={handleClose}>
              <X size={20} />
            </button>
          </Modal.Header>

          <Modal.Body className="modern-modal-body requirement-modal-body">
            <div className="requirement-mode-summary" style={{ marginBottom: '20px' }}>
              <AlertCircle size={16} />
              <span>
                Are you sure you want to delete invoice <strong>{i.invoice_number}</strong>?
              </span>
            </div>

            <div className="submit-buttons" style={{ justifyContent: 'flex-end' }}>
              <button type="button" className="btn-secondaryy" onClick={handleClose} disabled={loading}>
                Cancel
              </button>
              <button
                type="button"
                className="btn-primaryy"
                style={{ background: "#dc3545", borderColor: "#dc3545" }}
                onClick={handleFormSubmitDelete}
                disabled={loading}
              >
                {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                <span>{loading ? 'Deleting...' : 'Delete'}</span>
              </button>
            </div>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};



// ? *************** Project Crud Models End ***************

const AddTrackRecordDetails = ({

  getProjects,
  projectList,
  projectId,
  contractor,
  contractorlist,
  lettertype,
  letterfor,
  projectName,
  site_prcode,
  title,
}) => {
  const [letterData, setLetterData] = useState([]);
  const siteSubCompany = sessionStorage.getItem("sitemanagement_project_sub_company");
  const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format


  const [toggleStatus, setToggleStatus] = useState(siteSubCompany === "6d96e791-c499-4524-ba5a-2e8d9f99ad7c" ? "48cb62b4-9b60-4305-b6b4-b9da5d1baaf5" : "59408e4e-a455-46b6-b3db-8deaa0ae4475");


  const [siteDepartmentList, setSiteDepartmentList] = useState([]);
  const [isLetterNumLoaded, setIsLetterNumLoaded] = useState(false);

  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState(initialFormData());
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [trackRecordList, setTrackRecordList] = useState([]);
  const [fileNames, setFileNames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0); // For upload progress
  const [contractorlists, setContractorLists] = useState([]);

  // console.log(contractorlists)

  function initialFormData() {
    return {
      project: projectId ? projectId : "",
      letter_num: "",
      reply_by: "",
      subject: "",
      letter_date: "",
      status: "pending",
      workperformedby: letterfor ? letterfor : sessionStorage.getItem('sitemanagement_role') === "SiteManagement" ? "contractor" : "consultant",
      lettertype: lettertype ? lettertype : "null",
      letterExchange: sessionStorage.getItem('sitemanagement_role') === "SiteManagement" ? "receive" : "send",
      associated_letters: [],
      associated_letters_status: "pending",
      letterdepartment: "",
      is_timebound: false,
      letter_from: "null",
      letter_to: "",
      tat_duration: 0,
      end_date: null,

      documents: [{ document_name: "", document_file: "" }],
      contractor: contractor ? contractor : "",
      remarks: '',
    };
  }
  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      contractor: letterfor === "contractor" ? contractor : "",
    }));
  }, [contractor]);



  useEffect(() => {
    if (formData.project || formData.workperformedby) {
      fetchAssociatedLetters();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.project, formData.workperformedby, formData.lettertype]);

  const [letterNumberList, setLetterNumberList] = useState([]);


  const fetchLetterNumber = async () => {
    try {
      setIsLetterNumLoaded(false);

      const res = await axios.get(
        `${BASE_URL}/siteproject/letterrecordfilterletter/${formData.project}/null/null/null/null/null/`
      );

      if (res.status === 200) {
        setLetterNumberList(res.data);
        setIsLetterNumLoaded(true);
      }
    } catch (error) {
      console.error(error);
      setIsLetterNumLoaded(false);
    }
  };


  useEffect(() => {
    if (show === true && formData.project !== "null") {
      fetchLetterNumber();


    }
  }, [formData.project, show]);

  useEffect(() => {
    const filterNum = letterNumberList.filter(i => i.letter_num === formData.letter_num);
    if (filterNum.length > 0) {
      toast.warning(`Letter already exist change letter number ${formData.letter_num}`)
    }
  }, [formData.letter_num, letterNumberList])



  const fetchAssociatedLetters = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/letterrecordbclosestatus/${formData.project || 'null'
        }/${formData.workperformedby || 'null'}/${formData.lettertype || 'null'}/`
      );
      setTrackRecordList(res.data);
    } catch (err) {
      console.error("Error fetching letters.", err);
    }
  };
  const [buffer, setBuffering] = useState(true); //buffering logic


  const getSiteDepartment = async () => {
    setBuffering(true); //buffering logic // Start Buffering
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/department/`);
      setSiteDepartmentList(res.data);
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      setBuffering(false); //buffering logic // End Buffering
    }
  };

  // Function to Fetch Contractor Details
  const getProjectContractorDetails = async () => {
    try {
      const contractordetails = await axios.get(
        `${BASE_URL}/siteproject/contractorbyproject/${formData.project}/null/`
      );
      setContractorLists(contractordetails.data);
    } catch (err) {
      // handleErrorToast(err);
    } finally {
    }
  };


  const handleShow = () => {
    setShow(true);
    if (projectId) {
      getProjectContractorDetails();
    }
    getSiteDepartment();

  };

  const handleClose = () => {
    setShow(false);
    setFormData(initialFormData());
    setErrors({});
    setInputState({});
    setFileNames([]);
  };
  const validateForm = () => {
    const requiredFields = [
      'letter_num',
      'project',
      'subject',
      'letter_date',
      'status',
      'lettertype',
      'workperformedby',
      'letterExchange',
      'letter_to',
      // 'letter_from',
    ];

    const newErrors = requiredFields.reduce((acc, field) => {
      if (
        !formData[field] ||
        formData[field] === "null" ||
        (Array.isArray(formData[field]) && formData[field].length === 0)
      ) {
        acc[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
          } is required!`;
      }
      return acc;
    }, {});

    // Conditional validation for 'contractor' field
    if (formData.workperformedby === "contractor" && !formData.contractor) {
      newErrors["contractor"] = "Contractor Name is required!";
    }

    // Conditional validation for 'associated_letters_status'
    if (
      formData.associated_letters &&
      formData.associated_letters.length > 0 &&
      !formData.associated_letters_status
    ) {
      newErrors["associated_letters_status"] =
        "Status for associated letters is required!";
    }

    // Validate documents array
    formData.documents.forEach((doc, index) => {
      if (!doc.document_name || doc.document_name.trim() === "") {
        newErrors[`document_name_${index}`] = `Document Name is required for document ${index + 1}`;
      }
      if (!doc.document_file) {
        newErrors[`document_file_${index}`] = `Document File is required for document ${index + 1}`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };
  const handleInputChange = (e) => {
    const { name, value, type, checked, options } = e.target;

    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else if (type === "select-multiple") {
      newValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else {
      newValue = value;
    }

    if (name === "letter_date") {
      const selectedDate = new Date(value);
      const todayDate = new Date();

      todayDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate > todayDate) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Date cannot be greater than today.",
        }));
        return; // stop updating invalid value
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "",
        }));
      }
    }

    // === Word limit for other_type_name ===
    if (name === "other_type_name") {
      const charCount = value.trim().length;

      if (charCount > 15) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          other_type_name: "Maximum 15 characters allowed.",
        }));
        return;
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          other_type_name: "",
        }));
      }
    }


    // === Update input state for validation feedback ===
    setInputState((prevState) => ({
      ...prevState,
      [name]:
        newValue && (Array.isArray(newValue) ? newValue.length > 0 : newValue)
          ? "success"
          : "",
    }));

    // === Update form data with additional logic ===
    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: newValue,

        ...(name === "reply_by" &&
          prevFormData.letterExchange === "send" && {
          letter_from: value,
        }),

        ...(name === "workperformedby" &&
          value === "consultant" && {
          contractor: "",
        }),
      };

      return updatedFormData;
    });
  };



  // const handleDocInputChange = (index, e) => {
  //   const { name, value, files } = e.target;

  //   setFormData((prevFormData) => {
  //     const newDocuments = [...prevFormData.documents];
  //     newDocuments[index] = {
  //       ...newDocuments[index],
  //       [name]: files ? files[0] : value, // Removed .trim()
  //     };

  //     if (files) {
  //       setFileNames((prevFileNames) => {
  //         const newFileNames = [...prevFileNames];
  //         newFileNames[index] = files[0]?.name || "";
  //         return newFileNames;
  //       });
  //     }

  //     return { ...prevFormData, documents: newDocuments };
  //   });
  // };


  const handleDocInputChange = (index, e) => {
    const { name, value, files } = e.target;

    setFormData((prevFormData) => {
      const newDocuments = [...prevFormData.documents];

      // if it's a file input
      if (files && files[0]) {
        const file = files[0];

        // ✅ Allowed file types
        const allowedTypes = [
          "application/pdf",
          "application/zip", "application/x-zip-compressed",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/vnd.ms-excel",
          "image/png",
          "image/gif"
        ];

        if (!allowedTypes.includes(file.type) && !file.name.match(/\.(zip|pdf|xls|xlsx|png|gif)$/i)) {
          toast.error("Only ZIP, PDF, PNG, GIF and Excel files are allowed!");
          return prevFormData;
        }

        // ✅ Generate Aimantra filename
        const symbols = "!@#$%^&*()_-+=";
        const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
        const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const numbers = "0123456789";
        const now = new Date();
        const date = now.toLocaleDateString("en-GB").split("/").reverse().join("-"); // YYYY-MM-DD
        const time = now.toLocaleTimeString("en-GB", { hour12: false }).replace(/:/g, "-"); // HH-MM-SS
        const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;

        let randomCode = "";
        for (let i = 0; i < 8; i++) {
          const randomIndex = Math.floor(Math.random() * allChars.length);
          randomCode += allChars[randomIndex];
        }




        const aimantraFileName = ` ${site_prcode}-${projectName}  ${file.name} ${date} ${time}_${randomCode}`;
        const customFile = new File([file], aimantraFileName, { type: file.type });

        // ✅ Update document data
        newDocuments[index] = {
          ...newDocuments[index],
          document_file: customFile,
          original_filename: aimantraFileName, // store Aimantra name here
          // document_name stays untouched
        };

        // ✅ Update fileNames for display
        setFileNames((prevFileNames) => {
          const newFileNames = [...prevFileNames];
          newFileNames[index] = aimantraFileName;
          return newFileNames;
        });
      }
      // if it's a normal text input
      else {
        newDocuments[index] = {
          ...newDocuments[index],
          [name]: value,
        };
      }

      return { ...prevFormData, documents: newDocuments };
    });

    // ✅ Handle validation errors
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      const fieldKey = `${name}_${index}`;
      const isValid =
        name === "document_name" ? value.trim() !== "" : files && files[0];
      if (isValid) {
        delete newErrors[fieldKey];
      }
      return newErrors;
    });
  };
  const handleAddDocuments = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: [
        ...prevFormData.documents,
        { document_name: "", document_file: null },
      ],
    }));
  };

  const handleRemoveDocument = (index) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: prevFormData.documents.filter((_, i) => i !== index),
    }));
    setFileNames((prevFileNames) =>
      prevFileNames.filter((_, i) => i !== index)
    );
  };

  const getLetterTat = async () => {
    try {
      setBuffering(true);
      const res = await axios.get(`${BASE_URL}/siteproject/tatdurationfilter/${toggleStatus}/`);
      setLetterData(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    if (show === true) {
      getLetterTat();

    }
  }, [toggleStatus, show]);


  function addDaysToLetterDate(letterDate, daysToAdd) {
    const date = new Date(letterDate);
    date.setDate(date.getDate() + daysToAdd);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    const letter_tat = letterData?.find(item => item?.letter_type_data?.name === formData?.lettertype);
    if (letter_tat) {
      setFormData((prev) => ({
        ...prev,
        tat_duration: Number(letter_tat.tat_duration),
        end_date: addDaysToLetterDate(formData.letter_date, letter_tat.tat_duration),
      }));
    }
  }, [formData.lettertype, formData.letter_date, letterData, formData.is_timebound]);


  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        const formDataToSend = new FormData();

        Object.keys(formData).forEach((key) => {
          if (key !== "documents" && formData[key]) {
            if (key === "associated_letters") {
              formDataToSend.append(key, JSON.stringify(formData[key]));
            } else {
              formDataToSend.append(key, formData[key]);
            }
          }
        });
        let fileIndex = 0;
        for (let doc of formData.documents) {
          if (doc.document_file) {
            const fileId = await uploadFileInChunks(
              doc.document_file,
              doc.document_name,
              setUploadProgress
            );
            if (!fileId) {
              console.error(`❌ Failed to upload file: ${doc.document_name}`);
              continue;
            }
            console.log(doc, "documents");
            formDataToSend.append("file_ids", fileId);
            formDataToSend.append(
              `documents[${fileIndex}][document_name]`,
              doc.document_name
            );
            formDataToSend.append(
              `documents[${fileIndex}][original_filename]`,
              doc.document_file.name
            );
            formDataToSend.append(
              `documents[${fileIndex}][file]`,
              doc.document_file
            );
            fileIndex++;
          }
        }

        if (!formDataToSend.has("file_ids")) {
          console.error("❌ No valid files were uploaded.");
          setLoading(false);
          return;
        }

        const res = await axiosInstance2.post("/siteproject/documentbulkwithletter-new/",
          formDataToSend,
          {
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress(percentCompleted);
            },
          }
        );

        if (res.status === 200) {
          await getProjects(); // Refresh project list
          toast.success("Letter Documents uploaded successfully!");
          handleClose();
        } else {
          throw new Error("Document upload failed");
        }
      } catch (err) {
        toast.error("Error uploading documents");
        console.error("Error uploading documents", err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
        setUploadProgress(0);
      }
    }
  };

  const createCustomFile = (originalFile) => {
    const randomCode = generateRandomString();
    const now = new Date();
    const date = now.toISOString().split("T")[0];
    const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
    const customFileName = `Aimantra ${date} ${time}_${randomCode}_${originalFile.name}`;
    return new File([originalFile], customFileName, {
      type: originalFile.type,
    });
  };

  const generateRandomString = () => {
    const chars =
      "!@#$%^&*()_+abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array.from(
      { length: 8 },
      () => chars[Math.floor(Math.random() * chars.length)]
    ).join("");
  };

  useEffect(() => {
    if (formData.project) {
      getProjectContractorDetails();
    }
  }, [formData.project]); // Dependency array includes formData.project

  const options = trackRecordList
    .sort((a, b) => parseInt(a.letter_num) - parseInt(b.letter_num))
    .map((e) => ({
      value: e.id,
      label: `${e.letter_num} - ${e.letter_date}`,
    }));

  const handleChangecc = (selected) => {
    const associated_letters =
      selected.length > 0 ? selected.map((item) => item.value) : "";
    setFormData((prevState) => ({
      ...prevState,
      associated_letters,
    }));
  };


  return (
    <>


      <button type="button" className="letter_button" onClick={handleShow}>
        <span className="letter_button__text">Add Letter</span>
        <span className="letter_button__icon"><svg xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" stroke-width="2" stroke-linejoin="round" stroke-linecap="round" stroke="currentColor" height="24" fill="none" className="svg"><line y2="19" y1="5" x2="12" x1="12"></line><line y2="12" y1="12" x2="19" x1="5"></line></svg></span>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>Add {title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-form">
            <div className="form-flex-wrap">

              {sessionStorage.getItem('sitemanagement_role') === "SiteManagement" ? "" :

                ((projectId === 'null' || projectId === undefined || projectId === "") && (
                  <div className="form-group">
                    <RenderSelectField
                      title="Site Project"
                      name="project"
                      required={true}
                      options={projectList?.map((project) => ({
                        value: project.id,
                        label: `${project.site_prcode} - ${project.project_short_name}`,
                      }))}
                      placeholder="Select a Project"
                      formData={formData}
                      errors={errors}
                      inputState={inputState}
                      handleInputChange={handleInputChange}
                    />
                    {errors.project && (
                      <div className="error-message col">
                        {errors.project}
                      </div>
                    )}
                  </div>
                ))
              }


              <div className="form-group">
                <RenderSelectField
                  title="Letter Exchange"
                  name="letterExchange"
                  required={true}
                  options={[
                    { value: "send", label: "Send" },
                    { value: "receive", label: "Received" },
                  ]}
                  placeholder="Select an Exchange Type"
                  formData={formData}
                  errors={errors}
                  inputState={inputState}
                  handleInputChange={handleInputChange}
                />
                {errors.letterExchange && (
                  <div className="error-message col">
                    {errors.letterExchange}
                  </div>
                )}
              </div>

              {formData.letterExchange === "send" && (
                <div className="form-group">
                  <RenderSelectField
                    title="Reply By"
                    name="reply_by"
                    required={true}
                    options={[
                      { value: "HO", label: "Head Office" },
                      { value: "SO", label: "Site Office" },
                    ]}
                    placeholder="Select a Reply By"
                    formData={formData}
                    errors={errors}
                    inputState={inputState}
                    handleInputChange={handleInputChange}
                  />
                  {errors.reply_by && (
                    <div className="error-message col">{errors.reply_by}</div>
                  )}
                </div>
              )}

              {!isLetterNumLoaded ?
                <div class="spinner center">
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                  <div class="spinner-blade"></div>
                </div> :
                (
                  <div className="form-group">
                    <RenderInputField
                      title={`${formData.letterExchange === "null"
                        ? ""
                        : toTitleCase(formData.letterExchange)
                        } Letter Number`}
                      name="letter_num"
                      required={true}
                      placeholder="Enter Letter Number"
                      formData={formData}
                      errors={errors}
                      inputState={inputState}
                      handleInputChange={handleInputChange}
                    />

                    {errors.letter_num && (
                      <div className="error-message col">{errors.letter_num}</div>
                    )}
                  </div>
                )}


              <>

                <div className="form-group">
                  <div className="flex-column">
                    <div
                      className="flex-row justify-between"
                      style={{ height: "25px" }}>
                      <label
                        htmlFor="lettertype"
                        className="form-labels font-weight500 font-size-subheading">
                        LetterType{" "}
                        <span className="required">*</span>
                      </label>
                      {formData.lettertype !== "null" && (
                        <div className="checkbox-wrapper">
                          <label className="custom-checkbox  font-weight500 font-size-subheading">
                            <input
                              type="checkbox"
                              name="is_timebound"
                              checked={formData.is_timebound || false}
                              onChange={handleInputChange}
                            />
                            <span className="checkmark"></span>
                            Time Bound
                          </label>
                        </div>
                      )}
                    </div>
                    <input
                      readOnly
                      value={formData.lettertype}
                      name="lettertype"
                      className={`form-input ${errors.lettertype ? 'error' : inputState.lettertype ? 'success' : ''}`}

                    />
                  </div>
                  {errors.lettertype && (
                    <div className="error-message col">
                      {errors.lettertype}
                    </div>
                  )}
                </div>

              </>
              <div className="flex-column">
                <label className="form-labels">
                  Tat Duration <span className="required">{formData.is_timebound === false ? "(Read-Only)" : "*"}</span>
                </label>
                <input
                  type="number"
                  name="tat_duration"
                  placeholder="Enter Tat Duration"
                  value={formData.tat_duration}
                  onChange={handleInputChange}
                  disabled={formData.is_timebound === false}
                  className={`form-input input-form ${errors.tat_duration
                    ? "error"
                    : inputState.tat_duration
                      ? "success"
                      : ""
                    }`}
                />

                {errors.tat_duration && (
                  <div style={{ color: "red", marginTop: "4px" }}>
                    {errors.tat_duration}
                  </div>
                )}
              </div>


              <div className="form-group">
                <RenderInputField
                  title={`${formData.letterExchange === "null" ? "" : toTitleCase(formData.letterExchange)} Letter Date`}
                  name="letter_date"
                  type="date"
                  max={today}
                  required={true}
                  formData={formData}
                  errors={errors}
                  inputState={inputState}
                  handleInputChange={handleInputChange}
                />
                {errors.letter_date && (
                  <div className="error-message col">{errors.letter_date}</div>
                )}
              </div>

              <div className="form-group">
                <RenderInputField
                  title="Subject"
                  name="subject"
                  placeholder="Write only the bold part in the subject of the letter...."
                  rows={5}
                  cols={50}
                  formData={formData}
                  errors={errors}
                  required={true}
                  inputState={inputState}
                  handleInputChange={handleInputChange}
                />
                {errors.subject && (
                  <div className="error-message col">{errors.subject}</div>
                )}
              </div>

              <div className="form-group">
                <div title="Status" className="flex-column form-group-selectt">
                  <label
                    htmlFor="status"
                    className="form-labels  font-weight500    font-size-subheading">
                    Status<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="status"
                    name="status"
                    placeholder="Status"
                    value={formData.status}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.status
                      ? "error"
                      : inputState.status
                        ? "success"
                        : ""
                      }`}>
                    <option value="pending">Pending</option>
                    {formData.letterExchange === "receive" ? (
                      ""
                    ) : (
                      <option value="close">Close</option>
                    )}
                  </select>
                  {/*  */}
                </div>
                {errors.status && (
                  <div className="error-message col">{errors.status}</div>
                )}
              </div>


              {formData.workperformedby === 'contractor' && <div title=" Contractor Name" className="flex-column form-group-selectt">
                <label htmlFor="project" className="form-labels  font-weight500    font-size-subheading">
                  Contractor Name<span className="required">*</span>
                </label>
                <br />
                <select
                  id="contractor"
                  name="contractor"
                  value={formData.contractor}
                  onChange={handleInputChange}
                  disabled={!!contractor}

                  className={`form-input form-group-selection ${errors.contractor ? "error" : inputState.contractor ? "success" : ""
                    }`}
                >
                  <option value="null">Select a Contractor</option>
                  {contractorlists?.sort((a, b) => a.name?.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                    <option value={i.id}>{i.name}</option>
                  </>))
                  }
                </select>
                {/* {formData.project !== "" ? "" :  */}
                <div className="form-group-selection-arrow">

                </div>
                {/* } */}
                <div>
                  {errors.project && (
                    <span className="error-message font-size-text ">{errors.project}</span>
                  )}
                </div>
              </div>
              }





              {formData.letterExchange === 'receive' &&
                <div className="form-group">
                  <RenderInputField
                    title="Letter From"
                    name="letter_from"
                    placeholder="Letter From"
                    max={100}
                    formData={formData}
                    required={true}
                    errors={errors}
                    inputState={inputState}
                    handleInputChange={handleInputChange}
                  />
                  {errors.letter_from && (
                    <div className="error-message col">
                      {errors.letter_from}
                    </div>
                  )}
                </div>}

              <div className="form-group">
                <RenderInputField
                  title="Letter To"
                  name="letter_to"
                  placeholder="Letter To"
                  max={100}
                  required={true}
                  formData={formData}
                  errors={errors}
                  inputState={inputState}
                  handleInputChange={handleInputChange}
                />
                {errors.letter_to && (
                  <div className="error-message col">{errors.letter_to}</div>
                )}
              </div>
              <div className="form-group">
                <RenderInputField
                  title="Remarks"
                  name="remarks"
                  placeholder="Write only 5 words"
                  max={100}
                  required={true}
                  formData={formData}
                  errors={errors}
                  inputState={inputState}
                  handleInputChange={handleInputChange}
                />
                {errors.remarks && (
                  <div className="error-message col">{errors.remarks}</div>
                )}
              </div>

              <div className="flex-column">
                <label
                  htmlFor="names"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading">
                  Associated Letters
                </label>
                <Select
                  options={options}
                  isMulti
                  onChange={handleChangecc}
                  styles={{
                    control: (provided) => ({
                      ...provided,
                      width: "34vw",
                      height: "50px",
                      borderRadius: "10px",
                      border: "1px solid #e3e3e3",
                      margin: "10px 0px 20px 0px",
                      color: "#4a4a4a",
                      backgroundColor: "#f7f8fa",
                      padding: "0px 10px",
                    }),
                    placeholder: (provided) => ({
                      ...provided,
                      color: "#4a4a4a",
                    }),
                    menu: (provided) => ({
                      ...provided,
                      width: "33vw",
                      borderRadius: "10px",
                      marginTop: "0",
                    }),
                    singleValue: (provided) => ({
                      ...provided,
                      color: "#4a4a4a",
                    }),
                    input: (provided) => ({
                      ...provided,
                      color: "#4a4a4a",
                    }),
                  }}
                />
                {errors.associated_letters && (
                  <span className="error-message font-size-text">
                    {errors.associated_letters}
                  </span>
                )}
              </div>

              {/* Show status options if associated letters are selected */}
              {formData.associated_letters &&
                formData.associated_letters.length > 0 && (
                  <>
                    <div className="form-column">
                      <RenderSelectField
                        title="Update Status of Associated Letters"
                        name="associated_letters_status"
                        required={true}
                        options={[
                          { value: "pending", label: "Pending" },
                          { value: "close", label: "Close" },
                        ]}
                        placeholder="Select Status"
                        formData={formData}
                        errors={errors}
                        inputState={inputState}
                        handleInputChange={handleInputChange}
                      />
                      {errors.associated_letters_status && (
                        <div className="error-message col">
                          {errors.associated_letters_status}
                        </div>
                      )}
                    </div>
                  </>
                )}
            </div>

            <DocumentSection
              formData={formData}
              handleDocInputChange={handleDocInputChange}
              handleAddDocuments={handleAddDocuments}
              handleRemoveDocument={handleRemoveDocument}
              errors={errors}
              fileNames={fileNames}
              inputState={inputState}
            />

            {/* Upload Progress Bar */}
            {uploadProgress > 0 && (
              <div className="progress-bar">
                <div
                  className="progress-bar-fill"
                  style={{ width: `${uploadProgress}%` }}
                ></div>
                <span>{uploadProgress}%</span>
              </div>
            )}

            <div className="button-models">
              <button
                onClick={handleFormSubmit}
                className="model-button font-weight500 model-button-submit"
                disabled={loading}
              >
                Submit
              </button>
            </div>
            <p className="error-message font-size-text">
              {isSubmitted && Object.keys(errors).length > 0 && (
                Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">Please fill all mandatory fields!</h5>
                ) : (

                  <h6 className="text-center">
                    {Object.keys(errors).map((field) =>
                      field.charAt(0).toUpperCase() + field.slice(1)
                    ).join(', ') + ' are required!'}
                  </h6>
                )
              )}
            </p>
          </form>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};


const AddLetters = ({
  getProjects,
  projectList,
  projectId,
  toggleState,
  contractor,
  contractorlist,
  lettertype,
  letterfor,
}) => {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState(initialFormData());
  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [inputState, setInputState] = useState({});
  const [trackRecordList, setTrackRecordList] = useState([]);
  const [fileNames, setFileNames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0); // For upload progress
  const [contractorlists, setContractorLists] = useState([]);

  function initialFormData() {
    return {
      project: projectId || "",
      letter_num: "",
      reply_by: "null",
      subject: "",
      letter_date: "",
      status: "pending",
      workperformedby: letterfor,
      lettertype: lettertype,
      letterExchange: "",
      associated_letters: [], // Changed from 'associated_letter' to 'associated_letters' as an array
      associated_letters_status: "", // Updated field name
      letter_from: "",
      letter_to: "",
      contractor: contractor ? contractor : "",
      documents: [{ document_name: "", document_file: "" }],
    };
  }

  useEffect(() => {
    if (formData.project || formData.workperformedby) {
      fetchAssociatedLetters();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.project, formData.workperformedby, formData.lettertype]);

  const fetchAssociatedLetters = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/letterrecordbclosestatus/${formData.project || 'null'
        }/${formData.workperformedby || 'null'}/${formData.lettertype || 'null'}/`
      );
      setTrackRecordList(res.data);
    } catch (err) {
      console.error("Error fetching letters.", err);
    }
  };

  // Function to Fetch Contractor Details
  const getProjectContractorDetails = async () => {
    try {
      const contractordetails = await axios.get(
        `${BASE_URL}/siteproject/contractorbyproject/${formData.project}/null/`
      );
      setContractorLists(contractordetails.data);
    } catch (err) {
      // handleErrorToast(err);
    } finally {
    }
  };

  const handleShow = () => {
    setShow(true);
    if (projectId) {
      getProjectContractorDetails();
    }
  };

  const handleClose = () => {
    setShow(false);
    setFormData(initialFormData());
    setErrors({});
    setInputState({});
    setFileNames([]);
  };
  const validateForm = () => {
    const requiredFields = [
      "project",
      "letter_num",

      "subject",
      "letter_date",
      "status",
      "workperformedby",
      "lettertype",

      "associated_letters",
      "associated_letters_status",
      "letter_from",
      "letter_to",
      'letterExchange',
    ];
    const newErrors = requiredFields.reduce((acc, field) => {
      if (
        !formData[field] ||
        (Array.isArray(formData[field]) && formData[field].length === 0)
      ) {
        acc[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
          } is required!`;
      }
      return acc;
    }, {});

    if (
      formData.associated_letters &&
      formData.associated_letters.length > 0 &&
      !formData.associated_letters_status
    ) {
      newErrors["associated_letters_status"] =
        "Status for associated letters is required!";
    }

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  // Modified handleInputChange to handle multiple selections
  const handleInputChange = (e) => {
    const { name, value, type, options } = e.target;

    let newValue;
    if (type === "select-multiple") {
      // Handle multiple selections
      newValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else {
      // Handle single selection or other input types
      newValue = value;
    }

    // Update input state (e.g., for validation styling)
    setInputState((prevState) => ({
      ...prevState,
      [name]:
        newValue && (Array.isArray(newValue) ? newValue.length > 0 : newValue)
          ? "success"
          : "",
    }));

    // Update form data
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: newValue,


      ...(name === 'reply_by' && prevFormData.letterExchange === 'send' && {
        letter_from: value,
      }),
    }));
  };

  const handleDocInputChange = (index, e) => {
    const { name, value, files } = e.target;

    setFormData((prevFormData) => {
      const newDocuments = [...prevFormData.documents];
      newDocuments[index] = {
        ...newDocuments[index],
        [name]: files ? files[0] : value.trim(),
      };

      if (files) {
        setFileNames((prevFileNames) => {
          const newFileNames = [...prevFileNames];
          newFileNames[index] = files[0]?.name || "";
          return newFileNames;
        });
      }

      return { ...prevFormData, documents: newDocuments };
    });
  };

  const handleAddDocuments = () => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: [
        ...prevFormData.documents,
        { document_name: "", document_file: null },
      ],
    }));
  };

  const handleRemoveDocument = (index) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      documents: prevFormData.documents.filter((_, i) => i !== index),
    }));
    setFileNames((prevFileNames) =>
      prevFileNames.filter((_, i) => i !== index)
    );
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        const formDataToSend = new FormData();

        // Append general form fields
        Object.keys(formData).forEach((key) => {
          if (key !== "documents" && formData[key]) {
            if (key === "associated_letters") {
              formData[key].forEach((value) =>
                formDataToSend.append(key, value)
              );
            } else {
              formDataToSend.append(key, formData[key]);
            }
          }
        });

        // Append documents data
        formData.documents.forEach((doc, index) => {
          if (doc.document_file) {
            const customFile = createCustomFile(doc.document_file);
            formDataToSend.append(
              `documents[${index}][document_name]`,
              doc.document_name
            );
            formDataToSend.append(
              `documents[${index}][document_file]`,
              customFile
            );
          }
        });

        const res = await axiosInstance2.post(
          `/siteproject/documentbulkwithletter/`,
          formDataToSend,
          {
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress(percentCompleted);
            },
          }
        );

        if (res.status === 200) {
          handleClose();
          await getProjects(); // Refresh project list
          toast.success("Letter Documents uploaded successfully!");
        } else {
          throw new Error("Document upload failed");
        }
      } catch (err) {
        // toast.error('Error uploading documents');
        console.error("Error uploading documents", err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
        setUploadProgress(0);
      }
    }
  };

  const createCustomFile = (originalFile) => {
    const randomCode = generateRandomString();
    const now = new Date();
    const date = now.toISOString().split("T")[0];
    const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
    const customFileName = `Aimantra ${date} ${time}_${randomCode}_${originalFile.name}`;
    return new File([originalFile], customFileName, {
      type: originalFile.type,
    });
  };

  const generateRandomString = () => {
    const chars =
      "!@#$%^&*()_+abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array.from(
      { length: 8 },
      () => chars[Math.floor(Math.random() * chars.length)]
    ).join("");
  };

  useEffect(() => {
    if (formData.project) {
      getProjectContractorDetails();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.project]); // Dependency array includes formData.project

  // options={trackRecordList.map((option) => ({
  //   value: option.id,
  //   label: option.letter_num,
  // }))}

  const options = trackRecordList
    .sort((a, b) => parseInt(a.letter_num) - parseInt(b.letter_num))
    .map((e) => ({
      value: e.id,
      label: `${e.letter_num} - ${e.letter_date}`,
    }));

  const handleChangecc = (selected) => {
    const associated_letters =
      selected.length > 0 ? selected.map((item) => item.value) : "";
    setFormData((prevState) => ({
      ...prevState,
      associated_letters,
    }));
  };

  return (
    <>
      <button
        title="Add Letter Tracking"
        className="upload-svg"
        onClick={handleShow}
      >
        {/* Replace with your icon component */}
        <AddwithWhiteCircle /> Add Letter
      </button>
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>Add Letter Details </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-form">
            <div className="form-flex-wrap">
              {projectId === undefined && (
                <div>
                  <RenderSelectField
                    title="Site Project"
                    name="project"
                    required={true}
                    options={projectList
                      .sort((a, b) =>
                        a.project_short_name.localeCompare(b.project_short_name)
                      )
                      .map((project) => ({
                        value: project.id,
                        label: `${project.site_prcode} - ${project.project_short_name}`,
                      }))}
                    placeholder="Select a Project"
                    formData={formData}
                    errors={errors}
                    inputState={inputState}
                    handleInputChange={handleInputChange}
                  />
                </div>
              )}

              <RenderSelectField
                title="Letter Exchange"
                name="letterExchange"
                required={true}
                options={[
                  { value: "send", label: "Send" },
                  { value: "receive", label: "Received" },
                ]}
                placeholder="Select an Exchange Type"
                formData={formData}
                errors={errors}
                inputState={inputState}
                handleInputChange={handleInputChange}
              />

              {formData.letterExchange === "send" && (
                <RenderSelectField
                  title="Reply By"
                  name="reply_by"
                  required={true}
                  options={[
                    { value: "HO", label: "Head Office" },
                    { value: "SO", label: "Site Office" },
                  ]}
                  placeholder="Select a Reply By"
                  formData={formData}
                  errors={errors}
                  inputState={inputState}
                  handleInputChange={handleInputChange}
                />
              )}

              <RenderInputField
                title={`${toTitleCase(formData.letterExchange)} Letter No.`}
                name="letter_num"
                placeholder="Letter Number"
                required={true}
                formData={formData}
                errors={errors}
                inputState={inputState}
                handleInputChange={handleInputChange}
              />

              <RenderInputField
                title={`${toTitleCase(formData.letterExchange)} Letter Date`}
                name="letter_date"
                type="date"
                formData={formData}
                required={true}
                errors={errors}
                inputState={inputState}
                handleInputChange={handleInputChange}
              />

              <RenderInputField
                title="Subject"
                name="subject"
                placeholder="Enter subject here..."
                rows={5}
                cols={50}
                formData={formData}
                required={true}
                errors={errors}
                inputState={inputState}
                handleInputChange={handleInputChange}
              />


              {formData.workperformedby === 'contractor' && <div title=" Contractor Name" className="flex-column form-group-selectt">
                <label htmlFor="project" className="form-labels  font-weight500    font-size-subheading">
                  Contractor Name<span className="required">*</span>
                </label>
                <br />
                <select
                  id="contractor"
                  name="contractor"
                  value={formData.contractor}
                  onChange={handleInputChange}
                  className={`form-input form-group-selection ${errors.contractor ? "error" : inputState.contractor ? "success" : ""
                    }`}
                >
                  <option value="null">Select a Contractor</option>
                  {contractorlists?.sort((a, b) => a.name.localeCompare(b.name, 'en', { ignorePunctuation: true })).map((i, index) => (<>
                    <option value={i.id}>{i.name}</option>
                  </>))
                  }
                </select>
                {/* {formData.project !== "" ? "" :  */}
                <div className="form-group-selection-arrow">

                </div>
                {/* } */}
                <div>
                  {errors.project && (
                    <span className="error-message font-size-text ">{errors.project}</span>
                  )}
                </div>
              </div>
              }





              {formData.letterExchange === 'receive' &&
                <RenderInputField
                  title="Letter From"
                  name="letter_from"
                  placeholder="Letter From"
                  max={100}
                  formData={formData}
                  required={true}
                  errors={errors}
                  inputState={inputState}
                  handleInputChange={handleInputChange}
                />
              }

              <RenderInputField
                title="Letter To"
                name="letter_to"
                placeholder="Letter To"
                max={100}
                formData={formData}
                required={true}
                errors={errors}
                inputState={inputState}
                handleInputChange={handleInputChange}
              />
              {/* 
              <RenderSelectField
                title="Associated Letters"
                name="associated_letters"
                required={true}
                options={trackRecordList.map((option) => ({
                  value: option.id,
                  label: option.letter_num,
                }))}
                placeholder="Select Letters"
                formData={formData}
                errors={errors}
                inputState={inputState}
                handleInputChange={handleInputChange}
                multiple={true}
              /> */}

              <div className="flex-column">
                <label
                  htmlFor="names"
                  className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                >
                  Associated Letter
                </label>
                <Select
                  options={options}
                  isMulti
                  onChange={handleChangecc}
                  styles={{
                    container: (provided) => ({
                      ...provided,
                      width: "34.5vw",
                    }),
                  }}
                />
                {errors.remarks && (
                  <span className="error-message font-size-text">
                    {errors.remarks}
                  </span>
                )}
              </div>


              {/* Show status options if associated letters are selected */}
              {formData.associated_letters &&
                formData.associated_letters.length > 0 && (
                  <RenderSelectField
                    title="Update Status of Associated Letters"
                    name="associated_letters_status"
                    required={true}
                    options={[
                      { value: "partially", label: "Partially" },
                      { value: "close", label: "Close" },
                    ]}
                    placeholder="Select Status"
                    formData={formData}
                    errors={errors}
                    inputState={inputState}
                    handleInputChange={handleInputChange}
                  />
                )}
            </div>

            <DocumentSection
              formData={formData}
              handleDocInputChange={handleDocInputChange}
              handleAddDocuments={handleAddDocuments}
              handleRemoveDocument={handleRemoveDocument}
              errors={errors}
              fileNames={fileNames}
              inputState={inputState}
            />

            {/* Upload Progress Bar */}
            {uploadProgress > 0 && (
              <div className="progress-bar">
                <div
                  className="progress-bar-fill"
                  style={{ width: `${uploadProgress}%` }}
                ></div>
                <span>{uploadProgress}%</span>
              </div>
            )}

            <div className="button-models">
              <button
                onClick={handleFormSubmit}
                className="model-button font-weight500 model-button-submit"
                disabled={loading}
              >
                Submit
              </button>
            </div>
            <p className="error-message font-size-text">
              {isSubmitted && Object.keys(errors).length > 0 && (
                Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">Please fill all mandatory fields!</h5>
                ) : (

                  <h6 className="text-center">
                    {Object.keys(errors).map((field) =>
                      field.charAt(0).toUpperCase() + field.slice(1)
                    ).join(', ') + ' are required!'}
                  </h6>
                )
              )}
            </p>
          </form>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};


const AddDocuments = ({ vehicle, employee, letter, getDocument }) => {
  const [show, setShow] = useState(false);
  const [formData, setFormData] = useState([]);



  const handleInputChange = (e, index) => {
    const { name, value } = e.target;

    setFormData((prevFormData) => {
      const newDocuments = [...prevFormData];
      newDocuments[index] = {
        ...newDocuments[index],
        [name]: value, // Updates document_name, vehicledocs, or employeedocs
      };

      return newDocuments;
    });
  };
  const handleFileChange = (e, index) => {
    const file = e.target.files[0];

    setFormData((prevFormData) => {
      const newDocuments = [...prevFormData];
      newDocuments[index] = {
        ...newDocuments[index],
        // document_file: file, // Updates the document_file field with the selected file
        document_file: file,
      };

      return newDocuments;
    });
  };




  const addNewDocument = () => {
    setFormData(
      // [...formprevFormDataata, initialFormData]
      (prevFormData) => ([
        ...prevFormData,
        {
          document_name: "",
          document_file: null,
          vehicledocs: vehicle || "",
          employeedocs: employee || "",
        },
      ])
    );
  };

  const handleRemoveDocument = (index) => {
    setFormData((prevFormData) => (
      prevFormData.filter((_, i) => i !== index)
    ));
  };

  const createCustomFile = (originalFile) => {
    const randomCode = generateRandomString();
    const now = new Date();
    const date = now.toISOString().split("T")[0];
    const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
    const customFileName = `Aimantra ${date} ${time}_${randomCode}_${originalFile.name}`;
    return new File([originalFile], customFileName, {
      type: originalFile.type,
    });
  };
  const generateRandomString = () => {
    const chars =
      "!@#$%^&*()_+abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array.from(
      { length: 8 },
      () => chars[Math.floor(Math.random() * chars.length)]
    ).join("");
  };




  const handleSubmit = async () => {
    // Create a new FormData object to handle file uploads
    const formDataToSend = new FormData();

    // Prepare an array of documents to send
    formData.forEach((doc, index) => {
      const customFile = doc.document_file ? createCustomFile(doc.document_file) : null;

      // Append the document details
      formDataToSend.append(`documents[${index}].document_name`, doc.document_name);
      formDataToSend.append(`documents[${index}].vehicledocs`, doc.vehicledocs);
      formDataToSend.append(`documents[${index}].employeedocs`, doc.employeedocs);

      // Append the custom file if it exists
      if (customFile) {
        formDataToSend.append(`documents[${index}].document_file`, customFile);
      }
    });

    try {
      const response = await axiosInstance2.post(
        `/siteproject/documentbulk/`,
        formDataToSend,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      console.log('Success:', response.data);
      getDocument(); // Callback to refresh documents after adding
    } catch (error) {
      console.error('Error uploading documents:', error);
    }
  };



  return (
    <div>
      {formData.map((data, index) => (
        <div key={index}>
          <input
            type="text"
            name="document_name"
            value={data.document_name}
            onChange={(e) => handleInputChange(e, index)}
            placeholder="Document Name"
          />
          <input
            type="file"
            name="document_file"
            onChange={(e) => handleFileChange(e, index)}
          />
          <button onClick={() => handleRemoveDocument(index)}>Close</button>
        </div>
      ))}
      <button onClick={addNewDocument}>Add Document</button>
      <br />
      <button onClick={handleSubmit}>Submit Documents</button>
    </div>
  );
};

// const DeleteDocuments = ({ i, getDocument }) => {
//   const [show, setshow] = useState(false);
//   const handleClose = () => {
//     setshow(false);
//   };
//   const [loading, setLoading] = useState(false);

//   const handleShow = () => {
//     setshow(true);
//   };
//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [showProgressModal, setShowProgressModal] = useState(false);


//   const handleDelete = async (e) => {
//     e.preventDefault();
//     setShowProgressModal(true);
//     setLoading(true);
//     setUploadProgress(0);

//     const loadingToastId = toast.loading("Deleting: please wait...");
//     let progress = 0;
//     const interval = setInterval(() => {
//       progress += 10;
//       if (progress >= 100) {
//         progress = 100;
//         clearInterval(interval);
//       }
//       setUploadProgress(progress);
//     }, 100);
//     try {
//       const ress = await axios.delete(
//         `${BASE_URL}/siteproject/documents/${i.id}/`
//       );
//       if (ress.status === 200) {
//         await getDocument();
//         handleClose();
//         setTimeout(() => {
//           toast.dismiss(loadingToastId);
//           toast.success("Data deleted successfully.", {
//             autoClose: 1000,
//             pauseOnHover: true,
//             closeOnClick: true,
//           });
//         }, 1000);
//       } else {
//         throw new Error("Unexpected response status: " + ress.status);
//       }

//     } catch (err) {
//       clearInterval(interval);
//       setUploadProgress(0);
//       handleErrorToast(err);
//     } finally {
//       clearInterval(interval);

//       setTimeout(() => {
//         setShowProgressModal(false);
//       }, 1500);

//       setLoading(false);
//       toast.dismiss(loadingToastId);
//     }
//   };

//   return (
//     <>
//       <button className="model-delete-button" onClick={handleShow}>
//         <DeleteDustbin />
//       </button>
//       {
//         showProgressModal ?
//           <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" /> :
//           show === true ?
//             <Modal
//               show={show}
//               onHide={handleClose}
//               dialogClassName="request-leave width-40vw"
//             >
//               <Modal.Header closeButton>
//                 <Modal.Title>Delete Document {i.document_name}</Modal.Title>
//               </Modal.Header>
//               <Modal.Body>
//                 <div className="parent-div">
//                   Are You Sure You Want to delete Document {i.document_name}
//                   <div className="button-models" style={{ marginTop: "20px", justifyContent: "space-evenly" }}>
//                     <button className="cancelbutton" onClick={handleClose}>Cancel</button>
//                     <DeleteButton onclick={handleDelete} />

//                   </div>
//                 </div>
//                 <ToastContainer
//                   position="top-center"
//                   autoClose={1000}
//                   hideProgressBar={false}
//                   newestOnTop={true}
//                   closeOnClick
//                   rtl={false}
//                   pauseOnFocusLoss
//                   draggable
//                   pauseOnHover
//                 />
//               </Modal.Body>
//             </Modal>
//             : ""
//       }
//     </>
//   );
// };

const DeleteDocuments = ({ i, getDocument }) => {
  const [show, setshow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);

  const handleClose = () => setshow(false);
  const handleShow = () => setshow(true);

  const handleDelete = async (e) => {
    e.preventDefault();
    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);

    const loadingToastId = toast.loading("Deleting: please wait...");

    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);

    try {
      const ress = await axios.delete(`${BASE_URL}/siteproject/documents/${i.id}/`);
      if (ress.status === 200) {
        await getDocument();
        toast.dismiss(loadingToastId);
        toast.success("Data deleted successfully.", {
          autoClose: 1000,
          pauseOnHover: true,
          closeOnClick: true,
        });
        setshow(false);
      } else {
        throw new Error("Unexpected response status: " + ress.status);
      }
    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      handleErrorToast(err);
    } finally {
      clearInterval(interval);
      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button title="Delete Document" className="model-delete-button-modern action-icon" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
        <DeleteDustbin modernButton="true" />
      </button>

      {showProgressModal ? (
        <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" />
      ) : (
        <Modal show={show} onHide={handleClose} dialogClassName="modern-required-modal" centered>
          <Modal.Header className="modern-modal-header requirement-modal-header">
            <div className="header-content">
              <div className="requirement-header-icon">
                <Trash2 size={22} />
              </div>
              <div>
                <Modal.Title>Delete Document</Modal.Title>
                <p className="header-subtitle" style={{ color: "white" }}>
                  This action cannot be undone
                </p>
              </div>
            </div>
            <button className="close-btn" onClick={handleClose}>
              <X size={20} />
            </button>
          </Modal.Header>

          <Modal.Body className="modern-modal-body requirement-modal-body">
            <div className="requirement-mode-summary" style={{ marginBottom: '20px' }}>
              <AlertCircle size={16} />
              <span>
                Are you sure you want to delete <strong>{i.document_name}</strong>?
              </span>
            </div>

            <div className="submit-buttons" style={{ justifyContent: 'flex-end' }}>
              <button type="button" className="btn-secondaryy" onClick={handleClose} disabled={loading}>
                Cancel
              </button>
              <button
                type="button"
                className="btn-primaryy"
                style={{ background: "#dc3545", borderColor: "#dc3545" }}
                onClick={handleDelete}
                disabled={loading}
              >
                {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
                <span>{loading ? 'Deleting...' : 'Delete'}</span>
              </button>
            </div>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

const DocumentModel = ({ projectCode, project, letterType, setDrawingFormData, drawingFormData, handleRemoveDrawingDocument, handleAddDrawingDocuments, officerent, vehicle, certificate, employee, getDocument, siteVehicle, employeeData, rentData, p_id, title, letter_tracking, letterData, letterrecord, usedFor, documents, setDocuments, projectsList, document_for }) => {
  const [show, setShow] = useState(false);
  const [toggleState, setToggleState] = useState(1);
  const DRAWING_LETTER_TYPES = [
    "Design & Drawing (Highway)",
    "Design & Drawing (Structure)",
  ];

  const drawingTypeOptions = [
    { value: "Highway GFC Drawings", label: "Highway GFC Drawings" },
    { value: "Structural GFC Drawings", label: "Structural GFC Drawings" },
    { value: "Miscellaneous GFC Drawings", label: "Miscellaneous GFC Drawings" },
  ];

  useEffect(() => {
    if (show && title === "Project Drawings") {
      setToggleState(3);
    }
  }, [show, title])
  const [formData, setFormData] = useState([
    {
      document_name: "",
      document_file: null,
      original_filename: "",
      vehicledocs: vehicle ? vehicle : "",
      employeedocs: employee ? employee : "",
      miscellaneous_docs: p_id ? p_id : "",
      document_type: "",
      officerent: officerent ? officerent : "",
      letter_tracking: letter_tracking ? letter_tracking : "",
      letterrecord: letterrecord ? letterrecord : "",
      drawingtype: "null",
      loa_copy: "",
      project: "null",
      certificate_copy: certificate ? certificate : "",
    },
  ]);
  const role = sessionStorage.getItem('sitemanagement_role');
  const [documenttype, setdocumenttype] = useState("null");

  useEffect(() => {
    if (title === "Documents" || title === "Letters" || title === `Letter Documents`) {
      setToggleState(2);
    }
  }, [title]);

  useEffect(() => {
    if (role === "ViewAccess") {
      setToggleState(2);
    }
  }, [role]);



  const [uploadProgress, setUploadProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const fileInputRefs = useRef([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    setFormData([
      {
        document_name: "",
        document_file: null,
        vehicledocs: vehicle || "",
        employeedocs: employee || "",
        miscellaneous_docs: p_id || "",
        original_filename: "",
        project: "null",
        drawingtype: "null",

        document_type: "",
        officerent: officerent || "",
        letter_tracking: letter_tracking || "",
        letterrecord: letterrecord || "",
        certificate_copy: certificate || "",
      },
    ]);
  }, [vehicle, employee, p_id, officerent, letter_tracking, letterrecord, certificate]);

  const refresh = () => {
    setFormData([{
      document_name: "",
      document_file: null,
      original_filename: "",
      project: "null",
      vehicledocs: vehicle ? vehicle : "",
      employeedocs: employee ? employee : "",
      drawingtype: "null",

      miscellaneous_docs: p_id ? p_id : "",
      document_type: "",
      officerent: officerent ? officerent : "",
      letter_tracking: letter_tracking ? letter_tracking : "",
      letterrecord: letterrecord ? letterrecord : "",
      loa_copy: "",
      certificate_copy: certificate ? certificate : "",
    }]);

    setDesignDrawingFormData([{
      document_name: "",
      document_file: null,
      original_filename: "",
      project: "null",
      drawingtype: "null",
      letterrecord: null
    }])
  };

  const handleShow = () => {
    setShow(true);
    if (title === "Letter Documents") {
      setDocuments(true);
    }
  };

  const handleClose = () => {
    setShow(false);
    if (title === "Letter Documents") {
      setDocuments(false);
    }
    if (title === "Letters" || title === "Documents" || role === "ViewAccess") {
      setToggleState(2);
    } else {
      setToggleState(1);
    }
    refresh();
  };

  const handleInputChange = (e, index) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => {
      const newDocuments = [...prevFormData];
      newDocuments[index] = { ...newDocuments[index], [name]: value };
      return newDocuments;
    });
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") delete newErrors[`${index}-${name}`];
      return newErrors;
    });
  };
  // const handleInputDrawingChange = (e, index) => {
  //   const { name, value } = e.target;
  //   setDesignDrawingFormData((prevFormData) => {
  //     const newDocuments = [...prevFormData];
  //     newDocuments[index] = { ...newDocuments[index], [name]: value };
  //     return newDocuments;
  //   });
  //   setErrors((prevErrors) => {
  //     const newErrors = { ...prevErrors };
  //     if (value.trim() !== "") delete newErrors[`${index}-${name}`];
  //     return newErrors;
  //   });
  // };

  const handleInputDrawingChange = (e, index, setter = setDesignDrawingFormData) => {
    const { name, value } = e.target;
    setter((prevFormData) => {
      const newDocuments = [...prevFormData];
      newDocuments[index] = { ...newDocuments[index], [name]: value };
      return newDocuments;
    });
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      if (value.trim() !== "") delete newErrors[`${index}-${name}`];
      return newErrors;
    });
  };

  const [docNames, setDocNames] = useState([]);

  const handleFileChange = (e, index) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = [
        "application/pdf", "application/zip", "application/x-zip-compressed",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel", "image/png", "image/gif"
      ];
      if (!allowedTypes.includes(file.type) && !file.name.match(/\.(zip|pdf|xls|xlsx|png|gif)$/i)) {
        toast.error("Only ZIP, PDF, PNG, GIF and Excel files are allowed!");
        return;
      }
      const symbols = "!@#$%^&*()_-+=";
      const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
      const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const numbers = "0123456789";
      const now = new Date();
      const date = now.toLocaleDateString("en-GB").split("/").reverse().join("-");
      const time = now.toLocaleTimeString("en-GB", { hour12: false }).replace(/:/g, "-");
      const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
      let randomCode = "";
      for (let i = 0; i < 8; i++) {
        randomCode += allChars[Math.floor(Math.random() * allChars.length)];
      }
      const aimantraFileName = `Aimantra ${date} ${time}_${randomCode} ${file.name}`;
      const customFile = new File([file], aimantraFileName, { type: file.type });

      setFormData((prevFormData) => {
        const newDocuments = [...prevFormData];
        newDocuments[index] = { ...newDocuments[index], document_file: customFile, original_filename: aimantraFileName };
        return newDocuments;
      });
      setDocNames((prev) => {
        const newNames = [...prev];
        newNames[index] = aimantraFileName;
        return newNames;
      });
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[`${index}-document_file`];
        delete newErrors[`${index}-original_filename`];
        return newErrors;
      });
    } else {
      setDocNames((prev) => {
        const newNames = [...prev];
        newNames[index] = "";
        return newNames;
      });
      setFormData((prevFormData) => {
        const newDocuments = [...prevFormData];
        newDocuments[index] = { ...newDocuments[index], document_file: null, original_filename: "" };
        return newDocuments;
      });
    }
  };

  // const handleFileDrawingChange = (e, index) => {
  //   const file = e.target.files[0];
  //   if (file) {
  //     const allowedTypes = [
  //       "application/pdf", "application/zip", "application/x-zip-compressed",
  //       "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //       "application/vnd.ms-excel", "image/png", "image/gif"
  //     ];
  //     if (!allowedTypes.includes(file.type) && !file.name.match(/\.(zip|pdf|xls|xlsx|png|gif)$/i)) {
  //       toast.error("Only ZIP, PDF, PNG, GIF and Excel files are allowed!");
  //       return;
  //     }
  //     const symbols = "!@#$%^&*()_-+=";
  //     const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
  //     const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  //     const numbers = "0123456789";
  //     const now = new Date();
  //     const date = now.toLocaleDateString("en-GB").split("/").reverse().join("-");
  //     const time = now.toLocaleTimeString("en-GB", { hour12: false }).replace(/:/g, "-");
  //     const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
  //     let randomCode = "";
  //     for (let i = 0; i < 8; i++) {
  //       randomCode += allChars[Math.floor(Math.random() * allChars.length)];
  //     }
  //     const aimantraFileName = `Aimantra ${date} ${time}_${randomCode} ${file.name}`;
  //     const customFile = new File([file], aimantraFileName, { type: file.type });

  //     setDesignDrawingFormData((prevFormData) => {
  //       const newDocuments = [...prevFormData];
  //       newDocuments[index] = { ...newDocuments[index], document_file: customFile, original_filename: aimantraFileName };
  //       return newDocuments;
  //     });
  //     setDocNames((prev) => {
  //       const newNames = [...prev];
  //       newNames[index] = aimantraFileName;
  //       return newNames;
  //     });
  //     setErrors((prevErrors) => {
  //       const newErrors = { ...prevErrors };
  //       delete newErrors[`${index}-document_file`];
  //       delete newErrors[`${index}-original_filename`];
  //       return newErrors;
  //     });
  //   } else {
  //     setDocNames((prev) => {
  //       const newNames = [...prev];
  //       newNames[index] = "";
  //       return newNames;
  //     });
  //     setDesignDrawingFormData((prevFormData) => {
  //       const newDocuments = [...prevFormData];
  //       newDocuments[index] = { ...newDocuments[index], document_file: null, original_filename: "" };
  //       return newDocuments;
  //     });
  //   }
  // };


  const handleFileDrawingChange = (e, index, setter = setDesignDrawingFormData) => {
    const file = e.target.files[0];
    if (file) {
      const allowedTypes = [
        "application/pdf", "application/zip", "application/x-zip-compressed",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel", "image/png", "image/gif"
      ];
      if (!allowedTypes.includes(file.type) && !file.name.match(/\.(zip|pdf|xls|xlsx|png|gif)$/i)) {
        toast.error("Only ZIP, PDF, PNG, GIF and Excel files are allowed!");
        return;
      }
      const symbols = "!@#$%^&*()_-+=";
      const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
      const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const numbers = "0123456789";
      const now = new Date();
      const date = now.toLocaleDateString("en-GB").split("/").reverse().join("-");
      const time = now.toLocaleTimeString("en-GB", { hour12: false }).replace(/:/g, "-");
      const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
      let randomCode = "";
      for (let i = 0; i < 8; i++) {
        randomCode += allChars[Math.floor(Math.random() * allChars.length)];
      }
      const aimantraFileName = `Aimantra ${date} ${time}_${randomCode} ${file.name}`;
      const customFile = new File([file], aimantraFileName, { type: file.type });

      setter((prevFormData) => {
        const newDocuments = [...prevFormData];
        newDocuments[index] = { ...newDocuments[index], document_file: customFile, original_filename: aimantraFileName };
        return newDocuments;
      });
      setDocNames((prev) => {
        const newNames = [...prev];
        newNames[index] = aimantraFileName;
        return newNames;
      });
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[`${index}-document_file`];
        delete newErrors[`${index}-original_filename`];
        return newErrors;
      });
    } else {
      setDocNames((prev) => {
        const newNames = [...prev];
        newNames[index] = "";
        return newNames;
      });
      setter((prevFormData) => {
        const newDocuments = [...prevFormData];
        newDocuments[index] = { ...newDocuments[index], document_file: null, original_filename: "" };
        return newDocuments;
      });
    }
  };
  console.log(drawingFormData, "drawingformdata")
  const [letterNumberData, setLetterNumberData] = useState([]);

  const handleLetterChange = async (index, value) => {
    try {
      const updatedForm = [...formData];
      updatedForm[index] = { ...updatedForm[index], letterrecord: value || "null" };
      setFormData(updatedForm);
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        if (typeof value === "string" && value.trim() !== "") delete newErrors[`${index}-letterrecord`];
        return newErrors;
      });
    } catch (error) {
      console.error("Error in handleProjectChange:", error);
    }
  };

  const handleProjectChange = async (index, value) => {
    try {
      const updatedForm = [...formData];
      updatedForm[index] = { ...updatedForm[index], project: value || "" };
      setFormData(updatedForm);
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        if (typeof value === "string" && value.trim() !== "") delete newErrors[`${index}-project`];
        return newErrors;
      });
      if (value) await fetchLetterNumber(index, value);
    } catch (error) {
      console.error("Error in handleProjectChange:", error);
    }
  };

  const fetchLetterNumber = async (index, projectId) => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/letternum/${projectId}/`);
      setLetterNumberData((prev) => ({ ...prev, [index]: res.data }));
    } catch (error) {
      console.error("Error fetching letter number:", error);
    }
  };

  const addNewDocument = () => {
    setFormData((prevFormData) => [
      ...prevFormData,
      {
        document_name: "", document_file: null, vehicledocs: vehicle || "",
        original_filename: "", letterrecord: letterrecord || "", employeedocs: employee || "",
        miscellaneous_docs: p_id || "", document_type: "", officerent: officerent || "",
        letter_tracking: letter_tracking || "", loa_copy: "", certificate_copy: certificate || "", project: "",
      },
    ]);
    fileInputRefs.current.push(null);
  };
  const addNewDocumentForDesign = () => {
    setDesignDrawingFormData((prevFormData) => [
      ...prevFormData,
      { document_name: "", document_file: "", original_filename: "", drawingtype: "null", letterrecord: null, project: "null", miscellaneous_docs: null, }

    ]);
  };


  const [designDrawingFormData, setDesignDrawingFormData] = useState([
    { project: "null", document_name: "", document_file: "", original_filename: "", drawingtype: "null", letterrecord: null, miscellaneous_docs: null }
  ]);

  const handleRemoveDocument = (index) => {
    setFormData((prevFormData) => prevFormData.filter((_, i) => i !== index));
    fileInputRefs.current.splice(index, 1);
  };
  const handleRemoveDocumentForDesign = (index) => {
    setDesignDrawingFormData((prevFormData) => prevFormData.filter((_, i) => i !== index));
    fileInputRefs.current.splice(index, 1);
  };

  const handleClear = (index) => {
    setFormData((prevFormData) => {
      const newDocuments = [...prevFormData];
      newDocuments[index] = { ...newDocuments[index], document_file: null };
      return newDocuments;
    });
    if (fileInputRefs.current[index]) fileInputRefs.current[index].value = "";
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[`${index}-document_file`];
      return newErrors;
    });
  };
  const handleClearForDesign = (index) => {
    setDesignDrawingFormData((prevFormData) => {
      const newDocuments = [...prevFormData];
      newDocuments[index] = { ...newDocuments[index], document_file: null };
      return newDocuments;
    });
    if (fileInputRefs.current[index]) fileInputRefs.current[index].value = "";
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[`${index}-document_file`];
      return newErrors;
    });
  };

  const validateForm = () => {
    const newErrors = {};
    if (toggleState === 3) {
      designDrawingFormData.forEach((doc, index) => {
        if (!doc.document_name.trim()) newErrors[`${index}-document_name`] = "Document Name is required!";
        if (!doc.drawingtype || doc.drawingtype === "null") newErrors[`drawingtype_${index}`] = "Drawing Type is required!";
        if (!doc.document_file) newErrors[`${index}-document_file`] = "Document file is required!";
      });
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
    }
    formData.forEach((doc, index) => {
      if (!doc.document_name.trim()) newErrors[`${index}-document_name`] = "Document Name is required!";
      if (title !== "Miscellaneous Document" && title !== "Document" && title !== "Letter Attacments" && title !== "Bulk Documents" && !doc.document_type.trim()) {
        newErrors[`${index}-document_type`] = "Document Type is required ";
      }
      if (title === "Bulk Documents" && (doc.project === "null" || doc.project === "")) {
        newErrors[`${index}-project`] = "Project Name is required!";
      }
      if (title === "Bulk Documents" && (doc.letterrecord === "null" || doc.letterrecord === "")) {
        newErrors[`${index}-letterrecord`] = "Letter Number is required!";
      }
      if (!doc.document_file) newErrors[`${index}-document_file`] = "Document file is required!";
    });


    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    setLoading(true);
    const loadingToastId = toast.loading("Uploading: please wait...");
    const formDataToSend = new FormData();
    const designFormDatatoSend = new FormData();

    const abort = (msg) => {
      console.error(msg);
      toast.dismiss(loadingToastId);
      setLoading(false);
      setUploadProgress(0);
    };

    try {
      if (toggleState === 3) {
        for (const [index, doc] of designDrawingFormData.entries()) {
          designFormDatatoSend.append(`documents[${index}].document_name`, doc.document_name);
          if (doc.drawingtype && doc.drawingtype !== "null")
            designFormDatatoSend.append(`documents[${index}].drawingtype`, doc.drawingtype);
          if (letterrecord && title === "Letter Attacments")
            designFormDatatoSend.append(`documents[${index}].letterrecord`, letterrecord);
          if (projectCode)
            designFormDatatoSend.append(`documents[${index}].miscellaneous_docs`, projectCode);
          if (project)
            designFormDatatoSend.append(`documents[${index}].project`, project);

          if (!doc.document_file) {
            return abort(`No file selected for: ${doc.document_name}`);
          }
          const fileId = await uploadFileInChunks(doc.document_file, doc.document_name, setUploadProgress);
          if (!fileId) {
            return abort(`Failed to upload file: ${doc.document_name}`);
          }
          designFormDatatoSend.append("file_ids", fileId);
          designFormDatatoSend.append(`documents[${index}][document_name]`, doc.document_name);
          designFormDatatoSend.append(`documents[${index}][original_filename]`, doc.document_file.name);
          designFormDatatoSend.append(`documents[${index}].document_file`, doc.document_file);
        }
      } else {
        for (const [index, doc] of formData.entries()) {
          formDataToSend.append(`documents[${index}].document_name`, doc.document_name);
          if (doc.employeedocs) formDataToSend.append(`documents[${index}].employeedocs`, doc.employeedocs);
          if (doc.vehicledocs) formDataToSend.append(`documents[${index}].vehicledocs`, doc.vehicledocs);

          if (!doc.document_file) {
            return abort(`No file selected for: ${doc.document_name}`);
          }
          const fileId = await uploadFileInChunks(doc.document_file, doc.document_name, setUploadProgress);
          if (!fileId) {
            return abort(`Failed to upload file: ${doc.document_name}`);
          }
          formDataToSend.append("file_ids", fileId);
          formDataToSend.append(`documents[${index}][document_name]`, doc.document_name);
          formDataToSend.append(`documents[${index}][original_filename]`, doc.document_file.name);

          if (doc.officerent) formDataToSend.append(`documents[${index}].officerent`, doc.officerent);
          if (doc.miscellaneous_docs) formDataToSend.append(`documents[${index}].miscellaneous_docs`, doc.miscellaneous_docs);
          if (doc.letter_tracking) formDataToSend.append(`documents[${index}].letter_tracking`, doc.letter_tracking);
          if (doc.letterrecord) formDataToSend.append(`documents[${index}].letterrecord`, doc.letterrecord);
          if (doc.loa_copy) formDataToSend.append(`documents[${index}].loa_copy`, doc.loa_copy);
          if (doc.certificate_copy) formDataToSend.append(`documents[${index}].certificate_copy`, doc.certificate_copy);
          formDataToSend.append(`documents[${index}].document_file`, doc.document_file);
          if (document_for === "contractor") formDataToSend.append(`documents[${index}].document_type`, "boq");
          if (document_for === "consultant") formDataToSend.append(`documents[${index}].document_type`, "actual");
          if (doc.document_type) formDataToSend.append(`documents[${index}].document_type`, doc.document_type);
        }
      }

      const response = await axiosInstance2.post(
        `/siteproject/documentbulk/`,
        toggleState === 3 ? designFormDatatoSend : formDataToSend,
        {
          headers: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setUploadProgress(percentCompleted);
          },
        }
      );

      if (response.status >= 200 && response.status < 300) {
        if (toggleState === 3) {
          setDesignDrawingFormData([
            { document_name: "", document_file: "", original_filename: "", drawingtype: "null", letterrecord: null },
          ]);
          setToggleState(4);
        }
        if (title === "Project Drawings") {
          setToggleState(4)


          getDrawingDocuments();

        }
        if (title === "LOA & Certificate Document") {
          getCompanyCreditData();
          setToggleState(2);
          refresh();
        } else if (title === "Letter Attacments") {
          getDocuments();
          if (toggleState === 3) {
            setToggleState(4);

          }
          else {

            setToggleState(2);
          }


          refresh();
        } else {
          getDocument();
          getDocuments();
          handleClose();
          refresh();
        }
        toast.dismiss(loadingToastId);
        toast.success("Data added successfully.", { autoClose: 1000, pauseOnHover: true, closeOnClick: true });
      }
    } catch (error) {
      console.error("Upload error:", error);
      // handleErrorToast(error);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
      setUploadProgress(0);
    }
  };

  const [DocumentData, setDocumentData] = useState([]);
  const [DrawingDocumentData, setDrawingDocumentData] = useState([]);
  const getDocuments = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/documentwithletterget/${letterrecord}/`);
      setDocumentData(res.data);
    } catch (error) {
      console.error(error);
    }
  };
  const getDrawingDocuments = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/documentwithmiscellaneousget/${project}/`);
      setDrawingDocumentData(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const [filteredData, setFilteredData] = useState([]);
  const [CompanyCreditDocumentData, setCompanyCreditDocumentData] = useState([]);
  const getCompanyCreditData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/documentmodelfiltercertificate/null/${certificate}/`);
      setCompanyCreditDocumentData(res.data);
      setFilteredData(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    if (show === true && letterrecord) getDocuments();
  }, [letterrecord, show]);
  useEffect(() => {
    if (show === true && title === "Project Drawings") getDrawingDocuments();
  }, [project, show]);
  useEffect(() => {
    if (show === true && certificate) getCompanyCreditData();
  }, [certificate, show]);

  const handleStatusChange = (option) => {
    const value = option?.value || "";
    setdocumenttype(value);
    if (value === "") {
      setFilteredData(CompanyCreditDocumentData);
    } else {
      setFilteredData(CompanyCreditDocumentData.filter((item) => item.document_type === value));
    }
  };

  const projectOption = [
    ...(Array.isArray(projectsList) ? projectsList.map((i) => ({ value: i.id, label: `${i.site_prcode} - ${i.project_short_name}` })) : []),
  ];

  const statusOptions = [
    { value: "", label: "All" },
    { value: "actual", label: "LOA Copy" },
    { value: "boq", label: "Certificate Copy" },
  ];

  // Compile the "current" document list based on which source prop was passed, for the view table
  const getCurrentDocs = () => {
    if (vehicle) {
      return siteVehicle
        .filter((v) => v.id === vehicle)
        .flatMap((v) => v.documents)
        .filter((doc) => doc.vehicledocs === vehicle)
        .map((doc) => ({ ...doc, _deleteSource: getDocument }));
    }
    if (certificate) {
      return filteredData.map((doc) => ({
        ...doc,
        document_type: doc.document_type === "actual" ? "LOA Copy" : "Certiciate Copy",
        _deleteSource: getCompanyCreditData,
      }));
    }
    if (employee) {
      return (employeeData?.document || []).map((doc) => ({ ...doc, _deleteSource: getDocument }));
    }
    if (officerent) {
      return (rentData || [])
        .filter((v) => v.id === officerent)
        .flatMap((v) => v?.documents)
        .filter((doc) => doc.officerent === officerent)
        .map((doc) => ({ ...doc, _deleteSource: getDocument }));
    }
    if (letter_tracking) {
      return (letterData || [])
        .filter((v) => v.id === letter_tracking)
        .flatMap((v) => v?.documents)
        .map((doc) => ({ ...doc, _deleteSource: getDocument }));
    }
    if (letterrecord) {
      return DocumentData.map((doc) => ({ ...doc, _deleteSource: getDocuments }));
    }
    if (title === "Project Drawings") {
      return DrawingDocumentData.map((doc) => ({ ...doc, _deleteSource: getDrawingDocuments }));
    }
    return [];
  };

  const currentDocs = getCurrentDocs();
  const showTypeColumn = title !== "Miscellaneous Document" && title !== "LetterTracking" && title !== "Documents" && title !== "Letters" && title !== "Letter Attacments" && title !== "Letter Documents" && title !== "Document";
  const showActionColumn = title !== "Miscellaneous Document" && title !== "LetterTracking" && title !== "Documents" && title !== "Letters" && title !== "Letter Documents" && role !== "ViewAccess";

  return (
    <>
      {role === "ViewAccess" ? (
        <button title="View Document" className="doc-trigger-btn" onClick={handleShow}>
          <Eye size={13} /> View
        </button>
      ) : vehicle || officerent || title === "Document" || title === "LOA & Certificate Document" ? (
        <button title="Add/View Document" className=" actionn-icon" style={{ background: "#00000075", borderRadius: "5px", padding: "5px", color: "white" }} onClick={handleShow}>
          <FileText size={13} /> Add/View
        </button>
      ) : title === "Documents" ? (
        <button onClick={handleShow} className="doc-trigger-btn-icon" title="View">
          <Eye size={14} />
        </button>
      ) : title === "Letters" ? (
        <button title="View Document" className="doc-trigger-btn" onClick={handleShow}>
          <Mail size={13} /> View Letters
        </button>
      ) : title === "AddLetterDrawings" ? (
        <>

          {drawingFormData.map((doc, index) => {

            const drawingNo = index + 1;

            const nameError = errors[`document_name_${index}`];
            const fileError = errors[`document_file_${index}`];
            const drawingTypeError = errors[`drawingtype_${index}`];

            // first normal doc = letter; drawings are never the letter

            // keep at least one drawing row when drawing letter type is selected
            const canRemove = index > 0;

            const cardTitle = `Drawing ${drawingNo}`


            return (
              <div
                key={index}
                style={{
                  border: "1px solid #e3e3e3",
                  borderRadius: "12px",
                  background: "#f7f8fa",
                  padding: "16px",
                  marginBottom: "16px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginBottom: "12px",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      fontWeight: 500,
                    }}
                  >
                    <PencilRuler size={16} />
                    <span>{cardTitle}</span>
                  </div>

                  {canRemove && (
                    <button
                      type="button"
                      className="btn-secondaryy"
                      onClick={() => handleRemoveDrawingDocument(index)}
                    >
                      <Trash2 size={14} /> <span>Remove</span>
                    </button>
                  )}
                </div>

                <div className="form-grid">
                  <div className="form-field">
                    <label><FileText size={14} /> Document Name<span className="required">*</span></label>
                    {/* <input
                      type="text"
                      name="document_name"
                      value={doc.document_name}
                      onChange={(e) => handleInputDrawingChange(e, index)}
                      placeholder="Document Name"
                    /> */}
                    <input
                      type="text"
                      name="document_name"
                      value={doc.document_name}
                      onChange={(e) => handleInputDrawingChange(e, index, setDrawingFormData)}
                      placeholder="Document Name"
                    />
                    {errors[`${index}-document_name`] && <span className="error-message">{errors[`${index}-document_name`]}</span>}
                  </div>



                  <div className="form-field">
                    <label>
                      <Tag size={14} /> Drawing Type
                      <span className="required">*</span>
                    </label>
                    {/* <Select
                      options={drawingTypeOptions}
                      value={
                        drawingTypeOptions.find(
                          (opt) => opt.value === doc.drawingtype
                        ) || null
                      }
                      onChange={(selectedOption) => {
                        handleInputDrawingChange({
                          target: {
                            name: "drawingtype",
                            value: selectedOption ? selectedOption.value : "",
                          },
                        }, index);
                      }}
                      isSearchable
                      isClearable
                      placeholder="Select Drawing Type"
                      styles={CSSForSelectModern}
                    /> */}
                    <Select
                      options={drawingTypeOptions}
                      value={drawingTypeOptions.find((opt) => opt.value === doc.drawingtype) || null}
                      onChange={(selectedOption) => {
                        handleInputDrawingChange(
                          { target: { name: "drawingtype", value: selectedOption ? selectedOption.value : "" } },
                          index,
                          setDrawingFormData
                        );
                      }}
                      isSearchable
                      isClearable
                      placeholder="Select Drawing Type"
                      styles={CSSForSelectModern}
                    />
                    {drawingTypeError && (
                      <span className="error-message">{drawingTypeError}</span>
                    )}
                  </div>


                  <div className="form-field">
                    <label><Paperclip size={14} /> Upload Document<span className="required">*</span></label>
                    {!doc.document_file ? (
                      <label htmlFor={`document_file_${index}`} className="custom-file-upload-modern">
                        <FileUp size={18} />
                        <span>Click to select file (.zip, .pdf, .xls, .xlsx, .gif)</span>
                      </label>
                    ) : (
                      <>
                        <button type='button' className="explorer-btn">
                          <div className="icon-wrapper">
                            <div className="folder-part folder-base"></div>
                            <div className="folder-part folder-tab"></div>
                            <div className="folder-part folder-accent"></div>
                            <div className="folder-part folder-highlight"></div>
                          </div>
                          <div className="status-indicator"></div>
                          <span className="tooltip-label">File Explorer</span>
                        </button>

                        <span style={{ fontSize: "12px", color: "#10b981", marginTop: "4px", display: "block" }}>
                          ✓ File selected: {doc.document_file.name}
                        </span>
                      </>

                    )}
                    {/* <input
                      type="file"
                      id={`document_file_${index}`}
                      name="document_file"
                      accept=".zip, .pdf, .xls, .xlsx, .gif"
                      style={{ display: "none" }}
                      onChange={(e) => handleFileDrawingChange(e, index)}
                      ref={(el) => (fileInputRefs.current[index] = el)}
                    /> */}

                    <input
                      type="file"
                      id={`document_file_${index}`}
                      name="document_file"
                      accept=".zip, .pdf, .xls, .xlsx, .gif"
                      style={{ display: "none" }}
                      onChange={(e) => handleFileDrawingChange(e, index, setDrawingFormData)}
                      ref={(el) => (fileInputRefs.current[index] = el)}
                    />
                    {errors[`${index}-document_file`] && <span className="error-message">{errors[`${index}-document_file`]}</span>}
                  </div>
                </div>
              </div>
            );
          })}
        </>


      ) : title === "AddNewDocument" ? (
        <button
          type="button"
          title="Add Drawings"
          className="btn-secondaryy"
          onClick={() => handleAddDrawingDocuments()}
        >
          <PencilRuler size={16} /> <span>Add Drawings</span>
        </button>
      ) : title === "Letter Attacments" ? (
        <DocumentButton onclick={handleShow} />
      ) : title === "Project Drawings" ?
        (
          <button className="plb-trigger-btn buttonCSS " onClick={handleShow}>
            <div className="plb-row">
              <FileText size={20} className="plb-icon" />
              {/* <div className="plb-stats-row">
                                <div className="plb-stat-chip total">
                                    <span className="plb-chip-count">{project?.prolongation_count || 0}</span>
                                    <span className="plb-chip-label">Total</span>
                                </div>
                                <div className="plb-stat-chip prolongation">
                                    <span className="plb-chip-count">{project?.prolongation_prolongation_count || 0}</span>
                                    <span className="plb-chip-label">Prolongation</span>
                                </div>
                                <div className="plb-stat-chip deviation">
                                    <span className="plb-chip-count">{project?.prolongation_deviation_count || 0}</span>
                                    <span className="plb-chip-label">Deviation</span>
                                </div>
                            </div> */}
            </div>
            <span className="plb-tooltip">Add/View Drawings</span>
          </button>
        ) :
        title === `Letter Documents` ? (
          <button className="doc-trigger-btn" onClick={handleShow}>
            <FileText size={13} /> View Letter Documents
          </button>
        ) : title === "Bulk Documents" ? (
          <button className="doc-trigger-btn primary" onClick={handleShow}>
            <UploadIcon size={13} /> {title}
          </button>
        ) : role !== "ViewAccess" ? (
          <button title="Add Document" className="doc-trigger-btn primary" onClick={handleShow}>
            <UploadIcon size={13} /> {title}
          </button>
        ) :
          (
            <button title="View Document" className="doc-trigger-btn" onClick={handleShow}>
              <Eye size={13} /> View Documents
            </button>
          )}

      <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
        <Modal.Header className="modern-modal-header">
          <div className="header-content">
            <div style={{ color: "white" }}>
              <FileText size={22} />
            </div>
            <div>
              <Modal.Title>{toggleState === 1 ? `Add ${title}` : toggleState === 2 ? `View ${title}` : toggleState === 3 ? "Add Drawings" : "View Drawings"}</Modal.Title>
              <p className="header-subtitle" style={{ color: "white" }}>
                {(toggleState === 1 || toggleState === 3) ? "Upload and attach documents" : "Browse attached documents"}
              </p>
            </div>
          </div>
          <button className="close-btn" onClick={handleClose}>
            <X size={20} />
          </button>
        </Modal.Header>

        <Modal.Body className="modern-modal-body">

          {(title !== "Miscellaneous Document" && title !== "Documents" && title !== "Letters" && title !== "Letter Documents" && title !== "Bulk Documents" && role !== "ViewAccess") && (
            <div className="modern-tabs-container" style={{ padding: '0 0 12px 0', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div className="tabs-scroll">
                {title !== "Project Drawings" &&
                  <button
                    className={`modern-tab-btn ${toggleState === 1 ? 'active' : ''}`}
                    onClick={() => setToggleState(1)}
                  >
                    <Upload size={15} />
                    <span>Add {title}</span>
                    {toggleState === 1 && <div className="active-indicator" />}
                  </button>
                }
                {title === "Letter Attacments" && (letterType === "Design & Drawing (Structure)" || letterType === "Design & Drawing (Highway)") &&

                  <button
                    className={`modern-tab-btn ${toggleState === 3 ? "active" : ""}`}
                    onClick={() => setToggleState(3)}
                  >
                    <Upload size={15} />
                    <span>Add Drawings</span>
                    {toggleState === 3 && <div className="active-indicator" />}
                  </button>
                }
                {title === "Project Drawings" &&
                  <button
                    className={`modern-tab-btn ${toggleState === 3 ? "active" : ""}`}
                    onClick={() => setToggleState(3)}
                  >
                    <Upload size={15} />
                    <span>Add Drawings</span>
                    {toggleState === 3 && <div className="active-indicator" />}
                  </button>
                }

                {title !== "Project Drawings" &&
                  <button
                    className={`modern-tab-btn ${toggleState === 2 ? 'active' : ''}`}
                    onClick={() => setToggleState(2)}
                  >
                    <Eye size={15} />
                    <span>View {title}</span>
                    {toggleState === 2 && <div className="active-indicator" />}
                  </button>
                }

                {title === "Letter Attacments" && (letterType === "Design & Drawing (Structure)" || letterType === "Design & Drawing (Highway)") &&

                  <button
                    className={`modern-tab-btn ${toggleState === 4 ? 'active' : ''}`}
                    onClick={() => setToggleState(4)}
                  >
                    <Eye size={15} />
                    <span>View Drawings</span>
                    {toggleState === 4 && <div className="active-indicator" />}
                  </button>
                }
                {title === "Project Drawings" &&
                  <button
                    className={`modern-tab-btn ${toggleState === 4 ? 'active' : ''}`}
                    onClick={() => setToggleState(4)}
                  >
                    <Eye size={15} />
                    <span>View Drawings</span>
                    {toggleState === 4 && <div className="active-indicator" />}
                  </button>
                }

              </div>

              {title === "LOA & Certificate Document" && toggleState === 2 && (
                <div style={{ minWidth: '160px' }}>
                  <Select
                    options={statusOptions}
                    value={statusOptions.find((o) => o.value === documenttype) || statusOptions[0]}
                    onChange={handleStatusChange}
                    styles={CSSForSelectModern}
                  />
                </div>
              )}
            </div>
          )}

          {toggleState === 1 && (
            <div className="form-section">
              <div className="section-title" style={{ justifyContent: 'space-between', display: 'flex' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <FileText size={18} />
                  <h4>Document Details</h4>
                </div>
                <button onClick={addNewDocument} className="btn-secondaryy" style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                  <Plus size={14} />
                  Another Document
                </button>
              </div>

              {formData.map((data, index) => (
                <div key={index} className="doc-upload-row">
                  <div className="form-grid">
                    {title === "Bulk Documents" && (
                      <>
                        <div className="form-field">
                          <label><Briefcase size={14} /> Site Project<span className="required">*</span></label>
                          <Select
                            options={projectOption}
                            onChange={(selectedOption) => handleProjectChange(index, selectedOption?.value)}
                            value={projectOption.find((item) => item.value === data.project) || null}
                            placeholder="Select a Project"
                            isSearchable isClearable
                            noOptionsMessage={() => "No other options"}
                            styles={CSSForSelectModern}
                          />
                          {errors[`${index}-project`] && <span className="error-message">{errors[`${index}-project`]}</span>}
                        </div>

                        <div className="form-field">
                          <label><Mail size={14} /> Letter Number<span className="required">*</span></label>
                          {(() => {
                            const letterOptionsForRow = letterNumberData[index]?.map((i) => ({ value: i.id, label: i.letter_num })) || [];
                            return (
                              <Select
                                options={letterOptionsForRow}
                                onChange={(selectedOption) => handleLetterChange(index, selectedOption?.value)}
                                value={letterOptionsForRow.find((item) => item.value === data.letterrecord) || null}
                                placeholder="Select Letter Number"
                                isSearchable isClearable
                                noOptionsMessage={() => "No other options"}
                                styles={CSSForSelectModern}
                              />
                            );
                          })()}
                          {errors[`${index}-letterrecord`] && <span className="error-message">{errors[`${index}-letterrecord`]}</span>}
                        </div>
                      </>
                    )}

                    <div className="form-field">
                      <label><FileText size={14} /> Document Name<span className="required">*</span></label>
                      <input
                        type="text"
                        name="document_name"
                        value={data.document_name}
                        onChange={(e) => handleInputChange(e, index)}
                        placeholder="Document Name"
                      />
                      {errors[`${index}-document_name`] && <span className="error-message">{errors[`${index}-document_name`]}</span>}
                    </div>

                    {title !== "Miscellaneous Document" && title !== "Document" && title !== "Letter Attacments" && title !== "Bulk Documents" && (
                      <div className="form-field">
                        <label><Tag size={14} /> Document Type<span className="required">*</span></label>
                        {(() => {
                          const documentTypeOptions = title !== "LOA & Certificate Document"
                            ? [
                              { value: "actual", label: "Actual Document" },
                              { value: "boq", label: "Boq Document" },
                            ]
                            : [
                              { value: "actual", label: "LOA Copy" },
                              { value: "boq", label: "Certificate Copy" },
                            ];

                          return (
                            <Select
                              options={documentTypeOptions}
                              value={documentTypeOptions.find((opt) => opt.value === data.document_type) || null}
                              onChange={(selectedOption) => {
                                handleInputChange(
                                  { target: { name: "document_type", value: selectedOption ? selectedOption.value : "" } },
                                  index
                                );
                              }}
                              isSearchable
                              isClearable
                              placeholder="Select Document Type"
                              styles={CSSForSelectModern}
                            />
                          );
                        })()}
                        {errors[`${index}-document_type`] && <span className="error-message">{errors[`${index}-document_type`]}</span>}
                      </div>
                    )}

                    <div className="form-field">
                      <label><Paperclip size={14} /> Upload Document<span className="required">*</span></label>
                      {!data.document_file ? (
                        <label htmlFor={`document_file_${index}`} className="custom-file-upload-modern">
                          <FileUp size={18} />
                          <span>Click to select file (.zip, .pdf, .xls, .xlsx, .gif)</span>
                        </label>
                      ) : (
                        <>
                          <button type='button' className="explorer-btn">
                            <div className="icon-wrapper">
                              <div className="folder-part folder-base"></div>
                              <div className="folder-part folder-tab"></div>
                              <div className="folder-part folder-accent"></div>
                              <div className="folder-part folder-highlight"></div>
                            </div>
                            <div className="status-indicator"></div>
                            <span className="tooltip-label">File Explorer</span>
                          </button>

                          <span style={{ fontSize: "12px", color: "#10b981", marginTop: "4px", display: "block" }}>
                            ✓ File selected: {data.document_file.name}
                          </span>
                        </>

                      )}
                      <input
                        type="file"
                        id={`document_file_${index}`}
                        name="document_file"
                        accept=".zip, .pdf, .xls, .xlsx, .gif"
                        style={{ display: "none" }}
                        onChange={(e) => handleFileChange(e, index)}
                        ref={(el) => (fileInputRefs.current[index] = el)}
                      />
                      {errors[`${index}-document_file`] && <span className="error-message">{errors[`${index}-document_file`]}</span>}
                    </div>

                    <div className="form-field" style={{ flexDirection: 'row', alignItems: 'flex-end', gap: '8px' }}>
                      <button title="Clear File" onClick={() => handleClear(index)} className="btn-secondaryy" type="button">
                        Clear
                      </button>
                      {formData.length > 1 && (
                        <button title="Remove Document" onClick={() => handleRemoveDocument(index)} className="btn-secondaryy" type="button" style={{ color: '#dc3545', borderColor: '#fecaca' }}>
                          Remove
                        </button>
                      )}
                    </div>
                  </div>
                  {formData.length > 1 && index !== formData.length - 1 && <div className="employee-card-v2-divider" style={{ margin: '16px 0' }} />}
                </div>
              ))}

              {uploadProgress > 0 && (
                <div className="upload-progress-modern">
                  <div className="upload-progress-label">
                    <span>Uploading</span>
                    <strong>{uploadProgress}%</strong>
                  </div>
                  <div className="upload-progress-track">
                    <div className="upload-progress-fill" style={{ width: `${uploadProgress}%` }} />
                  </div>
                </div>
              )}

              <div className="form-actions">
                <div></div>
                <div className="submit-buttons">
                  <button className="btn-secondaryy" onClick={handleClose}>Cancel</button>
                  <button className="btn-primaryy" onClick={handleSubmit} disabled={loading}>
                    {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                    <span>{loading ? 'Uploading...' : 'Add Document'}</span>
                  </button>
                </div>
              </div>
            </div>
          )}
          {toggleState === 3 && (
            <div className="form-section">
              <div className="section-title" style={{ justifyContent: "space-between", display: "flex" }}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <FileText size={18} />
                  <h4>Document Details</h4>
                </div>
                <button
                  type="button"
                  onClick={addNewDocumentForDesign}
                  className="btn-secondaryy"
                  style={{ display: "inline-flex", alignItems: "center", gap: "6px" }}
                >
                  <Plus size={14} />
                  Another Document
                </button>
              </div>

              {designDrawingFormData.map((doc, index) => {
                const drawingTypeError = errors[`drawingtype_${index}`];
                const canRemove = designDrawingFormData.length > 1;
                const cardTitle = `Drawing ${index + 1}`;

                return (
                  <div
                    key={index}
                    style={{
                      border: "1px solid #e3e3e3",
                      borderRadius: "12px",
                      background: "#f7f8fa",
                      padding: "16px",
                      marginBottom: "16px",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginBottom: "12px",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "center", gap: "8px", fontWeight: 500 }}>
                        <PencilRuler size={16} />
                        <span>{cardTitle}</span>
                      </div>
                      {canRemove && (
                        <button
                          type="button"
                          className="btn-secondaryy"
                          onClick={() => handleRemoveDocumentForDesign(index)}
                        >
                          <Trash2 size={14} /> <span>Remove</span>
                        </button>
                      )}
                    </div>

                    <div className="form-grid">
                      <div className="form-field">
                        <label><FileText size={14} /> Document Name<span className="required">*</span></label>
                        <input
                          type="text"
                          name="document_name"
                          value={doc.document_name}
                          onChange={(e) => handleInputDrawingChange(e, index, setDesignDrawingFormData)}
                          placeholder="Document Name"
                        />
                        {errors[`${index}-document_name`] && (
                          <span className="error-message">{errors[`${index}-document_name`]}</span>
                        )}
                      </div>

                      <div className="form-field">
                        <label><Tag size={14} /> Drawing Type<span className="required">*</span></label>
                        <Select
                          options={drawingTypeOptions}
                          value={drawingTypeOptions.find((opt) => opt.value === doc.drawingtype) || null}
                          onChange={(selectedOption) =>
                            handleInputDrawingChange(
                              { target: { name: "drawingtype", value: selectedOption ? selectedOption.value : "" } },
                              index,
                              setDesignDrawingFormData
                            )
                          }
                          isSearchable
                          isClearable
                          placeholder="Select Drawing Type"
                          styles={CSSForSelectModern}
                        />
                        {drawingTypeError && <span className="error-message">{drawingTypeError}</span>}
                      </div>

                      <div className="form-field">
                        <label><Paperclip size={14} /> Upload Document<span className="required">*</span></label>
                        {!doc.document_file ? (
                          <label htmlFor={`design_file_${index}`} className="custom-file-upload-modern">
                            <FileUp size={18} />
                            <span>Click to select file (.zip, .pdf, .xls, .xlsx, .gif)</span>
                          </label>
                        ) : (
                          <>
                            <button type="button" className="explorer-btn">
                              <div className="icon-wrapper">
                                <div className="folder-part folder-base"></div>
                                <div className="folder-part folder-tab"></div>
                                <div className="folder-part folder-accent"></div>
                                <div className="folder-part folder-highlight"></div>
                              </div>
                              <div className="status-indicator"></div>
                              <span className="tooltip-label">File Explorer</span>
                            </button>
                            <span style={{ fontSize: "12px", color: "#10b981", marginTop: "4px", display: "block" }}>
                              ✓ File selected: {doc.document_file.name}
                            </span>
                          </>
                        )}
                        <input
                          type="file"
                          id={`design_file_${index}`}
                          name="document_file"
                          accept=".zip, .pdf, .xls, .xlsx, .gif"
                          style={{ display: "none" }}
                          onChange={(e) => handleFileDrawingChange(e, index, setDesignDrawingFormData)}
                        />
                        {errors[`${index}-document_file`] && (
                          <span className="error-message">{errors[`${index}-document_file`]}</span>
                        )}
                      </div>
                    </div>

                    <div className="form-field" style={{ flexDirection: "row", alignItems: "flex-end", gap: "8px" }}>
                      <button
                        title="Clear File"
                        onClick={() => handleClearForDesign(index)}
                        className="btn-secondaryy"
                        type="button"
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                );
              })}

              {uploadProgress > 0 && (
                <div className="upload-progress-modern">
                  <div className="upload-progress-label">
                    <span>Uploading</span>
                    <strong>{uploadProgress}%</strong>
                  </div>
                  <div className="upload-progress-track">
                    <div className="upload-progress-fill" style={{ width: `${uploadProgress}%` }} />
                  </div>
                </div>
              )}

              <div className="form-actions">
                <div></div>
                <div className="submit-buttons">
                  <button type="button" className="btn-secondaryy" onClick={handleClose}>Cancel</button>
                  <button className="btn-primaryy" onClick={handleSubmit} disabled={loading}>
                    {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
                    <span>{loading ? "Uploading..." : "Add Document"}</span>
                  </button>
                </div>
              </div>
            </div>
          )}
          {toggleState === 2 && (
            <div className="table-wrapper-minimal table-box scroll-container-table">
              <table className="progress-table-minimal">
                <thead className="table-heading">
                  <tr>
                    <th className="col-sno" style={{ width: '6%' }}>#</th>
                    <th className="col-period">Document Name</th>
                    {showTypeColumn && <th className="col-period">Document Type</th>}
                    <th className="col-approved text-center" style={{ width: '15%' }}>Document</th>
                    {showActionColumn && <th className="col-action text-center" style={{ width: '12%' }}>Action</th>}
                  </tr>
                </thead>
                <tbody>
                  {currentDocs.filter((doc) => doc.drawingtype === null).map((doc, docIndex) => (
                    <tr className="progress-row" key={docIndex}>
                      <td className="col-sno text-start">{docIndex + 1}.</td>
                      <td className="col-period">{doc.document_name}</td>
                      {showTypeColumn && <td className="col-period">{doc.document_type}</td>}
                      <td className="col-approved text-center">
                        {doc.document_file ? (
                          <a href={doc.document_file} target="blank" className="attachment-link">
                            <FileCheck size={14} style={{ marginRight: '4px', verticalAlign: 'middle' }} />
                            View
                          </a>
                        ) : (
                          <span style={{ fontSize: '11px', color: '#cbd5e1', fontStyle: 'italic' }}>Not Attached</span>
                        )}
                      </td>
                      {showActionColumn && (
                        <td className="col-action text-center">
                          <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                            <DeleteDocuments i={doc} getDocument={doc._deleteSource} />
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                  {currentDocs.filter((doc) => doc.drawingtype === null).length === 0 && (
                    <tr>
                      <td colSpan={showTypeColumn ? (showActionColumn ? 5 : 4) : (showActionColumn ? 4 : 3)}>
                        <div className="empty-state-attractive">
                          <div className="empty-state-icon-wrap">
                            <FileSpreadsheet size={32} />
                          </div>
                          <h4 className="empty-state-title">No Documents Found</h4>
                          <p className="empty-state-subtitle">No documents have been uploaded yet.</p>
                        </div>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
          {
            toggleState === 4 && (
              <div className="table-wrapper-minimal table-box scroll-container-table">
                <table className="progress-table-minimal">
                  <thead className="table-heading">
                    <tr>
                      <th className="col-sno" style={{ width: '6%' }}>#</th>
                      <th className="col-period">Document Name</th>
                      <th className="col-period">Drawing Type</th>
                      <th className="col-approved text-center" style={{ width: '15%' }}>Document</th>
                      {showActionColumn && <th className="col-action text-center" style={{ width: '12%' }}>Action</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {currentDocs.filter((doc) => doc.drawingtype !== null).map((doc, docIndex) => (
                      <tr className="progress-row" key={docIndex}>
                        <td className="col-sno text-start">{docIndex + 1}.</td>
                        <td className="col-period">{doc.document_name}</td>
                        <td className="col-period">{doc.drawingtype}</td>
                        <td className="col-approved text-center">
                          {doc.document_file ? (
                            <a href={doc.document_file} target="blank" className="attachment-link">
                              <FileCheck size={14} style={{ marginRight: '4px', verticalAlign: 'middle' }} />
                              View
                            </a>
                          ) : (
                            <span style={{ fontSize: '11px', color: '#cbd5e1', fontStyle: 'italic' }}>Not Attached</span>
                          )}
                        </td>
                        {showActionColumn && (
                          <td className="col-action text-center">
                            <div className="action-group-minimal" style={{ justifyContent: 'center' }}>
                              <DeleteDocuments i={doc} getDocument={doc._deleteSource} />
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                    {currentDocs.filter((doc) => doc.drawingtype !== null).length === 0 && (
                      <tr>
                        <td colSpan={5}>
                          <div className="empty-state-attractive">
                            <div className="empty-state-icon-wrap">
                              <PencilRuler size={32} />
                            </div>
                            <h4 className="empty-state-title">No Drawings Found</h4>
                            <p className="empty-state-subtitle">No drawing documents have been uploaded yet.</p>
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
        </Modal.Body>
      </Modal>
    </>
  );
};

const Updatedocument = ({ i, getData }) => {


  const [formData, setFormData] = useState({
    document_type: "",
    document_name: "",
  });

  const [inputstate, setInputState] = useState({});
  const [errors, setErrors] = useState({});
  const [show, setShow] = useState(false);
  const validateForm = () => {
    const newErrors = {};
    const requiredFields = ["document_name", "document_type"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {

    const { name, value } = e.target;

    setInputState({
      ...inputstate,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => {

    setShow(true);

    const filteredData = { ...i };
    delete filteredData.document_file;
    setFormData(filteredData);

  };

  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setShowProgressModal(true);
      setLoading(true);
      setUploadProgress(0);

      const loadingToastId = toast.loading("Updating: please wait...");
      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setUploadProgress(progress);
      }, 100);
      try {
        const formDataToSend = new FormData();

        Object.keys(formData).forEach((key) => {
          if (formData[key] && key !== "document_file") {
            formDataToSend.append(key, formData[key]);
          }
        });
        let res = await axios.put(
          `${BASE_URL}/siteproject/documents/${i.id}/`,
          formDataToSend
        );

        if (res.status === 200) {
          handleClose();
          await getData();
          setTimeout(() => {
            toast.dismiss(loadingToastId);
            toast.success("Data updated successfully.", {
              autoClose: 1000,
              pauseOnHover: true,
              closeOnClick: true,
            });
          }, 1000);
        } else {
          throw new Error("Unexpected response status: " + res.status);
        }

      } catch (err) {
        clearInterval(interval);
        setUploadProgress(0);
        handleErrorToast(err);
      } finally {
        clearInterval(interval);

        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);

        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button title='Update' className="model-edit-button" onClick={handleShow}>
        <UpdatePencil />
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" /> :
          show === true ?
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
              <Modal.Header closeButton>
                <Modal.Title>Update Document {i.document_name}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="parent-div">
                  <div className="bdy-div">
                    {/* <h6 className="task-Tab-heading   font-weight500    font-size-heading">Birthday </h6> */}
                    <div title="Document Name" className="flex-column">
                      <label htmlFor="document_name" className="form-labels  font-weight500    font-size-subheading">
                        Document name<span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        maxLength={50}
                        id="document_name"
                        name="document_name"
                        placeholder="Document Name"
                        onChange={handleInputChange}
                        value={formData.document_name}
                        className={`form-input ${errors.document_name ? "error" : inputstate.tile ? "success" : ""
                          }`}
                      />
                      {errors.document_name && (
                        <span className="error-message font-size-text ">{errors.document_name}</span>
                      )}
                    </div>

                    <div title="Document type" className="flex-column form-group-selectt">
                      <label htmlFor="document_type" className="form-labels  font-weight500    font-size-subheading">
                        Document Type <span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="document_type"
                        name="document_type"
                        value={formData.document_type}
                        onChange={handleInputChange}
                        className={`form-input form-group-selection ${errors.document_type ? "error" : inputstate.document_type ? "success" : ""
                          }`}
                      >
                        <option value="">Select Document Type</option>
                        <option value="actual">Consultant</option>
                        <option value="boq">contractor</option>


                      </select>

                      <div>
                        {errors.document_type && (
                          <span className="error-message font-size-text ">{errors.document_type}</span>
                        )}
                      </div>
                    </div>

                    <div className="button-models" style={{ marginTop: "20px", justifyContent: "space-evenly" }}>
                      <button className="cancelbutton" onClick={handleClose}>Cancel</button>

                      <Updatebutton onclick={handleFormSubmitPut} />
                    </div>
                  </div>
                </div>
                <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
              </Modal.Body>
            </Modal> : ""
      }
    </>
  )



};


// const AddViewWork = () => {
//   const [documents, setDocuments] = useState([{ document_name: "", document_file: null }]);
//   const [remarks, setRemarks] = useState("");
//   const [toggleState, setToggleState] = useState(1);
//   const [show, setShow] = useState(false);

//   const handleShow = () => setShow(true);
//   const handleClose = () => {
//     setShow(false);
//     setRemarks("");
//     setDocuments([{ document_name: "", document_file: null }]);
//   };

//   const handleFileChange = (e, index) => {
//     const updatedDocuments = [...documents];
//     updatedDocuments[index].document_file = e.target.files[0];
//     setDocuments(updatedDocuments);
//   };

//   const handleNameChange = (e, index) => {
//     const updatedDocuments = [...documents];
//     updatedDocuments[index].document_name = e.target.value;
//     setDocuments(updatedDocuments);
//   };

//   const addDocumentField = () => {
//     setDocuments([...documents, { document_name: "", document_file: null }]);
//   };

//   const removeDocumentField = (index) => {
//     setDocuments(documents.filter((_, i) => i !== index));
//   };

//   const handleSubmit = async () => {
//     const formData = new FormData();
//     documents.forEach((doc, index) => {
//       if (doc.document_file) {
//         formData.append(`documents[${index}][document_name]`, doc.document_name);
//         formData.append(`documents[${index}][document_file]`, doc.document_file);
//       }
//     });
//     formData.append("remarks", remarks);

//     try {
//       const response = await axios.post(`${BASE_URL}/siteproject/letter-assign-mail-post/`, formData, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       console.log("Upload successful", response.data);
//     } catch (error) {
//       console.error("Upload failed", error);
//     }
//   };

//   return (
//     <>
//       <button title="Add/View Document" className="document-download-button width-5vw" onClick={handleShow}>
//         Add/View
//       </button>
//       <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
//         <Modal.Header closeButton>
//           <Modal.Title>{toggleState === 1 ? "Add Document" : "View Document"}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           {toggleState === 1 && (
//             <>
//               {documents.map((doc, index) => (
//                 <div key={index} className="flex-row justify-between">
//                   <input
//                     type="text"
//                     value={doc.document_name}
//                     onChange={(e) => handleNameChange(e, index)}
//                     placeholder="Document Name"
//                     className="form-input"
//                   />
//                   <input
//                     type="file"
//                     accept=".pdf, .doc, .docx"
//                     onChange={(e) => handleFileChange(e, index)}
//                   />
//                   <button onClick={() => removeDocumentField(index)}>Remove</button>
//                 </div>
//               ))}
//               <button onClick={addDocumentField}>Add Another Document</button>
//               <button onClick={handleSubmit}>Submit</button>
//             </>
//           )}
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };


// const LetterExchangePage = ({ letterId }) => {
//   const { letter_id, assigned_to } = useParams();
//   const [letterData, setLetterData] = useState([]);
//   const [projectsList, setprojectList] = useState([]);

//   const [buffer, setBuffering] = useState(false)
//   const getProject = async () => {
//     setBuffering(true);
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/siteproject/projectbyid/${letterData.project}/`
//       );
//       setprojectList(res.data);
//     } catch (err) {
//       // toast.error('Error fetching letters.');
//       handleErrorToast(err);
//     } finally {
//       setBuffering(false);// End Buffering
//     }
//   };
//   const getLettersingle = async () => {
//     setBuffering(true);
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/siteproject/getletterrecordanddoc/${letter_id}/`
//       );
//       setLetterData(res.data);
//     } catch (err) {
//       // toast.error('Error fetching letters.');
//       handleErrorToast(err);
//     } finally {
//       setBuffering(false);// End Buffering
//     }
//   };

//   useEffect(() => {
//     getLettersingle();
//   }, [letter_id]);

//   useEffect(() => {
//     getProject();
//   }, [letterData.project])

//   return (
//     <>


//       <div className="attendance-subcont">
//         <div className="field-cont width-100vw justify-between">
//           <div>
//             <AddAssignTO siteprcode={projectList.site_prcode} projectname={projectList.project_short_name} letterno={letterData.letter_num} letterId={letterData.id} subject={letterData.subject} assignemail={assigned_to} />
//           </div>
//           <div className='table-css-white-background'>
//             <div class="form-flex-wrap table-box height-73vh scroll-container-table ">
//               <table className="table-css ">
//                 <thead className='table-heading'>
//                   <tr className="custom-table-head-tr">
//                     <th className="align-left">S. No.</th>
//                     <th className="align-center">Assigned By</th>
//                     <th className="align-center">Assigned To</th>
//                     <th className="align-right width-5vw">View </th>
//                     <th className="align-right width-5vw">Assignee Remarks </th>
//                     <th className="align-right width-5vw">Receiver Remarks </th>
//                     <th className="align-right width-5vw">DeadLine </th>
//                   </tr>
//                 </thead>
//                 {buffer ? <div className="spinner"></div> : //buffering logic
//                   <tbody>
//                     {letterData.letter_tracking?.map((i, index) => (
//                       <React.Fragment key={index}>
//                         <tr className="custom-table-head-td">
//                           <td className="align-left">{index + 1}</td>
//                           <td className="align-center">{i.assigned_by}</td>
//                           <td className="align-center">{i.assigned_to}</td>
//                           {i.assigned_to === assigned_to ?
//                             <td className="align-center">

//                               <DocumentModel letterData={letterData.letter_tracking} letter_tracking={i.id} title={"Document"} getDocument={getLettersingle} />

//                             </td> :
//                             <td className="align-center">-</td>
//                           }
//                           <td className="align-center">{i.assiginee_remarks}</td>
//                           <td className="align-center">{i.assiginee_remarks}</td>
//                           <td className="align-center">{i.remarks}</td>
//                         </tr>
//                       </React.Fragment>
//                     ))}
//                   </tbody>
//                 }
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>



//       <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

//     </>
//   );
// };

const LetterExchangePage = ({ letterId }) => {
  const { letter_id, assigned_to } = useParams();
  const [letterData, setLetterData] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [contractor, setContractor] = useState([]);
  const [buffer, setBuffering] = useState(false);
  const [contractorName, setContractorName] = useState([]);


  const getProject = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/projectbyid/${letterData.project}/`
      );
      setProjectList(res.data);
      const contractor = await axios.get(
        `${BASE_URL}/siteproject/contractorbyproject/${letterData.project}/null/`
      );
      setContractor(contractor.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  const getLettersingle = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/getletterrecordanddoc/${letter_id}/`
      );
      setLetterData(res.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    getLettersingle();
  }, [letter_id]);

  useEffect(() => {
    if (letterData.project) {
      getProject();
    }
  }, [letterData.project]);

  useEffect(() => {
    if (letterData.contractor) {
      const contractor_name = contractor.find(i => i.id === letterData.contractor);
      setContractorName(contractor_name || {}); // Ensure it's always an object
    }
  }, [letterData.contractor, contractor]);






  return (
    <>
      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
      <div className="dashboard-main-section" style={{ width: "100%", background: "#f4f7fe", height: "auto" }}>
        <div className="content-tabs" style={{ width: "100%" }}>
          <div className="info-box-div-bg">

            <div className="jd-heading-outer heading-bg-color-white">
              <div className="jd-heading-outer-flex">
                <h2 className="jd-heading-main font-weight600 font-size-heading">
                  Letter Details of :"{letterData?.letter_num} " of project:"{projectList.site_prcode}-{projectList.project_short_name}"
                </h2>
                <div>
                  <DocumentModel title="Letters" letterrecord={letterData.id} getDocument={getLettersingle} letterData={letterData} />
                </div>
              </div>

              <div>
                <div className="jd-heading-bottom-bold" style={{ width: "35vw", height: "2px" }}></div>
                <div className="jd-heading-bottom-light"></div>
              </div>
            </div>
            <div className="flex-row justify-between">
              <div className="">
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text table-body">Letter Date</td>
                  <td>:</td>
                  <th className="personal-detail-2 font-weight500 font-size-text table-body">
                    {letterData.letter_date
                      ? new Date(letterData.letter_date).toISOString().split('T')[0].split('-').reverse().join('/')
                      : "N/A"}
                  </th>

                </tr>
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text table-body">Work Performed By</td>
                  <td>:</td>
                  <th className="personal-detail-2 font-weight500 font-size-text table-body">{letterData.workperformedby}</th>
                </tr>
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text table-body">Contractor Name</td>
                  <td>:</td>
                  <th className="personal-detail-2 font-weight500 font-size-text table-body">{contractorName.name}</th>
                </tr>
              </div>
              <div>
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text table-body">Letter Type</td>
                  <td>:</td>
                  <th className="personal-detail-2 font-weight500 font-size-text table-body">{letterData.lettertype}</th>
                </tr>
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text table-body">Subject</td>
                  <td>:</td>
                  <th className="personal-detail-2 font-weight500 font-size-text table-body">{letterData.subject}</th>
                </tr>
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text table-body">Letter Status</td>
                  <td>:</td>
                  <th className="personal-detail-2 font-weight500 font-size-text table-body">{letterData.status}</th>
                </tr>
              </div>
              <div>
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text table-body">Letter Remark</td>
                  <td>:</td>
                  <th className="personal-detail-2 font-weight500 font-size-text table-body">{letterData.remarks}</th>
                </tr>
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text table-body">Letter Exchange Type</td>
                  <td>:</td>
                  <th className="personal-detail-2 font-weight500 font-size-text table-body">{letterData.letterExchange}</th>
                </tr>
                <tr>
                  <td className="personal-detail-1 font-weight500 font-size-text table-body">Associated Letters</td>
                  <td>:</td>
                  <th className="personal-detail-2 font-weight500 font-size-text table-body"><AssociatedLetters id={letterData.id} LetterData={letterData.id} /></th>
                </tr>
              </div>
            </div>

          </div>
          <div className="info-box-div-bg " style={{ marginTop: "20px" }}>
            <div >
              <div className="jd-heading-outer-flex ">
                <h2 className="jd-heading-main font-weight600  font-size-heading">Authority Exchange List</h2>
                <div className="field-cont">
                  <AddAssignTO
                    siteprcode={projectList.site_prcode}
                    projectname={projectList.project_short_name}
                    letterno={letterData.letter_num}
                    letterId={letter_id}
                    subject={letterData.subject}
                    assignemail={assigned_to}
                    getData={getLettersingle}
                  />
                </div>
              </div>
              <div>
                <div className="jd-heading-bottom-bold"></div>
                <div className="jd-heading-bottom-light"></div>
              </div>
            </div>

            <div className="form-flex-wrap table-box paddingTop-0px  scroll-container-table child-table-scroll" >
              <table className="table-css">
                <thead className='table-heading'>
                  <tr className="custom-table-head-tr">
                    <th className="table-heading-text text-lefttt">S. No.</th>
                    <th className="table-heading-text">Assigned Work</th>
                    <th className="table-heading-text">Assigned By</th>
                    <th className="table-heading-text">Assigned To</th>
                    <th className="table-heading-text">Your Work</th>
                    <th className="table-heading-text text-center">Add/View Documents</th>
                    <th className="table-heading-text text-right">Work Assigned Date</th>
                  </tr>
                </thead>
                {buffer ? (
                  <div className="loading-spinner"></div>
                ) : (
                  <tbody>
                    {letterData.letter_tracking?.map((i, index) => (
                      <tr className="custom-table-head-td" key={index}>
                        <td className="table-body text-lefttt">{index + 1}</td>
                        <td className="table-body">{i.assiginee_remarks ? i.assiginee_remarks : "-"}</td>
                        <td className="table-body">{i.assigned_by_name ? i.assigned_by_name : "-"}</td>
                        <td className="table-body">{i.assigned_to_name ? i.assigned_to_name : "-"}</td>
                        <td className="table-body">{i.remarks ? i.remarks : "-"}</td>

                        {i.assigned_to === assigned_to ? (
                          <td className="table-body ">
                            <div className="flex-row justify-center">
                              <DocumentModel
                                letterData={letterData.letter_tracking}
                                letter_tracking={i.id}
                                title="Document"
                                getDocument={getLettersingle}
                              />
                            </div>
                          </td>
                        ) : (
                          <td className="table-body text-center">-</td>
                        )}
                        <td className="table-body text-right">
                          {new Date(i.created_at).toISOString().split('T')[0].split('-').reverse().join('/')}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                )}
              </table>
            </div>

          </div>
        </div>
      </div>

      <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};




const AddAssignTO = ({ siteprcode, projectname, letterno, subject, letterdate, letterId, assignemail, getData }) => {

  const [show, setShow] = useState(false);
  const name = sessionStorage.getItem("name");
  const email = sessionStorage.getItem("email");
  const [empList, setEmpList] = useState([]);
  const navigate = useNavigate();
  const currentUrl = window.location.href;
  const urlParts = currentUrl.split("/");
  const FRONTEND_URL = urlParts[0] + `//` + urlParts[2];



  const handleClose = () => {
    setShow(false);
    setFormData({
      concern_personname: "",
      subject: subject,
      letter_no: letterno,
      assignedbyname: name,
      due_date: "",
      project_code: siteprcode,
      project_name: projectname,
      assigned_to: "",
      link: "",
      concern_person_email: "",
      assiginee_remarks: "",
      remarks: "",
      assignedbyemail: email,
      assigned_by: email,
      letter_id: letterId,
      documents: [],
    })
    setErrors({});
  };
  const handleShow = () => {
    setShow(true);
    getEmployee();
  }
  const [formData, setFormData] = useState({
    concern_personname: "",
    subject: subject,
    letter_no: letterno,
    due_date: "",
    assignedbyname: name,
    project_code: siteprcode,
    project_name: projectname,
    link: "",
    concern_person_email: "",
    assigned_to: "",
    assiginee_remarks: "",
    remarks: "",
    assignedbyemail: email ? email : assignemail,
    assigned_by: email ? email : assignemail,
    letter_id: letterId,
    documents: [],
  });


  const linkk = `${FRONTEND_URL}/LetterExchange/${letterId}/${formData.assigned_to}/`
  const getEmployee = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/getemprole/`);
      setEmpList(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  console.log("formData");
  console.log(formData)

  // const handleEmployeeChange = (e) => {
  //   const selectedValue = e.target.value;
  //   const selectedEmployee = empList.find(emp => emp.employee === selectedValue);

  //   if (selectedEmployee) {

  //     setFormData({
  //       ...formData,
  //       concern_personname: selectedEmployee.name,
  //       assigned_to: selectedEmployee.employee,
  //       concern_person_email: selectedEmployee.employee,
  //     });

  //     setErrors(prevErrors => {
  //       const updatedErrors = { ...prevErrors };
  //       delete updatedErrors.concern_personname;
  //       delete updatedErrors.concern_person_email;
  //       return updatedErrors;
  //     });
  //   }
  // };

  // const handleEmployeeChange = (selectedOption) => {
  //   if (selectedOption) {
  //     setFormData({
  //       ...formData,
  //       concern_personname: selectedOption.name,
  //       assigned_to: selectedOption.employee,
  //       concern_person_email: selectedOption.employee,
  //     });



  //     setErrors((prevErrors) => {
  //       const updatedErrors = { ...prevErrors };
  //       delete updatedErrors.concern_personname;
  //       delete updatedErrors.concern_person_email;
  //       return updatedErrors;
  //     });


  //   }

  // };

  const handleEmployeeChange = (selectedOption) => {
    if (!selectedOption) {
      // Reset to null when cleared
      setFormData({
        ...formData,
        concern_personname: "",
        assigned_to: "",
        concern_person_email: "",
      });
    } else {
      setFormData({
        ...formData,
        concern_personname: selectedOption.name,
        assigned_to: selectedOption.employee,
        concern_person_email: selectedOption.employee,
      });
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.concern_personname;
      delete updatedErrors.concern_person_email;
      return updatedErrors;
    });
  };

  const employeeOptions = [
    { value: "null", label: "Select Employee" },
    ...empList.map((emp) => ({
      value: emp.employee,
      label: `${emp.emp_code} - ${emp.name}`,
      name: emp.name,
      employee: emp.employee,
    })),
  ];


  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      link: linkk,
      project_code: siteprcode,
      project_name: projectname,
      subject: subject,
      letter_no: letterno,
      letter_id: letterId,
      assigned_by: email ? email : assignemail
    }))
  }, [linkk, siteprcode, projectname, subject, letterno, letterId, email, assignemail])


  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);
  const validateForm = () => {
    const newErrors = {};

    if (!formData.assigned_to) {
      newErrors.assigned_to = "Employee is required!";
    }

    if (!formData.assiginee_remarks) {
      newErrors.assiginee_remarks = "Assigned work is required!";
    }
    if (assignemail && !formData.remarks) {
      newErrors.remarks = "Your Work is required!";
    }


    setErrors(newErrors);
    setIsSubmitted(true);

    return Object.keys(newErrors).length === 0;
  };


  console.log("formData.createdAt")
  console.log(formData.createdAt)

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (value) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };



  // ?  ************** Validation End **************  ! //

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait...");
      setLoading(true);

      try {
        const today = new Date();
        today.setDate(today.getDate() + 5); // Add 5 days
        const dueDate = today.toISOString().split("T")[0]; // Format YYYY-MM-DD

        let res = await axios.post(`${BASE_URL}/siteproject/letter-assign-mail-post/`, {
          ...formData,
          due_date: dueDate, // Set due_date dynamically
        });

        if (res.status === 200) {
          await getData();
          handleClose();
          toast.dismiss(loadingToastId);
          toast.success("Work Assigned Successfully");


        } else {
          alert(res);
        }
      } catch (err) {
        handleErrorToast(err);
        console.error(err);

      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };



  return (
    <>

      <button title="Assign To" className="upload-svg" onClick={handleShow}>
        <AddwithWhiteCircle />
        {" "} Assign Work
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw" >
        <Modal.Header closeButton className=" task-Tab-heading font-weight500    font-size-heading ">
          <Modal.Title>Assign Work</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">

              <div className="flex-column">
                <div className="form-group">
                  <div className="flex-column form-group-selectt">
                    <label
                      htmlFor="assigned_to"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Employee <span className="required">*</span>
                    </label>
                    <br />
                    {/* <select id="assigned_to"
                      name="assigned_to"
                      placeholder="assigned_to"
                      value={formData.assigned_to}

                      onChange={handleEmployeeChange}
                      className={`form-input form-group-selection ${errors.assigned_to ? "error" : inputState.assigned_to ? "success" : ""
                        }`}
                    >
                      <option value="">Select an Employee</option>
                      {empList?.sort((a, b) => a.emp_code.localeCompare(b.emp_code, 'en', { ignorePunctuation: true }))
                        .map((i) => (
                          <option key={i.employee} value={i.employee}>
                            {i.emp_code} - {i.name}
                          </option>
                        ))}
                    </select> */}

                    <Select
                      options={employeeOptions}
                      onChange={handleEmployeeChange}
                      value={employeeOptions.find(option => option.value === formData.assigned_to)}
                      placeholder="Select or Search Employee"
                      // className={`form-input ${errors.assigned_to ? "error" : inputState.assigned_to ? "success" : ""}`}
                      isSearchable
                      isClearable
                      noOptionsMessage={() => "No other options"}
                      styles={{
                        control: (provided) => ({
                          ...provided,
                          width: '33vw',
                          height: '50px',
                          borderRadius: '10px',
                          border: '1px solid #e3e3e3',
                          margin: '10px 0px 20px 0px',
                          color: '#4a4a4a',
                          backgroundColor: '#f7f8fa',
                          padding: '0px 10px',
                        }),
                        placeholder: (provided) => ({
                          ...provided,
                          color: '#4a4a4a',
                        }),
                        menu: (provided) => ({
                          ...provided,
                          width: '33vw',
                          borderRadius: '10px',
                          marginTop: '0',
                          zIndex: 5,
                        }),
                        menuPortal: (provided) => ({
                          ...provided,
                          zIndex: 5,
                        }),
                        singleValue: (provided) => ({
                          ...provided,
                          color: '#4a4a4a',
                        }),
                        input: (provided) => ({
                          ...provided,
                          color: '#4a4a4a',
                        }),
                      }}

                    />





                  </div>
                  {errors.assigned_to && (
                    <div className="error-message font-size-text">{errors.assigned_to}</div>
                  )}
                </div>
                {assignemail &&
                  <div className="flex-column">
                    <label htmlFor="remarks" className="form-labels  font-weight500    font-size-subheading">
                      Your Work<span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      maxLength={50}
                      id="remarks"
                      name="remarks"
                      placeholder="Your Work"
                      onChange={handleInputChange}
                      value={formData.remarks}
                      className={`form-input ${errors.remarks ? "error" : inputState.tile ? "success" : ""
                        }`}
                    />
                    {errors.remarks && (
                      <span className="error-message font-size-text ">{errors.remarks}</span>
                    )}
                  </div>
                }
                <div className="flex-column">
                  <label htmlFor="assiginee_remarks" className="form-labels  font-weight500    font-size-subheading">
                    Assigned Work<span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    maxLength={50}
                    id="assiginee_remarks"
                    name="assiginee_remarks"
                    placeholder="Assigned Work"
                    onChange={handleInputChange}
                    value={formData.assiginee_remarks}
                    className={`form-input ${errors.assiginee_remarks ? "error" : inputState.tile ? "success" : ""
                      }`}
                  />
                  {errors.assiginee_remarks && (
                    <span className="error-message font-size-text ">{errors.assiginee_remarks}</span>
                  )}
                </div>



                <div className="button-models">
                  <button className="model-button   font-weight500   model-button-cancel" type="button" onClick={handleClose}>
                    Cancel
                  </button>
                  <button
                    //   type="submit"
                    className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                    onClick={handleFormSubmit}
                    disabled={loading}
                  >
                    Submit
                  </button>
                </div>

              </div>

            </div>
          </div>
          <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />

        </Modal.Body>
      </Modal>
    </>
  );
};


// const UpdateTrackRecordDetailsold = ({
//   i,
//   title,
//   getProjects,
//   projectList,
//   projectId,
//   letterType,
//   workperformedby,
//   associatedletters,
//   documents,

// }) => {
//   const [show, setShow] = useState(false);






//   const handleClose = () => setShow(false);
//   const handleShow = () => {
//     setFormData(i)
//     setShow(true);
//     getAsociatedLetters(i);
//   };




//   const [formData, setFormData] = useState({
//     letter_num: "",
//     project: projectId ? projectId : "",
//     subject: "",
//     letter_date: "",
//     reply_by: "",
//     status: "pending",
//     workperformedby: workperformedby ? workperformedby : "",
//     lettertype: letterType ? letterType : "",
//     letterExchange: "",
//     letter_from: "",
//     letterdepartment: "",

//     letter_to: "",
//     associated_letters: associatedletters ? associatedletters : [],
//     associated_letters_status: "",
//     documents: [
//       {
//         document_name: null,
//         document_file: "",
//       },
//     ],
//   });

//   const [formDataDoc, setFormDataDoc] = useState({
//     documents: [
//       {
//         document_name: null,
//         document_file: "",
//       },
//     ],
//   });


//   // console.log(i)





//   const [trackRecordList, setTrackRecordList] = useState([]);
//   const [optionsList, setoptionsList] = useState([]);
//   const getAsociatedLetters = async (i) => {
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/siteproject/letterrecordbclosestatus/${i.project
//         }/${i.workperformedby}/${i.lettertype}`
//       );
//       setTrackRecordList(res.data);
//     } catch (err) {
//       // toast.error('Error fetching letters.');
//       handleErrorToast(err);
//     }
//   };

//   // useEffect(() => {

//   // }, [formData.workperformedby, formData.project]);

//   // !  ************** Validation start **************  ! //

//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});

//   const validateForm = () => {
//     const requiredFields = [
//       // "letter_num",
//       // "project",
//       // "subject",
//       // "letter_date",
//       // "status",
//       // "lettertype",
//       // "workperformedby",
//       // 'workperformedby',
//       // 'letterExchange',
//       // 'letter_to',
//     ];
//     requiredFields.forEach((field) => {
//       if (!formData[field]) {
//         newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
//           } is required !`;
//       }
//     });

//     const newErrors = requiredFields.reduce((acc, field) => {
//       if (
//         !formData[field] ||
//         (Array.isArray(formData[field]) && formData[field].length === 0)
//       ) {
//         acc[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
//           } is required!`;
//       }
//       return acc;
//     }, {});

//     // if (
//     //   formData.associated_letters &&
//     //   formData.associated_letters.length > 0 &&
//     //   !formData.associated_letters_status
//     // ) {
//     //   newErrors["associated_letters_status"] =
//     //     "Status for associated letters is required!";
//     // }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   // const handleInputChange = (e) => {
//   //   const {name, value} = e.target;

//   //   setInputState({
//   //     ...inputState,
//   //     [name]: value.trim() ? "green" : "",
//   //   });

//   //   setFormData({
//   //     ...formData,
//   //     [name]: value,
//   //   });
//   // };

//   const handleInputChange = (e) => {
//     const { name, value, type, options } = e.target;

//     let newValue;
//     // Handle multiple select inputs
//     if (type === 'select-multiple') {
//       newValue = Array.from(options)
//         .filter((option) => option.selected)
//         .map((option) => option.value);
//     } else {
//       newValue = value;
//     }

//     // Update input state for UI feedback
//     setInputState((prevState) => ({
//       ...prevState,
//       [name]:
//         newValue && (Array.isArray(newValue) ? newValue.length > 0 : newValue)
//           ? "success"
//           : "",
//     }));

//     // Update form data based on the input change
//     setFormData((prevFormData) => {
//       const updatedData = {
//         ...prevFormData,
//         [name]: newValue,
//         ...(name === 'lettertype' && {
//           status:
//             newValue === 'informative' || newValue === 'show-cause'
//               ? newValue
//               : prevFormData.status,
//         }),

//         ...(name === 'reply_by' && prevFormData.letterExchange === 'send' && {
//           letter_from: value,
//         }),
//       };




//       return updatedData;
//     });

//   };

//   // ?  ************** Validation End **************  ! //

//   const [loading, setLoading] = useState(false); //loading logic
//   const handleFormSubmit = async (e) => {
//     e.preventDefault();

//     if (validateForm()) {
//       setLoading(true); // Start loading
//       const loadingToastId = toast.loading("Loading: Please wait..."); // Display loading toast

//       try {
//         const formDataToSend = new FormData();

//         // Loop through formData keys, skipping 'documents'
//         Object.keys(formData).forEach((key) => {
//           if (key !== "documents" && formData[key]) {
//             if (key === "associated_letters") {
//               // Append each associated letter to the form data
//               formData[key].forEach((value) => formDataToSend.append(key, value));
//             } else {
//               formDataToSend.append(key, formData[key]);
//             }
//           }
//         });

//         // Process documents, create custom filenames, and append to formData
//         formDataDoc.documents.forEach((doc, index) => {
//           const symbols = "!@#$%^&*()_-+=";
//           const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
//           const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
//           const numbers = "0123456789";
//           const now = new Date();
//           const date = now.toLocaleDateString("en-GB").split("/").reverse().join("-");
//           const time = now.toLocaleTimeString("en-GB", { hour12: false }).replace(/:/g, "-");
//           const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
//           let randomCode = "";

//           // Generate random code for unique filename
//           for (let i = 0; i < 8; i++) {
//             const randomIndex = Math.floor(Math.random() * allChars.length);
//             randomCode += allChars[randomIndex];
//           }

//           const originalFile = doc.document_file;
//           const customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
//           const customFile = new File([originalFile], customFileName, {
//             type: originalFile.type,
//           });

//           // Check if the document has a valid file before appending
//           if (doc.document_file) {
//             formDataToSend.append(`documents[${index}][document_name]`, doc.document_name);
//             formDataToSend.append(`documents[${index}][document_file]`, customFile);
//           } else {
//             console.warn(`Document file at index ${index} is not valid.`);
//           }
//         });

//         // Logging for debugging (can be removed in production)
//         console.log("FormData to send:");
//         formDataToSend.forEach((value, key) => {
//           if (value instanceof File) {
//             console.log(`${key}: [File] ${value.name} - ${value.size} bytes`);
//           } else {
//             console.log(`${key}: ${value}`);
//           }
//         });

//         // Send the PUT request with the FormData
//         let res = await axios.put(
//           `${BASE_URL}/siteproject/documentbulkwithletterupdate/${formData.id}/`,
//           formDataToSend,
//           {
//             headers: {
//               "Content-Type": "multipart/form-data",
//             },
//           }
//         );

//         // Handle response
//         if (res.status === 200) {
//           setShow(false); // Close modal or update UI
//           await getProjects(); // Fetch updated project data
//         } else {
//           alert("Failed to update the record.");
//         }
//       } catch (err) {
//         handleErrorToast(err); // Handle and show errors using toast
//       } finally {
//         setLoading(false); // End loading
//         toast.dismiss(loadingToastId); // Dismiss loading toast
//       }
//     }
//   };


//   const [fileNames, setFileNames] = useState([]);

//   const handleDocInputChange = (index, e) => {
//     const { name, value, type, files } = e.target;

//     setFormDataDoc((prevFormData) => {
//       const newDocuments = [...prevFormData.documents];
//       if (type === "file") {
//         newDocuments[index] = {
//           ...newDocuments[index],
//           [name]: files[0],
//         };
//         setFileNames((prevFileNames) => {
//           const newFileNames = [...prevFileNames];
//           newFileNames[index] = files[0]?.name;
//           return newFileNames;
//         });
//       } else {
//         newDocuments[index] = {
//           ...newDocuments[index],
//           [name]: value.trim() ? value : "",
//         };
//       }
//       return {
//         ...prevFormData,
//         documents: newDocuments,
//       };
//     });
//   };

//   const handleAddDocuments = (e) => {
//     e.preventDefault();
//     setFormDataDoc((prevFormData) => ({
//       ...prevFormData,
//       documents: [
//         ...prevFormData.documents,
//         {
//           document_name: "",
//           document_file: null,
//         },
//       ],
//     }));
//   };

//   const handleRemoveDocument = (index) => {
//     setFormDataDoc((prevFormData) => {
//       const newDocuments = [...prevFormData.documents];
//       newDocuments.splice(index, 1);
//       return {
//         ...prevFormData,
//         documents: newDocuments,
//       };
//     });
//     setFileNames((prevFileNames) => {
//       const newFileNames = [...prevFileNames];
//       newFileNames.splice(index, 1);
//       return newFileNames;
//     });
//   };

//   const handlePicDelete = async (e, i, getProjects) => {
//     e.preventDefault();

//     setLoading(true); // loading logic
//     const loadingToastId = toast.loading("Loading: Please wait..."); // toast logic

//     try {
//       let res = await axios.delete(
//         `${BASE_URL}/siteproject/documents/${i.id}/`
//       );

//       if (res.status === 200) {
//         await getProjects();
//       } else {
//         alert(res);
//       }
//     } catch (err) {
//       handleErrorToast(err);
//     } finally {
//       setLoading(false); // loading logic
//       toast.dismiss(loadingToastId);
//     }
//   };

//   useEffect(() => {
//     if (trackRecordList.length > 0) {
//       const valuetoshowinoptions = trackRecordList.filter((option) => option?.letter_num !== formData?.letter_num)
//       setoptionsList(valuetoshowinoptions);
//     }
//   }, [trackRecordList])


//   const handleChangecc = (selected) => {
//     const associated_letters = selected.length > 0 ? selected.map((item) => item.value) : [];

//     // Update the formData with the selected associated letters
//     setFormData((prevState) => ({
//       ...prevState,
//       associated_letters,
//     }));

//     // Check if any selected associated letter does not exist in trackRecordList
//     const missingLetters = associated_letters.filter(
//       (id) => !trackRecordList.some((record) => record.id === id)
//     );


//     // If there are missing letters, set associated_letters_status to 'close'
//     if (missingLetters.length > 0) {
//       setFormData((prevState) => ({
//         ...prevState,
//         associated_letters_status: 'close', // Update status if missing letters found
//       }));
//     } else {
//       setFormData((prevState) => ({
//         ...prevState,
//         associated_letters_status: '', // Reset status if all letters are found
//       }));
//     }
//   };



//   // ? Document End ===============================

//   // useEffect(() => {
//   //   getAsociatedLetters();
//   // }, [formData.project, formData.workperformedby, formData.lettertype]);

//   return (
//     <>
//       <button onClick={handleShow} className="document-download-button  width-5vw  width-5vw" >
//         View/Edit
//       </button>

//       <Modal
//         show={show}
//         onHide={handleClose}
//         dialogClassName="ourcompany-model"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>{title ? title : "Update Track Details"}</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>

//           <div className="form-flex-wrap">
//             {sessionStorage.getItem('sitemanagement_role') === "SiteManagement" ? "" :

//               ((projectId === 'null' || projectId === undefined || projectId === "") && (
//                 <div className="form-group">
//                   <RenderSelectField
//                     title="Site Projects"
//                     name="project"
//                     required={true}
//                     options={projectList?.sort((a, b) =>
//                       a.project_short_name.localeCompare(b.project_short_name)
//                     )
//                       .map((project) => ({
//                         value: project.id,
//                         label: `${project.site_prcode} - ${project.project_short_name}`,
//                       }))}
//                     placeholder="Select a Project"
//                     formData={formData}
//                     errors={errors}
//                     inputState={inputState}
//                     handleInputChange={handleInputChange}
//                   />
//                   {errors.project && (
//                     <div className="error-message col">
//                       {errors.project}
//                     </div>
//                   )}
//                 </div>
//               ))
//             }


//             <div className="form-group">
//               <RenderSelectField
//                 title="Letter Exchange"
//                 name="letterExchange"
//                 required={true}
//                 options={[
//                   { value: "send", label: "Send" },
//                   { value: "receive", label: "Received" },
//                 ]}
//                 placeholder="Select an Exchange Type"
//                 formData={formData}
//                 errors={errors}
//                 inputState={inputState}
//                 handleInputChange={handleInputChange}
//               />
//               {errors.letterExchange && (
//                 <div className="error-message col">
//                   {errors.letterExchange}
//                 </div>
//               )}
//             </div>

//             {formData.letterExchange === "send" && (
//               <div className="form-group">
//                 <RenderSelectField
//                   title="Reply By"
//                   name="reply_by"
//                   required={true}
//                   options={[
//                     { value: "HO", label: "Head Office" },
//                     { value: "SO", label: "Site Office" },
//                   ]}
//                   placeholder="Select a Reply By"
//                   formData={formData}
//                   errors={errors}
//                   inputState={inputState}
//                   handleInputChange={handleInputChange}
//                 />
//                 {errors.reply_by && (
//                   <div className="error-message col">{errors.reply_by}</div>
//                 )}
//               </div>
//             )}

//             <div className="form-group">
//               <RenderInputField
//                 title={`${toTitleCase(formData.letterExchange)} Letter No.`}
//                 name="letter_num"
//                 placeholder="Letter Number"
//                 formData={formData}
//                 errors={errors}
//                 required={true}
//                 inputState={inputState}
//                 handleInputChange={handleInputChange}
//               />
//               {errors.letter_num && (
//                 <div className="error-message col">{errors.letter_num}</div>
//               )}
//             </div>

//             <div className="form-group">
//               <RenderInputField
//                 title={`${toTitleCase(formData.letterExchange)} Letter Date`}
//                 name="letter_date"
//                 type="date"
//                 formData={formData}
//                 errors={errors}
//                 required={true}
//                 inputState={inputState}
//                 handleInputChange={handleInputChange}
//               />
//               {errors.letter_date && (
//                 <div className="error-message col">{errors.letter_date}</div>
//               )}
//             </div>

//             <div className="form-group">
//               <RenderInputTextareaField
//                 title="Subject"
//                 name="subject"
//                 placeholder="Enter subject here..."
//                 rows={5}
//                 cols={50}
//                 formData={formData}
//                 required={true}
//                 errors={errors}
//                 inputState={inputState}
//                 handleInputChange={handleInputChange}
//               />
//               {errors.subject && (
//                 <div className="error-message col">{errors.subject}</div>
//               )}
//             </div>
//             <div title="Status" className="flex-column form-group-selectt">
//               <label
//                 htmlFor="status"
//                 className="form-labels  font-weight500    font-size-subheading"
//               >
//                 Status<span className="required">*</span>
//               </label>
//               <br />
//               <select
//                 id="status"
//                 name="status"
//                 placeholder="Status"
//                 value={formData.status}
//                 onChange={handleInputChange}
//                 className={`form-input form-group-selection ${errors.status ? "error" : inputState.status ? "success" : ""
//                   }`}

//               >
//                 <option value="">Select a Status</option>
//                 <option value="pending">Pending</option>


//                 <option value="close">Close</option>

//               </select>


//               <div className="form-group-selection-arrow">
//                 
//               </div>

//               <div>
//                 {errors.status && (
//                   <span className="error-message font-size-text ">
//                     {errors.status}
//                   </span>
//                 )}
//               </div>
//             </div>

//             <div className="form-group">
//               <RenderSelectField
//                 title="Letter Type"
//                 disabled
//                 name="lettertype"
//                 required={true}
//                 options={[
//                   { value: "show-cause", label: "Show Cause" },
//                   { value: "informative", label: "Informative" },
//                   { value: "eot", label: "EOT" },
//                   { value: "cos", label: "COS" },
//                   { value: "billing", label: "Billing" },
//                   { value: "design", label: "Design" },
//                   { value: "ncr", label: "NCR" },

//                   { value: "Design & Drawing", label: "Design & Drawing" },
//                   { value: "P&P", label: "P&P" },
//                   { value: "QAP", label: "QAP" },
//                   { value: "Structure", label: "Structure" },
//                   { value: "Q & ME", label: "Q & ME" },
//                   { value: "BBS", label: "BBS" },
//                   { value: "noc", label: "NOC" },
//                   { value: "Road Safety", label: "Road Safety" },
//                   { value: "Work Plan", label: "Work Plan" },
//                   { value: "Drain", label: "Drain" },
//                   { value: "Hydrology", label: "Hydrology" },
//                   { value: "Survey", label: "Survey" },
//                   { value: "Milestone", label: "Milestone" },
//                   { value: "query", label: "Query" },
//                   { value: "SiteProgress", label: "SiteProgress" },
//                   { value: "other", label: "Others" }
//                 ]}
//                 placeholder="Select a Letter Type"
//                 formData={formData}
//                 errors={errors}
//                 inputState={inputState}
//                 handleInputChange={handleInputChange}
//                 readOnly
//               />
//               {errors.lettertype && (
//                 <div className="error-message col">{errors.lettertype}</div>
//               )}
//             </div>



//             {formData.letterExchange === 'receive' &&
//               <div className="form-group">
//                 <RenderInputField
//                   title="Letter From"
//                   name="letter_from"
//                   placeholder="Letter From"
//                   max={100}
//                   formData={formData}
//                   errors={errors}
//                   required={true}
//                   inputState={inputState}
//                   handleInputChange={handleInputChange}
//                 />
//                 {errors.letter_from && (
//                   <div className="error-message col">
//                     {errors.letter_from}
//                   </div>
//                 )}
//               </div>}

//             <div className="form-group">
//               <RenderInputField
//                 title="Letter To"
//                 name="letter_to"
//                 placeholder="Letter To"
//                 max={100}
//                 required={true}
//                 formData={formData}
//                 errors={errors}
//                 inputState={inputState}
//                 handleInputChange={handleInputChange}
//               />
//               {errors.letter_to && (
//                 <div className="error-message col">{errors.letter_to}</div>
//               )}
//             </div>
//             <div className="form-group">
//               <RenderInputTextareaField
//                 title="Remarks"
//                 name="remarks"
//                 placeholder="Remarks"
//                 rows={5}
//                 cols={50}
//                 formData={formData}
//                 required={true}
//                 errors={errors}
//                 inputState={inputState}
//                 handleInputChange={handleInputChange}
//               />
//               {errors.remarks && (
//                 <div className="error-message col">{errors.remarks}</div>
//               )}
//             </div>

//             <div className="flex-column">
//               <label
//                 htmlFor="names"
//                 className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
//               >
//                 Associated Letters
//               </label>

//               {/* Select component to show and handle associated letters */}
//               <Select
//                 options={optionsList.map((e) => ({
//                   value: e.id,
//                   label: `${e.letter_num}`, // Display the letter number as label
//                 }))}
//                 isMulti
//                 onChange={handleChangecc}
//                 styles={{
//                   control: (provided) => ({
//                     ...provided,
//                     width: '33vw',
//                     height: '50px',
//                     borderRadius: '10px',
//                     border: '1px solid #e3e3e3',
//                     margin: '10px 0px 20px 0px',
//                     color: '#4a4a4a',
//                     backgroundColor: '#f7f8fa',
//                     padding: '0px 10px',
//                   }),
//                   placeholder: (provided) => ({
//                     ...provided,
//                     color: '#4a4a4a',
//                   }),
//                   menu: (provided) => ({
//                     ...provided,
//                     width: '33vw',
//                     borderRadius: '10px',
//                     marginTop: '0',
//                   }),
//                   singleValue: (provided) => ({
//                     ...provided,
//                     color: '#4a4a4a',
//                   }),
//                   input: (provided) => ({
//                     ...provided,
//                     color: '#4a4a4a',
//                   }),
//                 }}

//                 value={trackRecordList
//                   .filter((option) => formData.associated_letters.includes(option.id))
//                   .map((e) => ({
//                     value: e.id,
//                     label: `${e.letter_num}`, // Pre-selected values showing letter_num
//                   }))}
//               />

//             </div>

//             {formData.associated_letters &&
//               formData.associated_letters.length > 0 && (
//                 <RenderSelectField
//                   title="Update Status of Associated Letters"
//                   name="associated_letters_status"
//                   required={true}
//                   options={[
//                     { value: "pending", label: "pending" },
//                     { value: "close", label: "Close" },
//                   ]}
//                   placeholder="Select Status"
//                   formData={formData}
//                   errors={errors}
//                   inputState={inputState}
//                   handleInputChange={handleInputChange}
//                 />
//               )}
//           </div>

//           <>
//             <div className="jd-heading-outer heading-bg-color-white">
//               <div className="jd-heading-outer-flex">
//                 <h2 className="jd-heading-main font-weight600  font-size-heading">
//                   Documents{" "}
//                 </h2>
//                 <div>
//                   <button
//                     title="Add Documents"
//                     onClick={handleAddDocuments}
//                     className="upload-svg equal-hieg"
//                     style={{ float: "right" }}
//                   >
//                     <AddwithWhiteCircle /> Document
//                   </button>
//                   {/* <br /> */}
//                 </div>
//               </div>
//               <div>
//                 <div className="jd-heading-bottom-bold"></div>
//                 <div className="jd-heading-bottom-light"></div>
//               </div>
//             </div>

//             <div className="form-flex-wrap">
//               <table className="table-css">
//                 <thead>
//                   <tr className="custom-table-head-tr">
//                     <th className="align-left">S. No.</th>
//                     <th className="align-center">Name</th>
//                     <th className="align-center">File</th>
//                     <th className="align-right width-5vw">Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {i?.documents?.map((i, index) => (
//                     <React.Fragment key={index}>
//                       {/* <tr className="tr-border-bottom">
//                             <td colSpan="6"></td>
//                           </tr> */}
//                       <tr className="custom-table-head-td">
//                         <td className="align-left">{index + 1}</td>
//                         <td className="align-center">{i.document_name}</td>
//                         <td className="align-center">
//                           {i.document_file ? (
//                             // <a href={i.document_file} target="blank">
//                             //   View
//                             // </a>
//                             <a href={i.document_file} target="blank">
//                               <DocumentIcon />
//                             </a>
//                           ) : (
//                             "Document Not Attached"
//                           )}
//                         </td>

//                         <td className="align-right width-5vw ">
//                           <button
//                             className="model-delete-button"
//                             onClick={(e) =>
//                               handlePicDelete(e, i, getProjects)
//                             }
//                           >
//                             <DeleteDustbin />
//                           </button>
//                         </td>
//                       </tr>
//                     </React.Fragment>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//             <hr className="line" />

//             <div title="Documents" className="">
//               {/* <label className="form-labels font-weight500 font-size-subheading">Documents</label> */}
//               {formDataDoc?.documents?.map((doc, index) => (
//                 <div key={index} className="expense-req">
//                   <div className="flex-column field-cont-div">
//                     <label
//                       htmlFor={`document_name_${index}`}
//                       className="form-labels announce-date font-weight500 font-size-heading"
//                     >
//                       File Name
//                     </label>
//                     <input
//                       type="text"
//                       id={`document_name_${index}`}
//                       name={`document_name`}
//                       placeholder="Document Name"
//                       value={doc.document_name}
//                       onChange={(e) => handleDocInputChange(index, e)}
//                       className={`form-modal-input ${errors[`document_name_${index}`]
//                         ? "error"
//                         : inputState[`document_name`]
//                           ? "success"
//                           : ""
//                         }`}
//                     />
//                     {errors[`document_name_${index}`] && (
//                       <span className="error-message font-size-text">
//                         {errors[`document_name_${index}`]}
//                       </span>
//                     )}
//                   </div>

//                   <div className="flex-column field-cont-div">
//                     <label
//                       htmlFor=""
//                       className="form-labels announce-date font-weight500 font-size-heading"
//                     >
//                       Upload File
//                     </label>
//                     <label
//                       htmlFor={`document_file_${index}`}
//                       className={`form-inputss custom-file-upload ${errors[`document_file_${index}`]
//                         ? "error"
//                         : inputState[`document_file`]
//                           ? "success"
//                           : ""
//                         }`}
//                     >
//                       <div className={`align-center pdf-input  ${errors[`document_file_${index}`] ? 'error' : ''}`}>
//                         <Attachment />
//                       </div>
//                     </label>
//                     <input
//                       id={`document_file_${index}`}
//                       name={`document_file`}
//                       type="file"
//                       onChange={(e) => handleDocInputChange(index, e)}
//                       style={{ display: "none", position: "relative" }}
//                     />
//                     {fileNames[index] && (
//                       <p className="file-name align-center">
//                         {fileNames[index]}
//                       </p>
//                     )}

//                     {errors[`document_file_${index}`] && (
//                       <span className="error-message font-size-text">
//                         {errors[`document_file_${index}`]}
//                       </span>
//                     )}
//                   </div>

//                   {index === 0 ? null : (
//                     <button
//                       type="button"
//                       className="model-button-cancel"
//                       onClick={() => handleRemoveDocument(index)}
//                     >
//                       Remove
//                     </button>
//                   )}
//                 </div>
//               ))}
//             </div>
//           </>
//           <>
//             <div className="jd-heading-outer heading-bg-color-white">
//               <div className="jd-heading-outer-flex">
//                 <h2 className="jd-heading-main font-weight600  font-size-heading">
//                   Authority Transfer List{" "}
//                 </h2>
//                 <div>
//                   <AddAssignTO
//                     siteprcode={i.site_prcode}
//                     projectname={i.project_short_name}
//                     letterdate={i.letter_date}
//                     letterno={i.letter_num}
//                     subject={i.subject}
//                     letterId={i.id}



//                   />
//                   {/* <br /> */}
//                 </div>
//               </div>
//               <div>
//                 <div className="jd-heading-bottom-bold"></div>
//                 <div className="jd-heading-bottom-light"></div>
//               </div>
//             </div>

//             <div className="form-flex-wrap">
//               <table className="table-css">
//                 <thead>
//                   <tr className="custom-table-head-tr">
//                     <th className="align-left">S. No.</th>
//                     <th className="align-center">Name</th>
//                     <th className="align-center">File</th>
//                     <th className="align-right width-5vw">Action</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {i?.documents?.map((i, index) => (
//                     <React.Fragment key={index}>
//                       {/* <tr className="tr-border-bottom">
//                             <td colSpan="6"></td>
//                           </tr> */}
//                       <tr className="custom-table-head-td">
//                         <td className="align-left">{index + 1}</td>
//                         <td className="align-center">{i.document_name}</td>
//                         <td className="align-center">
//                           {i.document_file ? (
//                             <DocumentModel />
//                           ) : (
//                             "Document Not Attached"
//                           )}
//                         </td>

//                         <td className="align-right width-5vw ">
//                           <button
//                             className="model-delete-button"
//                             onClick={(e) =>
//                               handlePicDelete(e, i, getProjects)
//                             }
//                           >
//                             <DeleteDustbin />
//                           </button>
//                         </td>
//                       </tr>
//                     </React.Fragment>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//             <hr className="line" />
//             <div className="button-models">
//               <button
//                 onClick={handleFormSubmit}
//                 className="model-button   font-weight500    model-button-submit"
//                 disabled={loading}
//               >
//                 {/* //loading logic */}
//                 Update
//               </button>
//             </div>
//           </>
//           <ToastContainer
//             position="top-center"
//             autoClose={1000}
//             hideProgressBar={false}
//             newestOnTop={true}
//             closeOnClick
//             rtl={false}
//             pauseOnFocusLoss
//             draggable
//             pauseOnHover
//           />
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };


const UpdateTrackRecordDetails = ({
  i,
  title,
  getProjects,
  projectList,
  projectId,
  letterfor,
  letterType,
  contractorlist,
  contractor,
  projectName,
  siteCode,
  workperformedby,
  associatedletters,
  documents,
  letterData,
  LetterTypeOptions,
  subCompanyId

}) => {
  const [show, setShow] = useState(false);

  const [letterdata, setLetterdata] = useState([]);
  const today = new Date().toISOString().split("T")[0];
  const [uploadProgress, setUploadProgress] = useState(0);





  const is7DaysPassed =
    (new Date() - new Date(i.created_at)) / (1000 * 60 * 60 * 24) > 6;


  const handleClose = () => {
    setShow(false);
    setFileNames([]);
    setErrors("");
    setFormDataDoc({
      documents: [
        {
          document_name: "",
          document_file: "",
        },
      ],
    })
  }



  const handleShow = () => {
    setFormData(i)
    setShow(true);
    getAsociatedLetters(i);
    getLettersingle();

  };
  const getLettersingle = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/getletterrecordanddoc/${i.id}/`
      );
      setLetterdata(res.data);

      setFormData(res.data)
    } catch (err) {
      // toast.error('Error fetching letters.');
      handleErrorToast(err);
    }
  };




  const [formData, setFormData] = useState({
    letter_num: "",
    project: projectId ? projectId : "",
    division: "59408e4e-a455-46b6-b3db-8deaa0ae4475",
    subject: "",
    letter_date: "",
    reply_by: "",
    status: "pending",
    workperformedby: workperformedby ? workperformedby : "",
    lettertype: letterType ? letterType : "",
    letterExchange: "",
    letter_from: "",
    letterdepartment: "",
    tat_duration: 0,
    end_date: null,
    other_letter_from: "",
    other_letter_to: "",
    letter_to: "",
    associated_letters: associatedletters ? [associatedletters] : [],
    associated_letters_status: "",
    documents: [
      {
        document_name: "",
        document_file: "",
      },
    ],
    other_type_name: '',
    is_timebound: false,
  });



  const [formDataDoc, setFormDataDoc] = useState({
    documents: [
      // {
      //   document_name: "",
      //   document_file: "",
      // },
    ],
  });




  // console.log(i)


  console.log("formdataenddate")
  console.log(formData)


  function addDaysToLetterDate(letterDate, daysToAdd) {
    const date = new Date(letterDate);
    date.setDate(date.getDate() + daysToAdd);

    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      select: "",
      is_timebound: false,
    }));
  }, [formData.lettertype]);


  useEffect(() => {
    const letter_tat = letterData?.find(item => item?.letter_type_data?.name === formData?.lettertype);
    if (letter_tat) {
      setFormData((prev) => ({
        ...prev,
        tat_duration: Number(letter_tat.tat_duration),
        end_date: addDaysToLetterDate(formData.letter_date, letter_tat.tat_duration),
      }));
    }
  }, [formData.lettertype, formData.letter_date, letterData, formData.is_timebound]);



  useEffect(() => {
    if (formData.is_timebound === false) {
      setFormData((prev) => ({
        ...prev,
        end_date: null,
      }));
    }



  }, [formData.is_timebound])


  useEffect(() => {
    if (formData.tat_duration) {
      setFormData((prev) => ({
        ...prev,
        end_date: addDaysToLetterDate(
          formData.letter_date,
          Number(formData.tat_duration)
        ),
      }));
    }

  }, [formData.tat_duration, formData.letter_date]);




  const [trackRecordList, setTrackRecordList] = useState([]);
  const [optionsList, setoptionsList] = useState([]);
  const getAsociatedLetters = async (i) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/letterrecordbyfilters/${i.project
        }/${i.workperformedby}/${i.lettertype}/`
      );
      setTrackRecordList(res.data);
    } catch (err) {
      handleErrorToast(err);
    }
  };

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const requiredFields = [
      "letter_num",
      "project",
      "subject",
      "letter_date",
      "status",
      "lettertype",
      "workperformedby",
      'letterExchange',
    ];


    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    const newErrors = requiredFields.reduce((acc, field) => {
      if (
        !formData[field] ||
        (Array.isArray(formData[field]) && formData[field].length === 0)
      ) {
        acc[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
          } is required!`;
      }
      return acc;
    }, {});
    if ((formData.lettertype === "other") && (!formData.other_type_name || formData.other_type_name.trim() === "")) {
      newErrors["other_type_name"] = `Other Letter Name is required! `;
    }
    if ((formData.letterExchange === "send") && (!formData.letter_to || formData.letter_to.trim() === "")) {
      newErrors["letter_to"] = `Letter To is required! `;
    }
    if ((formData.letterExchange === "receive") && (!formData.letter_from || formData.letter_from.trim() === "")) {
      newErrors["letter_from"] = `Letter From is required! `;
    }
    if (((formData.letter_from === "other") && (formData.letterExchange === "receive")) && (!formData.other_letter_from || formData.other_letter_from.trim() === "")) {
      newErrors["other_letter_from"] = `Other Letter From is required!`;
    }
    if (((formData.letter_to === "other") && (formData.letterExchange === "send")) && (!formData.other_letter_to || formData.other_letter_to.trim() === "")) {
      newErrors["other_letter_to"] = `Other Letter To is required!`;
    }






    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked, options } = e.target;

    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else if (type === "select-multiple") {
      newValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else {
      newValue = value;
    }

    if (name === "letter_date") {
      const selectedDate = new Date(value);
      const todayDate = new Date();

      todayDate.setHours(0, 0, 0, 0);
      selectedDate.setHours(0, 0, 0, 0);

      if (selectedDate > todayDate) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "Date cannot be greater than today.",
        }));
        return; // stop updating invalid value
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          [name]: "",
        }));
      }
    }

    // === Word limit for other_type_name ===
    if (name === "other_type_name") {
      const charCount = value.trim().length;

      if (charCount > 15) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          other_type_name: "Maximum 15 characters allowed.",
        }));
        return;
      } else {
        setErrors((prevErrors) => ({
          ...prevErrors,
          other_type_name: "",
        }));
      }
    }


    // === Update input state for validation feedback ===
    setInputState((prevState) => ({
      ...prevState,
      [name]:
        newValue && (Array.isArray(newValue) ? newValue.length > 0 : newValue)
          ? "success"
          : "",
    }));

    // === Update form data with additional logic ===
    setFormData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: newValue,

        ...(name === "reply_by" &&
          prevFormData.letterExchange === "send" && {
          letter_from: value,
        }),

        ...(name === "workperformedby" &&
          value === "consultant" && {
          contractor: "",
        }),
      };

      return updatedFormData;
    });
  };




  console.log("errors")
  console.log(errors)


  // ?  ************** Validation End **************  ! //

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        const formDataToSend = new FormData();

        Object.keys(formData).forEach((key) => {
          if (key !== "documents" && formData[key]) {
            if (key === "associated_letters") {
              formDataToSend.append(key, JSON.stringify(formData[key]));
            } else {
              formDataToSend.append(key, formData[key]);
            }
          }
        });


        let fileIndex = 0;
        for (let doc of formDataDoc.documents) {
          if (doc.document_file) {
            const fileId = await uploadFileInChunks(doc.document_file, doc.document_name, setUploadProgress);
            if (!fileId) {
              console.error(`❌ Failed to upload file: ${doc.document_name}`);
              continue;
            }
            console.log(doc, "documents")
            formDataToSend.append("file_ids", fileId);
            const renamedFile = new File([doc.document_file], doc.document_file.name, { type: doc.document_file.type });
            formDataToSend.append(`documents[${fileIndex}][file]`, renamedFile);
            formDataToSend.append(`documents[${fileIndex}][document_name]`, doc.document_name);


            formDataToSend.append(`documents[${fileIndex}][original_filename]`, doc.document_file.name);
            formDataToSend.append(`documents[${fileIndex}][file]`, doc.document_file);

            fileIndex++;

          }
        }




        let res = await axios.put(
          `${BASE_URL}/siteproject/documentbulkwithletterupdate/${formData.id}/`,
          formDataToSend,
          {
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress(percentCompleted);
            },
          }
        );

        if (res.status === 200) {
          await getProjects();
          handleClose();
        } else {
          alert("Failed to update the record.");
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
        setUploadProgress(0);

      }
    }
  };


  const [fileNames, setFileNames] = useState([]);



  const handleContractorInputChange = (selectedOption) => {

    if (!selectedOption) {
      if (formData.letterExchange === "receive") {
        setFormData({
          ...formData,
          letter_from: "",
        })
      }
      else if (formData.letterExchange === "send") {
        setFormData({
          ...formData,
          letter_to: ""
        })
      }

    } else {
      if (formData.letterExchange === "receive") {

        setFormData({
          ...formData,
          letter_from: selectedOption.value,
          letter_to: "",
        })

      }
      else if (formData.letterExchange === "send") {

        setFormData({
          ...formData,
          letter_to: selectedOption.value,
          letter_from: "",
        })

      }
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.project;
      return updatedErrors;
    });
  }

  const handleRemoveDocument = (index) => {
    setFormDataDoc((prevFormData) => {
      const newDocuments = [...prevFormData.documents];
      newDocuments.splice(index, 1);
      return {
        ...prevFormData,
        documents: newDocuments,
      };
    });
    setFileNames((prevFileNames) => {
      const newFileNames = [...prevFileNames];
      newFileNames.splice(index, 1);
      return newFileNames;
    });
  };

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      is_timebound: false,
    }))
  }, [formData.lettertype])

  const handlePicDelete = async (e, i, getProjects) => {
    e.preventDefault();

    setLoading(true); // loading logic
    const loadingToastId = toast.loading("Loading: Please wait..."); // toast logic

    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/documents/${i.id}/`
      );

      if (res.status === 200) {
        await getProjects();
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setLoading(false); // loading logic
      toast.dismiss(loadingToastId);
    }
  };

  const trackrecordfilter = trackRecordList?.filter(i => i.letter_date < formData.letter_date);

  const recordpendingLetters = trackrecordfilter?.filter(i => i.status === "pending")

  const options = recordpendingLetters
    .sort((a, b) => parseInt(a.letter_num) - parseInt(b.letter_num))
    .map((e) => ({
      value: e.id,
      label: `${e.letter_num} - ${e.letter_date}`,
    }));


  const [letterDataa, setLetterDataa] = useState([])

  const getLetterDataaa = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/letterrecordbyID/${i.id}/`)
      setLetterDataa(res.data);
    } catch (error) {

    }
  }
  const getSelectedAssociatedLetters = () => {
    if (!formData.associated_letters) return [];

    // Always match from FULL list, not filtered pending list
    const selectedArray = Array.isArray(formData.associated_letters)
      ? formData.associated_letters
      : [formData.associated_letters];

    return selectedArray
      .map((id) =>
        trackRecordList.find((item) => item.id === id)
      )
      .filter(Boolean)
      .map((item) => ({
        value: item.id,
        label: `${item.letter_num} - ${item.letter_date} (${item.status})`,
      }));
  };

  useEffect(() => {
    if (show === true) {
      getLetterDataaa();
    }
  }, [show]);

  const handleChangecc = (selected) => {
    const associated_letters =
      selected.length > 0 ? selected.map((item) => item.value) : "";
    setFormData((prevState) => ({
      ...prevState,
      associated_letters,
    }));
  };

  // *******************************Letter Type And Division Functionality*****************************//


  const handleLetterTypeOption = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        lettertype: "",
      })

    } else {
      setFormData({
        ...formData,
        lettertype: selectedOption.value,
      })
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.lettertype;
      return updatedErrors;
    });

  }

  const [contractorlists, setContractorLists] = useState([]);

  const getProjectContractorDetails = async () => {
    try {
      const contractordetails = await axios.get(
        `${BASE_URL}/siteproject/contractorbyproject/${formData.project}/null/`
      );
      setContractorLists(contractordetails.data);
    } catch (err) {
      // handleErrorToast(err);
    } finally {
    }
  };

  useEffect(() => {
    if (formData.project !== "null" && show === true) {
      getProjectContractorDetails();
    }
  }, [formData.project, show]);


  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      other_letter_from: "",
      other_letter_to: "",
    }))
  }, [formData.letter_from, formData.letter_to]);

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      letter_from: "",
      letter_to: "",
    }))
  }, [formData.letterExchange])


  const ContractorListOption = contractorlists?.sort((a, b) => a.name.localeCompare(b.name)).map((i) => ({
    value: i.name,
    label: `${i.name}`
  }));

  const extendedLetterOptions = [
    ...ContractorListOption,
    { label: "Other", value: "other" },
  ];


  // **************************End of Functionality*************************//

  const errorText = formData.letterExchange === "send" ? errors.letter_to : errors.letter_from;

  const ProjectListOption = projectList
    ?.sort((a, b) => a.site_prcode.localeCompare(b.site_prcode))
    .map((i) => ({
      value: i.id,
      label: `${i.site_prcode} - ${i.project_short_name}`,
    }));

  const handleProjectChange = (selectedOption) => {
    if (!selectedOption) {
      setFormData({
        ...formData,
        project: "",
      });
    } else {
      setFormData({
        ...formData,
        project: selectedOption.value,
      });
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors.project;
      return updatedErrors;
    });
  };

  const isReadOnly = sessionStorage.getItem('sitemanagement_role') === "SiteManagement" && is7DaysPassed;



  const [lettertypeList, setlettertype] = useState([])

  useEffect(() => {
    if (formData.workperformedby === 'consultant') {
      const lettertypeOptionss = LetterTypeOptions.filter(i => i.work_performed_by === 'consultant' || i.work_performed_by === "For Both")
      setlettertype(lettertypeOptionss)
    }
    else if (formData.workperformedby === 'contractor') {
      const lettertypeOptionss = LetterTypeOptions.filter(i => i.work_performed_by === 'contractor' || i.work_performed_by === "For Both")
      setlettertype(lettertypeOptionss)

    }


  }, [formData.workperformedby, LetterTypeOptions])
  return (
    <>
      <button onClick={handleShow} className="model-edit-button" >
        <UpdatePencil />
      </button >

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header closeButton>
          <Modal.Title>{title ? title : "Update Track Details"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>

          <div className="form-flex-wrap">
            <div className="form-group">
              <label
                htmlFor="project"
                className="form-labels font-weight500 font-size-subheading"
              >
                Site Project <span className="required">{projectId !== "null" || isReadOnly ? "(Read-Only)" : "*"}</span>
              </label>

              <Select
                options={ProjectListOption}
                onChange={handleProjectChange}
                value={
                  formData.project === "null" || formData.project === undefined
                    ? null
                    : ProjectListOption?.find(
                      (option) => option.value === formData.project
                    )
                }
                placeholder={siteCode ? `${siteCode} - ${projectName}` : `${i.project_pr_code}-${i.project_short_name}`}
                isSearchable
                isClearable
                noOptionsMessage={() => "No other options"}
                styles={CSSForSelect}
                isDisabled={projectId !== "null" || isReadOnly ? true : false}
              />

              {errors.project && (
                <div className="error-message col">{errors.project}</div>
              )}
            </div>

            <div className="form-group">
              <RenderSelectField
                title="Letter Exchange"
                name="letterExchange"
                required={true}
                options={[
                  { value: "receive", label: "Received" },
                  { value: "send", label: "Send" },

                ]}
                placeholder="Select an Exchange Type"
                formData={formData}
                errors={errors}
                inputState={inputState}
                handleInputChange={handleInputChange}
                isReadOnly={isReadOnly}
                disabled={isReadOnly ? true : false}
              />
              {errors.letterExchange && (
                <div className="error-message col">
                  {errors.letterExchange}
                </div>
              )}
            </div>

            {formData.letterExchange === "send" && (
              <div className="form-group">
                <RenderSelectField
                  title="Reply By"
                  name="reply_by"
                  required={true}
                  options={[
                    { value: "HO", label: "Head Office" },
                    { value: "SO", label: "Site Office" },
                  ]}
                  placeholder="Select a Reply By"
                  formData={formData}
                  errors={errors}
                  inputState={inputState}
                  handleInputChange={handleInputChange}
                  isReadOnly={isReadOnly}
                  disabled={isReadOnly ? true : false}
                />
                {errors.reply_by && (
                  <div className="error-message col">{errors.reply_by}</div>
                )}
              </div>
            )}


            <div className="form-group">
              <RenderInputField
                title={`${formData.letterExchange === "null"
                  ? ""
                  : toTitleCase(formData.letterExchange)
                  } Letter Number`}
                name="letter_num"
                required={true}
                placeholder="Enter Letter Number"
                formData={formData}
                errors={errors}
                inputState={inputState}
                handleInputChange={handleInputChange}
                isReadOnly={isReadOnly}
                disabled={isReadOnly ? true : false}
              />

              {errors.letter_num && (
                <div className="error-message col">{errors.letter_num}</div>
              )}
            </div>
            {letterfor ? (
              <></>
            ) : (
              <div className="form-group">
                <RenderSelectField
                  title="Matter Related To"
                  name="workperformedby"
                  required={true}
                  options={[
                    ...(formData.project &&
                      ((Array.isArray(contractorlist) &&
                        contractorlist.length > 0) ||
                        (Array.isArray(contractorlists) &&
                          contractorlists.length > 0))
                      ? [{ value: "contractor", label: "Contractor" }]
                      : []),
                    { value: "consultant", label: "Consultant" },
                  ]}
                  placeholder="Select Option"
                  formData={formData}
                  errors={errors}
                  inputState={inputState}
                  handleInputChange={handleInputChange}

                />
                {errors.workperformedby && (
                  <div className="error-message col">
                    {errors.workperformedby}
                  </div>
                )}
              </div>
            )}
            {formData.workperformedby === "contractor" ? (
              <div className="form-group">
                <div
                  title=" Contractor Name"
                  className="flex-column form-group-selectt">
                  <label
                    htmlFor="project"
                    className="form-labels  font-weight500    font-size-subheading">
                    Contractor Name<span className="required">{isReadOnly ? "(Read-Only)" : "*"}</span>
                  </label>
                  <br />
                  <select
                    id="contractor"
                    name="contractor"
                    value={formData.contractor}
                    onChange={handleInputChange}
                    className={`form-input form-group-selection ${errors.contractor
                      ? "error"
                      : inputState.contractor
                        ? "success"
                        : ""
                      }`}>
                    <option value="">Select a Contractor</option>
                    {contractorlists
                      ?.sort((a, b) =>
                        a.name?.localeCompare(b.name, "en", {
                          ignorePunctuation: true,
                        })
                      )
                      .map((i, index) => (
                        <>
                          <option value={i.id}>{i.name}</option>
                        </>
                      ))}
                  </select>
                </div>

                {errors.contractor && (
                  <div className="error-message col">{errors.contractor}</div>
                )}
              </div>
            ) : (
              ""
            )}

            <div className="form-group">
              <RenderInputField
                title={`${toTitleCase(formData.letterExchange)} Letter Date`}
                name="letter_date"
                type="date"
                isReadOnly={isReadOnly}
                disabled={isReadOnly ? true : false}
                max={today}
                formData={formData}
                errors={errors}
                required={true}
                inputState={inputState}
                handleInputChange={handleInputChange}
              />
              {errors.letter_date && (
                <div className="error-message col">{errors.letter_date}</div>
              )}
            </div>
            <div className="form-group">
              <label htmlFor={formData.letterExchange === "receive" ? "letter_from" : "letter_to"} className="form-labels  font-weight500    font-size-subheading">Letter {formData.letterExchange === "send" ? "To" : "From"} <span className="required">{isReadOnly ? "(Read-Only)" : "*"}</span></label>
              <Select
                options={extendedLetterOptions}
                onChange={handleContractorInputChange}
                value={
                  formData.letterExchange === 'receive'
                    ? formData.letter_from === "null" || !formData.letter_from
                      ? null
                      : extendedLetterOptions.find(option => option.value === formData.letter_from)
                    : formData.letter_to === "null" || !formData.letter_to
                      ? null
                      : extendedLetterOptions.find(option => option.value === formData.letter_to)
                }
                placeholder={formData.letterExchange === "send" ? "Select Letter To" : "Select Letter From"}
                isSearchable
                isClearable
                isDisabled={isReadOnly ? true : false}
                noOptionsMessage={() => "No other options"}
                styles={CSSForSelect}
              />

              {errorText && (
                <div className="error-message col required">
                  <span className="required">{errorText}</span>
                </div>
              )}
            </div>
            {formData.letterExchange === 'receive' && formData.letter_from === "other" ?
              <div className="flex-column">
                <label className="form-labels">Other Letter From <span className="required">{isReadOnly ? "(Read-Only)" : "*"}</span></label>
                <input
                  type="text"
                  name="other_letter_from"
                  placeholder='Enter Other Letter From'
                  value={formData.other_letter_from}
                  onChange={handleInputChange}
                  disabled={isReadOnly ? true : false}
                  className={`form-input input-form ${errors.other_letter_from ? 'error' : inputState.other_letter_from ? 'success' : ''}`}
                />

                {errors.other_letter_from && (
                  <div style={{ color: 'red', marginTop: '4px' }}>
                    {errors.other_letter_from}
                  </div>
                )}


              </div> :
              formData.letterExchange === 'send' && formData.letter_to === "other" ?
                <div className="flex-column">
                  <label className="form-labels">Other Letter To <span className="required">{isReadOnly ? "(Read-Only)" : "*"}</span></label>
                  <input
                    type="text"
                    name="other_letter_to"
                    placeholder='Enter Other Letter To'
                    value={formData.other_letter_to}
                    disabled={isReadOnly ? true : false}
                    onChange={handleInputChange}
                    className={`form-input input-form ${errors.other_letter_to ? 'error' : inputState.other_letter_to ? 'success' : ''}`}
                  />

                  {errors.other_letter_to && (
                    <div style={{ color: 'red', marginTop: '4px' }}>
                      {errors.other_letter_to}
                    </div>
                  )}


                </div>
                : ""
            }

            <div className="form-group">
              <RenderInputField
                title="Subject"
                name="subject"
                placeholder="Write only the bold part in the subject of the letter...."
                rows={5}
                cols={50}
                formData={formData}
                required={true}
                errors={errors}
                inputState={inputState}
                handleInputChange={handleInputChange}
                isReadOnly={isReadOnly}
                disabled={isReadOnly ? true : false}
              />
              {errors.subject && (
                <div className="error-message col">{errors.subject}</div>
              )}
            </div>
            <div title="Status" className="flex-column form-group-selectt">
              <label
                htmlFor="status"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Status<span className="required">{isReadOnly ? "(Read-Only)" : "*"}</span>
              </label>
              <br />
              <select
                id="status"
                name="status"
                placeholder="Status"
                value={formData.status}
                disabled={isReadOnly ? true : false}

                onChange={handleInputChange}
                className={`form-input form-group-selection ${errors.status ? "error" : inputState.status ? "success" : ""
                  }`}

              >
                <option value="">Select a Status</option>
                <option value="pending">Pending</option>


                <option value="close">Close</option>

              </select>


              <div className="form-group-selection-arrow">

              </div>

              <div>
                {errors.status && (
                  <span className="error-message font-size-text ">
                    {errors.status}
                  </span>
                )}
              </div>
            </div>



            {formData.division !== "null" &&
              <div className="form-group">
                <div className="flex-column">
                  <div className="flex-row justify-between" style={{ height: "25px" }}>
                    <label htmlFor="lettertype" className='form-labels font-weight500 font-size-subheading'>Select LetterType <span className='required'>*</span></label>
                    {
                      formData.lettertype &&
                      <div className="checkbox-wrapper">
                        <label className="custom-checkbox  font-weight500 font-size-subheading">
                          <input
                            type="checkbox"
                            name="is_timebound"
                            checked={formData.is_timebound || false}
                            onChange={handleInputChange}
                          />
                          <span className="checkmark"></span>
                          Time Bound

                        </label>
                      </div>

                    }
                  </div>
                  <Select
                    options={lettertypeList}
                    onChange={handleLetterTypeOption}
                    value={
                      formData?.lettertype === "null" || formData?.lettertype === undefined
                        ? "null"
                        : lettertypeList?.find(option => option.value === formData.lettertype)
                    }
                    placeholder="Select Letter-Type"
                    isSearchable
                    isClearable
                    noOptionsMessage={() => "No other options"}
                    styles={CSSForSelect}
                  />

                </div>
                {errors.lettertype && (
                  <div className="error-message col">
                    {errors.lettertype}
                  </div>
                )}
              </div>

            }

            {formData.lettertype === "other" && <div className="flex-column">
              <label className="form-labels">Other Letter Type Name  <span className="required">* (only 15 Characters Allowed)</span></label>
              <input
                type="text"
                name="other_type_name"
                value={formData.other_type_name}
                onChange={handleInputChange}
                className={`form-input input-form ${errors.other_type_name ? 'error' : inputState.other_type_name ? 'success' : ''}`}
                placeholder="Use Short Form"
              />
              {errors.other_type_name && <span className="error-message">{errors.other_type_name}</span>}
            </div>}


            <div className="flex-column">
              <label className="form-labels">
                Tat Duration <span className="required">{formData.is_timebound === false ? "(Read-Only)" : "*"}</span>
              </label>
              <input
                type="text"
                name="tat_duration"
                placeholder='Enter Tat Duration'
                value={formData.tat_duration}
                disabled={formData.is_timebound === false}

                onChange={handleInputChange}
                className={`form-input input-form ${errors.tat_duration ? 'error' : inputState.tat_duration ? 'success' : ''}`}
              />

              {errors.tat_duration && (
                <div style={{ color: 'red', marginTop: '4px' }}>
                  {errors.tat_duration}
                </div>
              )}


            </div>

            <div className="form-group">
              <RenderInputTextareaField
                title="Remarks"
                name="remarks"
                placeholder="Write only 5 words"

                rows={5}
                cols={50}
                formData={formData}
                required={true}
                errors={errors}
                inputState={inputState}
                isReadOnly={isReadOnly}
                disabled={isReadOnly ? true : false}
                handleInputChange={handleInputChange}
              />
              {errors.remarks && (
                <div className="error-message col">{errors.remarks}</div>
              )}
            </div>

            <div className="flex-column">
              <label
                htmlFor="names"
                className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
              >
                Associated Letters<span className="required">{isReadOnly ? "(Read-Only)" : ""}</span>
              </label>

              {/* Select component to show and handle associated letters */}
              <Select
                options={options}
                isMulti
                onChange={handleChangecc}
                styles={{
                  control: (provided) => ({
                    ...provided,
                    width: '33vw',
                    height: '50px',
                    borderRadius: '10px',
                    border: '1px solid #e3e3e3',
                    margin: '10px 0px 20px 0px',
                    color: '#4a4a4a',
                    backgroundColor: '#f7f8fa',
                    padding: '0px 10px',
                  }),
                  placeholder: (provided) => ({
                    ...provided,
                    color: '#4a4a4a',
                  }),
                  menu: (provided) => ({
                    ...provided,
                    width: '33vw',
                    borderRadius: '10px',
                    marginTop: '0',
                  }),
                  singleValue: (provided) => ({
                    ...provided,
                    color: '#4a4a4a',
                  }),
                  input: (provided) => ({
                    ...provided,
                    color: '#4a4a4a',
                  }),
                }}
                isDisabled={isReadOnly ? true : false}


                value={getSelectedAssociatedLetters()}
              />

            </div>

            {formData.associated_letters &&
              formData.associated_letters.length > 0 && (
                <RenderSelectField
                  title="Update Status of Associated Letters"
                  name="associated_letters_status"
                  required={true}
                  options={[
                    { value: "pending", label: "Pending" },
                    { value: "close", label: "Close" },
                  ]}
                  placeholder="Select Status"
                  formData={formData}
                  errors={errors}
                  inputState={inputState}
                  handleInputChange={handleInputChange}
                  disabled={isReadOnly ? true : false}
                  isReadOnly={isReadOnly}

                />
              )}
          </div>


          <>
            <div className="jd-heading-outer heading-bg-color-white">
              <div className="jd-heading-outer-flex">
                <h2 className="jd-heading-main font-weight600  font-size-heading">
                  Authority Transfer List{" "}
                </h2>
                <div>
                  <AddAssignTO
                    siteprcode={i.site_prcode}
                    projectname={i.project_short_name}
                    letterdate={i.letter_date}
                    letterno={i.letter_num}
                    subject={i.subject}
                    letterId={i.id}
                    getData={getLettersingle}
                  />
                  {/* <br /> */}
                </div>
              </div>
              <div>
                <div className="jd-heading-bottom-bold"></div>
                <div className="jd-heading-bottom-light"></div>
              </div>
            </div>

            <div className="form-flex-wrap">
              <table className="table-css">
                <thead className='table-heading'>
                  <tr className="custom-table-head-tr">
                    <th className="table-heading-text text-lefttt">S. No.</th>
                    <th className="table-heading-text">Assigned Work</th>
                    <th className="table-heading-text">Assigned By</th>
                    <th className="table-heading-text">Assigned To</th>
                    <th className="table-heading-text">Your Work</th>
                    <th className="table-heading-text">Add/View Documents</th>
                    <th className="table-heading-text text-right">Work Assigned Date</th>
                  </tr>
                </thead>
                <tbody>
                  {letterdata.letter_tracking?.map((i, index) => (
                    <React.Fragment key={index}>
                      {/* <tr className="tr-border-bottom">
                            <td colSpan="6"></td>
                          </tr> */}
                      <tr className="custom-table-head-td">
                        <td className="table-body text-lefttt">{index + 1}</td>
                        <td className="table-body">{i.assiginee_remarks ? i.assiginee_remarks : "-"}</td>
                        <td className="table-body">{i.assigned_by_name ? i.assigned_by_name : "-"}</td>
                        <td className="table-body">{i.assigned_to_name ? i.assigned_to_name : "-"}</td>
                        <td className="table-body">{i.remarks ? i.remarks : "-"}</td>
                        <td className="text-left">
                          {i.documents && i.documents.length > 0 ? (
                            <td className="table-body ">
                              <div className="flex-row justify-center">
                                <DocumentModel letter_tracking={i.id} letterData={letterdata.letter_tracking} title={"Documents"} getDocument={getLettersingle} />
                              </div>
                            </td>
                          ) : (
                            "Document Not Attached"
                          )}

                        </td>
                        <td className="table-body text-right">
                          {new Date(i.created_at).toISOString().split('T')[0].split('-').reverse().join('/')}
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>

            </div>
            <hr className="line" />
            {uploadProgress > 0 && (
              <div className="progress-bar">
                <h6 className="uploading-percentage">Uploading {uploadProgress}%</h6>
                <div className="progress-bar-fill" style={{ width: `${uploadProgress}%` }}></div>

              </div>
            )}

            <div className="button-models">
              <button
                onClick={handleFormSubmit}
                className="model-button   font-weight500    model-button-submit"
                disabled={loading}
              >
                {/* //loading logic */}
                Update
              </button>
            </div>
          </>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal >
    </>
  );
};


const UpdateTrackRecordDetailwithIDonly = ({
  i,
  title,
  getProjects,
  projectList,
  projectId,
  letterType,
  workperformedby,
  associatedletters,
  letterData
}) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = async () => {
    setShow(true);
    setFormData(i);

    // Trigger the API calls when the modal is shown
    await getLettersByID();
    // await getAsociatedLetters();
  };

  const [formData, setFormData] = useState({
    letter_num: "",
    project: projectId ? projectId : "null",
    subject: "",
    letter_date: "",
    status: "",
    workperformedby: workperformedby ? workperformedby : "null",
    lettertype: letterType ? letterType : "null",
    letterExchange: "",
    letter_from: "",
    letter_to: "",
    remarks: '',
    associated_letters: associatedletters ? associatedletters : [],
    associated_letters_status: "pending",
    documents: [
      {
        document_name: null,
        document_file: "",
      },
    ],
  });
  const today = new Date().toISOString().split("T")[0]; // Get today's date in YYYY-MM-DD format




  const [formDataDoc, setFormDataDoc] = useState({
    documents: [
      {
        document_name: null,
        document_file: "",
      },
    ],
  });




  const getLettersByID = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/linked-letter-list/${i.id}/`
      );

      const filteredData = res.data.filter(item => item.id === i.id);
      if (filteredData.length > 0) {
        setFormData(prevState => ({
          ...prevState,
          ...filteredData[0], // Merge with existing state
        }));
      }

    } catch (err) {
      handleErrorToast(err);
    }
  };


  const [trackRecordList, setTrackRecordList] = useState([]);
  const getAsociatedLetters = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/letterrecordbyfilters/${formData.project
        }/${formData.workperformedby}/${formData.lettertype
        }`
      );
      setTrackRecordList(res.data);
    } catch (err) {
      // toast.error('Error fetching letters.');
      handleErrorToast(err);
    }
  };

  // useEffect(() => {

  // }, [formData.workperformedby, formData.project]);

  // !  ************** Validation start **************  ! //

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const requiredFields = [
      // "letter_num",
      // "project",
      // "subject",
      // "letter_date",
      // "status",
      // "lettertype",
      // "workperformedby",
    ];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
          } is required !`;
      }
    });

    const newErrors = requiredFields.reduce((acc, field) => {
      if (
        !formData[field] ||
        (Array.isArray(formData[field]) && formData[field].length === 0)
      ) {
        acc[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
          } is required!`;
      }
      return acc;
    }, {});

    if (
      formData.associated_letters &&
      formData.associated_letters.length > 0 &&
      !formData.associated_letters_status
    ) {
      newErrors["associated_letters_status"] =
        "Status for associated letters is required!";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // const handleInputChange = (e) => {
  //   const {name, value} = e.target;

  //   setInputState({
  //     ...inputState,
  //     [name]: value.trim() ? "green" : "",
  //   });

  //   setFormData({
  //     ...formData,
  //     [name]: value,
  //   });
  // };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    // if (name === "lettertype") {
    //   if (value === "informative") {
    //     setFormData({
    //       ...formData,
    //       [name]: value,
    //       status: "informative",
    //     });
    //   } else if (value === "show-cause") {
    //     setFormData({
    //       ...formData,
    //       [name]: value,
    //       status: "show-cause",
    //     });
    //   } else {
    //     setFormData({
    //       ...formData,
    //       [name]: value,
    //     });
    //   }
    // } else {
    //   setFormData({
    //     ...formData,
    //     [name]: value,
    //   });
    // }
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const createCustomFile = (originalFile) => {
    const randomCode = generateRandomString();
    const now = new Date();
    const date = now.toISOString().split("T")[0];
    const time = now.toTimeString().split(" ")[0].replace(/:/g, "-");
    const customFileName = `Aimantra ${date} ${time}_${randomCode}_${originalFile.name}`;
    return new File([originalFile], customFileName, {
      type: originalFile.type,
    });
  };

  const generateRandomString = () => {
    const chars =
      "!@#$%^&*()_+abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    return Array.from(
      { length: 8 },
      () => chars[Math.floor(Math.random() * chars.length)]
    ).join("");
  };



  // ?  ************** Validation End **************  ! //

  const [loading, setLoading] = useState(false); //loading logic
  const handleFormSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

      try {
        const formDataToSend = new FormData();

        // Append general form fields
        Object.keys(formData).forEach((key) => {
          if (key !== "documents" && formData[key]) {
            if (key === "associated_letters") {
              formData[key].forEach((value) =>
                formDataToSend.append(key, value)
              );
            } else {
              formDataToSend.append(key, formData[key]);
            }
          }
        });

        // Append documents data
        formDataDoc.documents.forEach((doc, index) => {
          const symbols = "!@#$%^&*()_-+=";
          const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
          const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
          const numbers = "0123456789";
          const now = new Date();
          const date = now.toLocaleDateString("en-GB").split("/").reverse().join("-");
          const time = now.toLocaleTimeString("en-GB", { hour12: false }).replace(/:/g, "-");
          const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
          let randomCode = "";

          // Generate random code for unique filename
          for (let i = 0; i < 8; i++) {
            const randomIndex = Math.floor(Math.random() * allChars.length);
            randomCode += allChars[randomIndex];
          }

          const originalFile = doc.document_file;
          const customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
          const customFile = new File([originalFile], customFileName, {
            type: originalFile.type,
          });

          // Check if the document has a valid file before appending
          if (doc.document_file) {
            formDataToSend.append(`documents[${index}][document_name]`, doc.document_name);
            formDataToSend.append(`documents[${index}][document_file]`, customFile);
          } else {
            console.warn(`Document file at index ${index} is not valid.`);
          }
        });
        let res = await axios.put(
          `${BASE_URL}/siteproject/documentbulkwithletterupdate/${i.id}/`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (res.status === 200) {
          setShow(false);
          await getProjects();
        } else {
          alert(res);
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  const [fileNames, setFileNames] = useState([]);

  const handleDocInputChange = (index, e) => {
    const { name, value, type, files } = e.target;

    setFormDataDoc((prevFormData) => {
      const newDocuments = [...prevFormData.documents];
      if (type === "file") {
        newDocuments[index] = {
          ...newDocuments[index],
          [name]: files[0],
        };
        setFileNames((prevFileNames) => {
          const newFileNames = [...prevFileNames];
          newFileNames[index] = files[0]?.name;
          return newFileNames;
        });
      } else {
        newDocuments[index] = {
          ...newDocuments[index],
          [name]: value.trim() ? value : "",
        };
      }
      return {
        ...prevFormData,
        documents: newDocuments,
      };
    });
  };

  const handleAddDocuments = (e) => {
    e.preventDefault();
    setFormDataDoc((prevFormData) => ({
      ...prevFormData,
      documents: [
        ...prevFormData.documents,
        {
          document_name: "",
          document_file: null,
        },
      ],
    }));
  };

  const handleRemoveDocument = (index) => {
    setFormDataDoc((prevFormData) => {
      const newDocuments = [...prevFormData.documents];
      newDocuments.splice(index, 1);
      return {
        ...prevFormData,
        documents: newDocuments,
      };
    });
    setFileNames((prevFileNames) => {
      const newFileNames = [...prevFileNames];
      newFileNames.splice(index, 1);
      return newFileNames;
    });
  };

  const handlePicDelete = async (e, i, getProjects) => {
    e.preventDefault();

    setLoading(true); // loading logic
    const loadingToastId = toast.loading("Loading: Please wait..."); // toast logic

    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/documents/${i.id}/`
      );

      if (res.status === 200) {
        await getProjects();
      } else {
        alert(res);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setLoading(false); // loading logic
      toast.dismiss(loadingToastId);
    }
  };

  const options = trackRecordList
    .sort((a, b) => parseInt(a.letter_num) - parseInt(b.letter_num))
    .map((e) => ({
      value: e.id,
      label: `${e.letter_num} - ${e.letter_date}`,
    }));






  const handleChangecc = (selected) => {
    const associated_letters =
      selected.length > 0 ? selected.map((item) => item.value) : "";
    setFormData((prevState) => ({
      ...prevState,
      associated_letters,
    }));
  };

  // ? Document End ===============================

  useEffect(() => {
    getAsociatedLetters();
  }, [formData.project, formData.workperformedby, formData.lettertype]);

  return (
    <>
      <button onClick={handleShow} className="document-download-button  width-5vw  " style={{ margin: "0px", height: "30px" }}>
        View
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header closeButton>
          <Modal.Title>{title ? title : letterData ? "View Associated Letter Details" : "Update Track Details"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>

          <div className="form-flex-wrap">
            <div title="letter ID" className="flex-column">
              <label
                htmlFor="letter_num"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Letter No.<span className="required">*</span>
              </label>
              <input
                type="text"
                id="letter_num"
                name="letter_num"
                placeholder="Letter Number"
                onChange={handleInputChange}
                value={formData.letter_num}
                className={`form-input ${errors.letter_num
                  ? "error"
                  : inputState.letter_num
                    ? "success"
                    : ""
                  }`}
                disabled={letterData}
              />
              {errors.letter_num && (
                <span className="error-message font-size-text ">
                  {errors.letter_num}
                </span>
              )}
            </div>

            <div title="Subject" className="flex-column">
              <label
                htmlFor="subject"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Subject<span className="required">*</span>
              </label>
              <input
                type="text"
                id="subject"
                max={150}
                name="subject"
                placeholder="Subject"
                onChange={handleInputChange}
                value={formData.subject}
                disabled={letterData}
                className={`form-input ${errors.subject
                  ? "error"
                  : inputState.subject
                    ? "success"
                    : ""
                  }`}
              />
              {errors.subject && (
                <span className="error-message font-size-text ">
                  {errors.subject}
                </span>
              )}
            </div>

            <div title="Letter Date" className="flex-column">
              <label
                htmlFor="letter_date"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Letter Date<span className="required">*</span>
              </label>
              <input
                type="date"
                id="letter_date"
                name="letter_date"
                max={today}
                placeholder="Sent Letter Date"
                onChange={handleInputChange}
                value={formData.letter_date}
                disabled={letterData}
                className={`form-input ${errors.letter_date
                  ? "error"
                  : inputState.letter_date
                    ? "success"
                    : ""
                  }`}
              />
              {errors.letter_date && (
                <span className="error-message font-size-text ">
                  {errors.letter_date}
                </span>
              )}
            </div>

            <div
              title="Letter Type"
              className="flex-column form-group-selectt"
            >
              <label
                htmlFor="lettertype"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Letter Type<span className="required">*</span>
              </label>
              <br />
              <select
                id="lettertype"
                name="lettertype"
                placeholder="lettertype"
                value={formData.lettertype}
                onChange={handleInputChange}
                disabled
                className={`form-input form-group-selection ${errors.lettertype
                  ? "error"
                  : inputState.lettertype
                    ? "success"
                    : ""
                  }`}

              >
                <option value="null">Select Letter Type</option>
                <option value="eot">EOT</option>
                <option value="cos">COS</option>
                <option value="ncr">NCR</option>
                <option value="billing">Billing</option>
                <option value="design">Design</option>
                <option value="informative">Informative</option>
                <option value="show-cause">Show Cause</option>
                <option value="Design & Drawing">Design & Drawing</option>
                <option value="P&P">P&P</option>
                <option value="QAP">QAP</option>
                <option value="Structure">Structure</option>
                <option value="billing">Billing</option>
                <option value="Q & ME">Q & ME</option>
                <option value="BBS">BBS</option>
                <option value="noc">NOC</option>
                <option value="Road Safety">Road Safety</option>
                <option value="Work Plan">Work Plan</option>
                <option value="Drain">Drain</option>
                <option value="Hydrology">Hydrology</option>
                <option value="Survey">Survey</option>
                <option value="Milestone">Milestone</option>
                <option value="SiteProgress">SiteProgress</option>
                <option value="query">Query</option>
                <option value="other">Others</option>


              </select>
              <div className="form-group-selection-arrow">

              </div>
              <div>
                {errors.lettertype && (
                  <span className="error-message font-size-text ">
                    {errors.lettertype}
                  </span>
                )}
              </div>
            </div>

            <div title="Status" className="flex-column form-group-selectt">
              <label
                htmlFor="status"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Status<span className="required">*</span>
              </label>
              <br />
              <select
                id="status"
                name="status"
                placeholder="Status"
                disabled={letterData}
                value={formData.status}
                onChange={handleInputChange}
                className={`form-input form-group-selection ${errors.status ? "error" : inputState.status ? "success" : ""
                  }`}

              >
                <option value="">Select a Status</option>
                <option value="pending">Pending</option>


                <option value="close">Close</option>

              </select>


              <div className="form-group-selection-arrow">

              </div>

              <div>
                {errors.status && (
                  <span className="error-message font-size-text ">
                    {errors.status}
                  </span>
                )}
              </div>
            </div>


            <div
              title="Letter Exchange"
              className="flex-column form-group-selectt"
            >
              <label className="form-labels font-weight500 font-size-subheading">
                Letter Exchange<span className="required">*</span>
              </label>
              <br />
              <select
                id="letterExchange"
                name="letterExchange"
                value={formData.letterExchange}
                disabled={letterData}
                onChange={handleInputChange}
                className={`form-input form-group-selection ${errors.letterExchange
                  ? "error"
                  : inputState.letterExchange
                    ? "success"
                    : ""
                  }`}
              >
                <option value="">Select Letter</option>
                <option value="send">Send</option>
                <option value="receive">Receive</option>
              </select>
              <div className="form-group-selection-arrow">

              </div>
              {errors.letterExchange && (
                <div className="error-message font-size-text">
                  {errors.letterExchange}
                </div>
              )}
            </div>

            <div title="Letter From" className="flex-column">
              <label
                htmlFor="letter_from"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Letter From<span className="required">*</span>
              </label>
              <input
                type="text"
                id="letter_from"
                max={100}
                name="letter_from"
                disabled={letterData}
                placeholder="Letter From"
                onChange={handleInputChange}
                value={formData.letter_from}
                className={`form-input ${errors.letter_from
                  ? "error"
                  : inputState.letter_from
                    ? "success"
                    : ""
                  }`}
              />
              {errors.letter_from && (
                <span className="error-message font-size-text ">
                  {errors.letter_from}
                </span>
              )}
            </div>
            <div title="Letter To" className="flex-column">
              <label
                htmlFor="letter_to"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Letter To<span className="required">*</span>
              </label>
              <input
                type="text"
                id="letter_to"
                max={100}
                name="letter_to"
                placeholder="Letter To"
                disabled={letterData}
                onChange={handleInputChange}
                value={formData.letter_to}
                className={`form-input ${errors.letter_to
                  ? "error"
                  : inputState.letter_to
                    ? "success"
                    : ""
                  }`}
              />
              {errors.letter_to && (
                <span className="error-message font-size-text required">
                  {errors.letter_to}
                </span>
              )}
            </div>
            {letterData ? "" :
              <>
                <div className="flex-column">
                  <label
                    htmlFor="names"
                    className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                  >
                    Associated Letters
                  </label>
                  <Select
                    options={options}
                    isMulti
                    onChange={handleChangecc}
                    styles={{
                      control: (provided) => ({
                        ...provided,
                        width: '33vw',
                        height: '50px',
                        borderRadius: '10px',
                        border: '1px solid #e3e3e3',
                        margin: '10px 0px 20px 0px',
                        color: '#4a4a4a',
                        backgroundColor: '#f7f8fa',
                        padding: '0px 10px',
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        color: '#4a4a4a',
                      }),
                      menu: (provided) => ({
                        ...provided,
                        width: '33vw',
                        borderRadius: '10px',
                        marginTop: '0',
                      }),
                      singleValue: (provided) => ({
                        ...provided,
                        color: '#4a4a4a',
                      }),
                      input: (provided) => ({
                        ...provided,
                        color: '#4a4a4a',
                      }),
                    }}
                  />
                  {errors.remarks && (
                    <span className="error-message font-size-text">
                      {errors.remarks}
                    </span>
                  )}
                </div>
                {formData.associated_letters &&
                  formData.associated_letters.length > 0 && (
                    <RenderSelectField
                      title="Update Status of Associated Letters"
                      name="associated_letters_status"
                      required={true}
                      options={[
                        { value: "pending", label: "Pending" },
                        { value: "close", label: "Close" },
                      ]}
                      placeholder="Select Status"
                      formData={formData}
                      errors={errors}
                      inputState={inputState}
                      handleInputChange={handleInputChange}
                    />
                  )}
              </>
            }
          </div>


          <>

            <div className="jd-heading-outer  heading-bg-color-white">
              <div className="jd-heading-outer-flex ">
                <h2 className="jd-heading-main font-weight600  font-size-heading">
                  Documents{" "}
                </h2>
                <div>

                  <button
                    title="Add Documents"
                    onClick={handleAddDocuments}
                    className="jd-heading-main font-weight600 -right-button"
                    style={{ float: "right", backgroundColor: "#2576bc", color: 'white', borderRadius: '8px', marginRight: '10px', padding: '8px' }}
                  >
                    <AddwithWhiteCircle /> Document
                  </button>

                  <br />
                </div>
              </div>
              <div>
                <div className="jd-heading-bottom-bold"></div>
                <div className="jd-heading-bottom-light"></div>
              </div>
            </div>

            <div className="form-flex-wrap">
              <table className="table-css">
                <thead>
                  <tr className="custom-table-head-tr">
                    <th className="align-left">S. No.</th>
                    <th className="align-center">Name</th>
                    <th className="align-center">File</th>

                    <th className="align-right width-5vw">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {formData?.documents?.map((i, index) => (
                    <React.Fragment key={index}>

                      <tr className="custom-table-head-td">
                        <td className="align-left">{index + 1}</td>
                        <td className="align-center">{i.document_name}</td>

                        <td className="align-center">
                          {i.document_file ? (

                            <a href={i.document_file} target="blank">
                              <DocumentIcon />
                            </a>
                          ) : (
                            "Document Not Attached"
                          )}
                        </td>

                        <td className="align-right width-5vw ">
                          <button
                            className="model-delete-button"
                            onClick={(e) =>
                              handlePicDelete(e, i, getProjects)
                            }
                          >
                            <DeleteDustbin />
                          </button>
                        </td>
                      </tr>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>
            </div>
            <hr className="line" />
            {!letterData &&
              <>
                <div title="Documents" className="">
                  {/* <label className="form-labels font-weight500 font-size-subheading">Documents</label> */}
                  {formDataDoc?.documents?.map((doc, index) => (
                    <div key={index} className="expense-req">
                      <div className="flex-column field-cont-div">
                        <label
                          htmlFor={`document_name_${index}`}
                          className="form-labels announce-date font-weight500 font-size-heading"
                        >
                          File Name
                        </label>
                        <input
                          type="text"
                          id={`document_name_${index}`}
                          name={`document_name`}
                          placeholder="Document Name"
                          value={doc.document_name}
                          onChange={(e) => handleDocInputChange(index, e)}
                          className={`form-modal-input ${errors[`document_name_${index}`]
                            ? "error"
                            : inputState[`document_name`]
                              ? "success"
                              : ""
                            }`}
                        />
                        {errors[`document_name_${index}`] && (
                          <span className="error-message font-size-text">
                            {errors[`document_name_${index}`]}
                          </span>
                        )}
                      </div>

                      <div className="flex-column field-cont-div">
                        <label
                          htmlFor=""
                          className="form-labels announce-date font-weight500 font-size-heading"
                        >
                          Upload File
                        </label>
                        <label
                          htmlFor={`document_file_${index}`}
                          className={`form-inputss custom-file-upload ${errors[`document_file_${index}`]
                            ? "error"
                            : inputState[`document_file`]
                              ? "success"
                              : ""
                            }`}
                        >
                          <div className={`align-center pdf-input  ${errors[`document_file_${index}`] ? 'error' : ''}`}>
                            <Attachment />
                          </div>
                        </label>
                        <input
                          id={`document_file_${index}`}
                          name={`document_file`}
                          type="file"
                          onChange={(e) => handleDocInputChange(index, e)}
                          style={{ display: "none", position: "relative" }}
                        />
                        {fileNames[index] && (
                          <p className="file-name align-center">
                            {fileNames[index]}
                          </p>
                        )}

                        {errors[`document_file_${index}`] && (
                          <span className="error-message font-size-text">
                            {errors[`document_file_${index}`]}
                          </span>
                        )}
                      </div>

                      {index === 0 ? null : (
                        <button
                          type="button"
                          className="model-button-cancel"
                          onClick={() => handleRemoveDocument(index)}
                        >
                          Remove
                        </button>
                      )}
                    </div>
                  ))}
                </div>

                <div className="button-models">
                  <button
                    onClick={handleFormSubmit}
                    className="model-button   font-weight500    model-button-submit"
                    disabled={loading}
                    type="submit"

                  >
                    {/* //loading logic */}
                    Update
                  </button>
                </div>
              </>
            }
          </>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>


      </Modal>
    </>
  );
};

const DeleteTrackAndLetterDetails = ({ i, getLetterDetail }) => {
  const [show, setshow] = useState(false);
  const handleClose = () => {
    setshow(false);
  };
  const handleShow = () => {
    setshow(true);
  };

  const handleDelete = async (e) => {
    e.preventDefault();
    try {
      const ress = await axios.delete(
        `${BASE_URL}/siteproject/letterrecord/${i.id}/`
      );
      if (ress.status === 200) {
        await getLetterDetail();
        setshow(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <DeleteDustbinbUTTON onclick={handleShow} />
      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Letter Records {i.letter_num}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete Letter Records {i.letter_num}
            <div className="button-models">
              <button
                className="model-button   font-weight500    model-button-cancel"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const Option = (props) => (
  <components.Option {...props}>

    <label title="Star" class="star">
      <input id="star-checkbox" checked={props.isSelected}
        onChange={() => null} className="checkbox" type="checkbox" />
      <div className="svg-container">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="svg-outline"
          viewBox="0 0 24 24"
        >
          <path
            d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5ZM12 4.75L14 9.33L18.7 9.75L15 13.07L16.18 17.75L12 15.16L7.82 17.75L9 13.07L5.3 9.75L10 9.33L12 4.75Z"
          ></path>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="svg-filled"
          viewBox="0 0 24 24"
        >
          <path
            d="M12 2.5L9.45 8.5L3 9.06L7.725 13.39L6.25 19.82L12 16.5L17.75 19.82L16.275 13.39L21 9.06L14.55 8.5L12 2.5Z"
          ></path>
        </svg>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="100"
          width="100"
          className="svg-celebrate"
        >
          <circle r="2" cy="50" cx="50" className="particle"></circle>
          <circle r="2" cy="50" cx="50" className="particle"></circle>
          <circle r="2" cy="50" cx="50" className="particle"></circle>
          <circle r="2" cy="50" cx="50" className="particle"></circle>
          <circle r="2" cy="50" cx="50" className="particle"></circle>
          <circle r="2" cy="50" cx="50" className="particle"></circle>
          <circle r="2" cy="50" cx="50" className="particle"></circle>
          <circle r="2" cy="50" cx="50" className="particle"></circle>
        </svg>
      </div>
    </label>
    {props.label}
  </components.Option>
);



const MenuList = (props) => {
  const { options, selectProps } = props;

  const filteredOptions = options.filter(
    (opt) => opt.label.toLowerCase() !== "other"
  );

  const selectedValues = selectProps.value?.map((i) => i.value) || [];
  const filteredValues = filteredOptions.map((i) => i.value);

  const isAllSelected = filteredValues.every((val) =>
    selectedValues.includes(val)
  );

  const handleToggle = () => {
    if (isAllSelected) {
      const preserveOther = selectProps.value?.filter(
        (i) => i.label.toLowerCase() === "other"
      ) || [];
      selectProps.onChange(preserveOther);
    } else {
      const preserveOther = selectProps.value?.filter(
        (i) => i.label.toLowerCase() === "other"
      ) || [];
      selectProps.onChange([...filteredOptions, ...preserveOther]);
    }
  };

  return (
    <components.MenuList {...props}>
      <button
        type="button"
        onClick={handleToggle}
        style={{
          width: "100%",
          padding: "6px 0",
          cursor: "pointer",
          fontWeight: "600",
          borderBottom: "1px solid #e3e3e3",
          background: "white"
        }}
      >
        {isAllSelected ? "Unselect All" : "Select All"}
      </button>

      {props.children}
    </components.MenuList>
  );
};



// ! *************** Sector Crud Models Start ***************

const AddCircular = ({ getSiteCirculars }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [activeSection, setActiveSection] = useState('details');
  const [tabValidationAttempted, setTabValidationAttempted] = useState({});

  const sections = [
    { id: 'details', label: 'Circular Details', icon: FileText },
    { id: 'content', label: 'Content', icon: List },
    { id: 'attachment', label: 'Attachment', icon: Paperclip },
  ];

  const emptyFormData = {
    title: "",
    file: "",
    description: "",
    publish_date: "",
    issue_by: "",
    related_to_department: [],
    remarks: "",
  };

  const [formData, setFormData] = useState({ ...emptyFormData });

  const handleShow = () => {
    setFormData({ ...emptyFormData });
    setActiveSection('details');
    setTabValidationAttempted({});
    setErrors({});
    setInputState({});
    setIsSubmitted(false);
    setShow(true);
  };

  const handleClose = (event) => {
    if (event) event.preventDefault();
    setShow(false);
    setFormData({ ...emptyFormData });
    setActiveSection('details');
    setTabValidationAttempted({});
    setErrors({});
    setInputState({});
  };

  // !  ************** Validation start **************  ! //
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const fieldLabels = {
    title: 'Circular Number',
    publish_date: 'Publish Date',
    issue_by: 'Issue By',
    description: 'Description',
    related_to_department: 'Related to Department',
    file: 'Attachment',
  };

  const getTabRequiredFields = (tabId) => {
    const map = {
      details: ['title', 'publish_date', 'issue_by'],
      content: ['description', 'related_to_department'],
      attachment: ['file'],
    };
    return map[tabId] || [];
  };

  const isFieldEmpty = (field, data = formData) => {
    const value = data[field];
    if (Array.isArray(value)) return value.length === 0;
    return value === null || value === undefined || (typeof value === 'string' && value.trim() === "");
  };

  const tabHasMissingFields = (tabId) => getTabRequiredFields(tabId).some((field) => isFieldEmpty(field));

  const validateCurrentTab = () => {
    const currentTab = activeSection;
    const fieldsToValidate = getTabRequiredFields(currentTab);
    const newErrors = {};

    fieldsToValidate.forEach((field) => {
      if (isFieldEmpty(field)) {
        newErrors[field] = `${fieldLabels[field] || field} is required!`;
      }
    });

    setErrors(prev => {
      const updated = { ...prev, ...newErrors };
      fieldsToValidate.forEach((field) => {
        if (!isFieldEmpty(field)) delete updated[field];
      });
      return updated;
    });

    setTabValidationAttempted(prev => ({ ...prev, [currentTab]: true }));

    return Object.keys(newErrors).length === 0;
  };

  const hasCurrentTabErrors = () => getTabRequiredFields(activeSection).some(field => errors[field]);

  const getCurrentTabErrorMessage = () => {
    const missingFields = getTabRequiredFields(activeSection)
      .filter(field => isFieldEmpty(field))
      .map(field => fieldLabels[field] || field);

    if (missingFields.length === 0 && !hasCurrentTabErrors()) return null;
    if (missingFields.length === 1) return `${missingFields[0]} is required to proceed`;
    if (missingFields.length > 1) {
      const tabLabel = sections.find(s => s.id === activeSection)?.label || activeSection;
      return `Please fill all required fields in ${tabLabel} before proceeding`;
    }
    return `Please fix the errors in this section before proceeding`;
  };

  const goToNextTab = () => {
    const currentIndex = sections.findIndex(s => s.id === activeSection);
    const nextTab = sections[currentIndex + 1]?.id;

    if (!validateCurrentTab()) {
      const formContainer = document.querySelector('.modern-modal-body');
      if (formContainer) formContainer.scrollTop = 0;
      return;
    }

    if (nextTab) setActiveSection(nextTab);
  };

  const goToPreviousTab = () => {
    const idx = sections.findIndex(s => s.id === activeSection);
    if (idx > 0) setActiveSection(sections[idx - 1].id);
  };

  const validateForm = () => {
    const newErrors = {};
    sections.forEach((section) => {
      getTabRequiredFields(section.id).forEach((field) => {
        if (isFieldEmpty(field)) {
          newErrors[field] = `${fieldLabels[field] || field} is required!`;
        }
      });
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));
    setInputState((prev) => ({ ...prev, [name]: value?.toString().trim() ? "green" : "" }));

    if (value?.toString().trim()) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };
  // ?  ************** Validation End **************  ! //

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setShowProgressModal(true);
      setLoading(true);
      setUploadProgress(0);

      const loadingToastId = toast.loading("Loading: Please wait...");

      const formDataa = new FormData();
      formDataa.append("title", formData.title);
      formDataa.append("description", formData.description);
      formDataa.append("publish_date", formData.publish_date);
      formDataa.append("related_to_department", JSON.stringify(formData.related_to_department));
      formDataa.append("issue_by", formData.issue_by);
      formDataa.append("remarks", formData.remarks);

      const symbols = "!@#$%^&*()_-+=";
      const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
      const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const numbers = "0123456789";
      const now = new Date();
      const date = now.toLocaleDateString("en-GB").split("/").reverse().join("-");
      const time = now.toLocaleTimeString("en-GB", { hour12: false }).replace(/:/g, "-");
      const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
      let randomCode = "";
      for (let idx = 0; idx < 8; idx++) {
        randomCode += allChars[Math.floor(Math.random() * allChars.length)];
      }
      const originalFile = formData.file;
      const customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
      const customFile = new File([originalFile], customFileName, { type: originalFile.type });
      formDataa.append("file", customFile);

      try {
        const res = await axios.post(
          `${BASE_URL}/siteproject/circularupload/`,
          formDataa,
          {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              setUploadProgress(percentCompleted);
            },
          }
        );

        if (res.status === 200) {
          await getSiteCirculars();
          toast.dismiss(loadingToastId);
          toast.success("Circular added successfully!");
          handleClose();
        } else {
          toast.dismiss(loadingToastId);
          toast.error("Failed to add circular!");
        }
      } catch (err) {
        setUploadProgress(0);
        handleErrorToast(err);
      } finally {
        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    } else {
      const firstErrorTab = sections.find(s => tabHasMissingFields(s.id))?.id;
      if (firstErrorTab) {
        setActiveSection(firstErrorTab);
        setTabValidationAttempted(prev => ({ ...prev, [firstErrorTab]: true }));
      }
    }
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];

    if (file) {
      const validFileTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];

      if (validFileTypes.includes(file.type)) {
        setFormData((prev) => ({ ...prev, [name]: file }));
        setInputState((prev) => ({ ...prev, [name]: "green" }));
        setErrors((prev) => {
          const updated = { ...prev };
          delete updated[name];
          return updated;
        });
      } else {
        setErrors((prev) => ({ ...prev, [name]: "Invalid file type. Please select a PDF or DOC file." }));
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: null }));
    }
  };

  const handleFileClear = (name) => {
    setFormData((prev) => ({ ...prev, [name]: null }));
    setInputState((prev) => ({ ...prev, [name]: "" }));
  };

  const extendedConsultantOptions = [
    { label: "SAPL", value: "SAPL" },
    { label: "CIPL", value: "CIPL" },
    { label: "MoRTH", value: "MoRTH" },
    { label: "NHAI", value: "NHAI" },
  ];

  const departmentOptions = [
    { label: "Accounts", value: "Accounts" },
    { label: "Administration", value: "Administration" },
    { label: "Auxiliary", value: "Auxiliary" },
    { label: "BD", value: "BD" },
    { label: "Contracts", value: "Contracts" },
    { label: "Environmental Engineer", value: "Environmental Engineer" },
    { label: "Equipment", value: "Equipment" },
    { label: "Highway", value: "Highway" },
    { label: "Humane Resource", value: "Humane Resource" },
    { label: "Intermittent", value: "Intermittent" },
    { label: "IT", value: "IT" },
    { label: "Lab", value: "Lab" },
    { label: "Management", value: "Management" },
    { label: "Project Co-ordination", value: "Project Co-ordination" },
    { label: "Quantity Survey", value: "Quantity Survey" },
    { label: "Road Safety", value: "Road Safety" },
    { label: "Structure", value: "Structure" },
    { label: "Support Staff", value: "Support Staff" },
  ];

  const renderDetailsSection = () => (
    <div className="form-section">
      <div className="section-title">
        <FileText size={18} />
        <h4>Circular Details</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><FileText size={14} /> Circular Number<span className="required">*</span></label>
          <input
            id="title"
            type="text"
            name="title"
            placeholder="Circular Number"
            onChange={handleInputChange}
            value={formData.title}
            className={errors.title ? "error" : inputState.title ? "success" : ""}
          />
          {errors.title && <span className="error-message">{errors.title}</span>}
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Publish Date<span className="required">*</span></label>
          <input
            id="date"
            type="date"
            name="publish_date"
            onChange={handleInputChange}
            value={formData.publish_date}
            className={errors.publish_date ? "error" : inputState.publish_date ? "success" : ""}
          />
          {errors.publish_date && <span className="error-message">{errors.publish_date}</span>}
        </div>

        <div className="form-field full-width">
          <label><User size={14} /> Issue By<span className="required">*</span></label>
          <Select
            options={extendedConsultantOptions}
            isSearchable
            isClearable
            placeholder="Select"
            value={extendedConsultantOptions.find((opt) => opt.value === formData.issue_by) || null}
            onChange={(selectedOption) => {
              setFormData((prev) => ({ ...prev, issue_by: selectedOption ? selectedOption.value : "" }));
              setInputState((prev) => ({ ...prev, issue_by: selectedOption ? "green" : "" }));
              setErrors((prev) => {
                const updated = { ...prev };
                if (selectedOption) delete updated.issue_by;
                return updated;
              });
            }}
            styles={CSSForSelectModern}
          />
          {errors.issue_by && <span className="error-message">{errors.issue_by}</span>}
        </div>
      </div>

      <div className="section-navigation-buttons nav-buttons-wrapper">
        {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
          <div className="tab-error-message">
            <AlertCircle size={14} />
            <span>{getCurrentTabErrorMessage()}</span>
          </div>
        )}
        {(!tabValidationAttempted[activeSection] || !hasCurrentTabErrors()) && <div></div>}
        <button type="button" className="btn-next" onClick={goToNextTab} disabled={tabHasMissingFields('details')}>
          Next: Content <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );

  const renderContentSection = () => (
    <div className="form-section">
      <div className="section-title">
        <List size={18} />
        <h4>Content</h4>
      </div>
      <div className="form-grid">
        <div className="form-field full-width">
          <label><FileText size={14} /> Description<span className="required">*</span></label>
          <textarea
            placeholder="Description"
            name="description"
            onChange={handleInputChange}
            value={formData.description}
            className={errors.description ? "error" : inputState.description ? "success" : ""}
          />
          {errors.description && <span className="error-message">{errors.description}</span>}
        </div>

        <div className="form-field full-width">
          <label><Building2 size={14} /> Related to Department<span className="required">*</span></label>
          <Select
            options={departmentOptions}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            placeholder="Select Department"
            onChange={(selected) => {
              const related_to_department = selected ? selected.map((item) => item.value) : [];
              setFormData((prev) => ({ ...prev, related_to_department }));
              setErrors((prev) => {
                const updated = { ...prev };
                if (related_to_department.length > 0) delete updated.related_to_department;
                return updated;
              });
            }}
            value={departmentOptions.filter((opt) => formData?.related_to_department?.includes(opt.value))}
            styles={CSSForSelectModern}
          />
          {errors.related_to_department && <span className="error-message">{errors.related_to_department}</span>}
        </div>

        <div className="form-field full-width">
          <label><FileText size={14} /> Remarks</label>
          <textarea
            placeholder="Remarks"
            name="remarks"
            onChange={handleInputChange}
            value={formData.remarks}
            className={errors.remarks ? "error" : inputState.remarks ? "success" : ""}
          />
          {errors.remarks && <span className="error-message">{errors.remarks}</span>}
        </div>
      </div>

      <div className="section-navigation-buttons dual-buttons">
        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous
          </button>
          {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
            <div className="tab-error-message">
              <AlertCircle size={14} />
              <span>{getCurrentTabErrorMessage()}</span>
            </div>
          )}
          <button type="button" className="btn-next" onClick={goToNextTab} disabled={tabHasMissingFields('content')}>
            Next: Attachment <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );

  const renderAttachmentSection = () => (
    <div className="form-section">
      <div className="section-title">
        <Paperclip size={18} />
        <h4>Attachment</h4>
      </div>
      <div className="form-grid">
        <div className="form-field full-width">
          <label><Paperclip size={14} /> Attachment<span className="required">*</span></label>
          <div className={`file-upload-container flex-row justify-between file-in-upload ${errors.file ? 'error' : inputState.file ? 'success' : ''}`}>
            <label style={{ cursor: 'pointer' }} htmlFor="file">
              <Attachment />
              <span style={{ marginLeft: "20px" }}>
                {formData.file ? formData.file.name : 'No file selected'}
              </span>
            </label>
            <input
              id="file"
              name="file"
              type="file"
              accept=".pdf,.doc,.docx,.xls,.xlsx"
              onChange={handleFileChange}
              style={{ display: "none", position: "relative" }}
            />
            {formData.file ? (
              <span className="file-clear" onClick={() => handleFileClear('file')}>
                Clear
              </span>
            ) : null}
          </div>
          {errors.file && <span className="error-message">{errors.file}</span>}
        </div>
      </div>

      <div className="form-actions">
        <button type="button" className="btn-prev" onClick={goToPreviousTab}>
          <ChevronRight size={16} className="rotate-left" /> Previous: Content
        </button>
        <div className="submit-buttons">
          <button type="button" className="btn-secondaryy" onClick={handleClose}>
            Cancel
          </button>
          <button type="submit" className="btn-primaryy" disabled={loading || tabHasMissingFields('details') || tabHasMissingFields('content')}>
            {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
            <span>{loading ? 'Adding...' : 'Add'}</span>
          </button>
        </div>
      </div>

      {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
        <div className="tab-error-message" style={{ marginTop: '12px' }}>
          <AlertCircle size={14} />
          <span>{getCurrentTabErrorMessage()}</span>
        </div>
      )}
    </div>
  );

  const renderCurrentSection = () => {
    switch (activeSection) {
      case 'details': return renderDetailsSection();
      case 'content': return renderContentSection();
      case 'attachment': return renderAttachmentSection();
      default: return renderDetailsSection();
    }
  };

  return (
    <div>

      <AddDynamicButton title="Add Circular" logo={<FileText size={24} />} onClick={handleShow} />

      {showProgressModal ? (
        <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" />
      ) : (
        <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
          <Modal.Header className="modern-modal-header">
            <div className="header-content">
              <div style={{ color: "white" }}>
                <FileText size={24} />
              </div>
              <div>
                <Modal.Title>Add Circular</Modal.Title>
                <p className="header-subtitle" style={{ color: "white" }}>Fill in the details to publish a new circular</p>
              </div>
            </div>
            <button className="close-btn" onClick={handleClose}>
              <X size={20} />
            </button>
          </Modal.Header>

          <Modal.Body className="modern-modal-body">
            <div className="section-navigation">
              {sections.map((section) => {
                const Icon = section.icon;
                const hasMissing = tabHasMissingFields(section.id);
                return (
                  <button
                    key={section.id}
                    className={`section-nav-btn ${activeSection === section.id ? 'active' : ''} ${hasMissing && section.id !== activeSection ? 'has-warning' : ''}`}
                    onClick={() => {
                      if (activeSection !== section.id) {
                        if (validateCurrentTab()) {
                          setActiveSection(section.id);
                        } else {
                          const formContainer = document.querySelector('.modern-modal-body');
                          if (formContainer) formContainer.scrollTop = 0;
                        }
                      }
                    }}
                  >
                    <Icon size={16} />
                    <span>{section.label}</span>
                    {hasMissing && section.id !== activeSection && (
                      <div className="warning-dot" title="Missing required fields" />
                    )}
                    {activeSection === section.id && <ChevronRight size={14} className="nav-arrow" />}
                  </button>
                );
              })}
            </div>

            <form onSubmit={handleSubmit} className="project-form">
              <div key={activeSection}>
                {renderCurrentSection()}
              </div>
            </form>

            <p className="error-message" style={{ marginTop: '12px' }}>
              {!isSubmitted && Object.keys(errors).length > 5 && (
                <span>Please fill all mandatory fields!</span>
              )}
            </p>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};
const UpdateCicular = ({ getSiteCirculars, i }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [activeSection, setActiveSection] = useState('details');
  const [tabValidationAttempted, setTabValidationAttempted] = useState({});

  const sections = [
    { id: 'details', label: 'Circular Details', icon: FileText },
    { id: 'content', label: 'Content', icon: List },
    { id: 'attachment', label: 'Attachment', icon: Paperclip },
  ];

  const buildFormDataFromI = () => {
    const filteredData = { ...i };
    delete filteredData.file;
    return {
      title: filteredData.title || "",
      file: "",
      description: filteredData.description || "",
      remarks: filteredData.remarks || "",
      publish_date: filteredData.publish_date || "",
      issue_by: filteredData.issue_by || "",
      related_to_department: filteredData.related_to_department || [],
    };
  };

  const [formData, setFormData] = useState(buildFormDataFromI());

  const handleShow = () => {
    setFormData(buildFormDataFromI());
    setActiveSection('details');
    setTabValidationAttempted({});
    setErrors({});
    setInputState({});
    setIsSubmitted(false);
    setShow(true);
  };

  const handleClose = (event) => {
    if (event) event.preventDefault();
    setShow(false);
    setFormData(buildFormDataFromI());
    setActiveSection('details');
    setTabValidationAttempted({});
    setErrors({});
    setInputState({});
  };

  // !  ************** Validation start **************  ! //
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const fieldLabels = {
    title: 'Circular Number',
    publish_date: 'Publish Date',
    issue_by: 'Issue By',
    description: 'Description',
    remarks: 'Remarks',
    related_to_department: 'Related to Department',
  };

  const getTabRequiredFields = (tabId) => {
    const map = {
      details: ['title', 'publish_date', 'issue_by'],
      content: ['description', 'related_to_department', 'remarks'],
      attachment: [],
    };
    return map[tabId] || [];
  };

  const isFieldEmpty = (field, data = formData) => {
    const value = data[field];
    if (Array.isArray(value)) return value.length === 0;
    return value === null || value === undefined || (typeof value === 'string' && value.trim() === "");
  };

  const tabHasMissingFields = (tabId) => getTabRequiredFields(tabId).some((field) => isFieldEmpty(field));

  const validateCurrentTab = () => {
    const currentTab = activeSection;
    const fieldsToValidate = getTabRequiredFields(currentTab);
    const newErrors = {};

    fieldsToValidate.forEach((field) => {
      if (isFieldEmpty(field)) {
        newErrors[field] = `${fieldLabels[field] || field} is required!`;
      }
    });

    setErrors(prev => {
      const updated = { ...prev, ...newErrors };
      fieldsToValidate.forEach((field) => {
        if (!isFieldEmpty(field)) delete updated[field];
      });
      return updated;
    });

    setTabValidationAttempted(prev => ({ ...prev, [currentTab]: true }));

    return Object.keys(newErrors).length === 0;
  };

  const hasCurrentTabErrors = () => getTabRequiredFields(activeSection).some(field => errors[field]);

  const getCurrentTabErrorMessage = () => {
    const missingFields = getTabRequiredFields(activeSection)
      .filter(field => isFieldEmpty(field))
      .map(field => fieldLabels[field] || field);

    if (missingFields.length === 0 && !hasCurrentTabErrors()) return null;
    if (missingFields.length === 1) return `${missingFields[0]} is required to proceed`;
    if (missingFields.length > 1) {
      const tabLabel = sections.find(s => s.id === activeSection)?.label || activeSection;
      return `Please fill all required fields in ${tabLabel} before proceeding`;
    }
    return `Please fix the errors in this section before proceeding`;
  };

  const goToNextTab = () => {
    const currentIndex = sections.findIndex(s => s.id === activeSection);
    const nextTab = sections[currentIndex + 1]?.id;

    if (!validateCurrentTab()) {
      const formContainer = document.querySelector('.modern-modal-body');
      if (formContainer) formContainer.scrollTop = 0;
      return;
    }

    if (nextTab) setActiveSection(nextTab);
  };

  const goToPreviousTab = () => {
    const idx = sections.findIndex(s => s.id === activeSection);
    if (idx > 0) setActiveSection(sections[idx - 1].id);
  };

  const validateForm = () => {
    const newErrors = {};
    sections.forEach((section) => {
      getTabRequiredFields(section.id).forEach((field) => {
        if (isFieldEmpty(field)) {
          newErrors[field] = `${fieldLabels[field] || field} is required!`;
        }
      });
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({ ...prev, [name]: value }));
    setInputState((prev) => ({ ...prev, [name]: value?.toString().trim() ? "green" : "" }));

    if (value?.toString().trim()) {
      setErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };
  // ?  ************** Validation End **************  ! //

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setShowProgressModal(true);
      setLoading(true);
      setUploadProgress(0);

      const loadingToastId = toast.loading("Loading: Please wait...");

      const formDataa = new FormData();
      formDataa.append("title", formData.title);
      formDataa.append("description", formData.description);
      formDataa.append("publish_date", formData.publish_date);
      formDataa.append("related_to_department", JSON.stringify(formData.related_to_department));
      formDataa.append("issue_by", formData.issue_by);
      formDataa.append("remarks", formData.remarks);

      if (formData.file instanceof File) {
        const originalFile = formData.file;
        const symbols = "!@#$%^&*()_-+=";
        const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
        const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const numbers = "0123456789";
        const now = new Date();
        const date = now.toLocaleDateString("en-GB").split("/").reverse().join("-");
        const time = now.toLocaleTimeString("en-GB", { hour12: false }).replace(/:/g, "-");
        const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
        let randomCode = "";
        for (let idx = 0; idx < 8; idx++) {
          randomCode += allChars[Math.floor(Math.random() * allChars.length)];
        }
        const customFileName = `Aimantra ${date} ${time}_${randomCode} ${originalFile.name}`;
        const customFile = new File([originalFile], customFileName, { type: originalFile.type });
        formDataa.append("file", customFile);
      }

      try {
        const res = await axios.put(
          `${BASE_URL}/siteproject/circularuploadupdate/${i.id}/`,
          formDataa,
          {
            headers: { "Content-Type": "multipart/form-data" },
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              setUploadProgress(percentCompleted);
            },
          }
        );

        if (res.status === 200) {
          await getSiteCirculars();
          toast.dismiss(loadingToastId);
          toast.success("Circular updated successfully!");
          handleClose();
        } else {
          toast.dismiss(loadingToastId);
          toast.error("Failed to update circular!");
        }
      } catch (err) {
        setUploadProgress(0);
        handleErrorToast(err);
      } finally {
        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    } else {
      const firstErrorTab = sections.find(s => tabHasMissingFields(s.id))?.id;
      if (firstErrorTab) {
        setActiveSection(firstErrorTab);
        setTabValidationAttempted(prev => ({ ...prev, [firstErrorTab]: true }));
      }
    }
  };

  const handleFileChange = (e) => {
    const { name } = e.target;
    const file = e.target.files[0];

    if (file) {
      const validFileTypes = [
        "application/pdf",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      ];

      if (validFileTypes.includes(file.type)) {
        setFormData((prev) => ({ ...prev, [name]: file }));
        setInputState((prev) => ({ ...prev, [name]: "green" }));
        setErrors((prev) => {
          const updated = { ...prev };
          delete updated[name];
          return updated;
        });
      } else {
        setErrors((prev) => ({ ...prev, [name]: "Invalid file type. Please select a PDF or DOC file." }));
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: null }));
    }
  };

  const handleFileClear = (name) => {
    setFormData((prev) => ({ ...prev, [name]: null }));
    setInputState((prev) => ({ ...prev, [name]: "" }));
  };

  const extendedConsultantOptions = [
    { label: "SAPL", value: "SAPL" },
    { label: "CIPL", value: "CIPL" },
    { label: "MoRTH", value: "MoRTH" },
    { label: "NHAI", value: "NHAI" },
  ];

  const departmentOptions = [
    { label: "Accounts", value: "Accounts" },
    { label: "Administration", value: "Administration" },
    { label: "Auxiliary", value: "Auxiliary" },
    { label: "BD", value: "BD" },
    { label: "Contracts", value: "Contracts" },
    { label: "Environmental Engineer", value: "Environmental Engineer" },
    { label: "Equipment", value: "Equipment" },
    { label: "Highway", value: "Highway" },
    { label: "Humane Resource", value: "Humane Resource" },
    { label: "Intermittent", value: "Intermittent" },
    { label: "IT", value: "IT" },
    { label: "Lab", value: "Lab" },
    { label: "Management", value: "Management" },
    { label: "Project Co-ordination", value: "Project Co-ordination" },
    { label: "Quantity Survey", value: "Quantity Survey" },
    { label: "Road Safety", value: "Road Safety" },
    { label: "Structure", value: "Structure" },
    { label: "Support Staff", value: "Support Staff" },
  ];

  const renderDetailsSection = () => (
    <div className="form-section">
      <div className="section-title">
        <FileText size={18} />
        <h4>Circular Details</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><FileText size={14} /> Circular Number<span className="required">*</span></label>
          <input
            id="title"
            type="text"
            name="title"
            placeholder="Circular Number"
            onChange={handleInputChange}
            value={formData.title}
            className={errors.title ? "error" : inputState.title ? "success" : ""}
          />
          {errors.title && <span className="error-message">{errors.title}</span>}
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Publish Date<span className="required">*</span></label>
          <input
            id="date"
            type="date"
            name="publish_date"
            onChange={handleInputChange}
            value={formData.publish_date}
            className={errors.publish_date ? "error" : inputState.publish_date ? "success" : ""}
          />
          {errors.publish_date && <span className="error-message">{errors.publish_date}</span>}
        </div>

        <div className="form-field full-width">
          <label><User size={14} /> Issue By<span className="required">*</span></label>
          <Select
            options={extendedConsultantOptions}
            isSearchable
            isClearable
            placeholder="Select"
            value={extendedConsultantOptions.find((opt) => opt.value === formData.issue_by) || null}
            onChange={(selectedOption) => {
              setFormData((prev) => ({ ...prev, issue_by: selectedOption ? selectedOption.value : "" }));
              setInputState((prev) => ({ ...prev, issue_by: selectedOption ? "green" : "" }));
              setErrors((prev) => {
                const updated = { ...prev };
                if (selectedOption) delete updated.issue_by;
                return updated;
              });
            }}
            styles={CSSForSelectModern}
          />
          {errors.issue_by && <span className="error-message">{errors.issue_by}</span>}
        </div>
      </div>

      <div className="section-navigation-buttons nav-buttons-wrapper">
        {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
          <div className="tab-error-message">
            <AlertCircle size={14} />
            <span>{getCurrentTabErrorMessage()}</span>
          </div>
        )}
        {(!tabValidationAttempted[activeSection] || !hasCurrentTabErrors()) && <div></div>}
        <button type="button" className="btn-next" onClick={goToNextTab} disabled={tabHasMissingFields('details')}>
          Next: Content <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );

  const renderContentSection = () => (
    <div className="form-section">
      <div className="section-title">
        <List size={18} />
        <h4>Content</h4>
      </div>
      <div className="form-grid">
        <div className="form-field full-width">
          <label><FileText size={14} /> Description<span className="required">*</span></label>
          <textarea
            placeholder="Description"
            name="description"
            onChange={handleInputChange}
            value={formData.description}
            className={errors.description ? "error" : inputState.description ? "success" : ""}
          />
          {errors.description && <span className="error-message">{errors.description}</span>}
        </div>

        <div className="form-field full-width">
          <label><Building2 size={14} /> Related to Department<span className="required">*</span></label>
          <Select
            options={departmentOptions}
            isMulti
            closeMenuOnSelect={false}
            hideSelectedOptions={false}
            placeholder="Select Department"
            onChange={(selected) => {
              const related_to_department = selected ? selected.map((item) => item.value) : [];
              setFormData((prev) => ({ ...prev, related_to_department }));
              setErrors((prev) => {
                const updated = { ...prev };
                if (related_to_department.length > 0) delete updated.related_to_department;
                return updated;
              });
            }}
            value={departmentOptions.filter((opt) => formData?.related_to_department?.includes(opt.value))}
            styles={CSSForSelectModern}
          />
          {errors.related_to_department && <span className="error-message">{errors.related_to_department}</span>}
        </div>

        <div className="form-field full-width">
          <label><FileText size={14} /> Remarks<span className="required">*</span></label>
          <textarea
            placeholder="Remarks"
            name="remarks"
            onChange={handleInputChange}
            value={formData.remarks}
            className={errors.remarks ? "error" : inputState.remarks ? "success" : ""}
          />
          {errors.remarks && <span className="error-message">{errors.remarks}</span>}
        </div>
      </div>

      <div className="section-navigation-buttons dual-buttons">
        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous
          </button>
          {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
            <div className="tab-error-message">
              <AlertCircle size={14} />
              <span>{getCurrentTabErrorMessage()}</span>
            </div>
          )}
          <button type="button" className="btn-next" onClick={goToNextTab} disabled={tabHasMissingFields('content')}>
            Next: Attachment <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );

  const renderAttachmentSection = () => (
    <div className="form-section">
      <div className="section-title">
        <Paperclip size={18} />
        <h4>Attachment</h4>
      </div>
      <div className="form-grid">
        <div className="form-field full-width">
          <label><Paperclip size={14} /> Attachment</label>
          <div className={`file-upload-container flex-row justify-between file-in-upload ${errors.file ? 'error' : inputState.file ? 'success' : ''}`}>
            <label style={{ cursor: 'pointer' }} htmlFor="file">
              <Attachment />
              <span style={{ marginLeft: "20px" }}>
                {formData.file ? formData.file.name : 'No file selected'}
              </span>
            </label>
            <input
              id="file"
              name="file"
              type="file"
              accept=".pdf,.doc,.docx,.xls,.xlsx"
              onChange={handleFileChange}
              style={{ display: "none", position: "relative" }}
            />
            {formData.file ? (
              <span className="file-clear" onClick={() => handleFileClear('file')}>
                Clear
              </span>
            ) : null}
          </div>
          {errors.file && <span className="error-message">{errors.file}</span>}
        </div>
      </div>

      <div className="form-actions">
        <button type="button" className="btn-prev" onClick={goToPreviousTab}>
          <ChevronRight size={16} className="rotate-left" /> Previous: Content
        </button>
        <div className="submit-buttons">
          <button type="button" className="btn-secondaryy" onClick={handleClose}>
            Cancel
          </button>
          <button type="submit" className="btn-primaryy" disabled={loading || tabHasMissingFields('details') || tabHasMissingFields('content')}>
            {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
            <span>{loading ? 'Updating...' : 'Update'}</span>
          </button>
        </div>
      </div>

      {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
        <div className="tab-error-message" style={{ marginTop: '12px' }}>
          <AlertCircle size={14} />
          <span>{getCurrentTabErrorMessage()}</span>
        </div>
      )}
    </div>
  );

  const renderCurrentSection = () => {
    switch (activeSection) {
      case 'details': return renderDetailsSection();
      case 'content': return renderContentSection();
      case 'attachment': return renderAttachmentSection();
      default: return renderDetailsSection();
    }
  };

  return (
    <div>
      <button title="Update Circular" className="model-edit-button-modern actionn-icon" style={{ background: "#00000075" }} onClick={handleShow}>
        <UpdatePencil modernButton="true" />
      </button>

      {showProgressModal ? (
        <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
      ) : (
        <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
          <Modal.Header className="modern-modal-header">
            <div className="header-content">
              <div style={{ color: "white" }}>
                <FileText size={24} />
              </div>
              <div>
                <Modal.Title>Update Circular</Modal.Title>
                <p className="header-subtitle" style={{ color: "white" }}>Update the details of this circular</p>
              </div>
            </div>
            <button className="close-btn" onClick={handleClose}>
              <X size={20} />
            </button>
          </Modal.Header>

          <Modal.Body className="modern-modal-body">
            <div className="section-navigation">
              {sections.map((section) => {
                const Icon = section.icon;
                const hasMissing = tabHasMissingFields(section.id);
                return (
                  <button
                    key={section.id}
                    className={`section-nav-btn ${activeSection === section.id ? 'active' : ''} ${hasMissing && section.id !== activeSection ? 'has-warning' : ''}`}
                    onClick={() => {
                      if (activeSection !== section.id) {
                        if (validateCurrentTab()) {
                          setActiveSection(section.id);
                        } else {
                          const formContainer = document.querySelector('.modern-modal-body');
                          if (formContainer) formContainer.scrollTop = 0;
                        }
                      }
                    }}
                  >
                    <Icon size={16} />
                    <span>{section.label}</span>
                    {hasMissing && section.id !== activeSection && (
                      <div className="warning-dot" title="Missing required fields" />
                    )}
                    {activeSection === section.id && <ChevronRight size={14} className="nav-arrow" />}
                  </button>
                );
              })}
            </div>

            <form onSubmit={handleSubmit} className="project-form">
              <div key={activeSection}>
                {renderCurrentSection()}
              </div>
            </form>

            <p className="error-message" style={{ marginTop: '12px' }}>
              {!isSubmitted && Object.keys(errors).length > 5 && (
                <span>Please fill all mandatory fields!</span>
              )}
            </p>

            <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};
const ApproveCircular = ({ i, getCircular }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.put(
        `${BASE_URL}/siteproject/circularuploadupdate/${i.id}/`,
        {
          admin_approval_status: "approved",
        }
      );

      if (res.status === 200) {
        await getCircular();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Approve Circular"
        className="model-edit-button"
        onClick={handleShow}
      >
        <CheckGreen />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Approve Circular {i.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to Approve Circular {i.title}
            <div className="button-models">
              <button
                className="model-button   font-weight500     model-button-cancel  "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-submit"
              >
                Approve
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const RejectCircular = ({ i, getCircular }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.put(
        `${BASE_URL}/siteproject/circularuploadupdate/${i.id}/`,
        {
          admin_approval_status: "rejected",
        }
      );

      if (res.status === 200) {
        await getCircular();
        setShow(false);
      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Rejected Circular"
        className="model-delete-button"
        onClick={handleShow}
      >
        <CrossRed />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Rejected Circular {i.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to rejected circular {i.title}
            <div className="button-models">
              <button
                className="model-button   font-weight500     model-button-cancel  "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Rejected
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const DeleteCircular = ({ i, getCircular }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/circularuploadupdate/${i.id}/`
      );

      if (res.status === 200) {
        await getCircular();
        toast.dismiss(loadingToastId);
        toast.success("Deleted Successfully");
        setShow(false);
      } else {
        toast.dismiss(loadingToastId);
        toast.error("Failed to delete data!");
      }
    } catch (err) {
      toast.dismiss(loadingToastId);
      handleErrorToast(err);
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button title="Delete Circular" className="model-delete-button-modern actionn-icon" style={{ backgroundColor: "#00000075" }} onClick={handleShow}>
        <DeleteDustbin modernButton="true" />
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="modern-required-modal" centered>
        <Modal.Header className="modern-modal-header requirement-modal-header">
          <div className="header-content">
            <div className="requirement-header-icon">
              <Trash2 size={22} />
            </div>
            <div>
              <Modal.Title>Delete Circular</Modal.Title>
              <p className="header-subtitle" style={{ color: "white" }}>
                This action cannot be undone
              </p>
            </div>
          </div>
          <button className="close-btn" onClick={handleClose}>
            <X size={20} />
          </button>
        </Modal.Header>

        <Modal.Body className="modern-modal-body requirement-modal-body">
          <div className="requirement-mode-summary" style={{ marginBottom: '20px' }}>
            <AlertCircle size={16} />
            <span>
              Are you sure you want to delete circular <strong>{i.title}</strong>?
            </span>
          </div>

          <div className="submit-buttons" style={{ justifyContent: 'flex-end' }}>
            <button type="button" className="btn-secondaryy" onClick={handleClose} disabled={loading}>
              Cancel
            </button>
            <button
              type="button"
              className="btn-primaryy"
              style={{ background: "#dc3545", borderColor: "#dc3545" }}
              onClick={handleFormSubmitDelete}
              disabled={loading}
            >
              {loading ? <Loader size={18} className="spinning" /> : <Trash2 size={18} />}
              <span>{loading ? 'Deleting...' : 'Delete'}</span>
            </button>
          </div>

          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const AddInsurance = ({ project, getProjects }) => {
  const [show, setShow] = useState(false);
  const [inputState, setInputState] = useState({});
  const handleClose = () => {
    setShow(false);
    setFormData({
      project: project,
      insurance_policy_num: "",
      insurance_file_upload: "",
      insurance_policy_start_date: null,
      insurance_name: "",
      insurance_company_name: "",
      insurance_amount: "",
      insurance_policy_valid_upto_date: null,
    });
    setDocNames("");
    setInsuranceTypeName("null");
  };
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    project: project,
    insurance_policy_num: "",
    insurance_file_upload: "",
    insurance_policy_start_date: null,
    insurance_name: "",
    insurance_company_name: "",
    insurance_amount: "",
    insurance_policy_valid_upto_date: null,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [uploadProgress, setUploadProgress] = useState(0);

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "insurance_policy_num",
      "insurance_company_name",
      "insurance_amount",



    ];

    if (insurancetypeName === "null") {
      newErrors.insurancetypeName = "Insurance type is required!";
    }
    if (!formData.insurance_policy_start_date) {
      newErrors.insurance_policy_start_date = "Required Field!";
    }
    if (!formData.insurance_policy_valid_upto_date) {
      newErrors.insurance_policy_valid_upto_date = "Required Field!";
    }
    if (!formData.insurance_file_upload) {
      newErrors.insurance_file_upload = "Required Field!";
    }

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
          } is required!`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [docNames, setDocNames] = useState();

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const symbols = "!@#$%^&*()_-+=";
      const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
      const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const numbers = "0123456789";
      const now = new Date();
      const date = now
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-"); // Format: YYYY-MM-DD
      const time = now
        .toLocaleTimeString("en-GB", { hour12: false })
        .replace(/:/g, "-"); // Format: HH-MM-SS
      const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
      let randomCode = "";
      for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * allChars.length);
        randomCode += allChars[randomIndex];
      }
      const customFileName = `Aimantra ${date} ${time}_${randomCode} ${file.name}`;
      const customFile = new File([file], customFileName, { type: file.type });

      setFormData({
        ...formData,
        insurance_file_upload: customFile,
      });
      setDocNames(customFileName);
    } else {
      setDocNames("");
    }
  };

  const handleFileClear = (name) => {
    setFormData({
      ...formData,
      insurance_file_upload: null,
    });
    setDocNames("");
  };
  const [showProgressModal, setShowProgressModal] = useState(false);
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setShowProgressModal(true);
      setLoading(true);
      setUploadProgress(0);

      const loadingToastId = toast.loading("Uploading: please wait...");
      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setUploadProgress(progress);
      }, 100);
      const formDataToSubmit = new FormData();
      Object.keys(formData).forEach((key) => {
        formDataToSubmit.append(key, formData[key]);
      });

      try {
        const res = await axios.post(
          `${BASE_URL}/siteproject/insurance/`,
          formDataToSubmit,
          {
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress(percentCompleted);
            },
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (res.status === 200) {
          handleClose();
          await getProjects();
          setTimeout(() => {
            toast.dismiss(loadingToastId);
            toast.success("Insurance added successfully.", {
              autoClose: 1000,
              pauseOnHover: true,
              closeOnClick: true,
            });
          }, 1000);
        } else {
          throw new Error("Unexpected response status: " + res.status);
        }

      } catch (err) {
        clearInterval(interval);
        setUploadProgress(0);
        handleErrorToast(err);
      } finally {
        clearInterval(interval);

        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);

        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  const [insurancetypeName, setInsuranceTypeName] = useState("null");
  const insuranceTypeList = [
    { name: "PROFESSIONAL INDEMNITY POLICY SCHEDULE", label: "PROFESSIONAL INDEMNITY POLICY SCHEDULE" },
    { name: "PUBLIC LIABILITY", label: "PUBLIC LIABILITY" },
    { name: "WORKING EMPLOYEES COMPENSATION", label: "WORKING EMPLOYEES COMPENSATION" },
    { name: "FIRE", label: "FIRE" },
    { name: "BURGLARY", label: "BURGLARY" },
  ]

  const options = insuranceTypeList?.sort((a, b) => a.name.localeCompare(b.name)).map((i) => ({
    value: i.name,
    label: i.label
  }));



  const handleNameChange = (option) => {
    if (!option) {
      setInsuranceTypeName("null");
    }
    else {
      setInsuranceTypeName(option.value)
    }
  }

  useEffect(() => {
    if (insurancetypeName !== "null") {
      setFormData((prev) => ({
        ...prev,
        insurance_name: insurancetypeName
      }))
    }
  }, [insurancetypeName])

  return (
    <>
      <button title="Add Insurance" className="upload-svg" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clip-path="url(#clip0_1415_3177)">
            <path
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1415_3177">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>{" "}
        Insurance
      </button>

      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" /> :
          show === true ?
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="request-leave width-40vw"
            >
              <Modal.Header
                closeButton
                className="justify-center task-Tab-heading font-weight500    font-size-heading "
              >
                <Modal.Title> Add Insurance</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ToastContainer
                  position="top-center"
                  autoClose={3000}
                  hideProgressBar
                />
                <div className="parent-div">
                  <div className="bdy-div">
                    <div className="form-flex-wrap">



                      <div className="form-group">
                        <label htmlFor={insurancetypeName} className="form-labels  font-weight500    font-size-subheading">Insurance Type <span className="required">*</span></label>
                        <Select
                          options={options}
                          onChange={handleNameChange}
                          value={
                            insurancetypeName === "null"
                              ? "null"
                              : options.find(option => option.value === insurancetypeName)
                          }
                          placeholder="Select type"
                          isSearchable
                          isClearable
                          noOptionsMessage={() => "No other options"}
                          styles={CSSForSelect}
                        />

                        {errors.insurancetypeName && (
                          <div className="error-message col required">
                            <span className="required">{errors.insurancetypeName}</span>
                          </div>
                        )}
                      </div>

                      <div className="flex-column" title="Insurance Company Name">
                        <label
                          className="form-labels font-weight500 font-size-subheading"
                          htmlFor="insurance_company_name"
                        >
                          Company Name <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          id="insurance_company_name"
                          name="insurance_company_name"
                          placeholder="Insurance Company Name"
                          value={formData.insurance_company_name}
                          onChange={handleInputChange}
                          className={`form-input ${errors.insurance_company_name ? "is-invalid" : ""
                            }`}
                        />
                        {errors.insurance_company_name && (
                          <div className="error-message font-size-text">
                            {errors.insurance_company_name}
                          </div>
                        )}
                      </div>

                      <div className="flex-column">
                        <label className="form-labels  font-weight500 font-size-subheading">
                          {" "}
                          Policy Number <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="insurance_policy_num"
                          placeholder="Insurance Policy Number"
                          value={formData.insurance_policy_num}
                          onChange={handleInputChange}
                          className={`form-input width-15vw ${errors.insurance_policy_num ? "is-invalid" : ""
                            }`}
                        />
                        {errors.insurance_policy_num && (
                          <div className="error-message font-size-text">
                            {errors.insurance_policy_num}
                          </div>
                        )}
                      </div>
                      <div className="flex-column">
                        <label className="form-labels  font-weight500 font-size-subheading">
                          Premium Amount <span className="required">(₹)*</span>
                        </label>
                        <input
                          type="number"
                          min={0}
                          name="insurance_amount"
                          placeholder="0"
                          value={formData.insurance_amount}
                          onChange={handleInputChange}
                          className={`form-input width-15vw ${errors.insurance_amount ? "is-invalid" : ""
                            }`}
                        />
                        {errors.insurance_amount && (
                          <div className="error-message font-size-text">
                            {errors.insurance_amount}
                          </div>
                        )}
                      </div>
                      <div className="flex-column">
                        <label className="form-labels  font-weight500 font-size-subheading">
                          Policy Start Date <span className="required">*</span>
                        </label>
                        <input
                          type="date"
                          name="insurance_policy_start_date"
                          placeholder="Insurance Policy Start Date"
                          value={formData.insurance_policy_start_date}
                          onChange={handleInputChange}
                          className={`form-input width-15vw ${errors.insurance_policy_start_date ? "is-invalid" : ""
                            }`}
                        />
                        {errors.insurance_policy_start_date && (
                          <div className="error-message font-size-text">
                            {errors.insurance_policy_start_date}
                          </div>
                        )}
                      </div>
                      <div className="flex-column">
                        <label className="form-labels  font-weight500 font-size-subheading">
                          Policy Valid Upto <span className="required">*</span>
                        </label>
                        <input
                          type="date"
                          name="insurance_policy_valid_upto_date"
                          placeholder="Insurance Policy Valid Upto"
                          value={formData.insurance_policy_valid_upto_date}
                          onChange={handleInputChange}
                          className={`form-input width-15vw ${errors.insurance_policy_valid_upto_date
                            ? "is-invalid"
                            : ""
                            }`}
                        />
                        {errors.insurance_policy_valid_upto_date && (
                          <div className="error-message font-size-text">
                            {errors.insurance_policy_valid_upto_date}
                          </div>
                        )}
                      </div>
                      <div className="flex-column">
                        <label className="form-labels  font-weight500 font-size-subheading">
                          Upload Policy Document <span className="required">*</span>
                        </label>
                        <div className="flex-row">
                          <label
                            htmlFor={`insurance_file_upload`}
                            className={` custom-file-upload ${errors[`insurance_file_upload`]
                              ? "error"
                              : inputState[`insurance_file_upload`]
                                ? "success"
                                : ""
                              }`}
                          >
                            <div className={`align-center pdf-input  ${errors[`insurance_file_upload`] ? 'error' : ''}`}>
                              <Attachment />
                            </div>
                          </label>
                          <input
                            id="insurance_file_upload"
                            name="insurance_file_upload"
                            type="file"
                            onChange={handleFileChange}
                            style={{ display: "none", position: "relative" }}
                          />
                          {docNames && (
                            <p className="file-name align-center">{docNames}</p>
                          )}
                          {formData.insurance_file_upload ? (
                            <span
                              className="file-clear model-button-cancel"
                              onClick={() => handleFileClear("file")}
                            >
                              Clear
                            </span>
                          ) : null}
                          {errors.insurance_file_upload && (
                            <div className="error-message font-size-text">
                              {errors.insurance_file_upload}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="button-models" style={{ marginTop: "20px", justifyContent: "space-evenly" }}>
                  <button className="cancelbutton" onClick={handleClose}>Cancel</button>

                  <Addbutton onclick={handleFormSubmit} />
                </div>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};
const UpdateInsurance = ({ project, getProjects, i }) => {
  const [show, setShow] = useState(false);
  const [inputState, setInputState] = useState({});
  const handleClose = () => setShow(false);
  const handleShow = () => {
    console.log(i, 'data')
    setShow(true);
    const filteredData = { ...i };
    delete filteredData.insurance_file_upload;
    setFormData(filteredData);


  };

  const [formData, setFormData] = useState({
    project: project,
    insurance_policy_num: "",
    insurance_file_upload: "",
    insurance_policy_start_date: null,
    insurance_name: "",
    insurance_company_name: "",
    insurance_amount: "",
    insurance_policy_valid_upto_date: null,
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "insurance_policy_num",
      "insurance_company_name",
      "insurance_amount",



    ];


    if (!formData.insurance_policy_start_date) {
      newErrors.insurance_policy_start_date = "Required Field!";
    }
    if (!formData.insurance_policy_valid_upto_date) {
      newErrors.insurance_policy_valid_upto_date = "Required Field!";
    }

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
          } is required!`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const [docNames, setDocNames] = useState();

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const symbols = "!@#$%^&*()_-+=";
      const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
      const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const numbers = "0123456789";
      const now = new Date();
      const date = now
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-"); // Format: YYYY-MM-DD
      const time = now
        .toLocaleTimeString("en-GB", { hour12: false })
        .replace(/:/g, "-"); // Format: HH-MM-SS
      const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
      let randomCode = "";
      for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * allChars.length);
        randomCode += allChars[randomIndex];
      }
      const customFileName = `Aimantra ${date} ${time}_${randomCode} ${file.name}`;
      const customFile = new File([file], customFileName, { type: file.type });

      setFormData({
        ...formData,
        insurance_file_upload: customFile,
      });
      setDocNames(customFileName);
    } else {
      setDocNames("");
    }
  };

  const handleFileClear = (name) => {
    setFormData({
      ...formData,
      insurance_file_upload: null,
    });
    setDocNames("");
  };
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const updatedfromdata = {
      ...formData,
    };
    if (validateForm()) {
      setShowProgressModal(true);
      setLoading(true);
      setUploadProgress(0);

      const loadingToastId = toast.loading("Uploading: please wait...");
      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setUploadProgress(progress);
      }, 100);
      const formDataToSubmit = new FormData();
      Object.keys(formData).forEach((key) => {
        formDataToSubmit.append(key, formData[key]);
      });
      const formDataToSend = new FormData();

      // Append general form fields
      Object.keys(updatedfromdata).forEach((key) => {
        if (updatedfromdata[key] && key !== "insurance_file_upload") {
          formDataToSend.append(key, updatedfromdata[key]);
        }
      });

      // Append file fields conditionally
      if (updatedfromdata.insurance_file_upload) {
        formDataToSend.append("insurance_file_upload", updatedfromdata.insurance_file_upload);
      }

      try {
        const res = await axios.put(
          `${BASE_URL}/siteproject/insurance/${i.id}/`,
          formDataToSend
        );

        if (res.status === 200) {
          setShow(false);
          await getProjects();
          setTimeout(() => {
            toast.dismiss(loadingToastId);
            toast.success("Data updated successfully.", {
              autoClose: 1000,
              pauseOnHover: true,
              closeOnClick: true,
            });
          }, 1000);
        } else {
          throw new Error("Unexpected response status: " + res.status);
        }

      } catch (err) {
        clearInterval(interval);
        setUploadProgress(0);
        handleErrorToast(err);
      } finally {
        clearInterval(interval);

        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);

        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button
        title="Update Insurance"
        className="model-edit-button"
        onClick={handleShow}
      >
        <UpdatePencil />
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" /> :
          show === true ?
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="request-leave width-40vw"
            >
              <Modal.Header
                closeButton
                className="justify-center task-Tab-heading font-weight500    font-size-heading "
              >
                <Modal.Title> Update Insurance</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ToastContainer
                  position="top-center"
                  autoClose={3000}
                  hideProgressBar
                />
                <div className="parent-div">
                  <div className="bdy-div">
                    <div className="form-flex-wrap">




                      <div className="flex-column">
                        <label className="form-labels  font-weight500 font-size-subheading">
                          Insurance Type <span className="required">(Read-Only)</span>
                        </label>
                        <input
                          type="text"
                          name="insurance_name"
                          placeholder="Insurance Name"
                          value={formData.insurance_name}
                          onChange={handleInputChange}
                          readOnly
                          className={`form-input ${errors.insurance_name ? "is-invalid" : ""
                            }`}
                        />
                        {errors.insurance_name && (
                          <div className="error-message font-size-text">
                            {errors.insurance_name}
                          </div>
                        )}
                      </div>

                      <div className="flex-column" title="Insurance Company Name">
                        <label
                          className="form-labels font-weight500 font-size-subheading"
                          htmlFor="insurance_company_name"
                        >
                          Company Name <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          id="insurance_company_name"
                          name="insurance_company_name"
                          placeholder="Insurance Company Name"
                          value={formData.insurance_company_name}
                          onChange={handleInputChange}
                          className={`form-input ${errors.insurance_company_name ? "is-invalid" : ""
                            }`}
                        />
                        {errors.insurance_company_name && (
                          <div className="error-message font-size-text">
                            {errors.insurance_company_name}
                          </div>
                        )}
                      </div>

                      <div className="flex-column">
                        <label className="form-labels  font-weight500 font-size-subheading">
                          {" "}
                          Policy Number <span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="insurance_policy_num"
                          placeholder="Insurance Policy Number"
                          value={formData.insurance_policy_num}
                          onChange={handleInputChange}
                          className={`form-input width-15vw ${errors.insurance_policy_num ? "is-invalid" : ""
                            }`}
                        />
                        {errors.insurance_policy_num && (
                          <div className="error-message font-size-text">
                            {errors.insurance_policy_num}
                          </div>
                        )}
                      </div>

                      <div className="flex-column">
                        <label className="form-labels  font-weight500 font-size-subheading">
                          Premium Amount <span className="required">(₹)*</span>
                        </label>
                        <input
                          type="number"
                          min={0}
                          name="insurance_amount"
                          placeholder="0"
                          value={formData.insurance_amount}
                          onChange={handleInputChange}
                          className={`form-input width-15vw ${errors.insurance_amount ? "is-invalid" : ""
                            }`}
                        />
                        {errors.insurance_amount && (
                          <div className="error-message font-size-text">
                            {errors.insurance_amount}
                          </div>
                        )}
                      </div>
                      <div className="flex-column">
                        <label className="form-labels  font-weight500 font-size-subheading">
                          Policy Start Date <span className="required">*</span>
                        </label>
                        <input
                          type="date"
                          name="insurance_policy_start_date"
                          placeholder="Insurance Policy Start Date"
                          value={formData.insurance_policy_start_date}
                          onChange={handleInputChange}
                          className={`form-input width-15vw ${errors.insurance_policy_start_date ? "is-invalid" : ""
                            }`}
                        />
                        {errors.insurance_policy_start_date && (
                          <div className="error-message font-size-text">
                            {errors.insurance_policy_start_date}
                          </div>
                        )}
                      </div>
                      <div className="flex-column">
                        <label className="form-labels  font-weight500 font-size-subheading">
                          Policy Valid Upto <span className="required">*</span>
                        </label>
                        <input
                          type="date"
                          name="insurance_policy_valid_upto_date"
                          placeholder="Insurance Policy Valid Upto"
                          value={formData.insurance_policy_valid_upto_date}
                          onChange={handleInputChange}
                          className={`form-input width-15vw ${errors.insurance_policy_valid_upto_date
                            ? "is-invalid"
                            : ""
                            }`}
                        />
                        {errors.insurance_policy_valid_upto_date && (
                          <div className="error-message font-size-text">
                            {errors.insurance_policy_valid_upto_date}
                          </div>
                        )}
                      </div>
                      <div className="flex-column">
                        <label className="form-labels  font-weight500 font-size-subheading">
                          Upload Policy Document <span className="required">*</span>
                        </label><div className="flex-row">

                          <label htmlFor={`insurance_file_upload`} className={` custom-file-upload ${errors[`insurance_file_upload`] ? "error" : inputState[`insurance_file_upload`] ? "success" : ""}`}>
                            <svg className="pdf-input" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 20 20" fill="none">
                              <path d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831" stroke="#707070" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </label>
                          <input
                            id="insurance_file_upload"
                            name="insurance_file_upload"
                            type="file"
                            onChange={handleFileChange}
                            style={{ display: "none", position: "relative" }}
                          />
                          {docNames && <p className="file-name align-center">{docNames}</p>}
                          {formData.insurance_file_upload ? (
                            <span
                              className="file-clear model-button-cancel"
                              onClick={() => handleFileClear("file")}
                            >
                              Clear
                            </span>
                          ) : null}
                          {errors.insurance_file_upload && <div className="error-message font-size-text">{errors.insurance_file_upload}</div>}
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div className="button-models" style={{ marginTop: "20px", justifyContent: "space-evenly" }}>
                  <button className="cancelbutton" onClick={handleClose}>Cancel</button>

                  <Updatebutton onclick={handleFormSubmit} />
                </div>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};

const DeleteInsurance = ({ i, getInsuranceData }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);

    const loadingToastId = toast.loading("Deleting: please wait...");
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);
    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/insurance/${i.id}/`
      );

      if (res.status === 200) {
        await getInsuranceData();
        setShow(false);
        setTimeout(() => {
          toast.dismiss(loadingToastId);
          toast.success("Data deleted successfully.", {
            autoClose: 1000,
            pauseOnHover: true,
            closeOnClick: true,
          });
        }, 1000);
      } else {
        throw new Error("Unexpected response status: " + res.status);
      }

    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      handleErrorToast(err);
    } finally {
      clearInterval(interval);

      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);

      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete Insurance"
        className="model-delete-button"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" /> :
          show === true ?
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="request-leave width-40vw"
            >
              <Modal.Header closeButton>
                <Modal.Title>Delete Insurance {i.title}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="parent-div">
                  Are You Sure You Want to delete Insurance {i.title}
                  <div className="button-models" style={{ marginTop: "40px", justifyContent: "space-evenly" }}>
                    <button className="cancelbutton" onClick={handleClose}>Cancel</button>
                    <DeleteButton onclick={handleFormSubmitDelete} />

                  </div>
                </div>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};

const AddBankGuarantee = ({ getbg, project }) => {
  const [show, setShow] = useState(false);
  const [inputState, setInputState] = useState({});
  const handleClose = () => {
    setShow(false);
    setFormData({
      project: project,
      bank_name: "",
      bg_num: "",
      bg_document: "",
      bg_date: "",
      bg_expiry_date: "",
      bg_release_date: "",
      bg_remark: "",
      bg_amount: "",
    });
    setDocNames("");
  }
  const handleShow = () => setShow(true);

  const [formData, setFormData] = useState({
    project: project,
    bank_name: "",
    bg_num: "",
    bg_document: "",
    bg_date: "",
    bg_expiry_date: "",
    bg_release_date: "",
    bg_remark: "",
    bg_amount: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "bank_name",
      "bg_num",
      "bg_document",
      "bg_date",
      "bg_expiry_date",
      "bg_remark",
      "bg_amount",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
          } is required!`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [docNames, setDocNames] = useState();
  const [uploadProgress, setUploadProgress] = useState(0);

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const symbols = "!@#$%^&*()_-+=";
      const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
      const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const numbers = "0123456789";
      const now = new Date();
      const date = now
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-"); // Format: YYYY-MM-DD
      const time = now
        .toLocaleTimeString("en-GB", { hour12: false })
        .replace(/:/g, "-"); // Format: HH-MM-SS
      const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
      let randomCode = "";
      for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * allChars.length);
        randomCode += allChars[randomIndex];
      }
      const customFileName = `Aimantra ${date} ${time}_${randomCode} ${file.name}`;
      const customFile = new File([file], customFileName, { type: file.type });

      setFormData({
        ...formData,
        bg_document: customFile,
      });
      setDocNames(customFileName);
    } else {
      setDocNames("");
    }
  };

  const handleFileClear = (name) => {
    setFormData({
      ...formData,
      bg_document: null,
    });
    setDocNames("");
  };


  const [showProgressModal, setShowProgressModal] = useState(false);
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setShowProgressModal(true);
      setLoading(true);
      setUploadProgress(0);

      const loadingToastId = toast.loading("Uploading: please wait...");
      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setUploadProgress(progress);
      }, 100);

      const formDataToSubmit = new FormData();
      Object.keys(formData).forEach((key) => {
        formDataToSubmit.append(key, formData[key]);
      });

      try {
        const res = await axios.post(
          `${BASE_URL}/siteproject/bgdetails/`,
          formDataToSubmit,
          {
            onUploadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              setUploadProgress(percentCompleted);
            },
          },
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        );

        if (res.status === 200) {
          handleClose();
          await getbg();
          setTimeout(() => {
            toast.dismiss(loadingToastId);
            toast.success("BG data added successfully.", {
              autoClose: 1000,
              pauseOnHover: true,
              closeOnClick: true,
            });
          }, 1000);
        } else {
          throw new Error("Unexpected response status: " + res.status);
        }

      } catch (err) {
        clearInterval(interval);
        setUploadProgress(0);
        handleErrorToast(err);
      } finally {
        clearInterval(interval);

        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);

        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };



  return (
    <>
      <button title="Add BG" className="upload-svg" onClick={handleShow}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
        >
          <g clip-path="url(#clip0_1415_3177)">
            <path
              d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
              fill="white"
            />
          </g>
          <defs>
            <clipPath id="clip0_1415_3177">
              <rect width="24" height="24" fill="white" />
            </clipPath>
          </defs>
        </svg>{" "}
        Bank Guarantee
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" /> :
          show === true ?
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="request-leave width-40vw"
            >
              <Modal.Header
                closeButton
                className="justify-center task-Tab-heading font-weight500    font-size-heading "
              >
                <Modal.Title> Add Bank Guarantee Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ToastContainer
                  position="top-center"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
                <div className="parent-div">
                  <div className="form-flex-wrap">

                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        Bank Name <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="bank_name"
                        style={{ width: "37vw" }}
                        placeholder="Bank Name"
                        value={formData.bank_name}
                        onChange={handleInputChange}
                        className={`form-input ${errors.bank_name ? "is-invalid" : ""
                          }`}
                      />
                      {errors.bank_name && (
                        <div className="error-message font-size-text">
                          {errors.bank_name}
                        </div>
                      )}
                    </div>
                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        {" "}
                        Bank Guarantee Number <span className="required">*</span>
                      </label>
                      <input
                        type="text"
                        name="bg_num"
                        placeholder="Bank Guarantee Number"
                        value={formData.bg_num}
                        onChange={handleInputChange}
                        className={`form-input width-17vw ${errors.bg_num ? "is-invalid" : ""
                          }`}
                      />
                      {errors.bg_num && (
                        <div className="error-message font-size-text">
                          {errors.bg_num}
                        </div>
                      )}
                    </div>
                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        {" "}
                        Amount <span className="required">*</span>
                      </label>
                      <input
                        type="number"
                        name="bg_amount"
                        placeholder="Amount"
                        min={0}
                        value={formData.bg_amount}
                        onChange={handleInputChange}
                        className={`form-input width-17vw ${errors.bg_amount ? "is-invalid" : ""
                          }`}
                      />
                      {errors.bg_amount && (
                        <div className="error-message font-size-text">
                          {errors.bg_amount}
                        </div>
                      )}
                    </div>

                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        Guarantee Date <span className="required">*</span>
                      </label>
                      <input
                        type="date"
                        name="bg_date"
                        placeholder="Bank Guarantee Date"
                        value={formData.bg_date}
                        onChange={handleInputChange}
                        className={`form-input width-10vw ${errors.bg_date ? "is-invalid" : ""
                          }`}
                      />
                      {errors.bg_date && (
                        <div className="error-message font-size-text">
                          {errors.bg_date}
                        </div>
                      )}
                    </div>
                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        Expiry Date{" "}
                        <span className="required">*</span>
                      </label>
                      <input
                        type="date"
                        name="bg_expiry_date"
                        placeholder="Bank Guarantee Expiry Date"
                        value={formData.bg_expiry_date}
                        onChange={handleInputChange}
                        className={`form-input width-10vw ${errors.bg_expiry_date ? "is-invalid" : ""
                          }`}
                      />
                      {errors.bg_expiry_date && (
                        <div className="error-message font-size-text">
                          {errors.bg_expiry_date}
                        </div>
                      )}
                    </div>

                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        Release Date
                      </label>
                      <input
                        type="date"
                        name="bg_release_date"
                        placeholder="Bank Release Date"
                        value={formData.bg_release_date}
                        onChange={handleInputChange}
                        className={`form-input width-10vw ${errors.bg_release_date ? "is-invalid" : ""
                          }`}
                      />
                      {errors.bg_release_date && (
                        <div className="error-message font-size-text">
                          {errors.bg_release_date}
                        </div>
                      )}
                    </div>
                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        Document<span className="required">*</span>
                      </label>
                      <div className="flex-row">
                        <label
                          htmlFor={`bg_document`}
                          className={` custom-file-upload ${errors[`bg_document`]
                            ? "error"
                            : inputState[`bg_document`]
                              ? "success"
                              : ""
                            }`}
                        >
                          <div className={`align-center pdf-input  ${errors[`bg_document`] ? 'error' : ''}`}>
                            <Attachment />
                          </div>
                        </label>
                        <input
                          id="bg_document"
                          name="bg_document"
                          type="file"
                          onChange={handleFileChange}
                          style={{ display: "none", position: "relative" }}
                        />
                        {docNames && (
                          <p className="file-name align-center">{docNames}</p>
                        )}
                        {formData.bg_document ? (
                          <span
                            className="file-clear model-button-cancel"
                            onClick={() => handleFileClear("file")}
                          >
                            Clear
                          </span>
                        ) : null}
                        {errors.bg_document && (
                          <div className="error-message font-size-text">
                            {errors.bg_document}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        Remarks <span className="required">*</span>
                      </label>
                      <textarea
                        type="text"
                        name="bg_remark"
                        style={{ width: "37vw" }}

                        placeholder="Remarks"
                        value={formData.bg_remark}
                        onChange={handleInputChange}
                        className={`form-input-textarea ${errors.bg_remark ? "is-invalid" : ""
                          }`}
                      />
                      {errors.bg_remark && (
                        <div className="error-message font-size-text">
                          {errors.bg_remark}
                        </div>
                      )}
                    </div>



                  </div>

                </div>
                <div className="button-models" style={{ marginTop: "20px", justifyContent: "space-evenly" }}>
                  <button className="cancelbutton" onClick={handleClose}>Cancel</button>

                  <Addbutton onclick={handleFormSubmit} />
                </div>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};
const UpdateBankGuarantee = ({ getbg, project, i, document }) => {
  const [show, setShow] = useState(false);
  const [inputState, setInputState] = useState({});
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);

    const filteredData = { ...i };
    delete filteredData.bg_document;


    setFormData(filteredData);
  };


  const is24hrsPassed =
    (new Date() - new Date(i.created_at)) / (1000 * 60 * 60) >= 24;

  const isReadOnly = sessionStorage.getItem('sitemanagement_role') !== "Admin" && is24hrsPassed;


  const [formData, setFormData] = useState({
    project: project,
    bank_name: "",
    bg_num: "",
    bg_date: "",
    bg_expiry_date: "",
    bg_remark: "",
    bg_amount: "",
    bg_release_date: "",
    bg_document: "",

  });


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "bank_name",
      "bg_amount",
      "bg_num",
      "bg_date",
      "bg_expiry_date",
      "bg_remark",
      "bg_release_date",
    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
          } is required!`;
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const [docNames, setDocNames] = useState();

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const symbols = "!@#$%^&*()_-+=";
      const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
      const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const numbers = "0123456789";
      const now = new Date();
      const date = now
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-"); // Format: YYYY-MM-DD
      const time = now
        .toLocaleTimeString("en-GB", { hour12: false })
        .replace(/:/g, "-"); // Format: HH-MM-SS
      const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
      let randomCode = "";
      for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * allChars.length);
        randomCode += allChars[randomIndex];
      }
      const customFileName = `Aimantra ${date} ${time}_${randomCode} ${file.name}`;
      const customFile = new File([file], customFileName, { type: file.type });

      setFormData({
        ...formData,
        bg_document: customFile,
      });
      setDocNames(customFileName);
    } else {
      setDocNames("");
    }
  };

  const handleFileClear = (name) => {
    setFormData({
      ...formData,
      bg_document: null,
    });
    setDocNames("");
  };
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const updatedfromdata = {
      ...formData,
    };
    if (validateForm()) {
      setShowProgressModal(true);
      setLoading(true);
      setUploadProgress(0);

      const loadingToastId = toast.loading("Updating: please wait...");
      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setUploadProgress(progress);
      }, 100);
      const formDataToSend = new FormData();

      // Append general form fields
      Object.keys(updatedfromdata).forEach((key) => {
        if (updatedfromdata[key] && key !== "bg_document") {
          formDataToSend.append(key, updatedfromdata[key]);
        }
      });

      // Append file fields conditionally
      if (updatedfromdata.bg_document) {
        formDataToSend.append("bg_document", updatedfromdata.bg_document);
      }

      try {

        // Make the PUT request without sending `bg_document`
        const res = await axios.put(
          `${BASE_URL}/siteproject/bgdetails/${i.id}/`,
          formDataToSend
        );

        if (res.status === 200) {
          handleClose();
          await getbg();
          setTimeout(() => {
            toast.dismiss(loadingToastId);
            toast.success("Data updated successfully.", {
              autoClose: 1000,
              pauseOnHover: true,
              closeOnClick: true,
            });
          }, 1000);
        } else {
          throw new Error("Unexpected response status: " + res.status);
        }

      } catch (err) {
        clearInterval(interval);
        setUploadProgress(0);
        handleErrorToast(err);
      } finally {
        clearInterval(interval);

        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);

        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button className="model-edit-button" onClick={handleShow}>
        <UpdatePencil />
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" /> :
          show === true ?
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="request-leave width-40vw"
            >
              <Modal.Header
                closeButton
                className="justify-center task-Tab-heading font-weight500 font-size-heading "
              >
                <Modal.Title> Update Bank Guarantee Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <ToastContainer
                  position="top-center"
                  autoClose={5000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
                <div className="parent-div">
                  <div className="form-flex-wrap">

                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        Bank Name <span className="required">(Read-Only)</span>
                      </label>
                      <input
                        type="text"
                        name="bank_name"
                        style={{ width: "37vw" }}
                        placeholder="Bank Name"
                        value={formData.bank_name}
                        onChange={handleInputChange}
                        readOnly
                        className={`form-input ${errors.bank_name ? "is-invalid" : ""
                          }`}
                      />
                      {errors.bank_name && (
                        <div className="error-message font-size-text">
                          {errors.bank_name}
                        </div>
                      )}
                    </div>
                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        {" "}
                        Bank Guarantee Number
                        {isReadOnly ?
                          <>
                            <br />
                            <span className="required">(Read-Only)</span>
                          </> :
                          <span className="required">*</span>

                        }
                      </label>
                      <input
                        type="text"
                        name="bg_num"
                        placeholder="Bank Guarantee Number"
                        value={formData.bg_num}
                        onChange={handleInputChange}
                        isDisabled={isReadOnly ? true : false}
                        className={`form-input width-17vw ${errors.bg_num ? "is-invalid" : ""
                          }`}
                      />
                      {errors.bg_num && (
                        <div className="error-message font-size-text">
                          {errors.bg_num}
                        </div>
                      )}
                    </div>
                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        {" "}
                        Amount
                        {isReadOnly ?
                          <>
                            <br />
                            <span className="required">(Read-Only)</span>
                          </> :
                          <span className="required">*</span>

                        }
                      </label>
                      <input
                        type="number"
                        name="bg_amount"
                        placeholder="Amount"
                        min={0}
                        value={formData.bg_amount}
                        isDisabled={isReadOnly ? true : false}

                        onChange={handleInputChange}
                        className={`form-input width-17vw ${errors.bg_amount ? "is-invalid" : ""
                          }`}
                      />
                      {errors.bg_amount && (
                        <div className="error-message font-size-text">
                          {errors.bg_amount}
                        </div>
                      )}
                    </div>

                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        Issue Date
                        {isReadOnly ?
                          <>
                            <br />
                            <span className="required">(Read-Only)</span>
                          </> :
                          <span className="required">*</span>

                        }
                      </label>
                      <input
                        type="date"
                        name="bg_date"
                        placeholder="Issue Date"
                        value={formData.bg_date}
                        isDisabled={isReadOnly ? true : false}

                        onChange={handleInputChange}
                        className={`form-input width-10vw ${errors.bg_date ? "is-invalid" : ""
                          }`}
                      />
                      {errors.bg_date && (
                        <div className="error-message font-size-text">
                          {errors.bg_date}
                        </div>
                      )}
                    </div>
                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        Expiry Date{" "}

                        {isReadOnly ?
                          <>
                            <br />
                            <span className="required">(Read-Only)</span>
                          </> :
                          <span className="required">*</span>

                        }
                      </label>
                      <input
                        type="date"
                        name="bg_expiry_date"
                        isDisabled={isReadOnly ? true : false}

                        placeholder="Bank Guarantee Expiry Date"
                        value={formData.bg_expiry_date}
                        onChange={handleInputChange}
                        className={`form-input width-10vw ${errors.bg_expiry_date ? "is-invalid" : ""
                          }`}
                      />
                      {errors.bg_expiry_date && (
                        <div className="error-message font-size-text">
                          {errors.bg_expiry_date}
                        </div>
                      )}
                    </div>

                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        Release Date
                      </label>
                      <input
                        type="date"
                        name="bg_release_date"
                        placeholder="Bank Release Date"
                        value={formData.bg_release_date}
                        onChange={handleInputChange}
                        className={`form-input width-10vw ${errors.bg_release_date ? "is-invalid" : ""
                          }`}
                      />
                      {errors.bg_release_date && (
                        <div className="error-message font-size-text">
                          {errors.bg_release_date}
                        </div>
                      )}
                    </div>
                    {/* <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        Document<span className="required">*</span>
                      </label>
                      <div className="flex-row">
                        <label
                          htmlFor={`bg_document`}
                          className={` custom-file-upload ${errors[`bg_document`]
                            ? "error"
                            : inputState[`bg_document`]
                              ? "success"
                              : ""
                            }`}
                        >
                          <div className={`align-center pdf-input  ${errors[`bg_document`] ? 'error' : ''}`}>
                            <Attachment />
                          </div>
                        </label>
                        <input
                          id="bg_document"
                          name="bg_document"
                          type="file"
                          onChange={handleFileChange}
                          style={{ display: "none", position: "relative" }}
                        />
                        {docNames && (
                          <p className="file-name align-center">{docNames}</p>
                        )}
                        {formData.bg_document ? (
                          <span
                            className="file-clear model-button-cancel"
                            onClick={() => handleFileClear("file")}
                          >
                            Clear
                          </span>
                        ) : null}
                        {errors.bg_document && (
                          <div className="error-message font-size-text">
                            {errors.bg_document}
                          </div>
                        )}
                      </div>
                    </div> */}
                    <div className="flex-column">
                      <label className="form-labels  font-weight500 font-size-subheading">
                        Remarks <span className="required">*</span>
                      </label>
                      <textarea
                        type="text"
                        name="bg_remark"
                        style={{ width: "37vw" }}

                        placeholder="Remarks"
                        value={formData.bg_remark}
                        onChange={handleInputChange}
                        className={`form-input-textarea ${errors.bg_remark ? "is-invalid" : ""
                          }`}
                      />
                      {errors.bg_remark && (
                        <div className="error-message font-size-text">
                          {errors.bg_remark}
                        </div>
                      )}
                    </div>
                    {uploadProgress > 0 && (
                      <div className="progress-bar">
                        <h6 className="uploading-percentage">Uploading {uploadProgress}%</h6>
                        <div className="progress-bar-fill" style={{ width: `${uploadProgress}%` }}></div>

                      </div>
                    )}


                  </div>

                </div>
                <div className="button-models" style={{ marginTop: "20px", justifyContent: "space-evenly" }}>
                  <button className="cancelbutton" onClick={handleClose}>Cancel</button>

                  <Updatebutton onclick={handleFormSubmit} />
                </div>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};

const DeleteBg = ({ i, getbg }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [loading, setLoading] = useState(false);


  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);

    const loadingToastId = toast.loading("Deleting: please wait...");
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);
    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/bgdetails/${i.id}/`
      );

      if (res.status === 200) {
        await getbg();
        handleClose();
        setTimeout(() => {
          toast.dismiss(loadingToastId);
          toast.success("Data deleted successfully.", {
            autoClose: 1000,
            pauseOnHover: true,
            closeOnClick: true,
          });
        }, 1000);
      } else {
        throw new Error("Unexpected response status: " + res.status);
      }

    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      handleErrorToast(err);
    } finally {
      clearInterval(interval);

      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);

      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete Bank Guarantee"
        className="model-delete-button"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" /> :
          show === true ?
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="request-leave width-40vw"
            >
              <Modal.Header closeButton>
                <Modal.Title>Delete Bank Guarantee {i.title}</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="parent-div">
                  Are You Sure You Want to delete Bank Guarantee {i.title}
                  <div className="button-models" style={{ marginTop: "40px", justifyContent: "space-evenly" }}>
                    <button className="cancelbutton" onClick={handleClose}>Cancel</button>
                    <DeleteButton onclick={handleFormSubmitDelete} />

                  </div>
                </div>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};

// const AddContractor = ({
//   projectId,
//   getProjectContractorDetails,
//   getProjects,
//   getDetails,
//   onAddContractor,
//   contractor,
// }) => {
//   const [show, setShow] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const [formData, setFormData] = useState({
//     project: projectId,
//     name: "",
//     cost: "",
//     project_length: "",
//     contractor_bid_due_date: null,
//     loa_award_date: null,
//     agreement_date: null,
//     project_duration: "",
//     commencement_date: null,
//     actual_completion_date: null,
//     schedule_completion_date: null,
//     construction_duration: "",
//     OM_duration: "",
//     actual_construction_completion_date: null,
//     schedule_construction_completion_date: null,
//     contractor_address: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});

//   const handleClose = () => {
//     setShow(false);
//     setFormData({
//       project: projectId,
//       name: "",
//       cost: "",
//       project_length: "",
//       contractor_bid_due_date: null,
//       loa_award_date: null,
//       agreement_date: null,
//       project_duration: "",
//       commencement_date: null,
//       actual_completion_date: null,
//       schedule_completion_date: null,
//       construction_duration: "",
//       OM_duration: "",
//       actual_construction_completion_date: null,
//       schedule_construction_completion_date: null,
//       contractor_address: "",
//     });
//     setErrors({});
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setInputState({
//       ...inputState,
//       [name]: value.trim() ? "green" : "",
//     });
//     setFormData({
//       ...formData,
//       [name]: value,
//     });
//     setErrors((prevErrors) => ({
//       ...prevErrors,
//       [name]: "",
//     }));



//   };


//   const validateEotForm = () => {
//     const newErrors = {};
//     const requiredFields = [
//       "name",
//       "cost",
//       "project_length",
//       "construction_duration",
//       'contractor_address',
//       'OM_duration'
//     ];

//     requiredFields.forEach((field) => {
//       if (!formData[field]) {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
//           } is required!`;
//       }
//     });

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleAxiosError = (err) => {
//     handleErrorToast(err);
//   };

//   const handlePost = async (e) => {
//     e.preventDefault();
//     if (validateEotForm()) {
//       setLoading(true);
//       const loadingToastId = toast.loading("Loading: Please wait...");

//       try {
//         const res = await axios.post(
//           `${BASE_URL}/siteproject/contractor/`,
//           formData
//         );

//         if (res.status === 200) {
//           if (onAddContractor) {
//             onAddContractor(); // Call the callback to notify the parent
//           }
//           await getProjectContractorDetails();
//           await getProjects();
//           getDetails();
//           handleClose();
//         } else {
//           toast.error(`Error: ${res.statusText}`);
//         }
//       } catch (err) {
//         handleAxiosError(err);
//       } finally {
//         setLoading(false);
//         toast.dismiss(loadingToastId);
//       }
//     }
//   };

//   useEffect(() => {
//     const totalMonths = Number(formData.OM_duration) + Number(formData.construction_duration);
//     setFormData((prev) => ({
//       ...prev,
//       project_duration: totalMonths
//     }))
//   }, [formData.OM_duration, formData.construction_duration, formData.project_duration]);

//   useEffect(() => {
//     const { commencement_date, construction_duration, project_duration } = formData;

//     if (!commencement_date) return;
//     if (construction_duration) {
//       const baseDate = new Date(commencement_date);
//       if (!isNaN(baseDate)) {
//         const result = new Date(baseDate);
//         result.setMonth(result.getMonth() + Number(construction_duration));

//         if (!isNaN(result)) {
//           const formatted = result.toISOString().substring(0, 10);
//           setFormData(prev => ({
//             ...prev,
//             schedule_construction_completion_date: formatted
//           }));
//         }
//       }
//     } else {
//       setFormData(prev => ({
//         ...prev,
//         schedule_construction_completion_date: ""
//       }));
//     }

//     if (project_duration) {
//       const baseDate2 = new Date(commencement_date);
//       if (!isNaN(baseDate2)) {
//         const result2 = new Date(baseDate2);
//         result2.setMonth(result2.getMonth() + Number(project_duration));

//         if (!isNaN(result2)) {
//           const formatted2 = result2.toISOString().substring(0, 10);
//           setFormData(prev => ({
//             ...prev,
//             schedule_completion_date: formatted2
//           }));
//         }
//       }
//     } else {
//       setFormData(prev => ({
//         ...prev,
//         schedule_completion_date: ""
//       }));
//     }
//   }, [
//     formData.commencement_date,
//     formData.construction_duration,
//     formData.project_duration
//   ]);



//   return (
//     <>
//       <button
//         title="Add Contractor"
//         className="upload-svg"
//         onClick={() => setShow(true)}
//       >
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           width="24"
//           height="24"
//           viewBox="0 0 24 24"
//           fill="none"
//         >
//           <g clip-path="url(#clip0_1415_3177)">
//             <path
//               d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
//               fill="white"
//             />
//           </g>
//           <defs>
//             <clipPath id="clip0_1415_3177">
//               <rect width="24" height="24" fill="white" />
//             </clipPath>
//           </defs>
//         </svg>{" "}
//         Contractor
//       </button>

//       <Modal
//         show={show}
//         onHide={handleClose}
//         dialogClassName="four-fifth-modal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Add Contractor Detail</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <ToastContainer
//             position="top-center"
//             autoClose={3000}
//             hideProgressBar
//           />
//           <form onSubmit={handlePost}>
//             <div className="form-flex-wrap">
//               <div className="flex-column">
//                 <label className="form-labels font-weight500 font-size-subheading" title="Name">
//                   Name<span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="name"
//                   title="Name"
//                   placeholder="Name"
//                   value={formData.name}
//                   onChange={handleInputChange}
//                   className={`form-input width-20vw ${errors.name ? "error" : inputState.name ? "success" : ""
//                     }`}
//                 />
//                 {errors.name && (
//                   <span className="error-message font-size-text">
//                     {errors.name}
//                   </span>
//                 )}
//               </div>
//               <div title="Address" className="flex-column">
//                 <label
//                   htmlFor="contractor_address"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Address <span className="required">*</span>
//                 </label>
//                 <textarea
//                   type="text"
//                   id="contractor_address"
//                   name="contractor_address"
//                   placeholder="Address"
//                   onChange={handleInputChange}
//                   rows="50"
//                   cols="100"
//                   value={formData.contractor_address}
//                   style={{ width: "40vw" }}
//                   className={`form-input ${errors.contractor_address
//                     ? "error"
//                     : inputState.contractor_address
//                       ? "success"
//                       : ""
//                     }`}

//                 />
//                 {errors.contractor_address && (
//                   <span className="error-message font-size-text ">
//                     {errors.contractor_address}
//                   </span>
//                 )}
//               </div>

//               <div className="flex-column">
//                 <label className="form-labels font-weight500 font-size-subheading" title="cost">
//                   Cost <br /><span className="required">(in cr.)*</span>
//                 </label>
//                 <input
//                   type="number"
//                   title="Cost"
//                   name="cost"
//                   placeholder="Cost"
//                   value={formData.cost}
//                   onChange={handleInputChange}
//                   className={`form-input-date width-10vw ${errors.cost ? "error" : inputState.cost ? "success" : ""
//                     }`}
//                 />
//                 {errors.cost && (
//                   <span className="error-message font-size-text">
//                     {errors.cost}
//                   </span>
//                 )}
//               </div>

//               <div title="Project Length" className="flex-column">
//                 <label
//                   htmlFor="project_length"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Project Length <br /><span className="required">(in kms)*</span>
//                 </label>
//                 <input
//                   type="number"
//                   id="project_length"
//                   name="project_length"
//                   placeholder="10"
//                   onChange={handleInputChange}
//                   value={formData.project_length}
//                   className={`form-input-date width-10vw ${errors.project_length
//                     ? "error"
//                     : inputState.project_length
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.project_length && (
//                   <span className="error-message font-size-text ">
//                     {errors.project_length}
//                   </span>
//                 )}
//               </div>


//               <div title="Construction Duration" className="flex-column">
//                 <label
//                   htmlFor="construction_duration"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Construction Duration
//                   <br /><span className="required">(in months)*</span>
//                 </label>
//                 <input
//                   type="number"
//                   id="construction_duration"
//                   name="construction_duration"
//                   placeholder="0"
//                   onChange={handleInputChange}
//                   value={formData.construction_duration}
//                   className={`form-input-date width-10vw ${errors.construction_duration
//                     ? "error"
//                     : inputState.construction_duration
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.construction_duration && (
//                   <span className="error-message font-size-text ">
//                     {errors.construction_duration}
//                   </span>
//                 )}
//               </div>
//               <div title="O&M Duration" className="flex-column">
//                 <label
//                   htmlFor="OM_duration"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   O&M Duration
//                   <br /><span className="required">(in months)*</span>
//                 </label>
//                 <input
//                   type="number"
//                   id="OM_duration"
//                   name="OM_duration"
//                   placeholder="0"
//                   onChange={handleInputChange}
//                   value={formData.OM_duration}
//                   className={`form-input-date width-10vw ${errors.OM_duration
//                     ? "error"
//                     : inputState.OM_duration
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.OM_duration && (
//                   <span className="error-message font-size-text ">
//                     {errors.OM_duration}
//                   </span>
//                 )}
//               </div>
//               <div title="Project Duration" className="flex-column">
//                 <label
//                   htmlFor="project_duration"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Project Duration
//                   <br /><span className="required">(Auto-Calculate)</span>
//                 </label>
//                 <input
//                   type="number"
//                   id="project_duration"
//                   name="project_duration"
//                   readOnly
//                   placeholder="0"
//                   onChange={handleInputChange}
//                   value={formData.project_duration}
//                   className={`form-input-date width-10vw ${errors.project_duration
//                     ? "error"
//                     : inputState.project_duration
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.project_duration && (
//                   <span className="error-message font-size-text ">
//                     {errors.project_duration}
//                   </span>
//                 )}
//               </div>

//               <div title="Contractor Bid Due Date" className="flex-column">
//                 <label
//                   htmlFor="contractor_bid_due_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Contractor Bid Due Date
//                 </label>
//                 <input
//                   type="date"
//                   id="contractor_bid_due_date"
//                   name="contractor_bid_due_date"
//                   placeholder="Contractor Bid Due Date"
//                   onChange={handleInputChange}
//                   value={formData.contractor_bid_due_date}
//                   className={`form-input-date width-15vw ${errors.contractor_bid_due_date
//                     ? "error"
//                     : inputState.contractor_bid_due_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.contractor_bid_due_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.contractor_bid_due_date}
//                   </span>
//                 )}
//               </div>

//               <div title="LOA Date" className="flex-column">
//                 <label
//                   htmlFor="loa_award_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   LOA Date
//                 </label>
//                 <input
//                   type="date"
//                   id="loa_award_date"
//                   name="loa_award_date"
//                   min={formData.contractor_bid_due_date}
//                   placeholder="Award Date"
//                   onChange={handleInputChange}
//                   value={formData.loa_award_date}
//                   className={`form-input-date width-15vw ${errors.loa_award_date
//                     ? "error"
//                     : inputState.loa_award_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.loa_award_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.loa_award_date}
//                   </span>
//                 )}
//               </div>

//               <div title="Agreement Date" className="flex-column">
//                 <label
//                   htmlFor="agreement_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Agreement Date
//                 </label>
//                 <input
//                   type="date"
//                   id="agreement_date"
//                   name="agreement_date"
//                   min={formData.contractor_bid_due_date}
//                   placeholder="Agreement Date"
//                   onChange={handleInputChange}
//                   value={formData.agreement_date}
//                   className={`form-input-date width-15vw ${errors.agreement_date
//                     ? "error"
//                     : inputState.agreement_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.agreement_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.agreement_date}
//                   </span>
//                 )}
//               </div>

//               <div title="Appointed Date" className="flex-column">
//                 <label
//                   htmlFor="commencement_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Appointed Date
//                 </label>
//                 <input
//                   type="date"
//                   id="commencement_date"
//                   name="commencement_date"
//                   min={formData.loa_award_date}
//                   placeholder="Appointed Date"
//                   onChange={handleInputChange}
//                   value={formData.commencement_date}
//                   className={`form-input-date width-15vw ${errors.commencement_date
//                     ? "error"
//                     : inputState.commencement_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.commencement_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.commencement_date}
//                   </span>
//                 )}
//               </div>

//               <div
//                 title="Schedule Construction Completion Date"
//                 className="flex-column"
//               >
//                 <label
//                   htmlFor="schedule_construction_completion_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Schedule Const.

//                   Completion  <br /> Date <span className="required">(Auto-Calculate)</span>

//                 </label>
//                 <input
//                   type="date"
//                   id="schedule_construction_completion_date"
//                   name="schedule_construction_completion_date"
//                   min={formData.commencement_date}
//                   disabled
//                   placeholder="Schedule Construction Completion Date"
//                   onChange={handleInputChange}
//                   value={formData.schedule_construction_completion_date}
//                   className={`form-input-date width-15vw ${errors.schedule_construction_completion_date
//                     ? "error"
//                     : inputState.schedule_construction_completion_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.schedule_construction_completion_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.schedule_construction_completion_date}
//                   </span>
//                 )}
//               </div>

//               <div title="Schedule Completion Date" className="flex-column">
//                 <label
//                   htmlFor="schedule_completion_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Schedule Completion Date
//                   <br />
//                   <span className="required">(Auto-Calculate)</span>
//                 </label>
//                 <input
//                   type="date"
//                   id="schedule_completion_date"
//                   name="schedule_completion_date"
//                   min={formData.schedule_construction_completion_date}
//                   placeholder="Schedule Completion Date"
//                   onChange={handleInputChange}
//                   disabled
//                   value={formData.schedule_completion_date}
//                   className={`form-input-date width-15vw ${errors.schedule_completion_date
//                     ? "error"
//                     : inputState.schedule_completion_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.schedule_completion_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.schedule_completion_date}
//                   </span>
//                 )}
//               </div>

//               <div title="Actual Completion Date" className="flex-column">
//                 <label
//                   htmlFor="actual_completion_date"
//                   style={{ marginBottom: "25px" }}
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Actual Completion Date
//                 </label>
//                 <input
//                   type="date"
//                   id="actual_completion_date"
//                   name="actual_completion_date"
//                   placeholder="Actual Completion Date"
//                   onChange={handleInputChange}
//                   value={formData.actual_completion_date}
//                   className={`form-input-date width-15vw ${errors.actual_completion_date
//                     ? "error"
//                     : inputState.actual_completion_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.actual_completion_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.actual_completion_date}
//                   </span>
//                 )}
//               </div>

//               <div
//                 title="Actual Construction Completion Date"
//                 className="flex-column"
//               >
//                 <label
//                   htmlFor="actual_construction_completion_date"
//                   style={{ marginBottom: "25px" }}
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Actual Const. Completion Date
//                 </label>
//                 <input
//                   type="date"
//                   id="actual_construction_completion_date"
//                   name="actual_construction_completion_date"
//                   placeholder="Actual Construction Completion Date"
//                   onChange={handleInputChange}
//                   value={formData.actual_construction_completion_date}
//                   className={`form-input-date width-15vw ${errors.actual_construction_completion_date
//                     ? "error"
//                     : inputState.actual_construction_completion_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.actual_construction_completion_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.actual_construction_completion_date}
//                   </span>
//                 )}
//               </div>


//             </div>
//             <div className="button-models">
//               <button
//                 className="model-button   font-weight500    model-button-cancel"
//                 onClick={handleClose}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="model-button font-weight500 model-button-leave font-size-heading"
//                 type="submit"
//                 disabled={loading}
//               >
//                 {loading ? "Adding..." : "Add"}
//               </button>
//             </div>
//           </form>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };


const AddContractor = ({
  projectId,
  usefor,
  getProjectContractorDetails,
  getProjects,
  getDetails,
  onAddContractor,
  contractor,
}) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeSection, setActiveSection] = useState('basic');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [tabValidationAttempted, setTabValidationAttempted] = useState({});

  const sections = [
    { id: 'basic', label: 'Basic Info', icon: Info },
    { id: 'dates', label: 'Dates', icon: Calendar },
    { id: 'duration', label: 'Duration', icon: Clock },
  ];

  // Define required fields for each tab
  const tabRequiredFields = {
    basic: ["name", "cost", "project_length", "contractor_address"],
    dates: [], // No required fields in dates tab
    duration: ["construction_duration", "OM_duration"]
  };

  const [formData, setFormData] = useState({
    project: projectId,
    name: "",
    cost: "",
    project_length: "",
    contractor_bid_due_date: null,
    loa_award_date: null,
    agreement_date: null,
    project_duration: "",
    commencement_date: null,
    actual_completion_date: null,
    schedule_completion_date: null,
    construction_duration: "",
    OM_duration: "",
    actual_construction_completion_date: null,
    schedule_construction_completion_date: null,
    contractor_address: "",
    grace_period: "",
  });

  const handleClose = () => {
    setShow(false);
    setFormData({
      project: projectId,
      name: "",
      cost: "",
      project_length: "",
      contractor_bid_due_date: null,
      loa_award_date: null,
      agreement_date: null,
      project_duration: "",
      commencement_date: null,
      actual_completion_date: null,
      schedule_completion_date: null,
      construction_duration: "",
      OM_duration: "",
      actual_construction_completion_date: null,
      schedule_construction_completion_date: null,
      contractor_address: "",
      grace_period: "",
    });
    setErrors({});
    setInputState({});
    setActiveSection('basic');
    setTabValidationAttempted({});
    setIsSubmitted(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clamp grace_period between 0 and 100
    let sanitizedValue = value;
    if (name === "grace_period") {
      const num = Number(value);
      if (value !== "" && (num < 0 || num > 100)) return; // block invalid input
    }

    setInputState({
      ...inputState,
      [name]: sanitizedValue?.trim() ? "green" : "",
    });
    setFormData({
      ...formData,
      [name]: sanitizedValue,
    });
    if (errors[name]) {
      setErrors(prev => {
        const updated = { ...prev };
        delete updated[name];
        return updated;
      });
    }
  };

  // Function to validate only the current tab fields
  const validateCurrentTab = () => {
    const currentTab = activeSection;
    const newErrors = {};
    const fieldsToValidate = tabRequiredFields[currentTab] || [];

    fieldsToValidate.forEach((field) => {
      if (!formData[field]) {
        const fieldLabels = {
          name: "Contractor Name",
          cost: "Cost",
          project_length: "Project Length",
          contractor_address: "Contractor Address",
          construction_duration: "Construction Duration",
          OM_duration: "O&M Duration"
        };
        newErrors[field] = `${fieldLabels[field] || field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(prev => ({ ...prev, ...newErrors }));
    setTabValidationAttempted(prev => ({ ...prev, [currentTab]: true }));

    return Object.keys(newErrors).length === 0;
  };

  // Navigate to next tab with validation
  const goToNextTab = () => {
    const currentIndex = sections.findIndex(s => s.id === activeSection);
    const nextTab = sections[currentIndex + 1]?.id;

    if (!validateCurrentTab()) {
      const formContainer = document.querySelector('.modern-modal-body');
      if (formContainer) {
        formContainer.scrollTop = 0;
      }
      return;
    }

    if (nextTab) {
      setErrors(prev => {
        const nextTabFields = tabRequiredFields[nextTab] || [];
        const filteredErrors = { ...prev };
        nextTabFields.forEach(field => {
          delete filteredErrors[field];
        });
        return filteredErrors;
      });
    }

    if (currentIndex < sections.length - 1) {
      setActiveSection(nextTab);
    }
  };

  // Navigate to previous tab
  const goToPreviousTab = () => {
    const currentIndex = sections.findIndex(s => s.id === activeSection);
    if (currentIndex > 0) {
      setActiveSection(sections[currentIndex - 1].id);
      setErrors({});
    }
  };

  // Check if current tab has errors
  const hasCurrentTabErrors = () => {
    const currentTab = activeSection;
    const fieldsToValidate = tabRequiredFields[currentTab] || [];
    return fieldsToValidate.some(field => errors[field]);
  };

  // Get current tab error message
  const getCurrentTabErrorMessage = () => {
    const currentTab = activeSection;
    const missingFields = (tabRequiredFields[currentTab] || [])
      .filter(field => !formData[field])
      .map(field => {
        const labels = {
          name: "Contractor Name",
          cost: "Cost",
          project_length: "Project Length",
          contractor_address: "Contractor Address",
          construction_duration: "Construction Duration",
          OM_duration: "O&M Duration"
        };
        return labels[field] || field;
      });

    if (missingFields.length === 0) return null;
    if (missingFields.length === 1) {
      return `${missingFields[0]} is required to proceed`;
    }
    return `Please fill all required fields in ${currentTab.charAt(0).toUpperCase() + currentTab.slice(1)} section`;
  };

  // Validate all tabs for final submission
  const validateAllTabs = () => {
    let allValid = true;
    const allErrors = {};

    Object.keys(tabRequiredFields).forEach(tab => {
      const fields = tabRequiredFields[tab];
      fields.forEach(field => {
        if (!formData[field]) {
          const labels = {
            name: "Contractor Name",
            cost: "Cost",
            project_length: "Project Length",
            contractor_address: "Contractor Address",
            construction_duration: "Construction Duration",
            OM_duration: "O&M Duration"
          };
          allErrors[field] = `${labels[field] || field} is required!`;
          allValid = false;
        }
      });
    });

    setErrors(allErrors);
    setIsSubmitted(true);
    return allValid;
  };

  const handlePost = async (e) => {
    e.preventDefault();
    if (validateAllTabs()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        const res = await axios.post(`${BASE_URL}/siteproject/contractor/`, formData);
        if (res.status === 200 || res.status === 201) {
          toast.success("Contractor added successfully!");
          if (onAddContractor) onAddContractor();
          await getProjectContractorDetails();
          await getProjects();
          getDetails();
          handleClose();
        } else {
          toast.error(`Error: ${res.statusText}`);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    } else {
      // Find first tab with errors and navigate to it
      const firstTabWithError = Object.keys(tabRequiredFields).find(tab => {
        return tabRequiredFields[tab].some(field => !formData[field]);
      });
      if (firstTabWithError) {
        setActiveSection(firstTabWithError);
        const formContainer = document.querySelector('.modern-modal-body');
        if (formContainer) {
          formContainer.scrollTop = 0;
        }
      }
    }
  };

  useEffect(() => {
    const totalMonths = Number(formData.OM_duration) + Number(formData.construction_duration);
    setFormData((prev) => ({
      ...prev,
      project_duration: totalMonths || ""
    }));
  }, [formData.OM_duration, formData.construction_duration]);

  useEffect(() => {
    const { commencement_date, construction_duration, project_duration } = formData;

    if (!commencement_date) return;

    if (construction_duration) {
      const baseDate = new Date(commencement_date);
      if (!isNaN(baseDate)) {
        const result = new Date(baseDate);
        result.setMonth(result.getMonth() + Number(construction_duration));
        if (!isNaN(result)) {
          const formatted = result.toISOString().substring(0, 10);
          setFormData(prev => ({
            ...prev,
            schedule_construction_completion_date: formatted
          }));
        }
      }
    }

    if (project_duration) {
      const baseDate2 = new Date(commencement_date);
      if (!isNaN(baseDate2)) {
        const result2 = new Date(baseDate2);
        result2.setMonth(result2.getMonth() + Number(project_duration));
        if (!isNaN(result2)) {
          const formatted2 = result2.toISOString().substring(0, 10);
          setFormData(prev => ({
            ...prev,
            schedule_completion_date: formatted2
          }));
        }
      }
    }
  }, [formData.commencement_date, formData.construction_duration, formData.project_duration]);

  const renderBasicInfo = () => (
    <div className="form-section">
      <div className="section-title">
        <Info size={18} />
        <h4>Basic Information</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><Building2 size={14} /> Contractor Name<span className="required">*</span></label>
          <input type="text" name="name" placeholder="Enter contractor name" value={formData.name} onChange={handleInputChange} className={errors.name ? "error" : inputState.name ? "success" : ""} />
          {errors.name && <span className="error-message">{errors.name}</span>}
        </div>

        <div className="form-field">
          <label><IndianRupee size={14} /> Cost (in Cr.)<span className="required">*</span></label>
          <input type="number" name="cost" placeholder="e.g. 150.5" value={formData.cost} onChange={handleInputChange} className={errors.cost ? "error" : inputState.cost ? "success" : ""} />
          {errors.cost && <span className="error-message">{errors.cost}</span>}
        </div>

        <div className="form-field">
          <label><Ruler size={14} /> Project Length (KM)<span className="required">*</span></label>
          <input type="number" name="project_length" placeholder="e.g. 18.5" value={formData.project_length} onChange={handleInputChange} className={errors.project_length ? "error" : inputState.project_length ? "success" : ""} />
          {errors.project_length && <span className="error-message">{errors.project_length}</span>}
        </div>

        <div className="form-field full-width">
          <label><MapPin size={14} /> Contractor Address<span className="required">*</span></label>
          <textarea name="contractor_address" placeholder="Enter full address" rows={3} value={formData.contractor_address} onChange={handleInputChange} className={errors.contractor_address ? "error" : inputState.contractor_address ? "success" : ""} />
          {errors.contractor_address && <span className="error-message">{errors.contractor_address}</span>}
        </div>
      </div>

      <div className="section-navigation-buttons">
        {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
          <div className="tab-error-message">
            <AlertCircle size={14} />
            <span>{getCurrentTabErrorMessage()}</span>
          </div>
        )}
        <button type="button" className="btn-next" onClick={goToNextTab}>
          Next: Dates <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );

  const renderDates = () => (
    <div className="form-section">
      <div className="section-title">
        <Calendar size={18} />
        <h4>Important Dates</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><Calendar size={14} /> Bid Due Date</label>
          <input type="date" name="contractor_bid_due_date" value={formData.contractor_bid_due_date} onChange={handleInputChange} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> LOA Date</label>
          <input type="date" name="loa_award_date" min={formData.contractor_bid_due_date} value={formData.loa_award_date} onChange={handleInputChange} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Agreement Date</label>
          <input type="date" name="agreement_date" min={formData.contractor_bid_due_date} value={formData.agreement_date} onChange={handleInputChange} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Appointed Date</label>
          <input type="date" name="commencement_date" min={formData.loa_award_date} value={formData.commencement_date} onChange={handleInputChange} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Actual Construction Completion</label>
          <input type="date" name="actual_construction_completion_date" value={formData.actual_construction_completion_date} onChange={handleInputChange} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Actual Completion Date</label>
          <input type="date" name="actual_completion_date" value={formData.actual_completion_date} onChange={handleInputChange} />
        </div>
      </div>

      <div className="section-navigation-buttons dual-buttons">
        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous: Basic Info
          </button>
          <button type="button" className="btn-next" onClick={goToNextTab}>
            Next: Duration <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );

  const renderDuration = () => (
    <div className="form-section">
      <div className="section-title">
        <Clock size={18} />
        <h4>Project Duration</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><Timer size={14} /> Construction Duration (Months)<span className="required">*</span></label>
          <input type="number" name="construction_duration" placeholder="e.g. 18" value={formData.construction_duration} onChange={handleInputChange} className={errors.construction_duration ? "error" : inputState.construction_duration ? "success" : ""} />
          {errors.construction_duration && <span className="error-message">{errors.construction_duration}</span>}
        </div>

        <div className="form-field">
          <label><Timer size={14} /> O&M Duration (Months)<span className="required">*</span></label>
          <input type="number" name="OM_duration" placeholder="e.g. 60" value={formData.OM_duration} onChange={handleInputChange} className={errors.OM_duration ? "error" : inputState.OM_duration ? "success" : ""} />
          {errors.OM_duration && <span className="error-message">{errors.OM_duration}</span>}
        </div>

        <div className="form-field">
          <label><Clock size={14} /> Total Project Duration (Months)</label>
          <input type="text" value={formData.project_duration} disabled className="readonly-field" placeholder="Auto-calculated" />
        </div>
        <div className="form-field">
          <label><Timer size={14} /> Grace Period (Days)<span className="required">*</span></label>
          <input
            type="number"
            min={0}
            max={100}
            name="grace_period"
            placeholder="e.g. 30 days"
            value={formData.grace_period}
            onChange={handleInputChange}
            onKeyDown={(e) => {
              // Block 'e', '+', '-' keys (common in number inputs)
              if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
            }}
            className={errors.grace_period ? "error" : inputState.grace_period ? "success" : ""}
          />
          {errors.grace_period && <span className="error-message">{errors.grace_period}</span>}          {errors.grace_period && <span className="error-message">{errors.grace_period}</span>}
        </div>


        <div className="form-field">
          <label><Calendar size={14} /> Schedule Construction Completion</label>
          <input type="date" value={formData.schedule_construction_completion_date} disabled className="readonly-field" />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Schedule Completion Date</label>
          <input type="date" value={formData.schedule_completion_date} disabled className="readonly-field" />
        </div>
      </div>

      <div className="section-navigation-buttons dual-buttons">
        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous: Dates
          </button>
        </div>
      </div>

      {/* Submit Buttons - Only on last tab */}
      <div className="form-actions">
        <div className="submit-buttons" style={{ justifyContent: 'flex-end', width: '100%' }}>
          <button type="button" className="btn-secondaryy" onClick={handleClose}>
            Cancel
          </button>
          <button type="submit" className="btn-primaryy" disabled={loading}>
            {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
            <span>{loading ? 'Adding...' : 'Add Contractor'}</span>
          </button>
        </div>
      </div>
    </div>
  );

  const renderCurrentSection = () => {
    switch (activeSection) {
      case 'basic': return renderBasicInfo();
      case 'dates': return renderDates();
      case 'duration': return renderDuration();
      default: return renderBasicInfo();
    }
  };

  return (
    <>
      {usefor !== "projectDetails" ?
        <button title="Add Contractor" className={`${usefor === "projectDetails" ? "upload-svg" : "primary-btn small"}`} onClick={() => setShow(true)}>

          <Plus size={18} />
          <span> {usefor !== "projectDetails" && "Add"}Contractor</span>
        </button>
        :
        <AddModalButton title="Add Contractor" onClick={() => setShow(true)} />
      }

      <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
        <Modal.Header className="modern-modal-header">
          <div className="header-content">
            <div style={{ color: "white" }}>
              <Building2 size={24} />
            </div>
            <div>
              <Modal.Title>Add Contractor Details</Modal.Title>
              <p className="header-subtitle">Fill in the details to add a new contractor</p>
            </div>
          </div>
          <button className="close-btn" onClick={handleClose}>
            <X size={20} />
          </button>
        </Modal.Header>

        <Modal.Body className="modern-modal-body">
          <div className="section-navigation">
            {sections.map((section) => {
              const Icon = section.icon;
              // Check if this tab has missing required fields
              const hasMissingRequiredFields = () => {
                const requiredFields = tabRequiredFields[section.id] || [];
                return requiredFields.some(field => !formData[field]);
              };

              return (
                <button
                  key={section.id}
                  className={`section-nav-btn ${activeSection === section.id ? 'active' : ''} ${hasMissingRequiredFields() && section.id !== activeSection ? 'has-warning' : ''}`}
                  onClick={() => {
                    // Validate current tab before switching to another tab
                    if (activeSection !== section.id) {
                      if (validateCurrentTab()) {
                        setActiveSection(section.id);
                        setErrors({});
                      } else {
                        // Show error message and stay on current tab
                        const formContainer = document.querySelector('.modern-modal-body');
                        if (formContainer) {
                          formContainer.scrollTop = 0;
                        }
                      }
                    }
                  }}
                >
                  <Icon size={16} />
                  <span>{section.label}</span>
                  {hasMissingRequiredFields() && section.id !== activeSection && (
                    <div className="warning-dot" title="Missing required fields" />
                  )}
                  {activeSection === section.id && <ChevronRight size={14} className="nav-arrow" />}
                </button>
              );
            })}
          </div>

          <form onSubmit={handlePost} className="project-form">


            {renderCurrentSection()}


          </form>
        </Modal.Body>
      </Modal>

      <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};
// const UpdateContractor = ({
//   projectId,
//   i,
//   contractor,
//   getContractorDetails,
// }) => {
//   const [show, setShow] = useState(false);
//   const [loading, setLoading] = useState(false);

//   const [formData, setFormData] = useState({
//     project: projectId,
//     name: "",
//     cost: "",
//     project_length: "",
//     contractor_bid_due_date: "null",
//     loa_award_date: "null",
//     agreement_date: "null",
//     project_duration: "null",
//     commencement_date: "null",
//     actual_completion_date: "null",
//     schedule_completion_date: "null",
//     construction_duration: "",
//     OM_duration: "",

//     actual_construction_completion_date: "null",
//     schedule_construction_completion_date: "null",
//     contractor_address: "",
//   });

//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});

//   const handleClose = () => {
//     setShow(false);
//     setFormData({
//       project: projectId,
//       name: "",
//       cost: "",
//       project_length: "",
//       contractor_bid_due_date: null,
//       loa_award_date: null,
//       agreement_date: null,
//       project_duration: "",
//       commencement_date: null,
//       actual_completion_date: null,
//       schedule_completion_date: null,
//       construction_duration: "",
//       OM_duration: "",
//       actual_construction_completion_date: null,
//       schedule_construction_completion_date: null,
//       contractor_address: "",
//     });
//     setErrors({});
//   };
//   const handleShow = () => {
//     setShow(true);
//     setFormData(i);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     if (e.target.type === "date") {
//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         [name]: value || null, // Set to null if cleared
//       }));
//     } else {

//       setFormData({
//         ...formData,
//         [name]: value,
//       });
//     }
//     setErrors((prevErrors) => ({
//       ...prevErrors,
//       [name]: "",
//     }));
//     setInputState({
//       ...inputState,
//       [name]: value.trim() ? "green" : "",
//     });

//   };

//   useEffect(() => {
//     const { commencement_date, construction_duration, project_duration } = formData;

//     if (!commencement_date) return; // stop if date is empty

//     // Calculate construction completion date
//     if (construction_duration) {
//       const baseDate = new Date(commencement_date);
//       if (!isNaN(baseDate)) {
//         const result = new Date(baseDate);
//         result.setMonth(result.getMonth() + Number(construction_duration));

//         if (!isNaN(result)) {
//           const formatted = result.toISOString().substring(0, 10);
//           setFormData(prev => ({
//             ...prev,
//             schedule_construction_completion_date: formatted
//           }));
//         }
//       }
//     } else {
//       // clear value when field is blank
//       setFormData(prev => ({
//         ...prev,
//         schedule_construction_completion_date: ""
//       }));
//     }

//     // Calculate project completion date
//     if (project_duration) {
//       const baseDate2 = new Date(commencement_date);
//       if (!isNaN(baseDate2)) {
//         const result2 = new Date(baseDate2);
//         result2.setMonth(result2.getMonth() + Number(project_duration));

//         if (!isNaN(result2)) {
//           const formatted2 = result2.toISOString().substring(0, 10);
//           setFormData(prev => ({
//             ...prev,
//             schedule_completion_date: formatted2
//           }));
//         }
//       }
//     } else {
//       setFormData(prev => ({
//         ...prev,
//         schedule_completion_date: ""
//       }));
//     }
//   }, [
//     formData.commencement_date,
//     formData.construction_duration,
//     formData.project_duration
//   ]);


//   const validateEotForm = () => {
//     const newErrors = {};
//     const requiredFields = [
//       "name",
//       "cost",
//       "project_length",
//       "construction_duration",
//       'contractor_address',
//       'OM_duration'
//     ];

//     requiredFields.forEach((field) => {
//       if (!formData[field]) {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
//           } is required!`;
//       }
//     });

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleAxiosError = (err) => {
//     handleErrorToast(err);
//   };

//   const handlePost = async (e) => {
//     e.preventDefault();
//     if (validateEotForm()) {
//       setLoading(true);
//       const loadingToastId = toast.loading("Loading: Please wait...");

//       try {
//         const res = await axios.put(
//           `${BASE_URL}/siteproject/contractor/${contractor}/`,
//           formData
//         );

//         if (res.status === 200) {
//           handleClose();
//           await getContractorDetails();
//         } else {
//           toast.error(`Error: ${res.statusText}`);
//         }
//       } catch (err) {
//         handleAxiosError(err);
//       } finally {
//         setLoading(false);
//         toast.dismiss(loadingToastId);
//       }
//     }
//   };

//   useEffect(() => {
//     const totalMonths = Number(formData.OM_duration) + Number(formData.construction_duration);
//     setFormData((prev) => ({
//       ...prev,
//       project_duration: totalMonths
//     }))
//   }, [formData.OM_duration, formData.construction_duration, formData.project_duration]);




//   return (
//     <>
//       <button
//         title="Update Contractor"
//         className="upload-svg"
//         onClick={handleShow}
//       >
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           width="24"
//           height="24"
//           fill="white"
//           viewBox="0 0 24 24"
//           id="pen-new-square"
//         >
//           <path
//             fill=""
//             fill-rule="evenodd"
//             d="M11.9426 1.25L13.5 1.25C13.9142 1.25 14.25 1.58579 14.25 2C14.25 2.41421 13.9142 2.75 13.5 2.75H12C9.62177 2.75 7.91356 2.75159 6.61358 2.92637C5.33517 3.09825 4.56445 3.42514 3.9948 3.9948C3.23505 4.75455 2.91245 5.86509 2.80417 8.03734C2.78355 8.45104 2.43146 8.76969 2.01776 8.74907C1.60406 8.72845 1.28541 8.37636 1.30603 7.96266C1.41642 5.74802 1.74641 4.12187 2.93414 2.93414C3.82895 2.03933 4.96897 1.63399 6.41371 1.43975C7.82519 1.24998 9.63423 1.24999 11.9426 1.25ZM22 9.75C22.4142 9.75 22.75 10.0858 22.75 10.5V12.0574C22.75 14.3658 22.75 16.1748 22.5603 17.5863C22.366 19.031 21.9607 20.1711 21.0659 21.0659C20.1711 21.9607 19.031 22.366 17.5863 22.5603C16.1748 22.75 14.3658 22.75 12.0574 22.75H11.9426C9.63423 22.75 7.82519 22.75 6.41371 22.5603C4.96897 22.366 3.82895 21.9607 2.93414 21.0659C2.03933 20.1711 1.63399 19.031 1.43975 17.5863C1.24998 16.1748 1.24999 14.3658 1.25 12.0574L1.25 12C1.25 11.5858 1.58579 11.25 2 11.25C2.41421 11.25 2.75 11.5858 2.75 12C2.75 14.3782 2.75159 16.0864 2.92637 17.3864C3.09825 18.6648 3.42514 19.4355 3.9948 20.0052C4.56445 20.5749 5.33517 20.9018 6.61358 21.0736C7.91356 21.2484 9.62177 21.25 12 21.25C14.3782 21.25 16.0864 21.2484 17.3864 21.0736C18.6648 20.9018 19.4355 20.5749 20.0052 20.0052C20.5749 19.4355 20.9018 18.6648 21.0736 17.3864C21.2484 16.0864 21.25 14.3782 21.25 12V10.5C21.25 10.0858 21.5858 9.75 22 9.75Z"
//             clip-rule="evenodd"
//           ></path>
//           <path
//             fill=""
//             fill-rule="evenodd"
//             d="M16.7705 2.27592C18.1384 0.908029 20.3562 0.908029 21.7241 2.27592C23.092 3.6438 23.092 5.86158 21.7241 7.22947L18.0928 10.8607C17.7999 11.1536 17.3251 11.1536 17.0322 10.8607C16.7393 10.5678 16.7393 10.093 17.0322 9.80006L19.1051 7.72709C18.5892 7.50519 17.9882 7.14946 17.4193 6.58065C16.8505 6.01185 16.4948 5.41082 16.2729 4.89486L11.2175 9.95026C10.801 10.3668 10.6376 10.532 10.4988 10.71C10.3274 10.9297 10.1804 11.1676 10.0605 11.4192C9.96337 11.623 9.88868 11.8429 9.7024 12.4017L9.27051 13.6974L10.3026 14.7295L11.5983 14.2976C12.1571 14.1113 12.377 14.0366 12.5808 13.9395C12.8324 13.8196 13.0703 13.6726 13.2901 13.5012C13.468 13.3624 13.6332 13.199 14.0497 12.7825C14.3426 12.4896 14.8175 12.4896 15.1104 12.7825C15.4033 13.0754 15.4033 13.5503 15.1104 13.8432L15.076 13.8776C14.7047 14.2489 14.4721 14.4815 14.2126 14.684C13.9069 14.9224 13.5761 15.1268 13.2261 15.2936C12.929 15.4352 12.6169 15.5392 12.1188 15.7052L9.21426 16.6734C8.67801 16.8521 8.0868 16.7126 7.68711 16.3129C7.28742 15.9132 7.14785 15.322 7.3266 14.7857L8.29477 11.8812C8.46079 11.3831 8.56479 11.071 8.7064 10.7739C8.87319 10.4239 9.07761 10.0931 9.31605 9.78742C9.51849 9.52787 9.7511 9.29529 10.1224 8.92401L16.7705 2.27592ZM17.4546 3.7132C17.4773 3.80906 17.509 3.92327 17.5532 4.05066C17.6965 4.46372 17.9677 5.00771 18.48 5.51999C18.9923 6.03227 19.5363 6.30346 19.9493 6.44677C20.0767 6.49097 20.1909 6.52273 20.2868 6.54543L20.6634 6.16881C21.4455 5.38671 21.4455 4.11867 20.6634 3.33658C19.8813 2.55448 18.6133 2.55448 17.8312 3.33658L17.4546 3.7132Z"
//             clip-rule="evenodd"
//           ></path>
//         </svg>{" "}
//         Contractor
//       </button>

//       <Modal
//         show={show}
//         onHide={handleClose}
//         dialogClassName="four-fifth-modal"
//       >
//         <Modal.Header closeButton>
//           <Modal.Title>Update Contractor Detail</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <ToastContainer
//             position="top-center"
//             autoClose={3000}
//             hideProgressBar
//           />
//           <form onSubmit={handlePost}>
//             <div className="form-flex-wrap">
//               <div className="flex-column">
//                 <label className="form-labels font-weight500 font-size-subheading" title="Name">
//                   Name<span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="name"
//                   title="Name"
//                   placeholder="Name"
//                   value={formData.name}
//                   onChange={handleInputChange}
//                   className={`form-input width-20vw ${errors.name ? "error" : inputState.name ? "success" : ""
//                     }`}
//                 />
//                 {errors.name && (
//                   <span className="error-message font-size-text">
//                     {errors.name}
//                   </span>
//                 )}
//               </div>
//               <div title="Address" className="flex-column">
//                 <label
//                   htmlFor="contractor_address"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Address <span className="required">*</span>
//                 </label>
//                 <textarea
//                   type="text"
//                   id="contractor_address"
//                   name="contractor_address"
//                   placeholder="Address"
//                   onChange={handleInputChange}
//                   rows="50"
//                   cols="100"
//                   value={formData.contractor_address}
//                   style={{ width: "40vw" }}
//                   className={`form-input ${errors.contractor_address
//                     ? "error"
//                     : inputState.contractor_address
//                       ? "success"
//                       : ""
//                     }`}

//                 />
//                 {errors.contractor_address && (
//                   <span className="error-message font-size-text ">
//                     {errors.contractor_address}
//                   </span>
//                 )}
//               </div>

//               <div className="flex-column">
//                 <label className="form-labels font-weight500 font-size-subheading" title="cost">
//                   Cost <br /><span className="required">(in cr.)*</span>
//                 </label>
//                 <input
//                   type="number"
//                   title="Cost"
//                   name="cost"
//                   placeholder="Cost"
//                   value={formData.cost}
//                   onChange={handleInputChange}
//                   className={`form-input-date width-10vw ${errors.cost ? "error" : inputState.cost ? "success" : ""
//                     }`}
//                 />
//                 {errors.cost && (
//                   <span className="error-message font-size-text">
//                     {errors.cost}
//                   </span>
//                 )}
//               </div>

//               <div title="Project Length" className="flex-column">
//                 <label
//                   htmlFor="project_length"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Project Length <br /><span className="required">(in kms)*</span>
//                 </label>
//                 <input
//                   type="number"
//                   id="project_length"
//                   name="project_length"
//                   placeholder="10"
//                   onChange={handleInputChange}
//                   value={formData.project_length}
//                   className={`form-input-date width-10vw ${errors.project_length
//                     ? "error"
//                     : inputState.project_length
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.project_length && (
//                   <span className="error-message font-size-text ">
//                     {errors.project_length}
//                   </span>
//                 )}
//               </div>


//               <div title="Construction Duration" className="flex-column">
//                 <label
//                   htmlFor="construction_duration"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Construction Duration
//                   <br /><span className="required">(in months)*</span>
//                 </label>
//                 <input
//                   type="number"
//                   id="construction_duration"
//                   name="construction_duration"
//                   placeholder="0"
//                   onChange={handleInputChange}
//                   value={formData.construction_duration}
//                   className={`form-input-date width-10vw ${errors.construction_duration
//                     ? "error"
//                     : inputState.construction_duration
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.construction_duration && (
//                   <span className="error-message font-size-text ">
//                     {errors.construction_duration}
//                   </span>
//                 )}
//               </div>
//               <div title="O&M Duration" className="flex-column">
//                 <label
//                   htmlFor="OM_duration"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   O&M Duration
//                   <br /><span className="required">(in months)*</span>
//                 </label>
//                 <input
//                   type="number"
//                   id="OM_duration"
//                   name="OM_duration"
//                   placeholder="0"
//                   onChange={handleInputChange}
//                   value={formData.OM_duration}
//                   className={`form-input-date width-10vw ${errors.OM_duration
//                     ? "error"
//                     : inputState.OM_duration
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.OM_duration && (
//                   <span className="error-message font-size-text ">
//                     {errors.OM_duration}
//                   </span>
//                 )}
//               </div>
//               <div title="Project Duration" className="flex-column">
//                 <label
//                   htmlFor="project_duration"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Project Duration
//                   <br /><span className="required">(Auto-Calculate)</span>
//                 </label>
//                 <input
//                   type="number"
//                   id="project_duration"
//                   name="project_duration"
//                   readOnly
//                   placeholder="0"
//                   onChange={handleInputChange}
//                   value={formData.project_duration}
//                   className={`form-input-date width-10vw ${errors.project_duration
//                     ? "error"
//                     : inputState.project_duration
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.project_duration && (
//                   <span className="error-message font-size-text ">
//                     {errors.project_duration}
//                   </span>
//                 )}
//               </div>

//               <div title="Contractor Bid Due Date" className="flex-column">
//                 <label
//                   htmlFor="contractor_bid_due_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Contractor Bid Due Date
//                 </label>
//                 <input
//                   type="date"
//                   id="contractor_bid_due_date"
//                   name="contractor_bid_due_date"
//                   placeholder="Contractor Bid Due Date"
//                   onChange={handleInputChange}
//                   value={formData.contractor_bid_due_date}
//                   className={`form-input-date width-15vw ${errors.contractor_bid_due_date
//                     ? "error"
//                     : inputState.contractor_bid_due_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.contractor_bid_due_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.contractor_bid_due_date}
//                   </span>
//                 )}
//               </div>

//               <div title="LOA Date" className="flex-column">
//                 <label
//                   htmlFor="loa_award_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   LOA Date
//                 </label>
//                 <input
//                   type="date"
//                   id="loa_award_date"
//                   name="loa_award_date"
//                   min={formData.contractor_bid_due_date}
//                   placeholder="Award Date"
//                   onChange={handleInputChange}
//                   value={formData.loa_award_date}
//                   className={`form-input-date width-15vw ${errors.loa_award_date
//                     ? "error"
//                     : inputState.loa_award_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.loa_award_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.loa_award_date}
//                   </span>
//                 )}
//               </div>

//               <div title="Agreement Date" className="flex-column">
//                 <label
//                   htmlFor="agreement_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Agreement Date
//                 </label>
//                 <input
//                   type="date"
//                   id="agreement_date"
//                   name="agreement_date"
//                   min={formData.contractor_bid_due_date}
//                   placeholder="Agreement Date"
//                   onChange={handleInputChange}
//                   value={formData.agreement_date}
//                   className={`form-input-date width-15vw ${errors.agreement_date
//                     ? "error"
//                     : inputState.agreement_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.agreement_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.agreement_date}
//                   </span>
//                 )}
//               </div>

//               <div title="Appointed Date" className="flex-column">
//                 <label
//                   htmlFor="commencement_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Appointed Date
//                 </label>
//                 <input
//                   type="date"
//                   id="commencement_date"
//                   name="commencement_date"
//                   min={formData.loa_award_date}
//                   placeholder="Appointed Date"
//                   onChange={handleInputChange}
//                   value={formData.commencement_date}
//                   className={`form-input-date width-15vw ${errors.commencement_date
//                     ? "error"
//                     : inputState.commencement_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.commencement_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.commencement_date}
//                   </span>
//                 )}
//               </div>

//               <div
//                 title="Schedule Construction Completion Date"
//                 className="flex-column"
//               >
//                 <label
//                   htmlFor="schedule_construction_completion_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Schedule Const.

//                   Completion  <br /> Date <span className="required">(Auto-Calculate)</span>

//                 </label>
//                 <input
//                   type="date"
//                   id="schedule_construction_completion_date"
//                   name="schedule_construction_completion_date"
//                   min={formData.commencement_date}
//                   disabled
//                   placeholder="Schedule Construction Completion Date"
//                   onChange={handleInputChange}
//                   value={formData.schedule_construction_completion_date}
//                   className={`form-input-date width-15vw ${errors.schedule_construction_completion_date
//                     ? "error"
//                     : inputState.schedule_construction_completion_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.schedule_construction_completion_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.schedule_construction_completion_date}
//                   </span>
//                 )}
//               </div>

//               <div title="Schedule Completion Date" className="flex-column">
//                 <label
//                   htmlFor="schedule_completion_date"
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Schedule Completion Date
//                   <br />
//                   <span className="required">(Auto-Calculate)</span>
//                 </label>
//                 <input
//                   type="date"
//                   id="schedule_completion_date"
//                   name="schedule_completion_date"
//                   min={formData.schedule_construction_completion_date}
//                   placeholder="Schedule Completion Date"
//                   onChange={handleInputChange}
//                   disabled
//                   value={formData.schedule_completion_date}
//                   className={`form-input-date width-15vw ${errors.schedule_completion_date
//                     ? "error"
//                     : inputState.schedule_completion_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.schedule_completion_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.schedule_completion_date}
//                   </span>
//                 )}
//               </div>

//               <div title="Actual Completion Date" className="flex-column">
//                 <label
//                   htmlFor="actual_completion_date"
//                   style={{ marginBottom: "25px" }}
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Actual Completion Date
//                 </label>
//                 <input
//                   type="date"
//                   id="actual_completion_date"
//                   name="actual_completion_date"
//                   placeholder="Actual Completion Date"
//                   onChange={handleInputChange}
//                   value={formData.actual_completion_date}
//                   className={`form-input-date width-15vw ${errors.actual_completion_date
//                     ? "error"
//                     : inputState.actual_completion_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.actual_completion_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.actual_completion_date}
//                   </span>
//                 )}
//               </div>

//               <div
//                 title="Actual Construction Completion Date"
//                 className="flex-column"
//               >
//                 <label
//                   htmlFor="actual_construction_completion_date"
//                   style={{ marginBottom: "25px" }}
//                   className="form-labels  font-weight500    font-size-subheading"
//                 >
//                   Actual Const. Completion Date
//                 </label>
//                 <input
//                   type="date"
//                   id="actual_construction_completion_date"
//                   name="actual_construction_completion_date"
//                   placeholder="Actual Construction Completion Date"
//                   onChange={handleInputChange}
//                   value={formData.actual_construction_completion_date}
//                   className={`form-input-date width-15vw ${errors.actual_construction_completion_date
//                     ? "error"
//                     : inputState.actual_construction_completion_date
//                       ? "success"
//                       : ""
//                     }`}
//                 />
//                 {errors.actual_construction_completion_date && (
//                   <span className="error-message font-size-text ">
//                     {errors.actual_construction_completion_date}
//                   </span>
//                 )}
//               </div>


//             </div>
//             <div className="button-models">
//               <button
//                 className="model-button   font-weight500    model-button-cancel"
//                 onClick={handleClose}
//               >
//                 Cancel
//               </button>
//               <button
//                 className="model-button font-weight500 model-button-leave font-size-heading"
//                 type="submit"
//                 disabled={loading}
//               >
//                 {loading ? "Updating..." : "Update"}
//               </button>
//             </div>
//           </form>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };

const UpdateContractor = ({
  projectId,
  i,
  contractor,
  getContractorDetails,
}) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [activeSection, setActiveSection] = useState('basic');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [tabValidationAttempted, setTabValidationAttempted] = useState({});

  const sections = [
    { id: 'basic', label: 'Basic Info', icon: Info },
    { id: 'dates', label: 'Dates', icon: Calendar },
    { id: 'duration', label: 'Duration', icon: Clock },
  ];

  // Define required fields for each tab
  const tabRequiredFields = {
    basic: ["name", "cost", "project_length", "contractor_address"],
    dates: [],
    duration: ["construction_duration", "OM_duration"]
  };

  const [formData, setFormData] = useState({
    project: projectId,
    name: "",
    cost: "",
    project_length: "",
    contractor_bid_due_date: null,
    loa_award_date: null,
    agreement_date: null,
    project_duration: "",
    commencement_date: null,
    actual_completion_date: null,
    schedule_completion_date: null,
    construction_duration: "",
    OM_duration: "",
    grace_period: "",
    actual_construction_completion_date: null,
    schedule_construction_completion_date: null,
    contractor_address: "",
  });

  const handleClose = () => {
    setShow(false);
    setFormData({
      project: projectId,
      name: "",
      cost: "",
      project_length: "",
      contractor_bid_due_date: null,
      loa_award_date: null,
      agreement_date: null,
      project_duration: "",
      commencement_date: null,
      actual_completion_date: null,
      schedule_completion_date: null,
      construction_duration: "",
      OM_duration: "",
      grace_period: "",
      actual_construction_completion_date: null,
      schedule_construction_completion_date: null,
      contractor_address: "",
    });
    setErrors({});
    setInputState({});
    setActiveSection('basic');
    setTabValidationAttempted({});
    setIsSubmitted(false);
  };

  const handleShow = () => {
    setShow(true);
    setFormData(i);
    setActiveSection('basic');
    setErrors({});
    setTabValidationAttempted({});
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Clamp grace_period between 0 and 100
    let sanitizedValue = value;
    if (name === "grace_period") {
      const num = Number(value);
      if (value !== "" && (num < 0 || num > 100)) return; // block invalid input
    }

    setInputState({
      ...inputState,
      [name]: sanitizedValue?.trim() ? "green" : "",
    });
    setFormData({
      ...formData,
      [name]: sanitizedValue,
    });
    if (errors[name]) {
      setErrors(prev => {
        const updated = { ...prev };
        delete updated[name];
        return updated;
      });
    }
  };

  // Function to validate only the current tab fields
  const validateCurrentTab = () => {
    const currentTab = activeSection;
    const newErrors = {};
    const fieldsToValidate = tabRequiredFields[currentTab] || [];

    fieldsToValidate.forEach((field) => {
      if (!formData[field]) {
        const fieldLabels = {
          name: "Contractor Name",
          cost: "Cost",
          project_length: "Project Length",
          contractor_address: "Contractor Address",
          construction_duration: "Construction Duration",
          OM_duration: "O&M Duration"
        };
        newErrors[field] = `${fieldLabels[field] || field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(prev => ({ ...prev, ...newErrors }));
    setTabValidationAttempted(prev => ({ ...prev, [currentTab]: true }));

    return Object.keys(newErrors).length === 0;
  };

  // Navigate to next tab with validation
  const goToNextTab = () => {
    const currentIndex = sections.findIndex(s => s.id === activeSection);
    const nextTab = sections[currentIndex + 1]?.id;

    if (!validateCurrentTab()) {
      const formContainer = document.querySelector('.modern-modal-body');
      if (formContainer) {
        formContainer.scrollTop = 0;
      }
      return;
    }

    if (nextTab) {
      setErrors(prev => {
        const nextTabFields = tabRequiredFields[nextTab] || [];
        const filteredErrors = { ...prev };
        nextTabFields.forEach(field => {
          delete filteredErrors[field];
        });
        return filteredErrors;
      });
    }

    if (currentIndex < sections.length - 1) {
      setActiveSection(nextTab);
    }
  };

  // Navigate to previous tab
  const goToPreviousTab = () => {
    const currentIndex = sections.findIndex(s => s.id === activeSection);
    if (currentIndex > 0) {
      setActiveSection(sections[currentIndex - 1].id);
      setErrors({});
    }
  };

  // Check if current tab has errors
  const hasCurrentTabErrors = () => {
    const currentTab = activeSection;
    const fieldsToValidate = tabRequiredFields[currentTab] || [];
    return fieldsToValidate.some(field => errors[field]);
  };

  // Get current tab error message
  const getCurrentTabErrorMessage = () => {
    const currentTab = activeSection;
    const missingFields = (tabRequiredFields[currentTab] || [])
      .filter(field => !formData[field])
      .map(field => {
        const labels = {
          name: "Contractor Name",
          cost: "Cost",
          project_length: "Project Length",
          contractor_address: "Contractor Address",
          construction_duration: "Construction Duration",
          OM_duration: "O&M Duration"
        };
        return labels[field] || field;
      });

    if (missingFields.length === 0) return null;
    if (missingFields.length === 1) {
      return `${missingFields[0]} is required to proceed`;
    }
    return `Please fill all required fields in ${currentTab.charAt(0).toUpperCase() + currentTab.slice(1)} section`;
  };

  // Validate all tabs for final submission
  const validateAllTabs = () => {
    let allValid = true;
    const allErrors = {};

    Object.keys(tabRequiredFields).forEach(tab => {
      const fields = tabRequiredFields[tab];
      fields.forEach(field => {
        if (!formData[field]) {
          const labels = {
            name: "Contractor Name",
            cost: "Cost",
            project_length: "Project Length",
            contractor_address: "Contractor Address",
            construction_duration: "Construction Duration",
            OM_duration: "O&M Duration"
          };
          allErrors[field] = `${labels[field] || field} is required!`;
          allValid = false;
        }
      });
    });

    setErrors(allErrors);
    setIsSubmitted(true);
    return allValid;
  };

  const handleUpdate = async (e) => {
    e.preventDefault();
    if (validateAllTabs()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");

      try {
        const res = await axios.put(
          `${BASE_URL}/siteproject/contractor/${contractor}/`,
          formData
        );

        if (res.status === 200 || res.status === 201) {
          toast.success("Contractor updated successfully!");
          handleClose();
          await getContractorDetails();
        } else {
          toast.error(`Error: ${res.statusText}`);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    } else {
      const firstTabWithError = Object.keys(tabRequiredFields).find(tab => {
        return tabRequiredFields[tab].some(field => !formData[field]);
      });
      if (firstTabWithError) {
        setActiveSection(firstTabWithError);
        const formContainer = document.querySelector('.modern-modal-body');
        if (formContainer) {
          formContainer.scrollTop = 0;
        }
      }
    }
  };

  useEffect(() => {
    const totalMonths = Number(formData.OM_duration) + Number(formData.construction_duration);
    setFormData((prev) => ({
      ...prev,
      project_duration: totalMonths || ""
    }));
  }, [formData.OM_duration, formData.construction_duration]);

  useEffect(() => {
    const { commencement_date, construction_duration, project_duration } = formData;

    if (!commencement_date) return;

    if (construction_duration) {
      const baseDate = new Date(commencement_date);
      if (!isNaN(baseDate)) {
        const result = new Date(baseDate);
        result.setMonth(result.getMonth() + Number(construction_duration));
        if (!isNaN(result)) {
          const formatted = result.toISOString().substring(0, 10);
          setFormData(prev => ({
            ...prev,
            schedule_construction_completion_date: formatted
          }));
        }
      }
    }

    if (project_duration) {
      const baseDate2 = new Date(commencement_date);
      if (!isNaN(baseDate2)) {
        const result2 = new Date(baseDate2);
        result2.setMonth(result2.getMonth() + Number(project_duration));
        if (!isNaN(result2)) {
          const formatted2 = result2.toISOString().substring(0, 10);
          setFormData(prev => ({
            ...prev,
            schedule_completion_date: formatted2
          }));
        }
      }
    }
  }, [formData.commencement_date, formData.construction_duration, formData.project_duration]);

  const renderBasicInfo = () => (
    <div className="form-section">
      <div className="section-title">
        <Info size={18} />
        <h4>Basic Information</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><Building2 size={14} /> Contractor Name<span className="required">*</span></label>
          <input type="text" name="name" placeholder="Enter contractor name" value={formData.name} onChange={handleInputChange} className={errors.name ? "error" : inputState.name ? "success" : ""} />
          {errors.name && <span className="error-message">{errors.name}</span>}
        </div>

        <div className="form-field">
          <label><IndianRupee size={14} /> Cost (in Cr.)<span className="required">*</span></label>
          <input type="number" name="cost" placeholder="e.g. 150.5" value={formData.cost} onChange={handleInputChange} className={errors.cost ? "error" : inputState.cost ? "success" : ""} />
          {errors.cost && <span className="error-message">{errors.cost}</span>}
        </div>

        <div className="form-field">
          <label><Ruler size={14} /> Project Length (KM)<span className="required">*</span></label>
          <input type="number" name="project_length" placeholder="e.g. 18.5" value={formData.project_length} onChange={handleInputChange} className={errors.project_length ? "error" : inputState.project_length ? "success" : ""} />
          {errors.project_length && <span className="error-message">{errors.project_length}</span>}
        </div>

        <div className="form-field full-width">
          <label><MapPin size={14} /> Contractor Address<span className="required">*</span></label>
          <textarea name="contractor_address" placeholder="Enter full address" rows={3} value={formData.contractor_address} onChange={handleInputChange} className={errors.contractor_address ? "error" : inputState.contractor_address ? "success" : ""} />
          {errors.contractor_address && <span className="error-message">{errors.contractor_address}</span>}
        </div>
      </div>

      <div className="section-navigation-buttons">
        {tabValidationAttempted[activeSection] && hasCurrentTabErrors() && (
          <div className="tab-error-message">
            <AlertCircle size={14} />
            <span>{getCurrentTabErrorMessage()}</span>
          </div>
        )}
        <button type="button" className="btn-next" onClick={goToNextTab}>
          Next: Dates <ChevronRight size={16} />
        </button>
      </div>
    </div>
  );

  const renderDates = () => (
    <div className="form-section">
      <div className="section-title">
        <Calendar size={18} />
        <h4>Important Dates</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><Calendar size={14} /> Bid Due Date</label>
          <input type="date" name="contractor_bid_due_date" value={formData.contractor_bid_due_date || ""} onChange={handleInputChange} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> LOA Date</label>
          <input type="date" name="loa_award_date" min={formData.contractor_bid_due_date} value={formData.loa_award_date || ""} onChange={handleInputChange} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Agreement Date</label>
          <input type="date" name="agreement_date" min={formData.contractor_bid_due_date} value={formData.agreement_date || ""} onChange={handleInputChange} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Appointed Date</label>
          <input type="date" name="commencement_date" min={formData.loa_award_date} value={formData.commencement_date || ""} onChange={handleInputChange} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Actual Construction Completion</label>
          <input type="date" name="actual_construction_completion_date" value={formData.actual_construction_completion_date || ""} onChange={handleInputChange} />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Actual Completion Date</label>
          <input type="date" name="actual_completion_date" value={formData.actual_completion_date || ""} onChange={handleInputChange} />
        </div>
      </div>

      <div className="section-navigation-buttons dual-buttons">
        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous: Basic Info
          </button>
          <button type="button" className="btn-next" onClick={goToNextTab}>
            Next: Duration <ChevronRight size={16} />
          </button>
        </div>
      </div>
    </div>
  );

  const renderDuration = () => (
    <div className="form-section">
      <div className="section-title">
        <Clock size={18} />
        <h4>Project Duration</h4>
      </div>
      <div className="form-grid">
        <div className="form-field">
          <label><Timer size={14} /> Construction Duration (Months)<span className="required">*</span></label>
          <input type="number" name="construction_duration" placeholder="e.g. 18" value={formData.construction_duration} onChange={handleInputChange} className={errors.construction_duration ? "error" : inputState.construction_duration ? "success" : ""} />
          {errors.construction_duration && <span className="error-message">{errors.construction_duration}</span>}
        </div>

        <div className="form-field">
          <label><Timer size={14} /> O&M Duration (Months)<span className="required">*</span></label>
          <input type="number" name="OM_duration" placeholder="e.g. 60" value={formData.OM_duration} onChange={handleInputChange} className={errors.OM_duration ? "error" : inputState.OM_duration ? "success" : ""} />
          {errors.OM_duration && <span className="error-message">{errors.OM_duration}</span>}
        </div>

        <div className="form-field">
          <label><Clock size={14} /> Total Project Duration (Months)</label>
          <input type="text" value={formData.project_duration} disabled className="readonly-field" placeholder="Auto-calculated" />
        </div>

        <div className="form-field">
          <label><Timer size={14} /> Grace Period (Days)<span className="required">*</span></label>
          <input
            type="number"
            min={0}
            max={100}
            name="grace_period"
            placeholder="e.g. 30 days"
            value={formData.grace_period}
            onChange={handleInputChange}
            onKeyDown={(e) => {
              // Block 'e', '+', '-' keys (common in number inputs)
              if (["e", "E", "+", "-"].includes(e.key)) e.preventDefault();
            }}
            className={errors.grace_period ? "error" : inputState.grace_period ? "success" : ""}
          />
          {errors.grace_period && <span className="error-message">{errors.grace_period}</span>}          {errors.grace_period && <span className="error-message">{errors.grace_period}</span>}
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Schedule Construction Completion</label>
          <input type="date" value={formData.schedule_construction_completion_date || ""} disabled className="readonly-field" />
        </div>

        <div className="form-field">
          <label><Calendar size={14} /> Schedule Completion Date</label>
          <input type="date" value={formData.schedule_completion_date || ""} disabled className="readonly-field" />
        </div>
      </div>

      <div className="section-navigation-buttons dual-buttons">
        <div className="nav-buttons-wrapper">
          <button type="button" className="btn-prev" onClick={goToPreviousTab}>
            <ChevronRight size={16} className="rotate-left" /> Previous: Dates
          </button>
        </div>
      </div>

      <div className="form-actions">
        <div className="submit-buttons" style={{ justifyContent: 'flex-end', width: '100%' }}>
          <button type="button" className="btn-secondaryy" onClick={handleClose}>
            Cancel
          </button>
          <button type="submit" className="btn-primaryy" disabled={loading}>
            {loading ? <Loader size={18} className="spinning" /> : <Save size={18} />}
            <span>{loading ? 'Updating...' : 'Update Contractor'}</span>
          </button>
        </div>
      </div>
    </div>
  );

  const renderCurrentSection = () => {
    switch (activeSection) {
      case 'basic': return renderBasicInfo();
      case 'dates': return renderDates();
      case 'duration': return renderDuration();
      default: return renderBasicInfo();
    }
  };

  return (
    <>
      <button title="Update Contractor" className="upload-svg" onClick={handleShow}>
        <Edit size={18} />
        <span>Contractor</span>
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="modern-project-modal" size="xl">
        <Modal.Header className="modern-modal-header">
          <div className="header-content">
            <div style={{ color: "white" }}>
              <Building2 size={24} />
            </div>
            <div>
              <Modal.Title>Update Contractor Details</Modal.Title>
              <p className="header-subtitle">Update the contractor information</p>
            </div>
          </div>
          <button className="close-btn" onClick={handleClose}>
            <X size={20} />
          </button>
        </Modal.Header>

        <Modal.Body className="modern-modal-body">
          <div className="section-navigation">
            {sections.map((section) => {
              const Icon = section.icon;
              // Check if this tab has missing required fields
              const hasMissingFields = () => {
                const requiredFields = tabRequiredFields[section.id] || [];
                return requiredFields.some(field => !formData[field]);
              };

              return (
                <button
                  key={section.id}
                  className={`section-nav-btn ${activeSection === section.id ? 'active' : ''} ${hasMissingFields() && section.id !== activeSection ? 'has-warning' : ''}`}
                  onClick={() => {
                    // Validate current tab before switching
                    if (activeSection !== section.id) {
                      if (validateCurrentTab()) {
                        setActiveSection(section.id);
                        setErrors({});
                      } else {
                        // Show error message and stay on current tab
                        const formContainer = document.querySelector('.modern-modal-body');
                        if (formContainer) {
                          formContainer.scrollTop = 0;
                        }
                      }
                    }
                  }}
                >
                  <Icon size={16} />
                  <span>{section.label}</span>
                  {hasMissingFields() && section.id !== activeSection && (
                    <div className="warning-dot" />
                  )}
                  {activeSection === section.id && <ChevronRight size={14} className="nav-arrow" />}
                </button>
              );
            })}
          </div>

          <form onSubmit={handleUpdate} className="project-form">
            {renderCurrentSection()}



          </form>
        </Modal.Body>
      </Modal>

      <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} newestOnTop closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
    </>
  );
};

const DeleteContractor = ({ contractor, getProjectContractorDetails, getcontractor, getproject }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic

    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/contractor/${contractor}/`
      );

      if (res.status === 200) {
        await getProjectContractorDetails();
        await getproject();
        setShow(false);
        toast.success("Deleted Successfully");
        toast.dismiss(loadingToastId);

      } else {
        alert(res);
      }
    } catch (err) {
      //toast Logic
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete Contractor"
        className="model-delete-button"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
        >
          <path
            d="M15.1875 3.375H12.375V2.8125C12.375 2.36495 12.1972 1.93572 11.8807 1.61926C11.5643 1.30279 11.1351 1.125 10.6875 1.125H7.3125C6.86495 1.125 6.43572 1.30279 6.11926 1.61926C5.80279 1.93572 5.625 2.36495 5.625 2.8125V3.375H2.8125C2.66332 3.375 2.52024 3.43426 2.41475 3.53975C2.30926 3.64524 2.25 3.78832 2.25 3.9375C2.25 4.08668 2.30926 4.22976 2.41475 4.33525C2.52024 4.44074 2.66332 4.5 2.8125 4.5H3.375V14.625C3.375 14.9234 3.49353 15.2095 3.7045 15.4205C3.91548 15.6315 4.20163 15.75 4.5 15.75H13.5C13.7984 15.75 14.0845 15.6315 14.2955 15.4205C14.5065 15.2095 14.625 14.9234 14.625 14.625V4.5H15.1875C15.3367 4.5 15.4798 4.44074 15.5852 4.33525C15.6907 4.22976 15.75 4.08668 15.75 3.9375C15.75 3.78832 15.6907 3.64524 15.5852 3.53975C15.4798 3.43426 15.3367 3.375 15.1875 3.375ZM6.75 2.8125C6.75 2.66332 6.80926 2.52024 6.91475 2.41475C7.02024 2.30926 7.16332 2.25 7.3125 2.25H10.6875C10.8367 2.25 10.9798 2.30926 11.0852 2.41475C11.1907 2.52024 11.25 2.66332 11.25 2.8125V3.375H6.75V2.8125ZM13.5 14.625H4.5V4.5H13.5V14.625ZM7.875 7.3125V11.8125C7.875 11.9617 7.81574 12.1048 7.71025 12.2102C7.60476 12.3157 7.46168 12.375 7.3125 12.375C7.16332 12.375 7.02024 12.3157 6.91475 12.2102C6.80926 12.1048 6.75 11.9617 6.75 11.8125V7.3125C6.75 7.16332 6.80926 7.02024 6.91475 6.91475C7.02024 6.80926 7.16332 6.75 7.3125 6.75C7.46168 6.75 7.60476 6.80926 7.71025 6.91475C7.81574 7.02024 7.875 7.16332 7.875 7.3125ZM11.25 7.3125V11.8125C11.25 11.9617 11.1907 12.1048 11.0852 12.2102C10.9798 12.3157 10.8367 12.375 10.6875 12.375C10.5383 12.375 10.3952 12.3157 10.2898 12.2102C10.1843 12.1048 10.125 11.9617 10.125 11.8125V7.3125C10.125 7.16332 10.1843 7.02024 10.2898 6.91475C10.3952 6.80926 10.5383 6.75 10.6875 6.75C10.8367 6.75 10.9798 6.80926 11.0852 6.91475C11.1907 7.02024 11.25 7.16332 11.25 7.3125Z"
            fill="#F72B50"
          />
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Delete Contractor</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want to delete Contractor
            <div className="button-models">
              <button
                className="model-button font-weight500"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitDelete}
                className="model-button   font-weight500    model-button-delete"
              >
                Delete
              </button>
            </div>
          </div>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};









const AddEOTDetails = ({
  project,
  getEot,
  toggleState,
  contractorlist,
  contractor,
  site_prcode,
  projectName,

}) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    project: project,
    eot_code: "",
    workperformedby: toggleState,
    letter: "",
    days: "",
    contractor: toggleState === "contractor" ? contractor : "",
    process_initiate_date: "",
    eot_status: "pending"

  });

  const [trackRecordList, setTrackRecordList] = useState([]);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const handleClose = () => {
    setShow(false);
    setFormData({
      project: project,
      eot_code: "",
      days: "",
      process_initiate_date: "",
      contractor: toggleState === "contractor" ? contractor : "",
      workperformedby: toggleState,
      letter: "",
      eot_status: "pending"

    })
    setErrors("");
  }



  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      contractor: toggleState === "contractor" ? contractor : "",
    }));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [contractor]);



  const handleShow = () => {
    setShow(true)
  };

  const getLetters = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        contractor ?
          `${BASE_URL}/siteproject/letterrecordbyfilters/${project}/${formData.workperformedby}/eot/${contractor}/` :
          `${BASE_URL}/siteproject/letterrecordbyfilters/${project}/${formData.workperformedby}/eot/`
      );
      setTrackRecordList(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getLetters();
  }, [formData.workperformedby, contractor]);


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });
    setFormData({
      ...formData,
      [name]: value,
    });
    if (errors[name]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[name]; // Remove the specific field's error
        return newErrors;
      });
    }
  };

  const validateEotForm = () => {
    const newErrors = {};
    const requiredFields = [
      "eot_code",
      "letter",
      "process_initiate_date",
      "days",

    ];

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });


    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) {
      toast.dismiss();
      toast.warn("Fill all * fields");
      return false;
    }
    return Object.keys(newErrors).length === 0;



  };

  const handleAxiosError = (err) => {
    handleErrorToast(err);
  };

  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);


  const handleEotPost = async (e) => {
    e.preventDefault();
    if (validateEotForm()) {
      setShowProgressModal(true);
      setLoading(true);
      setUploadProgress(0);

      const loadingToastId = toast.loading("Uploading: please wait...");
      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setUploadProgress(progress);
      }, 100);

      try {


        const res = await axios.post(`${BASE_URL}/siteproject/eot/`, formData);

        if (res.status === 200) {
          await getEot();
          handleClose();
          setTimeout(() => {
            toast.dismiss(loadingToastId);
            toast.success("EOT data added successfully.", {
              autoClose: 1000,
              pauseOnHover: true,
              closeOnClick: true,
            });
          }, 1000);
        } else {
          throw new Error("Unexpected response status: " + res.status);
        }

      } catch (err) {
        clearInterval(interval);
        setUploadProgress(0);
        handleErrorToast(err);
      } finally {
        clearInterval(interval);

        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);

        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };




  return (
    <>
      <button title='Add EOT' className='upload-svg float-right equal-hi' style={{ margin: 0 }} onClick={handleShow}>

        <AddwithWhiteCircle />
        {" "} EOT
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" /> :
          show === true ?
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
              <Modal.Header closeButton>
                <Modal.Title>Add EOT Detail</Modal.Title>
              </Modal.Header>
              <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
              <Modal.Body>
                <div className="form-flex-wrap">
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading"
                      title="EOT Code">EOT Code<span className="required">*</span></label>
                    <input
                      type="text"
                      name="eot_code"
                      placeholder="EOT Code"
                      title="EOT Code"
                      value={formData.eot_code}
                      onChange={handleInputChange}
                      className={`form-input-date width-17vw ${errors.eot_code ? "error" : inputState.eot_code ? "success" : ""}`}
                    />
                    {errors.eot_code && <span className="error-message font-size-text">{errors.eot_code}</span>}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading" title="Process initiate Date">Initial Submission Date<span className="required">*</span></label>
                    <input
                      type="date"
                      name="process_initiate_date"
                      title="Process initiate Date"
                      value={formData.process_initiate_date}
                      onChange={handleInputChange}
                      className={`form-input-date width-17vw ${errors.process_initiate_date ? "error" : inputState.process_initiate_date ? "success" : ""}`}
                    />
                    {errors.process_initiate_date && <span className="error-message font-size-text">{errors.process_initiate_date}</span>}
                  </div>
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading" title="Days">
                      Initial Submission Days<span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="days"
                      title="Days"
                      placeholder="Number of Days"
                      value={formData.days}
                      onChange={handleInputChange}
                      className={`form-input-date width-17vw ${errors.days
                        ? "error"
                        : inputState.days
                          ? "success"
                          : ""
                        }`}
                    />
                    {errors.days && (
                      <span className="error-message font-size-text">
                        {errors.days}
                      </span>
                    )}
                  </div>
                  <div className="form-group">
                    <div className="flex-column form-group-selectt">
                      <label className="form-labels font-weight500 font-size-subheading" title="Initiate Letter">Initial Submission Letter<span className="required">*</span></label>
                      <br />
                      <select
                        name="letter"
                        title="Letter"
                        value={formData.letter}
                        onChange={handleInputChange}
                        className={`form-input-date width-17vw form-group-selection ${errors.letter ? "error" : inputState.letter ? "success" : ""}`}
                      >
                        <option value="" title="Select Option">Select Option</option>
                        {trackRecordList.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.letter_num}
                          </option>
                        ))}
                      </select>

                    </div>
                    {errors.letter && <div className="error-message font-size-text">{errors.letter}</div>}
                  </div>
                </div>
                {formData.letter ? (
                  ""
                ) : (
                  <>
                    <div
                      style={{ display: "flex", justifyContent: "space-evenly" }}
                    >
                      <div>OR</div>
                    </div>

                    <div className="button-models">
                      <AddTrackRecordDetails
                        projectId={project}
                        contractor={contractor}
                        letterfor={formData.workperformedby}
                        lettertype="eot"
                        getProjects={getLetters}
                        title="EOT Letter"
                        site_prcode={site_prcode}
                        projectName={projectName}

                      />
                    </div>
                  </>
                )}








                <div className="button-models" style={{ marginTop: "20px", justifyContent: "space-evenly" }}>
                  <button className="cancelbutton" onClick={handleClose}>Cancel</button>

                  <Addbutton onclick={handleEotPost} />
                </div>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};




const UpdateEOTDetails = ({ i, getEot, toggleState, project, contractor, contractor_date, contractor_id, site_prcode,
  projectName }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({

    eot_code: "",
    approved_date: null,
    approved_days: "0",
    process_initiate_date: "",
    workperformedby: toggleState,
    close_letter: "",
    eot_status: "pending",
    ae_eot_status: "pending",
    ae_approved_days: "null",
    ae_close_letter: "null",
    ae_reject_date: null,
    ae_approved_date: null,
    ae_ie_observation_date: null,
    ae_ie_observation_letter: null,
    ae_ie_rejected_letter: null,
    client_rejected_date: null,
    client_seek_clarfication_letter: null,
    client_rejected_letter: null,





  });

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const handleClose = () => {
    setShow(false);
    setErrors("");

  }

  const handleShow = () => {
    setShow(true)
    setFormData(i);
    getLetters();

  };




  const [ContractorData, setContractorData] = useState({
    schedule_construction_completion_date_with_eot: null,
    EOT_Days: "null"
  });
  useEffect(() => {
    if (formData.eot_status === "rejected" || formData.eot_status === "pending") {
      setFormData((prev) => ({
        ...prev,
        approved_days: "0",
        close_letter: "",
      }))
    }
  }, [formData.eot_status]);




  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });
    setFormData({
      ...formData,
      [name]: value,
    });
    if (errors[name]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[name]; // Remove the specific field's error
        return newErrors;
      });
    }
  };

  const validateEotForm = () => {
    const newErrors = {};

    if (!formData.approved_date && formData.eot_status === "Approved") {
      newErrors.approved_date = "Date is required!";
    }
    if (!formData.client_rejected_date && formData.eot_status === "rejected") {
      newErrors.client_rejected_date = "Date is required!";
    }

    if (formData.eot_status === "Approved" && !formData.close_letter) {
      newErrors.close_letter = " Client apporved letter is required";
    }
    if (formData.eot_status === "rejected" && !formData.client_rejected_letter) {
      newErrors.client_rejected_letter = " Client rejected letter is required";
    }
    if (formData.eot_status === "seek_clarification" && !formData.client_seek_clarfication_letter) {
      newErrors.client_seek_clarfication_letter = " Client seek clarification letter is required";
    }
    if (!formData.approved_days && formData.eot_status === "Approved") {
      newErrors.approved_days = "Approved Days is required!";
    }
    if (formData.ae_eot_status === "Approved" && !formData.ae_approved_days) {
      newErrors.ae_approved_days = "AE Recommeded Days is required!";
    }
    if ((formData.ae_eot_status === "Approved") && !formData.ae_approved_date) {
      newErrors.ae_approved_date = `AE Recommended Date is required!`;
    }
    if ((formData.ae_eot_status === "observation") && !formData.ae_ie_observation_date) {
      newErrors.ae_ie_observation_date = `AE Observation Date is required!`;
    }
    if ((formData.ae_eot_status === "rejected") && !formData.ae_reject_date) {
      newErrors.ae_reject_date = `AE Rejected Date is required!`;
    }
    if (
      (formData.ae_eot_status === "Approved") &&
      !formData.ae_close_letter
    ) {
      newErrors.ae_close_letter = "AE Response Letter is required";
    }
    if ((formData.ae_eot_status === "rejected") && !formData.ae_ie_rejected_letter) {
      newErrors.ae_ie_rejected_letter = `AE Rejected Letter is required!`;
    }
    if ((formData.ae_eot_status === "observation") && !formData.ae_ie_observation_letter) {
      newErrors.ae_ie_observation_letter = `AE Observation Letter is required!`;
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.dismiss();
      toast.warn("Fill all * fields");
      return false;
    }

    return true;
  };

  const handleAxiosError = (err) => {
    handleErrorToast(err);
  };
  const [contractorList, setContractorList] = useState({});

  const getContractorData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/EOTCOSContractorbyid/${contractor_id}/`);
      setContractorList(res.data);
      return res.data; // Return the latest contractor data
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);

  const handleEotUpdate = async (e) => {
    e.preventDefault();
    if (!validateEotForm()) return;

    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);

    const loadingToastId = toast.loading("Updating: please wait...");
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);
    try {
      const res = await axios.put(`${BASE_URL}/siteproject/eot/${i.id}/`, formData);

      if (res.status === 200) {
        await getEot();
        if (toggleState === "contractor") {
          await new Promise(resolve => setTimeout(resolve, 500));

          const contractorData = await getContractorData();
          if (!contractorData) throw new Error("Failed to fetch contractor data.");

          const gettotaldays = contractorData.linked_eots.total_approved_days;
          console.log(gettotaldays);

          await new Promise(resolve => setTimeout(resolve, 500));

          if (toggleState === "contractor") {
            const updatedContractorData = {
              ...ContractorData,
              EOT_Days: gettotaldays,
              schedule_construction_completion_date_with_eot: calculateNextDate(contractor_date, Number(gettotaldays)),
            };

            await axios.put(`${BASE_URL}/siteproject/contractor/${contractor_id}/`, updatedContractorData);
          }
        }


        handleClose();
        setTimeout(() => {
          toast.dismiss(loadingToastId);
          toast.success("Data updated successfully.", {
            autoClose: 1000,
            pauseOnHover: true,
            closeOnClick: true,
          });
        }, 1000);
      } else {
        throw new Error("Unexpected response status: " + res.status);
      }

    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      handleErrorToast(err);
    } finally {
      clearInterval(interval);

      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);

      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };






  const [trackRecordList, setTrackRecordList] = useState([]);
  const getLetters = async () => {
    try {
      const res = await axios.get(
        contractor ?
          `${BASE_URL}/siteproject/letterrecordbyfilters/${project}/${formData.workperformedby}/eot/${contractor}/`
          :
          `${BASE_URL}/siteproject/letterrecordbyfilters/${project}/${formData.workperformedby}/eot/`
      );
      setTrackRecordList(res.data);
    } catch (err) {
      console.error(err);
    } finally {
    }
  };
  useEffect(() => {
    getLetters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.workperformedby, contractor]);

  const aeCloseLetterOptions = trackRecordList.map((item) => ({
    value: item.id,
    label: item.letter_num,
  }));





  return (
    <>
      <button title='Update EOT' className="model-edit-button" onClick={handleShow}>

        <UpdatePencil />
      </button>

      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" /> :
          show === true ?
            <Modal show={show} onHide={handleClose} dialogClassName="request-leave ">
              <Modal.Header closeButton>
                <Modal.Title>Update EOT Detail</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="form-flex-wrap">

                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading" title="EOT Code">
                      EOT Code<span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="eot_code"
                      title="EOT Code"
                      placeholder="EOT Code"
                      value={formData.eot_code}
                      onChange={handleInputChange}
                      className={`form-input-date width-17vw ${errors.eot_code ? "error" : inputState.eot_code ? "success" : ""
                        }`}
                    />
                    {errors.eot_code && (
                      <span className="error-message font-size-text">
                        {errors.eot_code}
                      </span>
                    )}
                  </div>


                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading" title="Initiate Date">Initial Submission Date<span className="required">*</span>
                    </label>
                    <input
                      type="date"
                      name="process_initiate_date"
                      title="Process Initiate Date"
                      value={formData.process_initiate_date}
                      onChange={handleInputChange}
                      className={`form-input-date width-17vw ${errors.process_initiate_date ? "error" : inputState.process_initiate_date ? "success" : ""}`}
                    />
                    {errors.process_initiate_date && <span className="error-message font-size-text">{errors.process_initiate_date}</span>}
                  </div>
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading" title="Process Initiate Date">Initial Submission Days<span className="required">*</span>
                    </label>
                    <input
                      type="number"
                      name="days"
                      title="Days"
                      value={formData.days}
                      onChange={handleInputChange}
                      className={`form-input-date width-17vw ${errors.days ? "error" : inputState.days ? "success" : ""}`}
                    // readOnly
                    />
                    {errors.days && <span className="error-message font-size-text">{errors.days}</span>}
                  </div>
                  {toggleState !== "consultant" &&
                    <div className="flex-column form-group-selectt">
                      <label className="form-labels font-weight500 font-size-subheading" title="AE/IE Response">AE/IE Response </label>
                      <br />
                      <select
                        name="ae_eot_status"
                        title="AE/IE Response"
                        value={formData.ae_eot_status}
                        onChange={handleInputChange}
                        className={`form-input-date width-17vw form-group-selection`}
                      >
                        <option value="">Select Status</option>
                        <option value="pending">Pending</option>
                        <option value="observation">Observation</option>
                        <option value="Approved">Recommended</option>
                        <option value="rejected">Rejected</option>

                      </select>

                      {errors.ae_eot_status && <div className="error-message font-size-text">{errors.ae_eot_status}</div>}
                    </div>
                  }
                  {formData.ae_eot_status && formData.ae_eot_status !== "pending" ?
                    <>
                      <div className="flex-column">
                        <label className="form-labels font-weight500 font-size-subheading" title="AE Approved Date">
                          AE/IE {formData.ae_eot_status === "Approved" ? "Recommended" : formData.ae_eot_status === "observation" ? "Observation" : "Rejected"} Date
                          <span className="required">*</span>
                        </label>
                        {formData.ae_eot_status === "Approved" && (
                          <input
                            type="date"
                            name="ae_approved_date"
                            value={formData.ae_approved_date}
                            onChange={handleInputChange}
                            className="form-input-date width-17vw"
                          />
                        )}

                        {formData.ae_eot_status === "observation" && (
                          <input
                            type="date"
                            name="ae_ie_observation_date"
                            value={formData.ae_ie_observation_date}
                            onChange={handleInputChange}
                            className="form-input-date width-17vw"
                          />
                        )}

                        {formData.ae_eot_status === "rejected" && (
                          <input
                            type="date"
                            name="ae_reject_date"
                            value={formData.ae_reject_date}
                            onChange={handleInputChange}
                            className="form-input-date width-17vw"
                          />
                        )}

                        {formData.ae_eot_status === "Approved" && errors.ae_approved_date && (
                          <div className="error-message font-size-text">{errors.ae_approved_date}</div>
                        )}
                        {formData.ae_eot_status === "observation" && errors.ae_ie_observation_date && (
                          <div className="error-message font-size-text">{errors.ae_ie_observation_date}</div>
                        )}
                        {formData.ae_eot_status === "rejected" && errors.ae_reject_date && (
                          <div className="error-message font-size-text">{errors.ae_reject_date}</div>
                        )}
                      </div>

                    </>
                    : ""
                  }
                  {formData.ae_eot_status === "Approved" ?
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading" title="Days">AE/IE Recommended Days<span className="required">*</span></label>
                      <input
                        type="number"
                        name="ae_approved_days"
                        title="AE/IE Recommended Days"
                        placeholder="AE/IE Recommended Days"
                        value={formData.ae_approved_days}
                        onChange={handleInputChange}

                        className={`form-input-date width-17vw ${errors.ae_approved_days ? "error" : inputState.ae_approved_days ? "success" : ""}`}

                      />
                      {errors.ae_approved_days && <div className="error-message font-size-text">{errors.ae_approved_days}</div>}
                    </div> : ""

                  }
                  <div className="flex-column form-group-selectt">
                    <label className="form-labels font-weight500 font-size-subheading" title="Client Response">Client Response</label>
                    <br />
                    <select
                      name="eot_status"
                      title="Client Response"
                      value={formData.eot_status}
                      onChange={handleInputChange}
                      className={`form-input-date width-17vw form-group-selection`}
                    >
                      <option value="pending">Pending</option>
                      <option value="seek_clarification">Seek Clarification</option>
                      <option value="Approved">Approved</option>
                      <option value="rejected">Rejected</option>

                    </select>

                    {errors.eot_status && <div className="error-message font-size-text">{errors.eot_status}</div>}
                  </div>
                  {(formData.eot_status !== "pending" && formData.eot_status !== "seek_clarification") &&
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading" >
                        Client {formData.eot_status === "Approved" ? "Approved" : "Rejected"}  Date<span className="required">*</span>
                      </label>
                      {formData.eot_status === "Approved" &&
                        <input
                          type="date"
                          name="approved_date"
                          value={formData.approved_date}
                          min={formData.process_initiate_date}
                          onChange={handleInputChange}
                          className={`form-input-date width-17vw ${errors.approved_date
                            ? "error"
                            : inputState.approved_date
                              ? "success"
                              : ""
                            }`}
                        />
                      }
                      {formData.eot_status === "rejected" &&
                        <input
                          type="date"
                          name="client_rejected_date"
                          value={formData.client_rejected_date}
                          min={formData.process_initiate_date}
                          onChange={handleInputChange}
                          className={`form-input-date width-17vw ${errors.client_rejected_date
                            ? "error"
                            : inputState.client_rejected_date
                              ? "success"
                              : ""
                            }`}
                        />
                      }
                      {errors.approved_date && (
                        <span className="error-message font-size-text">
                          {errors.approved_date}
                        </span>
                      )}
                      {errors.client_rejected_date && (
                        <span className="error-message font-size-text">
                          {errors.client_rejected_date}
                        </span>
                      )}
                    </div>
                  }

                  {formData.eot_status !== "pending" ?
                    <>


                      {formData.eot_status === "Approved" &&
                        <div className="flex-column">
                          <label className="form-labels font-weight500 font-size-subheading" title="Approved Days By Client">
                            Approved Days By Client<span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            name="approved_days"
                            title="Approved Days By Client"
                            placeholder="Approved Days by Client"
                            value={formData.approved_days}
                            onChange={handleInputChange}
                            className={`form-input-date width-17vw ${errors.approved_days
                              ? "error"
                              : inputState.approved_days
                                ? "success"
                                : ""
                              }`}
                          />
                          {errors.approved_days && (
                            <span className="error-message font-size-text">
                              {errors.approved_days}
                            </span>
                          )}
                        </div>
                      }
                    </>
                    : ""
                  }

                  <div className="form-group">
                    <div className="flex-column form-group-selectt">
                      <label className="form-labels font-weight500 font-size-subheading" title="Initial Submission Letter">Initial Submission Letter<span className="required">*</span></label>
                      <br />

                      <Select
                        name="letter"
                        placeholder="Select Option"
                        options={aeCloseLetterOptions}
                        isClearable
                        value={aeCloseLetterOptions.find(
                          (opt) => opt.value === formData.letter
                        )}
                        onChange={(selectedOption) =>
                          handleInputChange({
                            target: {
                              name: "letter",
                              value: selectedOption ? selectedOption.value : "",
                            },
                          })
                        }
                        styles={CSSForSelect15vWWidth}
                      />

                    </div>
                    {errors.letter && <div className="error-message font-size-text">{errors.letter}</div>}
                  </div>

                  {formData.ae_eot_status && formData.ae_eot_status !== "pending" ?
                    <div className="flex-column form-group-selectt">
                      <label className="form-labels font-weight500 font-size-subheading" title="AE Response Letter">
                        AE/IE {formData.ae_eot_status === "Approved" ? "Recommended" : formData.ae_eot_status === "observation" ? "Observation" : "Rejected"} Letter<span className="required">*</span>
                      </label>
                      <br />
                      {formData.ae_eot_status === "Approved" && (
                        <Select
                          name="ae_close_letter"
                          placeholder="Select Option"
                          options={aeCloseLetterOptions}
                          isClearable
                          value={aeCloseLetterOptions.find(
                            (opt) => opt.value === formData.ae_close_letter
                          )}
                          onChange={(selectedOption) =>
                            handleInputChange({
                              target: {
                                name: "ae_close_letter",
                                value: selectedOption ? selectedOption.value : "",
                              },
                            })
                          }
                          styles={CSSForSelect15vWWidth}
                        />
                      )}

                      {formData.ae_eot_status === "observation" && (

                        <Select
                          name="ae_ie_observation_letter"
                          placeholder="Select Option"
                          options={aeCloseLetterOptions}
                          isClearable
                          value={aeCloseLetterOptions.find(
                            (opt) => opt.value === formData.ae_ie_observation_letter
                          )}
                          onChange={(selectedOption) =>
                            handleInputChange({
                              target: {
                                name: "ae_ie_observation_letter",
                                value: selectedOption ? selectedOption.value : "",
                              },
                            })
                          }
                          styles={CSSForSelect15vWWidth}
                        />
                      )}

                      {formData.ae_eot_status === "rejected" && (

                        <Select
                          name="ae_ie_rejected_letter"
                          placeholder="Select Option"
                          options={aeCloseLetterOptions}
                          isClearable
                          value={aeCloseLetterOptions.find(
                            (opt) => opt.value === formData.ae_ie_rejected_letter
                          )}
                          onChange={(selectedOption) =>
                            handleInputChange({
                              target: {
                                name: "ae_ie_rejected_letter",
                                value: selectedOption ? selectedOption.value : "",
                              },
                            })
                          }
                          styles={CSSForSelect15vWWidth}
                        />
                      )}

                      <div className="form-group-selection-arrow">

                      </div>
                      {errors.ae_close_letter && (
                        <div className="error-message font-size-text">
                          {errors.ae_close_letter}
                        </div>
                      )}
                      {errors.ae_ie_observation_letter && (
                        <div className="error-message font-size-text">
                          {errors.ae_ie_observation_letter}
                        </div>
                      )}
                      {errors.ae_ie_rejected_letter && (
                        <div className="error-message font-size-text">
                          {errors.ae_ie_rejected_letter}
                        </div>
                      )}
                    </div> : ""
                  }

                  <div className="form-group">
                    <div className="flex-column form-group-selectt">
                      {formData.eot_status !== "pending" &&
                        <label className="form-labels font-weight500 font-size-subheading" title="Client Response Letter">
                          Client  {formData.eot_status === "Approved" ? "Approved" : formData.eot_status === "seek_clarification" ? "Seek-Clarification" : formData.eot_status === "rejected" ? "Rejected" : ""} Letter<span className="required">*</span>
                        </label>
                      }
                      <br />
                      {formData.eot_status === "Approved" && (

                        <Select
                          name="close_letter"
                          placeholder="Select Option"
                          options={aeCloseLetterOptions}
                          isClearable
                          value={aeCloseLetterOptions.find(
                            (opt) => opt.value === formData.close_letter
                          )}
                          onChange={(selectedOption) =>
                            handleInputChange({
                              target: {
                                name: "close_letter",
                                value: selectedOption ? selectedOption.value : "",
                              },
                            })
                          }
                          styles={CSSForSelect15vWWidth}
                        />
                      )}
                      {formData.eot_status === "rejected" && (
                        <Select
                          name="client_rejected_letter"
                          placeholder="Select Option"
                          options={aeCloseLetterOptions}
                          isClearable
                          value={aeCloseLetterOptions.find(
                            (opt) => opt.value === formData.client_rejected_letter
                          )}
                          onChange={(selectedOption) =>
                            handleInputChange({
                              target: {
                                name: "client_rejected_letter",
                                value: selectedOption ? selectedOption.value : "",
                              },
                            })
                          }
                          styles={CSSForSelect15vWWidth}
                        />
                      )}
                      {formData.eot_status === "seek_clarification" && (

                        <Select
                          name="client_seek_clarfication_letter"
                          placeholder="Select Option"
                          options={aeCloseLetterOptions}
                          isClearable
                          value={aeCloseLetterOptions.find(
                            (opt) => opt.value === formData.client_seek_clarfication_letter
                          )}
                          onChange={(selectedOption) =>
                            handleInputChange({
                              target: {
                                name: "client_seek_clarfication_letter",
                                value: selectedOption ? selectedOption.value : "",
                              },
                            })
                          }
                          styles={CSSForSelect15vWWidth}
                        />
                      )}


                    </div>
                    {errors.close_letter && (
                      <div className="error-message font-size-text">
                        {errors.close_letter}
                      </div>
                    )}
                    {errors.client_seek_clarfication_letter && (
                      <div className="error-message font-size-text">
                        {errors.client_seek_clarfication_letter}
                      </div>
                    )}
                    {errors.client_rejected_letter && (
                      <div className="error-message font-size-text">
                        {errors.client_rejected_letter}
                      </div>
                    )}
                  </div>




                </div>

                <>
                  <div
                    style={{ display: "flex", justifyContent: "space-evenly" }}
                  >
                    <div>OR</div>
                  </div>

                  <div className="button-models">
                    <AddTrackRecordDetails
                      projectId={project}
                      contractor={contractor}
                      letterfor={formData.workperformedby}
                      lettertype="eot"
                      getProjects={getLetters}
                      title="EOT Letter"
                      site_prcode={site_prcode}
                      projectName={projectName}

                    />
                  </div>
                </>




                <div className="button-models" style={{ marginTop: "20px", justifyContent: "space-evenly" }}>
                  <button className="cancelbutton" onClick={handleClose}>Cancel</button>

                  <Updatebutton onclick={handleEotUpdate} />
                </div>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal>
            : ""
      }
    </>
  );
};

const DeleteEOT = ({ i, getEOT, contractor, toggleState }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  const [loading, setLoading] = useState(false);


  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);

    const loadingToastId = toast.loading("Deleting: please wait...");
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);


    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/eot/${i.id}/`
      );

      if (res.status === 200) {
        await getEOT();


        handleClose();
        setTimeout(() => {
          toast.dismiss(loadingToastId);
          toast.success("Data deleted successfully.", {
            autoClose: 1000,
            pauseOnHover: true,
            closeOnClick: true,
          });
        }, 1000);
      } else {
        throw new Error("Unexpected response status: " + res.status);
      }

    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      handleErrorToast(err);
    } finally {
      clearInterval(interval);

      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);

      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete EOT"
        className="model-delete-button"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" /> :
          show === true ?
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="request-leave width-40vw"
            >
              <Modal.Header closeButton>
                <Modal.Title>Delete EOT</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="parent-div">
                  Are You Sure You Want to delete EOT Data of {i.eot_code}
                  <div className="button-models" style={{ marginTop: "40px", justifyContent: "space-evenly" }}>
                    <button className="cancelbutton" onClick={handleClose}>Cancel</button>
                    <DeleteButton onclick={handleFormSubmitDelete} />

                  </div>
                </div>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};







const AddCOSDetails = ({ project, getProjects, toggleState, contractorlist, contractor, site_prcode,
  projectName }) => {

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    setFormData({
      project: project,
      cos_code: "",
      contractor: toggleState === "contractor" ? contractor : "",
      amount: "",
      workperformedby: toggleState,
      letter: "",
      cos_status: "pending",
      cos_type: "",
      negativeamount: "",


    })

    setErrors("");

  }
  const handleShow = () => setShow(true);

  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    project: project,
    cos_code: "",
    approval_date: null,
    contractor: toggleState === "contractor" ? contractor : "",
    process_initiate_date: null,
    cos_status: "pending",
    amount: "",
    workperformedby: toggleState,
    letter: "",
    cos_type: "",
    negativeamount: "",

  });



  const [trackRecordList, setTrackRecordList] = useState([]);

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const getLetters = async () => {
    try {
      const res = await axios.get(
        contractor ?
          `${BASE_URL}/siteproject/letterrecordbyfilters/${project}/${formData.workperformedby}/cos/${contractor}/` :
          `${BASE_URL}/siteproject/letterrecordbyfilters/${project}/${formData.workperformedby}/cos/`
      );
      setTrackRecordList(res.data);
    } catch (err) {
      console.error(err);
    } finally {
    }
  };
  useEffect(() => {
    getLetters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.workperformedby, contractor]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
    if (errors[name]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[name]; // Remove the specific field's error
        return newErrors;
      });
    }
  };

  const validateCOSForm = () => {
    const newErrors = {};

    let RequiredFields = ["cos_code", "process_initiate_date", "cos_type", "letter"];

    if (formData.cos_type === "positivecos" || formData.cos_type === "") {
      RequiredFields.push("amount");
    }

    if (formData.cos_type === "negativecos") {
      RequiredFields.push("negativeamount");
    }

    RequiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.dismiss();
      toast.warn("Fill all * fields");
      return false;
    }

    return true;
  };


  console.log(errors)

  const handleAxiosError = (err) => {
    handleErrorToast(err);
  };

  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);

  const handleCOSPost = async (e) => {
    e.preventDefault();

    if (validateCOSForm()) {
      setShowProgressModal(true);
      setLoading(true);
      setUploadProgress(0);

      const loadingToastId = toast.loading("Uploading: please wait...");
      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setUploadProgress(progress);
      }, 100);
      try {
        let res = await axios.post(`${BASE_URL}/siteproject/cos/`, formData)

        if (res.status === 200) {
          await getProjects();
          handleClose();
          setTimeout(() => {
            toast.dismiss(loadingToastId);
            toast.success("COS data added successfully.", {
              autoClose: 1000,
              pauseOnHover: true,
              closeOnClick: true,
            });
          }, 1000);
        } else {
          throw new Error("Unexpected response status: " + res.status);
        }

      } catch (err) {
        clearInterval(interval);
        setUploadProgress(0);
        handleErrorToast(err);
      } finally {
        clearInterval(interval);

        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);

        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  return (
    <>
      <button title="Add COS" className="upload-svg" style={{ margin: 0 }} onClick={handleShow}>
        <AddwithWhiteCircle />
        {" "}
        COS
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" /> :
          show === true ?
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="request-leave width-40vw"
            >
              <Modal.Header closeButton>
                <Modal.Title>Add COS Detail</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="form-flex-wrap">
                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading" title="COS Code">
                      COS Code<span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      title="COS Code"
                      name="cos_code"
                      placeholder="COS Code"
                      value={formData.cos_code}
                      onChange={handleInputChange}
                      className={`form-input-date width-17vw ${errors.cos_code
                        ? "error"
                        : inputState.cos_code
                          ? "success"
                          : ""
                        }`}
                    />
                    {errors.cos_code && (
                      <div className="error-message font-size-text">
                        {errors.cos_code}
                      </div>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading" title="Initate Date">
                      Initiate Date<span className="required">*</span>
                    </label>
                    <input
                      type="date"
                      title="Initiate Date"
                      name="process_initiate_date"
                      value={formData.process_initiate_date}
                      onChange={handleInputChange}
                      className={`form-input-date width-17vw ${errors.process_initiate_date
                        ? "error"
                        : inputState.process_initiate_date
                          ? "success"
                          : ""
                        }`}
                    />
                    {errors.process_initiate_date && (
                      <div className="error-message font-size-text">
                        {errors.process_initiate_date}
                      </div>
                    )}
                  </div>
                  <div className="flex-column form-group-selectt">
                    <label className="form-labels font-weight500 font-size-subheading" style={{ marginBottom: formData.cos_type === "negativecos" ? "25px" : "0px" }} title="COS Type">COS Type <span className="required">*</span></label>
                    <br />
                    <select
                      name="cos_type"
                      title="COS Type"
                      value={formData.cos_type}
                      onChange={handleInputChange}
                      className={`form-input-date width-17vw form-group-selection`}
                    >
                      <option value="">Select COS Type</option>
                      <option value="negativecos">Negative COS</option>
                      <option value="positivecos">Positive COS</option>

                    </select>

                    {errors.cos_type && <div className="error-message font-size-text">{errors.cos_type}</div>}
                  </div>
                  {
                    formData.cos_type === 'negativecos' ?
                      <>
                        <div className="flex-column">
                          <label className="form-labels font-weight500 font-size-subheading" title="Amount">
                            Negative Amount <br />(Write full amount)<span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            name="negativeamount"
                            title="Negative Amount"
                            placeholder="Enter Amount"
                            value={formData.negativeamount}
                            onChange={handleInputChange}
                            className={`form-input-date width-17vw ${errors.negativeamount ? "error" : inputState.negativeamount ? "success" : ""
                              }`}
                          />
                          {errors.negativeamount && (
                            <div className="error-message font-size-text">
                              {errors.negativeamount}
                            </div>
                          )}
                        </div>
                      </> :
                      formData.cos_type === 'positivecos' ?
                        <>
                          <div className="flex-column">
                            <label className="form-labels font-weight500 font-size-subheading" title="Amount">
                              Amount(Write full amount)<span className="required">*</span>
                            </label>
                            <input
                              type="text"
                              name="amount"
                              title="Amount"
                              placeholder="Amount"
                              value={formData.amount}
                              onChange={handleInputChange}
                              className={`form-input-date width-17vw ${errors.amount ? "error" : inputState.amount ? "success" : ""
                                }`}
                            />
                            {errors.amount && (
                              <div className="error-message font-size-text">
                                {errors.amount}
                              </div>
                            )}
                          </div>
                        </> : ""
                  }




                  <div className="form-group">
                    <div className="flex-column form-group-selectt">
                      <label className="form-labels font-weight500 font-size-subheading" title="Letter">
                        Letter <span className="required">*</span>
                      </label>
                      <br />
                      <select
                        name="letter"
                        title="Letter"
                        value={formData.letter}
                        onChange={handleInputChange}
                        className={`form-input-date width-17vw form-group-selection ${errors.letter ? "error" : inputState.letter ? "success" : ""
                          }`}
                      >
                        <option value="">Select Option</option>
                        {trackRecordList.map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.letter_num}
                          </option>
                        ))}
                      </select>

                    </div>
                    {errors.letter && (
                      <div className="error-message font-size-text">
                        {errors.letter}
                      </div>
                    )}
                  </div>
                </div>

                {formData.letter ? (
                  ""
                ) : (
                  <>
                    <div
                      style={{ display: "flex", justifyContent: "space-evenly" }}
                    >
                      <div>OR</div>
                    </div>

                    <div className="button-models">
                      <AddTrackRecordDetails
                        projectId={project}
                        contractor={contractor}
                        letterfor={formData.workperformedby}
                        lettertype="cos"
                        getProjects={getLetters}
                        title="COS Letter"
                        site_prcode={site_prcode}
                        projectName={projectName}

                      />
                    </div>
                  </>
                )}

                <div className="button-models" style={{ marginTop: "20px", justifyContent: "space-evenly" }}>
                  <button className="cancelbutton" onClick={handleClose}>Cancel</button>

                  <Addbutton onclick={handleCOSPost} />
                </div>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};




const UpdateCOSDetails = ({ i, getCos, toggleState, project, contractor, cost, site_prcode,
  projectName }) => {

  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    setErrors("");
    setFormData("");

  }
  const handleShow = () => {
    setShow(true);
    setFormData(i)

  }



  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({

    cos_code: "",
    approval_date: null,
    cos_status: "pending",
    process_initiate_date: null,
    workperformedby: toggleState,
    amount: "",
    approved_amount: "",
    letter: "",
    close_letter: "",
    cos_type: "",
    negative_amt: "",
    ae_approved_amount: "",
    ae_cos_status: "pending",
    ae_approval_date: null,
    ae_close_letter: null,
    ae_reject_date: null,
    ae_ie_observation_letter: null,
    ae_ie_rejected_letter: null,
    ae_ie_rejected_date: null,
    ae_ie_observation_date: null,
    client_rejected_date: null,
    client_rejected_letter: null,
    client_seek_clarfication_letter: null,
    client_in_principle_letter: null,
    client_in_principle_date: null,

  });




  const [trackRecordList, setTrackRecordList] = useState([]);

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const getLetters = async () => {
    try {
      const res = await axios.get(
        contractor ?
          `${BASE_URL}/siteproject/letterrecordbyfilters/${project}/${formData.workperformedby}/cos/${contractor}/` :
          `${BASE_URL}/siteproject/letterrecordbyfilters/${project}/${formData.workperformedby}/cos/`
      );
      setTrackRecordList(res.data);
    } catch (err) {
      console.error(err);
    } finally {
    }
  };


  useEffect(() => {
    getLetters();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formData.workperformedby, contractor]);




  useEffect(() => {
    if (formData.cos_status === "rejected") {
      setFormData((prev) => ({
        ...prev,
        approved_amount: "",
        close_letter: "",
      }))
    }
  }, [formData.cos_status])

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });

    if (name === 'ae_cos_status') {
      setErrors(prev => ({
        ...prev,
        ae_approval_date: '',
        ae_close_letter: ''
      }));
    }

    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      if (value) {
        delete updatedErrors[name];
      }
      return updatedErrors;
    });
  };

  const validateCOSForm = () => {
    const newErrors = {};

    let RequiredFields = ["cos_code", "process_initiate_date", "cos_type", "letter"];

    if (formData.cos_type === "positivecos" || formData.cos_type === "") {
      RequiredFields.push("amount");
    }

    if (formData.cos_type === "negativecos") {
      RequiredFields.push("negativeamount");
    }


    if ((formData.cos_status === "Approved") && !formData.approval_date) {
      newErrors.approval_date = "Client Approval Date is required!";
    }
    if ((formData.cos_status === "Approved") && !formData.approved_amount) {
      newErrors.approved_amount = "Client Approval Amount is required!";
    }
    if ((formData.cos_status === "Approved") && !formData.close_letter) {
      newErrors.close_letter = "Client Approved Letter is required!";
    }
    if ((formData.cos_status === "inprinciple") && !formData.in_principle_amount_byclient) {
      newErrors.in_principle_amount_byclient = "Client inprinciple Amount is required!";
    }
    if ((formData.cos_status === "inprinciple") && !formData.client_in_principle_date) {
      newErrors.client_in_principle_date = "Client inprinciple date is required!";
    }
    if ((formData.cos_status === "inprinciple") && !formData.client_in_principle_letter) {
      newErrors.client_in_principle_letter = "Client inprinciple Letter is required!";
    }
    if ((formData.cos_status === "rejected") && !formData.client_rejected_letter) {
      newErrors.client_rejected_letter = "Client rejected Letter is required!";
    }
    if ((formData.cos_status === "seek_clarification") && !formData.client_seek_clarfication_letter) {
      newErrors.client_seek_clarfication_letter = "Client seek-clarification Letter is required!";
    }
    if (!formData.cos_type) {
      newErrors.cos_type = "COS Type is required!";
    }

    if (formData.ae_cos_status === "Approved" && !formData.ae_approved_amount) {
      newErrors.ae_approved_amount = "AE/IE Recommended Amount is required!";
    }
    if ((formData.ae_cos_status === "Approved") && !formData.ae_approval_date) {
      newErrors.ae_approval_date = `AE/IE Recommended Date is required!`;
    }
    if ((formData.ae_cos_status === "rejected") && !formData.ae_reject_date) {
      newErrors.ae_reject_date = `AE/IE Rejected Date is required!`;
    }
    if ((formData.ae_cos_status === "rejected") && !formData.ae_ie_rejected_letter) {
      newErrors.ae_ie_rejected_letter = `AE/IE Rejected letter is required!`;
    }
    if (
      (formData.ae_cos_status === "Approved") &&
      !formData.ae_close_letter
    ) {
      newErrors.ae_close_letter = "AE/IE Recommended Letter is required";
    }

    if ((formData.ae_cos_status === "observation") && !formData.ae_ie_observation_date) {
      newErrors.ae_ie_observation_date = `AE/IE Observation Date is required!`;
    }
    if ((formData.ae_cos_status === "observation") && !formData.ae_ie_observation_letter) {
      newErrors.ae_ie_observation_letter = `AE/IE Observation Letter is required!`;
    }


    RequiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.dismiss();
      toast.warn("Fill all * fields");
      return false;
    }

    return true;
  };






  const handleAxiosError = (err) => {
    handleErrorToast(err);
  };
  const [ContractorData, setContractorData] = useState({
    cost_with_cos: 0
  });


  const [contractorList, setContractorList] = useState({});


  const getContractorData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/EOTCOSContractorbyid/${contractor}/`);
      setContractorList(res.data);
      return res.data; // Return the latest contractor data
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  function calculateFinalAmount(total_approved_amount, cost) {
    return total_approved_amount < 0
      ? Math.abs(total_approved_amount) - cost
      : total_approved_amount + cost;
  }
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);

  const handleCOSUpdate = async (e) => {
    e.preventDefault();


    if (validateCOSForm()) {

      setShowProgressModal(true);
      setLoading(true);
      setUploadProgress(0);

      const loadingToastId = toast.loading("Updating: please wait...");
      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setUploadProgress(progress);
      }, 100);
      try {





        let res = await axios.put(`${BASE_URL}/siteproject/cos/${i.id}/ `, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })

        if (res.status === 200) {
          await getCos();

          await new Promise(resolve => setTimeout(resolve, 500));
          if (toggleState === "contractor") {
            const contractorData = await getContractorData();
            if (!contractorData) throw new Error("Failed to fetch contractor data.");

            const getTotalAmount = contractorData.linked_cos.total_approved_amount;
            console.log(getTotalAmount);


            await new Promise(resolve => setTimeout(resolve, 500));

            if (toggleState === "contractor") {
              const updatedContractorData = {
                ...ContractorData,
                cost_with_cos: calculateFinalAmount(Number(getTotalAmount), Number(contractorData.cost)),
              };

              console.log(calculateFinalAmount(Number(getTotalAmount), Number(contractorData.cost)))

              await axios.put(`${BASE_URL}/siteproject/contractor/${contractor}/`, updatedContractorData);
            }

          }

          handleClose();
          setTimeout(() => {
            toast.dismiss(loadingToastId);
            toast.success("Data updated successfully.", {
              autoClose: 1000,
              pauseOnHover: true,
              closeOnClick: true,
            });
          }, 1000);
        } else {
          throw new Error("Unexpected response status: " + res.status);
        }

      } catch (err) {
        clearInterval(interval);
        setUploadProgress(0);
        handleErrorToast(err);
      } finally {
        clearInterval(interval);

        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);

        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };


  const letterOptions = trackRecordList.map((item) => ({
    value: item.id,
    label: item.letter_num,
  }));


  return (
    <>
      <button title="Update COS" className="model-edit-button" onClick={handleShow}>
        <UpdatePencil />
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" /> :
          show === true ?
            <Modal show={show} onHide={handleClose} dialogClassName="half-modal">
              <Modal.Header closeButton>
                <Modal.Title>Update COS Detail</Modal.Title>
              </Modal.Header>
              <Modal.Body>

                <div className="form-flex-wrap">


                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading" title="COS Code">COS Code<span className="required">*</span></label>
                    <input
                      type="text"
                      name="cos_code"
                      title="COS Code"
                      placeholder="COS Code"
                      value={formData.cos_code}
                      onChange={handleInputChange}

                      className={`form-input-date width-20vw ${errors.cos_code ? "error" : inputState.cos_code ? "success" : ""}`}
                    />
                    {errors.cos_code && <div className="error-message font-size-text">{errors.cos_code}</div>}
                  </div>



                  <div className="flex-column">
                    <label className="form-labels font-weight500 font-size-subheading" title="Initiate Date">Initiate Date<span className="required">*</span></label>
                    <input
                      type="date"
                      name="process_initiate_date"
                      title="Initiate Date"
                      value={formData.process_initiate_date}
                      onChange={handleInputChange}
                      className={`form-input-date width-20vw ${errors.process_initiate_date ? "error" : inputState.process_initiate_date ? "success" : ""}`}
                    />
                    {errors.process_initiate_date && <div className="error-message font-size-text">{errors.process_initiate_date}</div>}
                  </div>


                  {formData.amount ?
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading" title="Amount(Write full amount)">Amount<span className="required">*</span></label>
                      <input
                        type="text"
                        name="amount"
                        title="Amount"
                        placeholder="Amount"
                        value={formData.amount}
                        onChange={handleInputChange}

                        className={`form-input-date width-20vw ${errors.amount ? "error" : inputState.amount ? "success" : ""}`}
                      />
                      {errors.amount && <div className="error-message font-size-text">{errors.amount}</div>}
                    </div> :
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading" title="Negative Amount">Negative Amount<span className="required">(Read-Only)</span></label>
                      <input
                        type="text"
                        name="negativeamount"
                        title="negativeamount"
                        placeholder="negativeamount"
                        value={formData.negativeamount}
                        onChange={handleInputChange}

                        className={`form-input-date width-20vw ${errors.negativeamount ? "error" : inputState.negativeamount ? "success" : ""}`}
                        readOnly
                      />
                      {errors.negativeamount && <div className="error-message font-size-text">{errors.negativeamount}</div>}
                    </div>
                  }
                  {toggleState !== "consultant" &&
                    <div className="flex-column form-group-selectt">
                      <label className="form-labels font-weight500 font-size-subheading" title="AE COS Status">AE COS Status </label>
                      <br />
                      <select
                        name="ae_cos_status"
                        title="AE COS status"
                        value={formData.ae_cos_status}
                        onChange={handleInputChange}
                        className={`form-input-date width-20vw form-group-selection`}
                      >
                        <option value="pending">Pending</option>
                        <option value="observation">Observation</option>
                        <option value="Approved">Recommended</option>
                        <option value="rejected">Rejected</option>

                      </select>

                      {errors.ae_cos_status && <div className="error-message font-size-text">{errors.ae_cos_status}</div>}
                    </div>
                  }
                  {formData.ae_cos_status && formData.ae_cos_status !== "pending" ?
                    <>
                      <div className="flex-column">
                        <label className="form-labels font-weight500 font-size-subheading" title="AE Approved Date">
                          AE/IE {formData.ae_cos_status === "Approved" ? "Recommended" : formData.ae_cos_status === "observation" ? "Observation" : "Rejected"} Date
                          <span className="required">*</span>
                        </label>
                        {formData.ae_cos_status === "Approved" && (
                          <input
                            type="date"
                            name="ae_approval_date"
                            value={formData.ae_approval_date}
                            onChange={handleInputChange}
                            className="form-input-date width-17vw"
                          />
                        )}

                        {formData.ae_cos_status === "observation" && (
                          <input
                            type="date"
                            name="ae_ie_observation_date"
                            value={formData.ae_ie_observation_date}
                            onChange={handleInputChange}
                            className="form-input-date width-17vw"
                          />
                        )}

                        {formData.ae_cos_status === "rejected" && (
                          <input
                            type="date"
                            name="ae_reject_date"
                            value={formData.ae_reject_date}
                            onChange={handleInputChange}
                            className="form-input-date width-17vw"
                          />
                        )}

                        {formData.ae_cos_status === "Approved" && errors.ae_approval_date && (
                          <div className="error-message font-size-text">{errors.ae_approval_date}</div>
                        )}
                        {formData.ae_cos_status === "rejected" && errors.ae_reject_date && (
                          <div className="error-message font-size-text">{errors.ae_reject_date}</div>
                        )}
                        {formData.ae_cos_status === "observation" && errors.ae_ie_observation_date && (
                          <div className="error-message font-size-text">{errors.ae_ie_observation_date}</div>
                        )}
                      </div>

                    </>
                    : ""
                  }
                  {formData.ae_cos_status === "Approved" ?
                    <div className="flex-column">
                      <label className="form-labels font-weight500 font-size-subheading" title="Amount(Write full amount)">AE/IE Recommended Amount<span className="required">*</span></label>
                      <input
                        type="number"
                        name="ae_approved_amount"
                        title="AE Approved Amount"
                        placeholder="AE Approved Amount"
                        value={formData.ae_approved_amount}
                        onChange={handleInputChange}

                        className={`form-input-date width-20vw ${errors.ae_approved_amount ? "error" : inputState.ae_approved_amount ? "success" : ""}`}

                      />
                      {errors.ae_approved_amount && <div className="error-message font-size-text">{errors.ae_approved_amount}</div>}
                    </div> : ""

                  }

                  <div className="flex-column form-group-selectt">
                    <label className="form-labels font-weight500 font-size-subheading" title="Client Response">Client Response</label>
                    <br />
                    <select
                      name="cos_status"
                      title="Client Response"
                      value={formData.cos_status}
                      onChange={handleInputChange}
                      className={`form-input-date width-20vw form-group-selection`}
                    >
                      <option value="pending">Pending</option>
                      <option value="inprinciple">In-Principle</option>
                      <option value="seek_clarification">Seek-Clarification</option>
                      <option value="Approved">Approved</option>
                      <option value="rejected">Rejected</option>

                    </select>

                    {errors.cos_status && <div className="error-message font-size-text">{errors.cos_status}</div>}
                  </div>
                  {(formData.cos_status !== "pending" && formData.cos_status !== "seek_clarification") ?
                    <>
                      <div className="flex-column">
                        <label style={{ marginBottom: formData.cos_status === "inprinciple" ? "25px" : formData.cos_status === "Approved" ? "25px" : "0px" }} className="form-labels font-weight500 font-size-subheading" title="Approval Date">
                          Client {formData.cos_status === "Approved" ? "Approved" : formData.cos_status === "inprinciple" ? "In-Principle" : formData.cos_status === "rejected" ? "Rejected" : ""}  Date<span className="required">*</span></label>
                        {formData.cos_status === "Approved" &&
                          <input
                            type="date"
                            name="approval_date"
                            value={formData.approval_date}
                            onChange={handleInputChange}
                            className={`form-input-date width-20vw ${errors.approval_date
                              ? "error"
                              : inputState.approval_date
                                ? "success"
                                : ""
                              }`}
                          />
                        }
                        {formData.cos_status === "rejected" &&
                          <input
                            type="date"
                            name="client_rejected_date"
                            value={formData.client_rejected_date}
                            min={formData.process_initiate_date}
                            onChange={handleInputChange}
                            className={`form-input-date width-20vw ${errors.client_rejected_date
                              ? "error"
                              : inputState.client_rejected_date
                                ? "success"
                                : ""
                              }`}
                          />
                        }
                        {formData.cos_status === "inprinciple" &&
                          <input
                            type="date"
                            name="client_in_principle_date"
                            value={formData.client_in_principle_date}
                            min={formData.process_initiate_date}
                            onChange={handleInputChange}
                            className={`form-input-date width-20vw ${errors.client_in_principle_date
                              ? "error"
                              : inputState.client_in_principle_date
                                ? "success"
                                : ""
                              }`}
                          />
                        }


                        {errors.approval_date && <div className="error-message font-size-text">{errors.approval_date}</div>}
                        {errors.client_in_principle_date && <div className="error-message font-size-text">{errors.client_in_principle_date}</div>}
                        {errors.client_rejected_date && <div className="error-message font-size-text">{errors.client_rejected_date}</div>}
                      </div>
                      {(formData.cos_status === "Approved" || formData.cos_status === "inprinciple") &&
                        <div className="flex-column">
                          <label className="form-labels font-weight500 font-size-subheading" title={`Client ${formData.cos_status === "Approved" ? "Approved" : formData.cos_status === "inprinciple" ? "In-Principle" : ""} Amount`}>Client {formData.cos_status === "Approved" ? "Approved" : formData.cos_status === "inprinciple" ? "In-Principle" : ""}  Amount <span className="required">*<br />(Write full Amount)</span>
                          </label>
                          {formData.cos_status === "Approved" &&

                            <input
                              type="text"
                              name="approved_amount"
                              title="Approved Amount By Client(Write full Amount)"
                              placeholder="Approved Amount"
                              value={formData.approved_amount}
                              max={formData.amount}

                              onChange={handleInputChange}

                              className={`form-input-date width-20vw ${errors.approved_amount ? "error" : inputState.approved_amount ? "success" : ""}`}

                            />
                          }
                          {formData.cos_status === "inprinciple" &&

                            <input
                              type="text"
                              name="in_principle_amount_byclient"
                              title="Client In-Principle Amount(Write full Amount)"
                              placeholder="Approved Amount"
                              value={formData.in_principle_amount_byclient}
                              max={formData.amount}

                              onChange={handleInputChange}

                              className={`form-input-date width-20vw ${errors.in_principle_amount_byclient ? "error" : inputState.in_principle_amount_byclient ? "success" : ""}`}

                            />
                          }
                          {errors.in_principle_amount_byclient && <div className="error-message font-size-text">{errors.in_principle_amount_byclient}</div>}
                          {errors.approved_amount && <div className="error-message font-size-text">{errors.approved_amount}</div>}
                        </div>
                      }
                    </>
                    : ""}

                  <div className="form-group">
                    <div className="flex-column form-group-selectt">
                      <label style={{ marginBottom: toggleState === 'consultant' ? "0px" : formData.cos_status === "inprinciple" ? "25px" : formData.cos_status === "Approved" ? "25px" : "0px" }} className="form-labels font-weight500 font-size-subheading" title="Letter">
                        Initial Submission Letter <span className="required">*</span>
                      </label>

                      <br />
                      <Select
                        name="letter"
                        placeholder="Select Option"
                        options={letterOptions}
                        isClearable
                        value={letterOptions.find(
                          (opt) => opt.value === formData.letter
                        )}
                        onChange={(selectedOption) =>
                          handleInputChange({
                            target: {
                              name: "letter",
                              value: selectedOption ? selectedOption.value : "",
                            },
                          })
                        }
                        styles={CSSForSelect15vWWidth}
                      />


                    </div>
                    {errors.letter && (
                      <div className="error-message font-size-text">
                        {errors.letter}
                      </div>
                    )}
                  </div>

                  {formData.ae_cos_status && formData.ae_cos_status !== "pending" ?
                    <div className="flex-column form-group-selectt">
                      <label style={{ marginBottom: formData.cos_status === "inprinciple" ? "25px" : formData.cos_status === "Approved" ? "25px" : "0px" }} className="form-labels font-weight500 font-size-subheading" title="AE Close Letter">
                        AE/IE  {formData.ae_cos_status === "Approved" ? "Recommended" : formData.ae_cos_status === "observation" ? "Observation" : formData.ae_cos_status === "rejected" ? "Rejected" : ""} Letter<span className="required">*</span>

                      </label>
                      <br />
                      {formData.ae_cos_status === "Approved" && (
                        <Select
                          name="ae_close_letter"
                          placeholder="Select Option"
                          options={letterOptions}
                          isClearable
                          value={letterOptions.find(
                            (opt) => opt.value === formData.ae_close_letter
                          )}
                          onChange={(selectedOption) =>
                            handleInputChange({
                              target: {
                                name: "ae_close_letter",
                                value: selectedOption ? selectedOption.value : "",
                              },
                            })
                          }
                          styles={CSSForSelect15vWWidth}
                        />

                      )}
                      {formData.ae_cos_status === "rejected" && (
                        <Select
                          name="ae_ie_rejected_letter"
                          placeholder="Select Option"
                          options={letterOptions}
                          isClearable
                          value={letterOptions.find(
                            (opt) => opt.value === formData.ae_ie_rejected_letter
                          )}
                          onChange={(selectedOption) =>
                            handleInputChange({
                              target: {
                                name: "ae_ie_rejected_letter",
                                value: selectedOption ? selectedOption.value : "",
                              },
                            })
                          }
                          styles={CSSForSelect15vWWidth}
                        />
                      )}
                      {formData.ae_cos_status === "observation" && (
                        <Select
                          name="ae_ie_observation_letter"
                          placeholder="Select Option"
                          options={letterOptions}
                          isClearable
                          value={letterOptions.find(
                            (opt) => opt.value === formData.ae_ie_observation_letter
                          )}
                          onChange={(selectedOption) =>
                            handleInputChange({
                              target: {
                                name: "ae_ie_observation_letter",
                                value: selectedOption ? selectedOption.value : "",
                              },
                            })
                          }
                          styles={CSSForSelect15vWWidth}
                        />
                      )}

                      <div className="form-group-selection-arrow">

                      </div>
                      {errors.ae_close_letter && (
                        <div className="error-message font-size-text">
                          {errors.ae_close_letter}
                        </div>
                      )}
                      {errors.ae_ie_observation_letter && (
                        <div className="error-message font-size-text">
                          {errors.ae_ie_observation_letter}
                        </div>
                      )}
                      {errors.ae_ie_rejected_letter && (
                        <div className="error-message font-size-text">
                          {errors.ae_ie_rejected_letter}
                        </div>
                      )}
                    </div> : ""
                  }
                  {formData.cos_status !== "pending" &&
                    <>
                      <div className="flex-column form-group-selectt">
                        <label className="form-labels font-weight500 font-size-subheading" title="Close Letter">
                          Client  {formData.cos_status === "Approved" ? "Approved" : formData.cos_status === "seek_clarification" ? "Seek-Clarification" : formData.cos_status === "rejected" ? "Rejected" : formData.cos_status === "inprinciple" ? "In-Principle" : ""} Letter<span className="required">*</span>

                        </label>
                        <br />
                        {formData.cos_status === "Approved" && (
                          <select
                            name="close_letter"
                            title="Client Approved Letter"
                            value={formData.close_letter}
                            onChange={handleInputChange}
                            className={`form-input-date width-20vw form-group-selection ${errors.close_letter ? "error" : inputState.close_letter ? "success" : ""
                              }`}
                          >
                            <option value="">Select Option</option>
                            {trackRecordList.map((option) => (
                              <option key={option.id} value={option.id}>
                                {option.letter_num}
                              </option>
                            ))}
                          </select>
                        )}
                        {formData.cos_status === "rejected" && (
                          <Select
                            name="client_rejected_letter"
                            placeholder="Select Option"
                            options={letterOptions}
                            isClearable
                            value={letterOptions.find(
                              (opt) => opt.value === formData.client_rejected_letter
                            )}
                            onChange={(selectedOption) =>
                              handleInputChange({
                                target: {
                                  name: "client_rejected_letter",
                                  value: selectedOption ? selectedOption.value : "",
                                },
                              })
                            }
                            styles={CSSForSelect15vWWidth}
                          />
                        )}
                        {formData.cos_status === "inprinciple" && (
                          <Select
                            name="client_in_principle_letter"
                            placeholder="Select Option"
                            options={letterOptions}
                            isClearable
                            value={letterOptions.find(
                              (opt) => opt.value === formData.client_in_principle_letter
                            )}
                            onChange={(selectedOption) =>
                              handleInputChange({
                                target: {
                                  name: "client_in_principle_letter",
                                  value: selectedOption ? selectedOption.value : "",
                                },
                              })
                            }
                            styles={CSSForSelect15vWWidth}
                          />
                        )}
                        {formData.cos_status === "seek_clarification" && (
                          <Select
                            name="client_seek_clarfication_letter"
                            placeholder="Select Option"
                            options={letterOptions}
                            isClearable
                            value={letterOptions.find(
                              (opt) => opt.value === formData.client_seek_clarfication_letter
                            )}
                            onChange={(selectedOption) =>
                              handleInputChange({
                                target: {
                                  name: "client_seek_clarfication_letter",
                                  value: selectedOption ? selectedOption.value : "",
                                },
                              })
                            }
                            styles={CSSForSelect15vWWidth}
                          />
                        )}

                        <div className="form-group-selection-arrow">

                        </div>
                        {errors.close_letter && (
                          <div className="error-message font-size-text">
                            {errors.close_letter}
                          </div>
                        )}
                        {errors.client_rejected_letter && (
                          <div className="error-message font-size-text">
                            {errors.client_rejected_letter}
                          </div>
                        )}
                        {errors.client_in_principle_letter && (
                          <div className="error-message font-size-text">
                            {errors.client_in_principle_letter}
                          </div>
                        )}
                        {errors.client_seek_clarfication_letter && (
                          <div className="error-message font-size-text">
                            {errors.client_seek_clarfication_letter}
                          </div>
                        )}
                      </div>
                    </>

                  }

                </div>

                <>
                  <div
                    style={{ display: "flex", justifyContent: "space-evenly" }}
                  >
                    <div>OR</div>
                  </div>



                  <div className="button-models">
                    <AddTrackRecordDetails
                      projectId={project}
                      contractor={contractor}
                      letterfor={formData.workperformedby}
                      lettertype="cos"
                      getProjects={getLetters}
                      title="COS Letter"
                      site_prcode={site_prcode}
                      projectName={projectName}

                    />
                  </div>
                </>




                <div className="button-models" style={{ marginTop: "20px", justifyContent: "space-evenly" }}>
                  <button className="cancelbutton" onClick={handleClose}>Cancel</button>

                  <Updatebutton onclick={handleCOSUpdate} />
                </div>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};


const DeleteCOS = ({ i, getCOS, contractor, toggleState }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [ContractorData, setContractorData] = useState({
    cost_with_cos: 0
  });

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);


  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);

    const loadingToastId = toast.loading("Deleting: please wait...");
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);

    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/cos/${i.id}/`
      );

      if (res.status === 200) {
        await getCOS();



        handleClose();
        setTimeout(() => {
          toast.dismiss(loadingToastId);
          toast.success("Data deleted successfully.", {
            autoClose: 1000,
            pauseOnHover: true,
            closeOnClick: true,
          });
        }, 1000);
      } else {
        throw new Error("Unexpected response status: " + res.status);
      }

    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      handleErrorToast(err);
    } finally {
      clearInterval(interval);

      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);

      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete COS"
        className="model-delete-button"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" /> :
          show === true ?
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="request-leave width-40vw"
            >
              <Modal.Header closeButton>
                <Modal.Title>Delete COS</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="parent-div">
                  Are You Sure You Want to delete COS Data of {i.cos_code}
                  <div className="button-models" style={{ marginTop: "40px", justifyContent: "space-evenly" }}>
                    <button className="cancelbutton" onClick={handleClose}>Cancel</button>
                    <DeleteButton onclick={handleFormSubmitDelete} />

                  </div>
                </div>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};


const DeleteMileStone = ({ i, getMilestone }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  const [loading, setLoading] = useState(false);

  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);

  const handleFormSubmitDelete = async (e) => {
    e.preventDefault();
    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);

    const loadingToastId = toast.loading("Deleting: please wait...");
    let progress = 0;
    const interval = setInterval(() => {
      progress += 10;
      if (progress >= 100) {
        progress = 100;
        clearInterval(interval);
      }
      setUploadProgress(progress);
    }, 100);


    try {
      let res = await axios.delete(
        `${BASE_URL}/siteproject/milestone/${i.id}/`
      );

      if (res.status === 200) {
        await getMilestone();
        setShow(false);
        setTimeout(() => {
          toast.dismiss(loadingToastId);
          toast.success("Data deleted successfully.", {
            autoClose: 1000,
            pauseOnHover: true,
            closeOnClick: true,
          });
        }, 1000);
      } else {
        throw new Error("Unexpected response status: " + res.status);
      }

    } catch (err) {
      clearInterval(interval);
      setUploadProgress(0);
      handleErrorToast(err);
    } finally {
      clearInterval(interval);

      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);

      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      <button
        title="Delete Insurance"
        className="model-delete-button"
        onClick={handleShow}
      >
        <DeleteDustbin />
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" /> :
          show === true ?
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="request-leave width-40vw"
            >
              <Modal.Header closeButton>
                <Modal.Title>Delete Milestone</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="parent-div">
                  Are You Sure You Want to delete Milestone Data of {i.name}
                  <div className="button-models" style={{ marginTop: "40px", justifyContent: "space-evenly" }}>
                    <button className="cancelbutton" onClick={handleClose}>Cancel</button>
                    <DeleteButton onclick={handleFormSubmitDelete} />

                  </div>
                </div>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};
// const UpdateMilestone = ({ i, project, getProjects, appointed_date, contractor, site_prcode,
//   projectName }) => {
//   const [show, setShow] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     project: project,
//     name: "",
//     milestone_date: "null",
//     milestone_as_per_reschedule: "null",
//     milestone_as_per_actual: "null",
//     day: "",
//     rescedule_gap_days: "",
//     actual_letter: "null",
//     reschedule_letter: "null",
//     actual_gap_days: "",
//     workperformedby: "contractor",
//     letter: "",
//     contractor: contractor,
//   });

//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});

//   const handleClose = () => {
//     setShow(false);
//     setFormData({
//       project: project,
//       name: "",
//       milestone_date: null,
//       milestone_as_per_reschedule: null,
//       milestone_as_per_actual: null,
//       actual_letter: "null",
//       reschedule_letter: "null",
//       day: "",
//       rescedule_gap_days: "",
//       actual_gap_days: "",
//       workperformedby: "contractor",
//       letter: "",
//       contractor: contractor,
//     });
//   };

//   useEffect(() => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       contractor: contractor,
//     }));
//   }, [contractor]);

//   const handleShow = () => {
//     setShow(true);
//     setFormData(i);
//   }

//   const validateForm = () => {
//     const newErrors = {};

//     if (formData.milestone_as_per_actual && !formData.actual_letter) {
//       newErrors.actual_letter = "Actual Letter is required!";
//     }

//     if (formData.milestone_as_per_reschedule && !formData.reschedule_letter) {
//       newErrors.reschedule_letter = "Reschedule Letter is required!";
//     }

//     setErrors(newErrors);
//     console.log(errors, "milestoneErrors")


//     setErrors(newErrors);

//     if (Object.keys(newErrors).length > 0) {
//       toast.dismiss();
//       toast.warn("Fill all * fields");
//       return false;
//     }

//     return true;
//   };




//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     // input color feedback
//     setInputState({
//       ...inputState,
//       [name]: value.trim() ? "green" : "",
//     });

//     const appointedDate = new Date(appointed_date);

//     /* ================================
//        REVERSE LOGIC: GAP DAYS → DATE
//     ================================= */
//     if (name === "rescedule_gap_days") {
//       if (value === "" || isNaN(value)) {
//         setFormData((prev) => ({
//           ...prev,
//           rescedule_gap_days: 0,
//           milestone_as_per_reschedule: null,
//         }));
//         return;
//       }

//       if (!isNaN(appointedDate.getTime())) {
//         const gapDays = Number(value);

//         const calculatedDate = new Date(appointedDate);
//         calculatedDate.setDate(appointedDate.getDate() + gapDays - 1);

//         setFormData((prev) => ({
//           ...prev,
//           rescedule_gap_days: gapDays,
//           milestone_as_per_reschedule: calculatedDate
//             .toISOString()
//             .split("T")[0],
//         }));
//       }
//       return;
//     }

//     /* ================================
//        EXISTING DATE → DAYS LOGIC
//     ================================= */
//     if (name === "milestone_as_per_reschedule") {
//       if (value === "") {
//         setFormData((prev) => ({
//           ...prev,
//           milestone_as_per_reschedule: null,
//           rescedule_gap_days: 0,
//         }));
//       } else {
//         const milestoneRescheduleDate = new Date(value);

//         if (
//           !isNaN(milestoneRescheduleDate.getTime()) &&
//           milestoneRescheduleDate >= appointedDate
//         ) {
//           const diffInTime =
//             milestoneRescheduleDate.getTime() - appointedDate.getTime();
//           const diffInDays =
//             Math.ceil(diffInTime / (1000 * 3600 * 24)) + 1;

//           setFormData((prev) => ({
//             ...prev,
//             milestone_as_per_reschedule: value,
//             rescedule_gap_days: diffInDays,
//           }));
//         } else {
//           setErrors((prev) => ({
//             ...prev,
//             milestone_as_per_reschedule:
//               "Reschedule date must be after the appointed date",
//           }));
//         }
//       }
//       return;
//     }

//     /* ================================
//        ACTUAL DATE LOGIC (UNCHANGED)
//     ================================= */
//     if (name === "milestone_as_per_actual") {
//       if (value === "") {
//         setFormData((prev) => ({
//           ...prev,
//           milestone_as_per_actual: null,
//           actual_gap_days: 0,
//         }));
//       } else {
//         const milestoneActualDate = new Date(value);

//         if (
//           !isNaN(milestoneActualDate.getTime()) &&
//           milestoneActualDate >= appointedDate
//         ) {
//           const diffInTime =
//             milestoneActualDate.getTime() - appointedDate.getTime();
//           const diffInDays =
//             Math.floor(diffInTime / (1000 * 3600 * 24)) + 1;

//           setFormData((prev) => ({
//             ...prev,
//             milestone_as_per_actual: value,
//             actual_gap_days: diffInDays,
//           }));
//         } else {
//           setErrors((prev) => ({
//             ...prev,
//             milestone_as_per_actual:
//               "Actual milestone date must be after the appointed date",
//           }));
//         }
//       }
//       return;
//     }


//     setFormData((prev) => ({
//       ...prev,
//       [name]: value === "" ? null : value,
//     }));
//   };





//   const [trackRecordList, setTrackRecordList] = useState([]);

//   const getLetters = async () => {
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/siteproject/letterrecordbyfilters/${project}/${formData.workperformedby}/Milestone/${contractor}/`
//       );
//       setTrackRecordList(res.data);
//     } catch (err) {
//       console.error(err);
//     } finally {
//     }
//   };
//   useEffect(() => {
//     getLetters();
//     // eslint-disable-next-line react-hooks/exhaustive-deps
//   }, [formData.workperformedby, contractor]);


//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [showProgressModal, setShowProgressModal] = useState(false);

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (validateForm()) {
//       setShowProgressModal(true);
//       setLoading(true);
//       setUploadProgress(0);

//       const loadingToastId = toast.loading("Updating: please wait...");
//       let progress = 0;
//       const interval = setInterval(() => {
//         progress += 10;
//         if (progress >= 100) {
//           progress = 100;
//           clearInterval(interval);
//         }
//         setUploadProgress(progress);
//       }, 100);

//       try {

//         let res = await axios.put(
//           `${BASE_URL}/siteproject/milestone/${i.id}/`,
//           formData
//         );

//         if (res.status === 200) {
//           await getProjects();
//           handleClose();
//           setTimeout(() => {
//             toast.dismiss(loadingToastId);
//             toast.success("Data updated successfully.", {
//               autoClose: 1000,
//               pauseOnHover: true,
//               closeOnClick: true,
//             });
//           }, 1000);
//         } else {
//           throw new Error("Unexpected response status: " + res.status);
//         }

//       } catch (err) {
//         clearInterval(interval);
//         setUploadProgress(0);
//         handleErrorToast(err);
//       } finally {
//         clearInterval(interval);

//         setTimeout(() => {
//           setShowProgressModal(false);
//         }, 1500);

//         setLoading(false);
//         toast.dismiss(loadingToastId);
//       }
//     }
//   };

//   const letterOptions = trackRecordList.map((item) => ({
//     value: item.id,
//     label: item.letter_num,
//   }));
//   return (
//     <>
//       <button
//         title="Update Milestones"
//         className="model-edit-button"
//         onClick={handleShow}
//       >
//         <UpdatePencil />
//       </button>
//       {
//         showProgressModal ?
//           <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" /> :
//           show === true ?
//             <Modal
//               show={show}
//               onHide={handleClose}
//               dialogClassName="ourcompany-model"
//             >
//               <Modal.Header closeButton>
//                 <Modal.Title>Update Milestone Detail</Modal.Title>
//               </Modal.Header>
//               <Modal.Body>
//                 <ToastContainer
//                   position="top-center"
//                   autoClose={3000}
//                   hideProgressBar
//                 />
//                 <div className="parent-div">
//                   <div className="form-flex-wrap">

//                     <div className="flex-column">
//                       <label className="form-labels font-weight500 font-size-subheading" title="Name">
//                         Name<span className="required">(Read-Only)</span>
//                       </label>
//                       <input
//                         type="text"
//                         title="Name"
//                         name="name"
//                         placeholder="Name"
//                         value={formData.name}
//                         onChange={handleInputChange}
//                         className="width-17vw form-input-date"
//                         readOnly
//                       />
//                     </div>

//                     <div className="flex-column">
//                       <label className="form-labels font-weight500 font-size-subheading" title="Appointed Date">
//                         Appointed Date<span className="required">(Read-Only)</span>
//                       </label>
//                       <input
//                         type="date"
//                         name="appointed_date"
//                         title="Appointed Date"
//                         value={appointed_date}
//                         onChange={handleInputChange}
//                         className="width-17vw form-input-date"
//                         readOnly
//                       />
//                     </div>
//                     <div className="flex-column">
//                       <label className="form-labels font-weight500 font-size-subheading" title="MileStone Date(Enter Milestone Days)">
//                         Milestone Date<span className="required">(Read-Only)</span>
//                       </label>
//                       <input
//                         type="date"
//                         name="milestone_date"
//                         title="Milestone Date"
//                         min={appointed_date}
//                         value={formData.milestone_date}
//                         onChange={handleInputChange}
//                         className="width-17vw form-input-date"
//                         readOnly
//                       />
//                     </div>
//                     <div className="flex-column">
//                       <label className="form-labels font-weight500 font-size-subheading" title="MileStone Days">
//                         MileStone Days<span className="required">(Read-Only)</span>
//                       </label>
//                       <input
//                         type="number"
//                         name="day"
//                         title="MileStone Days"
//                         placeholder="Day"
//                         value={formData.day}
//                         min={0}
//                         onChange={handleInputChange}
//                         className="width-17vw form-input-date"
//                         readOnly
//                       />
//                     </div>


//                     <div className="flex-column">
//                       <label className="form-labels font-weight500 font-size-subheading" title="Actual Milestone Date">
//                         Actual Milestone Date
//                       </label>
//                       <input
//                         type="date"
//                         name="milestone_as_per_actual"
//                         title="Actual Milestone Date"
//                         min={formData.milestone_date}
//                         value={formData.milestone_as_per_actual}
//                         onChange={handleInputChange}
//                         className="width-17vw form-input-date"
//                       // readOnly
//                       />
//                       {errors.milestone_as_per_actual && (
//                         <div className="error-message font-size-text">
//                           {errors.milestone_as_per_actual}
//                         </div>
//                       )}
//                     </div>
//                     <div className="flex-column">
//                       <label className="form-labels font-weight500 font-size-subheading" title="Actual Gap Days">
//                         Actual Gap Days<span className="required">(Read-Only)</span>
//                       </label>
//                       <input
//                         type="number"
//                         title="Actual Gap Days"
//                         name="actual_gap_days"
//                         placeholder="Actual Gap Days"
//                         value={formData.actual_gap_days}
//                         min={0}
//                         onChange={handleInputChange}
//                         className="width-17vw form-input-date"
//                         readOnly
//                       />
//                     </div>

//                     <div className="flex-column">
//                       <label className="form-labels font-weight500 font-size-subheading" title="Reschedule Milestone Date">
//                         Reschedule Milestone Date <span className="required">(Read-Only)</span>
//                       </label>
//                       <input
//                         type="date"
//                         name="milestone_as_per_reschedule"
//                         title="Reschedule Milestone Date"
//                         min={formData.milestone_as_per_actual}
//                         value={formData.milestone_as_per_reschedule}
//                         onChange={handleInputChange}
//                         className="width-17vw form-input-date"
//                         readOnly
//                       />
//                       {errors.milestone_as_per_reschedule && (
//                         <div className="error-message font-size-text">
//                           {errors.milestone_as_per_reschedule}
//                         </div>
//                       )}
//                     </div>
//                     <div className="flex-column">
//                       <label className="form-labels font-weight500 font-size-subheading" title="Reschedule Gap Days">
//                         Reschedule Gap Days
//                       </label>
//                       <input
//                         type="number"
//                         name="rescedule_gap_days"
//                         title="Reschedule Gap Days"
//                         placeholder="Reschedule Gap Days"
//                         value={formData.rescedule_gap_days}
//                         min={0}
//                         onChange={handleInputChange}
//                         className="width-17vw form-input-date"
//                       />
//                     </div>
//                     <div className="flex-column form-group-selectt">
//                       <label className="form-labels font-weight500 font-size-subheading" title="Letter">
//                         Reschedule Letter {formData.milestone_as_per_reschedule !== null && <span className="required">*</span>}
//                       </label>
//                       <br />
//                       <Select
//                         name="reschedule_letter"
//                         placeholder="Select Option"
//                         options={letterOptions}
//                         isClearable
//                         value={letterOptions.find(
//                           (opt) => opt.value === formData.reschedule_letter
//                         )}
//                         onChange={(selectedOption) =>
//                           handleInputChange({
//                             target: {
//                               name: "reschedule_letter",
//                               value: selectedOption ? selectedOption.value : "",
//                             },
//                           })
//                         }
//                         styles={CSSForSelect15vWWidth}
//                       />

//                       {errors.reschedule_letter && (
//                         <div className="error-message font-size-text">
//                           {errors.reschedule_letter}
//                         </div>
//                       )}
//                     </div>
//                     <div className="form-group">
//                       <div className="flex-column form-group-selectt">
//                         <label className="form-labels font-weight500 font-size-subheading" title="Letter">
//                           Actual Letter {formData.milestone_as_per_actual !== null && <span className="required">*</span>}
//                         </label>
//                         <br />
//                         <Select
//                           name="actual_letter"
//                           placeholder="Select Option"
//                           options={letterOptions}
//                           isClearable
//                           value={letterOptions.find(
//                             (opt) => opt.value === formData.actual_letter
//                           )}
//                           onChange={(selectedOption) =>
//                             handleInputChange({
//                               target: {
//                                 name: "actual_letter",
//                                 value: selectedOption ? selectedOption.value : "",
//                               },
//                             })
//                           }
//                           styles={CSSForSelect15vWWidth}
//                         />


//                       </div>
//                       {errors.actual_letter && (
//                         <div className="error-message font-size-text">
//                           {errors.actual_letter}
//                         </div>
//                       )}
//                     </div>
//                     {formData.reschedule_letter && formData.actual_letter ? (
//                       ""
//                     ) : (
//                       <>
//                         <div className="flex-column justify-center">
//                           <div className="text-center" style={{ marginTop: "30px", width: "19vw" }}>OR</div>
//                         </div>

//                         <div className="flex-column">
//                           <div style={{ marginTop: "30px", width: "18vw" }}>
//                             <AddTrackRecordDetails
//                               projectId={project}
//                               contractor={contractor}
//                               letterfor="contractor"
//                               lettertype="Milestone"
//                               getProjects={getLetters}
//                               title="Milestone Letter"
//                               site_prcode={site_prcode}
//                               projectName={projectName}


//                             />
//                           </div>
//                         </div>
//                       </>
//                     )}

//                   </div>





//                   <div className="button-models" style={{ justifyContent: "space-evenly", marginTop: "20px" }}>
//                     <button className="cancelbutton" onClick={handleClose}>Cancel</button>
//                     <Updatebutton onclick={handleSubmit} />
//                   </div>

//                 </div>
//               </Modal.Body>
//             </Modal > : ""
//       }
//     </>
//   );
// };


const UpdateMilestone = ({ i, project, getProjects, appointed_date, contractor, site_prcode, projectName }) => {
  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    project: project,
    name: "",
    milestone_percentage: "",
    milestone_date: null,
    milestone_as_per_reschedule: null,
    milestone_as_per_actual: null,
    day: "",
    rescedule_gap_days: "",
    actual_letter: null,
    reschedule_letter: null,
    actual_gap_days: "",
    workperformedby: "contractor",
    letter: "",
    contractor: contractor,
  });

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const handleClose = () => {
    setShow(false);
    setFormData({
      project: project,
      name: "",
      milestone_percentage: "",
      milestone_date: null,
      milestone_as_per_reschedule: null,
      milestone_as_per_actual: null,
      actual_letter: "null",
      reschedule_letter: "null",
      day: "",
      rescedule_gap_days: "",
      actual_gap_days: "",
      workperformedby: "contractor",
      letter: "",
      contractor: contractor,
    });
    setErrors({});
  };

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      contractor: contractor,
    }));
  }, [contractor]);



  // ✅ Set original values when modal opens
  const handleShow = () => {
    setShow(true);
    setFormData(i);

  };

  const validateForm = () => {
    const newErrors = {};

    if (formData.milestone_as_per_actual && !formData.actual_letter) {
      newErrors.actual_letter = "Actual Letter is required!";
    }
    // if (formData.milestone_percentage) {
    //   newErrors.milestone_percentage = "Miletone Percentage is required!";
    // }

    if (formData.milestone_as_per_reschedule && !formData.reschedule_letter) {
      newErrors.reschedule_letter = "Reschedule Letter is required!";
    }

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.dismiss();
      toast.warn("Fill all required fields");
      return false;
    }

    return true;
  };
  const calculateDerivedFields = (updatedFormData, appointed_date) => {
    const derived = { ...updatedFormData };
    const toDate = (str) => (str ? new Date(str) : null);
    const diffDays = (dateA, dateB) => {
      if (!dateA || !dateB) return "";
      const msPerDay = 1000 * 60 * 60 * 24;
      const start = dateA < dateB ? dateA : dateB;
      const end = dateA < dateB ? dateB : dateA;
      return Math.floor((end - start) / msPerDay) + 1;
    };

    const appointedDate = toDate(appointed_date);
    const rescheduleDays = parseInt(derived.rescedule_gap_days);

    if (updatedFormData._changedField === "rescedule_gap_days") {
      derived.milestone_as_per_actual = null;
      derived.actual_gap_days = "";
    }

    if (!derived.rescedule_gap_days || isNaN(rescheduleDays) || rescheduleDays <= 0) {
      derived.milestone_as_per_reschedule = null;
    } else if (appointedDate && rescheduleDays > 0) {
      const rescheduleDate = new Date(appointedDate);
      rescheduleDate.setDate(rescheduleDate.getDate() + rescheduleDays - 1);
      derived.milestone_as_per_reschedule = rescheduleDate.toISOString().split("T")[0];
    }

    const actualDate = toDate(derived.milestone_as_per_actual);

    if (!actualDate) {
      derived.actual_gap_days = "";
    } else if (updatedFormData._changedField !== "rescedule_gap_days") {
      // ✅ Always use appointedDate as base for actual_gap_days
      derived.actual_gap_days = diffDays(appointedDate, actualDate);
    }

    return derived;
  };




  const resceduleDaysRef = useRef(null);
  const actualDateRef = useRef(null);
  const rescheduleDateRef = useRef(null);



  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Convert empty date values to null
    const dateFields = ["milestone_as_per_actual", "milestone_as_per_reschedule", "milestone_date"];
    const processedValue = dateFields.includes(name) && value === "" ? null : value;

    setInputState({
      ...inputState,
      [name]: processedValue ? "green" : "",
    });

    const updatedFormData = {
      ...formData,
      [name]: processedValue,
      _changedField: name,
    };

    const finalFormData = calculateDerivedFields(updatedFormData, appointed_date);
    delete finalFormData._changedField;

    if (name === "rescedule_gap_days") {
      if (actualDateRef.current) actualDateRef.current.value = "";
      if (rescheduleDateRef.current) rescheduleDateRef.current.value = "";
    }

    setFormData(finalFormData);

    if (errors[name]) {
      setErrors((prevErrors) => {
        const { [name]: removedError, ...restErrors } = prevErrors;
        return restErrors;
      });
    }
  };




  const [trackRecordList, setTrackRecordList] = useState([]);

  const getLetters = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/letterrecordbyfilters/${project}/${formData.workperformedby}/Milestone/${contractor}/`
      );
      setTrackRecordList(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    getLetters();
  }, [formData.workperformedby, contractor]);

  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setShowProgressModal(true);
      setLoading(true);
      setUploadProgress(0);

      const loadingToastId = toast.loading("Updating: please wait...");
      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setUploadProgress(progress);
      }, 100);

      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/milestone/${i.id}/`,
          formData
        );

        if (res.status === 200) {
          await getProjects();
          handleClose();
          setTimeout(() => {
            toast.dismiss(loadingToastId);
            toast.success("Milestone data updated successfully.", {
              autoClose: 1000,
              pauseOnHover: true,
              closeOnClick: true,
            });
          }, 1000);
        } else {
          throw new Error("Unexpected response status: " + res.status);
        }
      } catch (err) {
        clearInterval(interval);
        setUploadProgress(0);
        handleErrorToast(err);
      } finally {
        clearInterval(interval);
        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);
        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  const letterOptions = trackRecordList.map((item) => ({
    value: item.id,
    label: item.letter_num,
  }));

  console.log(formData, "formDataMilestone")


  return (
    <>
      <button title="Update Milestone" className="model-edit-button" style={{ background: "black" }} onClick={handleShow}>
        <UpdatePencil modernButton="true" />
      </button>

      {showProgressModal ? (
        <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Update" />
      ) : show === true ? (
        <Modal
          show={show}
          onHide={handleClose}
          dialogClassName="modern-project-modal"
          size="xl"
        >
          <Modal.Header className="modern-modal-header">
            <div className="header-content">
              <div className="header-icon" style={{ background: "transparent", color: "white" }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17 3l4 4-7 7H10v-4l7-7z" />
                  <path d="M4 20h16" />
                </svg>
              </div>
              <div>
                <Modal.Title>Update Milestone Details</Modal.Title>
                <p className="header-subtitle">Update milestone information for the project</p>
              </div>
            </div>
            <button className="close-btn" onClick={handleClose}>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </Modal.Header>

          <Modal.Body className="modern-modal-body">
            <ToastContainer position="top-center" autoClose={3000} hideProgressBar />

            <form onSubmit={handleSubmit} className="project-form">
              <div className="section-title">
                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2Z" />
                  <path d="M12 6v6l4 2" />
                </svg>
                <h4>Milestone Information</h4>
              </div>

              <div className="form-grid">
                {/* Read-only fields */}
                <div className="form-field">
                  <label>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                    </svg>
                    Milestone Name <span className="required">(Read-Only)</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    placeholder="Name"
                    value={formData.name}
                    className="readonly-field"
                    readOnly
                  />
                </div>

                <div className="form-field">
                  <label>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    Appointed Date <span className="required">(Read-Only)</span>
                  </label>
                  <input
                    type="date"
                    name="appointed_date"
                    value={appointed_date}
                    className="readonly-field"
                    readOnly
                  />
                </div>

                <div className="form-field">
                  <label>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    Milestone Date <span className="required">(Read-Only)</span>
                  </label>
                  <input
                    type="date"
                    name="milestone_date"
                    min={appointed_date}
                    value={formData.milestone_date}
                    className="readonly-field"
                    readOnly
                  />
                </div>
                <div className="form-field justify-between" style={{ width: "100%", flexDirection: "row" }}>
                  <div className="form-field" style={{ width: "54%" }}>
                    <label>
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <circle cx="12" cy="12" r="10" />
                        <polyline points="12 6 12 12 16 14" />
                      </svg>
                      Milestone Days <span className="required">(Read-Only)</span>
                    </label>
                    <input
                      type="number"
                      name="day"
                      placeholder="Day"
                      value={formData.day}
                      min={0}
                      className="readonly-field"
                      readOnly
                    />
                  </div>

                  <div className="form-field" style={{ width: "40%" }}>
                    <label>
                      <PercentCircleIcon size={12} />
                      Miletone Percentage
                    </label>
                    <input
                      type="number"
                      name="milestone_percentage"
                      placeholder="Miletone Percentage"
                      value={formData.milestone_percentage}
                      min={0}
                      onChange={handleInputChange}
                      className={`${errors.milestone_percentage ? "error" : inputState.milestone_percentage ? "success" : ""}`}
                    />
                  </div>
                </div>

                <div className="form-field">
                  <label>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    Reschedule Gap Days
                  </label>
                  <input
                    ref={resceduleDaysRef}
                    type="number"
                    name="rescedule_gap_days"
                    placeholder="Reschedule Gap Days"
                    value={formData.rescedule_gap_days || ""}
                    min={0}
                    onChange={handleInputChange}
                    className={`${errors.rescedule_gap_days ? "error" : inputState.rescedule_gap_days ? "success" : ""}`}
                  />
                </div>

                <div className="form-field">
                  <label>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    Reschedule Milestone Date <span className="required">(Read-Only)</span>
                  </label>
                  <input
                    ref={rescheduleDateRef}
                    type="date"
                    name="milestone_as_per_reschedule"
                    value={formData.milestone_as_per_reschedule || null}
                    className="readonly-field"
                    readOnly
                  />
                  {errors.milestone_as_per_reschedule && (
                    <div className="error-message">{errors.milestone_as_per_reschedule}</div>
                  )}
                </div>


                {/* Editable fields */}
                <div className="form-field">
                  <label>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    Actual Milestone Date
                  </label>
                  <input
                    ref={actualDateRef}
                    type="date"
                    name="milestone_as_per_actual"
                    min={appointed_date}
                    value={formData.milestone_as_per_actual || null}
                    onChange={handleInputChange}
                    className={`${errors.milestone_as_per_actual ? "error" : inputState.milestone_as_per_actual ? "success" : ""}`}
                  />
                  {errors.milestone_as_per_actual && (
                    <div className="error-message">{errors.milestone_as_per_actual}</div>
                  )}
                </div>

                <div className="form-field">
                  <label>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10" />
                      <polyline points="12 6 12 12 16 14" />
                    </svg>
                    Actual Gap Days <span className="required">(Read-Only)</span>
                  </label>
                  <input
                    type="number"
                    name="actual_gap_days"
                    placeholder="Actual Gap Days"
                    value={formData.actual_gap_days}
                    min={0}
                    className="readonly-field"
                    readOnly
                  />
                </div>




                <div className="form-field">
                  <label>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                    </svg>
                    Reschedule Letter {formData.milestone_as_per_reschedule !== null && <span className="required">*</span>}
                  </label>
                  <Select
                    name="reschedule_letter"
                    placeholder="Select Option"
                    options={letterOptions}
                    isClearable
                    value={letterOptions.find((opt) => opt.value === formData.reschedule_letter)}
                    onChange={(selectedOption) =>
                      handleInputChange({
                        target: {
                          name: "reschedule_letter",
                          value: selectedOption ? selectedOption.value : "",
                        },
                      })
                    }
                    styles={CSSForSelectModern}
                  />
                  {errors.reschedule_letter && (
                    <div className="error-message">{errors.reschedule_letter}</div>
                  )}
                </div>

                <div className="form-field">
                  <label>
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                      <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                    </svg>
                    Actual Letter {formData.milestone_as_per_actual !== null && <span className="required">*</span>}
                  </label>
                  <Select
                    name="actual_letter"
                    placeholder="Select Option"
                    options={letterOptions}
                    isClearable
                    value={letterOptions.find((opt) => opt.value === formData.actual_letter)}
                    onChange={(selectedOption) =>
                      handleInputChange({
                        target: {
                          name: "actual_letter",
                          value: selectedOption ? selectedOption.value : "",
                        },
                      })
                    }
                    styles={CSSForSelectModern}
                  />
                  {errors.actual_letter && (
                    <div className="error-message">{errors.actual_letter}</div>
                  )}
                </div>
              </div>

              {/* OR Section for adding new letters */}
              {!(formData.reschedule_letter && formData.actual_letter) && (
                <div className="or-section">
                  <div className="or-divider">
                    <span className="or-text">OR</span>
                  </div>
                  <div className="add-letter-section">
                    <AddTrackRecordDetails
                      projectId={project}
                      contractor={contractor}
                      letterfor="contractor"
                      lettertype="Milestone"
                      getProjects={getLetters}
                      title="Milestone Letter"
                      site_prcode={site_prcode}
                      projectName={projectName}
                    />
                  </div>
                </div>
              )}

              <div className="form-actions">
                <button type="button" className="btn-secondaryy" onClick={handleClose}>Cancel</button>
                <button type="submit" className="btn-primaryy" disabled={loading}>
                  {loading ? (
                    <>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="spinning">
                        <circle cx="12" cy="12" r="10" />
                        <path d="M12 6v2M12 12v2" />
                        <path d="m16 8-2 2M16 16l-2-2" />
                        <path d="M8 16l2-2M8 8l2 2" />
                      </svg>
                      <span>Updating...</span>
                    </>
                  ) : (
                    <>
                      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <path d="M17 3l4 4-7 7H10v-4l7-7z" />
                        <path d="M4 20h16" />
                      </svg>
                      <span>Update Milestone</span>
                    </>
                  )}
                </button>
              </div>
            </form>
            <ToastContainer
              position="top-center"
              autoClose={1000}
              hideProgressBar={false}
              newestOnTop={true}
              closeOnClick
              rtl={false}
              pauseOnFocusLoss
              draggable
              pauseOnHover
            />
          </Modal.Body>
        </Modal>
      ) : null}
    </>
  );
};




// const AddMilstoneDetails = ({ project, getProjects, appointed_date, contractor }) => {
//   console.log("project");
//   console.log(project);

//   const [show, setShow] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [formData, setFormData] = useState({
//     project: project,
//     name: "",
//     milestone_percentage: "",
//     milestone_date: null,
//     milestone_as_per_reschedule: null,
//     milestone_as_per_actual: null,
//     day: "",
//     rescedule_gap_days: "",
//     actual_gap_days: "",
//     workperformedby: "contractor",
//     letter: "",
//     contractor: contractor,
//   });

//   const [errors, setErrors] = useState({});
//   const [inputState, setInputState] = useState({});

//   const handleClose = () => {
//     setShow(false);
//     setFormData({
//       project: project,
//       name: "",
//       milestone_percentage: "",
//       milestone_date: null,
//       milestone_as_per_reschedule: null,
//       milestone_as_per_actual: null,
//       day: "",
//       rescedule_gap_days: "",
//       actual_gap_days: "",
//       workperformedby: "contractor",
//       letter: "",
//       contractor: contractor,
//     });
//     setErrors("");
//     setMilestoneName("null");
//   };

//   useEffect(() => {
//     setFormData((prevFormData) => ({
//       ...prevFormData,
//       contractor: contractor,
//     }));
//   }, [contractor]);

//   const handleShow = () => setShow(true);

//   const validateEotForm = () => {
//     const newErrors = {};
//     const RequiredFields = [

//       "day",
//       "milestone_percentage"
//     ];

//     if (milestoneName === "null") {
//       newErrors.milestoneName = "Milestone name is required!";
//     }

//     RequiredFields.forEach((field) => {
//       if (!formData[field]) {
//         newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
//           } is required!`;
//       }
//     });
//     setErrors(newErrors);
//     toast.warning(newErrors);

//     return Object.keys(newErrors).length === 0;
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;

//     setInputState({
//       ...inputState,
//       [name]: value.trim() ? "green" : "",
//     });

//     setFormData({
//       ...formData,
//       [name]: value,
//     });

//     if (errors[name]) {
//       setErrors((prevErrors) => {
//         const { [name]: removedError, ...restErrors } = prevErrors;
//         return restErrors;
//       });
//     }

//     if (name === "day") {
//       const dayValue = parseInt(value, 10);

//       if (dayValue === 0) {
//         // Reset milestone date when day is zero
//         setFormData({
//           ...formData,
//           milestone_date: null,
//           [name]: value,
//         });
//       } else if (!isNaN(dayValue) && dayValue > 0) {
//         const appointedDate = new Date(appointed_date); // Get the appointed date
//         const calculatedMilestoneDate = new Date(appointedDate); // Create a copy of appointedDate
//         calculatedMilestoneDate.setDate(appointedDate.getDate() + dayValue - 1); // Calculate milestone date

//         if (!isNaN(calculatedMilestoneDate.getTime())) {
//           setFormData({
//             ...formData,
//             milestone_date: calculatedMilestoneDate.toISOString().split("T")[0], // Format as YYYY-MM-DD
//             [name]: value,
//           });
//         } else {
//           setErrors({ ...errors, day: "Invalid day value" });
//         }
//       } else {
//         setErrors({ ...errors, day: "Day must be a positive number" });
//       }
//     }
//   };

//   const [uploadProgress, setUploadProgress] = useState(0);
//   const [showProgressModal, setShowProgressModal] = useState(false);



//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (validateEotForm()) {
//       setShowProgressModal(true);
//       setLoading(true);
//       setUploadProgress(0);

//       const loadingToastId = toast.loading("Uploading: please wait...");
//       let progress = 0;
//       const interval = setInterval(() => {
//         progress += 10;
//         if (progress >= 100) {
//           progress = 100;
//           clearInterval(interval);
//         }
//         setUploadProgress(progress);
//       }, 100);
//       try {


//         let res = await axios.post(
//           `${BASE_URL}/siteproject/milestone/`,
//           formData
//         );

//         if (res.status === 200) {
//           await getProjects();
//           handleClose();
//           setTimeout(() => {
//             toast.dismiss(loadingToastId);
//             toast.success("Milestone data added successfully.", {
//               autoClose: 1000,
//               pauseOnHover: true,
//               closeOnClick: true,
//             });
//           }, 1000);
//         } else {
//           throw new Error("Unexpected response status: " + res.status);
//         }

//       } catch (err) {
//         clearInterval(interval);
//         setUploadProgress(0);
//         handleErrorToast(err);
//       } finally {
//         clearInterval(interval);

//         setTimeout(() => {
//           setShowProgressModal(false);
//         }, 1500);

//         setLoading(false);
//         toast.dismiss(loadingToastId);
//       }
//     }
//   };

//   const [milestoneName, setMilestoneName] = useState("null");

//   const milstoneNameList = [
//     { name: "Project Milestone 1", label: "Project Milestone 1" },
//     { name: "Project Milestone 2", label: "Project Milestone 2" },
//     { name: "Project Milestone 3", label: "Project Milestone 3" },
//     { name: "Scheduled Completion", label: "Scheduled Completion" },
//   ]


//   const milestoneOptions = milstoneNameList?.sort((a, b) => a.name.localeCompare(b.name))?.map((i) => ({
//     name: i.name,
//     label: i.label
//   }))

//   const handleChangeMilestoneName = (option) => {
//     if (!option) {
//       setMilestoneName("null");
//     }
//     else {
//       setMilestoneName(option.name);
//     };
//   };

//   useEffect(() => {
//     if (milestoneName !== "null") {
//       setFormData((prev) => ({
//         ...prev,
//         name: milestoneName
//       }));
//     };
//   }, [milestoneName]);


//   return (
//     <>
//       <button
//         title="Add Milestones"
//         className="upload-svg"
//         onClick={handleShow}
//       >
//         <svg
//           xmlns="http://www.w3.org/2000/svg"
//           width="24"
//           height="24"
//           viewBox="0 0 24 24"
//           fill="none"
//         >
//           <g clip-path="url(#clip0_1415_3177)">
//             <path
//               d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z"
//               fill="white"
//             />
//           </g>
//           <defs>
//             <clipPath id="clip0_1415_3177">
//               <rect width="24" height="24" fill="white" />
//             </clipPath>
//           </defs>
//         </svg>{" "}
//         Milestones
//       </button>
//       {
//         showProgressModal ?
//           <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" /> :
//           show === true ?
//             <Modal
//               show={show}
//               onHide={handleClose}
//               dialogClassName="request-leave width-40vw"
//             >
//               <Modal.Header closeButton>
//                 <Modal.Title>Add Milestone Details</Modal.Title>
//               </Modal.Header>
//               <Modal.Body>
//                 <ToastContainer
//                   position="top-center"
//                   autoClose={3000}
//                   hideProgressBar
//                 />
//                 <div className="parent-div">
//                   <div className="form-flex-wrap">

//                     <div className="form-group">
//                       <label
//                         htmlFor="name"
//                         className="form-labels font-weight500 font-size-subheading"
//                       >
//                         Name <span className="required">*</span>
//                       </label>

//                       <Select
//                         options={milestoneOptions}
//                         onChange={handleChangeMilestoneName}
//                         value={
//                           milestoneName === "null"
//                             ? "null"
//                             : milestoneOptions?.find(
//                               (option) => option.name === milestoneName
//                             )
//                         }
//                         placeholder="Select Name"
//                         isSearchable
//                         isClearable
//                         noOptionsMessage={() => "No other options"}
//                         styles={CSSForSelect15vWWidth}
//                       />

//                       {errors.milestoneName && (
//                         <div className="error-message col">{errors.milestoneName}</div>
//                       )}
//                     </div>

//                     <div className="flex-column">
//                       <label className="form-labels font-weight500 font-size-subheading" title="Appointed Date">
//                         Appointed Date<span className="required">(Read-Only)</span>
//                       </label>
//                       <input
//                         type="date"
//                         name="appointed_date"
//                         title="Appointed Date"
//                         value={appointed_date}
//                         onChange={handleInputChange}
//                         className="form-input-date form-input-time"
//                         readOnly
//                       />
//                     </div>

//                     <div className="flex-column">
//                       <label className="form-labels font-weight500 font-size-subheading" title="MileStone Percentage">
//                         Milestone Percentage<span className="required">*</span>
//                       </label>
//                       <input
//                         type="number"
//                         name="milestone_percentage"
//                         title="MileStone Percentage"
//                         placeholder="Percentage"
//                         value={formData.milestone_percentage}
//                         min={0}
//                         onChange={handleInputChange}
//                         className="form-input-date form-input-time"
//                       // readOnly
//                       />
//                       {errors.milestone_percentage && <span className="error-message font-size-text ">{errors.milestone_percentage}</span>}

//                     </div>
//                     <div className="flex-column">
//                       <label className="form-labels font-weight500 font-size-subheading" title="MileStone Days">
//                         MileStone Days<span className="required">*</span>
//                       </label>
//                       <input
//                         type="number"
//                         name="day"
//                         title="MileStone Days"
//                         placeholder="Day"
//                         value={formData.day}
//                         min={0}
//                         onChange={handleInputChange}
//                         className="form-input-date form-input-time"
//                       // readOnly
//                       />
//                       {errors.day && <span className="error-message font-size-text ">{errors.day}</span>}

//                     </div>

//                     <div className="flex-column">
//                       <label className="form-labels font-weight500 font-size-subheading" title="MileStone Date(Enter Milestone Days)">
//                         Milestone Date<span className="required">(Read-Only)</span>
//                       </label>
//                       <input
//                         type="date"
//                         name="milestone_date"
//                         title="Milestone Date"
//                         min={appointed_date}
//                         value={formData.milestone_date}
//                         onChange={handleInputChange}
//                         className="form-input-date form-input-time"
//                         readOnly
//                       />
//                     </div>
//                   </div>


//                   <div className="button-models" style={{ marginTop: "20px", justifyContent: "space-evenly" }}>
//                     <button className="cancelbutton" onClick={handleClose}>Cancel</button>

//                     <Addbutton onclick={handleSubmit} />
//                   </div>
//                 </div>
//                 <ToastContainer
//                   position="top-center"
//                   autoClose={1000}
//                   hideProgressBar={false}
//                   newestOnTop={true}
//                   closeOnClick
//                   rtl={false}
//                   pauseOnFocusLoss
//                   draggable
//                   pauseOnHover
//                 />
//               </Modal.Body>
//             </Modal> : ""
//       }
//     </>
//   );
// };



const AddMilstoneDetails = ({ project, getProjects, appointed_date, contractor }) => {
  console.log("project");
  console.log(project);

  const [show, setShow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    project: project,
    name: "",
    milestone_percentage: "",
    milestone_date: null,
    milestone_as_per_reschedule: null,
    milestone_as_per_actual: null,
    day: "",
    rescedule_gap_days: "",
    actual_gap_days: "",
    workperformedby: "contractor",
    letter: "",
    contractor: contractor,
  });

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const handleClose = () => {
    setShow(false);
    setFormData({
      project: project,
      name: "",
      milestone_percentage: "",
      milestone_date: null,
      milestone_as_per_reschedule: null,
      milestone_as_per_actual: null,
      day: "",
      rescedule_gap_days: "",
      actual_gap_days: "",
      workperformedby: "contractor",
      letter: "",
      contractor: contractor,
    });
    setErrors("");
    setMilestoneName("null");
  };

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      contractor: contractor,
    }));
  }, [contractor]);

  const handleShow = () => setShow(true);

  const validateEotForm = () => {
    const newErrors = {};
    const RequiredFields = [
      "day",
      "milestone_percentage"
    ];

    if (milestoneName === "null") {
      newErrors.milestoneName = "Milestone name is required!";
    }

    RequiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)
          } is required!`;
      }
    });
    setErrors(newErrors);
    toast.warning(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });

    if (errors[name]) {
      setErrors((prevErrors) => {
        const { [name]: removedError, ...restErrors } = prevErrors;
        return restErrors;
      });
    }

    if (name === "day") {
      const dayValue = parseInt(value, 10);

      if (dayValue === 0) {
        // Reset milestone date when day is zero
        setFormData({
          ...formData,
          milestone_date: null,
          [name]: value,
        });
      } else if (!isNaN(dayValue) && dayValue > 0) {
        const appointedDate = new Date(appointed_date); // Get the appointed date
        const calculatedMilestoneDate = new Date(appointedDate); // Create a copy of appointedDate
        calculatedMilestoneDate.setDate(appointedDate.getDate() + dayValue - 1); // Calculate milestone date

        if (!isNaN(calculatedMilestoneDate.getTime())) {
          setFormData({
            ...formData,
            milestone_date: calculatedMilestoneDate.toISOString().split("T")[0], // Format as YYYY-MM-DD
            [name]: value,
          });
        } else {
          setErrors({ ...errors, day: "Invalid day value" });
        }
      } else {
        setErrors({ ...errors, day: "Day must be a positive number" });
      }
    }
  };

  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);



  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateEotForm()) {
      setShowProgressModal(true);
      setLoading(true);
      setUploadProgress(0);

      const loadingToastId = toast.loading("Uploading: please wait...");
      let progress = 0;
      const interval = setInterval(() => {
        progress += 10;
        if (progress >= 100) {
          progress = 100;
          clearInterval(interval);
        }
        setUploadProgress(progress);
      }, 100);
      try {


        let res = await axios.post(
          `${BASE_URL}/siteproject/milestone/`,
          formData
        );

        if (res.status === 200) {
          await getProjects();
          handleClose();
          setTimeout(() => {
            toast.dismiss(loadingToastId);
            toast.success("Milestone data added successfully.", {
              autoClose: 1000,
              pauseOnHover: true,
              closeOnClick: true,
            });
          }, 1000);
        } else {
          throw new Error("Unexpected response status: " + res.status);
        }

      } catch (err) {
        clearInterval(interval);
        setUploadProgress(0);
        handleErrorToast(err);
      } finally {
        clearInterval(interval);

        setTimeout(() => {
          setShowProgressModal(false);
        }, 1500);

        setLoading(false);
        toast.dismiss(loadingToastId);
      }
    }
  };

  const [milestoneName, setMilestoneName] = useState("null");

  const milstoneNameList = [
    { name: "Project Milestone 1", label: "Project Milestone 1" },
    { name: "Project Milestone 2", label: "Project Milestone 2" },
    { name: "Project Milestone 3", label: "Project Milestone 3" },
    { name: "Scheduled Completion", label: "Scheduled Completion" },
  ]


  const milestoneOptions = milstoneNameList?.sort((a, b) => a.name.localeCompare(b.name))?.map((i) => ({
    name: i.name,
    label: i.label
  }))

  const handleChangeMilestoneName = (option) => {
    if (!option) {
      setMilestoneName("null");
    }
    else {
      setMilestoneName(option.name);
    };
  };

  useEffect(() => {
    if (milestoneName !== "null") {
      setFormData((prev) => ({
        ...prev,
        name: milestoneName
      }));
    };
  }, [milestoneName]);


  return (
    <>
      <button
        title="Add Milestones"
        className="btn-animated"
        onClick={handleShow}
      >
        <div className="btn-content">
          <AwardIcon size={18} />
          <span>Add Milestone</span>
        </div>
        <div className="btn-ripple"></div>
      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Add" /> :
          show === true ?
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="modern-project-modal"
              size="xl"
            >
              <Modal.Header className="modern-modal-header">
                <div className="header-content">
                  <div className="header-icon" style={{ background: "transparent", color: "white" }}>
                    <LucideAward size={24} />
                  </div>
                  <div>
                    <Modal.Title>Add Milestone Details</Modal.Title>
                    <p className="header-subtitle">Fill in the details to add a new milestone for the project</p>
                  </div>
                </div>
                <button className="close-btn" onClick={handleClose}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                  </svg>
                </button>
              </Modal.Header>
              <Modal.Body className="modern-modal-body">
                <ToastContainer
                  position="top-center"
                  autoClose={3000}
                  hideProgressBar
                />
                <form onSubmit={handleSubmit} className="project-form">
                  <div className="section-title">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM17 13H13V17H11V13H7V11H11V7H13V11H17V13Z" />
                    </svg>
                    <h4>Milestone Information</h4>
                  </div>

                  <div className="form-grid">
                    <div className="form-field">
                      <label htmlFor="name">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20" />
                          <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z" />
                        </svg>
                        Milestone Name <span className="required">*</span>
                      </label>
                      <Select
                        options={milestoneOptions}
                        onChange={handleChangeMilestoneName}
                        value={
                          milestoneName === "null"
                            ? "null"
                            : milestoneOptions?.find(
                              (option) => option.name === milestoneName
                            )
                        }
                        placeholder="Select Name"
                        isSearchable
                        isClearable
                        noOptionsMessage={() => "No other options"}
                        styles={CSSForSelectModern}
                      />
                      {errors.milestoneName && (
                        <div className="error-message">{errors.milestoneName}</div>
                      )}
                    </div>

                    <div className="form-field">
                      <label title="Appointed Date">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        Appointed Date<span className="required">(Read-Only)</span>
                      </label>
                      <input
                        type="date"
                        name="appointed_date"
                        title="Appointed Date"
                        value={appointed_date}
                        className={`readonly-field ${errors.appointed_date ? "error" : ""}`}
                        readOnly
                      />
                    </div>

                    <div className="form-field">
                      <label title="MileStone Percentage">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <path d="M21 12a9 9 0 1 1-9-9" />
                          <path d="M12 6v6l4 2" />
                        </svg>
                        Milestone Percentage<span className="required">*</span>
                      </label>
                      <input
                        type="number"
                        name="milestone_percentage"
                        title="MileStone Percentage"
                        placeholder="0"
                        value={formData.milestone_percentage}
                        min={0}
                        onChange={handleInputChange}
                        className={`${errors.milestone_percentage ? "error" : inputState.milestone_percentage ? "success" : ""}`}
                      />
                      {errors.milestone_percentage && <span className="error-message">{errors.milestone_percentage}</span>}
                    </div>

                    <div className="form-field">
                      <label title="MileStone Days">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <circle cx="12" cy="12" r="10" />
                          <polyline points="12 6 12 12 16 14" />
                        </svg>
                        Milestone Days<span className="required">*</span>
                      </label>
                      <input
                        type="number"
                        name="day"
                        title="MileStone Days"
                        placeholder="0"
                        value={formData.day}
                        min={0}
                        onChange={handleInputChange}
                        className={`${errors.day ? "error" : inputState.day ? "success" : ""}`}
                      />
                      {errors.day && <span className="error-message">{errors.day}</span>}
                    </div>

                    <div className="form-field">
                      <label title="MileStone Date">
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                          <line x1="16" y1="2" x2="16" y2="6"></line>
                          <line x1="8" y1="2" x2="8" y2="6"></line>
                          <line x1="3" y1="10" x2="21" y2="10"></line>
                        </svg>
                        Milestone Date<span className="required">(Read-Only)</span>
                      </label>
                      <input
                        type="date"
                        name="milestone_date"
                        title="Milestone Date"
                        min={appointed_date}
                        value={formData.milestone_date}
                        className="readonly-field"
                        readOnly
                      />
                    </div>
                  </div>

                  <div className="form-actions">
                    <button type="button" className="btn-secondaryy" onClick={handleClose}>Cancel</button>
                    <button type="submit" className="btn-primaryy" disabled={loading}>
                      {loading ? (
                        <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="spinning">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M12 6v2M12 12v2" />
                            <path d="m16 8-2 2M16 16l-2-2" />
                            <path d="M8 16l2-2M8 8l2 2" />
                          </svg>
                          <span>Adding...</span>
                        </>
                      ) : (
                        <>
                          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34" />
                            <polygon points="18 2 22 6 12 16 8 16 8 12 18 2" />
                          </svg>
                          <span>Add Milestone</span>
                        </>
                      )}
                    </button>
                  </div>
                </form>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};

const AddProgressdetails = ({
  project,
  progress,
  getprogressDetails,
  contractor,
  progressdata,
  site_prcode,
  projectName
}) => {
  const [loading, setLoading] = useState(false);

  const [show, setShow] = useState(false);
  const [previousprogressdata, setPreviousProgressData] = useState([]);


  const months = [
    { text: "January", value: 1 },
    { text: "February", value: 2 },
    { text: "March", value: 3 },
    { text: "April", value: 4 },
    { text: "May", value: 5 },
    { text: "June", value: 6 },
    { text: "July", value: 7 },
    { text: "August", value: 8 },
    { text: "September", value: 9 },
    { text: "October", value: 10 },
    { text: "November", value: 11 },
    { text: "December", value: 12 },
  ];



  const [formData, setFormData] = useState({
    project,
    submitted_financial_progress: "0",
    submitted_physical_progress: "0",
    month: "",
    year: "",
    submitted_letter: "",
    contractor: contractor,
  });

  const { month, year } = formData;
  const [trackRecordList, setTrackRecordList] = useState([]);
  const validateForm = () => {
    const newErrors = {};

    if (Number(formData.submitted_physical_progress) < previousprogressdata.physical_progress || Number(formData.submitted_physical_progress) > 100) {
      newErrors.submitted_physical_progress = `Value must be between ${previousprogressdata.physical_progress}%- 100%`;
    }

    if (Number(formData.submitted_financial_progress) < previousprogressdata.financial_progress || Number(formData.submitted_financial_progress) > 100) {
      newErrors.submitted_financial_progress = `Value must be between ${previousprogressdata.financial_progress}%- 100%`;
    }

    const requiredFields = ["submitted_financial_progress", "submitted_physical_progress", "month", "year", "submitted_letter"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const getLetters = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/letterrecordbyfilters/${project}/contractor/SiteProgress/${contractor}/`
      );
      setTrackRecordList(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (!month || !year) {
      console.error("Both month and year are required to fetch progress data.");
      return;
    }

    const fetchProgressData = async () => {
      try {
        let currentMonth = month - 1 === 0 ? 12 : month - 1; // Start with the previous month
        let currentYear = month - 1 === 0 ? year - 1 : year; // Adjust year if previous month is December
        let dataFound = false; // Flag to check if data is found

        while (!dataFound) {
          const response = await axios.get(
            `${BASE_URL}/siteproject/progressbyproject/${project}/${contractor}/${currentMonth}/${currentYear}/`
          );

          const progressData = response.data;

          if (progressData.length > 0) {
            // Assuming progressData is an array
            const { financial_progress, physical_progress } = progressData[0]; // Take the first item

            // Set the values
            setPreviousProgressData({
              financial_progress,
              physical_progress,
            });

            console.log("Financial Progress:", financial_progress);
            console.log("Physical Progress:", physical_progress);

            dataFound = true; // Exit the loop
          } else {
            console.warn(
              `No progress data found for ${currentMonth}/${currentYear}. Checking the previous month.`
            );

            // Move to the previous month
            currentMonth -= 1;
            if (currentMonth === 0) {
              currentMonth = 12;
              currentYear -= 1; // Move to the previous year
            }

            // Stop the loop if we reach an unrealistic limit (e.g., 10 years back)
            if (currentYear < year - 1) {
              console.error("No data found for the past 10 years.");
              break;
            }
          }
        }
      } catch (error) {
        console.error("Error fetching progress data:", error);
      }
    };




    fetchProgressData();
  }, [month, year]);





  const handleShow = async () => {

    setShow(true);
    getLetters();
  };

  const handleClose = () => {
    setShow(false);
    setFormData({
      project,
      submitted_financial_progress: "0",
      submitted_physical_progress: "0",
      month: "",
      year: "",
      submitted_letter: "",
      contractor: contractor,
    });
    setErrors("");
    setPreviousProgressData("");
  };


  const [errors, setErrors] = useState({
    submitted_physical_progress: "",
    submitted_financial_progress: "",
  });
  const [inputState, setInputState] = useState({});


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let errorMessage = "";

    if (name === "submitted_physical_progress") {
      if (Number(value) < previousprogressdata.physical_progress || Number(value) > 100) {
        errorMessage = `Value must be between ${previousprogressdata.physical_progress}% - 100%`;
      }
    }

    if (name === "submitted_financial_progress") {
      if (Number(value) < previousprogressdata.financial_progress || Number(value) > 100) {
        errorMessage = `Value must be between ${previousprogressdata.financial_progress}% - 100%`;
      }
    }
    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      toast.error("Please fix the errors before submitting.");
      return;
    }

    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      let res = await axios.post(
        `${BASE_URL}/siteproject/progressget/`,
        formData
      );
      if (res.status === 200) {
        await getprogressDetails();
        handleClose();
        toast.success("Progress added successfully.");
      } else {
        toast.error(`Error: ${res.statusText}`);
      }
    } catch (error) {
      toast.error("An error occurred while submitting the progress.");
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };



  useEffect(() => {
    // Update the formData when previousprogressdata changes
    setFormData((prev) => ({
      ...prev,
      submitted_physical_progress: previousprogressdata.physical_progress || "",
      submitted_financial_progress: previousprogressdata.financial_progress || "",
    }));
  }, [previousprogressdata]);


  const submittedLetterOptions = trackRecordList.map((item) => ({
    value: item.id,
    label: item.letter_num,
  }));


  return (
    <>
      <button
        title="Add Site Progress"
        className="upload-svg"
        onClick={handleShow}
      >
        <AddwithWhiteCircle /> Progress
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Site Progress</Modal.Title>
        </Modal.Header>
        <Modal.Body>



          {/* Frozen Month Field */}
          <div className="flex-column">
            <label className="form-labels font-weight500 font-size-subheading">
              Month<span className="required">*</span>
            </label>
            <select
              name="month"
              value={formData.month}
              className="form-input"
              onChange={handleInputChange}
            >
              <option value=''>Select Month</option>
              {months.map((month) => (
                <option
                  key={month.value}
                  value={month.value}
                  disabled={progressdata.some(
                    (data) => data.month === String(month.value) && data.year === String(formData.year)
                  )}
                >
                  {month.text}
                </option>
              ))}
            </select>
            {errors.month && (
              <span className="error-message">{errors.month}</span>
            )}
          </div>

          {/* Frozen Year Field */}
          <div className="flex-column">
            <label className="form-labels font-weight500 font-size-subheading">
              Year<span className="required">*</span>
            </label>
            <select
              name="year"
              value={formData.year}
              className="form-input"
              onChange={handleInputChange}
            >
              <option value=''>Select Year</option>

              {[...Array(10)].map((_, index) => {
                const year = new Date().getFullYear() - index;
                return (
                  <option
                    key={year}
                    value={year}
                    disabled={progressdata.some(
                      (data) => data.year === String(year) && data.month === String(formData.month)
                    )}
                  >
                    {year}
                  </option>
                );
              })}
            </select>
            {errors.year && (
              <span className="error-message">{errors.year}</span>
            )}
          </div>
          {/* Submitted Physical Progress */}
          <div className="flex-column">
            <label className="form-labels font-weight500 font-size-subheading">
              Submitted Physical Progress (%)<span className="required">*</span>
            </label>
            <input
              type="number"
              min={previousprogressdata.physical_progress}
              placeholder={previousprogressdata.physical_progress || 0}
              name="submitted_physical_progress"
              onChange={handleInputChange}
              className={`form-input ${errors.submitted_physical_progress ? "input-error" : ""}`}
            />
            {errors.submitted_physical_progress && (
              <span className="error-message">{errors.submitted_physical_progress}</span>
            )}
          </div>

          {/* Submitted Financial Progress */}
          <div className="flex-column">
            <label className="form-labels font-weight500 font-size-subheading">
              Submitted Financial Progress (%)<span className="required">*</span>
            </label>
            <input
              type="number"
              min={previousprogressdata.financial_progress}
              placeholder={previousprogressdata.financial_progress || 0}
              name="submitted_financial_progress"
              onChange={handleInputChange}
              className={`form-input ${errors.submitted_financial_progress ? "input-error" : ""}`}
            />
            {errors.submitted_financial_progress && (
              <span className="error-message">{errors.submitted_financial_progress}</span>
            )}
          </div>
          <div className="flex-column form-group-selectt">
            <label className="form-labels font-weight500 font-size-subheading" title="Letter">Letter<span className="required">*</span></label>
            <br />
            <Select
              name="submitted_letter"
              placeholder="Select Option"
              options={submittedLetterOptions}
              value={submittedLetterOptions.find(
                (opt) => opt.value === formData.submitted_letter
              )}
              onChange={(selectedOption) =>
                handleInputChange({
                  target: {
                    name: "submitted_letter",
                    value: selectedOption ? selectedOption.value : "",
                  },
                })
              }
              styles={CSSForSelect}
            />

            {errors.submitted_letter && <div className="error-message ">{errors.submitted_letter}</div>}
          </div>
          {formData.submitted_letter ? (
            ""
          ) : (
            <>
              <div
                style={{ display: "flex", justifyContent: "space-evenly" }}
              >
                <div>OR</div>
              </div>

              <div className="button-models">
                <AddTrackRecordDetails
                  projectId={project}
                  contractor={contractor}
                  letterfor="contractor"
                  lettertype="SiteProgress"
                  getProjects={getLetters}
                  title="Site Progress Letter"
                  site_prcode={site_prcode}
                  projectName={projectName}

                />
              </div>
            </>
          )}


          <div className="button-models">
            <button
              className="model-button font-weight500 model-button-leave font-size-heading"
              onClick={handleSubmit}
              type="button"
              disabled={loading}
            >
              {loading ? "Adding..." : "Add"}
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

const UpdateProgressdetails = ({
  i,
  project,
  getprogressDetails,
  progressdata,
  contractor,
  site_prcode,
  projectName
}) => {

  const [loading, setLoading] = useState(false);

  const [show, setShow] = useState(false);
  const [previousprogressdata, setPreviousProgressData] = useState([]);


  const months = [
    { text: "January", value: 1 },
    { text: "February", value: 2 },
    { text: "March", value: 3 },
    { text: "April", value: 4 },
    { text: "May", value: 5 },
    { text: "June", value: 6 },
    { text: "July", value: 7 },
    { text: "August", value: 8 },
    { text: "September", value: 9 },
    { text: "October", value: 10 },
    { text: "November", value: 11 },
    { text: "December", value: 12 },
  ];



  const [formData, setFormData] = useState({
    project,
    financial_progress: "0",
    physical_progress: "0",
    submitted_physical_progress: "0",
    submitted_financial_progress: "0",
    month: "",
    year: "",
    approved_letter: "",
    contractor,
  });

  const { month, year } = formData;

  const validateForm = () => {
    const newErrors = {};

    if (Number(formData.physical_progress) < previousprogressdata.physical_progress || Number(formData.physical_progress) > 100) {
      newErrors.physical_progress = `Value must be between ${previousprogressdata.physical_progress}%- 100%`;
    }


    if (Number(formData.financial_progress) < previousprogressdata.financial_progress || Number(formData.financial_progress) > 100) {
      newErrors.financial_progress = `Value must be between ${previousprogressdata.financial_progress}%- 100%`;
    }

    const requiredFields = ["financial_progress", "physical_progress", "approved_letter"];
    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = `${field.charAt(0).toUpperCase() + field.slice(1)} is required!`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const [trackRecordList, setTrackRecordList] = useState([]);
  const handleShow = async () => {

    setShow(true);
    setFormData(i);
    getLetters();
  };

  const getLetters = async () => {
    setLoading(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/letterrecordbyfilters/${project}/contractor/SiteProgress/${contractor}/`
      );
      setTrackRecordList(res.data);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };




  useEffect(() => {
    // if (month || !year) {
    //   console.error("Both month and year are required to fetch progress data.");
    //   return;
    // }


    const fetchProgressData = async () => {
      try {
        let currentMonth = month - 1 === 0 ? 12 : month - 1; // Start with the previous month
        let currentYear = month - 1 === 0 ? year - 1 : year; // Adjust year if previous month is December
        let dataFound = false; // Flag to check if data is found

        while (!dataFound) {
          const response = await axios.get(
            `${BASE_URL}/siteproject/progressbyproject/${project}/${contractor}/${currentMonth}/${currentYear}/`
          );

          const progressData = response.data;

          if (progressData.length > 0) {
            // Assuming progressData is an array
            const { financial_progress, physical_progress } = progressData[0]; // Take the first item

            // Set the values
            setPreviousProgressData({
              financial_progress,
              physical_progress,
            });

            console.log("Financial Progress:", financial_progress);
            console.log("Physical Progress:", physical_progress);

            dataFound = true; // Exit the loop
          } else {
            console.warn(
              `No progress data found for ${currentMonth}/${currentYear}. Checking the previous month.`
            );

            // Move to the previous month
            currentMonth -= 1;
            if (currentMonth === 0) {
              currentMonth = 12;
              currentYear -= 1; // Move to the previous year
            }

            // Stop the loop if we reach an unrealistic limit (e.g., 10 years back)
            if (currentYear < year - 10) {
              console.error("No data found for the past 10 years.");
              break;
            }
          }
        }
      } catch (error) {
        console.error("Error fetching progress data:", error);
      }
    };




    fetchProgressData();
  }, [month, year]);







  const handleClose = () => {
    setShow(false);
    setFormData({
      project,
      submitted_financial_progress: "0",
      submitted_physical_progress: "0",
      month: "",
      year: "",
      approved_letter: "",
      contractor,
    });
    setErrors("");
    setPreviousProgressData("");
  };


  const [errors, setErrors] = useState({
    physical_progress: "",
    financial_progress: "",
  });

  const [inputState, setInputState] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    let errorMessage = "";

    if (name === "physical_progress") {
      if (Number(value) < previousprogressdata.physical_progress || Number(value) > 100) {
        errorMessage = `Value must be between ${previousprogressdata.physical_progress}% - 100%`;
      }
    }

    if (name === "financial_progress") {
      if (Number(value) < previousprogressdata.financial_progress || Number(value) > 100) {
        errorMessage = `Value must be between ${previousprogressdata.financial_progress}% - 100%`;
      }
    }
    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: errorMessage,
    }));
  };



  const handleSubmit = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Loading: Please wait...");


    if (!validateForm()) {
      toast.error("Please fix the errors before submitting.");
      return;
    }

    try {
      let res = await axios.put(
        `${BASE_URL}/siteproject/progressupdate/${i.id}/`,
        formData
      );
      if (res.status === 200) {
        getprogressDetails();
        handleClose();
        toast.success("Progress updated successfully.");
        toast.dismiss(loadingToastId);

      } else {
        toast.error(`Error: ${res.statusText}`);
      }
    } catch (error) {
      toast.error("An error occurred while submitting the progress.");
    } finally {
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };


  useEffect(() => {
    // Update the formData when previousprogressdata changes
    if (!formData.physical_progress || formData.physical_progress === "0" || !formData.financial_progress || formData.financial_progress === "0") {
      setFormData((prev) => ({
        ...prev,
        physical_progress: previousprogressdata.physical_progress || "0",
        financial_progress: previousprogressdata.financial_progress || "0",
      }));
    }
  }, [previousprogressdata]);

  const submittedLetterOptions = trackRecordList.map((item) => ({
    value: item.id,
    label: item.letter_num,
  }));
  const approveLetterOptions = trackRecordList.map((item) => ({
    value: item.id,
    label: item.letter_num,
  }));

  return (
    <>
      <button
        title="Update Site Progress"
        className="model-edit-button"
        onClick={handleShow}
      >
        <UpdatePencil />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Update Site Progress</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex-column">
            <label className="form-labels font-weight500 font-size-subheading">
              Month<span className="required">(Read-Only)</span>
            </label>
            <select
              name="month"
              value={formData.month}
              className="form-input"
              // onChange={handleInputChange}
              disabled
            >
              <option value=''>Select Month</option>
              {months.map((month) => (
                <option
                  key={month.value}
                  value={month.value}
                  disabled={progressdata.some(
                    (data) => data.month === String(month.value) && data.year === String(formData.year)
                  )}
                >
                  {month.text}
                </option>
              ))}
            </select>
          </div>

          {/* Frozen Year Field */}
          <div className="flex-column">
            <label className="form-labels font-weight500 font-size-subheading">
              Year<span className="required">(Read-Only)</span>
            </label>
            <select
              name="year"
              value={formData.year}
              className="form-input"
              // onChange={handleInputChange}
              disabled
            >
              <option value=''>Select Year</option>

              {[...Array(10)].map((_, index) => {
                const year = new Date().getFullYear() - index;
                return (
                  <option
                    key={year}
                    value={year}
                    disabled={progressdata.some(
                      (data) => data.year === String(year) && data.month === String(formData.month)
                    )}
                  >
                    {year}
                  </option>
                );
              })}
            </select>
          </div>



          {/* Actual Physical Progress */}
          <div className="flex-column">
            <label className="form-labels font-weight500 font-size-subheading">
              Submitted Physical Progress (%)
            </label>
            <input
              type="number"
              // min={previousProgress.estimated_physical_progress}
              name="submitted_physical_progress"
              value={formData.submitted_physical_progress}
              onChange={handleInputChange}
              className="form-input"
            />
          </div>

          {/* Actual Financial Progress */}
          <div className="flex-column">
            <label className="form-labels font-weight500 font-size-subheading">
              Submitted Financial Progress (%)
            </label>
            <input
              type="number"
              // min={previousProgress.estimated_financial_progress}
              name="submitted_financial_progress"
              value={formData.submitted_financial_progress}
              onChange={handleInputChange}
              className="form-input"
            />
          </div>

          {/* Submitted Physical Progress */}
          <div className="flex-column">
            <label className="form-labels font-weight500 font-size-subheading">
              Actual Physical Progress (%)<span className="required">*</span>
            </label>
            <input
              type="number"
              min={previousprogressdata.physical_progress}
              placeholder={formData.physical_progress || previousprogressdata.physical_progress || 0}
              name="physical_progress"
              onChange={handleInputChange}
              className={`form-input ${errors.physical_progress ? "input-error" : ""}`}
            />
            {errors.physical_progress && (
              <span className="error-message">{errors.physical_progress}</span>
            )}
          </div>

          {/* Submitted Financial Progress */}
          <div className="flex-column">
            <label className="form-labels font-weight500 font-size-subheading">
              Actual Financial Progress (%)<span className="required">*</span>
            </label>
            <input
              type="number"
              min={previousprogressdata.financial_progress}
              placeholder={formData.financial_progress || previousprogressdata.financial_progress || 0}
              name="financial_progress"
              onChange={handleInputChange}
              className={`form-input ${errors.financial_progress ? "input-error" : ""}`}
            />
            {errors.financial_progress && (
              <span className="error-message">{errors.financial_progress}</span>
            )}
          </div>
          <div className="flex-column form-group-selectt">
            <label className="form-labels font-weight500 font-size-subheading" title="Letter">Submitted Letter<span className="required">*</span></label>
            <br />
            <Select
              name="submitted_letter"
              placeholder="Select Option"
              options={submittedLetterOptions}
              value={submittedLetterOptions.find(
                (opt) => opt.value === formData.submitted_letter
              )}
              onChange={(selectedOption) =>
                handleInputChange({
                  target: {
                    name: "submitted_letter",
                    value: selectedOption ? selectedOption.value : "",
                  },
                })
              }
              styles={CSSForSelect}
            />

            {errors.submitted_letter && <div className="error-message ">{errors.submitted_letter}</div>}
          </div>
          <div className="flex-column form-group-selectt">
            <label className="form-labels font-weight500 font-size-subheading" title="Letter">Approved Letter<span className="required">*</span></label>
            <br />
            <Select
              name="approved_letter"
              placeholder="Select Option"
              options={approveLetterOptions}
              value={approveLetterOptions.find(
                (opt) => opt.value === formData.approved_letter
              )}
              onChange={(selectedOption) =>
                handleInputChange({
                  target: {
                    name: "approved_letter",
                    value: selectedOption ? selectedOption.value : "",
                  },
                })
              }
              styles={CSSForSelect}
            />

            {errors.approved_letter && <div className="error-message ">{errors.approved_letter}</div>}
          </div>
          {formData.approved_letter ? (
            ""
          ) : (
            <>
              <div
                style={{ display: "flex", justifyContent: "space-evenly" }}
              >
                <div>OR</div>
              </div>

              <div className="button-models">
                <AddTrackRecordDetails
                  projectId={project}
                  contractor={contractor}
                  letterfor="contractor"
                  lettertype="SiteProgress"
                  getProjects={getLetters}
                  title="Site Progress Letter"
                  site_prcode={site_prcode}
                  projectName={projectName}

                />
              </div>
            </>
          )}




          <div className="button-models">
            <button
              className="model-button font-weight500 model-button-leave font-size-heading"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};




const AssociatedLetters = ({ id, workperformedby, letterType, associated_letters, LetterData, usedFor }) => {
  const [show, setShow] = useState(false);
  const [letterList, setLetterList] = useState([]); // Main letter data

  const handleShow = () => {
    setShow(true);
  }
  const handleClose = () => setShow(false);

  const getLetters = async () => {
    console.log('called')
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/letter-associated/${id}/`
      );
      setLetterList(res.data);
      console.log({ res: res.data })
    } catch (error) {
      console.error("Error fetching initial letters:", error);
    }
  };


  useEffect(() => {
    if (show === true) {
      getLetters();

    }
  }, [show]);

  const fetchLetterDetails = async (id) => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/letter-associated/${id}/`
      );
      return res.data;
    } catch (error) {
      console.error(`Error fetching details for Letter ID ${id}:`, error);
      return null;
    }
  };

  const RenderLetter = ({ letter, level = 0 }) => {
    const { letter_num, associated_letters = [] } = letter;

    const [showNestedLetters, setShowNestedLetters] = useState(false);
    const [nestedLettersData, setNestedLettersData] = useState([]); // Temporarily store nested letter data

    const toggleNestedLetters = async () => {
      if (showNestedLetters) {
        setShowNestedLetters(false); // Collapse
        setNestedLettersData([]); // Remove data when collapsing
      } else {
        setShowNestedLetters(true); // Expand
        const data = await Promise.all(
          associated_letters.map((id) => fetchLetterDetails(id))
        );
        setNestedLettersData(data.filter((item) => item !== null)); // Set nested letter data
      }
    };

    return (
      <div style={{ marginLeft: `${level * 20}px` }}>
        <div style={{ display: "flex" }}>
          <div className="arrow-set">
            <ArrowBullet />
          </div>

          <div className="letter-card">
            <div className="letter-card-header">
              <span style={{ margin: "6px" }}>
                Letter Number: {letter_num}
              </span>
              <div>
                {associated_letters.length > 0 && (
                  <button onClick={toggleNestedLetters}>
                    <span className="view-text">{showNestedLetters ? "Close" : "View"}</span>
                  </button>
                )}
              </div>
            </div>

            <div style={{ margin: "20px 20px 20px 10px" }}>
              <table>
                <tbody>
                  <tr>
                    <td className="padding-bottom-5px">Reply of </td>
                    <td className="padding-bottom-5px" style={{ padding: "0px 4px" }}>:</td>
                    <td className="padding-bottom-5px">
                      {associated_letters.length > 0 ?
                        <>{letter.associated_letters_get.map(i => i.letter_num).join(",")}</> :
                        "No Associated Letter"}
                    </td>
                  </tr>
                  <tr>
                    <td className="padding-bottom-5px">Letter Date </td>
                    <td className="padding-bottom-5px" style={{ padding: "0px 4px" }}>:</td>
                    <td className="padding-bottom-5px">{letter.letter_date}</td>
                  </tr>
                  <tr>
                    <td className="padding-bottom-5px">View Letter </td>
                    <td className="padding-bottom-5px" style={{ padding: "0px 4px" }}>:</td>

                    <td className="padding-bottom-5px">
                      {
                        LetterData ?
                          <UpdateTrackRecordDetailwithIDonly
                            i={letter}
                            projectId={letter.project}
                            workperformedby={letter.workperformedby}
                            letterType={letter.lettertype}
                            getProjects={getLetters}
                            letterData={LetterData}
                          />
                          :
                          <UpdateTrackRecordDetailwithIDonly
                            i={letter}
                            projectId={letter.project}
                            workperformedby={letter.workperformedby}
                            letterType={letter.lettertype}
                            getProjects={getLetters}
                          />
                      }
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {/* Render child letters only if expanded */}
        {showNestedLetters &&
          nestedLettersData.map((childLetter, index) => (
            <div className="nested-letters" key={index}>
              <RenderLetter letter={childLetter} level={level + 1} />
            </div>
          ))}
      </div>
    );
  };

  useEffect(() => {
    if (show === true) {
      getLetters();
    }
  }, [id, show]);

  return (
    <>
      <button
        onClick={handleShow}
        className=""
        style={{
          // marginBottom: "10px",
          height: usedFor === "table" ? "20px" : usedFor === "nestedTable" ? "0px" : "30px",
          width: usedFor === "table" ? "3vw" : usedFor === "nestedTable" ? "0vw" : "5vw",
          borderRadius: usedFor === "table" ? "6px" : "10px",
          fontSize: usedFor === "nestedTable" ? "12px" : "14px"

        }}
      >
        <span className="view-text" >View</span>
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>View Letters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Letter data={letterList} />
          {/* <div className="letter-list-container scroll-container" style={{ border: "none" }}>
            <div className="scrollbar" style={{ border: "none" }} >
              {letterList?.letter_num ? (
                <RenderLetter letter={letterList} />
              ) : (
                <p className="no-letters-text">No letters found</p>
              )}

            </div>
          </div> */}
        </Modal.Body>
      </Modal >
    </>
  );
};
const AllAssociateLetter = ({ usedFor, id, letterId }) => {
  const [show, setShow] = useState(false);
  const handleShow = () => {
    setShow(true);
  };
  const handleClose = () => {
    setShow(false);
  };

  const [letterList, setLetterList] = useState([]);

  const getData = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/siteproject/assosiateletters/${id}/`)
      setLetterList(res.data);
    } catch (error) {
      handleErrorToast(error);
    }
  };

  const findLetter = letterList?.filter(i => i.id === letterId);
  console.log("fIND LETTER");
  console.log(findLetter);

  const selectedLetterIds = findLetter.map(i => i.associated_letters?.map((id) => id.id).flat());
  console.log("SelectedLetters");
  console.log(selectedLetterIds.flat());
  const [letterById, setLetterById] = useState([]);
  const [letterData, setLetterData] = useState([]);

  const renderData = async () => {
    try {
      const ids = [...new Set(selectedLetterIds.flat())];

      const responses = await Promise.all(
        ids.map(id => axios.get(`${BASE_URL}/siteproject/letterrecordsbyid/${id}/`))
      );

      const allLetters = responses.map(res => res.data);

      setLetterById(allLetters);
      setLetterData(prev => [...prev, ...allLetters]);


    } catch (error) {
      console.error(error);
      handleErrorToast(error);
    }
  };










  useEffect(() => {
    if (show === true) {
      getData();
    }
  }, [id, show]);

  useEffect(() => {
    if (selectedLetterIds.length > 0) {
      renderData();
    }
  }, [selectedLetterIds]);

  return (
    <>
      <button
        onClick={handleShow}
        className=""
        style={{
          // marginBottom: "10px",
          height: usedFor === "table" ? "20px" : usedFor === "nestedTable" ? "0px" : "30px",
          width: usedFor === "table" ? "3vw" : usedFor === "nestedTable" ? "0vw" : "5vw",
          borderRadius: usedFor === "table" ? "6px" : "10px",
          fontSize: usedFor === "nestedTable" ? "12px" : "14px"

        }}
      >
        <span className="view-text" >View</span>
      </button>
      <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
        <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
          <Modal.Title>Associate Letters</Modal.Title>
        </Modal.Header>
        <Modal.Body></Modal.Body>
        <Modal.Body>

        </Modal.Body>
      </Modal>
    </>
  )
}




// const AssociatedLetters = ({ id, workperformedby, letterType, associated_letters, LetterData }) => {
//   const [show, setShow] = useState(false);
//   const [letterList, setLetterList] = useState([]);

//   const handleShow = () => setShow(true);
//   const handleClose = () => setShow(false);

//   const getLetters = async () => {
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/siteproject/letter-associated/${id}/`
//       );
//       setLetterList(res.data);
//     } catch (error) {
//       console.error("Error fetching initial letters:", error);
//     }
//   };

//   const fetchLetterDetails = async (id) => {
//     try {
//       const res = await axios.get(
//         `${BASE_URL}/siteproject/letter-associated/${id}/`
//       );
//       return res.data;
//     } catch (error) {
//       console.error(`Error fetching details for Letter ID ${id}:`, error);
//       return null;
//     }
//   };

//   const RenderLetter = ({ letter, level = 3 }) => {
//     const { letter_num, associated_letters = [] } = letter;
//     const [nestedLettersData, setNestedLettersData] = useState([]);

//     useEffect(() => {
//       const fetchNestedLetters = async () => {
//         const data = await Promise.all(
//           associated_letters.map((id) => fetchLetterDetails(id))
//         );
//         setNestedLettersData(data.filter((item) => item !== null));
//       };

//       if (associated_letters.length > 0) {
//         fetchNestedLetters();
//       }
//     }, [associated_letters]);

//     return (
//       <div style={{}}>
//         {nestedLettersData.map((childLetter, index) => (
//           <div className="nested-letters" key={index}>
//             <RenderLetter letter={childLetter} level={level - 1} />
//           </div>
//         ))}
//         <div style={{ display: "flex", marginLeft: `${level * 20}px` }}>
//           <div className="arrow-set">
//             <ArrowBullet />
//           </div>
//           <div className="letter-card">
//             <div className="letter-card-header">
//               <span style={{ margin: "6px" }}>Letter Number: {letter_num}</span>
//             </div>
//             <div style={{ margin: "20px 20px 20px 10px" }}>
//               <table>
//                 <tbody>
//                   <tr>
//                     <td className="padding-bottom-5px">Reply of </td>
//                     <td className="padding-bottom-5px" style={{ padding: "0px 4px" }}>:</td>
//                     <td className="padding-bottom-5px">
//                       {associated_letters.length > 0 ?
//                         <>{letter.associated_letters_get.map(i => i.letter_num).join(",")}</> :
//                         "No Associated Letter"}
//                     </td>
//                   </tr>
//                   <tr>
//                     <td className="padding-bottom-5px">Letter Date </td>
//                     <td className="padding-bottom-5px" style={{ padding: "0px 4px" }}>:</td>
//                     <td className="padding-bottom-5px">{letter.letter_date}</td>
//                   </tr>
//                   <tr>
//                     <td className="padding-bottom-5px">View Letter </td>
//                     <td className="padding-bottom-5px" style={{ padding: "0px 4px" }}>:</td>
//                     <td className="padding-bottom-5px">
//                       <UpdateTrackRecordDetailwithIDonly
//                         i={letter}
//                         projectId={letter.project}
//                         workperformedby={letter.workperformedby}
//                         letterType={letter.lettertype}
//                         getProjects={getLetters}
//                         letterData={LetterData}
//                       />
//                     </td>
//                   </tr>
//                 </tbody>
//               </table>
//             </div>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   useEffect(() => {
//     getLetters();
//   }, [id]);

//   return (
//     <>
//       <button onClick={handleShow} className="document-download-button width-5vw" style={{ marginBottom: "10px", height: "30px" }}>
//         View
//       </button>
//       <Modal show={show} onHide={handleClose} dialogClassName="ourcompany-model">
//         <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
//           <Modal.Title>View Letters</Modal.Title>
//         </Modal.Header>
//         <Modal.Body>
//           <div className="letter-list-container scroll-container" style={{ border: "none" }}>
//             <div className="scrollbar" style={{ border: "none" }}>
//               {letterList?.letter_num ? (
//                 <RenderLetter letter={letterList} />
//               ) : (
//                 <p className="no-letters-text">No letters found</p>
//               )}
//             </div>
//           </div>
//         </Modal.Body>
//       </Modal>
//     </>
//   );
// };





const DeletePaymentrecipt = ({ i, getPaymentReceipt, deductionData, releaseIds, deductionIds }) => {
  const [show, setshow] = useState(false);
  const [loading, setLoading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [showProgressModal, setShowProgressModal] = useState(false);
  const [success, setSuccess] = useState(false)
  const handleClose = () => {
    setshow(false);
  };
  const handleShow = () => {
    setshow(true);
  };
  console.log(releaseIds, "ssssssssssssssss")

  const handleDelete = async (e) => {
    e.preventDefault();
    setShowProgressModal(true);
    setLoading(true);
    setUploadProgress(0);
    const loadingToastId = toast.loading("Deleting: Please wait...");



    try {
      // 📊 Calculate total number of delete calls
      const totalCalls = 1 + (deductionIds?.length || 0) + (releaseIds?.length || 0);
      let completedCalls = 0;

      const updateProgress = () => {
        completedCalls += 1;
        const percent = Math.round((completedCalls / totalCalls) * 100);
        setUploadProgress(percent);
      };

      // 🗑️ Delete main payment receipt
      const ress = await axios.delete(
        `${BASE_URL}/siteproject/paymentrecievedupdate/${i}/`
      );

      if (ress.status === 200) {
        updateProgress(); // ✅ 1st call done

        // 🔁 Delete all deduction IDs one by one
        if (deductionIds && deductionIds.length > 0) {
          for (const deductionId of deductionIds) {
            await axios.delete(
              `${BASE_URL}/siteproject/invoice-deduction/${deductionId}/`
            );
            updateProgress(); // ✅ Each deduction done
          }
        }

        // 🔁 Delete all release IDs one by one
        if (releaseIds && releaseIds.length > 0) {
          for (const releaseId of releaseIds) {
            await axios.delete(
              `${BASE_URL}/siteproject/invoice-deduction-release/${releaseId}/`
            );
            updateProgress(); // ✅ Each release done
          }
        }

        // 🎯 All deletions complete — progress is exactly 100 here
        setTimeout(() => {
          toast.dismiss(loadingToastId);
          toast.success("Data Deleted successfully.");
          window.location.reload();
        }, 1000);

      } else {
        throw new Error("Unexpected");
      }
    } catch (err) {
      setUploadProgress(0);
      handleErrorToast(err);
    } finally {
      setTimeout(() => {
        setShowProgressModal(false);
      }, 1500);
      setLoading(false);
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>

      <button
        className="model-delete-button-modern actionn-icon form-field flex-row" style={{ backgroundColor: "#00000075", borderRadius: "10px", display: "flex", alignItems: "center", gap: "5px", padding: "10px" }}
        onClick={handleShow} title=" Delete Payment Receipt"
      >
        <Trash2 size={18} color="#fff" /><label style={{ color: "white" }}> Delete Payment Receipt
        </label>

      </button>
      {
        showProgressModal ?
          <ProgressModal show={showProgressModal} progress={uploadProgress} usedFor="Delete" /> :
          show === true ?
            <Modal
              show={show}
              onHide={handleClose}
              dialogClassName="request-leave width-40vw"
            >
              <Modal.Header closeButton>
                <Modal.Title>Delete Payment Receipt </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="parent-div">
                  Are You Sure You Want to delete
                  <div className="button-models">
                    <button
                      className="model-button   font-weight500    model-button-cancel"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={handleDelete}
                      className="model-button   font-weight500    model-button-delete"
                    >
                      Delete
                    </button>
                  </div>
                </div>
                <ToastContainer
                  position="top-center"
                  autoClose={1000}
                  hideProgressBar={false}
                  newestOnTop={true}
                  closeOnClick
                  rtl={false}
                  pauseOnFocusLoss
                  draggable
                  pauseOnHover
                />
              </Modal.Body>
            </Modal> : ""
      }
    </>
  );
};





































export {
  AddProjectDetails,
  UpdateProjectAllDetails,
  AddProjectBill,
  AssociatedLetters,
  DeleteBillingDetails,
  AddTrackRecordDetails,
  UpdateTrackRecordDetails,
  UpdateTrackRecordDetailwithIDonly,
  DeleteTrackAndLetterDetails,
  AddCircular,
  UpdateCicular,
  ApproveCircular,
  RejectCircular,
  DeleteCircular,
  AddContractor,
  UpdateContractor,
  DeleteContractor,
  UpdateInsurance,
  AddInsurance,
  DeleteInsurance,
  AddBankGuarantee,
  DeleteBg,
  AddDocuments,
  DocumentModel,
  UpdateBankGuarantee,
  AddEOTDetails,
  UpdateEOTDetails,
  AddCOSDetails,
  UpdateCOSDetails,
  AddMilstoneDetails,
  UpdateMilestone,
  AddProgressdetails,
  UpdateProgressdetails,
  AddLetters,
  AddBOQInvoice,
  UpdateConsultantDetails,
  DeleteDocuments,
  DeleteMileStone,
  DeleteEOT,
  DeleteCOS,
  UpdateBill,
  LetterExchangePage,
  DeleteInvoice,
  Generateconsultantinvoicebyproject,
  DeletePaymentrecipt,
  ViewAmountModel,
  AllAssociateLetter,
  Updatedocument
};
